/**
 * Tiếng Việt là ngôn ngữ mặc định — docs/frontend-guide.md §6.
 *
 * Thuật ngữ nghiệp vụ tra ở docs/glossary.md. Spec là tiếng Việt còn code là
 * tiếng Anh, nên đừng tự dịch mỗi nơi một kiểu: "sprint" giữ nguyên,
 * "backlog" giữ nguyên, "task" là "công việc".
 */
export const vi = {
  assistantChat: {
    modelLevel: 'Mức model trả lời',
    modelLevelHint: 'Trợ lý trả lời bằng {{model}}. Mức và model lấy theo Cài đặt → Key AI.',
    modelUnknown: 'chưa rõ model',
    autoSummarize: 'Trợ lý tự tổng hợp',
    quickActions: 'Thao tác nhanh',
    thinking: 'Đang suy nghĩ…',
    reading: 'Đang đọc thông tin…',
    validating: 'Đang kiểm tra kết quả…',
    keyboardHint: 'Enter để gửi · Shift+Enter để xuống dòng',

    suggested: 'Gợi ý từ lịch sử và thói quen sử dụng của bạn',
    loadingSuggestions: 'Đang đọc lịch sử để gợi ý…',
    noOptions: 'Chưa có lựa chọn phù hợp. Kiểm tra quyền và cấu hình dự án, hoặc bỏ qua nếu đây là bước tuỳ chọn.',
    deleteOther: 'Xoá phiên {{n}} thuộc tổ chức khác',
    chat: 'Trò chuyện',
    activity: 'Hoạt động',
    sessions: 'Các phiên chat',
    new: 'Phiên mới',
    switchSession: 'Đổi phiên chat',
    deleteSession: 'Xoá phiên chat',
    noSession: 'Chưa có phiên chat',
    deleteConfirm: 'Xoá phiên chat này? Dữ liệu đã tạo vẫn được giữ.',
    limit:
      'Tối đa 3 phiên trên tài khoản. Xoá một phiên để tạo mới; phiên ở tổ chức khác được quản lý trong tổ chức đó.',
    empty: 'Tạo phiên mới để hỏi về ChillPM hoặc thực hiện thao tác từng bước.',
    you: 'Bạn',
    bot: 'Trợ lý ChillPM',
    source: 'Nguồn hướng dẫn',
    working: 'Đang xử lý…',
    preview: 'Bản nháp — chưa tạo dữ liệu',
    confirm: 'Xác nhận tạo',
    back: 'Bước trước',
    skip: 'Bỏ qua',
    cancel: 'Huỷ bản nháp',
    placeholder: 'Hỏi về ChillPM hoặc trả lời bước hiện tại…',
    message: 'Tin nhắn',
    send: 'Gửi',
    choose: 'Chọn một giá trị',
    yes: 'Có',
    no: 'Không',
    next: 'Tiếp tục',
    actions: {
      todo: 'Tạo to-do cá nhân',
      project: 'Tạo dự án',
      task: 'Tạo task',
      sprint: 'Tạo sprint',
      issue: 'Tạo issue',
      report: 'Tạo báo cáo',
    },
    fields: {
      startTime: 'Giờ làm',
      dueTime: 'Giờ hoàn thành',
      priority: 'Mức ưu tiên',
      typeId: 'Loại issue của dự án',
      name: 'Tên',
      key: 'Mã dự án',
      methodology: 'Phương pháp',
      description: 'Mô tả',
      startDate: 'Ngày bắt đầu',
      endDate: 'Ngày kết thúc',
      techStackIds: 'Công nghệ',
      lineManagerId: 'Quản lý',
      projectId: 'Dự án',
      title: 'Tiêu đề',
      taskTypeId: 'Loại việc',
      dueDate: 'Hạn hoàn thành',
      estimateHours: 'Ước lượng giờ',
      hasChecklist: 'Thêm checklist',
      checklist: 'Checklist',
      goal: 'Mục tiêu',
      color: 'Màu',
      kind: 'Loại xử lý',
      impact: 'Ảnh hưởng',
      urgency: 'Khẩn cấp',
      from: 'Từ ngày',
      to: 'Đến ngày',
      detail: 'Mức chi tiết',
      note: 'Ghi chú',
    },
  },
  common: {
    updatedAt: 'Cập nhật {{at}}',
    previous: 'Trang trước',
    next: 'Trang sau',
    delete: 'Xoá',
    saving: 'Đang lưu…',
    loadMore: 'Tải thêm',
    appName: 'Chill PM',
    loading: 'Đang tải…',
    retry: 'Thử lại',
    save: 'Lưu',
    edit: 'Sửa',
    cancel: 'Huỷ',
    close: 'Đóng',
    search: 'Tìm kiếm',
    signOut: 'Đăng xuất',
    discardChanges: {
      title: 'Thoát mà không lưu?',
      body: 'Nội dung vừa sửa hoặc thêm chưa được lưu. Thoát bây giờ thì các thay đổi này sẽ mất.',
      keep: 'Tiếp tục soạn',
      discard: 'Thoát, bỏ thay đổi',
    },
  },
  auth: {
    signInTitle: 'Đăng nhập',
    signInSubtitle: 'Quản lý dự án Agile và Waterfall, có AI hỗ trợ.',
    email: 'Email',
    emailPlaceholder: 'ban@congty.vn',
    submitting: 'Đang đăng nhập…',
    restoringSession: 'Đang khôi phục phiên đăng nhập…',
    signedOut: 'Bạn đã đăng xuất.',
    sessionExpired: 'Phiên đăng nhập đã kết thúc. Vui lòng đăng nhập lại.',
    signInWithGoogle: 'Đăng nhập bằng Google',
    googleNotConfigured:
      'Hệ thống chưa cấu hình đăng nhập Google. Liên hệ người vận hành để bật, hoặc xem thử bằng tài khoản demo bên dưới.',
    googleError: {
      state:
        'Lượt đăng nhập Google đã hết hạn hoặc bị gián đoạn. Bấm lại nút Google để thử từ đầu.',
      denied:
        'Không đăng nhập được bằng tài khoản Google này. Nếu tài khoản của bạn đã bị vô hiệu hoá, hãy liên hệ quản trị viên của tổ chức.',
      suspended:
        'Bạn đang bị tạm khoá ở tổ chức mình tham gia. Liên hệ quản trị của tổ chức để được mở khoá.',
    },
    demoTitle: 'Xem thử bằng tài khoản demo',
    demoPersona: {
      org_admin: 'Admin tổ chức',
      director: 'Giám đốc tổ chức',
      leader: 'Leader',
      pm: 'PM',
      member: 'Nhân viên',
    },
    demoOr: 'hoặc',
    demoHelp: 'Chọn một vai trò để vào xem ngay, không cần đăng ký hay mật khẩu.',
    demoReset:
      'Dữ liệu demo dùng chung và tự đặt lại khoảng 30 phút một lần. Bạn thoải mái thêm, sửa, xoá — kể cả khi đang có người khác cùng xem.',
  },
  onboarding: {
    title: 'Chào mừng — còn một bước',
    subtitle: 'Chọn cách bạn muốn bắt đầu.',
    signedInAs: 'Đang đăng nhập bằng',
    displayName: 'Tên hiển thị',
    displayNamePlaceholder: 'Tên đồng nghiệp sẽ thấy',
    orgName: 'Tên tổ chức',
    orgNamePlaceholder: 'Tên công ty hoặc nhóm của bạn',
    orgNameHelp: 'Bạn sẽ là quản trị viên của tổ chức này.',
    creating: 'Đang tạo…',
    expiredTitle: 'Phiên đăng ký đã hết hạn',
    expiredHelp: 'Phiếu đăng ký chỉ sống 24 giờ. Hãy bấm đăng nhập bằng Google lại.',
    backToLogin: 'Về trang đăng nhập',
    // Ba lựa chọn — APM-PSPACE-m (docs/plan-personal-space.md §0.3).
    needOrgTitle: 'Bạn cần thuộc một tổ chức',
    needOrg: 'Mỗi tài khoản đều nằm trong một tổ chức. Chọn một cách để bắt đầu.',
    choicesLabel: 'Cách bắt đầu',
    choice: {
      personal: {
        title: 'Tổ chức chỉ có mình tôi',
        hint: 'Dự án, việc của tôi, issue của tôi. Tối đa 50 việc, không mời người, không tải tệp.',
        submit: 'Bắt đầu một mình',
      },
      full: {
        title: 'Tổ chức mới đầy đủ',
        hint: 'Đủ mọi tính năng; bạn là quản trị viên và mời được người khác vào.',
        badge: 'Sau này sẽ tính phí',
        submit: 'Tạo tổ chức và vào',
      },
      wait: {
        title: 'Chờ được mời',
        hint: 'Tổ chức của bạn đã dùng phần mềm này: chờ quản trị viên mời email của bạn.',
        submit: 'Chờ lời mời',
      },
      guestOnly: {
        title: 'Chỉ tham gia dự án được mời',
        hint: 'Không lập tổ chức nào. Bạn thấy dự án {{project}} khi quản lý dự án duyệt.',
        submit: 'Gửi yêu cầu tham gia',
      },
    },
    // Link tổ chức cần duyệt, chưa có tài khoản — APM-ORGJR-c: một nút, không ba thẻ.
    requestTitle: 'Xin vào {{org}}',
    requestSubtitle:
      'Link này cần quản trị viên duyệt. Bấm gửi yêu cầu, quản trị viên duyệt xong là bạn vào được.',
    requestSubmit: 'Gửi yêu cầu tham gia',
    guestLinkPending:
      'Bạn đang xin tham gia dự án {{project}} ({{org}}). Yêu cầu sẽ chờ quản lý dự án duyệt, dù bạn chọn cách nào.',
    // Phòng chờ — thẻ 3 (APM-GAUTH-e, khôi phục ở APM-PSPACE-m).
    waitingTitle: 'Chờ được mời',
    waitingSubtitle:
      'Khi quản trị viên mời email này, bấm "Kiểm tra lại" là vào — không phải đăng nhập lại.',
    waitSendEmail: 'Gửi địa chỉ này cho quản trị viên của tổ chức bạn:',
    waitThenCheck: 'Họ có thể mời bằng email (rồi bạn bấm "Kiểm tra lại") hoặc gửi link mời.',
    checkAgain: 'Kiểm tra lại',
    checking: 'Đang kiểm tra…',
    notInvitedYet: 'Chưa có lời mời nào cho email này. Thử lại sau khi quản trị viên báo đã mời.',
    readyTitle: 'Bạn đã được thêm vào tổ chức.',
    enterNow: 'Vào ngay',
    requestsLabel: 'Yêu cầu tham gia tổ chức',
    request: {
      pending: 'Đang chờ {{org}} duyệt — gửi ngày {{at}}.',
      declined: 'Yêu cầu vào {{org}} chưa được duyệt.',
    },
    pendingTitle: 'Đã gửi yêu cầu tham gia',
    pendingHelpWait:
      'Quản trị của {{org}} sẽ duyệt yêu cầu của bạn. Bạn có thể đóng trang; khi được duyệt, mở lại và bấm "Kiểm tra lại".',
    waitClosable:
      'Bạn có thể đóng trang này. Chúng tôi nhớ bạn trong 24 giờ, nên quay lại không phải đăng nhập lại.',
    backToChoices: 'Quay lại các lựa chọn',
    invitedTitle: 'Bạn được mời vào một tổ chức',
    invitedSubtitle: 'Xác nhận tên hiển thị rồi tham gia.',
    inviteDead: 'Link mời không còn hiệu lực',
    inviteDeadHelp:
      'Link đã hết hạn hoặc bị thu hồi. Xin người gửi link gửi lại — hoặc chọn một cách bắt đầu dưới đây.',
    join: 'Tham gia tổ chức',
  },
  /** Giữ hay xoá "tổ chức chỉ có mình tôi" sau khi vào tổ chức khác — APM-PSPACE-n. */
  personalOrgDecision: {
    title: 'Bạn đã tham gia {{org}}',
    body: 'Bạn vẫn còn "Tổ chức chỉ có mình tôi" — nơi bạn làm việc một mình trước đây. Giữ lại hay xoá đi?',
    projectCount_one: 'Trong đó có {{count}} dự án.',
    projectCount_other: 'Trong đó có {{count}} dự án.',
    keep: 'Giữ',
    delete: 'Xoá…',
    keepHelp:
      'Giữ thì nó vẫn ở bộ chọn tổ chức. Muốn xoá sau vẫn được, ở Cài đặt → Tổ chức của tôi.',
    confirmTitle: 'Xoá tổ chức chỉ có mình tôi?',
    confirmBody:
      'Những dự án dưới đây sẽ không còn hiện ở đâu nữa, cùng với việc và to-do trong tổ chức ấy:',
    noProjects: 'Không có dự án nào.',
    confirm: 'Xoá',
    kept: 'Đã giữ tổ chức chỉ có mình tôi.',
    deleted: 'Đã xoá tổ chức chỉ có mình tôi.',
    settingsTitle: 'Tổ chức chỉ có mình tôi',
    settingsHelp: 'Xoá tổ chức riêng của bạn cùng mọi dự án trong đó.',
    settingsIsHome:
      'Đây đang là tổ chức chính của bạn — hãy tham gia một tổ chức khác trước rồi mới xoá được.',
    settingsButton: 'Xoá tổ chức chỉ có mình tôi',
  },
  /**
   * Thẻ "Không gian cá nhân" trên trang Dự án — APM-PSPACE-e. Tên khối riêng (không phải
   * `personalSpace`) để không đè khối câu báo của APM-PSPACE-b.
   */
  personalSpaceCard: {
    title: 'Không gian cá nhân',
    description:
      'Đây là không gian riêng của bạn. Khi được mời vào một tổ chức, bạn dùng được đầy đủ tính năng ở đó.',
    requestsLabel: 'Yêu cầu đang chờ',
    orgRequest: {
      pending: 'Đang chờ {{org}} duyệt yêu cầu tham gia — gửi ngày {{at}}.',
      declined: '{{org}} chưa duyệt yêu cầu tham gia của bạn.',
    },
    guestRequest: {
      pending: 'Đang chờ duyệt vào dự án {{project}} ({{org}}) — gửi ngày {{at}}.',
      declined: 'Chưa được duyệt vào dự án {{project}} ({{org}}).',
    },
    memberOf: 'Bạn đã là thành viên của:',
    enter: 'Vào',
    checkInvites: 'Kiểm tra lời mời',
    checking: 'Đang kiểm tra…',
    noInvites:
      'Chưa có tổ chức nào nhận email {{email}}. Gửi địa chỉ này cho quản trị viên của tổ chức bạn rồi kiểm tra lại.',
    createOrg: 'Tự lập tổ chức',
    orgName: 'Tên tổ chức',
    orgNamePlaceholder: 'Tên công ty hoặc nhóm của bạn',
    create: 'Lập tổ chức',
    createHelp: 'Bạn sẽ là quản trị viên của tổ chức này; màn hình chuyển sang tổ chức mới.',
  },
  /**
   * Portal của khách hàng — docs/plan-issue-management.md §8.2, APM-ISSUE-n.
   *
   * Khối riêng, không nằm trong `issueTracking`: portal là một **sản phẩm khác**
   * dùng chung dữ liệu, và giọng văn của nó cũng khác — người đọc là khách
   * hàng, không phải đồng nghiệp.
   */
  portal: {
    title: 'Vấn đề của tôi',
    greeting: 'Xin chào {{name}}',
    report: 'Báo vấn đề mới',
    created: 'Đã gửi. Chúng tôi sẽ phản hồi trong thời gian cam kết.',
    confirm: 'Xác nhận đã xong',
    confirmed: 'Cảm ơn bạn đã xác nhận',
    reopen: 'Chưa xong',
    reopenReason: 'Còn chỗ nào chưa ổn?',
    dueAt: 'Cam kết xử lý trước {{at}}',
    noProject: {
      title: 'Bạn chưa được mời vào dự án nào',
      description: 'Hãy liên hệ người phụ trách dự án để được cấp quyền truy cập.',
    },
    empty: {
      title: 'Bạn chưa báo vấn đề nào',
      description: 'Gặp sự cố hoặc cần hỗ trợ? Báo ở đây để được theo dõi và xử lý đúng hạn.',
    },
  },
  /** Mục Cấu hình issue trong Cấu hình dự án — APM-ITYPE-b. */
  issueTypes: {
    title: 'Cấu hình issue',
    subtitle: 'Các loại issue của dự án và cách xử lý của từng loại.',
    intro:
      'Mỗi loại thuộc một cách xử lý. Cách xử lý quyết định mức ưu tiên, việc liên kết vào nguyên nhân gốc và báo cáo bảo trì; tên và số loại do bạn đặt.',
    add: 'Thêm loại',
    editTitle: 'Sửa loại issue',
    editNamed: 'Sửa loại {{name}}',
    deleteNamed: 'Xoá loại {{name}}',
    deleteTitle: 'Xoá loại "{{name}}"',
    delete: 'Xoá loại',
    deleteUnused: 'Loại này chưa có issue nào. Xoá hẳn?',
    moveTo_one: '{{count}} issue đang mang loại này sẽ chuyển sang:',
    moveTo_other: '{{count}} issue đang mang loại này sẽ chuyển sang:',
    replacement: 'Loại thay thế',
    name: 'Tên loại',
    baseKind: 'Cách xử lý',
    color: 'Màu',
    issueCount_one: '{{count}} issue',
    issueCount_other: '{{count}} issue',
    emptyKind: 'Chưa có loại nào cho cách xử lý này.',
    lastOfKind: 'Mỗi cách xử lý phải còn ít nhất một loại.',
    kindLockedInUse:
      'Loại đang có issue nên không đổi được cách xử lý — đổi thì ưu tiên và báo cáo của issue cũ lệch theo.',
    kindLockedLast: 'Đây là loại duy nhất của cách xử lý này nên không đổi được.',
    created: 'Đã thêm loại issue',
    saved: 'Đã lưu loại issue',
    deleted: 'Đã xoá loại "{{name}}"',
    kind: { incident: 'Sự cố', request: 'Yêu cầu', problem: 'Nguyên nhân gốc' },
    kindHelp: {
      incident:
        'Thứ đang hỏng. Ưu tiên theo ảnh hưởng × khẩn cấp; liên kết được vào một nguyên nhân gốc.',
      request:
        'Việc một người xin (cấp tài khoản, cấp quyền, xuất dữ liệu). Ảnh hưởng luôn tính là một người.',
      problem:
        'Nguyên nhân gốc của nhiều sự cố. Chỉ người xử lý issue tạo được; sự cố liên kết vào đây.',
    },
    errors: {
      ISSUE_TYPE_NAME_TAKEN: 'Dự án đã có loại issue tên này.',
      ISSUE_TYPE_IN_USE: 'Loại đang có issue nên không đổi được cách xử lý.',
      ISSUE_TYPE_LAST_OF_KIND: 'Mỗi cách xử lý phải còn ít nhất một loại.',
      ISSUE_TYPE_REPLACEMENT_REQUIRED: 'Loại đang có issue — chọn loại thay thế.',
      ISSUE_TYPE_REPLACEMENT_MISMATCH: 'Loại thay thế phải cùng cách xử lý.',
    },
  },
  /** Trang link mời khách hàng — APM-CLINV-c. */
  clientInvite: {
    title: 'Lời mời tham gia dự án',
    invalidTitle: 'Link mời không dùng được',
    invalid: 'Link mời đã hết hạn hoặc đã bị thu hồi. Hãy xin quản lý dự án gửi link mới.',
    heading: 'Tham gia dự án {{project}}',
    subheading: '{{org}} mời bạn gửi và theo dõi issue của dự án {{key}}.',
    signedInAs: 'Bạn đang đăng nhập là {{name}}.',
    apply: 'Gửi yêu cầu tham gia',
    notYou: 'Không phải bạn? Đăng xuất',
    registerHelp: 'Tạo tài khoản để gửi yêu cầu. Quản lý dự án duyệt xong là bạn gửi được issue.',
    name: 'Họ tên',
    email: 'Email',
    password: 'Mật khẩu',
    passwordHint: 'Ít nhất 12 ký tự.',
    register: 'Tạo tài khoản và gửi yêu cầu',
    haveAccount: 'Đã có tài khoản?',
    signIn: 'Đăng nhập',
    toPortal: 'Tới trang issue của tôi',
    googleHelp:
      'Đăng nhập bằng Google để gửi yêu cầu. Tài khoản mới được tạo ngay ở bước tiếp theo.',
    toHome: 'Về trang chủ',
    outcome: {
      ok: 'Đã gửi yêu cầu. Quản lý dự án sẽ duyệt — bạn sẽ nhận thông báo khi xong.',
      pending: 'Bạn đã gửi yêu cầu trước đó, đang chờ quản lý dự án duyệt.',
      already_member: 'Bạn đã là khách hàng của dự án này.',
      staff:
        'Tài khoản của bạn là thành viên của tổ chức, không dùng link mời khách hàng. Hãy nhờ quản lý dự án thêm bạn vào dự án.',
      demo_account: 'Tài khoản demo không tham gia được dự án của tổ chức thật.',
    },
    mine: {
      label: 'Yêu cầu tham gia dự án',
      pending: 'Đang chờ duyệt vào dự án {{project}} ({{org}}) — gửi ngày {{at}}.',
      declined: 'Yêu cầu vào dự án {{project}} chưa được duyệt.',
      note: 'Lý do: {{note}}',
    },
  },

  // Cộng tác viên ngoài tổ chức — APM-GUEST-g, docs/plan-guest-collaborator.md.
  projectGuests: {
    badge: 'Ngoài',
    badgeHint:
      'Cộng tác viên ngoài tổ chức — làm được việc vai cho, trừ quản trị dự án và các quyền duyệt / chốt',
    inviteLink: {
      hint: 'Gửi link này cho cộng tác viên. Ai mở link cũng tự tạo được tài khoản, nhưng chỉ vào được dự án sau khi bạn duyệt ở mục Chờ duyệt.',
      empty: 'Chưa có link mời nào đang dùng.',
      create: 'Tạo link mời',
      url: 'Link mời cộng tác viên',
      meta: 'Hết hạn {{at}} · {{count}} người đã gửi yêu cầu',
      revoke: 'Thu hồi',
      revokeConfirm: 'Thu hồi link? Người chưa mở link sẽ không dùng được nữa.',
      regenerate: 'Tạo link mới',
      regenerateConfirm: 'Link hiện tại sẽ ngừng hoạt động ngay. Tạo link mới?',
      created: 'Đã tạo link mời',
      revoked: 'Đã thu hồi link mời',
    },
    requests: {
      empty: {
        title: 'Không có yêu cầu nào đang chờ',
        description: 'Người vào qua link mời sẽ hiện ở đây để bạn duyệt.',
      },
      sentAt: 'Gửi lúc',
      accept: 'Duyệt',
      decline: 'Từ chối',
      declineTitle: 'Từ chối yêu cầu của {{name}}',
      note: 'Lý do (người xin sẽ thấy, có thể bỏ trống)',
      accepted: 'Đã duyệt {{name}} vào dự án',
      declined: 'Đã từ chối yêu cầu',
      decided: 'Yêu cầu này đã được xử lý.',
    },
    errors: {
      staff: 'Người này là nhân sự của tổ chức — hãy thêm họ như thành viên bình thường.',
      clientAccount:
        'Email này là tài khoản khách hàng của tổ chức — không thêm được với tư cách cộng tác viên.',
      alreadyMember: 'Người này đã ở trong dự án.',
      roleTooWide:
        'Vai này rộng hơn quyền tối đa của cộng tác viên ngoài (vượt: {{permissions}}). Cộng tác viên làm được mọi việc vai cho, trừ quản trị dự án và các quyền duyệt / chốt (thay đổi, gợi ý AI, tài liệu, cấu hình issue).',
    },
    title: 'Cộng tác viên ngoài tổ chức',
    subtitle:
      'Người ngoài tổ chức làm việc trong dự án này theo vai bạn chọn — trừ quản trị dự án và các quyền duyệt / chốt. Họ không xuất hiện trong danh bạ, hiệu suất hay sơ đồ tổ chức.',
    invite: 'Mời cộng tác viên',
    name: 'Tên hiển thị',
    email: 'Email',
    role: 'Vai',
    openTasks: 'Việc chưa xong',
    googleReady:
      'Đã thêm {{email}}. Gửi link dưới đây và dặn họ đăng nhập bằng Google với đúng email này.',
    loginLink: 'Link đăng nhập',
    joined: 'Tham gia',
    hint: 'Cộng tác viên vào dự án ngay. Họ không xuất hiện trong danh bạ, hiệu suất hay sơ đồ tổ chức.',
    send: 'Mời',
    linkReady:
      'Đã tạo tài khoản cho {{email}}. Gửi link dưới đây để họ đặt mật khẩu — link chỉ hiện một lần.',
    link: 'Link đặt mật khẩu',
    copy: 'Sao chép link',
    copied: 'Đã sao chép link',
    copyFailed: 'Không sao chép được — hãy chọn và sao chép bằng tay',
    expires: 'Link hết hạn lúc {{at}}',
    existing: '{{email}} đã có tài khoản — họ được thêm vào dự án và thấy nó ngay khi đăng nhập.',
    remove: 'Gỡ',
    removeConfirm:
      'Gỡ {{name}} khỏi dự án? Tài khoản của họ vẫn còn, chỉ không vào được dự án này nữa.',
    removed: 'Đã gỡ cộng tác viên khỏi dự án',
    cannotRemove: 'Còn việc chưa xong — chuyển việc cho người khác rồi hãy gỡ.',
    empty: {
      title: 'Chưa có cộng tác viên nào',
      description: 'Mời người ngoài tổ chức để họ nhận việc và cập nhật tiến độ ngay trong dự án.',
    },
  },

  /** Mục Link mời vào dự án — APM-PSPACE-l, hai thẻ, mỗi thẻ một vai mặc định. */
  inviteLinks: {
    activeTitle: 'Link đang hoạt động',
    activeHint:
      'Mọi link mời còn hiệu lực của dự án. Sao chép lại bất cứ lúc nào; xoá một link là thu hồi riêng link đó — người đã đăng ký qua nó vẫn còn trong danh sách chờ duyệt.',
    empty: 'Chưa có link nào đang hoạt động.',
    createStaff: 'Tạo link mời thành viên',
    createGuest: 'Tạo link mời cộng tác viên',
    created: 'Đã tạo link mời',
    kind: { staff: 'Thành viên', guest: 'Cộng tác viên' },
    meta: 'Tạo {{created}} · hết hạn {{expires}}',
    legacy:
      'Link tạo trước khi lưu được — không sao chép lại được. Nếu không còn bản đã gửi, xoá link này và tạo link mới.',
    copy: 'Sao chép link',
    copied: 'Đã sao chép link',
    copyFailed: 'Không sao chép được — chọn ô link rồi sao chép tay',
    revoke: 'Xoá',
    revokeLabel: 'Xoá link {{kind}} tạo {{created}}',
    revokeConfirm:
      'Xoá link này? Ai mở link sẽ thấy link đã bị thu hồi. Đơn đã gửi qua link vẫn còn để bạn duyệt.',
    revoked: 'Đã xoá link',
    roleLabel: 'Vai mặc định',
    joinersTitle: 'Đã đăng ký qua link này ({{count}})',
    joinersEmpty: 'Chưa ai đăng ký qua link này.',
    joinerStatus: {
      pending: 'Chờ duyệt',
      accepted: 'Đã vào dự án',
      declined: 'Bị từ chối',
      withdrawn: 'Đã rút',
    },
    linksTitle: 'Link mời',
    guestBlocked:
      'Tổ chức trưng bày không mời được người ngoài — dữ liệu ở đây tự đặt lại mỗi 30 phút.',
    directTitle: 'Mời đích danh',
    directHint:
      'Chọn người trong tổ chức để mời thẳng, hoặc mời cộng tác viên bằng email — không cần link.',
    inviteGuestByEmail: 'Mời cộng tác viên bằng email',
  },
  projectInviteCards: {
    sectionSubtitle:
      'Các link mời thành viên và cộng tác viên đang hoạt động — sao chép lại, xem ai đã đăng ký, xoá từng link — và mời đích danh.',
    staff: {
      title: 'Thành viên trong tổ chức',
      subtitle:
        'Người đã có tài khoản trong tổ chức: mời đích danh, hoặc gửi link để họ tự đăng ký. Bạn chốt vai trò, khoảng ngày và thời lượng trước khi họ vào dự án.',
    },
    guest: {
      title: 'Cộng tác viên ngoài',
      demoOrg:
        'Tổ chức trưng bày không mời được người ngoài — dữ liệu ở đây tự đặt lại mỗi 30 phút. Thử tính năng cộng tác viên ở một tổ chức thật.',
    },
    defaultRole: 'Vai mặc định',
    staffNoDefault: 'Để người mở link tự chọn',
    staffDefaultHint:
      'Vai được chọn sẵn trên form đăng ký của người mở link và khi mời đích danh. Bạn vẫn chốt lại lúc duyệt.',
    guestDefaultHint:
      'Vai cộng tác viên nhận khi bạn duyệt đơn qua link (vẫn chọn lại được lúc duyệt), và vai sẵn khi mời bằng email. Đổi vai không đổi link.',
    staffLinkTitle: 'Link đăng ký',
    staffLinkHint:
      'Người trong tổ chức mở link, đăng nhập và gửi đăng ký kèm nguyện vọng. Đơn hiện ở khối Chờ duyệt của mục Thành viên. Link không tạo tài khoản mới.',
    roleSaved: 'Đã đổi vai mặc định của link',
  },

  guestInvite: {
    title: 'Lời mời cộng tác',
    invalidTitle: 'Link mời không dùng được',
    invalid: 'Link mời đã hết hạn hoặc đã bị thu hồi. Hãy xin quản lý dự án gửi link mới.',
    heading: 'Cộng tác trong dự án {{project}}',
    subheading: '{{org}} mời bạn nhận và cập nhật công việc trong dự án {{key}}.',
    signedInAs: 'Bạn đang đăng nhập là {{name}}.',
    apply: 'Gửi yêu cầu tham gia',
    notYou: 'Không phải bạn? Đăng xuất',
    registerHelp:
      'Tạo tài khoản để gửi yêu cầu. Quản lý dự án duyệt xong là bạn thấy việc được giao.',
    name: 'Họ tên',
    email: 'Email',
    password: 'Mật khẩu',
    passwordHint: 'Ít nhất 12 ký tự.',
    register: 'Tạo tài khoản và gửi yêu cầu',
    haveAccount: 'Đã có tài khoản?',
    signIn: 'Đăng nhập',
    toWork: 'Tới trang làm việc',
    googleHelp:
      'Đăng nhập bằng Google để gửi yêu cầu. Tài khoản mới được tạo ngay ở bước tiếp theo.',
    toHome: 'Về trang chủ',
    outcome: {
      ok: 'Đã gửi yêu cầu. Quản lý dự án sẽ duyệt — bạn sẽ nhận thông báo khi xong.',
      pending: 'Bạn đã gửi yêu cầu trước đó, đang chờ quản lý dự án duyệt.',
      already_member: 'Bạn đã ở trong dự án này.',
      staff:
        'Tài khoản của bạn là nhân sự của tổ chức, không dùng link mời cộng tác viên. Hãy nhờ quản lý dự án thêm bạn vào dự án.',
      client_account:
        'Tài khoản của bạn là khách hàng của tổ chức này, không dùng được link mời cộng tác viên.',
      demo_account: 'Tài khoản demo không tham gia được dự án của tổ chức thật.',
    },
    mine: {
      label: 'Yêu cầu tham gia dự án',
      pending: 'Đang chờ duyệt vào dự án {{project}} ({{org}}) — gửi ngày {{at}}.',
      declined: 'Yêu cầu vào dự án {{project}} chưa được duyệt.',
      note: 'Lý do: {{note}}',
    },
  },
  issueClients: {
    /** Nút mở popup ở header tab Issue (APM-CLINV-a). */
    open: 'Khách hàng',
    pendingBadge: '{{count}} người chờ duyệt',
    tabs: {
      label: 'Mục quản lý khách hàng',
      clients: 'Khách hàng',
      link: 'Link mời',
      pending: 'Chờ duyệt',
      pendingCount: 'Chờ duyệt ({{count}})',
    },
    inviteLink: {
      hint: 'Gửi link này cho khách. Ai mở link cũng tự tạo được tài khoản, nhưng chỉ gửi và xem được issue sau khi bạn duyệt ở mục Chờ duyệt.',
      empty: 'Chưa có link mời nào đang dùng.',
      create: 'Tạo link mời',
      url: 'Link mời khách hàng',
      meta: 'Hết hạn {{at}} · {{count}} người đã gửi yêu cầu',
      revoke: 'Thu hồi',
      revokeConfirm: 'Thu hồi link? Người chưa mở link sẽ không dùng được nữa.',
      regenerate: 'Tạo link mới',
      regenerateConfirm: 'Link hiện tại sẽ ngừng hoạt động ngay. Tạo link mới?',
      created: 'Đã tạo link mời',
      revoked: 'Đã thu hồi link mời',
    },
    requests: {
      empty: {
        title: 'Không có yêu cầu nào đang chờ',
        description: 'Người vào qua link mời sẽ hiện ở đây để bạn duyệt.',
      },
      sentAt: 'Gửi lúc',
      accept: 'Duyệt',
      decline: 'Từ chối',
      declineTitle: 'Từ chối yêu cầu của {{name}}',
      note: 'Lý do (khách sẽ thấy, có thể bỏ trống)',
      accepted: 'Đã duyệt {{name}} vào dự án',
      declined: 'Đã từ chối yêu cầu',
      decided: 'Yêu cầu này đã được xử lý.',
      staff: 'Người này là thành viên của tổ chức — không thêm được với tư cách khách hàng.',
    },
    title: 'Khách hàng của dự án',
    subtitle: 'Người ngoài tổ chức được mời để gửi và theo dõi issue của dự án này.',
    invite: 'Mời khách hàng',
    name: 'Tên hiển thị',
    email: 'Email',
    reported: 'Issue đã gửi',
    googleReady:
      'Đã thêm {{email}}. Gửi link dưới đây và dặn họ đăng nhập bằng Google với đúng email này.',
    loginLink: 'Link đăng nhập',
    joined: 'Tham gia',
    hint: 'Khách chỉ thấy issue do chính họ gửi hoặc được chia sẻ, không thấy phần trao đổi nội bộ.',
    send: 'Mời',
    linkReady:
      'Đã tạo tài khoản cho {{email}}. Gửi link dưới đây để họ đặt mật khẩu — link chỉ hiện một lần.',
    link: 'Link đặt mật khẩu',
    copy: 'Sao chép link',
    copied: 'Đã sao chép link',
    copyFailed: 'Không sao chép được — hãy chọn và sao chép bằng tay',
    expires: 'Link hết hạn lúc {{at}}',
    existing: '{{email}} đã có tài khoản — họ được thêm vào dự án và thấy nó ngay khi đăng nhập.',
    empty: {
      title: 'Chưa mời khách hàng nào',
      description:
        'Mời khách để họ tự gửi issue và theo dõi tiến độ xử lý ở trang "Issue của tôi".',
    },
    watchersOf: 'Người theo dõi của {{code}}',
  },
  myIssues: {
    title: 'Issue của tôi',
    subtitleStaff: 'Issue bạn đã gửi hoặc được chia sẻ, ở mọi dự án bạn là thành viên.',
    /** Vỏ hạn chế, vai không có `issue:read` ở dự án nào — APM-PSPACE-g. */
    noAccess: {
      title: 'Vai của bạn chưa được xem issue',
      description: 'Quản lý dự án có thể mở quyền xem issue cho vai của bạn trong cài đặt dự án.',
    },
    scopeLabel: 'Phạm vi',
    scope: { all: 'Tất cả', reported: 'Tôi gửi', watching: 'Được chia sẻ' },
    stateLabel: 'Trạng thái',
    state: { open: 'Đang mở', closed: 'Đã đóng', all: 'Mọi trạng thái' },
    projectLabel: 'Dự án',
    allProjects: 'Mọi dự án',
    projectOption: '{{name}} ({{count}})',
    search: 'Tìm theo tiêu đề hoặc số',
    report: 'Gửi issue',
    created: 'Đã gửi issue',
    more: 'Tải thêm',
    shared: 'Được chia sẻ',
    needsConfirm: 'Chờ bạn xác nhận',
    dueOverdue: 'Đã quá hạn',
    dueSoon: 'Còn dưới 2 giờ',
    col: {
      code: 'Mã',
      title: 'Tiêu đề',
      project: 'Dự án',
      state: 'Trạng thái',
      priority: 'Ưu tiên',
      due: 'Hạn xử lý',
    },
    empty: {
      title: 'Chưa có issue nào ở đây',
      description:
        'Issue bạn gửi hoặc được người khác chia sẻ sẽ hiện ở đây, kèm trạng thái xử lý.',
    },
    noProject: {
      title: 'Bạn chưa thuộc dự án nào nhận issue',
      description:
        'Khi bạn là thành viên của một dự án, bạn gửi và theo dõi issue của dự án ấy ở đây.',
    },
    detail: 'Chi tiết issue',
    dueAt: 'hạn {{at}}',
    resolvedAsk: 'Đội xử lý báo đã xong. Vấn đề của bạn đã được giải quyết chưa?',
    confirm: 'Xác nhận đã xong',
    confirmed: 'Đã xác nhận — issue được đóng',
    reopen: 'Chưa xong, mở lại',
    reopenReason: 'Còn chưa xong ở đâu?',
    timeline: 'Lịch sử xử lý',
    // Luồng công khai với đội xử lý — APM-ISC-e.
    conversation: 'Trao đổi với đội xử lý',
    entry: { created: 'Đã gửi' },
    actor: { reporter: 'Người gửi', team: 'Đội xử lý', system: 'Hệ thống' },
    watchers: 'Người theo dõi',
    noWatchers: 'Chưa chia sẻ với ai.',
    client: 'Khách',
    addWatcher: 'Thêm người theo dõi',
    watcherEmail: 'Email của người cần chia sẻ',
    share: 'Chia sẻ',
    shareHint:
      'Chỉ chia sẻ được với người đã là thành viên của dự án này. Người được chia sẻ thấy issue và nhận thông báo khi nó đổi trạng thái.',
    removeWatcher: 'Bỏ {{name}} khỏi danh sách theo dõi',
  },
  nav: {
    documents: 'Tài liệu',
    dashboard: 'Tổng quan',
    myTasks: 'Việc của tôi',
    myIssues: 'Issue của tôi',
    projects: 'Dự án',
    reports: 'Báo cáo',
    orgChart: 'Sơ đồ tổ chức',
    performance: 'Hiệu suất',
    velocity: 'Hiệu chỉnh ước lượng',
    okr: 'OKR',
    admin: 'Quản trị',
    system: 'Hệ thống',
    aiConsole: 'Bảng điều khiển AI',
    aiHarness: 'Harness',
    settings: 'Cài đặt của tôi',
    privacy: 'Quyền riêng tư',
    mainLabel: 'Điều hướng chính',
    adminGroup: 'Tính năng',
    viewAsUser: 'Xem như người dùng thường',
    viewAsAdmin: 'Về màn quản trị hệ thống',
    account: 'Tài khoản của tôi',
  },
  projects: {
    goneToast: 'Dự án này không còn, hoặc bạn không còn quyền xem nó.',
    period: {
      both: '{{from}} – {{to}}',
      fromOnly: 'từ {{from}}',
      untilOnly: 'đến {{to}}',
    },
    collapse: 'Thu gọn thanh bên',
    expand: 'Mở rộng thanh bên',
    quickAccess: 'Truy cập nhanh',
    myRole: 'Vai trò của bạn trong dự án này',
    sidebarEmpty: 'Chưa có dự án nào.',
    sidebarAllHidden: 'Bạn đã ẩn hết dự án khỏi mục này. Mở “Tất cả dự án” để hiện lại.',
    sidebarLabel: 'Danh sách dự án',
    archivedBadge: 'Đã lưu trữ',
    filterPlaceholder: 'Tìm dự án…',
    filterEmpty: 'Không có dự án nào khớp.',
    rag: {
      green: 'Đang đúng tiến độ',
      amber: 'Có vấn đề phát sinh',
      red: 'Vấn đề nghiêm trọng',
      unknown: 'Chưa đủ dữ liệu',
    },
    ragNoData: 'Chưa có số liệu — dự án chưa bắt đầu, hoặc bạn không có quyền xem báo cáo tổng.',
    ragProgress: 'Đã xong {{done}}/{{total}} việc',
    ragLate: 'Trễ hạn: {{count}} việc',
    ragRisk: 'Rủi ro còn mở: {{count}} (điểm cao nhất {{top}}/25)',
    ragNextMilestone: 'Mốc tới: {{title}} — {{date}}',
  },
  rag: {
    red: 'Nguy cơ cao',
    amber: 'Cần theo dõi',
    green: 'Bình thường',
    unknown: 'Chưa đủ dữ liệu',
  },
  /**
   * Giới hạn của không gian cá nhân — APM-PSPACE-b (docs/plan-personal-space.md §3.3). Tên theo
   * miền, không phải `personalSpace` trơn: khoá ấy để dành cho phần vỏ / onboarding của không gian.
   */
  personalSpaceLimits: {
    notice:
      'Không gian cá nhân: tối đa {{limit}} việc, không mời người, không tải tệp. Tham gia hoặc lập tổ chức để dùng đầy đủ.',
    taskLimit:
      'Không gian cá nhân có tối đa {{limit}} việc (đang có {{current}}). Tham gia hoặc lập tổ chức để thêm nữa.',
    restricted: {
      invite:
        'Không gian cá nhân không mời được người khác. Tham gia hoặc lập tổ chức để làm cùng người khác.',
      document:
        'Không gian cá nhân không thêm được tài liệu dự án. Tham gia hoặc lập tổ chức để dùng tài liệu.',
      task_attachment:
        'Không gian cá nhân không đính kèm được tệp. Tham gia hoặc lập tổ chức để tải tệp lên.',
      coordination:
        'Không gian cá nhân không có trang Nhân sự. Tham gia hoặc lập tổ chức để dùng đầy đủ.',
      change_request:
        'Không gian cá nhân không có yêu cầu thay đổi. Tham gia hoặc lập tổ chức để dùng đầy đủ.',
      design:
        'Không gian cá nhân không có trang Thiết kế. Tham gia hoặc lập tổ chức để dùng đầy đủ.',
      org_restructure: 'Không gian cá nhân không gộp, không tách và không là bên của đề xuất nào.',
    },
  },
  errors: {
    // Tab Git — APM-GIT-b, docs/plan-git-integration.md §3, §5.1.
    GIT_HOST_NOT_FOUND: 'Máy chủ git không còn tồn tại.',
    GIT_HOST_UNKNOWN:
      'Link này không thuộc máy chủ git nào đã khai — nhờ admin tổ chức khai máy chủ này.',
    GIT_HOST_IN_USE:
      'Máy chủ này còn {{connections}} kết nối dự án và {{identities}} tài khoản đã gắn nên không xoá được — tắt máy chủ thay vì xoá.',
    GIT_HOST_DISABLED: 'Máy chủ git này đang bị admin tổ chức tắt.',
    GIT_HOST_UNREACHABLE: 'Không tới được máy chủ git, hoặc địa chỉ đó không phải API của nó.',
    GIT_TOKEN_INVALID: 'Máy chủ git từ chối token — token sai, đã hết hạn hoặc đã bị thu hồi.',
    GIT_FORBIDDEN: 'Token không đủ quyền cho thao tác này ở máy chủ git.',
    GIT_REPO_NOT_FOUND: 'Không tìm thấy kho này, hoặc token không thấy được nó.',
    GIT_BRANCH_EXISTS: 'Nhánh này đã có trong kho.',
    GIT_RATE_LIMITED: 'Đang gọi máy chủ git quá nhanh — thử lại sau ít phút.',
    GIT_NOT_SUPPORTED:
      'Loại máy chủ git hoặc thao tác này chưa được hỗ trợ ở bản cài đặt hiện tại.',
    // Kết nối và kho của dự án — APM-GIT-d.
    GIT_CONNECTION_IN_USE:
      'Kết nối này còn kho đang gắn. Gỡ kho trước, hoặc đổi token nếu chỉ muốn thay token.',
    GIT_CONNECTION_REQUIRED:
      'Dự án chưa có kết nối nào dùng được tới máy chủ git của kho này. Tạo kết nối (dán token) trước.',
    GIT_REPO_ALREADY_LINKED: 'Kho này đã được gắn vào dự án rồi.',
    // Gắn cập nhật tiến độ với commit — APM-PCOM.
    GIT_NOT_CONNECTED:
      'Dự án chưa có kho git dùng được (kho đang gắn + token còn hiệu lực) — cấu hình Git trước.',
    GIT_COMMIT_NOT_FOUND: 'Không thấy commit này trên nhánh đã chọn — tải lại danh sách commit rồi chọn lại.',
    // Gắn cả nhóm kho — APM-GIT-s.
    GIT_GROUP_NOT_FOUND: 'Không tìm thấy nhóm này, hoặc token không thấy được nó.',
    GIT_GROUP_ALREADY_LINKED: 'Nhóm này đã được gắn vào dự án rồi.',
    // APM-ORGINT-d/-e — người đọc là admin tổ chức, người bật được là super admin.
    PRIVATE_ADDRESS_BLOCKED:
      'Địa chỉ này nằm trong mạng nội bộ — nhờ quản trị hệ thống bật "cho phép địa chỉ nội bộ" cho tổ chức của bạn.',
    // Đồng bộ dự án — APM-SYNC-a/b, docs/plan-project-sync.md.
    SYNC_PROVIDER_NOT_FOUND: 'Nguồn đồng bộ không còn tồn tại.',
    SYNC_PROVIDER_DISABLED: 'Nguồn đồng bộ này đang bị admin tổ chức tắt.',
    SYNC_PROVIDER_IN_USE:
      'Nguồn này còn {{n}} dự án đang dùng nên không xoá được — tắt nguồn thay vì xoá.',
    SYNC_PROVIDER_UNREACHABLE:
      'Không tới được nguồn đồng bộ, hoặc địa chỉ đó không phải API của nguồn.',
    SYNC_KEY_INVALID:
      'Nguồn từ chối API key — key sai, đã bị thu hồi, hoặc người phát hành đã rời dự án bên đó.',
    SYNC_EXTERNAL_PROJECT_TAKEN: 'Dự án bên ngoài này đã được nối với một dự án khác.',
    SYNC_RATE_LIMITED: 'Đang gọi nguồn quá nhanh — thử lại sau ít phút.',
    SYNC_REMOTE_ERROR: 'Nguồn đồng bộ báo lỗi. Thử lại sau.',
    SYNC_REMOTE_REJECTED: 'Nguồn từ chối dữ liệu gửi sang.',
    SYNC_REMOTE_NOT_FOUND: 'Nguồn không tìm thấy việc này (đã xoá hoặc thuộc dự án khác).',
    SYNC_RESPONSE_TOO_LARGE: 'Nguồn trả về quá nhiều dữ liệu một lần.',
    SYNC_PRIMARY_EXISTS: 'Dự án đã có một nguồn chính.',
    SYNC_CONNECTION_NOT_FOUND: 'Kết nối đồng bộ không tồn tại.',
    SYNC_RUNNING: 'Kết nối đang có một lượt đồng bộ chạy — đợi lượt đó xong.',
    SYNC_PROVIDER_KIND_UNSUPPORTED:
      'Loại nguồn đồng bộ này chưa được hỗ trợ ở bản cài đặt hiện tại.',
    SYNC_NO_TASK_TYPE:
      'Dự án chưa có loại việc nào nên không nhập được việc từ nguồn — thêm loại việc cho dự án rồi chạy lại.',
    // Sổ chốt phương án — APM-DSHEET-c.
    DECISION_ANSWER_CONFLICT: 'Câu này vừa được người khác chốt — hãy xem lại rồi chọn lại.',
    DECISION_IMPORT_INVALID: 'Tệp sổ chốt phương án chưa hợp lệ.',
    DECISION_SHEET_NOT_READY: 'Cần ít nhất một câu hỏi và một người chốt mới mở được sổ.',
    DECISION_SHEET_CLOSED: 'Sổ đã đóng — mở lại để sửa hoặc chốt tiếp.',
    DECISION_SHEET_NOT_CLOSED: 'Sổ chưa đóng — đóng sổ rồi mới xuất được tài liệu chốt.',
    DECISION_NOT_DECIDER: 'Bạn không phải người chốt của sổ này.',
    DECISION_OPTION_IN_USE:
      'Phương án này đang là đáp án đã chốt — bỏ chốt câu trước khi xoá hoặc đổi mã phương án.',
    DECISION_QUESTION_ANSWERED: 'Câu đã chốt — bỏ chốt trước khi xoá câu.',
    DECISION_DECIDER_NO_ACCESS:
      'Người này không có quyền xem tài liệu của dự án nên không làm người chốt được.',
    DECISION_SHEET_NOT_YET: 'Lúc đó sổ chưa được tạo.',
    DECISION_SUGGESTION_REVIEWED:
      'Gợi ý này đã được xử lý rồi — có thể người khác vừa tạo sổ hoặc bỏ nó.',
    DECISION_SUGGESTION_UNUSABLE: 'Gợi ý này không tạo được sổ chốt — hãy chạy lại AI.',
    // Link công khai của sổ chốt — APM-DSX-b.
    DECISION_SHARE_UNAVAILABLE: 'Link không còn dùng được — đã thu hồi, hết hạn hoặc không đúng.',
    DECISION_SHARE_READ_ONLY: 'Link này chỉ để xem — không chốt được.',
    DECISION_SHARE_RATE_LIMITED: 'Bạn gửi quá nhiều lần trong ít phút — chờ một lát rồi thử lại.',
    DECISION_RESPONDENT_REQUIRED: 'Cần ghi tên và email trước khi chốt.',
    // Gộp / tách tổ chức — APM-ORGMS-f (L13).
    ORG_RESTRUCTURE_IN_PROGRESS: 'Tổ chức đang là một bên của một đề xuất gộp / tách chưa xong.',
    ORG_RESTRUCTURE_DEMO: 'Tổ chức demo không gộp, không tách và không là bên của đề xuất nào.',
    ORG_RESTRUCTURE_NOT_APPROVER: 'Bạn không nằm trong danh sách người duyệt đề xuất này.',
    ORG_RESTRUCTURE_STALE_VERSION:
      'Cấu hình vừa được người khác sửa — hãy xem lại bản mới rồi thao tác lại.',
    ORG_RESTRUCTURE_BLOCKED:
      'Đã ghi lượt duyệt của bạn, nhưng đề xuất còn lỗi chặn nên chưa chạy được.',
    ORG_RESTRUCTURING: 'Tổ chức đang được gộp / tách — thường mất vài phút, hãy thử lại sau.',
    STORAGE_QUOTA_EXCEEDED:
      'Tổ chức đã dùng {{used}} trên hạn mức {{quota}}, nên không tải thêm được file {{requested}}. Xoá bớt file ở trang Files của dự án, hoặc nhờ quản trị hệ thống nâng hạn mức.',
    UNAUTHENTICATED: 'Bạn cần đăng nhập để tiếp tục.',
    TOKEN_EXPIRED: 'Phiên đăng nhập đã hết hạn.',
    FORBIDDEN: 'Bạn không có quyền thực hiện thao tác này.',
    TASK_NOT_EDITABLE: 'Bạn chỉ sửa được việc được giao cho mình hoặc do mình tạo.',
    ACTUAL_HOURS_NOT_EDITABLE:
      'Chỉ PM, quản trị hoặc quản lý của người làm mới sửa được giờ thực tế.',
    TASK_PLAN_MISSING: 'Việc này còn thiếu hạn hoặc ước lượng giờ nên chưa bắt đầu hay hoàn thành được.',
    TASK_STATUS_FORBIDDEN: 'Dự án này không cho bạn đổi trạng thái việc này.',
    TASK_DONE_FORBIDDEN: 'Dự án này không cho bạn chuyển việc này vào hay ra khỏi cột hoàn thành.',
    MEMBERSHIP_SUSPENDED:
      'Bạn đang bị tạm khoá ở {{orgs}}. Liên hệ quản trị của tổ chức để được mở khoá.',
    NOT_FOUND: 'Không tìm thấy nội dung bạn yêu cầu.',
    VALIDATION_FAILED: 'Dữ liệu chưa hợp lệ. Vui lòng kiểm tra lại.',
    RATE_LIMITED: 'Bạn thao tác quá nhanh. Vui lòng chờ một chút.',
    CONFLICT: 'Dữ liệu đã thay đổi ở nơi khác.',
    EMAIL_ALREADY_REGISTERED: 'Email này đã có tài khoản. Hãy đăng nhập, hoặc dùng email khác.',
    INTERNAL: 'Đã có lỗi xảy ra. Vui lòng thử lại.',
    FIGMA_NOT_CONFIGURED:
      'Tổ chức chưa có token Figma. Nhờ quản trị viên tổ chức nhập ở trang Quản trị › Figma.',
    FIGMA_FORBIDDEN: 'Figma từ chối token này, hoặc token không có quyền xem file.',
    FIGMA_FILE_NOT_FOUND: 'Figma không tìm thấy file này. Kiểm tra lại link.',
    FIGMA_RATE_LIMITED: 'Đã dùng hết lượt gọi Figma trong lúc này. Chờ một lúc rồi thử lại.',
    FIGMA_UNAVAILABLE: 'Không kết nối được tới Figma.',
    DESIGN_PAGE_TOO_LARGE: 'Dữ liệu Figma quá lớn để đọc một lần. Thử chụp một section nhỏ hơn.',
    TASK_NOT_DETAILED_ENOUGH:
      'Hãy mô tả công việc chi tiết hơn để dùng tính năng AI: thêm checklist, hoặc viết mô tả trên 50 từ.',
    TEAM_REPORT_FINALIZED:
      'Báo cáo đã chốt nên không sửa được nữa. Muốn số liệu hay lời văn khác thì tạo bản mới.',
    TRANSLATION_TOO_LONG:
      'Đoạn này quá dài để dịch trong một lượt. Hãy chia thành các đoạn ngắn hơn rồi dịch lại.',
    TRANSLATION_SAME_LANGUAGE: 'Đoạn này đã ở đúng ngôn ngữ đích — không cần dịch.',
    TRANSLATION_BLOCK_FAILED:
      'AI chưa dịch được đoạn này trong lượt chung — chọn đoạn rồi bấm Dịch lại khối này trên thanh trang để dịch riêng đoạn này.',
    SHARE_UNAVAILABLE:
      'Link chia sẻ này không còn mở được — có thể đã bị thu hồi, hết hạn, hoặc tài liệu đã bị xoá.',
    SHARE_ORG_ONLY: 'Tài liệu này chỉ chia sẻ trong tổ chức của người tạo link.',
    SHARE_EMAIL_NOT_FOUND: 'Email này chưa có tài khoản ChillPM.',
    // Kết nối đồng bộ của dự án — APM-SYNC-c.
    SYNC_EXTERNAL_PROJECT_MISMATCH:
      'Key này thuộc một dự án khác bên nguồn. Muốn đổi dự án nguồn thì ngắt kết nối rồi nối mới.',
    SYNC_CONNECTION_DISCONNECTED:
      'Kết nối này đã ngắt — nối lại bằng cách thêm nguồn với cùng key.',
    network: 'Không kết nối được máy chủ.',
  },
  systemMetrics: {
    orgs: 'Tổ chức',
    users: 'Người dùng',
    projects: 'Dự án',
    unitOrg: ' tổ chức',
    unitUser: ' người',
    unitProject: ' dự án',
    day: 'Hôm nay',
    week: '7 ngày',
    month: '30 ngày',
    perOrg: 'Từng tổ chức dùng tới đâu',
    colOrg: 'Tổ chức',
    colProjects: 'Dự án',
    colUsers: 'Người',
    colSince: 'Tạo ngày',
    demoTag: 'trưng bày',
    omitted: 'Còn {{n}} tổ chức nữa không liệt kê ở đây.',
    active: 'Đang hoạt động',
    activeHint:
      'Người có đăng nhập hoặc dùng app (làm mới phiên) trong khoảng — không tính tài khoản bị khoá.',
    activeDemo: 'Riêng tổ chức trưng bày: {{day}} hôm nay · {{month}} trong 30 ngày',
    files: 'Tệp',
    filesHint: 'Chỉ tính tệp người dùng tải lên, đã lưu xong và chưa bị xoá.',
    unitFile: ' tệp',
    colActive: 'Hoạt động 30 ngày',
    colFiles: 'Tệp',
    colBytes: 'Dung lượng',
  },
  systemMonitor: {
    title: 'Luồng ngầm',
    subtitle: 'Job định kỳ và job theo sự kiện của tiến trình đang chạy. Tự làm mới mỗi 30 giây.',
    onlyProblems: 'Chỉ hiện job có vấn đề',
    noProblems: 'Không job nào có vấn đề.',
    noJobs: 'Chưa có job nào được đăng ký.',
    colJob: 'Job',
    colStatus: 'Trạng thái',
    colLast: 'Lần cuối',
    colDuration: 'Mất',
    colP95: 'p95 7 ngày',
    colProjects: 'Dự án',
    colProjectsHint: 'Lượt cuối / trung bình 7 ngày',
    colNext: 'Lần tới',
    colFailures: 'Lỗi 7 ngày',
    colQueue: 'Hàng đợi',
    p95: 'p95 {{value}}',
    avg: 'TB {{value}}',
    onEvent: 'theo sự kiện',
    neverRan: 'chưa chạy lần nào',
    queue: '{{pending}} chờ · {{running}} đang chạy',
    health: {
      green: 'Ổn',
      amber: 'Cần xem',
      red: 'Có lỗi',
    },
    issues: {
      dead_24h: 'Có lượt hỏng hẳn trong 24 giờ qua',
      overdue: 'Lỡ từ 2 nhịp lịch trở lên',
      stale_running: 'Có lượt chạy quá 15 phút (nghi treo)',
      late: 'Lỡ nhịp lịch gần nhất',
      retrying: 'Lượt cuối lỗi, đang chờ thử lại',
      slow: 'Lượt cuối chậm hơn 3 lần trung vị',
    },
    runStatus: {
      queued: 'Đang chờ',
      running: 'Đang chạy',
      succeeded: 'Thành công',
      retrying: 'Lỗi, chờ thử lại',
      dead: 'Hỏng hẳn',
    },
    runsTitle: 'Các lượt gần nhất',
    runsEmpty: 'Job này chưa có lượt nào trong hàng đợi (hàng cũ bị dọn sau 30 ngày).',
    runAttempts: 'lần thử {{n}}',
    runOrg: 'tổ chức {{id}}',
    // Dòng tổng "Đồng bộ dự án" — APM-SYNC-j.
    projectSync: {
      title: 'Đồng bộ dự án',
      active: '{{n}} hoạt động',
      error: '{{n}} lỗi',
      paused: '{{n}} tạm dừng',
      disabled: '{{n}} kết nối của nguồn đang tắt',
      none: 'chưa có dự án nào kết nối',
      providerOff: 'Đang tắt',
    },
    loopsTitle: 'Vòng lặp nền',
    loopsHint:
      'Nhịp tim trong bộ nhớ của tiến trình đang trả lời — mất khi khởi động lại là bình thường.',
    loopLastTick: 'Nhịp gần nhất',
    loopEvery: 'Nhịp mong đợi',
    loopLastError: 'Lỗi gần nhất',
    durMs: '{{n}} ms',
    durSec: '{{n}} giây',
    durMin: '{{m}} phút {{s}} giây',
    durHour: '{{h}} giờ {{m}} phút',
    decimalSep: ',',
    justNow: 'vừa xong',
    agoMin: '{{n}} phút trước',
    agoHour: '{{n}} giờ trước',
    agoDay: '{{n}} ngày trước',
    inMin: 'sau {{n}} phút',
    inHour: 'sau {{n}} giờ',
    inDay: 'sau {{n}} ngày',
    nProjects: '{{n}} dự án',
    nOrgs: '{{n}} tổ chức',
    nItems: '{{n}} mục',
    loops: {
      jobs: { worker: 'Bộ chạy hàng đợi job' },
      telegram: { polling: 'Nhận tin Telegram (long poll)' },
    },
    jobs: {
      ai: {
        alerts: 'Cảnh báo AI (chi phí, tỉ lệ lỗi)',
        'prune-runs': 'Dọn lượt chạy AI cũ',
        'reap-stuck-runs': 'Gỡ lượt chạy AI bị treo',
        'rollup-daily': 'Tổng hợp chi phí AI theo ngày',
        'scan-models': 'Dò danh sách model AI',
      },
      core: { 'prune-job-queue': 'Dọn hàng đợi job' },
      demo: {
        'reset-org': 'Làm mới tổ chức trưng bày',
        'simulate-activity': 'Giả lập hoạt động trưng bày',
      },
      design: {
        'capture-snapshot': 'Chụp bản thiết kế',
        'compare-snapshots': 'So sánh bản chụp thiết kế',
        'detect-file-changes': 'Dò thay đổi tệp thiết kế',
      },
      document: {
        'backfill-extraction': 'Trích chữ tài liệu cũ',
        'extract-text': 'Trích chữ tài liệu',
      },
      events: {
        archive: 'Lưu trữ event cũ',
        'maintain-partitions': 'Bảo trì partition event_log',
      },
      files: {
        'cleanup-pending': 'Dọn tệp tải dở',
        'prune-draft-images': 'Dọn ảnh nháp',
      },
      issue: {
        actuals: 'Tính lại số đo vấn đề',
        auto_close: 'Tự đóng vấn đề',
      },
      notification: {
        fanout: 'Rải thông báo tới hộp thư',
        prune: 'Dọn thông báo cũ',
        'scan-due-soon': 'Nhắc việc sắp tới hạn',
      },
      offboarding: { 'execute-handover': 'Bàn giao khi nghỉ việc' },
      okr: { 'report-reminder': 'Nhắc báo cáo OKR' },
      org_restructure: {
        execute: 'Thực hiện tái cấu trúc tổ chức',
        expire: 'Hết hạn đề xuất tái cấu trúc',
      },
      performance: { goal_progress: 'Đo tiến độ mục tiêu cá nhân' },
      plan: { 'discard-stale-drafts': 'Huỷ kế hoạch nháp bị treo' },
      'project-sync': {
        pull: 'Kéo việc từ nguồn đồng bộ',
        schedule: 'Lịch đồng bộ dự án',
        push: 'Đẩy thay đổi ra nguồn đồng bộ',
        reconcile: 'Đối soát tuần với nguồn đồng bộ',
        'prune-runs': 'Dọn nhật ký đồng bộ cũ',
      },
      raid: { 'scan-risk-signals': 'Dò tín hiệu rủi ro' },
      reports: { 'project-health': 'Sức khoẻ dự án hằng ngày' },
      snapshots: {
        'tier-cold': 'Chuyển snapshot sang kho lạnh',
        write: 'Ghi snapshot cho Replay',
      },
      tasks: {
        'clear-milestone-types': 'Dọn loại việc của mốc cũ',
        'generate-recurring': 'Sinh việc định kỳ',
        'handover-reminder': 'Nhắc bàn giao trước kỳ nghỉ',
        'task-actuals': 'Tính lại số đo của việc',
      },
      telegram: { send: 'Gửi tin Telegram' },
      timesheet: {
        'auto-pause': 'Tự dừng đồng hồ chấm công',
        'start-reminder': 'Nhắc bấm giờ đầu ca qua Telegram',
      },
      users: { 'deactivate-offboarded': 'Khoá tài khoản đã nghỉ việc' },
      velocity: {
        'drift-scan': 'Dò lệch so với velocity',
        'sync-samples': 'Đồng bộ mẫu velocity',
      },
    },
  },
  system: {
    title: 'Hệ thống',
    probesTitle: 'Chuỗi kết nối',
    web: 'Web (Vite)',
    api: 'API (NestJS)',
    database: 'MySQL',
    running: 'đang chạy',
    stalled: 'Mồ côi',
    connected: 'kết nối được',
    disconnected: 'không kết nối được',
    mysqlHint: 'Chưa chạy MySQL? Chạy lệnh',
    apiHint: 'Không gọi được API — đã chạy pnpm dev chưa?',
  },
  storage: {
    title: 'Nơi lưu trữ file (S3)',
    subtitle: 'File không nằm trong máy chủ ứng dụng. Cấu hình một bucket S3, R2 hoặc MinIO ở đây.',
    notConfigured: 'Chưa cấu hình',
    notConfiguredHelp:
      'Ứng dụng vẫn chạy bình thường, nhưng tải file và kho tài liệu sẽ bị khoá cho tới khi có cấu hình hợp lệ.',
    active: 'Đang dùng',
    verified: 'Đã kiểm tra',
    unverified: 'Chưa kiểm tra',
    noConfigs: 'Chưa có cấu hình nào',
    noConfigsHelp: 'Thêm một cấu hình bên dưới, kiểm tra kết nối, rồi kích hoạt.',
    provider: 'Nhà cung cấp',
    endpoint: 'Endpoint',
    endpointOptional: 'Bỏ trống để dùng endpoint mặc định của AWS theo region.',
    endpointRequired: 'Bắt buộc với nhà cung cấp này.',
    awsDefaultEndpoint: 'endpoint mặc định AWS',
    region: 'Region',
    bucket: 'Bucket',
    accessKey: 'Access key ID',
    secretKey: 'Secret access key',
    sse: 'Mã hoá phía máy chủ',
    forcePathStyle: 'Dùng path-style (MinIO, một số cấu hình R2)',
    browserBaseUrl: 'URL cho trình duyệt (tuỳ chọn)',
    browserBaseUrlHint:
      'Chỉ điền khi không đặt được CORS cho bucket. Ví dụ https://app.congty.vn/_s3 — reverse proxy cùng tên miền phải chuyển đường dẫn này về bucket. Bỏ trống thì trình duyệt gọi thẳng bucket.',
    browserBaseUrlDirect: 'trình duyệt gọi thẳng bucket',
    browserBaseUrlVia: 'trình duyệt đi qua {{url}}',
    browserBaseUrlEdit: 'Sửa URL cho trình duyệt',
    browserBaseUrlSave: 'Lưu',
    browserBaseUrlCancel: 'Huỷ',
    browserBaseUrlSaved:
      'Đã lưu URL cho trình duyệt. Tải thử một tệp để kiểm tra đường đi qua proxy.',
    addConfig: 'Thêm cấu hình',
    testBeforeActivate:
      'Cấu hình mới chưa được kích hoạt ngay. Phải kiểm tra kết nối thành công trước.',
    testConnection: 'Kiểm tra kết nối',
    testPassed: 'Kết nối tốt: ghi, đọc và xoá đều được.',
    testFailed: 'Kiểm tra thất bại. Xem chi tiết từng bước bên dưới.',
    mustTestFirst: 'Phải kiểm tra kết nối thành công trước khi kích hoạt.',
    activate: 'Kích hoạt',
    activated: 'Đã kích hoạt cấu hình.',
    created: 'Đã thêm cấu hình. Hãy kiểm tra kết nối.',
  },
  usage: {
    title: 'Dung lượng theo tầng',
    subtitle:
      'Tầng nóng nằm trong MySQL và làm backup chậm dần; tầng nguội nằm trên S3 và chỉ tốn tiền lưu trữ.',
    hot: 'Tầng nóng (MySQL)',
    hotHint: 'Truy cập tức thì. Replay 30 ngày gần nhất đọc ở đây.',
    cold: 'Tầng nguội (S3)',
    coldHint: 'Event và snapshot cũ. Đọc chậm hơn nhưng hiếm khi cần.',
    files: 'File người dùng (S3)',
    filesHint: 'Đính kèm, tài liệu, bản xuất.',
    eventLog: 'Bảng event_log',
    events: 'Số event',
    snapshots: 'Snapshot',
    archived: 'Đã archive',
    committed: 'Đã xác nhận',
    fileCount: 'Số file',
    pending: 'Đang chờ',
    partitions: 'Partition',
    pendingWarning: '{{count}} upload dở dang — kiểm tra job dọn',
  },
  knowledge: {
    title: 'Sổ kiến thức',
    subtitle:
      'Kinh nghiệm quản lý dự án và ước lượng mà trợ lý AI đọc khi phán đoán. Đổi một mục là mất cache của mọi skill cùng tag.',
    help: 'Mục "active" có nhãn "prompt" đi vào system prompt của skill cùng tag, như dữ liệu tham khảo — không phải lệnh.',
    add: 'Thêm mục',
    empty: 'Chưa có mục kiến thức nào.',
    saved: 'Đã lưu sổ kiến thức',
    disable: 'Tắt',
    enable: 'Bật lại',
    approve: 'Duyệt',
    source: 'Nguồn',
    usedBy: 'Đang vào skill: {{skills}}',
    usedByNone: 'Không skill nào đang đọc mục này',
    status: { active: 'Đang dùng', disabled: 'Đã tắt', ai_suggested: 'AI đề xuất — chờ duyệt' },
    tag: {
      estimate: 'ước lượng',
      assign: 'giao việc',
      plan: 'lập kế hoạch',
      risk: 'rủi ro',
      retro: 'retro',
      okr: 'OKR',
      critic: 'phản biện (chỉ người phản biện đọc)',
      'harness:invariant': 'bài học chung của harness (lớp 1 của mọi skill, trần 300 token)',
    },
    lives: { prompt: 'prompt', code: 'code', metric: 'metric' },
    metric: {
      overdue_task_pct: 'Tỉ lệ việc đang mở đã quá hạn',
      late_start_pct: 'Tỉ lệ việc tới ngày bắt đầu mà chưa bắt đầu',
    },
    form: {
      title: 'Tiêu đề',
      body: 'Nội dung',
      bodyHint:
        'Một đến ba đoạn: điều gì đúng, vì sao, hệ quả nếu bỏ qua — rồi "hệ thống dùng thế nào".',
      tags: 'Tag (skill nào đọc)',
      lives: 'Sống ở đâu',
      livesHint:
        'Chỉ mục có "prompt" mới vào system prompt. "code" là luật đã nằm trong solver; "metric" là thứ cần đo — chọn chỉ số bên dưới để kèm số của tổ chức.',
      source: 'Nguồn',
      metric: 'Chỉ số kèm',
      noMetric: 'Không kèm số',
      since: 'Từ (YYYY-MM)',
    },
    impact: {
      none: 'Chưa skill nào đọc tag này — lưu không làm mất cache.',
      some: 'Lưu sẽ đổi system prompt của: {{skills}}. {{calls}} lượt gọi 24 giờ qua sẽ mất cache ở lượt kế.',
      overBudget:
        '⚠ Vượt trần khối kiến thức — những mục dài nhất sẽ bị bỏ khỏi prompt: {{skills}}',
    },
  },
  aiMemory: {
    title: 'Bộ nhớ AI của dự án',
    subtitle:
      'Sự thật bền mà trợ lý AI đọc mỗi lượt chạy trong dự án này — do người xác nhận, AI chỉ đề xuất.',
    userTitle: 'Bộ nhớ AI của tôi',
    userSubtitle: 'Ghi chú chỉ đi vào prompt của chính bạn, không của người khác.',
    help: {
      project:
        'Mỗi ghi chú là một dòng trong lớp bộ nhớ của prompt (ảnh chụp, không phải lịch sử). Xoá được từng dòng.',
      user: 'Ghi chú cá nhân: chỉ vào prompt khi chính bạn chạy trợ lý.',
      org: 'Ghi chú cấp tổ chức: vào prompt của mọi run trong tổ chức.',
    },
    empty: 'Chưa có ghi chú nào.',
    add: 'Thêm',
    placeholder: 'Ví dụ: đội làm 4 ngày một tuần',
    saved: 'Đã ghi nhớ',
    remembered: 'Đã ghi nhớ',
    rememberThis: 'Ghi nhớ điều này?',
    stillTrue: 'Vẫn đúng',
    confirmed_one: 'được xác nhận {{count}} lần',
    confirmed_other: 'được xác nhận {{count}} lần',
    origin: { manual: 'thêm tay', answer: 'từ câu trả lời hỏi lại', rejection: 'từ lý do từ chối' },
    durability: { durable: 'bền', temporary: 'tạm (30 ngày)' },
  },
  aiConsole: {
    title: 'Bảng điều khiển AI',
    subtitle:
      'Mọi thứ quản trị viên quản lý về trợ lý AI, một trang: kiến thức, ghi nhớ, prompt, chính sách, model, hạn mức.',
    forbidden: 'Bạn không có quyền quản trị cấu hình AI.',
    lastChanged: 'sửa lần cuối {{at}}',
    tabs: {
      knowledge: 'Kiến thức',
      memory: 'Ghi nhớ',
      prompts: 'Prompt',
      policy: 'Chính sách',
      models: 'Model',
      budgets: 'Hạn mức',
    },
    history: {
      show: 'Lịch sử',
      hide: 'Ẩn lịch sử',
      empty: 'Chưa có thay đổi nào.',
      system: 'hệ thống',
    },
    memory: {
      org: 'Ghi chú cấp tổ chức',
      project: 'Ghi chú của dự án',
      noProject: 'Chưa có dự án nào.',
      userNote:
        'Ghi chú cá nhân chỉ chính người đó thấy ở "Cài đặt của tôi" — quản trị không xem được.',
    },
    prompts: {
      skill: 'Skill',
      noSkill: 'Chưa có skill nào đăng ký.',
      active: 'Đang dùng: {{version}}',
      codeDefault: 'prompt trong code',
      impact:
        '{{calls}} lượt gọi / {{runs}} run trong 24 giờ qua sẽ mất cache khi kích hoạt bản mới',
      codePrompt: 'Xem prompt trong code',
      status: { draft: 'nháp', active: 'đang dùng', retired: 'đã rút' },
      forced: 'Ép qua golden: {{reason}}',
      diff: 'So sánh',
      diffBase: 'Bản đang dùng (hoặc code)',
      diffNext: 'Bản chọn',
      activate: 'Kích hoạt',
      force: 'Ép qua',
      forceHint: 'Cần lý do ≥ 5 ký tự ở ô bên dưới. Ghi lên phiên bản.',
      retire: 'Rút',
      retired: 'Đã rút phiên bản',
      goldenProject: 'Dự án thử để chạy golden set trước khi kích hoạt',
      goldenProjectNone: '— chưa chọn (kích hoạt sẽ bị chặn nếu skill có golden) —',
      forceReason: 'Lý do ép qua khi golden đỏ',
      forceReasonHint: 'ví dụ: thử nghiệm nội bộ, biết rủi ro',
      goldenFailed: 'Golden set đỏ — bản này chưa được kích hoạt:',
      activated: 'Đã kích hoạt {{version}}',
      activatedWithGolden: 'Đã kích hoạt {{version}} — golden {{passed}}/{{ran}} xanh',
      newDraft: 'Bản nháp mới (system prompt)',
      draftHint: 'Prompt hệ thống của skill. Luật harness được nối tự động.',
      draftHintDynamic:
        'Skill này có prepare(): bản nháp bắt buộc chứa {{dynamic}} — chỗ chèn phần động do code dựng.',
      notes: 'Ghi chú cho phiên bản (tuỳ chọn)',
      saveDraft: 'Lưu nháp',
      draftSaved: 'Đã lưu nháp {{version}}',
      // Bản ghi bằng chứng khi kích hoạt — APM-H-ao.
      experience: {
        title: 'Bản ghi bằng chứng (bắt buộc khi kích hoạt)',
        help: 'Golden xanh nói "không hỏng", không nói "vì sao đổi". Ghi: khi gặp dấu hiệu gì thì sửa gì, và run thử nào cho thấy. Lưu cùng nháp hoặc gửi lúc kích hoạt — bản gửi lúc kích hoạt thắng. Ép qua golden vẫn cần bằng chứng.',
        cue: 'Dấu hiệu (cue)',
        cueHint: 'ví dụ: model gộp hai việc không liên quan thành một',
        lesson: 'Bài học (lesson)',
        lessonHint: 'ví dụ: nhắc chia theo ranh giới dữ liệu trước khi chia theo thứ tự làm',
        runIds: 'Run sandbox làm bằng chứng',
        runIdsHint: 'Chạy thử bản nháp ở trang Harness (chế độ sandbox) rồi dán id run — mỗi dòng hoặc dấu phẩy một id',
        confidence: 'Độ tin',
        confidenceOf: { low: 'thấp', medium: 'vừa', high: 'cao' },
        scope: 'Phạm vi bài học',
        scopeOf: { invariant: 'mọi skill', domain: 'skill này' },
        incomplete: 'Điền đủ dấu hiệu, bài học và ít nhất một run id (hoặc nháp đã khai sẵn) rồi mới kích hoạt được.',
        stored: 'Nháp đã khai sẵn bằng chứng — để trống ô bên dưới thì dùng bản ấy.',
        runs: '{{count}} run',
        golden: 'golden {{before}} → {{after}}',
        none: 'Chưa có bản ghi bằng chứng',
      },
    },
    models: {
      help: 'Mỗi hàng một model: giá đang hiệu lực và năng lực (thinking, output_format, cache_control). "Kiểm năng lực" gửi ba lời gọi thật rất nhỏ.',
      empty: 'Chưa có model nào có giá hay năng lực.',
      price: 'vào {{input}} · ra {{output}} USD/1M token',
      noPrice: 'chưa có bảng giá — lời gọi sẽ bị bỏ qua model này',
      capability:
        'thinking: {{thinking}} · output_format: {{format}} · cache_control: {{cache}} · ảnh: {{vision}}',
      yes: 'có',
      no: 'không',
      verifiedAt: 'đã kiểm {{at}}',
      manual: 'khai tay {{at}}',
      unknownCapability: 'Chưa biết năng lực — dùng mặc định theo provider.',
      verify: 'Kiểm năng lực',
      verifyHint: 'Ba ping nhỏ, tốn tiền thật (feature: ping).',
      verified: 'Đã kiểm {{model}}',
      check: { thinking: 'thinking', outputFormat: 'output_format', cacheControl: 'cache_control' },
      editPrice: 'Sửa giá',
      priceTitle: 'Giá model',
      priceHelp:
        'Model chưa có giá thì mọi lời gọi bỏ qua nó. Giá tính bằng USD cho 1 triệu token, lấy từ bảng giá công bố của nhà cung cấp; hiệu lực ngay, giá cũ được đóng lại chứ không sửa. Hệ số cache: giá đọc cache so với giá input (bỏ trống ⇒ giữ như cũ, model mới là 0.1).',
      priceSaved: 'Đã lưu giá {{model}}',
      manualTitle: 'Khai tay năng lực',
      manualHelp: 'Khi gateway không cho ping. Khai tay xoá mốc kiểm cũ của model đó.',
      saved: 'Đã lưu năng lực',
      field: {
        modelId: 'Model id',
        provider: 'Provider',
        thinkingStyle: 'Kiểu diễn đạt suy nghĩ',
        supportsThinking: 'Có thinking',
        supportsOutputFormat: 'Có output_format',
        supportsCacheControl: 'Có cache_control',
        supportsVision: 'Đọc được ảnh',
        inputPrice: 'Input (USD/1M)',
        outputPrice: 'Output (USD/1M)',
        cacheRead: 'Hệ số đọc cache',
      },
    },
  },
  harness: {
    versions: {
      label: 'Phiên bản harness',
      default: 'Theo mặc định hệ thống ({{version}})',
      active: 'Đang dùng cho lượt mới: {{version}}',
      history: 'Lịch sử thay đổi harness',
      setDefault: 'Đặt làm mặc định',
      saved: 'Đã đổi phiên bản mặc định. Lượt đang chạy giữ phiên bản cũ.',
      used: 'Phiên bản đã chạy: {{version}}',
      // Thư viện bài học — APM-H-ao.
      experience: {
        title: 'Bản prompt đã kích hoạt kèm bằng chứng',
        empty: 'Chưa bản prompt nào được kích hoạt kèm bằng chứng.',
        openRun: 'Mở run ở tab So hai run',
        replaced: 'đã bị thay thế',
        golden: 'golden {{before}} → {{after}}',
        scope: { invariant: 'mọi skill', domain: 'skill này' },
        confidence: { low: 'tin thấp', medium: 'tin vừa', high: 'tin cao' },
      },
    },
    title: 'Harness',
    subtitle:
      'Chạy thử skill, đọc dấu vết theo sáu khối, so hai run, registry và chỉ số — cho người vận hành.',
    forbidden: 'Bạn không có quyền dùng trang Harness.',
    tabs: {
      run: 'Chạy thử',
      direct: 'Đối chứng',
      compare: 'So hai run',
      registry: 'Registry',
      prompts: 'Prompt',
      metrics: 'Chỉ số',
      models: 'Model & benchmark',
    },
    // Tab "Model & benchmark" — APM-MDL-c/-d.
    models: {
      sourceTitle: 'Nguồn benchmark công khai',
      sourceHelp:
        'Key Artificial Analysis (miễn phí, 1 000 lượt/ngày). Job quét 04:00 tải chỉ số từng model để đề xuất model + mức suy nghĩ cho việc khó / hằng ngày / dễ.',
      sourceStatus: 'Key …{{last4}} · {{count}} dòng benchmark · tải lần cuối {{at}}',
      notConfigured: 'Chưa nhập key nguồn benchmark — đề xuất chỉ dựa vào số đo nội bộ.',
      keyPlaceholder: 'API key Artificial Analysis',
      saveKey: 'Lưu key',
      fetchNow: 'Tải ngay',
      saved: 'Đã lưu key nguồn benchmark.',
      fetched: 'Đã tải {{count}} dòng benchmark.',
      tableTitle: 'Benchmark công khai đang có',
      empty: 'Chưa có dòng nào.',
      col: {
        model: 'Model',
        effort: 'Mức suy nghĩ',
        intelligence: 'Intelligence',
        coding: 'Coding',
        price: 'Giá/1M (blended)',
      },
      attribution: 'Nguồn: Artificial Analysis (artificialanalysis.ai).',
    },
    stage: {
      context: 'Context',
      llm: 'LLM',
      policy: 'Policy',
      runtime: 'Runtime',
      verify: 'Verify',
      result: 'Kết quả',
    },
    trace: {
      turn: 'lượt',
      allTurns: 'mọi lượt',
      turnLabel: 'lượt {{turn}}',
      dropped: 'bỏ {{count}} khối',
      rawPrompt: 'Xem prompt thô',
      hidden: 'tool bị ẩn',
    },
    usage: { none: 'Chưa có bước usage (bản bền chưa tải).', turn: 'lượt' },
    run: {
      skill: 'Skill',
      project: 'Dự án',
      mode: 'Chế độ',
      modeHint: {
        sandbox:
          'Gợi ý gắn cờ sandbox, không hiện ở màn nghiệp vụ; bản nháp prompt của bạn (nếu có) được dùng.',
        real: 'Hệt như người dùng bấm — dùng để tái hiện lỗi được báo.',
        replay:
          'Tool trả đúng kết quả của run gốc, chỉ model được gọi lại — đo prompt mới trên cùng đầu vào.',
      },
      sourceRun: 'Run gốc (replay)',
      prompt: 'Yêu cầu',
      params: 'Tham số',
      start: 'Chạy',
      running: 'Đang chạy…',
      done: 'Run xong',
      streaming: 'đang nhận bước…',
      needProject: 'Chọn một dự án trước.',
      compare: 'Mở ở So hai run',
      saveFixture: 'Lưu fixture',
    },
    compare: {
      left: 'Run A',
      right: 'Run B',
      pickTwo: 'Chọn hai run để so.',
      contentDiff: 'Khác biệt content',
    },
    direct: {
      help: 'Cùng skill, cùng đầu vào, chạy cả hai cùng lúc: run harness (sandbox, đủ tool/hook/kiểm) và một lời gọi thẳng model (chỉ system prompt của skill + yêu cầu, ép JSON). Cả hai đều tốn tiền thật với key của bạn.',
      runBoth: 'Chạy cả hai',
      harness: 'Harness',
      direct: 'Gọi thẳng model',
      harnessTrace: 'Dấu vết run harness',
      yes: 'có',
      no: 'không',
      row: {
        valid: 'Output hợp lệ (Zod)',
        items: 'Số mục',
        ungrounded: 'Id không có căn cứ',
        rejected: 'Phần finalize loại',
        verifyRetries: 'Lần nộp hỏng',
        turns: 'Lượt · tool',
        cost: 'Chi phí',
        latency: 'Độ trễ',
        tokens: 'Token',
        model: 'Model',
        prompt: 'Phiên bản prompt',
      },
    },
    registry: {
      skills: 'Skill ({{count}})',
      tools: 'Tool ({{count}})',
      manual: 'làm tay',
      usedBy: 'skill dùng',
      writes: 'GHI',
      crossProject: 'xuyên dự án',
    },
    metrics: {
      window: 'Cửa sổ {{from}} → {{to}}',
      allSkills: 'mọi skill',
      noBreach: 'Không chỉ số nào vượt ngưỡng.',
      sparkline: 'Run theo ngày',
      sparklineHint: 'cột = số run, đỏ = run lỗi',
    },
  },
  aiUsage: {
    title: 'Lưu lượng AI',
    subtitle: 'Token, chi phí và hạn mức. Số tiền đối chiếu được với hoá đơn Anthropic.',
    lastDays: '{{count}} ngày',
    exportCsv: 'Xuất CSV',
    cost: 'Chi phí',
    calls: 'lượt gọi',
    cacheHit: 'Tỉ lệ cache hit',
    cacheHitHint: 'Phần token đầu vào phục vụ từ cache — càng cao càng rẻ.',
    avgLatency: 'Độ trễ trung bình',
    overTime: 'Chi phí theo ngày',
    byFeature: 'Theo tính năng',
    byModel: 'Theo model',
    topUsers: 'Tiêu nhiều nhất',
    byProject: 'Theo dự án',
    noData: 'Chưa có dữ liệu',
    empty: 'Chưa có lời gọi AI nào',
    emptyHelp: 'Cấu hình key AI rồi dùng thử một tính năng để thấy số liệu ở đây.',
    perOrg: 'toàn tổ chức',
    perUser: 'theo người dùng',
    nearLimit: 'Sắp chạm hạn mức',
    overLimit: 'Đã vượt hạn mức — lời gọi mới bị chặn',
    rollupLagging: '{{count}} ngày chưa tổng hợp — kiểm tra job rollup',
    period: { day: 'Hạn mức ngày', month: 'Hạn mức tháng' },
  },
  /**
   * Ô nhập key AI cho tổ chức trưng bày — APM-1318e.
   *
   * `warning` nói cả hai thứ trong một câu: ai cũng tiêu được, và chưa đặt hạn
   * mức thì không có trần. Tách làm hai dòng thì người vận hành đọc dòng đầu
   * rồi dán key, và dòng thứ hai thành lời giải thích sau tai nạn.
   */
  miniApp: {
    loading: 'Đang mở…',
    outside:
      'Màn hình này chỉ chạy bên trong Telegram. Mở bot rồi bấm nút menu cạnh ô nhập tin nhắn.',
    openWeb: 'Mở bản web',
    notLinked: {
      title: 'Tài khoản Telegram này chưa kết nối',
      help: 'Mở trình duyệt để kết nối — ở đó bạn thường đã đăng nhập sẵn, khỏi phải đăng nhập lại trong Telegram. Kết nối xong thì quay lại đây.',
      openBrowser: 'Mở trình duyệt để kết nối',
      retry: 'Tôi đã kết nối xong, thử lại',
    },
    reopen: 'Đóng và mở lại',
    error: {
      title: 'Chưa mở được Mini App',
      openBrowser: 'Mở bằng trình duyệt',
      closeManually: 'Nếu cửa sổ chưa đóng, bấm dấu × ở góc trên rồi mở lại từ nút menu của bot.',
    },
    tabTimer: 'Bấm giờ',
    tabsLabel: 'Mục của Mini App',
    timerRunning: 'Đang bấm giờ',
    timerPaused: 'Đang tạm dừng',
    tabInbox: 'Thông báo',
    greeting: 'Chào {{name}}',
  },
  telegramTypes: {
    'task.assigned': 'Được giao việc mới',
    'task.unassigned': 'Việc của tôi chuyển cho người khác',
    'task.edited': 'Việc tôi đang làm bị người khác sửa',
    'task.time_running_out': 'Việc đang làm chỉ còn 10% thời gian tới hạn',
    'comment.mentioned': 'Có người nhắc tên tôi',
    'announcement.sent': 'Thông báo từ quản lý',
    'membership_request.invited': 'Lời mời tham gia dự án',
    'membership_request.applied': 'Có người đăng ký vào dự án tôi quản lý',
    'project_approval.requested': 'Có dự án mới chờ tôi duyệt',
    'project_approval.approved': 'Dự án tôi mở được duyệt',
    'project_approval.rejected': 'Dự án tôi mở bị từ chối',
    'project_approval.decided_by_other': 'Người khác duyệt thay dự án đang chờ tôi',
    'project.member_left': 'Thành viên rời dự án của tôi',
    'raid.risk_high': 'Rủi ro vượt ngưỡng cao',
    'raid.signals_detected': 'Tín hiệu rủi ro mới',
    'schedule.drift_detected': 'Lịch dự án đang lệch',
    'schedule.impact_detected': 'Lịch đổi ảnh hưởng kế hoạch',
    'schedule.deadline_changed': 'Hạn cuối dự án, sprint hoặc mốc bị dời',
    'sprint.ending_soon': 'Sprint tôi quản lý sắp tới ngày kết thúc',
    'sprint.last_day': 'Ngày cuối của sprint tôi quản lý',
    'sprint.auto_closed': 'Sprint tôi quản lý đã tự đóng khi hết hạn',
    'handover.suggested': 'Gợi ý bàn giao khi có người vắng',
    'design_file.remote_version_detected': 'File Figma có bản mới',
    'timesheet.timer_overdue': 'Đang bấm giờ cho việc đã quá hạn',
    'timesheet.session_capped': 'Đồng hồ tự dừng ở 12 giờ',
    'timesheet.overtime_capped': 'Đồng hồ làm thêm tự dừng',
    'timesheet.day_capped': 'Đồng hồ tự dừng vì đủ giờ trong ngày',
    'timesheet.start_reminder': 'Đầu ca mà chưa bấm giờ (kèm nút xin nghỉ nhanh)',
    'absence.requested': 'Người tôi quản lý trực tiếp xin nghỉ (kèm nút Duyệt)',
    'absence.retracted': 'Người tôi quản lý trực tiếp rút đơn nghỉ',
    'org_join_request.created': 'Có người xin vào tổ chức qua link mời (quản trị tổ chức)',
    'ai_budget.soft_limit_reached': 'Chi phí AI vượt ngưỡng cảnh báo',
    'issue.state_changed': 'Issue tôi gửi hoặc theo dõi đổi trạng thái',
    'issue.resolved': 'Issue đã xử lý, chờ tôi xác nhận',
    'issue.reopened': 'Issue tôi xử lý bị mở lại',
    'issue.watcher_added': 'Được chia sẻ một issue để theo dõi',
    // Trao đổi trên issue — APM-ISC-c.
    'issue.replied': 'Đội xử lý trả lời issue tôi gửi hoặc theo dõi',
    'issue.customer_replied': 'Người gửi phản hồi issue tôi xử lý',
    'issue.internal_comment': 'Trao đổi nội bộ trên issue tôi xử lý',
    'issue.assigned': 'Được giao xử lý một issue',
    'org_restructure.updated': 'Đề xuất gộp / tách tổ chức cần bạn xem',
    'okr.report_due': 'Kết quả then chốt trong OKR cần báo số',
    // Luồng lỗi kiểm thử — APM-TEST2-b.
    'bug.assigned': 'Được giao sửa một lỗi kiểm thử',
    'bug.fixed': 'Lỗi tôi ghi đã sửa xong, chờ tôi kiểm lại',
    'bug.still_failing': 'Lỗi tôi sửa bị báo vẫn còn',
    'bug.closed': 'Lỗi tôi sửa đã được xác nhận và đóng',
    'decision_sheet.invited': 'Được mời chốt phương án trong một sổ',
    'document.review_requested': 'Có tài liệu trong dự án tôi quản lý được gửi duyệt',
    'document.mentioned': 'Có người nhắc tên tôi trong một tài liệu',
  },
  telegramGroups: {
    work: 'Việc của tôi',
    timesheet: 'Bấm giờ',
    issue: 'Issue vận hành',
    bug: 'Lỗi kiểm thử',
    document: 'Tài liệu & thiết kế',
    project: 'Dự án & thành viên',
    planning: 'Kế hoạch & rủi ro (cho PM)',
    org: 'Tổ chức',
    count: '{{on}}/{{total}} đang bật',
    toggleAll: 'Bật / tắt cả nhóm {{group}}',
  },
  telegramLink: {
    reminder: {
      dot: 'chưa thiết lập Telegram',
      badge: 'Telegram',
      cardBadge: 'Cần thiết lập',
    },
    title: 'Telegram',
    subtitle:
      'Nhận thông báo công việc qua Telegram, và cập nhật tiến độ ngay trong đó — không cần mở web.',
    botMissing: 'Quản trị viên chưa cấu hình bot Telegram cho hệ thống, nên phần này đang tắt.',
    intro:
      'Bấm nút dưới đây, Telegram sẽ mở ra. Bấm tiếp “Start” trong Telegram là xong — không cần nhập mã.',
    connect: 'Kết nối Telegram',
    connecting: 'Đang tạo liên kết…',
    waiting: 'Đang chờ bạn bấm “Start” trong Telegram. Quét mã bằng điện thoại nếu Telegram ở đó.',
    qrAlt: 'Mã QR mở cuộc trò chuyện với bot',
    openTelegram: 'Mở lại Telegram',
    expiresIn: 'Liên kết hết hạn sau {{mm}}:{{ss}}',
    expired: 'Liên kết đã hết hạn. Bấm “Kết nối Telegram” để lấy liên kết mới.',
    since: 'Kết nối từ {{at}}',
    unnamed: 'Tài khoản Telegram',
    blocked:
      'Bạn đang chặn bot, hoặc đã xoá cuộc trò chuyện — thông báo không tới được. Mở lại cuộc trò chuyện với bot và gõ /start để nhận tiếp.',
    test: 'Gửi tin thử',
    testSent: 'Đã gửi. Kiểm tra Telegram của bạn.',
    unlink: 'Ngắt kết nối',
    unlinkConfirm:
      'Ngắt kết nối thì bạn sẽ không nhận thông báo qua Telegram nữa. Nối lại bất cứ lúc nào.',
    unlinked: 'Đã ngắt kết nối Telegram.',
    prefsTitle: 'Gửi cho tôi những loại này',
    prefsSave: 'Lưu tuỳ chọn',
    prefsSaving: 'Đang lưu…',
    prefsSaved: 'Đã lưu tuỳ chọn.',
    quietTitle: 'Giờ im lặng',
    quietFrom: 'Từ',
    quietTo: 'Đến',
    quietHelp:
      'Trong khoảng này Telegram sẽ im. Tin **không** dồn lại gửi sau — chúng vẫn nằm đầy đủ trong hộp thư trên web.',
  },
  // Đồng bộ dự án với hệ thống ngoài — APM-SYNC-*, docs/plan-project-sync.md.
  // Tên `projectSync`, không phải `sync` (bẫy trùng khoá cấp cao nhất).
  // Tab Git — docs/plan-git-integration.md. MỌI khoá của tính năng nằm dưới khối này;
  // task sau thêm khối con của mình vào CUỐI khối, đừng sắp lại phần sẵn có.
  gitTab: {
    // APM-GIT-o — trình hướng dẫn cấu hình Git ở Cấu hình dự án → Kho mã Git.
    wizard: {
      title: 'Kho mã Git',
      subtitle:
        'Nối dự án với GitLab hoặc GitHub để ChillPM tự thấy nhánh, merge request và commit của từng việc.',
      intro:
        'Làm lần lượt bốn bước dưới đây, mất khoảng 5 phút. Bước sau mở ra khi bước trước xong.',
      stepLabel: 'Bước {{n}}',
      status: { done: 'Xong', current: 'Đang làm', locked: 'Chưa tới' },
      lockedHint: 'Làm xong bước phía trên để mở bước này.',
      optionalLater:
        'Các tuỳ chọn thêm (tên nhánh, tự đổi trạng thái việc, cập nhật tức thì…) hiện ở đây sau khi bạn làm xong bốn bước.',
      openSettings: 'Cấu hình Git',
      host: {
        title: 'Chọn máy chủ git',
        pick: 'Kho mã của dự án nằm ở máy chủ nào?',
        kind: { gitlab: 'GitLab', github: 'GitHub' },
        chosen: 'Máy chủ: {{name}}',
        change: 'Chọn máy chủ khác',
        noneTitle: 'Chưa có máy chủ git nào để chọn',
        noneBody:
          'Admin tổ chức cần khai địa chỉ GitLab / GitHub của công ty trước — việc này chỉ làm một lần cho cả tổ chức. Gửi lời nhắn dưới đây cho admin tổ chức; khai xong thì quay lại trang này.',
        message:
          'Chào anh/chị, dự án «{{project}}» cần nối với kho mã trên GitLab/GitHub của công ty. Nhờ anh/chị khai máy chủ git trong ChillPM ở Quản trị → Máy chủ git: {{url}} . Cảm ơn anh/chị!',
        copyMessage: 'Sao chép lời nhắn',
        copied: 'Đã sao chép lời nhắn.',
        copyFailed: 'Không sao chép được — hãy chọn và chép tay lời nhắn ở trên.',
        orgAdminHint: 'Bạn là admin tổ chức nên tự khai được ngay.',
        openAdmin: 'Mở Quản trị → Máy chủ git',
      },
      token: {
        title: 'Tạo token trên máy chủ git',
        whatIsToken:
          'Token là một chuỗi ký tự dài, giống một chiếc chìa khoá riêng: nó cho ChillPM vào đọc kho mã của dự án mà không cần mật khẩu của ai.',
        levelQuestion: 'Bạn muốn ChillPM làm gì với kho mã?',
        level: { read: 'Chỉ xem', write: 'Xem + tạo nhánh/MR từ ChillPM' },
        levelHint: {
          read: 'ChillPM chỉ đọc: thấy nhánh, merge request (MR — đề nghị gộp code vào nhánh chính), commit, rồi tự nối chúng vào việc. Không sửa gì trong kho. Hợp với hầu hết dự án.',
          write:
            'Như "Chỉ xem", thêm: bấm một nút ở chi tiết việc là tạo được nhánh hoặc merge request ngay trong kho, dưới tên tài khoản của token.',
        },
        repoUrlLabel: 'Link kho (không bắt buộc)',
        repoUrlHint:
          'Dán link kho thì hướng dẫn có nút mở thẳng đúng trang, và bước chọn kho điền sẵn link này.',
        repoUrlOther: 'Link này không thuộc máy chủ {{host}} — kiểm lại, hoặc để trống.',
        followSteps: 'Làm theo từng bước trên {{host}}:',
        ready: 'Tôi đã có token — sang bước tiếp',
        chosenLevel: 'Mức quyền đã chọn: {{level}}',
        review: 'Xem lại hướng dẫn',
        showGuide: 'Xem cách tạo token',
      },
      guide: {
        openHost: 'Mở máy chủ git',
        gitlab: {
          openKnown:
            'Bấm nút dưới để mở trang tạo token của kho **{{path}}**. Nếu GitLab hỏi thì đăng nhập; tài khoản cần vai **Maintainer** trên kho.',
          openFind:
            'Mở GitLab, vào trang của kho mã dự án, rồi ở cột trái chọn **Settings** → **Access tokens**. Không thấy mục này nghĩa là tài khoản của bạn chưa đủ quyền trên kho — nhờ người quản lý kho (vai **Maintainer**) làm bước này, hoặc dùng token cá nhân ở cuối hướng dẫn.',
          openTokens: 'Mở trang Access tokens của kho',
          name: 'Bấm **Add new token**. Ở ô **Token name**, gõ **ChillPM**.',
          role: 'Ở ô **Select a role**, chọn **{{role}}**.',
          scope: 'Ở phần **Select scopes**, chỉ tích một ô **{{scope}}**.',
          expiry:
            'Ở ô **Expiration date**, chọn ngày hết hạn (GitLab cho tối đa một năm). Không cần lo quên: ChillPM nhắc bạn 14 ngày trước khi token hết hạn.',
          create:
            'Bấm **Create project access token**. Token hiện ngay ở đầu trang — bấm biểu tượng sao chép cạnh nó. ⚠️ Token chỉ hiện **một lần**: đóng trang là không xem lại được, phải tạo token mới.',
          personal:
            'Không tạo được token cho kho vì thiếu quyền? Dùng **token cá nhân** của bạn: nút dưới mở trang tạo token cá nhân, tên và quyền đã điền sẵn — chỉ cần chọn ngày hết hạn rồi bấm **Create token**. Lưu ý: khi đó ChillPM thấy mọi kho mà tài khoản của bạn thấy, và mọi thứ ghi vào git đứng tên bạn.',
          openPersonal: 'Mở trang tạo token cá nhân',
          groupNote:
            'Dự án có nhiều kho trong cùng một nhóm? Làm y hệt ở trang của **nhóm** (vào nhóm → **Settings** → **Access tokens**): một token dùng được cho cả nhóm.',
          maintainerNote:
            'Muốn ChillPM tự cài webhook (dữ liệu về sau vài giây, không phải chờ chu kỳ kéo) thì chọn vai **Maintainer** thay vì vai ở trên. Không bắt buộc.',
        },
        github: {
          open: 'Bấm nút dưới để mở trang tạo token mới của GitHub; đăng nhập nếu được hỏi.',
          openNew: 'Mở trang tạo token của GitHub',
          name: 'Ở ô **Token name**, gõ **ChillPM**.',
          expiry:
            'Ở ô **Expiration**, chọn ngày hết hạn. Không cần lo quên: ChillPM nhắc bạn 14 ngày trước khi token hết hạn.',
          owner:
            'Ở ô **Resource owner**: kho thuộc một tổ chức (organization) thì chọn đúng tổ chức ấy; kho của riêng bạn thì giữ tên bạn. Có tổ chức cần quản trị duyệt token — khi ấy GitHub sẽ báo.',
          repos:
            'Ở phần **Repository access**, chọn **Only select repositories** rồi chọn kho của dự án.',
          reposKnown:
            'Ở phần **Repository access**, chọn **Only select repositories** rồi chọn kho **{{path}}**.',
          permissions:
            'Ở phần **Permissions** → **Repository permissions**, bật đúng các quyền sau; các quyền khác để nguyên **No access**:',
          generate:
            'Bấm **Generate token** ở cuối trang, rồi sao chép token hiện ra. ⚠️ Token chỉ hiện **một lần**: đóng trang là không xem lại được.',
          webhookNote:
            'Muốn ChillPM tự cài webhook (dữ liệu về sau vài giây) thì bật thêm **Webhooks** → **Read and write**. Không bắt buộc.',
          classicNote:
            'Đã có sẵn token kiểu cũ (**classic**) với quyền **repo**? Dùng được luôn, không cần tạo mới.',
          permissionColumn: 'Quyền',
          accessColumn: 'Chọn mức',
          access: { read: 'Read-only', readWrite: 'Read and write' },
        },
      },
      connect: {
        title: 'Dán token và kiểm tra',
        tokenLabel: 'Dán token vào đây',
        tokenHint:
          'Token được cất mã hoá và không bao giờ hiện lại — sau khi lưu chỉ còn thấy 4 ký tự cuối.',
        submit: 'Kiểm tra và lưu',
        checking: 'Đang hỏi {{host}}…',
        defaultLabel: 'ChillPM · {{host}}',
        result: 'Đã kết nối bằng tài khoản **{{account}}**.',
        resultNoAccount: 'Đã kết nối.',
        access: 'Quyền: {{access}}.',
        accessValue: {
          read: 'chỉ xem',
          write: 'có thể tạo nhánh và merge request',
          unknown: 'GitHub cho biết khi gắn kho ở bước 4',
        },
        expires: 'Token hết hạn ngày {{date}}.',
        noExpiry: 'Token không có ngày hết hạn (hoặc máy chủ không cho biết).',
        expiresSoon:
          'Token sắp hết hạn — tạo token mới và bấm "Thay token" trước ngày ấy để kho không dừng cập nhật.',
        writeMissing:
          'Bạn chọn "Xem + tạo nhánh/MR" nhưng token này **chỉ xem được**: thiếu scope **api** hoặc vai **Developer**. ChillPM vẫn chạy ở mức chỉ xem; muốn tạo nhánh từ ChillPM thì tạo token mới theo bước 2 rồi bấm "Dán token khác".',
        writeUnknown:
          'GitHub không cho biết token này có quyền ghi hay không cho tới khi gắn kho — ChillPM sẽ kiểm ở bước 4.',
        replace: 'Dán token khác',
        broken: {
          invalid:
            'Máy chủ git đang từ chối token đã lưu — có thể nó đã bị thu hồi. Dán token mới để tiếp tục.',
          expired: 'Token đã lưu đã hết hạn. Tạo token mới theo bước 2 rồi dán vào đây.',
          hostDisabled:
            'Admin tổ chức đang tắt máy chủ git này. Nhờ admin tổ chức bật lại — ở đây không cần làm gì.',
        },
        errorTitle: 'Chưa kết nối được',
        fix: {
          GIT_TOKEN_INVALID:
            '{{host}} không nhận token này. Hay gặp nhất: chép thiếu ký tự, token đã hết hạn hoặc bị thu hồi, hoặc token tạo trên máy chủ khác (ví dụ token GitHub dán cho GitLab). Chép lại toàn bộ token, hoặc tạo token mới theo bước 2.',
          GIT_FORBIDDEN:
            'Token đúng nhưng thiếu quyền. Xem lại vai và quyền ở bước 2 (GitLab: vai Reporter trở lên và scope read_api; GitHub: quyền đọc Contents và Pull requests) rồi tạo token mới.',
          GIT_HOST_UNREACHABLE:
            'ChillPM không gọi được {{host}} lúc này. Thử lại sau ít phút; vẫn lỗi thì nhờ admin tổ chức kiểm địa chỉ máy chủ ở Quản trị → Máy chủ git.',
          GIT_HOST_DISABLED: 'Máy chủ git này đang bị admin tổ chức tắt — nhờ admin tổ chức bật lại.',
          GIT_RATE_LIMITED:
            '{{host}} đang bận vì có quá nhiều lượt gọi. Đợi vài phút rồi bấm Kiểm tra lại.',
          VALIDATION_FAILED:
            'Token phải là một chuỗi liền, không có dấu cách và dài ít nhất 8 ký tự. Xem có lỡ chép thêm dấu cách hay xuống dòng không.',
        },
        saved: 'Đã kết nối — token thuộc tài khoản {{account}}.',
        rotated: 'Đã thay token.',
        rotateSubmit: 'Kiểm tra và thay',
        newToken: 'Token mới',
      },
      repository: {
        title: 'Chọn kho mã',
        how: 'Cách chọn kho',
        mode: { list: 'Chọn trong danh sách', url: 'Dán link kho' },
        listHint: 'Đây là các kho mà token này thấy được.',
        searchPlaceholder: 'Tìm theo tên kho rồi bấm Enter',
        empty:
          'Token này không thấy kho nào khớp. Xem lại phần chọn kho lúc tạo token, hoặc chuyển sang "Dán link kho".',
        pick: 'Gắn kho này',
        alreadyLinked: 'Đã gắn',
        urlLabel: 'Link kho',
        urlHint:
          'Mở kho trên trình duyệt rồi sao chép địa chỉ trên thanh địa chỉ, ví dụ {{example}}.',
        linkByUrl: 'Gắn kho',
        linking: 'Đang gắn…',
        linked: 'Đã gắn kho {{path}} — ChillPM đang tải lịch sử lần đầu.',
        errorTitle: 'Chưa gắn được kho',
        urlAlreadyLinked: 'Kho {{path}} đã gắn vào dự án rồi — chọn kho khác.',
        // APM-GIT-s-b — gắn một kho hay cả nhóm.
        scope: {
          label: 'Gắn một kho hay cả nhóm',
          single: 'Một kho',
          group: { gitlab: 'Cả nhóm', github: 'Cả organization' },
        },
      },
      // APM-GIT-s-b — gắn cả nhóm GitLab / organization GitHub.
      group: {
        intro: {
          gitlab:
            'Không cần gắn từng kho: chọn một nhóm, ChillPM gắn mọi kho đang nằm trong nhóm ấy. Kho tạo sau trong nhóm sẽ hiện thành gợi ý để bạn duyệt.',
          github:
            'Không cần gắn từng kho: chọn một organization, ChillPM gắn mọi kho của organization mà token thấy. Kho tạo sau sẽ hiện thành gợi ý để bạn duyệt.',
        },
        how: 'Cách chọn nhóm',
        mode: { list: 'Chọn trong danh sách', url: 'Dán link nhóm' },
        searchPlaceholder: 'Tìm theo tên nhóm rồi bấm Enter',
        empty: {
          gitlab:
            'Token này không thấy nhóm nào khớp. Token tạo trong một kho chỉ thấy kho ấy — muốn gắn cả nhóm, tạo token ở trang của nhóm (Group access token) hoặc dùng token cá nhân.',
          github:
            'Token này không thấy organization nào khớp. Token chỉ thấy organization đã được cấp quyền lúc tạo token.',
        },
        pick: 'Chọn nhóm này',
        alreadyLinked: 'Đã gắn',
        urlLabel: 'Link nhóm',
        urlHint:
          'Mở trang của nhóm trên trình duyệt rồi sao chép địa chỉ, ví dụ {{example}}. Gõ tên nhóm cũng được.',
        urlError: {
          host_unknown: 'Link này không thuộc {{host}} — máy chủ của token đang dùng.',
          invalid_url: 'Đây chưa phải link tới một nhóm.',
        },
        continue: 'Tiếp tục',
        confirmTitle: {
          gitlab: 'Gắn cả nhóm {{path}} vào dự án?',
          github: 'Gắn cả organization {{path}} vào dự án?',
        },
        rule: {
          direct:
            'Gắn ngay mọi kho đang nằm trực tiếp trong nhóm. Kho trong nhóm con không tính, kho đã lưu trữ (archived) được bỏ qua.',
          cap: 'Mỗi lần gắn tối đa {{max}} kho. Nhóm nhiều hơn thì phần còn lại thành gợi ý — bạn gắn thêm ở danh sách "Chọn kho cho dự án".',
          later:
            'Kho tạo sau trong nhóm không tự gắn: ChillPM báo cho bạn và chờ bạn bấm Gắn hoặc Bỏ qua.',
        },
        link: 'Gắn cả nhóm',
        linking: 'Đang gắn…',
        pickOther: 'Chọn nhóm khác',
        errorTitle: 'Chưa gắn được nhóm',
        result: {
          title: 'Đã gắn nhóm {{path}}',
          linked_one: 'Đã gắn {{count}} kho.',
          linked_other: 'Đã gắn {{count}} kho.',
          suggested_one:
            '{{count}} kho chưa gắn vì vượt mức {{max}} kho mỗi lần — kho này đã thành gợi ý trong danh sách "Chọn kho cho dự án":',
          suggested_other:
            '{{count}} kho chưa gắn vì vượt mức {{max}} kho mỗi lần — các kho này đã thành gợi ý trong danh sách "Chọn kho cho dự án":',
          unreadable_one: '{{count}} kho token không đọc được nên chưa gắn:',
          unreadable_other: '{{count}} kho token không đọc được nên chưa gắn:',
          alreadyLinked_one: '{{count}} kho đã gắn từ trước — giữ nguyên.',
          alreadyLinked_other: '{{count}} kho đã gắn từ trước — giữ nguyên.',
          truncated:
            'Nhóm có quá nhiều kho nên ChillPM chưa liệt kê hết — kho còn lại sẽ hiện dần thành gợi ý.',
          importing:
            'ChillPM đang tải lịch sử lần đầu của các kho vừa gắn — kho lớn có thể mất vài chục phút.',
          done: 'Xong',
        },
      },
      // APM-GIT-s-b — danh sách quản lý kho của dự án.
      selection: {
        title: 'Chọn kho cho dự án',
        hint: 'Tích kho muốn ChillPM theo dõi, bỏ tích để gỡ — rồi bấm "Lưu lựa chọn". Kho mới trong nhóm đã gắn hiện ở đây thành gợi ý.',
        reload: 'Tải lại danh sách',
        groupKind: { gitlab: 'Nhóm', github: 'Organization' },
        groupMeta: '{{host}} · token của {{account}} · gắn từ {{date}}',
        removeGroup: 'Gỡ nhóm',
        removeAsk_one: 'Gỡ luôn {{count}} kho đã gắn qua nhóm {{group}}?',
        removeAsk_other: 'Gỡ luôn {{count}} kho đã gắn qua nhóm {{group}}?',
        removeAskNone: 'Gỡ nhóm {{group}} khỏi dự án?',
        removeExplain:
          'Gỡ nhóm thì ChillPM thôi gợi ý kho mới của nhóm. Kho đã gắn có thể giữ lại (chuyển xuống "Kho gắn tay") hoặc gỡ luôn — gỡ kho thì dừng kéo dữ liệu, còn liên kết cũ với công việc giữ nguyên và gắn lại được.',
        removeWithRepos_one: 'Gỡ nhóm và {{count}} kho',
        removeWithRepos_other: 'Gỡ nhóm và {{count}} kho',
        removeKeepRepos: 'Chỉ gỡ nhóm, giữ các kho',
        groupRemoved: 'Đã gỡ nhóm.',
        groupRemovedWithRepos_one: 'Đã gỡ nhóm và {{count}} kho.',
        groupRemovedWithRepos_other: 'Đã gỡ nhóm và {{count}} kho.',
        groupError:
          'Không hỏi được máy chủ git về nhóm này: {{message}} Các kho đã gắn vẫn hiện bên dưới.',
        truncated: 'Nhóm còn kho chưa liệt kê (quá nhiều kho) — chúng sẽ hiện dần.',
        groupEmpty: 'Nhóm này chưa có kho nào.',
        manualTitle: 'Kho gắn tay',
        status: {
          linked: 'Đã gắn',
          suggested: 'Gợi ý — mới',
          skipped: 'Đã bỏ qua',
          unlinked: 'Đã gỡ',
        },
        origin: {
          manual: 'Gắn tay',
          group: 'Gắn qua nhóm {{group}}',
          removedGroup: 'Gắn qua một nhóm đã gỡ',
          createdAt: 'Tạo ngày {{date}}',
        },
        change: {
          link: 'Sẽ gắn khi bấm Lưu.',
          relink: 'Sẽ gắn lại khi bấm Lưu — liên kết cũ còn nguyên.',
          unlink:
            'Sẽ gỡ khi bấm Lưu: ChillPM dừng kéo dữ liệu mới của kho; liên kết cũ giữ nguyên, gắn lại được.',
        },
        quickLink: 'Gắn',
        quickSkip: 'Bỏ qua',
        save: 'Lưu lựa chọn',
        saveCount_one: 'Lưu lựa chọn ({{count}} thay đổi)',
        saveCount_other: 'Lưu lựa chọn ({{count}} thay đổi)',
        saving: 'Đang lưu…',
        discard: 'Bỏ thay đổi',
        unlinkConfirm_one:
          'Gỡ {{count}} kho: {{paths}}? ChillPM dừng kéo dữ liệu mới; liên kết cũ với công việc giữ nguyên, gắn lại được bất cứ lúc nào.',
        unlinkConfirm_other:
          'Gỡ {{count}} kho: {{paths}}? ChillPM dừng kéo dữ liệu mới; liên kết cũ với công việc giữ nguyên, gắn lại được bất cứ lúc nào.',
        unlinkConfirmButton: 'Lưu và gỡ',
        deferred_one:
          'Còn {{count}} kho chưa gắn (mỗi lần lưu gắn tối đa {{max}} kho) — bấm "Lưu lựa chọn" lần nữa để gắn tiếp.',
        deferred_other:
          'Còn {{count}} kho chưa gắn (mỗi lần lưu gắn tối đa {{max}} kho) — bấm "Lưu lựa chọn" lần nữa để gắn tiếp.',
        unreadable_one: '{{count}} kho token không đọc được nên chưa gắn: {{paths}}.',
        unreadable_other: '{{count}} kho token không đọc được nên chưa gắn: {{paths}}.',
        toast: {
          saved: 'Đã lưu: {{parts}}.',
          nothing: 'Đã lưu — không có kho nào đổi.',
          linked_one: 'gắn {{count}} kho',
          linked_other: 'gắn {{count}} kho',
          unlinked_one: 'gỡ {{count}} kho',
          unlinked_other: 'gỡ {{count}} kho',
          skipped_one: 'bỏ qua {{count}} kho',
          skipped_other: 'bỏ qua {{count}} kho',
        },
      },
      // APM-GIT-r — luồng "Thêm kho" ở bản tóm tắt.
      addRepo: {
        title: 'Thêm kho',
        intro:
          'Gắn thêm một kho mã vào dự án. Các kho đang nối giữ nguyên; huỷ giữa chừng thì không có gì thay đổi.',
        whichToken: 'Dùng token nào?',
        usingToken: 'Dùng token của tài khoản {{account}}.',
        notFoundHint:
          'Không thấy kho cần? Có thể token này không được cấp quyền vào kho ấy, hoặc kho nằm ở máy chủ khác — tạo một token mới theo hướng dẫn.',
        useOtherToken: 'Dùng token khác',
        backToRepositories: 'Quay lại chọn kho',
      },
      summary: {
        done: 'Đã nối xong. Từ giờ ChillPM tự cập nhật nhánh, merge request và commit theo chu kỳ — không cần làm gì thêm.',
        importing:
          'Đang tải lịch sử lần đầu — kho lớn có thể mất vài chục phút. Bạn có thể đóng trang này; tab Git sẽ có dữ liệu dần.',
        connectionsTitle: 'Token đang dùng',
        host: 'Máy chủ',
        account: 'Tài khoản',
        access: 'Quyền',
        expires: 'Hết hạn',
        status: 'Tình trạng',
        statusValue: {
          ok: 'Dùng được',
          invalid: 'Bị máy chủ từ chối — cần thay token',
          expired: 'Đã hết hạn — cần thay token',
        },
        hostDisabled: 'Máy chủ git đang bị admin tổ chức tắt — kho tạm dừng cập nhật.',
        replaceToken: 'Thay token',
        repositoriesTitle: 'Kho đang nối',
        importingBadge: 'Đang tải lịch sử lần đầu',
        tokenAccount: 'Tài khoản token',
        sync: 'Tình trạng kéo',
        usedBy: 'Dùng cho kho',
        unused: 'Chưa dùng cho kho nào',
        replaceImpact_one:
          'Token này đang dùng cho {{count}} kho: {{paths}}. Token mới phải thấy được kho ấy, nếu không kho sẽ dừng cập nhật.',
        replaceImpact_other:
          'Token này đang dùng cho {{count}} kho: {{paths}}. Token mới phải thấy được tất cả các kho ấy — kho nào token mới không thấy sẽ dừng cập nhật.',
        addRepository: 'Thêm kho',
        revoke: 'Thu hồi token',
        revokeConfirm:
          'Thu hồi token của tài khoản {{account}}? Token bị xoá khỏi ChillPM; token trên máy chủ git thì bạn tự thu hồi ở đó.',
        revoked: 'Đã thu hồi token.',
      },
      tabs: {
        label: 'Phần của mục Kho mã Git',
        repositories: 'Kho ({{count}})',
        connections: 'Token ({{count}})',
        options: 'Tuỳ chọn ({{count}})',
      },
      optional: {
        title: 'Tuỳ chọn thêm',
        hint: 'ChillPM đã chạy được với phần trên. Các mục dưới đây không bắt buộc — mở mục nào bạn cần.',
        badge: 'Không bắt buộc',
        branchFormat: {
          title: 'Định dạng tên nhánh',
          benefit:
            'Đặt mẫu tên nhánh chung cho cả đội, để nút "Sao chép tên nhánh" ra đúng tên và nhánh tự nối vào việc.',
        },
        rules: {
          title: 'Tự đổi trạng thái việc',
          benefit:
            'Ví dụ: mở merge request thì việc tự sang "Đang review", merge xong thì tự sang "Xong" — đỡ phải kéo thẻ bằng tay.',
        },
        webhook: {
          title: 'Cập nhật tức thì (webhook)',
          benefit:
            'Webhook là cách máy chủ git "báo tin" cho ChillPM mỗi khi kho có thay đổi — dữ liệu về sau vài giây thay vì chờ chu kỳ kéo.',
        },
        identities: {
          title: 'Tài khoản git ↔ thành viên',
          benefit:
            'Cho ChillPM biết tài khoản git nào là ai trong dự án, để số liệu và thông báo gắn đúng người.',
        },
        write: {
          title: 'Ghi ngược vào git',
          benefit:
            'Để lại link việc ChillPM ngay trên merge request, hoặc biến mã việc (như GOLD-123) trong commit thành link bấm được.',
        },
        aiReadDiff: {
          title: 'Cho AI đọc mã',
          benefit:
            'Cho phép AI đọc phần code thay đổi của merge request để tóm tắt và đối chiếu chính xác hơn. Mặc định tắt.',
        },
      },
    },
    // APM-GIT-b — máy chủ git (`/admin?section=git-hosts`), §3.1; của tổ chức từ APM-ORGINT-e.
    hosts: {
      title: 'Máy chủ git',
      subtitle:
        'GitLab của công ty, GitHub.com, GitHub Enterprise mà dự án được nối kho mã vào. Token là của từng dự án — ở đây chỉ có địa chỉ.',
      intro:
        'PM dán link kho và token của dự án ở Cấu hình dự án → Kho mã Git; link chỉ được nhận khi máy chủ của nó đã khai và đang bật ở đây.',
      empty: 'Chưa có máy chủ nào — chưa dự án nào nối được kho mã.',
      add: 'Thêm máy chủ git',
      preset: {
        gitlab: 'GitLab',
        github_com: 'GitHub.com',
        ghes: 'GitHub Enterprise',
      },
      // APM-ORGINT-e — chọn loại bằng tab kính trong hộp thêm.
      pickKind: 'Kho mã của tổ chức bạn nằm ở đâu?',
      presetTab: {
        gitlab: 'GitLab công ty',
        github_com: 'GitHub.com',
        ghes: 'GitHub Enterprise',
      },
      githubComTaken: 'Tổ chức đã có GitHub.com — mỗi tổ chức chỉ cần một.',
      addTitle: 'Thêm máy chủ git',
      editTitle: 'Sửa máy chủ {{name}}',
      presetLine: 'Loại máy chủ: {{preset}}.',
      create: 'Thêm',
      edit: 'Sửa',
      howToTitle: 'Khai {{preset}} từng bước',
      // APM-ORGINT-e — các bước đánh số, không ô tích (`gitHostGuideSteps`).
      guide: {
        copyAddress: {
          gitlab:
            'Mở GitLab của công ty trên trình duyệt, chép địa chỉ trên thanh địa chỉ tới hết tên máy chủ — ví dụ **https://git.congty.vn**. GitLab cài dưới một đường dẫn con thì giữ cả đường dẫn, ví dụ **https://congty.vn/gitlab**.',
          ghes: 'Mở GitHub Enterprise của công ty trên trình duyệt, chép địa chỉ trên thanh địa chỉ tới hết tên máy chủ — ví dụ **https://github.congty.vn**.',
        },
        paste: {
          gitlab: 'Dán vào ô **Địa chỉ máy chủ** bên dưới. Không thêm /api/v4 hay tên dự án vào sau.',
          ghes: 'Dán vào ô **Địa chỉ máy chủ** bên dưới. Không thêm /api/v3 hay tên kho vào sau.',
        },
        internal:
          'Máy chủ chỉ mở được khi ở mạng công ty hoặc VPN (địa chỉ nội bộ)? Thì nhờ quản trị hệ thống bật "cho phép địa chỉ nội bộ" cho tổ chức của bạn trước — không thì ChillPM sẽ từ chối địa chỉ này.',
        ca: 'Trình duyệt báo chứng chỉ lạ khi mở máy chủ? Xin bộ phận IT tệp CA của công ty (dạng PEM, bắt đầu bằng -----BEGIN CERTIFICATE-----) và dán vào ô **CA riêng**. Không thì bỏ qua bước này.',
        test: 'Bấm **Thêm**, rồi bấm **Kiểm tra** ở thẻ máy chủ để chắc ChillPM nói chuyện được với nó. Sau đó PM nối kho ở Cấu hình dự án → Kho mã Git.',
        githubComReady:
          'GitHub.com có sẵn địa chỉ — không có gì phải nhập. Bấm **Thêm** là xong.',
        githubComToken:
          'Mỗi dự án tự tạo token GitHub của mình ở Cấu hình dự án → Kho mã Git — ở đó có hướng dẫn từng bước.',
      },
      name: 'Tên hiển thị',
      namePlaceholder: {
        gitlab: 'GitLab công ty',
        github_com: 'GitHub.com',
        ghes: 'GitHub nội bộ',
      },
      nameHint: 'Tên mà PM thấy khi nối kho.',
      apiBaseUrl: 'Địa chỉ máy chủ',
      apiBaseUrlShort: 'Địa chỉ API',
      apiBaseUrlHint: {
        gitlab: 'Gốc của GitLab, ví dụ https://git.congty.vn — không kèm /api/v4.',
        ghes: 'Gốc của GitHub Enterprise Server, ví dụ https://github.congty.vn — không kèm /api/v3.',
      },
      httpsOnly: 'Bản cài production chỉ nhận https://.',
      webBaseUrl: 'Địa chỉ web (tuỳ chọn)',
      webBaseUrlShort: 'Địa chỉ web',
      webBaseUrlHint:
        'Địa chỉ người dùng mở trên trình duyệt, cũng là thứ đem so với link kho PM dán. Để trống nếu trùng địa chỉ máy chủ.',
      fixedAddress: 'Địa chỉ của GitHub.com là cố định.',
      caPem: 'CA riêng (tuỳ chọn)',
      caPemHint:
        'Máy chủ nội bộ dùng chứng chỉ do CA riêng cấp thì dán CA ở dạng PEM. Không có lựa chọn bỏ qua kiểm chứng chỉ.',
      caShort: 'Chứng chỉ',
      caSet: 'Có CA riêng',
      minInterval: 'Chu kỳ tối thiểu',
      minIntervalHint: 'Kho thuộc máy chủ này không chọn được chu kỳ kéo ngắn hơn mức này.',
      minutes: '{{n}} phút',
      enabledLabel: 'Bật máy chủ',
      enabledHint: 'Tắt thì mọi kho dùng máy chủ này dừng kéo dữ liệu, không xoá gì.',
      on: 'Đang bật',
      off: 'Đang tắt',
      usage: 'Đang dùng',
      inUse: '{{connections}} kết nối dự án · {{identities}} tài khoản đã gắn',
      notInUse: 'Chưa dự án nào',
      test: 'Kiểm tra',
      testing: 'Đang kiểm tra…',
      testOk:
        'Kết nối được — máy chủ đã trả lời sau {{ms}} ms. Dự án giờ có thể nối kho ở Cấu hình dự án → Kho mã Git.',
      testFail: 'Chưa dùng được: {{message}}',
      remove: 'Xoá',
      removeConfirm: 'Xoá máy chủ "{{name}}"? Chưa dự án nào dùng nó nên không mất dữ liệu gì.',
      removeBlocked:
        'Còn {{connections}} kết nối dự án và {{identities}} tài khoản đã gắn trỏ tới máy chủ này nên không xoá được — tắt máy chủ thay vì xoá.',
      created: 'Đã thêm máy chủ {{name}}.',
      saved: 'Đã lưu máy chủ git.',
      removed: 'Đã xoá máy chủ git.',
      toggledOn: 'Đã bật máy chủ {{name}}.',
      toggledOff: 'Đã tắt máy chủ {{name}} — các kho dùng nó dừng kéo dữ liệu.',
      errors: {
        nameRequired: 'Nhập tên máy chủ.',
        nameTooLong: 'Tên tối đa 80 ký tự.',
        invalidUrl: 'Nhập một địa chỉ http(s) đầy đủ, không kèm query, # hay tên đăng nhập.',
        httpsRequired: 'Phải dùng https:// ở bản cài production.',
        invalidPem: 'CA phải ở dạng PEM (bắt đầu bằng -----BEGIN CERTIFICATE-----).',
        githubDotCom: 'Đây là địa chỉ của GitHub.com — chọn tab "GitHub.com" ở trên.',
      },
      // Vì sao nút Kiểm tra thất bại — theo `details.reason` của GIT_HOST_UNREACHABLE.
      unreachable: {
        timeout: 'Máy chủ không trả lời trong 20 giây.',
        network: 'Không kết nối được tới địa chỉ này.',
        tls: 'Không tin được chứng chỉ của máy chủ — dán CA nội bộ vào cấu hình máy chủ.',
        redirect:
          'Địa chỉ chuyển hướng sang {{host}} — không đi theo, vì token của dự án sẽ đi theo nó. Hãy nhập đúng địa chỉ cuối cùng.',
        bad_response:
          'Địa chỉ có trả lời, nhưng không phải API của máy chủ git (trang HTML hoặc sai định dạng).',
        unexpected_status:
          'Máy chủ trả mã {{status}} thay vì mã mong đợi khi gọi không có token — kiểm tra lại địa chỉ và đường dẫn con.',
      },
    },
    // APM-GIT-e — tab Git của dự án và khối "Phát triển" (§8.1–§8.3). Mỗi màn một khối con.
    views: {
      label: 'Các màn của tab Git',
      overview: 'Tổng quan',
      changeRequests: 'Merge request',
      branches: 'Nhánh',
      commits: 'Commit',
      releases: 'Bản phát hành',
    },
    common: {
      noAccess: 'Bạn không có quyền xem phần Git của dự án này.',
      state: { open: 'Đang mở', draft: 'Nháp', merged: 'Đã merge', closed: 'Đã đóng' },
      review: {
        none: 'Chưa review',
        requested: 'Chờ review',
        changes_requested: 'Yêu cầu sửa',
        approved: 'Đã duyệt',
      },
      ci: {
        pending: 'CI đang chờ',
        running: 'CI đang chạy',
        success: 'CI đạt',
        failed: 'CI lỗi',
        canceled: 'CI bị huỷ',
      },
      target: {
        closes: 'Liên kết đóng việc: merge là xong phần code của việc này',
        mentions: 'Chỉ nhắc tới việc này',
        manual: 'Liên kết do người gắn tay',
      },
      age: { minutes: '{{n}} phút', hours: '{{n}} giờ', days: '{{n}} ngày' },
      viewingAsOf: 'Đang xem dữ liệu git tại {{at}}.',
      partial: 'Chưa có dữ liệu git trước {{date}} — phần hiện ở đây chưa đủ.',
      openOnHost: 'Mở ở máy chủ git',
      repositoryFilter: 'Kho',
      allRepositories: 'Mọi kho',
      setup: {
        title: 'Dự án chưa nối kho mã nào',
        step1:
          'Admin tổ chức khai máy chủ git (GitLab của công ty, GitHub) ở Quản trị → Máy chủ git.',
        step2:
          'PM tạo token trên GitLab / GitHub rồi dán vào Cấu hình dự án → Kho mã Git — có hướng dẫn từng bước.',
        step3:
          'PM gắn kho bằng cách dán link kho hoặc chọn trong danh sách kho mà token thấy được.',
        manual:
          'Chưa nối kho vẫn dùng được nút "Sao chép tên nhánh" ở chi tiết việc: nhánh đặt đúng tên ấy sẽ tự nối vào việc ngay khi kho được gắn.',
        openSettings: 'Mở hướng dẫn cấu hình Git',
        askManager: 'Nhờ PM của dự án cấu hình Git — việc này cần quyền quản lý Git của dự án.',
      },
    },
    overview: {
      defaultBranch: 'Nhánh mặc định',
      lastSync: 'Kéo thành công lần cuối',
      nextSync: 'Lượt kéo kế',
      running: 'Đang kéo…',
      historyFrom: 'Có dữ liệu từ',
      syncNow: 'Kéo ngay',
      syncing: 'Đang xếp lượt…',
      syncQueued: 'Đã xếp một lượt kéo — dữ liệu mới sẽ có sau ít phút.',
      syncAlreadyQueued: 'Đã có một lượt kéo đang chờ hoặc đang chạy.',
      health: {
        ok: 'Đang kéo đều theo chu kỳ.',
        waiting: 'Kho vừa gắn — đang chờ lượt kéo đầu.',
        importing: 'Đang nhập lần đầu: đã đọc {{n}} mục.',
        failing: 'Lượt kéo gần nhất lỗi ({{n}} lượt liên tiếp): {{reason}}',
        hostDisabled: 'Admin tổ chức đang tắt máy chủ git này — kho dừng kéo, không mất gì.',
        connection: {
          invalid:
            'Máy chủ git từ chối token của kết nối — kho dừng kéo. PM dán token mới ở Cấu hình dự án → Kho mã Git.',
          expired:
            'Token của kết nối đã hết hạn — kho dừng kéo. PM dán token mới ở Cấu hình dự án → Kho mã Git.',
        },
      },
    },
    changeRequests: {
      column: {
        title: 'Merge request',
        tasks: 'Việc',
        author: 'Tác giả',
        branches: 'Nhánh nguồn → nhánh đích',
        review: 'Review · CI',
        age: 'Tuổi',
      },
      mergedOn: 'Merge {{date}}',
      closedOn: 'Đóng {{date}}',
      noTask: 'Chưa gắn việc',
      filter: {
        state: 'Lọc theo trạng thái',
        stateOption: { open: 'Đang mở', merged: 'Đã merge', closed: 'Đã đóng', all: 'Tất cả' },
        linked: 'Lọc theo việc',
        linkedOption: { all: 'Mọi MR', linked: 'Có gắn việc', unlinked: 'Chưa gắn việc' },
      },
      emptyTitle: 'Không có merge request nào khớp bộ lọc',
      emptyHint:
        'Đổi bộ lọc trạng thái hoặc kho. Kho vừa gắn thì chờ lượt nhập đầu chạy xong — xem tình trạng ở màn Tổng quan.',
      drawer: {
        label: 'Merge request {{ref}}',
        loading: 'Đang tải…',
        reviewers: 'Người review: {{names}}',
        size: '{{files}} tệp đổi · +{{additions}} −{{deletions}} dòng',
        description: 'Mô tả',
        phases: 'Thời gian từng pha',
        phase: { coding: 'Viết', pickup: 'Chờ nhận', review: 'Review' },
        phaseHint: {
          coding: 'Từ commit đầu tới lúc sẵn sàng review',
          pickup: 'Từ lúc sẵn sàng tới lượt review đầu tiên',
          review: 'Từ lượt review đầu tiên tới lúc merge',
        },
        milestone: {
          firstCommit: 'Commit đầu',
          created: 'Mở MR',
          ready: 'Hết nháp',
          firstReview: 'Review đầu',
          approved: 'Được duyệt',
          merged: 'Merge',
          closed: 'Đóng',
        },
        commits: 'Commit',
        commitsCount: 'Commit ({{n}})',
        noCommits: 'Chưa có commit nào tại mốc đang xem.',
      },
    },
    branches: {
      branchesTitle: 'Nhánh',
      commitsTitle: 'Commit trên nhánh mặc định',
      noBranches: 'Chưa có nhánh nào tại mốc đang xem.',
      noCommits: 'Chưa có commit nào trên nhánh mặc định tại mốc đang xem.',
      flag: {
        default: 'Mặc định',
        protected: 'Được bảo vệ',
        merged: 'Đã merge',
        deleted: 'Đã xoá',
      },
      column: { name: 'Nhánh', lastCommit: 'Commit cuối', changeRequest: 'Merge request' },
    },
    settings: {
      connections: {
        noExpiry: 'Không có hạn / không rõ',
      },
      repositories: {
        interval: 'Kéo mỗi',
        minutes: '{{n}} phút',
        backfill: 'Nhập lần đầu',
        days: '{{n}} ngày gần nhất',
        saved: 'Đã lưu cấu hình kho.',
        unlink: 'Gỡ kho',
        unlinkConfirm:
          'Gỡ kho {{path}} khỏi dự án? Kho dừng kéo; dữ liệu đã kéo về và liên kết với việc vẫn còn, gắn lại không phải nhập từ đầu.',
        unlinked: 'Đã gỡ kho.',
      },
      branchFormat: {
        title: 'Định dạng tên nhánh',
        hint: 'Mẫu mà nút "Sao chép tên nhánh" ở chi tiết việc dùng. Nhánh đặt theo mẫu này tự nối vào việc.',
        format: 'Mẫu tên nhánh',
        placeholders:
          'Dùng được: {type} (theo loại việc), {key} (mã dự án), {number} (số của việc), {slug} (tên việc bỏ dấu). Bắt buộc có {key}-{number}.',
        previewTask: 'Việc GOLD-123',
        previewIssue: 'Issue GOLD-I12',
        sample: { task: 'Sửa lỗi đăng nhập', issue: 'Không tải được báo cáo' },
        issue: {
          empty: 'Nhập mẫu tên nhánh.',
          too_long: 'Mẫu tối đa 120 ký tự.',
          unknown_placeholder: 'Chỉ dùng được {type}, {key}, {number}, {slug}.',
          missing_key_number:
            'Mẫu phải chứa {key}-{number} liền nhau — thiếu thì nhánh không tự nối được vào việc.',
          invalid_characters:
            'Phần chữ cố định chỉ gồm chữ, số và . _ / - ; không bắt đầu hay kết thúc bằng / hoặc dấu chấm.',
        },
        typeMap: 'Loại việc ⇒ {type}',
        typeMapHint:
          'Loại việc không có trong bảng dùng "feature" (issue vận hành dùng "fix"). Gõ tên loại việc, có dấu cũng được.',
        typeName: 'Tên loại việc',
        typeValue: 'Giá trị {type}',
        addRow: 'Thêm dòng',
        removeRow: 'Xoá dòng',
        typeRowInvalid:
          'Mỗi dòng cần tên loại việc không trùng dòng khác và một {type} chỉ gồm chữ thường, số, dấu gạch nối (tối đa 20 ký tự).',
        reset: 'Về mặc định',
        saved: 'Đã lưu định dạng tên nhánh.',
      },
      write: {
        title: 'Ghi ngược',
        hint: 'ChillPM tạo nhánh / merge request từ việc và bình luận link ngược trên MR — dưới tên tài khoản của token, cần token có quyền ghi.',
        backlinkTitle: 'Bình luận link ngược trên merge request',
        backlinkHint:
          'Bật cho một kho ⇒ mỗi merge request mới nhắc tới một việc nhận đúng một bình luận "ChillPM: GOLD-123 — <tên việc> <link>". Merge request có từ trước khi gắn kho không bị bình luận. Mặc định tắt.',
        noRepository: 'Chưa gắn kho nào.',
        postsAs: 'Bình luận đăng dưới tên {{account}}.',
        postsAsUnknown: 'Bình luận đăng dưới tên tài khoản của token.',
        backlinkOn: 'Đã bật bình luận link ngược — áp dụng từ lượt kéo kế.',
        backlinkOff: 'Đã tắt bình luận link ngược.',
        autolinkTitle: 'Link ngược không cần token ghi',
        autolinkHint:
          'Cấu hình một lần ở máy chủ git: mã việc (GOLD-123) trong mọi commit và merge request tự thành link về ChillPM. Không cần token, không cần bật gì ở đây.',
        copy: 'Sao chép',
        copied: 'Đã sao chép.',
        copyFailed: 'Không sao chép được — hãy chọn và chép tay: {{value}}',
        guide: {
          gitlab: {
            title: 'GitLab — Custom issue tracker',
            steps:
              'Ở kho (hoặc nhóm): Settings → Integrations → Custom issue tracker → bật, rồi điền Issue URL bên dưới. Project URL và New issue URL điền cùng địa chỉ ChillPM.',
            issueUrl: 'Issue URL',
          },
          github: {
            title: 'GitHub — Autolink references',
            steps:
              'Ở kho: Settings → Autolink references → Add autolink reference, chọn "Alphanumeric", rồi điền hai ô bên dưới.',
            prefix: 'Reference prefix',
            urlTemplate: 'Target URL',
          },
        },
      },
    },
    development: {
      title: 'Phát triển',
      copyBranch: 'Sao chép tên nhánh',
      readOnlyNotice:
        'Dự án hiện không nối kho Git nào — đây là các liên kết đã ghi nhận từ trước, chỉ xem.',
      copied: 'Đã chép tên nhánh {{name}}',
      copyFailed: 'Không chép được — hãy chọn và chép tay: {{name}}',
      empty:
        'Chưa có nhánh, merge request hay commit nào nhắc tới việc này. Đặt tên nhánh theo tên gợi ý ở trên là nó tự nối.',
      changeRequests: 'Merge request của việc này',
      branches: 'Nhánh của việc này',
      commitCount: '{{n}} commit',
      commitsCapped: 'Chỉ hiện {{n}} commit mới nhất.',
      hide: 'Ẩn',
      hideHint: 'Liên kết này nhầm? Ẩn nó khỏi việc — lượt kéo sau không dựng lại.',
      hidden: 'Đã ẩn liên kết khỏi việc này.',
      removeManual: 'Gỡ',
      removeManualHint: 'Gỡ liên kết đã gắn tay',
      overrideRemoved: 'Đã bỏ quyết định gắn / ẩn — liên kết trở về đúng thứ kéo từ git.',
      hiddenTitle: 'Liên kết đã ẩn',
      hiddenItem: 'Đã ẩn {{kind}} {{ref}}',
      unhide: 'Bỏ ẩn',
      manual: {
        open: 'Gắn link tay',
        title: 'Gắn một thứ ở git vào việc này',
        kind: 'Loại',
        kindOption: { change_request: 'Merge request', branch: 'Nhánh', commit: 'Commit' },
        placeholder: {
          change_request: 'Số MR hoặc link MR (ví dụ 45)',
          branch: 'Tên nhánh',
          commit: 'Mã commit đầy đủ (sha)',
        },
        invalid: {
          change_request: 'Nhập số của merge request, hoặc dán link của nó.',
          branch: 'Nhập tên nhánh, không có dấu cách.',
          commit: 'Nhập mã commit (7–40 ký tự hex), hoặc dán link của commit.',
        },
        submit: 'Gắn',
        added: 'Đã gắn vào việc này.',
        noRepository: 'Dự án chưa gắn kho nào nên chưa có gì để gắn.',
      },
    },
    // APM-GIT-k — ghi ngược (`components/git-write-*.tsx`), §8.4.
    write: {
      createBranch: 'Tạo nhánh',
      createChangeRequest: 'Tạo merge request',
      blocked: {
        host_disabled: 'Máy chủ git của kho đang bị admin tổ chức tắt nên chưa tạo được nhánh / merge request.',
        connection_unusable:
          'Token của kho đã bị máy chủ git từ chối hoặc đã thu hồi — PM dán token mới ở Cấu hình dự án → Kho mã Git.',
        not_supported: 'Máy chủ git này chưa hỗ trợ tạo nhánh / merge request từ ChillPM.',
        read_only: {
          gitlab:
            'Token của dự án chỉ đọc. Để tạo nhánh / merge request, PM dán token có scope api và vai Developer trở lên trong kho.',
          github:
            'Token của dự án chỉ đọc. Để tạo nhánh / pull request, PM dán token có quyền Contents và Pull requests ở mức đọc và ghi (hoặc PAT cổ điển scope repo).',
        },
      },
      branchTitle: 'Tạo nhánh cho {{code}}',
      changeRequestTitle: 'Tạo merge request cho {{code}}',
      asAccount: 'Sẽ tạo dưới tên {{account}} trên {{host}} — tài khoản của token dự án, không phải tài khoản của bạn.',
      asAccountUnknown: 'Sẽ tạo dưới tên tài khoản của token dự án trên {{host}}, không phải tài khoản của bạn.',
      repository: 'Kho',
      branchName: 'Tên nhánh',
      branchNameHint: 'Giữ mã việc trong tên để nhánh tự nối vào việc này.',
      baseBranch: 'Tạo từ nhánh',
      sourceBranch: 'Nhánh nguồn',
      sourceBranchHint: 'Nhánh chứa thay đổi — phải đã có trong kho.',
      targetBranch: 'Merge vào nhánh',
      sameBranches: 'Nhánh nguồn và nhánh đích phải khác nhau.',
      title: 'Tiêu đề',
      titleHint: 'Giữ mã việc ở đầu tiêu đề để merge request tự nối vào việc này.',
      titleEmpty: 'Nhập tiêu đề.',
      draft: 'Tạo ở dạng nháp',
      draftHint: 'Nháp thì chưa ai được nhắc duyệt cho tới khi bạn bỏ nháp ở máy chủ git.',
      afterCreate: 'Tạo xong, nhánh / merge request hiện ở khối Phát triển sau lượt kéo kế (thường trong vòng một phút).',
      creating: 'Đang tạo…',
      submitBranch: 'Tạo nhánh',
      submitChangeRequest: 'Tạo merge request',
      branchCreated: 'Đã tạo nhánh {{name}}.',
      changeRequestCreated: 'Đã tạo merge request #{{number}}.',
      changeRequestExisting: 'Nhánh này đã có merge request #{{number}} đang mở — không tạo thêm.',
      open: 'Mở',
      nameIssue: {
        empty: 'Nhập tên nhánh.',
        too_long: 'Tên nhánh tối đa 200 ký tự.',
        invalid: 'Tên nhánh có ký tự git không cho phép (dấu cách, ~ ^ : ? * [ \\, "..").',
      },
      forbidden: {
        gitlab: 'Token của dự án không ghi được vào kho này — cần scope api và vai Developer trở lên (nhánh được bảo vệ có thể đòi vai cao hơn).',
        github:
          'Token của dự án không ghi được vào kho này — cần quyền Contents và Pull requests ở mức đọc và ghi (hoặc PAT cổ điển scope repo), cùng quyền push trên kho.',
      },
      forbiddenRotate: 'Đã cấp thêm quyền thì PM dán lại token ở Cấu hình dự án → Kho mã Git để ChillPM đọc lại.',
      branchExists: 'Nhánh "{{name}}" đã có trong kho. Đổi tên khác, hoặc tạo merge request từ chính nhánh ấy.',
    },
    // APM-GIT-k — đường dẫn sâu theo mã (`routes/_app/t.$code.tsx`).
    workItem: {
      opening: 'Đang mở {{code}}…',
      notFound: 'Không tìm thấy {{code}} — mã sai, việc đã xoá, hoặc bạn không ở trong dự án ấy.',
    },
    // APM-GIT-l — ghi chú phát hành (`components/release-notes/`), §8.5.
    releaseNotes: {
      title: 'Ghi chú phát hành',
      status: {
        ai_suggested: 'AI gợi ý — chờ duyệt',
        approved: 'Đã duyệt',
        manual: 'Viết tay',
      },
      empty: 'Bản này chưa có ghi chú phát hành.',
      templateTitle: 'Bản mẫu — dựng từ danh sách việc của bản, nhóm theo loại',
      useTemplate: 'Dùng bản mẫu để viết',
      template: {
        heading: 'Bản {{tag}}',
        ungrouped: 'Khác',
        truncated: 'Khoảng commit của bản này bị cắt — danh sách việc có thể chưa đủ.',
        noItems: 'Chưa có việc nào gắn với bản này.',
      },
      editorLabel: 'Nội dung ghi chú phát hành (markdown)',
      placeholder: 'Viết ghi chú cho người không đọc code: bản này mang lại gì, sửa được gì…',
      save: 'Lưu',
      saved: 'Đã lưu ghi chú phát hành.',
      edit: 'Sửa',
      approve: 'Duyệt',
      approvedToast: 'Đã duyệt ghi chú phát hành.',
      approvedAt: 'Duyệt lúc {{date}}',
      copy: 'Sao chép',
      copied: 'Đã chép ghi chú — dán vào bản phát hành trên máy chủ git.',
      copyFailed: 'Không chép được — hãy chọn và chép tay.',
      readOnlyAsOf: 'Đang xem ghi chú như lúc {{date}} — chỉ đọc.',
      notPublished:
        'Ghi chú không tự đăng lên máy chủ git. Duyệt xong thì sao chép và dán vào bản phát hành.',
      aiButton: 'Soạn bằng AI',
      aiLabel: 'Soạn ghi chú phát hành {{tag}}',
      aiPrompt: 'Soạn ghi chú phát hành cho bản {{tag}}.',
      aiResult: 'Gợi ý {{count}} dòng ghi chú',
      aiApply: 'Đưa vào để duyệt',
      applied: 'Đã đưa gợi ý vào — duyệt hoặc sửa trước khi dùng.',
      notApplied:
        'Ghi chú đã được duyệt hoặc viết tay nên gợi ý AI không đè lên. Muốn dùng thì sửa tay.',
    },
    // APM-GIT-m — tóm tắt MR (`git-cr-summary-slot`) và công tắc "cho AI đọc mã", §8.5, §8.6.
    crSummary: {
      title: 'Tóm tắt',
      run: 'Tóm tắt bằng AI',
      rerun: 'Tóm tắt lại',
      trackLabel: 'Tóm tắt MR !{{number}}',
      writeManual: 'Viết tay',
      edit: 'Sửa',
      save: 'Lưu',
      cancel: 'Huỷ',
      approve: 'Duyệt',
      approvedToast: 'Đã duyệt lời tóm tắt.',
      saved: 'Đã lưu lời tóm tắt.',
      done: 'Đã tóm tắt — đang chờ duyệt.',
      empty: 'Chưa có lời tóm tắt cho bản mới nhất của MR này.',
      pastEmpty: 'Lúc ấy chưa có lời tóm tắt.',
      outdated: 'MR đã có commit mới từ lúc tóm tắt (bản cho {{sha}}). Tóm tắt lại để khớp bản mới nhất.',
      placeholder: 'Ba câu: đổi gì, chạm phần nào, liên quan việc nào.',
      status: {
        ai_suggested: 'Gợi ý AI — chờ duyệt',
        approved: 'Đã duyệt',
        manual: 'Viết tay',
      },
      basis: {
        diff: 'Có đọc mã',
        description: 'Dựa trên lời mô tả, không đọc mã',
      },
    },
    aiReadDiff: {
      title: 'Cho AI đọc mã thay đổi',
      hint: 'Mặc định AI chỉ đọc tiêu đề, mô tả, lời commit và đường dẫn tệp của MR. Bật theo từng kho để lời tóm tắt dựa trên cả phần mã thay đổi.',
      limits:
        'Tối đa 256 KB mỗi MR và 16 KB mỗi tệp. Phần mã chỉ đi qua bộ nhớ của một lượt chạy AI — không lưu. Tệp nhạy cảm (.env, khoá, chứng chỉ…) chỉ gửi đường dẫn.',
      label: 'Cho AI đọc mã thay đổi của {{path}}',
      on: 'Bật',
      off: 'Tắt',
      confirm:
        'Phần mã thay đổi trong MR của kho {{path}} sẽ được gửi tới nhà cung cấp AI đang cấu hình cho dự án. Bật?',
      confirmLabel: 'Bật',
      enabled: 'Đã cho AI đọc mã thay đổi của {{path}}.',
      disabled: 'Đã tắt — AI không đọc mã thay đổi của {{path}} nữa.',
      empty: 'Dự án chưa gắn kho nào.',
    },
    // APM-GIT-h — luật tự đổi trạng thái (`components/settings/git-rules-section.tsx`), §6.
    rules: {
      title: 'Luật tự đổi trạng thái',
      hint: 'Khi có chuyện ở git — bắt đầu code, mở / duyệt / merge merge request, lên production — tự chuyển việc liên kết sang cột bạn chọn.',
      intro:
        'Mặc định không luật nào bật. Luật chỉ đẩy việc tiến lên: không kéo lùi, không kéo ra khỏi cột Xong, và ai kéo việc lại bằng tay thì cùng sự kiện ấy không đẩy lại. Lần nhập đầu của một kho không chạy luật; merge request có [skip-pm] ở tiêu đề hoặc mô tả được bỏ qua.',
      empty: 'Chưa có luật nào — việc chỉ đổi cột khi có người kéo.',
      noStatuses: 'Dự án chưa có cột nào trên board để làm cột đích.',
      add: 'Thêm luật',
      remove: 'Xoá luật',
      discard: 'Bỏ thay đổi',
      saved: 'Đã lưu luật tự đổi trạng thái.',
      cannotSave: 'Còn luật chưa hợp lệ (vạch đỏ) — sửa xong mới lưu được.',
      ruleLabel: 'Luật {{n}}',
      enabled: 'Bật luật {{n}}',
      on: 'Đang bật',
      off: 'Đang tắt',
      when: 'Khi',
      moveTo: 'Chuyển việc sang cột',
      statusMissing: '(cột đã bị xoá — chọn lại)',
      statusInSprint: '{{status}} · chỉ sprint {{sprint}}',
      scope: 'Nhánh đích của merge request',
      scopeKind: {
        default: 'Nhánh mặc định',
        protected: 'Nhánh được bảo vệ',
        pattern: 'Theo mẫu',
      },
      scopeNotUsed: 'Không áp dụng — sự kiện này không đi theo nhánh đích.',
      pattern: 'Mẫu tên nhánh',
      patternMatches: 'khớp {{n}} nhánh đã kéo về',
      trigger: {
        work_started: 'Bắt đầu code (nhánh hoặc commit đầu tiên)',
        cr_opened: 'Mở merge request (không phải nháp)',
        cr_approved: 'Merge request được duyệt',
        cr_merged: 'Merge request được merge',
        deployed: 'Lên production',
      },
      error: {
        pattern_empty: 'Nhập mẫu tên nhánh, ví dụ release/*.',
        status_not_in_workflow:
          'Cột đích không còn trên board — luật này đang không chạy. Chọn lại cột.',
        duplicate_rule: 'Đã có một luật khác cho cùng sự kiện và cùng phạm vi nhánh.',
      },
      warning: {
        unprotected_branch:
          'Nhánh {{branches}} của {{repository}} không được bảo vệ: ai có quyền push cũng tự hoàn thành được việc của mình. Hãy bảo vệ nhánh trên máy chủ git, hoặc chọn «Nhánh được bảo vệ».',
        sprint_points:
          'Dự án có sprint: luật này đưa việc vào cột Xong mà không ai bấm — điểm của sprint sẽ đếm theo.',
        sprint_scoped_status:
          'Cột {{status}} chỉ thuộc sprint {{sprint}}: việc ngoài sprint ấy không chuyển được (sổ ghi là bỏ qua).',
      },
      skip: {
        already_fired: 'sự kiện này đã chuyển việc một lần rồi',
        backward: 'việc đã ở cột bằng hoặc sau cột đích — luật không kéo lùi',
        mentions_only: 'merge request chỉ nhắc tới việc, không đóng nó',
        pending_work: 'việc còn merge request khác đang mở',
        skipped_by_marker: 'merge request có [skip-pm]',
        status_missing: 'cột đích đã bị xoá',
        rule_inactive: 'luật đang tắt',
      },
      recent: {
        title: 'Luật đã chạy gần đây',
        empty: 'Chưa luật nào được xét — sổ ghi từ lượt kéo đầu tiên sau khi bật luật.',
        outcome: { applied: 'Đã chuyển', skipped: 'Bỏ qua' },
        because: 'Lý do: {{reason}}',
        deletedTarget: '(việc đã xoá)',
        branch: 'nhánh {{name}}',
        commit: 'commit {{sha}}',
      },
    },
    // APM-GIT-g — webhook "kéo ngay" (§5.2): dòng tình trạng trên thẻ kho + mục cài đặt.
    // APM-GIT-i — màn Bản phát hành, CI nhánh mặc định, chip trên task, dấu trên thẻ Kanban (§8.1, §8.2).
    releases: {
      listTitle: 'Bản phát hành',
      empty:
        'Chưa có bản phát hành nào tại mốc đang xem. Bản phát hành là tag khớp mẫu tag của kho (mặc định v*).',
      prerelease: 'Bản thử nghiệm',
      firstRelease: 'Bản đầu tiên trong dữ liệu đã kéo',
      fromTag: 'Từ {{tag}}',
      cell: { releasedAt: 'Ngày phát hành', items: 'Số việc', commits: 'Số commit' },
      range: { pending: 'Đang tính danh sách việc', truncated: 'Danh sách có thể thiếu' },
      back: 'Mọi bản phát hành',
      detailLabel: 'Bản phát hành {{tag}}',
      releasedAt: 'Phát hành {{at}}',
      rangeLine: '{{from}} → {{to}} · {{n}} commit',
      rangeLineFirst: 'Bản đầu tiên · {{n}} commit',
      pendingNotice:
        'Danh sách việc của bản này chưa tính xong — lượt kéo kế sẽ hoàn tất. Bấm "Kéo ngay" ở màn Tổng quan nếu cần sớm hơn.',
      truncatedNotice:
        'Khoảng {{from}} → {{to}} có hơn {{max}} commit nên chỉ {{max}} commit được đọc: danh sách việc dưới đây có thể thiếu.',
      asOfNotice:
        'Danh sách việc là kết quả lần tính gần nhất, không dựng lại theo mốc đang xem; tên và trạng thái việc là hiện tại.',
      itemsTitle: 'Việc trong bản này ({{n}})',
      noItems: 'Không có việc nào nối với commit hay merge request trong khoảng của bản này.',
      untyped: 'Chưa phân loại',
      via: 'qua {{ref}}',
      direct: 'qua commit trực tiếp',
      issueState: {
        new: 'Mới',
        triaged: 'Đã phân loại',
        in_progress: 'Đang xử lý',
        waiting_customer: 'Chờ khách hàng',
        waiting_third_party: 'Chờ bên thứ ba',
        resolved: 'Đã giải quyết',
        reopened: 'Mở lại',
        closed: 'Đã đóng',
      },
      deploymentsTitle: 'Đã triển khai bản này',
      noDeployments: 'Chưa có lượt triển khai nào của bản này tại mốc đang xem.',
    },
    deployments: {
      title: 'Deployment theo môi trường',
      empty:
        'Chưa có lượt triển khai nào tại mốc đang xem. Kho không dùng deployment của GitLab / GitHub thì mục này để trống.',
      production: 'Production',
      count: '{{n}} lượt',
      more: 'và {{n}} lượt cũ hơn',
      status: { running: 'Đang chạy', success: 'Thành công', failed: 'Lỗi', canceled: 'Đã huỷ' },
      finishedAt: 'xong {{at}}',
      startedAt: 'bắt đầu {{at}}',
    },
    ci: {
      line: 'CI nhánh {{branch}}:',
      none: 'Chưa có lượt CI nào của nhánh mặc định trong dữ liệu đã kéo.',
      status: {
        none: 'Không có CI',
        pending: 'Đang chờ',
        running: 'Đang chạy',
        success: 'Đạt',
        failed: 'Lỗi',
        canceled: 'Bị huỷ',
      },
    },
    releaseChips: {
      inRelease: 'Có trong {{tag}}',
      inReleaseTitle: 'Bản {{tag}} ({{repository}}) phát hành {{date}} có việc này',
      deployed: 'Đã lên production {{date}}',
      estimate: 'ước lượng',
      deployedTitle:
        'Ước lượng: lượt triển khai production thành công đầu tiên chứa (hoặc sau) mọi merge request đóng việc này. Có thể sai khi lượt ấy triển khai một commit cũ hơn (rollback).',
    },
    taskMark: {
      open: '{{n}} merge request đang mở',
    },
    webhook: {
      title: 'Webhook',
      hint: 'Để máy chủ git báo ngay khi có push, merge request hay pipeline mới, thay vì chờ lượt kéo theo chu kỳ. Không bật vẫn đủ dữ liệu — chỉ chậm hơn vài phút.',
      mode: {
        none: 'Webhook: chưa bật — kéo theo chu kỳ',
        manual: 'Webhook: dán tay',
        auto: 'Webhook: tự đăng ký',
      },
      lastSeen: 'nhận lần cuối {{at}}',
      neverSeen: 'chưa nhận lượt gọi nào',
      noRepository: 'Chưa gắn kho nào — gắn kho ở mục Kho bên trên rồi quay lại đây.',
      needsPublicUrl:
        'Webhook cần địa chỉ công khai — đang chạy bằng polling. ChillPM đang chạy ở một địa chỉ mà máy chủ git không gọi tới được; kho vẫn được kéo đều theo chu kỳ.',
      cannotAuto:
        'Token của kết nối không đủ quyền tự tạo webhook ở kho này (GitLab cần vai Maintainer, GitHub cần quyền admin của kho). Người quản kho dán tay theo hướng dẫn.',
      autoForbidden:
        'Máy chủ git từ chối: token của kết nối không đủ quyền tạo webhook ở kho này. Chưa có gì thay đổi — nhờ người quản kho dán tay theo hướng dẫn dưới đây.',
      leftover:
        'ChillPM chưa gỡ được webhook cũ ở máy chủ git. Hãy xoá nó bằng tay ở Settings → Webhooks của kho. Để lại cũng không gây hại (mọi lượt gọi của nó đều bị từ chối) nhưng nó nằm lại trong danh sách webhook.',
      action: {
        auto: 'Tự đăng ký',
        manual: 'Dán tay',
        regenerate: 'Tạo bí mật mới',
        off: 'Tắt webhook',
      },
      regenerateConfirm:
        'Tạo bí mật mới cho kho {{path}}? Bí mật cũ hết hiệu lực ngay: webhook ở máy chủ git sẽ bị từ chối cho tới khi dán bí mật mới vào.',
      changed: {
        auto: 'Đã tự đăng ký webhook ở máy chủ git.',
        manual: 'Đã tạo bí mật — dán địa chỉ và bí mật vào máy chủ git.',
        none: 'Đã tắt webhook — kho tiếp tục được kéo theo chu kỳ.',
      },
      manual: {
        title: 'Dán tay vào máy chủ git',
        where: {
          gitlab:
            'Ở GitLab: mở kho → Settings → Webhooks → Add new webhook. Dán địa chỉ vào ô URL, dán bí mật vào ô "Secret token", rồi tích các ô dưới đây.',
          github:
            'Ở GitHub: mở kho → Settings → Webhooks → Add webhook. Dán địa chỉ vào "Payload URL", dán bí mật vào "Secret", chọn "Let me select individual events" rồi tích các mục dưới đây.',
        },
        url: 'Địa chỉ (URL)',
        secret: 'Bí mật',
        secretOnce: 'Bí mật chỉ hiện đúng lần này. Chép ngay — ChillPM không hiện lại được.',
        secretHidden:
          'Bí mật chỉ hiện một lần lúc tạo. Đã mất thì bấm "Tạo bí mật mới" rồi dán lại vào máy chủ git.',
        secretPending: 'Bấm "Dán tay" bên dưới để ChillPM sinh bí mật — nó chỉ hiện một lần.',
        copyUrl: 'Sao chép địa chỉ',
        copySecret: 'Sao chép bí mật',
        copied: 'Đã chép.',
        copyFailed: 'Không chép được — hãy chọn và chép tay.',
        events: 'Sự kiện cần tích',
        traps: {
          title: 'Ba chỗ dễ vấp với GitLab tự host',
          group:
            'Webhook cấp group cần bản Premium. Bản CE phải thêm webhook ở từng project — mỗi kho gắn ở đây một webhook riêng.',
          pushLimit:
            'Một lần push hơn 3 nhánh hoặc tag thì GitLab không gửi push hook nào (push_event_hooks_limit). Lượt kéo theo chu kỳ vẫn thấy các nhánh ấy.',
          localNetwork:
            'Nếu nhìn từ GitLab, ChillPM nằm ở địa chỉ mạng nội bộ thì quản trị GitLab phải bật "Allow requests to the local network from webhooks and integrations".',
        },
      },
      // Nhãn ô tích — đúng chữ trên giao diện của máy chủ git, không dịch.
      event: {
        gitlab: {
          push_events: 'Push events',
          tag_push_events: 'Tag push events',
          merge_requests_events: 'Merge request events',
          note_events: 'Comments',
          pipeline_events: 'Pipeline events',
          deployment_events: 'Deployment events',
          releases_events: 'Releases events',
        },
        github: {
          push: 'Pushes',
          create: 'Branch or tag creation',
          delete: 'Branch or tag deletion',
          pull_request: 'Pull requests',
          pull_request_review: 'Pull request reviews',
          check_suite: 'Check suites',
          status: 'Statuses',
          workflow_run: 'Workflow runs',
          deployment_status: 'Deployment statuses',
          release: 'Releases',
        },
      },
    },
    coverage: {
      title: 'Đối chiếu tiêu chí với MR',
      help: 'Đặt tiêu chí nghiệm thu trong mô tả của việc cạnh những gì các MR đã gắn nói là đã làm, để thấy tiêu chí nào chưa ai nhắc tới. Chỉ là gợi ý — không sửa việc, không đổi trạng thái, không chặn merge.',
      run: 'Đối chiếu bằng AI',
      prompt: 'Đối chiếu tiêu chí của việc này với các MR đã gắn.',
      criteriaHeading: 'Tiêu chí của việc',
      changeRequestsHeading: 'MR đã gắn',
      noCriteriaManual: 'Mô tả của việc chưa có mục danh sách nào để làm tiêu chí.',
      noChangeRequests: 'Chưa có MR nào gắn với việc này.',
      status: 'Gợi ý của AI — chưa ai duyệt',
      basis: {
        diff: 'Có đọc mã',
        description: 'Chỉ kiểm lời mô tả của MR',
      },
      at: 'Đối chiếu lúc {{at}}',
      noCriteria: 'Việc này không có tiêu chí nào để đối chiếu.',
      missingHeading: 'Chưa thấy MR nào nhắc tới',
      seenHeading: 'Đã thấy',
      evidence: '!{{number}}: “{{quote}}”',
      checked: 'Đã đối chiếu với: {{list}}',
      checkedNone: 'Lượt này chưa đọc MR nào.',
      newSince: 'Có MR gắn sau lần đối chiếu này: {{list}} — đối chiếu lại để tính cả chúng.',
    },
    // APM-GIT-j: chỉ số luồng, "Cần chú ý", tài khoản git ↔ người (plan-git-integration §7, §4.1).
    insights: {
      title: 'Chỉ số luồng',
      partial: 'Chưa có dữ liệu git trước {{date}} — các tuần trước mốc ấy trống vì chưa có dữ liệu, không phải vì không ai làm.',
      emptyHelp: 'MR merge trong 12 tuần gần nhất hiện ở đây sau khi kho đã kéo dữ liệu.',
      p85: 'p85 {{value}}',
      samples: '{{n}} MR',
      cycle: {
        title: 'Thời gian chu trình MR, bốn pha',
        subtitle: 'Trung vị theo tuần merge · {{n}} MR merge trong 12 tuần',
        empty: 'Không MR nào merge trong 12 tuần này',
      },
      phase: {
        coding: 'Viết',
        pickup: 'Chờ nhận review',
        review: 'Review',
        deploy: 'Lên bản',
      },
      axis: {
        mergeWeek: 'Tuần merge (thứ Hai)',
        week: 'Tuần (thứ Hai)',
        medianHours: 'Giờ (trung vị)',
        medianDays: 'Ngày (trung vị)',
        openCount: 'Số MR đang mở',
        deploys: 'Lượt triển khai',
        releases: 'Bản phát hành (theo tag)',
      },
      open: {
        title: 'MR đang mở theo tuổi',
        subtitle: '{{n}} MR đang mở',
        empty: 'Không có MR nào đang mở',
      },
      age: {
        under1d: '< 1 ngày',
        d1to3: '1–3 ngày',
        d3to7: '3–7 ngày',
        over7d: '> 7 ngày',
      },
      deploys: {
        title: 'Tần suất triển khai',
        empty: 'Không có lượt triển khai hay bản phát hành nào trong 12 tuần này',
        source: {
          deployments: 'Số lượt triển khai thành công lên production mỗi tuần',
          tags: 'Số bản phát hành mỗi tuần, theo tag — kho không có deployment',
          mixed: 'Lượt triển khai lên production, cộng bản phát hành theo tag của các kho không có deployment',
          none: 'Chưa gắn kho nào',
        },
      },
      leadTime: {
        title: 'Lead time thay đổi',
        subtitle: 'Commit đầu → lên production (ước lượng), trung vị theo tuần merge',
        empty: 'Chưa MR nào đã merge lên tới production',
        whole: 'Cả 12 tuần',
      },
      unlinked: {
        title: 'Việc không có task ({{days}} ngày qua)',
        help: 'Cách đọc tỷ lệ việc không có task',
        detail: '{{unlinked}} trong {{commits}} commit trên nhánh mặc định không gắn với việc nào',
      },
    },
    attention: {
      title: 'Cần chú ý',
      asOfNote: 'Trạng thái của việc là trạng thái hiện tại, không phải tại mốc đang xem.',
      empty: 'Không có chỗ nào lệch giữa việc và code.',
      truncated: '({{shown}} trong {{total}}, cũ nhất trước)',
      pipeline: 'lượt CI ở {{sha}}',
      codes: 'Mã không tồn tại: {{codes}}',
      skipped: 'Luật bỏ qua: {{reason}}',
      ruleOff: 'Luật "MR merge" đang tắt',
      kind: {
        done_with_open_cr: 'Việc Xong, code chưa vào',
        merged_not_done: 'Code đã vào, việc chưa đóng',
        review_waiting: 'MR chờ review đầu tiên quá {{hours}} giờ',
        stale_change_request: 'MR không cập nhật quá {{days}} ngày',
        stale_branch: 'Nhánh của việc đang làm không có commit mới quá {{days}} ngày',
        unlinked_change_request: 'MR đang mở không gắn việc nào',
        unknown_code: 'Nhắc mã việc mà dự án không có',
        default_branch_red: 'Nhánh chính đỏ',
      },
      since: {
        done_with_open_cr: 'MR mở từ {{at}}',
        merged_not_done: 'merge lúc {{at}}',
        review_waiting: 'sẵn sàng review từ {{at}}',
        stale_change_request: 'cập nhật cuối {{at}}',
        stale_branch: 'commit cuối {{at}}',
        unlinked_change_request: 'mở từ {{at}}',
        unknown_code: 'từ {{at}}',
        default_branch_red: 'đỏ từ {{at}}',
      },
      author: {
        manual: 'Tác giả: {{name}} ({{username}})',
        email: 'Tác giả: {{name}} ({{username}}, khớp theo email)',
        unknown: 'Tác giả: {{username}}',
      },
    },
    identities: {
      title: 'Tài khoản git ↔ người',
      hint: 'Mọi tài khoản đã thấy ở kho của dự án — tác giả merge request, reviewer, và tác giả commit (theo email, vì commit không có tên đăng nhập). Áp dụng cho cả tổ chức. Tài khoản tự khớp theo email của commit; chọn người để gắn tay. Dùng để biết MR, commit của ai — không bao giờ để xếp hạng người.',
      empty: 'Chưa thấy tài khoản git nào — kho chưa kéo xong, hoặc chưa có merge request / commit.',
      saved: 'Đã lưu',
      choose: 'Người đứng sau {{account}}',
      none: '— chưa gắn —',
      byEmail: 'Khớp theo email: {{name}}',
      count: '{{total}} tài khoản · {{unmapped}} chưa gắn',
      filter: 'Lọc theo tài khoản, email hay tên',
      noMatch: 'Không có tài khoản nào khớp.',
      unmapped: 'Chưa gắn',
      inProject: 'Trong dự án',
      outsideProject: 'Ngoài dự án',
      seenAs: {
        change_request_author: 'Tác giả MR',
        reviewer: 'Reviewer',
      },
      commits_one: '{{count}} commit',
      commits_other: '{{count}} commit',
    },
  },
  projectSync: {
    kind: {
      aiservice: 'aiservice',
      jira_cloud: 'Jira Cloud',
      redmine: 'Redmine',
      trello: 'Trello',
      lark_tasks: 'Lark Tasks',
      meegle: 'Lark Project (Meegle)',
    },
    // APM-SYNC2-a — nhãn ô thông tin xác thực theo loại (`SyncProviderCapabilities.credentialFields`).
    credentials: {
      aiservice: {
        apiKey: 'API key của dự án bên đó',
        apiKeyPlaceholder: 'pmk_…',
        apiKeyHelp:
          'Lấy ở Cấu hình dự án → API key bên {{provider}}. Mỗi key chỉ mở đúng một dự án, và không hiện lại sau khi lưu.',
      },
      jira_cloud: {
        siteUrl: 'Site Jira',
        siteUrlPlaceholder: 'https://congty.atlassian.net',
        siteUrlHelp: 'Phần đầu địa chỉ khi mở Jira — dạng https://<tên>.atlassian.net.',
        email: 'Email tài khoản Atlassian',
        emailHelp: 'Email của tài khoản đã tạo API token. Việc đẩy ra Jira đứng tên người này.',
        apiToken: 'API token',
        apiTokenHelp:
          'Token mang đúng quyền của tài khoản đó, và hết hạn tối đa sau 1 năm — khi ấy dùng "Đổi thông tin xác thực".',
      },
      redmine: {
        apiKey: 'API key Redmine',
        apiKeyHelp:
          'Ở trang My account của Redmine, cột phải → API access key → Show. Việc đẩy ra đứng tên người này.',
      },
      trello: {
        apiKey: 'API key (Power-Up)',
        apiKeyHelp: 'Key của một Power-Up bạn tạo ở trello.com/power-ups/admin.',
        token: 'Token',
        tokenHelp:
          'Bấm liên kết "Token" cạnh API key rồi Allow. Key + token đọc/ghi được mọi board của tài khoản Trello đó.',
      },
      meegle: {
        email: 'Email Meegle',
        emailHelp:
          'Email tài khoản Meegle của bạn — phải trùng email đăng nhập ChillPM. Mọi thao tác đẩy ra đứng tên bạn và chỉ thấy thứ bạn được xem.',
        emailPlaceholder: 'ban@congty.com',
      },
    },
    // APM-SYNC2-c — hướng dẫn lấy thông tin xác thực theo loại (plan-sync-providers §3–§7).
    howTo: {
      jira_cloud:
        '1. Mở id.atlassian.com → Security → API tokens.\n2. Bấm "Create API token" (loại không phạm vi), đặt tên, chọn hạn.\n3. Dán token cùng email của tài khoản và site Jira vào đây.',
      redmine:
        '1. Đăng nhập Redmine, mở My account (góc trên phải).\n2. Cột phải: API access key → Show, chép key.\n3. Không thấy mục ấy: quản trị Redmine cần bật Administration → Settings → API → Enable REST web service.',
      trello:
        '1. Mở trello.com/power-ups/admin, tạo một Power-Up (tên tuỳ ý).\n2. Trong Power-Up: API key → Generate a new API key.\n3. Bấm liên kết "Token" cạnh key, chọn Allow, chép token.\nKey + token có quyền trên mọi board của tài khoản — dùng tài khoản dành riêng cho đồng bộ nếu được.',
      lark_tasks:
        '1. Bấm "Kết nối bằng Lark Tasks", đăng nhập Lark bằng tài khoản chủ danh sách việc và đồng ý cấp quyền.\n2. Chọn danh sách: ChillPM thêm app vào danh sách ấy. Lark không cho thêm thì "Tạo danh sách mới" — ChillPM tạo danh sách và chuyển quyền chủ cho bạn.\n3. Sau đó đồng bộ chạy bằng app, không giữ token của ai. Mô tả và bình luận ở Lark là chữ thường (tối đa 3 000 ký tự).',
      meegle:
        '1. Plugin ChillPM phải được cài ở không gian Meegle của bạn (Space settings → Plugin management).\n2. Nhập email tài khoản Meegle của bạn (trùng email đăng nhập ChillPM) rồi bấm Kiểm tra.\n3. Chọn không gian và loại việc. Loại việc dùng luồng nút (node flow) chỉ kéo trạng thái từ Meegle về; các trường khác đồng bộ hai chiều.',
    },
    // APM-SYNC2-c — bước kết nối theo loại: kiểm tra, chọn dự án/board, nhóm trạng thái.
    connect: {
      howToTitle: 'Lấy thông tin xác thực của {{source}} ở đâu?',
      oauth: 'Kết nối bằng {{source}}',
      // APM-SYNC2-g — đăng nhập ở nguồn (Lark) trong cửa sổ bật lên.
      oauthAgain: 'Đăng nhập lại {{source}}',
      oauthBlocked: 'Trình duyệt chặn cửa sổ bật lên.',
      oauthOpen: 'Mở trang đăng nhập {{source}}',
      oauthStatus: {
        waiting: 'Hoàn tất đăng nhập ở cửa sổ {{source}} — danh sách việc sẽ tự hiện ở đây (hoặc bấm Kiểm tra).',
        state: 'Lượt đăng nhập đã hết hạn hoặc không hợp lệ — bấm "Kết nối bằng {{source}}" lại.',
        denied: 'Bạn chưa đồng ý cấp quyền ở {{source}}.',
        error: '{{source}} không hoàn tất đăng nhập — thử lại sau ít phút.',
      },
      oauthAppNote:
        'Nguồn này chạy bằng app của bản cài đặt, không có thông tin xác thực riêng — Lưu để kiểm lại quyền của app với danh sách.',
      newContainer: 'Hoặc tạo danh sách mới',
      newContainerHint:
        'ChillPM tạo danh sách ở {{source}} và chuyển quyền chủ cho bạn — dùng khi không thêm được app vào danh sách có sẵn.',
      newContainerName: 'Tên danh sách',
      create: 'Tạo',
      creating: 'Đang tạo…',
      fieldError: {
        required: 'Ô này bắt buộc.',
        invalid: 'Giá trị chưa đúng dạng.',
      },
      check: 'Kiểm tra',
      checking: 'Đang kiểm tra…',
      checkAgain: 'Kiểm tra lại',
      signedInAs: 'Đăng nhập với tư cách {{name}}',
      containerTitle: 'Chọn dự án / board bên ngoài',
      containerSearch: 'Tìm theo tên hoặc mã',
      search: 'Tìm',
      containerEmpty: 'Tài khoản này chưa thấy dự án / board nào.',
      containerNoMatch: 'Không có dự án / board nào khớp "{{q}}".',
      loadMore: 'Tải thêm',
      loading: 'Đang tải…',
      preview: 'Xem trước',
      tasksTitleUnknown: 'Công việc — chưa rõ số lượng',
      totalUnknown: 'Nguồn này không cho đếm trước tổng số việc — số thật hiện ở tiến trình khi nhập.',
      scopesUncounted: {
        all: 'Tất cả',
        open: 'Chỉ việc chưa xong',
      },
      entityNotInSource: '{{source}} không có thông tin này.',
      categoryHint:
        'Nguồn này không chia trạng thái theo nhóm — chọn nhóm cho từng cột để báo cáo, burndown và "việc chưa xong" đếm đúng.',
      categoryFor: 'Nhóm của cột {{name}}',
      categoryPlaceholder: '— chọn nhóm —',
      needCategories: 'Còn {{n}} cột chưa chọn nhóm.',
    },
    // Vì sao nút Kiểm tra thất bại — theo `details.reason` của SYNC_PROVIDER_UNREACHABLE.
    unreachable: {
      timeout: 'Nguồn không trả lời trong 20 giây.',
      network: 'Không kết nối được tới địa chỉ này.',
      redirect:
        'Địa chỉ chuyển hướng sang {{host}} — không đi theo, vì key dự án sẽ đi theo nó. Hãy nhập đúng địa chỉ cuối cùng.',
      bad_envelope:
        'Địa chỉ có trả lời, nhưng không phải API của nguồn (trang HTML hoặc sai định dạng).',
      unexpected_status: 'Nguồn trả mã {{status}} thay vì 401 như mong đợi khi gọi không có key.',
    },
    admin: {
      title: 'Nguồn đồng bộ',
      subtitle:
        'Hệ thống quản lý công việc bên ngoài mà dự án được kéo việc về và đẩy việc ra. Key là của từng dự án — ở đây chỉ có địa chỉ.',
      intro:
        'Người tạo dự án chọn "Đồng bộ từ một nguồn" trong danh sách các nguồn đang bật ở đây, rồi dán API key của dự án bên kia.',
      empty: 'Chưa có nguồn nào — dự án chỉ tạo mới được, chưa đồng bộ được từ đâu.',
      add: 'Thêm nguồn',
      addTitle: 'Thêm nguồn đồng bộ',
      editTitle: 'Sửa nguồn {{name}}',
      create: 'Thêm',
      edit: 'Sửa',
      kindLine: 'Loại nguồn: {{kind}}.',
      // APM-SYNC2-c — form theo loại (plan-sync-providers §2.2).
      kind: 'Loại nguồn',
      howToTitle: 'Cài {{kind}} thế nào?',
      howTo: {
        jira_cloud:
          'Jira Cloud không có gì để khai ở đây: mỗi dự án tự nhập site (https://<tên>.atlassian.net), email và API token của mình.',
        trello:
          'Trello có một địa chỉ API duy nhất — không có gì để khai. Mỗi dự án dán API key + token của mình.',
      },
      // APM-ORGINT-e — hướng dẫn từng bước theo loại (`providerSetupGuide`), không ô tích.
      guideTitle: 'Tạo {{kind}} cho tổ chức — từng bước',
      guide: {
        lark: {
          open: 'Mở Lark Developer Console bằng tài khoản quản trị Lark của công ty bạn (đúng vùng với ô **Vùng Lark** bên dưới).',
          openLink: 'Mở Lark Developer Console',
          create:
            'Bấm **Create Custom App** (app tự dựng), đặt tên dễ nhận ra, ví dụ "ChillPM". Mỗi tổ chức tạo app riêng của mình.',
          scopes: 'Mở **Permissions & Scopes** và thêm đủ các quyền dưới đây:',
          redirect:
            'Mở **Security Settings** → **Redirect URLs**, thêm đúng địa chỉ dưới đây — chép nguyên, kể cả https:// (lệch một ký tự là PM không đăng nhập được):',
          publish:
            'Mở **Version Management & Release**, tạo một phiên bản và gửi phát hành. App chỉ chạy sau khi quản trị Lark của công ty duyệt phiên bản ấy.',
          credentials:
            'Mở **Credentials & Basic Info**, chép **App ID** và **App Secret**, dán vào hai ô ở cuối hộp này rồi bấm **Thêm**.',
        },
        meegle: {
          open: 'Mở **Developer Platform** của Meegle (Lark Project) bằng tài khoản quản trị Meegle của công ty bạn.',
          create:
            'Tạo một **plugin doanh nghiệp** (plugin riêng của công ty) — không chọn plugin marketplace: loại ấy không tra được người dùng theo email.',
          permissions:
            'Ở phần quyền của plugin, xin quyền: người dùng, không gian (space), work item, cấu hình, bình luận.',
          publish:
            '**Phát hành** plugin. Sau này có đổi quyền thì phải phát hành lại và cập nhật bản cài ở các không gian.',
          install:
            'Nhờ admin của từng không gian Meegle cài plugin: **Space settings → Plugin management**. Không gian chưa cài thì dự án không chọn được nó.',
          credentials: 'Chép **Plugin ID** và **Plugin Secret**, dán vào hai ô ở cuối hộp này.',
          domain:
            'Meegle của công ty dùng domain riêng? Chọn **Domain riêng…** ở ô **Domain Meegle** rồi nhập domain ấy. Không thì giữ domain mặc định.',
        },
        redmine: {
          api: 'Đăng nhập Redmine bằng tài khoản quản trị, mở **Administration → Settings → API**, tích **Enable REST web service** rồi **Save**.',
          format:
            'Xem **Administration → Settings → General → Text formatting** và chọn đúng định dạng ấy ở ô **Định dạng chữ của máy chủ** bên dưới — chọn sai thì mô tả việc hai bên vỡ định dạng.',
          address:
            'Mở Redmine trên trình duyệt, chép địa chỉ tới hết tên máy chủ (ví dụ **https://redmine.congty.vn**) và dán vào ô **Địa chỉ API**.',
          internal:
            'Redmine chỉ mở được khi ở mạng công ty hoặc VPN (địa chỉ nội bộ)? Nhờ quản trị hệ thống bật "cho phép địa chỉ nội bộ" cho tổ chức của bạn trước — không thì ChillPM từ chối địa chỉ này.',
          ca: 'Trình duyệt báo chứng chỉ lạ khi mở Redmine? Xin bộ phận IT tệp CA của công ty (dạng PEM) và dán vào ô **CA riêng**. Không thì bỏ qua.',
          keys: 'Ở đây không cần API key: mỗi dự án tự dán key Redmine của mình lúc nối.',
        },
        ownApp:
          'Nguồn này có từ trước, khi nguồn còn dùng chung cho cả hệ thống? Thì App ID / Secret có thể là app của tổ chức khác được chép sang — nên tạo app riêng của tổ chức bạn theo các bước trên rồi dán App Secret mới đè lên.',
      },
      sharedSecret:
        'Nguồn này có từ trước khi mỗi tổ chức tự khai nguồn, nên App Secret có thể là của app tổ chức khác được chép sang. Nên tạo app riêng của tổ chức bạn (xem hướng dẫn ở trên) rồi dán App ID và App Secret mới vào đây.',
      apiBaseUrlHintKind: {
        redmine: 'Gốc của máy chủ Redmine, ví dụ https://redmine.congty.vn — không kèm /projects.',
        meegle: 'Domain riêng của Meegle, ví dụ https://project.congty.com.',
      },
      apiPerConnection: 'Theo từng kết nối',
      meegleDomain: 'Domain Meegle',
      meegleCustom: 'Domain riêng…',
      region: 'Vùng Lark',
      regions: {
        larksuite: 'Lark quốc tế (open.larksuite.com)',
        feishu: 'Feishu (open.feishu.cn)',
      },
      textFormat: 'Định dạng chữ của máy chủ',
      textFormats: {
        common_mark: 'CommonMark Markdown (mặc định từ Redmine 5.1)',
        textile: 'Textile (Redmine cũ)',
        markdown: 'Markdown (Redcarpet, trước Redmine 6.0)',
      },
      textFormatHint: 'Đúng như Administration → Settings → General → Text formatting của máy chủ.',
      caCert: 'CA riêng (tuỳ chọn)',
      caCertHint: 'Máy chủ nội bộ dùng chứng chỉ do CA riêng cấp thì dán CA ở dạng PEM.',
      app: {
        lark: { title: 'App Lark', appId: 'App ID', appSecret: 'App Secret' },
        meegle: { title: 'Plugin Meegle', appId: 'Plugin ID', appSecret: 'Plugin Secret' },
      },
      appShort: 'App',
      appSaved: 'Đã lưu: {{hint}}',
      appKeepHint: 'Để trống cả hai ô để giữ bí mật đã lưu.',
      appWriteOnlyHint: 'Chỉ ghi — sau khi lưu, bí mật không hiện lại ở đâu cả.',
      name: 'Tên hiển thị',
      namePlaceholder: 'AI Service',
      nameHint: 'Tên mà người tạo dự án thấy khi chọn nguồn.',
      apiBaseUrl: 'Địa chỉ API',
      apiBaseUrlHint: 'Gốc của hệ thống, ví dụ https://pm.aiservice.vn — không kèm /api/public/v1.',
      httpsOnly: 'Bản cài production chỉ nhận https://.',
      webBaseUrl: 'Địa chỉ web (tuỳ chọn)',
      webBaseUrlShort: 'Địa chỉ web',
      webBaseUrlHint:
        'Ghép với đường dẫn của từng việc để ra link "mở ở nguồn". Để trống thì dùng địa chỉ API.',
      webSameAsApi: 'Như địa chỉ API',
      minInterval: 'Chu kỳ tối thiểu',
      minIntervalHint:
        'Dự án không chọn được chu kỳ ngắn hơn mức này. Bên kia giới hạn 60 request mỗi phút cho mỗi key.',
      duration: {
        minutes: '{{n}} phút',
        hours: '{{n}} giờ',
        days: '{{n}} ngày',
      },
      enabledLabel: 'Bật nguồn',
      enabledHint:
        'Tắt thì mọi dự án đang dùng nguồn này dừng đồng bộ ("Nguồn bị admin tổ chức tắt"), không xoá gì.',
      on: 'Đang bật',
      off: 'Đang tắt',
      usage: 'Đang dùng',
      inUse: '{{n}} dự án',
      notInUse: 'Chưa dự án nào',
      test: 'Kiểm tra',
      testing: 'Đang kiểm tra…',
      testOk:
        'Kết nối được — nguồn đã trả lời sau {{ms}} ms. Người tạo dự án giờ chọn được nguồn này.',
      testFail: 'Chưa dùng được: {{message}}',
      remove: 'Xoá',
      removeConfirm: 'Xoá nguồn "{{name}}"? Chưa dự án nào dùng nó nên không mất dữ liệu gì.',
      removeBlocked: 'Còn {{n}} dự án dùng nguồn này nên không xoá được — tắt nguồn thay vì xoá.',
      created: 'Đã thêm nguồn {{name}}.',
      saved: 'Đã lưu nguồn đồng bộ.',
      removed: 'Đã xoá nguồn đồng bộ.',
      toggledOn: 'Đã bật nguồn {{name}}.',
      toggledOff: 'Đã tắt nguồn {{name}} — các dự án dùng nó dừng đồng bộ.',
      errors: {
        nameRequired: 'Nhập tên nguồn.',
        nameTooLong: 'Tên tối đa 80 ký tự.',
        invalidUrl: 'Phải là địa chỉ http(s) đầy đủ, không kèm ?, # hay tài khoản đăng nhập.',
        httpsRequired: 'Phải dùng https:// — bản cài production không gửi key dự án qua http.',
        invalidPem: 'CA phải ở dạng PEM (-----BEGIN CERTIFICATE-----).',
        appRequired: 'Nhập đủ cả hai ô.',
      },
    },
    // Bước "Nguồn công việc" trong hộp tạo dự án — APM-SYNC-d (plan-project-sync §7.1).
    create: {
      sourceLabel: 'Nguồn công việc',
      source: {
        fresh: 'Tạo mới hoàn toàn',
        sync: 'Đồng bộ từ nguồn khác',
      },
      sourceHint: {
        fresh: 'Dự án trống, việc tạo ngay trong ChillPM.',
        sync: 'Lấy việc từ một hệ thống quản lý công việc khác và giữ hai bên khớp nhau.',
      },
      provider: 'Nguồn',
      providerPlaceholder: '— chọn nguồn —',
      singleProvider: 'Nguồn: {{name}}',
      thisSource: 'nguồn',
      apiKey: 'API key của dự án bên đó',
      apiKeyHint:
        'Lấy ở Cấu hình dự án → API key bên {{provider}}. Mỗi key chỉ mở đúng một dự án, và không hiện lại sau khi lưu.',
      preview: 'Kiểm tra và xem trước',
      previewAgain: 'Xem trước lại',
      previewing: 'Đang đọc từ nguồn…',
      previewTitle: 'Xem trước những gì sẽ lấy về',
      needPreview: 'Kiểm tra key và xem trước đã.',
      externalProject: 'Dự án bên ngoài',
      keyName: 'Key: {{name}}',
      tasksTitle: 'Công việc — {{n}} việc',
      category: { todo: 'Chưa làm', in_progress: 'Đang làm', done: 'Xong' },
      recentTitle: '{{n}} việc cập nhật gần nhất',
      noTasks: 'Dự án bên ngoài chưa có việc nào.',
      unassigned: 'Chưa giao',
      statusesTitle: 'Trạng thái — dựng thành cột của dự án, đúng thứ tự này',
      membersTitle: 'Người — {{matched}} ghép được theo email, {{unmatched}} không ghép được',
      memberUnmatched: 'không ghép được — việc của họ về sẽ không có người phụ trách',
      addMatched: 'Thêm {{n}} người ghép được vào dự án',
      addMatchedHint:
        'Người trong tổ chức có cùng email mà chưa ở dự án sẽ được thêm làm thành viên.',
      taskTypesTitle: 'Loại việc',
      sprintsTitle: 'Sprint',
      outcome: {
        matched: 'ghép với {{name}}',
        default: 'dùng loại mặc định {{name}}',
        create: 'sẽ tạo mới',
        none: 'không ghép',
      },
      sprintsNotSynced:
        'Nguồn có {{n}} sprint, nhưng dự án {{methodology}} không có sprint — sprint sẽ không được đồng bộ.',
      unsupportedTitle: 'Không đồng bộ',
      unsupportedTags: 'Tag: {{n}} — ChillPM chưa có tag cho công việc, nên tag ở lại bên nguồn.',
      unsupportedCustomFields:
        'Trường tuỳ chỉnh: {{n}} — API của nguồn chỉ cho đọc, và hai bên định nghĩa trường khác nhau.',
      direction: 'Cách đồng bộ',
      directions: {
        two_way: 'Hai chiều',
        pull: 'Chỉ lấy về',
        push: 'Chỉ đẩy ra',
        once: 'Nhập một lần',
      },
      directionHints: {
        two_way:
          'Thay đổi ở bên nào cũng sang bên kia. Cùng một trường bị sửa ở cả hai bên thì bên nguồn thắng.',
        pull: 'Nguồn là gốc; sửa ở ChillPM được giữ tới khi bên nguồn đổi đúng trường đó.',
        push: 'ChillPM là gốc; việc lấy về một lần để nối hai bên, sau đó chỉ đẩy thay đổi ra.',
        once: 'Lấy về một lần rồi thôi. Liên kết được giữ, nên bật đồng bộ sau này không tạo trùng.',
      },
      scope: 'Lấy những việc nào',
      scopes: {
        all: 'Tất cả — {{n}} việc',
        open: 'Chỉ việc chưa xong — {{n}} việc',
      },
      interval: 'Chu kỳ',
      sprintColumns: 'Cột của sprint tạo từ nguồn',
      sprintColumnsOptions: { all: 'Đủ cột của dự án', used: 'Chỉ cột đang có việc' },
      sprintColumnsHints: {
        all: 'Sprint mới có đủ mọi cột của dự án, kể cả cột chưa có việc nào.',
        used: 'Sprint mới chỉ có những cột đang có việc. Khi một việc sang trạng thái chưa có cột, cột ấy tự được thêm vào sprint, đúng thứ tự của dự án.',
      },
      intervalManual: 'Chỉ khi bấm "Đồng bộ ngay"',
      intervalHint:
        'Bên nguồn giới hạn 60 request mỗi phút cho mỗi key; một lượt không có gì mới tốn 1.',
      entities: 'Loại thông tin',
      entity: {
        title: 'Tên việc',
        description: 'Mô tả',
        status: 'Trạng thái',
        assignee: 'Người phụ trách',
        priority: 'Ưu tiên',
        dates: 'Ngày bắt đầu / hạn',
        estimate: 'Ước lượng giờ',
        sprint: 'Sprint',
        parent: 'Việc cha',
        taskType: 'Loại việc',
        comments: 'Bình luận',
      },
      entityUnsupported: {
        tags: 'Tag',
        customFields: 'Trường tuỳ chỉnh',
      },
      entityUnsupportedWhy: {
        tags: 'ChillPM chưa có tag cho công việc.',
        customFields: 'Nguồn chỉ cho đọc, không ghi được.',
      },
      submit: 'Tạo và bắt đầu đồng bộ',
      created: 'Đã tạo dự án — đang nhập lần đầu từ nguồn.',
      createdPendingApproval: 'Đã gửi. Dự án sẽ bắt đầu nhập từ nguồn sau khi được duyệt.',
    },
    // Trạng thái hiển thị của một kết nối (contracts `SyncConnectionStatus`) — APM-SYNC-i, dùng chung với khối Điều lệ.
    status: {
      active: 'Đang đồng bộ',
      initial_import: 'Đang nhập lần đầu',
      imported: 'Đã nhập xong',
      paused: 'Tạm dừng',
      error: 'Lỗi ở lượt gần nhất',
      key_invalid: 'Key bị từ chối',
      provider_disabled: 'Nguồn bị admin tổ chức tắt',
      pending_approval: 'Chờ duyệt dự án',
      disconnected: 'Đã ngắt',
    },
    // Khối "Đồng bộ" ở tab Điều lệ — APM-SYNC-h (plan-project-sync §7.3).
    problem: {
      heading: 'Cần xử lý',
      noTaskType: {
        title: 'Không nhập được việc nào: dự án chưa có loại việc.',
        hint: 'Mỗi việc phải thuộc một loại việc. Thêm ít nhất một loại việc cho dự án, rồi bấm Thử lại — toàn bộ việc ở nguồn sẽ được nhập.',
      },
      keyInvalid: {
        title: 'Đồng bộ đã dừng: API key của nguồn không còn hợp lệ.',
        hint: 'Mở Cấu hình đồng bộ và dán key mới. Lịch tự chạy sẽ bật lại ngay sau đó.',
      },
      error: {
        title: 'Lượt đồng bộ gần nhất lỗi ({{n}} lần liên tiếp): {{message}}',
        hint: 'Hệ thống sẽ tự thử lại, thưa dần sau mỗi lần hỏng. Bạn có thể thử lại ngay, hoặc mở nhật ký để xem lượt hỏng ở bước nào.',
      },
      skipped: {
        title: '{{n}} việc ở nguồn không nhập được (nhập được {{imported}}).',
        hint: 'Mở nhật ký để xem từng việc và lý do. Sửa xong nguyên nhân thì Nhập lại từ đầu để kéo chúng về.',
        hintReason:
          'Lý do gặp nhiều nhất: {{reason}}. Sửa xong thì Nhập lại từ đầu để kéo các việc này về.',
      },
      reason: {
        NO_TASK_TYPE: 'dự án chưa có loại việc để gán',
        EMPTY_TITLE: 'việc ở nguồn không có tiêu đề',
      },
      action: {
        retry: 'Thử lại ngay',
        reimport: 'Nhập lại từ đầu',
        taskTypes: 'Thêm loại việc',
        configure: 'Mở cấu hình đồng bộ',
        log: 'Xem nhật ký',
        map: 'Ghép ngay',
      },
      pending: {
        title: '{{n}} mục của nguồn chưa ghép được — {{tasks}} việc đang đặt tạm.',
        hint: 'Hệ thống không tự đoán cột hay loại việc khi không chắc. Mở kết quả của lượt gần nhất để chọn chỗ đúng rồi áp dụng lại.',
      },
      reimportQueued: 'Đã xếp lượt nhập lại từ đầu.',
    },
    runs: {
      title: 'Các lượt đồng bộ',
      hint: 'Bấm một lượt để xem tiến trình, kết quả và nhật ký của riêng lượt đó.',
      back: 'Các lượt đồng bộ',
      trigger: { schedule: 'tự chạy', manual: 'chạy tay', change: 'do có thay đổi' },
      outcome: {
        ok: 'Xong',
        no_change: 'Không đổi',
        partial: 'Xong một phần',
        error: 'Lỗi',
        running: 'Đang chạy',
      },
      count: {
        created: '{{n}} việc tạo mới',
        updated: '{{n}} việc cập nhật',
        comments: '{{n}} bình luận',
        conflicts: '{{n}} xung đột',
        errors: '{{n}} lỗi',
        pending: '{{n}} mục chờ ghép',
      },
      nothing: 'Không có gì đổi.',
      stillRunning: 'Đang chạy…',
      failedHint: 'Lượt này dừng vì lỗi — mở để xem lý do.',
      resultTitle: 'Kết quả của lượt này',
      stat: {
        created: 'Tạo mới',
        updated: 'Cập nhật',
        comments: 'Bình luận',
        conflicts: 'Xung đột',
        errors: 'Lỗi',
        pending: 'Chờ ghép',
      },
      unit: {
        created: 'việc',
        updated: 'việc',
        comments: 'bình luận',
        conflicts: 'việc',
        errors: 'mục',
        pending: 'mục',
      },
      pendingTitle: 'Cần ghép',
      pendingHint:
        'Lượt này gặp những giá trị của nguồn không ghép chắc được nên không tự đoán. Việc mang chúng đã được nhập nhưng đang đặt tạm. Chọn chỗ đúng cho từng mục rồi áp dụng lại.',
      pendingDone: 'Mọi mục của lượt này đã được ghép và áp dụng.',
      pendingKind: { status: 'Trạng thái của nguồn', task_type: 'Loại việc của nguồn' },
      pendingWaiting: '{{n}} việc đang đặt tạm',
      pendingNone: 'đã ghép, không còn việc nào đặt tạm',
      pendingPick: 'Ghép «{{name}}» với',
      pendingChoose: { status: '— Chọn cột —', task_type: '— Chọn loại việc —' },
      pendingIgnore: 'Không ghép (giữ nguyên bên trong)',
      pendingReadOnly: 'Chỉ người quản lý dự án mới ghép được các mục này.',
      saveAndApply: 'Lưu {{n}} ghép và áp dụng lại',
      applyAgain: 'Áp dụng lại',
      applyNote:
        'Áp dụng lại là một lượt đọc lại toàn bộ việc ở nguồn; việc đã có không bị tạo trùng.',
      applied: 'Đã lưu ghép và xếp lượt áp dụng lại.',
    },
    charter: {
      title: 'Đồng bộ',
      row: {
        health: 'Còn hoạt động?',
        lastRun: 'Lần cập nhật cuối',
        lastPull: 'Lần lấy dữ liệu mới cuối',
        lastPush: 'Lần đẩy ra ngoài cuối',
        missing: 'Không còn ở nguồn',
      },
      health: {
        active: 'Hoạt động',
        importing: 'Đang nhập lần đầu',
        importingProgress: 'Đang nhập lần đầu {{scanned}}/{{total}}',
        imported: 'Đã nhập xong',
        importedAt: 'Đã nhập xong lúc {{at}}',
        paused: 'Tạm dừng',
        error: 'Lỗi: {{message}} ({{n}} lần liên tiếp)',
        key_invalid: 'Key không còn hợp lệ — cần dán key mới',
        provider_disabled: 'Nguồn bị admin tổ chức tắt',
        pending_approval: 'Chờ duyệt dự án',
        disconnected: 'Đã ngắt',
        lastRunError: 'Lượt gần nhất lỗi: {{message}} ({{n}} lần liên tiếp)',
      },
      result: {
        noChange: 'không có gì mới',
        changes: '{{n}} thay đổi',
        partial: '{{n}} thay đổi, chưa hết — chạy tiếp lượt sau',
        error: 'lỗi',
      },
      running: 'Đang chạy…',
      neverRun: 'Chưa chạy lượt nào',
      next: 'Lần tới: {{at}}',
      nextManual: 'Lần tới: chỉ khi bấm "Đồng bộ ngay"',
      noPull: 'Chưa lấy được gì mới',
      noPush: 'Chưa đẩy gì ra',
      missing: '{{n}} việc không còn ở nguồn',
      missingHint:
        'Lượt đối soát hằng tuần không còn thấy các việc này bên nguồn. ChillPM giữ nguyên, không tự xoá — kiểm tra rồi xoá tay nếu cần.',
      missingSince: 'Phát hiện lúc {{at}}',
      parts: {
        created: '{{n}} việc mới',
        updated: '{{n}} việc thay đổi',
        conflicts: '{{n}} xung đột',
        comments: '{{n}} bình luận',
        errors: '{{n}} lỗi',
        pushed: 'đẩy {{n}} việc',
        pushFailed: '{{n}} việc không đẩy được',
      },
      showItems: 'Xem {{n}} việc',
      showFailures: 'Xem {{n}} việc không đẩy được',
      action: {
        created: 'tạo mới',
        updated: 'cập nhật',
        conflict: 'xung đột — lấy bên nguồn',
        pushed: 'đã đẩy',
        push_failed: 'không đẩy được',
        delete_unsupported: 'bị xoá bên kia — giữ lại ở đây',
        missing: 'không còn ở nguồn',
        restored: 'thấy lại ở nguồn',
        skipped: 'bỏ qua',
      },
      field: {
        title: 'tên',
        description: 'mô tả',
        status: 'trạng thái',
        assignee: 'người phụ trách',
        priority: 'ưu tiên',
        startDate: 'ngày bắt đầu',
        dueDate: 'hạn',
        estimate: 'ước lượng',
        sprint: 'sprint',
        parent: 'việc cha',
        taskType: 'loại việc',
      },
      // Dòng ở chi tiết task (§7.4).
      taskLine: 'Đồng bộ với {{source}}',
      taskLineDisconnected: 'Từng đồng bộ với {{source}} (đã ngắt)',
      openExternal: 'Mở {{code}} bên {{source}}',
    },
    // Hộp "Tiến trình & nhật ký" — APM-SYNC-k (plan-project-sync §5.7, §7.3).
    progress: {
      open: 'Xem tiến trình & nhật ký',
      title: 'Tiến trình & nhật ký — {{source}}',
      loading: 'Đang tải…',
      importing: 'Đang nhập lần đầu',
      imported: 'Đã nhập xong lần đầu',
      running: 'Đang chạy',
      idle: 'Không chạy',
      barLabel: 'Tiến trình nhập lần đầu',
      percent: '{{percent}}% — {{processed}}/{{total}} việc',
      fetched: 'Đã lấy {{n}} việc (nguồn không cho biết tổng)',
      phaseLabel: 'Các bước nhập lần đầu',
      phase: {
        lookups: 'Danh mục',
        tasks: 'Công việc',
        comments: 'Bình luận',
        done: 'Xong',
      },
      stat: {
        processed: 'Đã xử lý',
        rate: 'Tốc độ',
        eta: 'Còn khoảng',
        requests: 'Request lượt này',
        next: 'Lần chạy tới',
      },
      unit: {
        tasks: 'việc',
        perMin: 'việc/phút',
        calls: 'lời gọi',
      },
      ofTotal: '/ {{total}} việc',
      eta: {
        seconds: '{{n}} giây',
        minutes: '{{n}} phút',
        hours: '{{h}} giờ {{m}} phút',
      },
      duration: {
        seconds: '{{n}} giây',
        minutes: '{{m}} phút {{s}} giây',
      },
      runningNow: 'đang chạy',
      nextBatch: 'đợt tiếp theo lúc {{at}}',
      nextNone: 'chỉ khi bấm "Đồng bộ ngay"',
      runs: 'Các lượt chạy',
      runsHint: 'Bấm một lượt để xem nhật ký của riêng lượt đó.',
      noRuns: 'Chưa có lượt nào.',
      kind: {
        initial: 'Nhập lần đầu',
        pull: 'Lấy về',
        push: 'Đẩy ra',
        reconcile: 'Đối soát',
      },
      runFilter: 'Đang xem: {{kind}} lúc {{at}}',
      clearRun: 'Xem mọi lượt',
      log: 'Nhật ký',
      filterAction: 'Lọc theo hành động',
      filterDirection: 'Lọc theo chiều',
      allActions: 'Mọi hành động',
      allDirections: 'Cả hai chiều',
      search: 'Tìm theo mã hoặc tên',
      direction: {
        pull: 'về',
        push: 'ra',
        reconcile: 'đối soát',
      },
      entity: {
        task: 'việc',
        comment: 'bình luận',
        sprint: 'sprint',
        member: 'người',
        status: 'trạng thái',
      },
      action: {
        created: 'tạo mới',
        updated: 'cập nhật',
        conflict: 'xung đột — lấy bên nguồn',
        skipped: 'bỏ qua',
        error: 'lỗi',
        pushed: 'đã đẩy',
        push_failed: 'không đẩy được',
        missing: 'không còn ở nguồn',
        restored: 'thấy lại ở nguồn',
        delete_unsupported: 'bị xoá — giữ lại',
      },
      empty: 'Chưa có dòng nhật ký nào.',
      emptyFiltered: 'Không có dòng nào khớp bộ lọc.',
      loadMore: 'Tải thêm',
      newRows: '{{n}} dòng mới ↑',
      openTask: 'Mở {{code}}',
    },
    // Mục "Nguồn đồng bộ" ở Cấu hình dự án — APM-SYNC-i (plan-project-sync §7.2).
    settings: {
      title: 'Nguồn đồng bộ',
      subtitle:
        'Hệ thống bên ngoài mà dự án này kéo việc về hoặc đẩy việc ra: cách đồng bộ, chu kỳ, loại thông tin và ghép người, cột.',
      intro:
        'Mỗi nguồn là một dự án ở hệ thống khác, mở bằng API key của dự án bên đó. Việc mới tạo trong ChillPM chỉ đẩy ra nguồn chính.',
      empty: 'Dự án chưa đồng bộ với nguồn nào.',
      noProviders: 'Tổ chức chưa có nguồn đồng bộ nào đang bật — nhờ admin tổ chức khai ở Quản trị → Nguồn đồng bộ.',
      openAdmin: 'Mở Quản trị → Nguồn đồng bộ',
      orgAdminHint: 'Bạn là admin tổ chức nên tự khai được ngay.',
      add: 'Thêm nguồn',
      addTitle: 'Thêm nguồn đồng bộ',
      connect: 'Kết nối và bắt đầu đồng bộ',
      connected: 'Đã kết nối — đang nhập lần đầu từ nguồn.',
      primary: 'Nguồn chính',
      primaryLabel: 'Là nguồn chính',
      primaryHint: 'Việc tạo trong ChillPM được đẩy ra nguồn chính. Mỗi dự án chỉ có một.',
      primaryTaken: '{{name}} đang là nguồn chính — tắt ở đó trước.',
      keyLabel: 'Xác thực',
      direction: 'Cách',
      interval: 'Chu kỳ',
      intervalOnce: 'Không chạy định kỳ',
      nextRun: 'Lần tới: {{at}}',
      nextRunNone: 'Lần tới: chỉ khi bấm "Đồng bộ ngay"',
      lastRun: 'Lần chạy gần nhất: {{at}}',
      lastError: 'Lỗi gần nhất: {{message}}',
      configure: 'Cấu hình',
      collapse: 'Thu gọn',
      partSettings: 'Cách đồng bộ & chu kỳ',
      partPeople: 'Ghép người',
      partMapping: 'Ghép trạng thái / loại việc / sprint',
      save: 'Lưu',
      saved: 'Đã lưu cấu hình đồng bộ.',
      // APM-SYNC2-f — ưu tiên / ước lượng ở trường tuỳ chỉnh (Trello).
      fieldMap: {
        title: 'Ưu tiên & ước lượng từ trường tuỳ chỉnh',
        hint: 'Nguồn này không có ưu tiên và ước lượng riêng — chọn trường tuỳ chỉnh nào mang chúng. Không chọn thì hai thông tin này không đồng bộ.',
        none: 'Chưa thấy trường tuỳ chỉnh nào ở nguồn (board cần bật Custom Fields). Danh sách cập nhật sau lượt đồng bộ kế tiếp.',
        priority: 'Ưu tiên lấy từ trường',
        estimate: 'Ước lượng (giờ) lấy từ trường',
        estimateHint: 'Trường kiểu số; giá trị hiểu là số giờ.',
        notUsed: 'Không dùng',
        noValue: '— không ghép —',
      },
      runNow: 'Đồng bộ ngay',
      runQueued: {
        initial: 'Đã xếp lượt nhập tiếp từ nguồn.',
        pull: 'Đã xếp lượt lấy thay đổi về.',
        push: 'Đã xếp lượt đẩy thay đổi ra.',
        reconcile: 'Đã xếp lượt đối soát.',
      },
      pause: 'Tạm dừng',
      resume: 'Tiếp tục',
      paused: 'Đã tạm dừng đồng bộ.',
      resumed: 'Đã tiếp tục đồng bộ.',
      rotateKey: 'Đổi thông tin xác thực',
      rotateKeyTitle: 'Đổi thông tin xác thực của {{name}}',
      rotateKeyHint:
        'Thông tin mới phải mở cùng dự án bên ngoài ({{key}}). Thông tin cũ thôi dùng ngay khi lưu.',
      rotateUnsupported:
        'Bản cài này không còn hỗ trợ loại nguồn của kết nối — không đổi được thông tin xác thực.',
      keyRotated: 'Đã đổi thông tin xác thực — lượt tới dùng thông tin mới.',
      disconnect: 'Ngắt kết nối',
      disconnectConfirm:
        'Ngắt kết nối với {{name}}? Việc đã kéo về vẫn ở lại trong dự án, chỉ ngừng đồng bộ. Muốn nối lại thì thêm nguồn với key của cùng dự án — việc cũ không bị tạo trùng.',
      disconnected: 'Đã ngắt kết nối. Việc đã kéo về vẫn ở lại.',
      disconnectedNote: 'Đã ngắt lúc {{at}}. Nối lại bằng "Thêm nguồn" với key của cùng dự án.',
      disconnectedHeldNote:
        'Dự án ngoài vẫn đang được giữ cho dự án này — chưa nối được với dự án khác.',
      release: 'Ngắt & giải phóng',
      releaseConfirm:
        'Ngắt {{name}} và giải phóng dự án ngoài? Sau đó dự án ngoài này nối được với một dự án khác. Việc đã kéo về, liên kết và nhật ký vẫn ở lại trong dự án này.',
      releaseOnly: 'Giải phóng dự án ngoài',
      releaseOnlyConfirm:
        'Giải phóng {{name}}? Dự án ngoài này sẽ nối được với một dự án khác. Dự án này chỉ nối lại được khi chưa có dự án nào khác nối nó.',
      released: 'Đã giải phóng — dự án ngoài giờ nối được với dự án khác.',
      releasedNote: 'Đã ngắt lúc {{at}} và đã giải phóng: dự án ngoài này nối được với dự án khác.',
      reimport: 'Đồng bộ lại toàn bộ',
      reimportConfirm:
        'Đọc lại toàn bộ việc của {{name}} từ đầu — kể cả việc cũ và việc từng lỗi hoặc bị bỏ qua? Việc đã kéo về được cập nhật chứ không tạo trùng. Dự án lớn thì lượt này chạy lâu.',
      reimportQueued: 'Đã xếp lượt đồng bộ lại toàn bộ.',
      mappingRefreshed: 'Danh mục nguồn đọc lúc {{at}}.',
      mappingEmpty: 'Nguồn chưa có mục nào để ghép.',
      mappingSave: 'Lưu ghép ({{n}} thay đổi)',
      mappingSaved: 'Đã lưu bảng ghép.',
      mappingNone: '— Không ghép —',
      mappingAuto: '↺ Bỏ ghép tay, dùng gợi ý tự động',
      mappingPendingAuto: 'gợi ý tính lại khi lưu',
      mappingKind: {
        status: 'Trạng thái',
        task_type: 'Loại việc',
        sprint: 'Sprint',
      },
      sprintNotSynced:
        'Dự án {{methodology}} không có sprint — sprint của nguồn không được đồng bộ.',
      source: {
        auto: 'tự ghép',
        autoUser: 'tự ghép theo email',
        manual: 'ghép tay',
        none: 'không ghép',
      },
      category: { todo: 'Chưa làm', in_progress: 'Đang làm', done: 'Xong' },
      sprintState: { upcoming: 'sắp tới', running: 'đang chạy', closed: 'đã đóng' },
    },
    users: {
      title: 'Ghép người dùng',
      subtitle:
        'Người ở nguồn đồng bộ ứng với ai trong ChillPM — việc của người chưa ghép về dự án sẽ không có người phụ trách.',
      intro:
        'Nguồn có email thì tự ghép theo email người cùng tổ chức; nguồn ẩn email thì chọn tay theo tên và ID. Ghép tay luôn thắng gợi ý tự động.',
      emptyTitle: 'Chưa có nguồn đồng bộ nào',
      empty:
        'Dự án chưa kết nối với nguồn nào nên chưa có người bên ngoài để ghép. Thêm nguồn ở mục Nguồn đồng bộ trước.',
      emptyAction: 'Tới mục Nguồn đồng bộ',
      viewLabel: 'Góc nhìn',
      viewExternal: 'Theo người ở nguồn',
      viewMembers: 'Theo thành viên ChillPM',
      sourceLabel: 'Nguồn',
      summary: '{{people}} người chưa ghép — {{tasks}} việc của họ sẽ không có người phụ trách',
      allMapped: 'Mọi người ở nguồn đều đã được ghép hoặc đã chọn không ghép.',
      onlyUnmapped: 'Chỉ người chưa ghép',
      search: 'Tìm theo tên, email, ID',
      noMatch: 'Không có ai khớp bộ lọc.',
      noPeople: 'Nguồn chưa có ai để ghép.',
      noEmail: 'Không có email',
      shortId: 'ID {{id}}',
      tasks: 'Đang phụ trách {{n}} việc ở nguồn',
      localPersonFor: 'Người trong ChillPM ứng với {{name}}',
      groupMembers: 'Thành viên dự án',
      groupOthers: 'Người khác trong tổ chức',
      unmappedOption: '— Chưa ghép —',
      state: {
        auto: 'tự ghép theo email',
        manual: 'ghép tay',
        unmapped: 'chưa ghép',
        skipped: 'không ghép',
      },
      notMember: '⚠ Chưa là thành viên dự án',
      save: 'Lưu ghép ({{n}} thay đổi)',
      saved: 'Đã lưu ghép người.',
      runHint: 'Ghép mới áp vào việc ở lượt đồng bộ tới. Muốn áp ngay thì đồng bộ bây giờ.',
      addMembers: 'Thêm {{n}} người đã ghép vào dự án',
      addingMembers: 'Đang thêm…',
      addMembersHint: 'Lưu ghép trước rồi mới thêm người vào dự án.',
      membersAdded: 'Đã thêm {{n}} người vào dự án.',
      reverseIntro:
        'Mỗi thành viên dự án đang ứng với tài khoản nào ở từng nguồn — người chưa có tài khoản bên kia thì việc giao cho họ đẩy ra ngoài sẽ không có người phụ trách.',
      reverseEmpty: 'Dự án chưa có thành viên nào để đối chiếu.',
      noAccount: 'Chưa có tài khoản',
      notMemberRow: 'Đã ghép nhưng chưa là thành viên dự án',
      editorSummary: 'Đã ghép {{mapped}}/{{total}} người ở nguồn.',
      editorLink: 'Sửa ở mục Ghép người dùng',
    },
  },
  telegramBot: {
    foreign:
      'Bot đang bật thuộc môi trường {{origin}}, nên ở đây không nhận tin và không gửi tin bằng nó — hai nơi cùng dùng một bot là giành tin nhắn của nhau. Muốn dùng Telegram ở môi trường này thì tạo một bot riêng với @BotFather và lưu token của nó bên dưới.',
    title: 'Bot Telegram',
    subtitle:
      'Một bot cho cả hệ thống. Người dùng tự kết nối tài khoản của mình ở Cài đặt, rồi nhận thông báo và cập nhật tiến độ ngay trong Telegram.',
    none: 'Chưa cấu hình. Phần kết nối Telegram trong Cài đặt của mọi người đang tắt.',
    step1: 'Mở Telegram, nhắn @BotFather rồi gõ /newbot.',
    step2: 'Đặt tên và tên đăng nhập cho bot (tên đăng nhập phải kết thúc bằng "bot").',
    step3: 'BotFather trả về một dòng dạng 123456789:AAE… — dán nguyên dòng đó vào ô dưới.',
    token: 'Token của bot',
    tokenTail: 'Token ••••{{last4}}',
    modeLabel: 'Cách nhận tin nhắn',
    mode: {
      polling: 'Tự hỏi Telegram (polling)',
      webhook: 'Telegram gọi vào (webhook)',
    },
    modeHelp: {
      polling:
        'Chạy được ở mọi nơi, kể cả máy trong mạng nội bộ. Nên dùng cho tới khi lên máy chủ thật.',
      webhook:
        'Cần địa chỉ HTTPS công khai ở cổng 443, 80, 88 hoặc 8443. Nhẹ hơn và nhanh hơn một chút.',
    },
    httpsRequired:
      'APP_URL đang không phải https, nên Mini App và nút menu trong Telegram chưa bật được. Thông báo và nút thao tác nhanh vẫn chạy bình thường.',
    lastUpdate: 'Nhận tin gần nhất: {{at}}',
    noUpdateYet: 'Chưa nhận được tin nào.',
    lastError: 'Lỗi gần nhất: {{message}}',
    save: 'Lưu bot',
    saving: 'Đang kiểm token…',
    saved: 'Đã kết nối @{{bot}}.',
    test: 'Kiểm tra kết nối',
    testOk: 'Telegram trả lời bình thường (@{{bot}}).',
    remove: 'Gỡ bot',
    removeConfirm:
      'Gỡ bot thì mọi người ngừng nhận thông báo Telegram. Các liên kết tài khoản vẫn được giữ, cắm lại đúng bot này là dùng tiếp được.',
    removed: 'Đã gỡ bot.',
  },
  googleOauth: {
    title: 'Đăng nhập bằng Google',
    subtitle:
      'Cho phép người đã có tài khoản đăng nhập bằng Google. Không tự tạo tài khoản mới — email lạ vẫn bị từ chối.',
    none: 'Chưa cấu hình. Nút Google chưa hiện ở trang đăng nhập.',
    current: 'Đang dùng Client ID {{clientId}}.',
    redirectUri: 'Authorized redirect URI — dán chuỗi này vào Google Console',
    redirectHelp:
      'Google so khớp từng ký tự. Thêm cả origin ({{origin}}) vào mục "Authorized JavaScript origins".',
    copy: 'Chép',
    copied: 'Đã chép.',
    copyFailed: 'Trình duyệt không cho chép tự động. Bôi đen rồi chép tay giúp nhé.',
    clientId: 'Client ID',
    clientSecret: 'Client secret',
    save: 'Lưu cấu hình',
    saving: 'Đang lưu…',
    saved: 'Đã lưu. Thử nút Google ở trang đăng nhập.',
  },
  demoAiKey: {
    needBaseUrl: 'Điền địa chỉ gateway trước đã — LiteLLM không có địa chỉ mặc định.',
    refresh: 'Kiểm lại kết nối & cập nhật model',
    refreshing: 'Đang kiểm…',
    refreshed: 'Gateway trả {{n}} model. Đã cập nhật chuỗi model cho key này.',
    refreshHelp:
      'Dùng khi key vẫn tốt nhưng lời gọi báo không tìm thấy model: nút này đọc lại danh sách model của gateway rồi đặt chuỗi model cho key. Không tốn token, không cần dán lại key.',
    modelHint:
      'Key sống chưa đủ: lời gọi đi bằng tên model ở phần Cấu hình hệ thống (`ai.default_model`, `ai.model.strong`, `ai.model.small`). Gateway hay nhà cung cấp của key phải có đúng những tên ấy, hoặc đặt chuỗi model riêng cho key này.',
    label: 'Key trưng bày',
    field: 'Key AI cho tổ chức demo',
    warning:
      'Ai trên internet cũng đăng nhập được tổ chức demo, nên mọi lời gọi AI ở đó tiêu tiền của key này. Dùng key riêng (thu hồi được mà không đụng key thật), và đặt hạn mức ở mục Ngân sách AI — chưa đặt thì không có trần chi.',
    current: 'Đang dùng key •••• {{last4}}. Nhập key mới để thay.',
    none: 'Chưa có key. Tính năng AI trong tổ chức demo hiện đang tắt.',
    save: 'Lưu và kiểm kết nối',
    saving: 'Đang kiểm…',
    saved: 'Đã lưu và kích hoạt key cho tổ chức demo.',
    failed: 'Không kết nối được bằng key này — key chưa được kích hoạt.',
  },
  demoAdmin: {
    title: 'Tổ chức demo',
    subtitle:
      'Bộ dữ liệu trưng bày cho người chưa có tài khoản. Tự đặt lại định kỳ và tự sinh hoạt động để trông như đang chạy thật.',
    state: 'Tình trạng',
    on: 'Đang chạy',
    onIdle: 'Đã bật, chưa có gì để chạy',
    off: 'Đã tắt',
    noOrg:
      'Chưa có tổ chức demo. Chạy `pnpm seed:demo-org` trên máy chủ để dựng — hệ thống cố ý không tự tạo.',
    cadence: 'Nhịp mô phỏng',
    cadenceValue: '{{count}} hành động mỗi {{minutes}} phút',
    lastRun: 'Lượt gần nhất',
    never: 'Chưa chạy lần nào',
    actionsSinceStart: 'Hành động đã sinh (từ lần khởi động này)',
    lastActions: 'Lượt vừa rồi:',
    action: {
      start: 'Bắt đầu việc',
      finish: 'Hoàn thành việc',
      comment: 'Bình luận',
      create: 'Tạo việc mới',
    },
    runNow: 'Sinh hoạt động ngay',
    resetNow: 'Đặt lại dữ liệu demo ngay',
    ranNow: 'Đã sinh {{count}} hành động',
    resetDone: 'Đã dựng lại {{count}} dự án',
  },
  demoProjects: {
    help: 'Kịch bản demo nằm trong mã nguồn; ở đây bạn đắp lên nó. Phần đè sống sót qua mọi lượt dựng lại, nên nó là cách duy nhất để một thay đổi trong tổ chức demo tồn tại lâu hơn nửa giờ.',
    changedCount: 'đang đè {{n}} ô',
    untouched: 'theo kịch bản',
    editTitle: 'Sửa dự án demo',
    scenarioKey:
      'Mã trong kịch bản: {{key}} — đây là định danh không đổi, kể cả khi bạn đổi mã hiển thị.',
    key: 'Mã dự án',
    name: 'Tên',
    description: 'Mô tả',
    color: 'Màu',
    methodology: 'Phương pháp',
    maintain: 'Bảo trì / vận hành',
    startOffset: 'Bắt đầu (ngày so với hôm gieo)',
    endOffset: 'Kết thúc (ngày so với hôm gieo)',
    manMonths: 'Man-month',
    manMonthsHint: 'Quyết định số task sinh ra',
    pm: 'Quản lý dự án',
    contributors: 'Thành viên',
    hiddenTabs: 'Tab ẩn đi',
    hiddenTabsHelp:
      'Tab trụ (Điều lệ, Nhân sự, Công việc, Báo cáo) vẫn hiện dù có tích ở đây — cửa chặn nằm ở chính thanh tab.',
    reset: 'Về đúng kịch bản',
    saved: 'Đã lưu. Có hiệu lực từ lượt dựng lại tiếp theo.',
    cleared: 'Đã trả dự án về kịch bản gốc.',
    applyHint:
      'Thay đổi ghi vào cấu hình, không sửa dự án đang chạy: bấm "Đặt lại dữ liệu demo ngay" ở khối trên để thấy nó ngay lập tức.',
  },
  demoReset: {
    switchSaved: 'Đã lưu công tắc.',
    simulate: 'Tự sinh hoạt động trong tổ chức demo',
    simulateHelp:
      'Định kỳ tạo việc, đổi trạng thái và bình luận để bộ trưng bày trông như đang chạy. Tắt thì dữ liệu đứng yên giữa hai lượt dựng lại.',
    autoReset: 'Tự dựng lại theo lịch ({{minutes}} phút một lần)',
    autoResetHelp:
      'Xoá sạch dự án của tổ chức demo rồi gieo lại từ kịch bản, kể cả dự án do người xem thử tự tạo. Không đụng tổ chức nào khác.',
    frozenWarning:
      'Lịch đang tắt: mọi thay đổi sẽ ở lại, nhưng dữ liệu demo già dần. Kịch bản tính mọi mốc theo "hôm nay" và chỉ lượt dựng lại mới neo chúng vào thời gian thật — để lâu thì tiến độ, burndown và Gantt đều trượt về quá khứ.',
    manualHint:
      'Nút này chạy được cả khi lịch đang tắt: nó là thao tác có người bấm, không phải cỗ máy chạy ngầm.',
    historyTitle: 'Những lần dựng lại gần đây',
    noRuns:
      'Chưa ghi lượt nào. Sổ này bắt đầu từ lượt dựng lại đầu tiên sau khi tính năng được bật.',
    colAt: 'Lúc',
    colTrigger: 'Do đâu',
    colProjects: 'Dự án',
    colSwept: 'Thay đổi bị cuốn',
    colDuration: 'Mất',
    trigger: { cron: 'Theo lịch', manual: 'Bấm tay' },
    projectsValue: 'xoá {{dropped}} · dựng {{seeded}}',
    sweptHelp:
      '"Thay đổi bị cuốn" đếm những gì được ghi sau lượt gieo trước — gồm cả hành động của job tự sinh, vì nó ghi giống hệt người thật. Dấu "—" nghĩa là chưa có mốc để so, không phải bằng không.',
  },
  settings: {
    title: 'Cấu hình hệ thống',
    subtitle: 'Feature flag và tuỳ chọn mặc định. Đổi có tác dụng ngay, không cần khởi động lại.',
    saved: 'Đã lưu cấu hình.',
    changed: 'đã đổi',
    reset: 'Về mặc định',
    group: {
      feature: 'Bật/tắt tính năng',
      ai: 'Mặc định cho AI',
      standard: 'Quy chuẩn công việc',
      notification: 'Thông báo',
      ai_policy: 'Chính sách AI',
    },
  },
  /**
   * Bảng sắp xếp được — APM-PERF-f.
   *
   * Nhãn nói **hành động kế tiếp** chứ không nói trạng thái hiện tại: trạng
   * thái đã nằm ở `aria-sort` của ô, còn nút thì trả lời "bấm vào đây sẽ ra sao".
   */
  table: {
    sortAsc: 'Sắp xếp theo {{label}}, tăng dần',
    sortDesc: 'Sắp xếp theo {{label}}, giảm dần',
  },
  /** Form tạo/sửa task và nút "AI tách giúp" — APM-1308b. */
  /**
   * Hàng lọc/làm nổi trên board — APM-BOARD-f.
   *
   * "Làm nổi" và "Lọc" là hai việc khác nhau, nên hai chữ khác nhau: làm nổi
   * thì thẻ không khớp vẫn còn đó (chỉ chìm xuống), còn lọc thì chúng biến mất.
   */
  boardFilter: {
    modeSwitch: 'Cách thu hẹp',
    mode: { highlight: 'Làm nổi', filter: 'Lọc' },
    assignee: 'Người làm',
    anyAssignee: 'Tất cả',
    taskType: 'Loại việc',
    anyTaskType: 'Tất cả',
    due: 'Thời hạn',
    anyDue: 'Tất cả',
    dueBucket: {
      overdue: 'Quá hạn',
      today: 'Hết hạn hôm nay',
      upcoming: 'Còn thời gian',
    },
    clear: 'Bỏ chọn',
    criteria: 'Tiêu chí',
  },
  /**
   * Cửa "bắt đầu làm" — APM-BOARD-g. Mỗi câu nói **việc còn thiếu gì**, không
   * nói "không được phép": người dùng có quyền, chỉ là việc chưa sẵn sàng.
   */
  taskStart: {
    TASK_START_NO_ACTIVE_SPRINT:
      'Dự án chưa có sprint nào đang chạy — bắt đầu một sprint rồi mới bắt đầu làm việc này.',
    TASK_START_SPRINT_NO_COLUMN:
      'Sprint đang chạy không có cột "đang làm" nào — thêm cột ấy cho sprint rồi thử lại.',
    TASK_START_NO_ASSIGNEE: 'Chưa giao cho ai — gán người phụ trách rồi mới chuyển sang Đang làm.',
    TASK_START_NO_ESTIMATE:
      'Chưa có ước lượng giờ — vẫn bắt đầu được, nhưng velocity sẽ thiếu mẫu này.',
    TASK_START_DEPENDENCY_UNFINISHED:
      'Việc phụ thuộc chưa xong: {{blockedBy}}. Xong việc đó rồi mới bắt đầu được việc này.',
  },
  checklist: {
    title: 'Checklist công việc',
    add: 'Thêm checklist công việc',
    remove: 'Xoá checklist',
    addItem: 'Thêm mục',
    itemLabel: 'Nội dung mục {{number}}',
    weightLabel: 'Trọng số mục {{number}} (%)',
    removeItem: 'Xoá mục {{number}}',
    itemPlaceholder: 'Việc cần hoàn thành',
    auto: 'Tự chia',
    weightHelp: 'Để trống trọng số để chia đều phần % còn lại. Tổng trọng số phải bằng 100%.',
    invalid:
      'Mỗi mục cần có nội dung. Trọng số phải lớn hơn 0, tối đa 2 số lẻ; tổng là 100% hoặc còn phần dư cho các mục tự chia.',
    parentHelp: 'Tiến độ task cha được tính từ subtask, không thêm checklist tính tiến độ.',
    count: 'Checklist ({{done}}/{{total}})',
    expandItems: 'Hiện các mục checklist',
    collapseItems: 'Ẩn các mục checklist',
    doneHelp: 'Mở lại task trước khi bỏ tích hoặc thêm mục chưa hoàn thành.',
    todoHelp: 'Chuyển task sang Đang làm rồi mới tích được từng mục.',
    backlogHelp: 'Việc đang ở backlog — đưa vào sprint rồi mới tích được từng mục.',
    summary: '{{done}}/{{total}} mục · {{progress}}%',
    CHECKLIST_PROGRESS_LOCKED: 'Task có checklist nên không thể chỉnh tiến độ trực tiếp.',
    CHECKLIST_INCOMPLETE:
      'Cần hoàn thành tất cả mục trong checklist trước khi chuyển task sang hoàn thành.',
    CHECKLIST_PARENT_CONFLICT: 'Task có checklist không thể đồng thời có subtask.',
    CHECKLIST_STALE:
      'Checklist đã được cập nhật. Hãy đóng và mở lại form để lấy phiên bản mới nhất.',
    CHECKLIST_REOPEN_REQUIRED:
      'Hãy chuyển task ra khỏi trạng thái hoàn thành trước khi thay đổi checklist thành chưa hoàn tất.',
  },
  richText: {
    headingLevel: 'Cấp tiêu đề',
    align: { left: 'Căn trái', center: 'Căn giữa', right: 'Căn phải', justify: 'Căn đều hai bên' },
    paragraph: 'Văn bản thường',
    heading1: 'Tiêu đề 1',
    heading2: 'Tiêu đề 2',
    heading3: 'Tiêu đề 3',
    heading4: 'Tiêu đề 4',
    blockquote: 'Trích dẫn',
    codeBlock: 'Khối code',
    separator: 'Dấu phân cách (Ctrl+Enter)',
    link: 'Chèn link',
    linkUrl: 'Địa chỉ',
    linkText: 'Chữ hiển thị',
    linkInvalid: 'Chỉ nhận link http://, https:// hoặc mailto:.',
    applyLink: 'Chèn',
    removeLink: 'Bỏ link',
    fontFamily: 'Font chữ',
    defaultFont: 'Font mặc định',
    fontGroups: {
      sans: 'Không chân',
      serif: 'Có chân',
      mono: 'Đơn cách',
      handwriting: 'Viết tay',
      display: 'Trang trí',
      added: 'Đã thêm vào tài liệu',
      document: 'Trong văn bản',
    },
    addGoogleFont: 'Thêm font Google',
    googleFontName: 'Tên font trên Google Fonts',
    add: 'Thêm',
    fontNameInvalid: 'Tên font chỉ gồm chữ, số và dấu cách.',
    fontNotFound: 'Không tìm thấy font này trên Google Fonts.',
    fontOffline: 'Không kết nối được Google Fonts — thử lại sau.',
    textColor: 'Màu chữ',
    backgroundColor: 'Màu nền chữ',
    otherColor: 'Màu khác',
    removeColor: 'Bỏ màu',
    formatting: 'Định dạng mô tả',
    bold: 'In đậm',
    italic: 'In nghiêng',
    strike: 'Gạch ngang',
    underline: 'Gạch chân',
    smaller: 'Giảm cỡ chữ',
    larger: 'Tăng cỡ chữ',
    fontSize: 'Cỡ chữ',
    bulletList: 'Danh sách gạch đầu dòng',
    orderedList: 'Danh sách đánh số',
    taskList: 'Checklist (gắn được task)',
    indent: 'Tăng cấp danh sách',
    outdent: 'Giảm cấp danh sách',
    undo: 'Hoàn tác',
    redo: 'Làm lại',
    listHelp: 'Trong danh sách: Tab để tăng cấp, Shift + Tab để giảm cấp.',
    insertImage: 'Chèn ảnh',
    imageType: '“{{name}}” không phải ảnh PNG, JPEG, GIF hay WebP.',
    imageTooLarge: '“{{name}}” vẫn lớn hơn {{mb}} MB sau khi nén — hãy chèn nó dưới dạng tệp.',
    pastedImagesDropped_one:
      'Không lấy được {{count}} ảnh từ nội dung vừa dán — hãy chèn ảnh ấy bằng nút Chèn ảnh.',
    pastedImagesDropped_other:
      'Không lấy được {{count}} ảnh từ nội dung vừa dán — hãy chèn các ảnh ấy bằng nút Chèn ảnh.',
    documentTooLarge: 'Tài liệu sẽ vượt {{mb}} MB — bớt vài ảnh rồi thử lại.',
    uploadingImages_one: 'Đang tải {{count}} ảnh lên…',
    uploadingImages_other: 'Đang tải {{count}} ảnh lên…',
    imagesDisabled: 'Chưa chèn được ảnh: {{reason}}',
  },
  dependency: {
    title: 'Việc phải xong trước',
    help: 'Việc này chỉ bắt đầu được sau khi những việc dưới đây xong. Thêm hoặc bỏ có hiệu lực ngay, không cần bấm Lưu.',
    none: 'Chưa phụ thuộc vào việc nào.',
    pick: 'Chọn việc phải xong trước',
    pickPlaceholder: '— chọn một việc —',
    add: 'Thêm',
    removeOne: 'Bỏ phụ thuộc vào {{key}}',
  },
  triage: {
    duplicates: 'Việc trông giống đã có',
    done: '(đã xong)',
    storyPoints:
      'Việc tương tự đã xong thường {{value}} điểm (khoảng {{low}}–{{high}}, {{count}} việc).',
    askAi: 'Hỏi AI gợi ý thêm',
    asking: 'Đang hỏi…',
    applyPriority: 'Đặt ưu tiên: {{value}}',
    applyAssignee: 'Giao cho người được đề xuất',
    skipped: {
      no_key: 'Chưa cấu hình AI nên chỉ có phần tính sẵn.',
      failed: 'AI không trả lời được lúc này; phần tính sẵn vẫn ở trên.',
    },
  },
  bulkEdit: {
    proposed: 'Đã đề xuất {{count}} thay đổi',
    openResult: 'Xem kết quả',
    minimise: 'Thu nhỏ',
    restore: 'Mở lại',
    open: 'Sửa nhanh',
    title: 'Sửa hàng loạt bằng lời',
    prompt: 'Bạn muốn đổi gì?',
    placeholder: 'Ví dụ: dời mọi việc của Minh tuần sau sang Hà, trừ việc đang review',
    help: 'AI chỉ dựng bản xem trước. Không gì thay đổi cho tới khi bạn bấm duyệt.',
    preview: 'Xem trước',
    running: 'Đang dựng bản xem trước…',
    remaining: 'Sẽ áp dụng {{count}} thay đổi',
    apply: 'Duyệt và áp dụng',
    applying: 'Đang áp dụng…',
    applied: 'Đã áp dụng {{count}} thay đổi',
  },
  taskDelete: {
    button: 'Xoá việc',
    title: 'Xoá việc {{key}}?',
    body: 'Việc sẽ biến khỏi mọi danh sách, bảng và biểu đồ. Lấy lại được ở tab Thay đổi của dự án.',
    withChildren: '{{count}} việc con cũng bị xoá theo, và được lấy lại cùng.',
    confirm: 'Xoá',
    deleted: 'Đã xoá {{key}} — lấy lại ở tab Thay đổi.',
    restore: 'Khôi phục',
    restored: 'Đã khôi phục {{key}}.',
    errors: {
      TASK_DELETE_FORBIDDEN:
        'Chỉ PM của dự án hoặc người tạo việc mới xoá hay khôi phục được việc này.',
      TASK_RESTORE_PARENT_DELETED: 'Việc cha đang bị xoá — khôi phục việc cha trước.',
    },
  },
  taskForm: {
    selfAssigned: 'Bạn — việc tự tạo giao cho chính người tạo',
    assigneeByPm: 'PM của dự án đổi được người làm khi cần.',
    newTask: 'Việc mới',
    createTitle: 'Việc mới',
    editTitle: 'Sửa việc',
    edit: 'Sửa',
    title: 'Tiêu đề',
    titlePlaceholder: 'Làm gì?',
    description: 'Mô tả',
    descriptionPlaceholder: 'Làm để được gì, xong là thế nào? (không bắt buộc)',
    type: 'Loại việc',
    kindMilestone: 'Milestone',
    milestoneOwner: 'Người chịu trách nhiệm',
    assignee: 'Người làm',
    unassigned: '— chưa giao —',
    assigneeSearch: 'Gõ tên để tìm…',
    assigneeNone: 'Không có ai khớp.',
    scheduleLocked:
      'Bạn chưa được đổi ngày bắt đầu và hạn của việc này — PM mở được ở Cấu hình dự án › Quyền đổi ngày của việc. Độ ưu tiên chỉ PM đổi.',
    priorityLocked: 'Chỉ quản lý dự án đổi được độ ưu tiên.',
    ai: {
      toggle: 'Dùng AI giao việc',
      storyPoints: 'Story point',
      estimate: 'Estimate Storypoint',
      autoAssign: 'Auto Assign',
      working: 'Đang tính…',
      why: 'Vì sao ra số điểm này',
      noEstimate:
        'Chưa có việc tương tự nào đã xong để so, nên chưa ước lượng được. Hãy tự điền story point.',
      needPoints: 'Cần story point trước — bấm Estimate Storypoint hoặc tự điền số điểm.',
      assignedTo: 'Gợi ý giao cho {{name}}.',
      pace: {
        person_one:
          'Giờ làm tính theo {{hours}} giờ/điểm — từ {{count}} việc đã xong của chính người này.',
        person_other:
          'Giờ làm tính theo {{hours}} giờ/điểm — từ {{count}} việc đã xong của chính người này.',
        project_one:
          'Giờ làm tính theo {{hours}} giờ/điểm — trung vị của dự án ({{count}} việc), vì người này chưa đủ việc đã xong.',
        project_other:
          'Giờ làm tính theo {{hours}} giờ/điểm — trung vị của dự án ({{count}} việc), vì người này chưa đủ việc đã xong.',
      },
      noPace:
        'Dự án chưa đủ việc đã xong có story point để quy ra giờ — điền Thời gian làm rồi bấm Auto Assign lại để có Hạn chót.',
      typedHours:
        'Dự án chưa có tốc độ theo story point, nên lịch xếp theo Thời gian làm bạn đã điền ({{hours}} giờ).',
      noRoom: 'Lịch 90 ngày tới không đủ chỗ trống cho số giờ này — hãy tự đặt Hạn chót.',
    },
    assigned: 'Đã đổi người làm.',
    priority: 'Ưu tiên',
    priorityName: { low: 'Thấp', medium: 'Trung bình', high: 'Cao', urgent: 'Khẩn' },
    estimate: 'Thời gian làm (giờ)',
    milestoneDate: 'Ngày mốc',
    startDate: 'Bắt đầu',
    dueDate: 'Hạn chót',
    save: 'Lưu',
    created: 'Đã tạo việc.',
    updated: 'Đã cập nhật việc.',
    hours: '{{hours}} giờ',
    breakdown: 'AI tách giúp',
    breakdownAsking: 'AI đang chia…',
    breakdownPrompt: 'Chia việc này thành các subtask làm được, kèm ước lượng giờ.',
    breakdownTitle: 'AI đề xuất chia thành:',
    breakdownFound: 'AI đề xuất {{count}} subtask',
    breakdownEmpty: 'AI không đề xuất subtask nào.',
    breakdownApply: 'Tạo {{count}} subtask đã chọn',
    breakdownAccepted: 'Đã tạo {{count}} subtask.',
    breakdownDiscard: 'Bỏ gợi ý này',
    needApprove: 'Bạn không có quyền duyệt gợi ý AI.',
  },
  /** Nhờ AI xếp lại lịch — APM-1313. */
  reschedule: {
    ask: 'Xếp lịch bằng AI',
    asking: 'AI đang cân nhắc…',
    prompt: 'Xếp lại lịch cho những việc đang mất người, giữ ngày kết thúc nếu có thể.',
    movesFound: 'AI đề xuất {{count}} thay đổi',
    noPlan: 'AI không tìm được phương án nào chạy được với đội hiện tại.',
    empty: 'Không đọc được kết quả.',
    toPerson: '→ giao cho {{name}}',
    toDates: '→ {{from}} đến {{to}}',
    apply: 'Áp dụng {{count}} thay đổi',
    applied: 'Đã áp dụng phương án. Lịch và đường găng đã tính lại.',
    discard: 'Bỏ phương án này',
    needApprove: 'Bạn không có quyền duyệt gợi ý AI.',
    shortfallTitle: 'Không xếp nổi với đội hiện tại — cần thêm:',
    needPeople: 'thêm {{people}} người {{skill}} trong {{days}} ngày',
    extendDays: 'hoặc giãn hạn {{days}} ngày',
  },
  /** Ảnh hưởng của lịch lên kế hoạch — APM-1312. */
  impact: {
    reason: {
      assignee_absent: '{{name}} nghỉ trong khoảng ngày của việc này',
      assignee_leaving: '{{name}} đã nghỉ việc trước khi việc này xong',
      commitment_shortfall: '{{name}} không đủ giờ cam kết cho việc này',
    },
    needsReassign: 'cần giao lại cho người khác',
    needsMoreDays: 'cần thêm khoảng {{days}} ngày làm việc',
    stillFits: 'còn {{hours}} giờ, vẫn kịp',
    omitted: 'Còn {{count}} việc bị ảnh hưởng nữa chưa tô — xem bảng tín hiệu ở tab RAID.',
    slip: 'Trượt {{days}} ngày — dự kiến xong {{date}}',
  },
  /** Nghỉ việc — APM-1311b. */
  offboarding: {
    label: 'Ngày cuối làm việc:',
    none: 'vẫn đang làm',
    scheduled: 'Sẽ nghỉ việc sau {{date}} — kế hoạch từ hôm sau đã tính 0 giờ.',
    done: 'Đã nghỉ việc từ sau {{date}}. Tài khoản đã khoá, dữ liệu vẫn giữ nguyên.',
    cancel: 'Huỷ nghỉ việc',
    saved: 'Đã cập nhật ngày cuối làm việc.',
    // Kế hoạch nghỉ việc — APM-OFFB-b.
    rowLabel: 'Nghỉ việc',
    planAction: 'Kế hoạch nghỉ việc…',
    editPlan: 'Sửa kế hoạch…',
    planTitle: 'Kế hoạch nghỉ việc — {{name}}',
    dayLabel: 'Ngày cuối làm việc',
    planHelp:
      'Tài khoản dùng bình thường tới hết ngày này rồi tự khoá. Từ hôm sau, kế hoạch các dự án tính họ 0 giờ.',
    impactTitle: 'Ảnh hưởng',
    noProjects: 'Không ở dự án nào đang chạy.',
    openTasks: '{{count}} việc mở',
    lastPm: 'PM cuối cùng',
    usesAiKey: 'chạy AI bằng key của họ',
    directReports: '{{count}} người đang có họ làm quản lý trực tiếp — cần người tiếp quản.',
    myFiles: '{{count}} tệp cá nhân ({{size}}) — cần người tiếp quản.',
    pendingApprovals: '{{count}} dự án đang chờ họ duyệt.',
    notifyLeader:
      'Khi lưu, hệ thống báo cho {{pms}} PM và leader {{leader}} để sắp xếp chuyển việc.',
    notifyAdmins:
      'Khi lưu, hệ thống báo cho {{pms}} PM và quản trị tổ chức (người này không có leader) để sắp xếp chuyển việc.',
    savePlan: 'Lưu kế hoạch',
    planSaved: 'Đã lưu kế hoạch nghỉ việc của {{name}}.',
    handoverLink: 'Phương án tiếp quản →',
    guestHelp:
      'Đây không phải tổ chức gốc của {{name}}, nên không đặt được ngày cuối làm việc ở đây. Chỉ có thể khoá truy cập ngay.',
  },
  /** Gỡ khỏi tổ chức — APM-ORGRM-a. */
  memberRemoval: {
    action: 'Gỡ khỏi tổ chức',
    hint: 'Người vào nhầm, chưa có việc nào thì gỡ hẳn. Người đã có việc thì đi quy trình nghỉ việc.',
    confirmRemove:
      'Gỡ {{name}} khỏi tổ chức? Họ mất quyền vào tổ chức và {{projects}} dự án, phiên đăng nhập ở đây bị thu hồi. Tài khoản của họ vẫn còn.',
    confirmRemoveAction: 'Gỡ hẳn',
    removed: 'Đã gỡ {{name}} khỏi tổ chức.',
    hasWork:
      '{{name}} đã có {{count}} việc trong tổ chức ({{open}} chưa xong), nên không gỡ hẳn được — lịch sử và báo cáo vẫn cần họ. Cho nghỉ việc với ngày cuối là hôm nay? Tài khoản tự khoá sau hôm nay; nhớ giao lại việc chưa xong.',
    hasWorkAction: 'Cho nghỉ việc từ hôm nay',
    hasWorkGuest:
      '{{name}} đã có {{count}} việc trong tổ chức ({{open}} chưa xong), nên không gỡ hẳn được. Tổ chức này không phải tổ chức gốc của họ nên không đặt được ngày cuối làm việc — khoá họ trong tổ chức ngay bây giờ?',
    hasWorkGuestAction: 'Khoá truy cập ngay',
    hasWorkIntro:
      '{{name}} đã có {{count}} việc trong tổ chức ({{open}} chưa xong), nên không gỡ hẳn được — lịch sử và báo cáo vẫn cần họ. Lên kế hoạch nghỉ việc thay thế:',
    alreadyOffboarded:
      '{{name}} đã có việc nên không gỡ hẳn được, và đã được đặt ngày cuối làm việc.',
    alreadyLocked: '{{name}} đã có việc nên không gỡ hẳn được, và đã bị khoá trong tổ chức.',
    blocker: {
      self: 'Không thể tự gỡ chính mình khỏi tổ chức.',
      super_admin: 'Không gỡ được tài khoản quản trị hệ thống.',
      last_org_admin: 'Đây là quản trị tổ chức cuối cùng. Cấp quyền quản trị cho người khác trước.',
      last_pm: 'Người này là PM cuối cùng của dự án "{{project}}". Chỉ định PM khác trước.',
    },
  },
  /** Màn tiếp quản khi nghỉ việc — APM-OFFB-f. */
  offboardingHandover: {
    title: 'Tiếp quản phần của {{name}}',
    lastDay: 'Ngày cuối làm việc: {{date}}',
    daysLeft: 'còn {{count}} ngày',
    locked: 'đã nghỉ, tài khoản đã khoá',
    helpLeader:
      'Bạn là leader của người này. Chọn tự tiếp quản hoặc giao cho một người bạn quản lý trực tiếp. Việc trong dự án do PM chuyển, không nằm ở đây.',
    helpAdmin:
      'Bạn đang làm thay với tư cách quản trị tổ chức — chọn được bất kỳ ai đang hoạt động. Việc trong dự án do PM chuyển, không nằm ở đây.',
    category: { my_files: 'Tệp của tôi', direct_reports: 'Người dưới quyền' },
    status: {
      unplanned: 'Chưa lên phương án',
      planned: 'Sẽ chuyển khi tài khoản khoá',
      done: 'Đã chuyển',
      failed: 'Chưa chuyển được',
    },
    nothing: 'Không có gì để bàn giao.',
    filesSummary: '{{count}} tệp cá nhân ({{size}}), kèm link và quyền chia sẻ của chúng.',
    reportsSummary: '{{count}} người đang có họ làm quản lý trực tiếp: {{names}}.',
    targetLabel: 'Ai tiếp quản',
    targetFor: 'Ai tiếp quản: {{group}}',
    choose: 'Chọn người nhận…',
    self: 'Tôi tiếp quản',
    none: 'Không bàn giao',
    plannedBy: 'Phương án do {{name}} lưu lúc {{at}}.',
    doneMovedFiles: 'Đã chuyển {{count}} tệp cho {{name}} lúc {{at}}.',
    doneMovedReports: 'Đã chuyển {{count}} người sang quản lý {{name}} lúc {{at}}.',
    doneSkipped: 'Đã quyết không bàn giao (lúc {{at}}).',
    failedTarget:
      'Người nhận không còn đủ điều kiện (đã nghỉ, bị khoá hoặc không đủ vai quản lý) — chọn người khác.',
    failedError: 'Có lỗi khi chuyển — chọn lại người nhận rồi lưu để chạy lại.',
    save: 'Lưu phương án',
    saved: 'Đã lưu phương án tiếp quản.',
    execute: 'Làm ngay',
    executeConfirm:
      'Chuyển ngay phần của {{name}}? Họ mất quyền với tệp của mình từ bây giờ, kể cả khi chưa tới ngày cuối.',
    executed: 'Đã chạy phương án tiếp quản.',
    whenLater: 'Phương án tự chạy khi tài khoản khoá (qua ngày cuối làm việc).',
    whenLocked: 'Tài khoản đã khoá — lưu phương án là chuyển luôn.',
    forbiddenTitle: 'Bạn không lên phương án tiếp quản được cho người này',
    forbiddenHelp: 'Chỉ leader của người nghỉ hoặc quản trị tổ chức làm được việc này.',
    notPlannedTitle: 'Người này chưa có kế hoạch nghỉ việc',
    notPlannedHelp: 'Quản trị đặt ngày cuối làm việc ở Sơ đồ tổ chức hoặc mục Người dùng trước.',
    mineTitle: 'Cần bàn giao ({{count}})',
    mineRow: 'nghỉ sau ngày {{date}} · {{count}} nhóm chưa lên phương án',
  },
  /** Nghỉ phép — APM-1311. */
  absence: {
    dayCount: '{{count}} ngày',
    partial: 'nghỉ một phần',
    working: 'đi làm',
    shifts: 'Ca xin nghỉ',
    pickShift: 'Chọn ít nhất một ca.',
    noWorkingDay: 'Khoảng ngày này không có ngày làm việc nào.',
    request: 'Yêu cầu nghỉ phép',
    requested: 'Đã gửi yêu cầu nghỉ phép.',
    submit: 'Gửi yêu cầu',
    filterUser: 'Lọc theo người',
    filterAll: 'Tất cả',
    endBeforeStart: 'Ngày kết thúc phải sau hoặc bằng ngày bắt đầu.',
    colPerson: 'Người nghỉ',
    colRole: 'Chức vụ',
    colProjects: 'Dự án',
    colFrom: 'Ngày nghỉ',
    colHours: 'Khung giờ',
    colApproval: 'Duyệt',
    colTiming: 'Tình trạng',
    allDay: 'Cả ngày',
    approve: 'Duyệt',
    approval: {
      pending: 'Chờ duyệt',
      approved: 'Đã duyệt',
    },
    timing: {
      past: 'Đã xong',
      current: 'Đang nghỉ',
      upcoming: 'Sắp nghỉ',
    },
    noneOrg: 'Chưa có đợt nghỉ nào',
    noneOrgHelp: 'Khi có người khai nghỉ, đợt nghỉ sẽ hiện ở đây.',
    title: 'Nghỉ phép',
    subtitle:
      'Khai những ngày bạn không làm việc. Có hiệu lực ngay, không cần chờ duyệt — kế hoạch của các dự án sẽ tự trừ ra.',
    adminTitle: 'Nghỉ phép',
    pageSubtitle: 'Đơn xin nghỉ của bạn, của nhóm bạn quản lý, hoặc của cả tổ chức — tuỳ vai trò.',
    pickUser: 'Chọn người',
    pickUserNone: 'Chưa chọn ai',
    adminSubtitle: 'Khai nghỉ hộ người này. Cùng tác dụng như họ tự khai.',
    from: 'Từ ngày',
    to: 'Đến ngày',
    kind: 'Loại',
    kindName: { leave: 'Nghỉ phép', sick: 'Nghỉ ốm', other: 'Khác' },
    byHour: 'Nghỉ theo giờ',
    start: 'Từ giờ',
    end: 'Đến giờ',
    note: 'Ghi chú',
    notePlaceholder: 'Ghi chú (không bắt buộc)',
    declare: 'Khai nghỉ',
    declared: 'Đã khai nghỉ. Kế hoạch đã trừ những ngày này.',
    retract: 'Rút lại đợt nghỉ này',
    retracted: 'Đã rút lại đợt nghỉ.',
    empty: 'Chưa khai đợt nghỉ nào.',
    hours: '{{hours}} giờ',
    preview: 'Đợt nghỉ này trừ {{hours}} giờ khỏi lịch của bạn.',
    previewNoWorkday: 'Khoảng này không có ngày làm việc nào của bạn — không trừ giờ nào.',
    hourSingleDayOnly:
      'Nghỉ theo giờ chỉ khai được cho một ngày. Nhiều ngày mà chỉ nghỉ buổi thì khai từng ngày.',
  },

  /** Hồ sơ tổ chức — APM-ORGP-b. */
  orgProfile: {
    title: 'Hồ sơ tổ chức',
    subtitle: 'Tên, mô tả và lời chào mà người được mời thấy trước khi gia nhập.',
    hint: 'Những thông tin này hiện trên trang lời mời, trang ai cầm link cũng xem được. Để trống ô nào thì ô đó không hiện.',
    field: {
      name: 'Tên tổ chức',
      industry: 'Lĩnh vực hoạt động',
      website: 'Website',
      logoUrl: 'Logo (URL ảnh)',
      description: 'Mô tả',
      welcomeMessage: 'Lời chào người mới',
    },
    industryPlaceholder: 'Phần mềm, bán lẻ, giáo dục…',
    descriptionPlaceholder: 'Tổ chức làm gì, đội ngũ thế nào.',
    welcomePlaceholder: 'Câu chào người vừa nhận lời mời.',
    invalidName: 'Tên tổ chức cần ít nhất 2 ký tự.',
    invalidUrl: 'Website và logo phải là địa chỉ bắt đầu bằng http:// hoặc https://.',
    previewTitle: 'Người được mời sẽ thấy',
    previewHelp:
      'Lời nhắn riêng của từng link hiện ngay dưới tên người mời. Số thành viên hiện trên trang lời mời thật.',
    saved: 'Đã lưu hồ sơ tổ chức',
    savedRenamed: 'Đã lưu hồ sơ tổ chức. Tên mới hiện ở thanh trên sau khi tải lại trang.',
  },

  /** Lịch nghỉ lễ của tổ chức — APM-1311. */
  orgWorkSchedule: {
    title: 'Thời gian làm việc mặc định',
    subtitle:
      'Lịch cho mọi người chưa khai lịch riêng, kể cả người vào tổ chức sau này. Ai đã có lịch riêng thì giữ nguyên; vẫn sửa riêng được cho từng người ở mục Người dùng.',
  },
  orgTimezone: {
    title: 'Múi giờ',
    subtitle: 'Giờ trong lịch làm việc và ranh giới "hôm nay" được hiểu theo múi giờ này.',
    hint: 'Đổi múi giờ là dời ca làm việc của cả tổ chức: nút bấm giờ, giờ làm thêm và bảng tuần đều tính lại theo giá trị mới.',
    label: 'Múi giờ của tổ chức',
    nowThere: 'Bây giờ ở đó: {{at}}',
    saved: 'Đã lưu múi giờ',
  },
  timerReminder: {
    title: 'Nhắc bấm giờ',
    subtitle: 'Nhắc qua Telegram khi đầu ca mà chưa bấm giờ, kèm nút xin nghỉ nhanh.',
    hint: 'Ai tới đầu ca mà chưa bấm giờ sẽ nhận một tin Telegram, kèm hai nút xin nghỉ khung giờ đó hoặc cả ngày. Chỉ người đã liên kết Telegram mới nhận; ngày nghỉ, ngày lễ và giờ đã khai nghỉ thì không nhắc.',
    enabled: 'Bật nhắc bấm giờ',
    roles: 'Vai trò nhận nhắc',
    rolesHint: 'Vai trò trong tổ chức, không phải vai trò trong dự án.',
    delay: 'Nhắc sau đầu ca (phút)',
    delayHint: 'Từ 0 đến 60 phút. Tin có thể tới muộn thêm tối đa 5 phút.',
    excluded: 'Người không nhận nhắc',
    excludedHint: 'Những người không chấm công theo giờ chuẩn.',
    noneExcluded: 'Chưa loại trừ ai.',
    addExcluded: '+ Thêm người không nhận nhắc…',
    removeExcluded: 'Bỏ {{name}} khỏi danh sách',
    unknownUser: 'Người đã rời tổ chức',
    saved: 'Đã lưu cấu hình nhắc bấm giờ',
  },
  holiday: {
    title: 'Lịch nghỉ lễ',
    subtitle: 'Ngày nghỉ của cả tổ chức. Trần năng lực của mọi người tự trừ những ngày này.',
    date: 'Ngày',
    name: 'Tên ngày lễ',
    namePlaceholder: 'Quốc khánh, Tết…',
    add: 'Thêm',
    remove: 'Bỏ ngày này khỏi lịch nghỉ lễ',
    empty: 'Chưa có ngày nghỉ lễ nào.',
  },
  /** Cam kết theo dự án — APM-1310b. */
  commitment: {
    label: 'Cam kết cho dự án này:',
    unit: 'Đơn vị',
    unitName: { hours: 'giờ/ngày', percent: '% lịch làm việc' },
    value: { hours: '{{value}} giờ/ngày', percent: '{{value}}% lịch làm việc' },
    notSet: 'chưa đặt',
    save: 'Lưu',
    saved: 'Đã cập nhật cam kết.',
    alsoIn: 'Người này còn cam kết ở {{count}} dự án khác.',
    overflow:
      'Đã cam kết {{committed}}/{{capacity}} giờ {{weekday}}, vượt lịch làm việc — cộng cả {{count}} dự án khác.',
    willOverflow:
      'Đặt số này thì thành {{committed}}/{{capacity}} giờ {{weekday}}, vượt lịch làm việc — cộng cả {{count}} dự án khác.',
    hiddenProjects: '+{{count}} dự án bạn không xem được',
    baselineDefault: '· người này chưa khai lịch, đang tính theo mặc định T2–T6 tám tiếng',
    weekday: {
      0: 'Chủ nhật',
      1: 'thứ Hai',
      2: 'thứ Ba',
      3: 'thứ Tư',
      4: 'thứ Năm',
      5: 'thứ Sáu',
      6: 'thứ Bảy',
    },
  },
  /** Link mời vào dự án — APM-1317b. */
  invite: {
    apply: 'Đăng ký tham gia',
    applied: 'Đã gửi đăng ký. Quản lý dự án sẽ chốt lại vai trò và thời lượng rồi trả lời bạn.',
    wantRole: 'Vai trò mong muốn',
    pmDecides:
      'Đây là nguyện vọng. Quản lý dự án có thể đổi vai trò, khoảng ngày và thời lượng trước khi chấp nhận.',
    projectPeriod: 'Thời gian dự án: {{from}} → {{to}}',
    openEnded: 'không có ngày kết thúc',
    sectionTitle: 'Mời thành viên vào dự án',
    sectionSubtitle:
      'Người trong tổ chức mở link, đăng nhập và gửi đăng ký kèm nguyện vọng vai trò, khoảng ngày, thời lượng. Đơn về mục Đơn đăng ký bên dưới để bạn chốt. Link không tạo tài khoản mới.',
    create: 'Tạo link mời',
    recreate: 'Tạo link mới',
    revoke: 'Thu hồi',
    revoked: 'Đã thu hồi link mời.',
    copy: 'Sao chép',
    copied: 'Đã sao chép',
    copyFailed: 'Không chép tự động được — bôi đen link rồi chép tay giúp nhé.',
    none: 'Chưa có link nào đang dùng được.',
    expiresAt: 'Hết hạn ngày {{date}}.',
    onceWarning:
      'Chuỗi này chỉ hiện MỘT lần — hệ thống chỉ lưu bản băm. Sao chép ngay; tạo link mới sẽ thu hồi link cũ.',
    openProject: 'Mở dự án',
    backToProjects: 'Về danh sách dự án',
    acceptInvitation: 'Nhận lời',
    declineAtHome:
      'Muốn từ chối thì vào mục Lời mời của tôi ở trang chủ — ở đó bạn ghi được lý do.',
    status: {
      pending_request: 'Bạn đã đăng ký, đang chờ duyệt',
      invited: 'Quản lý dự án đã mời bạn',
      ok: 'Bạn được mời vào dự án này',
      already_member: 'Bạn đã ở trong dự án này',
      expired: 'Link mời đã hết hạn',
      revoked: 'Link mời đã bị thu hồi',
      not_found: 'Link mời không dùng được',
    },
    help: {
      pending_request:
        'Quản lý dự án sẽ chốt vai trò và thời lượng rồi trả lời. Không cần gửi lại.',
      invited:
        'Lời mời đang chờ bạn trả lời. Nhận lời là bạn vào dự án ngay, với vai trò quản lý dự án đã chọn.',
      ok: 'Chọn vai trò và thời lượng bạn mong muốn rồi gửi đăng ký.',
      already_member: 'Không cần làm gì thêm.',
      expired: 'Link chỉ có hiệu lực 7 ngày. Hỏi quản lý dự án một link mới.',
      revoked: 'Quản lý dự án đã thu hồi link này. Hỏi họ một link mới.',
      not_found:
        'Link sai, hoặc thuộc một tổ chức khác. Kiểm tra lại đường dẫn, hoặc hỏi người gửi.',
    },
  },
  approval: {
    title: 'Chờ bạn duyệt ({{count}})',
    subtitle: 'Người trong nhóm bạn quản lý vừa mở dự án mới. Duyệt thì dự án bắt đầu chạy.',
    noDescription: 'Người tạo chưa viết mô tả.',
    approve: 'Duyệt',
    reject: 'Từ chối',
    confirmReject: 'Xác nhận từ chối',
    notePlaceholder: 'Vì sao không duyệt? Người tạo sẽ đọc được.',
    needNote: 'Nhập lý do trước đã — từ chối im lặng thì người tạo sẽ mở lại một dự án gần giống.',
    approved: 'Đã duyệt. Dự án bắt đầu chạy.',
    rejected: 'Đã từ chối, kèm lý do.',
    // Director / quản trị thấy cả tổ chức — APM-ROLE-m3.
    titleOrg: 'Dự án chờ duyệt ({{count}})',
    subtitleOrg:
      'Dự án chờ bạn duyệt đứng đầu. Các dự án còn lại đang chờ quản lý trực tiếp — bạn có thể duyệt thay khi họ vắng.',
    requestedBy: '{{name}} mở',
    onBehalf: 'Đang chờ {{name}} duyệt — bạn đang duyệt thay',
  },
  handOverPm: {
    title: 'Bàn giao vai PM',
    subtitle: 'Chuyển vai PM cho một thành viên khác trong dự án.',
    help: 'Chuyển vai PM của bạn cho một thành viên khác. Bạn sẽ trở thành Thành viên, và họ trở thành PM — cả hai đổi cùng lúc, nên dự án không có lúc nào thiếu PM.',
    field: 'Bàn giao cho',
    placeholder: '— chọn thành viên —',
    action: 'Bàn giao',
    sending: 'Đang bàn giao…',
    done: 'Đã bàn giao. Bạn không còn là PM của dự án này.',
    noCandidates:
      'Chưa có ai để bàn giao. Thêm thành viên vào dự án trước — bàn giao chỉ chuyển vai giữa những người đã ở trong dự án.',
  },
  stopProject: {
    title: 'Dừng dự án bảo trì',
    subtitle: 'Đóng một dự án bảo trì và ghi lại ngày kết thúc.',
    help: 'Dự án bảo trì không có ngày kết thúc — nó chạy tới khi bạn dừng. Ngày dừng sẽ được ghi lại làm ngày kết thúc của dự án.',
    action: 'Dừng dự án',
    confirm:
      'Dừng thì dự án chuyển sang trạng thái đã hoàn thành và biến mất khỏi danh sách đang chạy của cả đội. Mở lại được ở ô trạng thái, nhưng trong lúc đó mọi người đã thấy nó biến mất.',
    confirmAction: 'Vẫn dừng',
    stopping: 'Đang dừng…',
    done: 'Đã dừng dự án. Ngày hôm nay được ghi làm ngày kết thúc.',
  },
  archiveProject: {
    title: 'Lưu trữ dự án',
    subtitle: 'Cất dự án tạo nhầm, dừng giữa chừng hoặc bị huỷ.',
    help: 'Dùng cho dự án không đi tới hoàn thành: tạo nhầm, dừng giữa chừng hoặc bị huỷ. Dự án rời khỏi danh sách đang chạy; việc, sprint và tài liệu vẫn giữ nguyên.',
    action: 'Lưu trữ dự án',
    reasonLabel: 'Lý do lưu trữ',
    reason: {
      created_by_mistake: 'Tạo nhầm',
      stopped: 'Dừng giữa chừng',
      cancelled: 'Bị huỷ',
    },
    notePlaceholder: 'Ghi chú thêm (không bắt buộc)',
    confirm:
      'Lưu trữ thì dự án biến khỏi danh sách đang chạy của cả đội, việc định kỳ ngừng sinh việc mới. Bạn có thể mở lại ở đây bất cứ lúc nào.',
    confirmAction: 'Lưu trữ',
    disconnect: {
      title: 'Ngắt kết nối ra ngoài',
      help: 'Lưu trữ không tự ngắt những thứ dưới đây. Mặc định giữ nguyên — mở lại dự án là dùng tiếp được; thứ đã ngắt thì phải thiết lập lại.',
      sync: 'Nguồn đồng bộ: {{sources}}',
      syncLabel: 'Làm gì với nguồn đồng bộ',
      syncChoice: {
        keep: 'Giữ nguyên',
        disconnect: 'Ngắt kết nối',
        release: 'Ngắt & giải phóng',
      },
      syncHelp: {
        keep: 'Đồng bộ tự dừng khi dự án đã lưu trữ và chạy tiếp khi mở lại. Dự án ngoài vẫn được giữ cho dự án này.',
        disconnect:
          'Ngừng đồng bộ hẳn. Dự án ngoài vẫn được giữ cho dự án này — chưa nối được với dự án khác.',
        release:
          'Ngừng đồng bộ và trả dự án ngoài: nó nối được với một dự án khác. Việc đã kéo về và liên kết vẫn ở lại.',
      },
      shareLinks: 'Thu hồi {{count}} link chia sẻ công khai của Sổ chốt phương án',
      inviteLinks: 'Thu hồi {{count}} link mời vào dự án',
      guests: 'Gỡ {{count}} khách khỏi dự án',
      guestsKept:
        '{{count}} khách còn việc chưa xong sẽ không bị gỡ — chuyển việc trước nếu muốn gỡ.',
    },
    archiving: 'Đang lưu trữ…',
    done: 'Đã lưu trữ dự án.',
    archivedTitle: 'Dự án đã lưu trữ',
    archivedHelp:
      'Dự án đang được cất. Mở lại sẽ đưa nó về đúng trạng thái trước khi lưu trữ (nếu không biết thì về Tạm dừng).',
    restore: 'Mở lại dự án',
    restoring: 'Đang mở lại…',
    restored: 'Đã mở lại dự án.',
  },
  createProject: {
    settingUp: 'Đang thiết lập dự án…',
    title: 'Dự án mới',
    key: 'Mã',
    name: 'Tên dự án',
    namePlaceholder: 'Website bán hàng',
    description: 'Vấn đề & objectives',
    descriptionPlaceholder:
      'Dự án này giải quyết việc gì, và xong nghĩa là gì? Người duyệt sẽ đọc phần này.',
    methodology: 'Phương pháp',
    manager: 'Quản lý trực tiếp của bạn',
    managerPlaceholder: '— chọn người duyệt —',
    managerHelp:
      'Bạn chưa khai quản lý trực tiếp. Người bạn chọn sẽ duyệt dự án này, và được lưu vào hồ sơ của bạn.',
    willBeApprovedBy: 'Dự án sẽ chờ {{name}} duyệt trước khi bắt đầu.',
    submit: 'Tạo dự án',
    needKeyAndName: 'Cần có mã và tên dự án.',
    needManager: 'Chọn người duyệt trước đã.',
    created: 'Đã tạo dự án.',
    sentForApproval: 'Đã gửi. Dự án sẽ chạy sau khi được duyệt.',
  },
  leaveProject: {
    title: 'Rời dự án',
    subtitle: 'Bạn vẫn ở công ty, chỉ không còn tham gia dự án này.',
    action: 'Rời dự án',
    confirmTitle: 'Rời dự án này?',
    warning:
      'Bạn còn {{count}} việc chưa xong. Rời đi thì chúng về trạng thái chưa giao và quản lý dự án phải tìm người khác.',
    noTasks: 'Bạn không còn việc nào chưa xong trong dự án này.',
    more: '…và {{count}} việc nữa.',
    due: 'hạn {{date}}',
    lastPm:
      'Bạn là quản lý dự án cuối cùng. Chỉ định một người khác làm quản lý rồi mới rời được — nếu không, dự án còn lại sẽ không ai có quyền giao việc hay thêm người.',
    confirm: 'Vẫn rời dự án',
    left: 'Đã rời dự án.',
    leftWithTasks:
      'Đã rời dự án. {{count}} việc về trạng thái chưa giao, quản lý dự án đã được báo.',
  },
  retro: {
    title: 'Review & Retrospective',
    help: 'Sprint đóng lại mà không ghi gì thì lần sau đội nêu đúng điều cũ.',
    goalOutcome: 'Mục tiêu sprint:',
    summaryPlaceholder: 'Đã giao được gì, và điều gì đáng nói…',
    addPlaceholder: 'Thêm một dòng rồi Enter…',
    toTask: 'Biến thành việc',
    markDone: 'Đánh dấu đã làm',
    reopen: 'Mở lại',
    drop: 'Quyết không làm',
    remove: 'Xoá dòng',
    outcome: { met: 'Đạt', partial: 'Đạt một phần', missed: 'Trượt' },
    kind: { keep: 'Giữ', drop: 'Bỏ', try_it: 'Thử' },
    kindHelp: {
      keep: 'Cách làm đã hiệu quả, đừng bỏ.',
      drop: 'Cách làm gây hại, dừng lại.',
      try_it: 'Điều đội quyết đổi ở sprint sau — dòng này biến thành việc được.',
    },
  },
  taskStatusRules: {
    title: 'Quyền đổi trạng thái',
    subtitle: 'Ai được kéo việc giữa các cột, và ai được chuyển việc sang hoàn thành.',
    statusChangeLabel: 'Ai được đổi trạng thái việc',
    statusChange: {
      members: 'Mọi thành viên (trừ vai trò Chỉ xem)',
      assignee_or_creator: 'Chỉ người được giao việc hoặc người tạo việc',
      roles: 'Chỉ các vai trò đã chọn',
    },
    doneLabel: 'Ai được chuyển việc sang hoàn thành',
    done: {
      pm: 'Chỉ PM',
      roles_and_pm: 'Các vai trò đã chọn và PM',
      assignee_or_creator_and_pm: 'Người được giao việc hoặc người tạo việc, và PM',
      not_assignee_and_pm: 'Người khác người được giao việc (nghiệm thu bởi người thứ hai), và PM',
      anyone: 'Bất cứ ai đổi được trạng thái việc đó',
    },
    pmNote:
      'PM và quản trị tổ chức luôn làm được. Chỉ áp cho đổi trạng thái — quyền sửa nội dung việc giữ nguyên.',
    doneNote:
      'Áp cả khi mở lại một việc đã hoàn thành. Người chuyển sang hoàn thành phải được đổi trạng thái việc đó ở rule trên.',
    rolesLabel: 'Vai trò được phép',
    noRoles: 'Chưa chọn vai trò nào — chỉ PM làm được.',
    save: 'Lưu',
    saved: 'Đã lưu quyền đổi trạng thái.',
  },
  // Thời gian tối thiểu trước khi hoàn thành — APM-TMIN-b.
  storyPointAnchor: {
    title: 'Neo story point',
    subtitle: '1 story point to cỡ nào — để mọi người chọn điểm theo cùng một thước đo.',
    hint: 'Story point vẫn là khối lượng việc; neo chỉ nói một điểm to cỡ nào. Khi ước lượng, hộp thoại đưa việc mốc lên đầu: việc 1 SP của chính người làm, không có thì việc 1 SP hoặc việc do người bậc này làm xong trong khoảng số giờ ấy (±25%), cùng loại việc. Giờ/điểm của velocity và hiệu suất vẫn đo từ dữ liệu thật — đổi neo không sửa số cũ.',
    level: 'Bậc',
    hours: 'Số giờ',
    preview: '1 story point ≈ công một người {{level}} làm trong {{hours}} giờ.',
    noLevelNote: 'Người chưa được xếp bậc không bao giờ là mốc theo bậc — xếp bậc ở mục Người dùng.',
    save: 'Lưu',
    saved: 'Đã lưu neo story point.',
  },
  // Gắn cập nhật tiến độ với commit — APM-PCOM, docs/plan-progress-commits.md.
  progressCommits: {
    headingChecklist: 'Tick: {{text}}',
    headingCompleted: 'Hoàn thành: {{title}}',
    reported_one: 'Đã gắn {{count}} commit',
    reported_other: 'Đã gắn {{count}} commit',
    reportFailed: 'Thao tác đã lưu nhưng chưa gắn được commit: {{reason}}',
    dialog: {
      title: 'Chọn commit cho cập nhật này',
      help: 'Chọn nhánh trước, rồi tích các commit ứng với phần việc vừa làm. Không có commit (họp, tài liệu…) thì bấm "Không có commit".',
      branchStep: '1. Nhánh',
      commitStep: '2. Commit',
      lastCommitAt: 'Commit cuối: {{at}}',
      pickedOnBranch: '{{count}} đã chọn',
      noBranch: 'Không có nhánh nào.',
      matchesTask: 'nhánh của việc này',
      defaultBranch: 'mặc định',
      pickBranch: 'Chọn một nhánh để xem commit.',
      loadingCommits: 'Đang đọc commit từ máy chủ git…',
      showOthers: 'Hiện commit của người khác',
      noCommits: 'Nhánh này chưa có commit nào.',
      noneMine: 'Chưa thấy commit nào của bạn trên nhánh này.',
      mapEmailHint: 'Commit ký bằng email git khác với email tài khoản? Nhờ PM gắn email đó ở Cấu hình Git › Tuỳ chọn › Tài khoản git, hoặc bật "Hiện commit của người khác".',
      alreadyLinked: 'đã gắn',
      skip: 'Không có commit',
      submit_one: 'Gắn {{count}} commit',
      submit_other: 'Gắn {{count}} commit',
    },
    settings: {
      title: 'Gắn cập nhật tiến độ với commit',
      howItWorks: 'Khi tick checklist, đóng việc hoặc kéo việc sang Xong (kể cả kéo tiến độ lên 100%), hộp chọn nhánh → commit hiện ra để người làm gắn các commit của mình. Bỏ qua được bằng "Không có commit". Kéo % tiến độ chưa tới 100 thì không hỏi.',
      noRepository: 'Cần nối kho git và dán access key trước khi bật.',
      connectionUnusable: 'Token của các kho đang gắn không dùng được — thay token trước khi bật.',
      openGit: 'Cấu hình Git',
      managerOnly: 'Chỉ người quản lý Git của dự án (PM) đổi được.',
      saved: 'Đã lưu cấu hình gắn commit',
    },
    block: {
      title: 'Commit đã báo',
      checklist: 'Tick "{{text}}"',
      completed: 'Hoàn thành',
      skipped: 'Báo không kèm commit',
      emptied: 'Đã gỡ hết commit',
      remove: 'Gỡ commit {{sha}}',
      removed: 'Đã gỡ commit',
    },
    chip_one: '{{count}} commit',
    chip_other: '{{count}} commit',
    review: {
      label: 'AI rà:',
      verdict: {
        related: 'Liên quan',
        partial: 'Liên quan một phần',
        unrelated: 'Không liên quan',
      },
      status: {
        pending: 'Đang rà…',
        failed: 'Không rà được',
        skipped: 'Bỏ qua (AI tắt hoặc hết hạn mức)',
      },
      basedOn: {
        diff: 'Dựa trên mã thay đổi',
        message: 'Chỉ dựa trên lời commit, không đọc mã',
      },
      readStats: 'đã đọc {{read}}/{{files}} tệp, {{kb}} KB',
      mapOnly: 'chỉ cần xem danh sách {{files}} tệp đổi, không phải đọc mã',
      suggestionOnly: 'AI gợi ý — tham khảo, việc không bị đổi gì',
      commitTitle: 'tiêu đề commit',
      acknowledge: 'Đã xem',
      acknowledged: '{{name}} đã xem lúc {{at}}',
      retry: 'Rà lại',
      badge: {
        short: 'Commit?',
        title: 'AI rà commit đã báo: {{verdict}}',
      },
      indicator: {
        title_one: '{{count}} lượt AI đang rà commit',
        title_other: '{{count}} lượt AI đang rà commit',
        hint: 'AI đang đọc commit bạn vừa báo, chạy ngầm — việc của bạn không phải chờ.',
        item: 'Tick "{{item}}"',
        completed: 'Hoàn thành việc',
        since_one: 'từ {{count}} phút trước',
        since_other: 'từ {{count}} phút trước',
      },
      toast: {
        related: 'AI rà xong {{task}}: commit liên quan',
        partial: 'AI rà xong {{task}}: commit chỉ liên quan một phần — PM sẽ xem',
        unrelated: 'AI rà xong {{task}}: commit có vẻ không liên quan — PM sẽ xem',
        notReviewed: 'Không rà được commit của {{task}} — mở việc để rà lại',
      },
      settings: {
        title: 'AI rà commit có khớp việc không',
        howItWorks:
          'Sau mỗi lần báo commit, AI đọc phần thay đổi (chỉ ở kho đã bật "AI đọc mã") và so với mục / việc. Thấp thì nhãn nhỏ trên thẻ + báo PM; việc không bị đổi gì. Mỗi lần báo là một lượt AI, tính vào hạn mức của người báo.',
        needsCommits: 'Bật "Gắn cập nhật tiến độ với commit" trước.',
        needsAi: 'Tổ chức chưa cấu hình trợ lý AI.',
      },
    },
  },
  taskPlanGate: {
    settings: {
      title: 'Bắt buộc có hạn và ước lượng trước khi làm',
      subtitle:
        'Việc chưa có hạn hoặc chưa ước lượng số giờ thì không chuyển sang Đang làm hay Hoàn thành được.',
      enable: 'Bật',
      howItWorks:
        'Ai cố chuyển sẽ thấy hộp thoại điền nhanh phần còn thiếu; số giờ ước lượng dựa trên một việc cũ đã làm thật. Mốc (milestone) và thay đổi do hệ thống (đồng bộ, luật git) không bị chặn.',
      save: 'Lưu',
      saved: 'Đã lưu',
    },
    bulkHeld_one: '{{count}} việc còn thiếu hạn hoặc ước lượng nên chưa chuyển — mở từng việc để điền.',
    bulkHeld_other: '{{count}} việc còn thiếu hạn hoặc ước lượng nên chưa chuyển — mở từng việc để điền.',
    dialog: {
      title: 'Chưa đủ thông tin để bắt đầu',
      body: 'Việc "{{title}}" cần có hạn và ước lượng số giờ trước khi chuyển sang Đang làm hay Hoàn thành. Điền phần còn thiếu dưới đây.',
      dueLabel: 'Hạn hoàn thành',
      dueAskPm: 'Bạn không được đặt hạn cho việc này — nhờ PM đặt hạn rồi chuyển lại.',
      estimateLabel: 'Ước lượng số giờ',
      loading: 'Đang tìm việc tương tự đã làm…',
      noReference: 'Chưa có việc tương tự nào đã xong để so — nhập số giờ ước lượng.',
      manualHours: 'Số giờ',
      manualPoints: 'Story point',
      optional: '(không bắt buộc)',
      chooseManual: 'Tự điền số SP',
      chooseManualHint: 'Không so với việc nào ở trên — điền thẳng số story point và số giờ.',
      chooseManualHintGate: 'Không so với việc nào ở trên — điền thẳng số giờ, kèm story point nếu có.',
      chosenReference: 'Việc mẫu đã chọn',
      repick_one: 'Chọn lại',
      repick_other: 'Chọn lại ({{count}} việc)',
      pickOne: 'Việc đã làm giống nhất — đọc lại xem việc này so với nó thế nào.',
      pickMany: 'Chọn việc đã làm giống nhất — đọc mô tả và checklist để so.',
      pickRecent:
        'Chưa có việc nào tương tự đã xong — đây là các việc làm xong gần đây. Chọn một việc làm mốc rồi đánh giá việc này tốn hơn hay ít hơn bao nhiêu.',
      tierAssignee: 'Việc người được giao đã làm trong dự án này.',
      tierProject: 'Người được giao chưa có việc nào đã xong ở dự án này — đây là việc của người khác trong dự án.',
      tierOrg: 'Dự án này chưa có việc nào đã xong để so — đây là việc ở dự án khác.',
      ratioLabel: 'Việc này tốn thời gian so với việc mẫu:',
      less: 'Ít hơn',
      more: 'Nhiều hơn',
      actual: 'thực tế {{hours}} giờ',
      spShort_one: '{{count}} SP',
      spShort_other: '{{count}} SP',
      noSpShort: 'chưa có SP',
      resultLabel: 'Story point của việc này',
      resultEdit: 'Sửa số',
      resultUseComputed: 'Dùng số tính được',
      resultHours: 'Giờ ước lượng',
      hoursAuto: 'Giờ tự tính theo tốc độ {{level}} của người được giao — sửa được.',
      hoursAutoNoLevel: 'Giờ tự tính theo tốc độ của người được giao — sửa được.',
      hoursAfterAssign: 'Việc chưa giao ai — giờ sẽ tự tính theo bậc người được giao khi giao.',
      hoursNeedAssign: 'Việc chưa giao ai — điền giờ để bắt đầu, hoặc giao việc trước.',
      spConverted: '≈{{value}} SP (quy đổi)',
      spConvertedHint: 'Việc này chưa có SP. Quy đổi từ giờ thật theo neo 1 SP ≈ {{level}} làm {{hours}} giờ, người làm: {{doer}}.',
      doerUnleveled: 'chưa xếp bậc (tính như mức chuẩn)',
      anchorLine: 'Mốc của tổ chức: 1 story point ≈ công một người {{level}} làm trong {{hours}} giờ. Việc mốc đứng đầu danh sách.',
      anchorOwn: 'Mốc · việc 1 SP của chính người làm',
      anchorOnePoint: 'Mốc · việc 1 SP',
      anchorLevelHours: 'Mốc · {{level}} làm xong trong {{hours}} giờ (≈1 SP)',
      calibration_one:
        '{{count}} lần gần nhất bạn ước lượng theo việc mẫu: bạn chọn trung bình {{chosen}}, thực tế là {{actual}}.',
      calibration_other:
        '{{count}} lần gần nhất bạn ước lượng theo việc mẫu: bạn chọn trung bình {{chosen}}, thực tế là {{actual}}.',
      moreItems: '… và {{count}} mục khác',
      later: 'Để sau',
      save: 'Lưu và tiếp tục',
      step: 'Bước {{current}}/{{total}} · {{label}}',
      next: 'Tiếp',
      back: 'Quay lại',
      estimateTitle: 'Ước lượng story point',
      estimateBody:
        'Chọn một việc đã làm thật để so với "{{title}}", rồi kéo xem việc này tốn hơn hay ít hơn bao nhiêu phần trăm.',
      ownSectionShort: 'Việc ≈1 SP của chính người làm',
      ownEmpty: 'Chưa có việc nào như thế đã xong trong dự án — so với việc tương tự bên dưới.',
      ownNearHours: '≈1 SP theo tốc độ {{level}} ({{hours}} giờ)',
      levelStandard: 'mức chuẩn',
      similarSection: 'Việc tương tự',
      similarEmpty: 'Không có thêm việc tương tự nào để so.',
      saveEstimate: 'Lưu ước lượng',
    },
  },
  taskMinDuration: {
    unit: {
      days_one: '{{count}} ngày',
      days_other: '{{count}} ngày',
      hours_one: '{{count}} giờ',
      hours_other: '{{count}} giờ',
      minutes_one: '{{count}} phút',
      minutes_other: '{{count}} phút',
    },
    dialog: {
      title: 'Chưa thể hoàn thành việc này',
      body: 'Dự án yêu cầu một việc phải được làm ít nhất {{min}} kể từ lúc bắt đầu. «{{title}}» bắt đầu lúc {{start}}, nên chỉ hoàn thành được từ {{earliest}}.',
      declareLabel: 'Bạn đã bắt đầu làm từ trước? Khai giờ bắt đầu thực tế',
      declareHelp: 'Mốc khai tay được ghi lại kèm tên bạn và gắn nhãn "khai tay" ở chi tiết việc.',
      future: 'Giờ bắt đầu không được ở tương lai.',
      tooOld: 'Chỉ được lùi giờ bắt đầu tối đa {{days}} ngày.',
      stillTooSoon: 'Với giờ này, việc vẫn chỉ hoàn thành được từ {{earliest}}.',
      later: 'Để sau',
      declare: 'Khai giờ và hoàn thành',
    },
    settings: {
      title: 'Thời gian tối thiểu trước khi hoàn thành',
      subtitle: 'Không cho chuyển một việc sang Xong khi nó chưa được làm đủ lâu kể từ lúc bắt đầu.',
      enable: 'Bật thời gian tối thiểu',
      amountLabel: 'Tối thiểu',
      unitLabel: 'Đơn vị',
      unitMinutes: 'Phút',
      unitHours: 'Giờ',
      invalid: 'Nhập một số nguyên dương, tối đa {{max}} ngày.',
      howItWorks: 'Tính từ giờ bắt đầu thực tế (lần đầu sang "Đang làm"), chưa có thì từ lúc tạo việc. Áp cho mọi người kể cả PM, ở bảng, danh sách, Cập nhật nhanh và Mini App Telegram. Người quên chuyển "Đang làm" có thể khai lại giờ bắt đầu khi hoàn thành. Mốc (milestone) không áp.',
      save: 'Lưu',
      saved: 'Đã lưu thời gian tối thiểu',
    },
    bulkHeld_one: '{{count}} việc chưa đủ thời gian tối thiểu nên chưa chuyển — mở từng việc để khai giờ bắt đầu.',
    bulkHeld_other: '{{count}} việc chưa đủ thời gian tối thiểu nên chưa chuyển — mở từng việc để khai giờ bắt đầu.',
    declared: 'khai tay',
    declaredHint: 'Giờ bắt đầu do người làm tự khai lúc hoàn thành, không phải hệ thống ghi.',
  },
  taskScheduleRules: {
    title: 'Quyền đổi ngày của việc',
    subtitle: 'Ai được đổi ngày bắt đầu và hạn của việc (cả kéo trên Gantt).',
    label: 'Ai được đổi ngày bắt đầu và hạn',
    option: {
      pm: 'Chỉ PM',
      assignee_or_creator: 'Người được giao việc hoặc người tạo việc, và PM',
      roles: 'Các vai trò đã chọn và PM',
    },
    pmNote:
      'PM và quản trị tổ chức luôn đổi được. Chỉ áp cho ngày — độ ưu tiên vẫn chỉ PM đổi; thành viên vẫn chỉ sửa được việc của mình.',
    rolesLabel: 'Vai trò được phép',
    noRoles: 'Chưa chọn vai trò nào — chỉ PM đổi được.',
    save: 'Lưu',
    saved: 'Đã lưu quyền đổi ngày của việc.',
  },
  standards: {
    title: 'Quy chuẩn của dự án này',
    subtitle: 'Hạng mục dài tối đa bao nhiêu ngày, và báo trước hạn mấy ngày.',
    help: 'Hai số dưới đây kế thừa theo hai kiểu khác nhau — đọc dòng gợi ý dưới mỗi ô.',
    wbsMaxDays: 'Hạng mục dài tối đa (ngày)',
    wbsMaxDaysHint:
      'Chép từ mặc định tổ chức lúc tạo dự án. Đổi mặc định về sau không đụng tới dự án này.',
    dueSoonDays: 'Báo trước hạn (ngày)',
    dueSoonInherited:
      'Đang kế thừa mặc định tổ chức ({{days}} ngày). Nhập số để dự án này tự quyết.',
    dueSoonOwn: 'Dự án này tự quyết. Xoá trắng để quay về mặc định tổ chức.',
  },
  sprintEdit: {
    title: 'Sửa {{name}}',
    closed: 'Sprint đã đóng — sửa lịch sử sẽ làm velocity của các sprint sau nói sai.',
    name: 'Tên sprint',
    goal: 'Mô tả',
    goalPlaceholder: 'Sprint này làm gì, và vì sao?',
    startDate: 'Bắt đầu',
    endDate: 'Kết thúc',
    color: 'Màu nhận dạng',
    colorAuto: 'Tự chọn',
    badRange: 'Ngày kết thúc phải sau ngày bắt đầu.',
    saved: 'Đã lưu sprint',
  },
  sprintCreate: {
    open: 'Sprint mới',
    title: 'Tạo sprint',
    help: 'Dựng khung thời gian trước; đổ việc vào sau, ở tab Công việc.',
    namePlaceholder: 'Ví dụ: Sprint 1',
    planningNote:
      'Sprint tạo ra ở trạng thái lập kế hoạch. Board mặc định vẽ sprint đang chạy, nên hãy chọn sprint này ở bộ chọn phía trên tab Công việc để thấy nó.',
    submit: 'Tạo sprint',
    created: 'Đã tạo {{name}}',
  },
  sprintLifecycle: {
    start: 'Bắt đầu sprint',
    startHelp: 'Mỗi lúc chỉ một sprint được chạy — đóng sprint đang chạy trước nếu có.',
    started: 'Đã bắt đầu {{name}}',
    close: 'Đóng sprint',
    closed: 'Đã đóng {{name}} — {{completed}} việc xong, {{carried}} việc dở đã chuyển đi.',
    alreadyClosed: 'Sprint đã đóng.',
    carryOver: 'Việc chưa xong khi đóng thì đi đâu?',
    carry: {
      backlog: 'Trả về hàng đợi (Backlog)',
      next_sprint: 'Chuyển sang sprint kế tiếp',
    },
  },
  sprintStats: {
    tasks: '{{done}}/{{total}} task đã xong',
    hours: '{{hours}} giờ đã bấm trên task của sprint (kể cả việc con)',
    members: '{{n}} người tham gia — được giao task hoặc đã bấm giờ trên task của sprint',
  },
  sprintGraph: {
    title: 'Dòng chảy sprint',
    help: 'Thời gian chạy từ trên xuống. Mũi tên là ràng buộc thứ tự — hai sprint nối nhau phải làm tuần tự; không nối thì thứ tự tuỳ ý.',
    helpEdit:
      'Thời gian chạy từ trên xuống. Kéo từ chấm dưới đáy một sprint sang sprint khác để buộc chúng làm tuần tự; bấm vào mũi tên để bỏ ràng buộc.',
    link: 'Nối {{name}} sang một sprint khác',
    unlink: 'Bỏ ràng buộc thứ tự này',
    openTasks: 'Xem công việc của {{name}}',
    editSprint: 'Sửa {{name}}',
    drag: 'Kéo {{name}} tới chỗ khác trên sơ đồ',
    overlapTag: 'chồng lịch',
    overlapWarning_one:
      '{{count}} sprint đang chồng ngày với sprint khác. Scrum Guide (2020) đặt các sprint nối tiếp nhau — sprint mới bắt đầu ngay sau khi sprint trước kết thúc — và hệ thống cũng chỉ cho một sprint chạy mỗi lúc, nên cái sau sẽ phải đợi. Vẫn lưu được nếu bạn cố ý.',
    overlapWarning_other:
      '{{count}} sprint đang chồng ngày với nhau. Scrum Guide (2020) đặt các sprint nối tiếp nhau — sprint mới bắt đầu ngay sau khi sprint trước kết thúc — và hệ thống cũng chỉ cho một sprint chạy mỗi lúc, nên cái sau sẽ phải đợi. Vẫn lưu được nếu bạn cố ý.',
    empty: 'Chưa có sprint nào',
    emptyHelp:
      'Dự án Agile cần ít nhất một sprint thì việc mới ra khỏi hàng đợi được. Tạo sprint đầu tiên ngay đây.',
    emptyHelpReadonly: 'Quản lý dự án sẽ tạo sprint đầu tiên.',
    noEstimate: 'chưa ước lượng',
  },
  /**
   * Tên hai mươi màu dự án — APM-PSET-e.
   *
   * Khoá là tên màu lưu trong cơ sở dữ liệu (`PROJECT_COLORS`), không phải số
   * thứ tự: đọc một hàng `color = 'teal'` là biết ngay màu gì, còn `color = 7`
   * thì phải tra bảng.
   */
  projectColor: {
    red: 'Đỏ',
    orange: 'Cam',
    amber: 'Hổ phách',
    gold: 'Vàng kim',
    lime: 'Xanh chanh',
    green: 'Xanh lá',
    emerald: 'Lục bảo',
    teal: 'Mòng két',
    cyan: 'Xanh lơ',
    sky: 'Xanh trời',
    blue: 'Xanh dương',
    indigo: 'Chàm',
    violet: 'Tím',
    purple: 'Tía',
    magenta: 'Hồng sen',
    pink: 'Hồng đậm',
    rose: 'Hồng',
    stone: 'Đá',
    slate: 'Xám xanh',
    graphite: 'Than chì',
    blush: 'Hồng phấn',
    peach: 'Đào',
    yellow: 'Vàng',
    olive: 'Ô liu',
    mint: 'Bạc hà',
    aqua: 'Xanh ngọc',
    ice: 'Băng',
    azure: 'Thiên thanh',
    lavender: 'Oải hương',
    candy: 'Kẹo hồng',
  },
  projectPriority: {
    label: 'Ưu tiên',
    badge: 'Ưu tiên: {{level}}',
    low: 'Thấp',
    medium: 'Trung bình',
    high: 'Cao',
    urgent: 'Khẩn',
  },
  /** Đổi loại dự án trong hộp sửa — APM-PMETH. */
  methodologyChange: {
    label: 'Loại dự án',
    help: 'Đổi loại thì tab, board và báo cáo của dự án đổi theo. Chọn một loại khác để xem trước những gì bị ảnh hưởng.',
    checking: 'Đang kiểm tra…',
    blockedTitle: 'Chưa đổi được:',
    lossesTitle: 'Khi đổi, dự án sẽ mất hoặc thôi hiện:',
    noLosses: 'Không mất dữ liệu nào.',
    acknowledge: 'Tôi đã đọc và đồng ý',
    submit: 'Đổi sang {{name}}',
    done: 'Đã đổi dự án sang {{name}}',
    blocker: {
      SAME_METHODOLOGY: 'Dự án đã ở loại này.',
      SPRINT_ACTIVE: 'Sprint "{{name}}" đang chạy — đóng sprint trước khi đổi.',
      PROJECT_CLOSED: 'Dự án đã đóng hoặc đã dừng — mở lại trước khi đổi.',
    },
    loss: {
      SPRINTS_HIDDEN_one:
        'Tab Sprint, velocity, review và retro sẽ ẩn ({{count}} sprint, {{tasks}} việc đang gắn sprint). Dữ liệu được giữ nguyên — đổi lại Agile là thấy lại.',
      SPRINTS_HIDDEN_other:
        'Tab Sprint, velocity, review và retro sẽ ẩn ({{count}} sprint, {{tasks}} việc đang gắn sprint). Dữ liệu được giữ nguyên — đổi lại Agile là thấy lại.',
      END_DATE_CLEARED:
        'Ngày kết thúc {{date}} bị xoá hẳn — dự án bảo trì chạy tới khi bạn bấm dừng.',
      SCHEDULE_REPORTS_HIDDEN:
        'Báo cáo tiến độ (burndown, EVM, kế hoạch gốc, đường găng) sẽ tắt vì không còn mốc kết thúc.',
      RECURRENCES_PAUSED_one:
        '{{count}} lịch việc định kỳ chuyển sang tạm dừng. Việc đã sinh vẫn giữ nguyên.',
      RECURRENCES_PAUSED_other:
        '{{count}} lịch việc định kỳ chuyển sang tạm dừng. Việc đã sinh vẫn giữ nguyên.',
      FLOW_REPORTS_HIDDEN: 'Báo cáo bảo trì (thông lượng, tồn đọng) và lọc theo kỳ sẽ tắt.',
    },
  },
  overview: {
    startDate: 'Ngày bắt đầu',
    endDate: 'Ngày kết thúc',
    endDateMaintain: 'Dự án bảo trì không có ngày kết thúc — nó chạy tới khi bạn bấm dừng.',
    editTitle: 'Sửa thông tin dự án {{name}}',
    dateOrder: 'Ngày kết thúc phải sau ngày bắt đầu.',
    color: 'Màu dự án',
    colorHelp: 'Tô nhãn tab và hàng trên thanh bên, để phân biệt nhanh giữa các dự án.',
    colorNone: 'Không màu',
    sprintMilestones: 'Milestone của sprint ({{count}})',
    noSprintMilestones:
      'Sprint này chưa có milestone nào. Đặt hạng mục “Milestone” cho một việc trong sprint.',
    scopeCommitted: 'Nhận',
    scopeAdded: 'Thêm giữa chừng',
    scopeCompleted: 'Xong',
    scopeCarried: 'Đẩy sang sau',
    scopeUnknown: 'chưa đo',
    sprints: 'Sprint ({{count}})',
    sprintsHelp: 'Bấm vào một sprint để xem burndown, việc đã giao và biên bản review.',
    sprintRowGoals: 'Mục tiêu',
    sprintRowMilestones: 'Milestone',
    sprintSummary: 'Sprint ({{count}})',
    sprintRunning: 'Đang chạy: {{name}}',
    sprintNoneRunning: 'Chưa có sprint nào đang chạy.',
    sprintSummaryHelp: 'Chi tiết từng sprint ở tab Sprint.',
    sprintDependencies: 'Phụ thuộc',
    sprintDependsOn: 'Phải xong trước sprint này: {{names}}',
    sprintBlocks: 'Sprint này phải xong trước: {{names}}',
    sprintNoDependency: 'Chưa nối với sprint nào. Kéo mũi tên ở “Dòng chảy sprint” để buộc thứ tự.',
    sprintPoints: '{{done}}/{{total}} điểm',
    sprintPointsShort: '{{points}} điểm',
    sprintNoPoints: 'chưa ước lượng',
    sprintNoGoal: 'Sprint này chưa có mô tả.',
    sprintDelivered: 'Đã giao ({{count}})',
    sprintCarried: 'Chưa xong ({{count}})',
    sprintNoTasks: 'Không có việc nào.',
    documents: 'Tài liệu ({{count}})',
    noDocuments: 'Chưa có tài liệu nào.',
    uploadDocuments: 'Tải lên tài liệu',
    newDocument: 'Tạo mới tài liệu',
    uploadingDocuments: 'Đang tải lên {{count}} tệp…',
    uploadedDocuments: 'Đã thêm {{count}} tài liệu vào dự án.',
    uploadDocumentFailed: 'Không tải lên được “{{name}}”: {{reason}}',
    documentLibrary: 'Tìm, lọc và duyệt trong kho tài liệu',
    documentVersion: 'bản {{version}}',
    saved: 'Đã lưu',
    descriptionLabel: 'Mô tả dự án',
    descriptionPlaceholder: 'Dự án này làm gì, cho ai, và thành công nghĩa là gì?',
    noDescription: 'Dự án chưa có mô tả. Bấm Sửa để viết, giúp người mới hiểu dự án làm gì.',
    milestones: 'Milestone',
    milestonesHelp:
      'Việc có hạng mục Milestone trong dự án — không có thời lượng, chỉ có ngày phải đạt. Tự cập nhật theo milestone của dự án.',
    noMilestones:
      'Chưa có milestone nào. Đặt hạng mục “Milestone” cho một việc khi tạo hoặc sửa việc.',
    milestoneNoDate: 'chưa có ngày',
    milestoneOverdue: 'quá hạn {{date}}',
  },
  invitations: {
    applicationsTitle: 'Đơn đăng ký qua link ({{count}})',
    applicationsSubtitle:
      'Người đăng ký chọn nguyện vọng; bạn chốt lại vai trò, khoảng ngày và thời lượng trước khi chấp nhận.',
    applicationAccept: 'Chấp nhận với điều kiện này',
    applicationAccepted: 'Đã chấp nhận. Người này là thành viên dự án.',
    noSkills: 'Chưa khai kỹ năng nào.',
    wanted: 'Xin: {{role}} · {{period}} · {{commitment}}',
    title: 'Lời mời vào dự án ({{count}})',
    subtitle: 'Bấm vào để xem mục tiêu dự án và điều kiện tham gia.',
    openDetail: 'xem chi tiết →',
    noDescription: 'Dự án chưa có mô tả mục tiêu.',
    role: 'Vai trò:',
    period: 'Thời gian:',
    periodOpen: 'chưa chốt',
    commitment: 'Thời lượng:',
    commitmentOpen: 'chưa chốt',
    hoursPerDay: '{{value}} giờ/ngày',
    accept: 'Nhận lời mời',
    decline: 'Từ chối',
    confirmDecline: 'Xác nhận từ chối',
    notePlaceholder: 'Vì sao bạn không tham gia? Người mời sẽ đọc được.',
    needNote: 'Nhập lý do trước đã — từ chối im lặng thì người mời sẽ chờ thay vì tìm người khác.',
    accepted: 'Đã nhận. Bạn là thành viên của dự án.',
    declined: 'Đã từ chối, kèm lý do.',
    inviteTitle: 'Mời người vào dự án',
    inviteSubtitle:
      'Lời mời mang vai trò, khoảng ngày và thời lượng. Người được mời phải nhận thì mới tính vào năng lực đội.',
    invitePending: 'đang chờ trả lời',
    inviteSend: 'Gửi lời mời',
    inviteSent: 'Đã gửi lời mời.',
    inviteFrom: 'Từ ngày',
    inviteTo: 'Đến ngày',
    invitePercent: 'Thời lượng (%)',
    // Trang Lời mời — đích của thông báo mời (APM-INVOPEN).
    page: {
      title: 'Lời mời vào dự án',
      subtitle: 'Lời mời gửi cho bạn. Nhận thì bạn vào dự án với vai trò và thời lượng ghi dưới đây.',
      othersTitle: 'Lời mời khác đang chờ bạn',
      emptyTitle: 'Không có lời mời nào đang chờ bạn',
      emptyDescription: 'Khi có người mời bạn vào một dự án, lời mời sẽ hiện ở đây và trong chuông thông báo.',
      notFoundTitle: 'Không tìm thấy lời mời này',
      notFoundDescription:
        'Lời mời có thể gửi cho tài khoản khác, hoặc thuộc tổ chức khác — đổi tổ chức ở thanh trên rồi mở lại thông báo.',
      reason: 'Lý do: {{note}}',
      openProject: 'Mở dự án',
      outcome: {
        alreadyMember: 'Bạn đã ở trong dự án này — không cần trả lời lời mời nữa.',
        awaitingPm: 'Đơn đăng ký của bạn đang chờ quản lý dự án duyệt.',
        withdrawn: 'Người mời đã thu hồi lời mời này.',
        invite: {
          accepted: 'Bạn đã nhận lời mời này lúc {{at}}.',
          declined: 'Bạn đã từ chối lời mời này lúc {{at}}.',
        },
        application: {
          accepted: 'Quản lý dự án đã chấp nhận đơn của bạn lúc {{at}}.',
          declined: 'Quản lý dự án đã từ chối đơn của bạn lúc {{at}}.',
        },
      },
    },
  },
  projectRoles: {
    title: 'Vai trò & quyền',
    rulesSaved: 'Đã lưu quyền đổi trạng thái và đổi ngày của việc.',
    subtitle:
      'Ba vai trò hệ thống có sẵn, cộng vai trò riêng bạn tự đặt. Vai trò tuỳ biến chỉ tồn tại trong dự án này.',
    systemBadge: 'hệ thống',
    systemLocked:
      'Vai trò hệ thống không sửa được: nhiều nơi khác trong hệ thống dựa vào chúng để nhận ra ai là PM.',
    systemExtrasHint:
      'Quyền có sẵn của vai hệ thống không bỏ được. Tích thêm để mở quyền cho vai này — chỉ trong dự án này.',
    builtIn: 'Có sẵn ở vai hệ thống',
    extraLine: 'Cộng thêm ở dự án này: {{list}}',
    memberCount: '{{count}} người',
    memberSplit: '{{staff}} nhân sự · {{guests}} cộng tác viên',
    guestOwnOnly: 'Vai này thiếu “Xem dự án”: cộng tác viên giữ vai này chỉ thấy việc của mình.',
    guestForbidden:
      'Đang có cộng tác viên ngoài giữ vai này — quyền quản trị dự án và duyệt / chốt không bật được.',
    noPermission: 'chưa chọn quyền nào',
    add: '+ Tạo vai trò mới',
    name: 'Tên vai trò',
    namePlaceholder: 'Người duyệt tài liệu, QA trưởng…',
    delete: 'Xoá',
    deleted: 'Đã xoá vai trò.',
    saved: 'Đã lưu vai trò.',
    inUse: 'Còn {{count}} người đang giữ vai trò này. Chuyển họ sang vai trò khác rồi hãy xoá.',
    needName: 'Vai trò cần có tên.',
    needPermission: 'Chọn ít nhất một quyền — một vai trò không quyền nào thì không cho làm gì.',
    broaderWarning:
      '⚠️ Quyền này cho sửa MỌI việc trong dự án, không chỉ việc của chính mình — mạnh hơn vai trò Thành viên mặc định.',
    group: {
      view: 'Xem',
      work: 'Làm việc',
      approve: 'Tài liệu & duyệt',
      design: 'Thiết kế',
      git: 'Git',
      track: 'Theo dõi & cấu hình',
    },
    memberHint:
      'Muốn một vai trò như Thành viên bình thường? Tích: Xem dự án · Tạo việc mới · Sửa việc được giao cho mình · Xem báo cáo của dự án.',
    permission: {
      'project:read': 'Xem dự án, board, Gantt, báo cáo',
      'project:update': 'Sửa thông tin dự án, cột board, thành viên',
      'workflow:manage': 'Thêm, sửa, đổi nhóm và xoá cột board',
      'task:create': 'Tạo việc mới',
      'task:update@own': 'Sửa việc được giao cho mình',
      // Cộng tác viên ngoài — APM-GUEST-c. Chỉ có tác dụng khi vai KHÔNG có 'Xem dự án'.
      'task:read@own': 'Chỉ xem việc của mình (không thấy board)',
      'task:update': 'Sửa việc toàn dự án',
      'task:delete': 'Xoá việc',
      'task:assign': 'Giao việc cho người khác',
      'document:read': 'Đọc tài liệu dự án',
      'document:write': 'Tải lên & sửa tài liệu',
      'document:approve': 'Duyệt tài liệu',
      'raid:manage': 'Quản lý rủi ro, vấn đề, quyết định',
      'ai_suggestion:approve': 'Duyệt gợi ý của AI',
      'change_request:approve': 'Duyệt yêu cầu thay đổi',
      'report:read_project': 'Xem báo cáo của dự án',
      'design:read': 'Xem màn hình thiết kế và bản so sánh',
      'design:write': 'Gắn file Figma, chụp bản mới, duyệt mô tả',
      // Tab Git — APM-GIT-b. Cộng tác viên ngoài và khách hàng không nhận ba quyền này dù vai có mang.
      'git:read': 'Xem tab Git và khối Phát triển trên việc',
      'git:act': 'Tạo nhánh, tạo merge request, gắn hoặc ẩn liên kết',
      'git:manage': 'Dán token, gắn kho, đặt luật tự đổi trạng thái',
    },
  },
  projectList: {
    edit: 'Tất cả dự án',
    title: 'Sắp danh sách dự án ở thanh bên',
    help: 'Kéo tay cầm ở đầu dòng sang thanh bên để thêm, hoặc bấm thùng rác ở thanh bên để bỏ. Dự án mới luôn tự xuất hiện.',
    finish: 'Hoàn thành',
    saved: 'Đã lưu danh sách.',
    helpCompact:
      'Bật công tắc để đưa dự án vào Truy cập nhanh; sắp thứ tự ở thẻ Truy cập nhanh. Dự án mới luôn tự xuất hiện.',
    tabAll: 'Tất cả',
    pinLabel: 'Hiện {{name}} ở Truy cập nhanh',
    openHint: 'Mở dự án {{name}}',
    dragHint: 'Kéo sang thanh bên trái',
    reorderHint: 'Kéo để đổi chỗ',
    onSidebar: 'Đang ở thanh bên',
    notOnSidebar: 'Đã ẩn',
    acceptFirst: 'Nhận lời mời trước',
    removeFromSidebar: 'Bỏ {{name}} khỏi thanh bên (không xoá dự án)',
    /** Dự án mình tham gia với tư cách cộng tác viên ngoài tổ chức (`GUEST`). */
    collab: {
      badge: 'Cộng tác viên',
      badgeHint: 'Bạn tham gia dự án này với tư cách cộng tác viên ngoài tổ chức',
      title: 'Dự án cộng tác',
      help: 'Dự án ở tổ chức khác mà bạn là cộng tác viên. Bấm để chuyển sang tổ chức ấy và mở dự án.',
      open: 'Chuyển sang {{org}} và mở {{name}}',
      switchFailed: 'Không chuyển được sang tổ chức ấy. Hãy thử lại.',
    },
    group: {
      invited: 'Dự án được mời',
      notStarted: 'Chưa bắt đầu',
      running: 'Đang thực thi',
      done: 'Hoàn thành',
      archived: 'Đã lưu trữ',
      rejected: 'Bị từ chối',
    },
    rejected: 'Bị từ chối',
    rejectedNote: 'Lý do: {{note}}',
    rejectedNoNote: 'Người duyệt không ghi lý do.',
    col: {
      key: 'Mã',
      name: 'Tên dự án',
      creator: 'Người tạo',
      role: 'Vai trò',
      status: 'Trạng thái',
      period: 'Thời gian',
      people: 'Người',
      tasks: 'Việc',
      onSidebar: 'Thanh bên',
    },
    status: {
      pending_approval: 'Chờ duyệt',
      planning: 'Đang lập kế hoạch',
      active: 'Đang thực thi',
      on_hold: 'Tạm dừng',
      completed: 'Hoàn thành',
      archived: 'Đã lưu trữ',
    },
  },
  projectSetup: {
    title: 'Còn {{count}} việc cần cấu hình',
    badgeTitle: '{{count}} việc cần cấu hình trong dự án này',
    item: {
      taskTypes: 'Chọn phân loại công việc cho dự án',
      aiKey: 'Gắn key AI cho dự án',
      members: 'Thêm thành viên vào dự án',
      rates: 'Đặt giá thuê theo giờ cho nhân sự',
    },
    why: {
      taskTypes:
        'Dự án chưa có phân loại công việc nào đang dùng được, nên chưa tạo được việc nào — mọi việc đều phải có một loại.',
      aiKey:
        'Chưa có key thì mọi tính năng AI của dự án chưa dùng được — phần còn lại vẫn chạy bình thường.',
      members: 'Dự án đang chỉ có một người, nên chưa giao việc được cho ai.',
      rates:
        'Chưa có giá thuê thì tab Ngân sách chưa tính được tiền nhân sự. Người chưa xếp bậc thì nút điền tự động không đoán giá — xếp bậc cho họ hoặc nhập giá riêng.',
    },
  },
  projectSettings: {
    nav: {
      back: 'Tất cả mục cấu hình',
      group: {
        team: 'Thành viên & quyền',
        work: 'Công việc',
        integrations: 'Kết nối & AI',
        lifecycle: 'Vòng đời dự án',
      },
      search: {
        label: 'Tìm mục cấu hình',
        placeholder: 'Tìm mục cấu hình — vd. quyền, ngày nghỉ, token…',
        empty: 'Không có mục nào khớp “{{query}}”. Thử từ khác, hoặc xoá ô tìm để xem mọi mục.',
        enterHint: 'Nhấn Enter để mở mục này.',
      },
      sidebarLabel: 'Danh mục cấu hình',
      jumpLabel: 'Chuyển sang mục cấu hình khác',
      keywords: {
        members: 'thành viên, đội, người, nhân sự, thêm người, gỡ người, việc dở',
        invites: 'mời, lời mời, link mời, thêm người, email',
        roles:
          'quyền, phân quyền, vai trò, PM, chỉ xem, ai được làm gì, trạng thái, kéo cột, kanban, hoàn thành, nghiệm thu, quyền đổi, ngày bắt đầu, hạn, deadline, lịch, Gantt, quyền đổi ngày',
        syncUsers: 'ghép người, ghép tài khoản, đồng bộ, Jira, Trello, email',
        staffingRates: 'giá thuê, đơn giá, lương, thù lao, chi phí, hệ số tốc độ, ngân sách',
        sync: 'đồng bộ, Jira, Trello, nhập, kết nối, tích hợp, nguồn ngoài',
        aiKey: 'token, khoá, API, Claude, AI, key',
        taskTypes: 'loại việc, phân loại, nhãn, bug, tính năng',
        issueConfig: 'issue, vấn đề, sự cố, ticket, loại issue, hỗ trợ',
        definitionOfDone: 'DoD, hoàn thành, tiêu chí xong, nghiệm thu, checklist',
        // Cấu hình chung — gộp quy chuẩn, thời gian tối thiểu, bắt buộc hạn + ước lượng (2026-10-15).
        general:
          'cấu hình chung, tham số, quy chuẩn, WBS, hạng mục, báo trước hạn, nhắc hạn, thời gian tối thiểu, vừa tạo đã xong, khai giờ bắt đầu, hạn, deadline, ước lượng, số giờ, bắt buộc, chặn',
        tabLayout: 'thanh tab, sắp xếp tab, ẩn tab, giao diện',
        handOver: 'bàn giao, đổi PM, chuyển quản lý',
        stop: 'dừng, tạm dừng, huỷ, đóng dự án',
        archive: 'lưu trữ, cất, archive, huỷ, tạo nhầm',
        aiMemory: 'bộ nhớ AI, ghi nhớ, ghi chú, ngữ cảnh, AI',
        leave: 'rời dự án, thoát, ra khỏi dự án',
        git: 'git, gitlab, github, token, kho mã, repository, merge request, MR, webhook, nhánh, commit',
      },
    },
    general: {
      title: 'Cấu hình chung',
      subtitle:
        'Các tham số nhỏ của dự án: bắt buộc hạn và ước lượng trước khi làm, thời gian tối thiểu của một việc, độ dài hạng mục, các kiểu nhắc hạn.',
      workRules: 'Bắt đầu và hoàn thành việc',
      reminders: 'Nhắc hạn',
      remindersHelp: 'Hai kiểu nhắc bật / tắt riêng. Cả hai gửi cho người phụ trách việc.',
      dueSoonEnable: 'Báo trước hạn',
      timeLowEnable: 'Nhắc khi việc đang làm sắp hết thời gian',
      timeLowPct: 'Còn lại (%)',
      timeLowHint:
        'Tính trên quãng từ lúc việc sang "Đang làm" tới hết giờ làm của ngày hạn. Mặc định 10%: bắt đầu 9:00, hạn hôm nay hết giờ 18:00 ⇒ nhắc lúc 17:06.',
      invalidNumber: 'Nhập số nguyên từ {{min}} đến {{max}}.',
      save: 'Lưu',
      saved: 'Đã lưu cấu hình chung',
    },
    membersTitle: 'Thành viên dự án',
    membersSubtitle:
      'Ai đang ở trong dự án, giữ vai trò gì, và đang gánh bao nhiêu việc chưa xong.',
    role: 'Vai trò',
    roleName: { PM: 'Quản lý dự án', CONTRIBUTOR: 'Thành viên', VIEWER: 'Chỉ xem' },
    openTasks: '{{count}} việc · {{hours}} giờ',
    noOpenTasks: 'không còn việc dở',
    remove: 'Gỡ',
    cannotRemove: {
      has_open_tasks: 'Còn việc chưa xong đang mang tên người này. Chuyển việc trước rồi hãy gỡ.',
      last_pm: 'Dự án phải còn ít nhất một quản lý. Chỉ định người khác trước.',
      ok: '',
    },
    searchPlaceholder: 'Tìm theo tên, email, phòng ban…',
    noMatch: 'Không ai khớp “{{query}}”.',
    addMember: '+ Thêm người vào dự án',
    add: 'Thêm',
    everyoneAdded: 'Mọi người trong tổ chức đều đã ở trong dự án này.',
    guestRoleHint:
      'Cộng tác viên ngoài không giữ được vai có quyền quản trị dự án hoặc quyền duyệt / chốt.',
    guestRoleBlocked: '{{role}} — vượt quyền cộng tác viên',
    pending: {
      title: 'Chờ duyệt ({{count}})',
      subtitle:
        'Người trong tổ chức đăng ký qua link dự án và cộng tác viên ngoài mở link mời. Chọn vai rồi duyệt.',
      defaultGuestRole: 'Cộng tác viên ngoài (tạo khi duyệt)',
      guestMeta: '{{email}} · gửi lúc {{at}}',
    },
    saved: 'Đã cập nhật đội hình.',
  },
  mySettings: {
    nav: {
      back: 'Tất cả mục cài đặt',
      group: {
        workplace: 'Tổ chức và kỹ năng',
        time: 'Thời gian làm việc',
        assistants: 'Kết nối và trợ lý AI',
        display: 'Giao diện',
      },
    },
  },
  /** Thanh dưới kiểu kính trên điện thoại — APM-MBAR-a. */
  dock: {
    account: 'Tài khoản',
    aiAssistant: 'Trợ lý AI',
    row: {
      main: 'Hàng chính',
      features: 'Tính năng {{n}}/{{total}}',
      account: 'Tài khoản',
    },
    short: {
      velocity: 'Ước lượng',
      aiConsole: 'Bảng AI',
      teamReports: 'Báo cáo team',
      settings: 'Cài đặt',
      tour: 'Hướng dẫn',
    },
  },
  navLayout: {
    title: 'Thanh điều hướng',
    subtitle: 'Chọn mục nào hiện trên thanh trên cùng, mục nào nằm trong "Tính năng", mục nào ẩn.',
    help: 'Kéo thả để đổi chỗ. Thanh trên cùng giữ tối đa {{max}} mục; ẩn một mục chỉ bỏ nó khỏi thanh, trang vẫn mở được bằng đường dẫn. Mỗi tổ chức một cấu hình riêng. Trên điện thoại, {{mobile}} mục đầu của thanh nằm ở hàng chính của thanh dưới; các mục còn lại vuốt dọc trên thanh để xem.',
    zone: { bar: 'Trên thanh', menu: 'Trong "Tính năng"', hidden: 'Ẩn' },
    moveTo: { bar: 'Chuyển lên thanh', menu: 'Chuyển vào "Tính năng"', hidden: 'Ẩn đi' },
    moveMenu: 'Chuyển “{{name}}” tới…',
    drag: 'Kéo để đổi chỗ “{{name}}”',
    empty: 'Kéo mục vào đây',
    barFull: 'Thanh đã đủ {{max}} mục — chuyển bớt một mục ra trước khi thêm.',
    reset: 'Khôi phục mặc định',
    saved: 'Đã lưu thanh điều hướng',
    resetDone: 'Đã về bố cục mặc định',
  },
  appearance: {
    title: 'Chế độ sáng/tối',
    subtitle: 'Theo hệ điều hành, luôn sáng hoặc luôn tối.',
    option: { system: 'Theo hệ điều hành', light: 'Sáng', dark: 'Tối' },
    help: 'Áp dụng ngay và chỉ cho trình duyệt trên máy này — máy khác giữ lựa chọn riêng. "Theo hệ điều hành" tự đổi khi máy chuyển sáng/tối.',
  },
  mySkills: {
    title: 'Kỹ năng của tôi',
    subtitle:
      'Bạn làm được những gì. Dùng để gợi ý người phù hợp khi giao việc và khi AI xếp lại lịch.',
    level: 'Mức',
    add: '+ Thêm kỹ năng',
    addButton: 'Thêm',
    remove: 'Bỏ kỹ năng này',
    empty: 'Chưa khai kỹ năng nào.',
    saved: 'Đã cập nhật kỹ năng.',
    help: 'Đây là hồ sơ tự khai, không phải đánh giá. Tốc độ thật do hệ thống đo từ dữ liệu công việc, không lấy từ con số ở đây.',
  },
  workSchedule: {
    title: 'Lịch làm việc',
    subtitle:
      'Bạn làm những ngày nào trong tuần, mỗi ngày những ca nào. Nghỉ trưa là khoảng trống giữa hai ca. Kế hoạch và biểu đồ tải dùng lịch này để biết bạn còn bao nhiêu giờ.',
    adminSubtitle:
      'Khai hộ cho người chưa tự cấu hình. Lịch này quyết định trần năng lực của họ trong mọi dự án.',
    usingDefault:
      'Chưa khai lịch riêng — đang dùng lịch mặc định của tổ chức. Sửa rồi lưu ở đây để có lịch riêng.',
    resetToOrg: 'Dùng lại lịch mặc định của tổ chức',
    resetConfirm:
      'Bỏ lịch riêng và dùng lịch mặc định của tổ chức? Lịch riêng hiện tại sẽ không còn.',
    resetDone: 'Đã chuyển về lịch mặc định của tổ chức.',
    orgUsingSystemDefault:
      'Tổ chức chưa đặt lịch — đang dùng mặc định thứ Hai–thứ Sáu, 8 giờ mỗi ngày.',
    weekday: {
      0: 'Chủ nhật',
      1: 'Thứ Hai',
      2: 'Thứ Ba',
      3: 'Thứ Tư',
      4: 'Thứ Năm',
      5: 'Thứ Sáu',
      6: 'Thứ Bảy',
    },
    start: 'Từ',
    end: 'Đến',
    addShift: 'Thêm một ca nữa trong ngày',
    removeShift: 'Bỏ ca này',
    dayOff: 'Không làm',
    hours: '{{count}} giờ',
    hoursUnit: 'giờ',
    weeklyTotal: 'Tổng một tuần:',
    invalidShift: 'Có ca làm việc kết thúc trước hoặc đúng lúc bắt đầu.',
    overlappingShift: 'Hai ca trong cùng một ngày chồng lên nhau.',
    needOneDay:
      'Phải có ít nhất một ngày làm việc. Nghỉ dài ngày thì khai ở mục nghỉ phép, không phải ở đây.',
    saved: 'Đã lưu lịch làm việc.',
  },
  wbs: {
    title: 'Thư viện WBS template',
    subtitle:
      'WBS (Work Breakdown Structure — cấu trúc phân rã công việc) là cách chia dự án thành ' +
      'các hạng mục nhỏ dần, tới mức mỗi hạng mục giao được cho một người làm. Nó nói dự án ' +
      'phải LÀM NHỮNG GÌ, chưa nói khi nào — phần lịch là việc của Gantt. Mỗi template ở đây ' +
      'là một khuôn chia việc dựng sẵn theo kiểu kiến trúc, để người lập kế hoạch và AI bắt ' +
      'đầu từ đó thay vì từ trang trắng.',
    architecture: {
      web_fullstack: 'Web full-stack',
      backend_only: 'Backend / API',
      frontend_only: 'Frontend',
      mobile: 'Ứng dụng di động',
      microservices: 'Hệ microservices',
      other: 'Khác',
    },
    empty: 'Chưa có template nào',
    emptyHelp: 'Tạo template đầu tiên, hoặc nhân bản một bộ dựng sẵn.',
    builtIn: 'Template dựng sẵn',
    builtInHint: 'Template dựng sẵn chỉ đọc. Bấm “Nhân bản” để tạo bản sao rồi sửa thoải mái.',
    clone: 'Nhân bản',
    cloned: 'Đã tạo bản sao. Sửa bản sao không ảnh hưởng bản gốc.',
    newTemplate: 'Tạo template mới…',
    newName: 'Template mới',
    newItem: 'Tên hạng mục mới',
    addItem: 'Thêm',
    removeItem: 'Xoá hạng mục {{title}}',
    delete: 'Xoá template {{name}}',
    moveUp: 'Đưa lên trên',
    moveDown: 'Đưa xuống dưới',
    showInactive: 'Hiện cả template đã tắt',
    inactive: 'đã tắt',
    itemCount: '{{count}} hạng mục',
    totalHours: 'khoảng {{hours}} giờ',
    hours: '{{hours}}h',
    after: 'sau: {{name}}',
  },
  chartHelp: {
    overtime: {
      what: 'Số giờ bạn đã bấm **nằm ngoài ca làm việc** của chính mình, trong 90 ngày gần nhất. Ngoài ca gồm cả trước giờ vào, sau giờ tan, giờ nghỉ trưa, và cả ngày thứ Bảy, Chủ nhật hay ngày lễ.',
      read: '⚠️ Đây **không phải** một chiều thành tích. Nó trả lời câu "người này đang gánh bao nhiêu", không phải "người này làm tốt tới đâu" — nên nó không có mặt ở bảng so sánh cả nhóm. Giờ làm thêm cao gần như luôn là dấu hiệu của ước lượng sai hoặc quá tải, tức một việc cần sửa ở kế hoạch chứ không phải một điều cần khen ở con người.',
      watch:
        'Nhìn **số ngày** chứ không chỉ tổng giờ: 10 giờ rải trên 8 ngày là một nhịp làm việc, 10 giờ trong một đêm là một hạn chót đã trượt. Đoạn ngoài ca tự dừng sau 2 giờ, nên nếu còn làm thì bấm **Làm tiếp** — không bấm thì phần sau đó không được ghi.',
    },
    okrStart: {
      what: 'Người này đang ở đâu **lúc cái đích được đặt ra**.',
      read: 'Chụp **một lần** rồi giữ nguyên: job đêm đo với mục tiêu đo tự động, lần báo số đầu tiên với kết quả then chốt tự do. Mốc chạy theo hiện tại thì tiến độ đứng yên ở 0% mãi mãi.',
      watch:
        'Chưa có điểm bắt đầu thì tiến độ là **"chưa đo lần nào"**, không phải 0% — người mới hoặc kỳ chưa có dữ liệu.',
    },
    okrNumbers: {
      what: 'Ba con số của một OKR. **Điểm bắt đầu** là người này đang ở đâu lúc cái đích được đặt ra — chụp **một lần** rồi giữ nguyên. **Đích** là con số cam kết chạm tới trước khi hết kỳ, và với mục tiêu đo tự động thì đây là số **duy nhất** do con người quyết. **Đo được** là con số hiện tại.',
      read: 'Phần trăm đo **quãng đường giữa điểm bắt đầu và đích**, không phải "đo được chia đích". Đi từ 75% lên đích 78% mà đang ở 80% là **167%** — cam kết đi 3 điểm, thực tế đi 5. Phải tính như vậy vì chỉ số dạng **giảm** (số lần mở lại: 8 → đích 3) sẽ bị chấm ngược nếu lấy phép chia. Số này **do ai ghi**: mục tiêu đo tự động thì job đêm tính từ công việc đã hoàn thành và không có ô nhập nào; kết quả then chốt tự do thì quản lý báo số, và lần báo đầu tiên chính là điểm bắt đầu.',
      watch:
        'Vượt **100%** nghĩa là cái đích đã đặt quá thấp — đáng ghi lại khi chốt kỳ, vì kỳ sau nên nhắm xa hơn. **0%** mà vẫn có điểm bắt đầu nghĩa là đang đi lùi so với lúc xuất phát, không phải "chưa làm gì". Còn **"chưa đo lần nào"** là chưa có điểm bắt đầu — người mới hoặc kỳ chưa có dữ liệu — và nó khác hẳn 0%.',
    },
    /** Nút (i) cạnh từng chỉ số đo tự động của OKR — người dùng yêu cầu 2026-09-30. */
    okrMetric: {
      on_time_ratio: {
        what: 'Trong các việc **có hạn** bạn hoàn thành trong kỳ, bao nhiêu phần trăm xong **đúng hoặc trước hạn**.',
        read: 'Job đêm đếm task bạn hoàn thành trong kỳ. Task không đặt hạn thì không tính. Bạn không phải nhập gì.',
        watch: 'Dưới **3 việc có hạn** thì con số nhảy mạnh — trễ một việc là mất cả chục điểm.',
      },
      rework_ratio: {
        what: 'Bao nhiêu phần trăm việc đã xong **không bị mở lại** — xong là xong thật.',
        read: 'Đếm task hoàn thành trong kỳ; task bị mở lại dù chỉ một lần sau khi đóng là tính "làm lại". Càng cao càng tốt.',
        watch:
          'Dưới **90%** là cứ mười việc hơn một việc phải quay lại — thường do đóng vội hoặc yêu cầu chưa rõ.',
      },
      sla_met_ratio: {
        what: 'Trong các vấn đề vận hành (sự cố, yêu cầu…) bạn đóng trong kỳ, bao nhiêu phần trăm xử lý **kịp hạn cam kết (SLA)**.',
        read: 'Chỉ tính vấn đề có hạn xử lý; mức ưu tiên không có cam kết thì không vào phép tính.',
        watch:
          'Kỳ không đóng vấn đề vận hành nào thì chỉ số này **không đo được** — chỉ chọn khi bạn có làm vận hành.',
      },
      reopen_count: {
        what: 'Tổng số lần các vấn đề vận hành bạn đã đóng trong kỳ **bị mở lại**.',
        read: 'Một vấn đề mở lại hai lần tính 2. **Càng thấp càng tốt** — đích nằm dưới điểm bắt đầu.',
        watch: 'Số này tăng cùng lúc số vấn đề đóng được tăng: đang đóng nhanh mà chưa dứt điểm.',
      },
      speed_index: {
        what: 'Bạn làm nhanh hay chậm **so với ước lượng**, đã hiệu chỉnh theo cách ước lượng của từng dự án. **100** = đúng nhịp dự án.',
        read: 'Giờ thực tế so với giờ ước lượng của task đã xong, chia cho mức chung của cả dự án, rồi gộp theo số giờ bạn làm ở mỗi dự án. 120 ≈ nhanh hơn nhịp 20%, 50 = chậm gấp đôi. Trần 150.',
        watch:
          'Luôn phải đi kèm một chỉ số **chất lượng** cùng kỳ — nhanh nhờ làm ẩu thì không tính. Chạm **150** thường là ước lượng sai, không phải năng lực.',
      },
      service_hours: {
        what: 'Số **giờ quy đổi** bạn bỏ vào vấn đề vận hành đã đóng trong kỳ.',
        read: 'Tính từ thời gian vấn đề ở trạng thái đang xử lý; cùng lúc xử lý n vấn đề thì mỗi cái nhận 1/n. Đếm theo giờ, không theo số phiếu — chia nhỏ phiếu không làm tăng số này.',
        watch:
          'Là chỉ số **khối lượng**, nên phải đi kèm một chỉ số chất lượng cùng kỳ (vd. tỉ lệ đúng cam kết).',
      },
    },
    timesheetWeek: {
      what: 'Số giờ bạn **đã bấm** trong tuần, theo từng ngày. Không phải giờ chấm công của công ty — chỉ những khoảng bạn bấm Bắt đầu và Dừng.',
      read: 'Ô `–` là ngày **chưa bấm giờ**, khác hẳn một ngày làm 0 giờ. Ô nền xám là ngày không có ca (cuối tuần, nghỉ lễ, nghỉ phép). Cột TB/ngày chia tổng giờ cho **số ngày có ca** của tuần đó, nên một tuần nghỉ phép ba ngày vẫn đọc được.',
      watch:
        'TB/ngày thấp hơn một nửa số giờ theo lịch trong hai tuần liên tiếp — thường là quên bấm chứ không phải làm ít, và khi đó mọi con số dựng trên nó đều hụt. Tổng tuần vượt số giờ theo lịch cũng đáng nhìn: hoặc đang làm thêm đều đặn, hoặc có đoạn quên bấm Dừng.',
    },
    testProgress: {
      what: 'Mỗi vòng test đã chạy được bao nhiêu ô, và kết quả ra sao. Một ô là một test case chạy trên một môi trường.',
      read: 'Chiều cao cả cột là tổng số ô phải chạy, nên phần xám là phần **chưa chạy**. So các cột với nhau để thấy vòng nào chạy đủ, vòng nào bỏ dở.',
      watch:
        'Phần xám còn lớn ở một vòng đã đóng — nghĩa là vòng ấy kết luận trên một phần bộ case. Và phần vàng (bị chặn) nhiều: đó không phải lỗi sản phẩm mà là môi trường test đang hỏng.',
    },
    testFixYield: {
      what: 'Trong mỗi vòng, dev báo đã sửa bao nhiêu lỗi và tester xác nhận được bao nhiêu.',
      read: '100% là mọi lỗi dev báo xong đều đã hết thật. 60% nghĩa là cứ 10 lỗi dev báo xong thì 4 lỗi test lại vẫn thấy. Hai đường là hai mặt của một con số nên cộng lại xấp xỉ 100%.',
      watch:
        'Dưới 70%, hoặc giảm dần qua các vòng. Cả hai nói rằng lỗi đang được báo xong trước khi sửa xong, và mỗi vòng test sau sẽ tốn thêm một lượt. Vòng không có điểm nào là vòng chưa ai sửa gì — khác hẳn 0%.',
    },
    testConvergence: {
      what: 'Số lỗi còn phải làm ở cuối mỗi vòng, và số lỗi mới phát sinh trong vòng đó.',
      read: 'Cả hai đường cùng đi xuống là đang hội tụ — sắp xong. Đọc đường **lỗi mới** trước: nó nói sản phẩm còn sinh lỗi hay đã ổn.',
      watch:
        'Lỗi còn lại giảm mà lỗi mới không giảm: đang đuổi theo chính mình, và đó là thứ cần thấy **trước** khi chốt ngày phát hành. Lỗi mới bật lên ở một vòng muộn thường nghĩa là một bản sửa đã làm hỏng chỗ khác.',
    },
    burndown: {
      what: 'Khối lượng còn lại của sprint giảm dần theo ngày, so với đường lý tưởng.',
      read: 'Đường thật nằm **trên** đường lý tưởng là đang chậm hơn nhịp; nằm dưới là nhanh hơn. Độ dốc quan trọng hơn vị trí: dốc đều nghĩa là việc xong rải đều, còn phẳng rồi rơi thẳng nghĩa là mọi việc dồn vào cuối sprint.',
      watch:
        'Đoạn phẳng kéo dài quá vài ngày, hoặc đường thật đi ngang tới sát ngày cuối. Cả hai đều nói rằng con số cuối sprint không đoán được từ giữa sprint.',
    },
    perfSpeed: {
      what: 'Bạn làm xong một việc nhanh hay chậm so với **nhịp chung của chính dự án đó**.',
      read: '100 là đúng nhịp dự án, 50 là chậm gấp đôi nhịp ấy. Chuẩn hoá theo từng dự án chứ không so tuyệt đối, vì một PM ước lượng rộng tay sẽ làm cả đội trông nhanh — so như thế là đo thói quen ước lượng của PM, không phải đo bạn. Chỉ số cắt trần ở 150.',
      watch:
        'Chạm trần 150 **không** phải tin tốt: nhanh gấp rưỡi nhịp dự án gần như luôn là dấu hiệu việc bị ước lượng quá rộng, không phải năng lực. Dưới 70 kéo dài thì xem lại cách chia nhỏ việc trước khi kết luận gì về tốc độ.',
    },
    perfOnTime: {
      what: 'Trong những việc **có hạn**, bao nhiêu phần trăm bạn xong kịp.',
      read: 'Mẫu số chỉ đếm việc có gắn hạn — việc không hạn không vào đây, cả tử lẫn mẫu. Nên một người toàn làm việc không hạn sẽ thấy “chưa đo được”, chứ không phải 0%.',
      watch:
        'Dưới 70% thì thường là vấn đề của **khâu đặt hạn**, không phải khâu làm: hạn do người khác đặt mà không hỏi tải hiện có thì tỉ lệ này không bao giờ đẹp lên được bằng cách cố gắng thêm.',
    },
    perfRework: {
      what: 'Bao nhiêu phần trăm việc bạn làm xong **không bị mở lại**.',
      read: 'Cao hơn là tốt hơn — cùng chiều với các chỉ số khác, để không có ô nào phải đọc ngược. Đây là đối trọng của tốc độ: đọc nó **cùng lúc** với “Tốc độ”, vì cách nhanh nhất để đẹp một chỉ số là làm hỏng chỉ số kia.',
      watch:
        'Dưới 85% là đáng nhìn kỹ. Và bất kỳ lúc nào Tốc độ tăng mà chỉ số này giảm — đó là dấu hiệu rõ nhất của việc đang đi nhanh bằng cách làm ẩu.',
    },
    perfService: {
      what: 'Công việc vận hành: đúng cam kết xử lý bao nhiêu, tốn bao nhiêu **giờ quy đổi**, và bao nhiêu vấn đề bị mở lại.',
      read: 'Đo bằng **giờ**, không bằng số ticket. Đếm ticket thưởng cho việc nhặt cái dễ và chia nhỏ phiếu — chia một việc hai giờ thành bốn phiếu vẫn là hai giờ. Mẫu số của tỉ lệ đúng cam kết **chỉ đếm vấn đề có cam kết**, nên không cam kết khác với lỡ hẹn.',
      watch:
        'Số mở lại tăng trong khi giờ quy đổi cũng tăng: đang xử lý nhiều hơn nhưng chưa dứt điểm. Khối này trống hẳn nghĩa là bạn không làm việc vận hành — khác với làm mà chưa đóng được vấn đề nào.',
    },
    perfLoad: {
      what: 'Tám tuần **tới** bạn đang được phân bổ bao nhiêu phần trăm sức làm việc.',
      read: '⚠️ Đây là ô duy nhất nhìn về **tương lai** — mọi ô khác kể lại quá khứ. Tính từ việc đã giao có ngày, so với quỹ giờ còn lại sau khi trừ ngày nghỉ đã đăng ký.',
      watch:
        'Trên 110% thì lịch đã hứa nhiều hơn số giờ có thật, và một việc nào đó sẽ trễ — mang con số này đi nói chuyện sớm thì rẻ hơn nhiều so với báo trễ về sau.',
    },
    velocity: {
      what: 'Mỗi sprint đã hoàn thành bao nhiêu điểm, và trung bình mấy sprint gần nhất.',
      read: 'Nhìn **mức dao động** trước khi nhìn giá trị: velocity ổn định cho phép dự báo, còn velocity nhảy gấp đôi rồi giảm nửa thì trung bình của nó không dùng để hứa hẹn được.',
      watch:
        'Hai sprint liên tiếp giảm mạnh, hoặc biên độ dao động lớn hơn chính giá trị trung bình.',
    },
    issueArrival: {
      what: 'Mỗi tuần nhận bao nhiêu vấn đề mới, và đóng được bao nhiêu.',
      read: 'Hai đường sát nhau nghĩa là đội đang **cân bằng** với lượng việc tới. Khoảng cách giữa chúng chính là phần tồn đọng tăng thêm trong tuần ấy.',
      watch:
        'Đường ghi nhận nằm trên đường đã đóng **ba tuần liền** — khi đó tồn đọng chỉ có thể lớn lên và không tự hết. Đây là cảnh báo sớm hơn mọi chỉ số khác trong nhóm này.',
    },
    issueCycle: {
      what: 'Xong một vấn đề mất bao lâu, tính từ lúc được ghi nhận tới lúc đóng.',
      read: 'Đọc cột **85%**, không đọc trung bình: phân bố loại này có đuôi dài rất nặng, nên trung bình luôn nằm ở chỗ không có vấn đề nào và nó che đúng những cái làm khách gọi điện. "85% xong trong 3 ngày" là một câu hứa được với khách.',
      watch:
        'Cột 85% tăng dần qua các kỳ, hoặc cách xa hẳn cột "một nửa" — nghĩa là phần đuôi đang dài ra: phần lớn vẫn nhanh, nhưng số ít bị bỏ quên ngày càng lâu.',
    },
    issueSla: {
      what: 'Bao nhiêu phần trăm vấn đề được phản hồi và xử lý đúng cam kết.',
      read: 'Mẫu số **chỉ đếm những vấn đề có cam kết**. P4 thường không cam kết hạn xử lý, nên ô ấy là một gạch chứ không phải 0% — không cam kết khác với lỡ hẹn.',
      watch:
        'Cột phản hồi tụt trước cột xử lý: đội đang quá tải ở khâu tiếp nhận, không phải ở khâu sửa. Hai nguyên nhân ấy cần hai cách xử lý khác nhau.',
    },
    issueAging: {
      what: 'Những vấn đề **đang mở** hiện nay đã mở bao lâu, và bao nhiêu trong số đó đã quá hạn.',
      read: 'Đây là biểu đồ duy nhất trong nhóm nhìn về **phía trước** — bốn cái kia kể lại quá khứ. Cột đỏ là phần đã vỡ cam kết; phần còn lại của mỗi cột là phần còn kịp.',
      watch:
        'Ô "lâu hơn" phình lên qua các lần xem: đó là những việc không ai từ chối nhưng cũng không ai làm. Và bất kỳ ô nào có cột đỏ chiếm phần lớn.',
    },
    issueMaintenance: {
      what: 'Công sức bảo trì đi vào loại việc nào: sửa lỗi, theo môi trường đổi, cải thiện, hay phòng ngừa.',
      read: 'Đo bằng **giờ quy đổi**, không bằng số vấn đề: mười yêu cầu nhỏ và một lần sửa kiến trúc là mười một việc nhưng công sức thì ngược hẳn. Đây là câu trả lời cho "tiền bảo trì đi đâu".',
      watch:
        'Phần "sửa lỗi" chiếm đa số kéo dài nhiều kỳ — sản phẩm đang xuống cấp, và đội chỉ còn thời gian chữa cháy. Ô "chưa phân loại" lớn thì cả biểu đồ này chưa đọc được.',
    },
    unplanned: {
      what: 'Bao nhiêu phần trăm việc mỗi tuần là việc không ai kịp lên kế hoạch — tạo ra sát ngay lúc phải làm.',
      read: 'Đo **mức độ dự đoán được**, không đo năng suất. Tỉ lệ cao nghĩa là công việc tới bất ngờ, và khi đó mọi kế hoạch cho việc khác đều mong manh. Chỗ đường **đứt quãng** là tuần không có việc nào tính được — không phải tuần 0%.',
      watch:
        'Tỉ lệ tăng dần qua nhiều tuần: đội đang bị cuốn vào chữa cháy. Và một tuần vọt lên gần 100% thường là một sự cố, đáng tìm xem nó là gì.',
    },
    throughput: {
      what: 'Số việc hoàn thành mỗi tuần.',
      read: 'Đếm **số việc**, không phải độ lớn — nên nó trả lời "đội đang chốt việc nhanh chậm ra sao" chứ không phải "làm được bao nhiêu". Gom theo tuần vì con số theo ngày của một đội nhỏ chỉ là nhiễu.',
      watch:
        'Xu hướng giảm kéo dài nhiều tuần, hoặc một tuần bằng không trong khi vẫn có việc đang làm — thường là việc bị kẹt ở một cột nào đó.',
    },
    flow: {
      what: 'Biểu đồ dòng tích luỹ (CFD): mỗi dải màu là số việc đang ở một cột, xếp chồng theo thời gian.',
      read: 'Đọc **bề dày** của dải, không đọc đường viền: dải dày lên nghĩa là việc vào nhiều hơn ra ở cột đó. Khoảng cách dọc giữa hai đường là số việc đang dở, khoảng cách ngang là thời gian một việc đi qua.',
      watch:
        'Một dải phình to dần — đó là nút thắt. Và dải trên cùng đi ngang nghĩa là đội đang nhận việc mới nhanh hơn tốc độ hoàn thành.',
    },
    cycle: {
      what: 'Mỗi chấm là một việc đã xong: nó mất bao nhiêu ngày từ lúc bắt đầu tới lúc hoàn thành.',
      read: 'Đường percentile quan trọng hơn từng chấm: p85 nghĩa là 85% việc xong trong ngần ấy ngày — đó là con số dùng để hứa hạn, không phải giá trị trung bình. Biểu đồ dưới nói quy trình có ổn định không (trung bình động ± 2σ).',
      watch:
        'Chấm nằm ngoài dải ±2σ là bất thường thật, đáng hỏi lý do. Và p85 tăng dần qua các tuần nghĩa là mọi lời hứa về hạn đang dần sai.',
    },
    aging: {
      what: 'Những việc **đang dở** đã nằm đó bao nhiêu ngày.',
      read: 'Khác cycle time ở chỗ nó tính việc **chưa** xong — nên nó nói về hiện tại, không phải lịch sử. Ngưỡng "già" là p85 của chính dự án này, nên đội chậm hay nhanh thì ngưỡng tự đi theo.',
      watch:
        'Việc vượt ngưỡng: nó bất thường so với lịch sử của chính đội, không phải so với một con số chung. Bấm vào dòng để xem việc đó đang vướng gì.',
    },
    evm: {
      what: 'Ba đường giá trị thu được, tính bằng **giờ** chứ không phải tiền: PV = lẽ ra đã xong bao nhiêu, EV = đã xong bao nhiêu, AC = đã bỏ ra bao nhiêu.',
      read: 'EV dưới PV là chậm tiến độ; AC trên EV là tốn công hơn dự tính. Hai chỉ số ở phụ đề là tỉ số của chính ba đường ấy: SPI = EV/PV (tiến độ), CPI = EV/AC (hiệu quả). Bằng 1 là đúng kế hoạch.',
      watch:
        'SPI hoặc CPI dưới 0,9. Và khoảng cách giữa các đường **giãn rộng dần** đáng lo hơn một khoảng cách lớn nhưng không đổi.',
    },
    estimate: {
      what: 'Mỗi chấm là một việc: ước lượng ban đầu (trục ngang) so với thời gian thực tế (trục dọc).',
      read: 'Đường chéo là "ước lượng đúng". Chấm **trên** đường là lâu hơn dự tính, **dưới** là nhanh hơn. Chấm rỗng là việc từng bị chặn — chậm vì chờ đợi, không phải vì năng lực.',
      watch:
        'Chấm dồn hẳn về một phía đường chéo: đội đang ước lượng lệch có hệ thống, và con số ấy đang nuôi mọi dự báo khác.',
    },
    slippage: {
      what: 'Ngày hoàn thành thực tế lệch bao nhiêu so với kế hoạch gốc đã chốt.',
      read: 'Cột dương là trễ hơn baseline, âm là sớm hơn. So với **baseline**, nên nó chỉ có nghĩa sau khi kế hoạch gốc được chốt.',
      watch: 'Nhiều cột dương liên tiếp — kế hoạch đang trượt đều chứ không phải một việc lỡ nhịp.',
    },
    riskMatrix: {
      what: 'Rủi ro xếp theo xác suất (trục ngang) và mức ảnh hưởng (trục dọc), thang 1–5.',
      read: 'Vị trí quan trọng hơn số lượng: một ô góc trên bên phải nặng hơn năm ô góc dưới bên trái. Điểm = xác suất × ảnh hưởng, tối đa 25.',
      watch:
        'Ô đỏ (điểm từ 15 trở lên) phải có người chịu trách nhiệm và phương án ứng phó — đó là ngưỡng mà hệ thống cũng dùng để cảnh báo.',
    },
    riskBurndown: {
      what: 'Tổng điểm rủi ro của dự án giảm dần theo thời gian.',
      read: 'Đo **tổng mức phơi nhiễm**, không phải số lượng rủi ro: đóng một rủi ro lớn kéo đường xuống nhiều hơn đóng ba rủi ro nhỏ.',
      watch:
        'Đường đi ngang hoặc đi lên trong khi dự án đang chạy: rủi ro mới sinh ra nhanh hơn tốc độ xử lý.',
    },
    crTrend: {
      what: 'Số yêu cầu thay đổi theo thời gian — đã đề xuất và đã duyệt.',
      read: 'Cột **đã đề xuất** mới là cột phải nhìn: nhịp đề xuất nói phạm vi đang bị kéo giãn tới đâu, kể cả khi phần lớn bị từ chối.',
      watch: 'Nhịp đề xuất tăng dần ở nửa sau dự án — dấu hiệu sớm của phạm vi phình ra.',
    },
    documents: {
      what: 'Tài liệu của dự án đang ở trạng thái nào: nháp, chờ duyệt, đã duyệt.',
      read: 'Danh sách bên dưới có ích hơn ba con số: nó nói **bản nào** đang chờ và chờ bao lâu.',
      watch:
        'Nhóm chờ duyệt lớn dần: phê duyệt đang là nút thắt, và những việc phụ thuộc tài liệu ấy đang đứng yên.',
    },
    periodComparison: {
      what: 'Năm con số của kỳ đang xem, đặt cạnh chính chúng ở kỳ liền trước.',
      read: 'Đọc **hai dòng đầu cùng nhau**: vào bao nhiêu, ra bao nhiêu. Ra ít hơn vào, kỳ nào cũng vậy, thì tồn đọng sẽ tăng mãi — không cần biết thêm gì nữa. Mũi tên chỉ **hướng**, còn màu nói **lành hay dữ**: xong nhiều việc hơn là tin tốt, tồn đọng nhiều hơn thì không.',
      watch:
        '⚠️ Tỉ lệ không kịp lên kế hoạch tăng mà tồn đọng cũng tăng: đội đang chữa cháy chứ không phải đang bận. Hai thứ ấy cần hai cách xử lý khác hẳn nhau.',
    },
    gates: {
      what: 'Trạng thái từng cổng pha của dự án Waterfall.',
      read: 'Mỗi cổng có điều kiện qua cổng đọc từ **đồ thị phụ thuộc** của chính dự án, không phải một ô ai đó tự tick. Nên "chưa đủ điều kiện" luôn kèm lý do cụ thể.',
      watch:
        'Cổng quá hạn mà chưa đủ điều kiện: mọi pha sau nó đang chạy trên một giả định chưa được xác nhận.',
    },
    resource: {
      what: 'Nhu cầu nhân lực theo thời gian, so với năng lực thật của đội.',
      read: 'Cột vượt đường năng lực nghĩa là **kế hoạch đòi hỏi nhiều hơn số giờ đội có** trong khoảng đó — đã trừ cuối tuần, ngày lễ và nghỉ phép.',
      watch: 'Cột vượt trần: lịch đó không chạy được như đang vẽ, dù mỗi việc riêng lẻ đều hợp lý.',
    },
    objectives: {
      what: 'Mục tiêu của dự án và những việc đang phục vụ từng mục tiêu.',
      read: 'Đọc theo hai câu hỏi: mục tiêu nào **chưa có việc nào** gắn vào, và mục tiêu nào đang có nhiều việc chạy.',
      watch: 'Mục tiêu không có việc nào: nó đang được cam kết mà không ai làm gì cho nó.',
    },
    teamPerf: {
      what: 'Năng suất theo từng người, tách theo loại việc và công nghệ.',
      read: 'So một người với **chính họ ở kỳ trước**, đừng xếp hạng giữa người với nhau: loại việc và độ khó khác nhau thì con số không so trực tiếp được.',
      watch:
        '⚠️ Đây là dữ liệu hiệu suất cá nhân. Mỗi lượt mở được ghi lại, và người bị xem đọc được dấu vết đó.',
    },
    health: {
      what: 'Sức khoẻ mọi dự án trên một bảng, mỗi dự án ba tín hiệu: tiến độ, rủi ro, chất lượng.',
      read: 'Mỗi ô kèm **con số** chứ không chỉ màu — nên đọc được ngay vì sao nó đỏ, không phải mở từng dự án ra hỏi.',
      watch:
        'Hai tín hiệu đỏ trở lên trên cùng một hàng: các vấn đề đang cộng hưởng chứ không còn độc lập.',
    },
    projectHealth: {
      what: 'Ba tín hiệu sức khoẻ của dự án này: tiến độ, rủi ro, chất lượng.',
      read: 'Cùng phép tính với bảng của lãnh đạo — cố ý như vậy, để PM và lãnh đạo nhìn cùng một màu về cùng một dự án.',
      watch:
        'Một tín hiệu chuyển màu mà con số bên cạnh chưa đổi nhiều: nó vừa vượt ngưỡng, đây là lúc rẻ nhất để xử lý.',
    },
    capacity: {
      what: 'Dự báo năng lực đội trong các tuần tới, so với khối lượng đã cam kết.',
      read: 'Năng lực đã trừ cuối tuần, ngày lễ và nghỉ phép đã đăng ký — nên nó là số giờ **thật sự** có, không phải số giờ trên lý thuyết.',
      watch:
        'Tuần mà cam kết vượt năng lực: cần giãn việc hoặc bớt phạm vi, và biết trước vẫn rẻ hơn biết vào cuối tuần đó.',
    },
    storage: {
      what: 'Dung lượng file **còn dùng được** của từng dự án đang có trên sidebar — đính kèm công việc và phiên bản tài liệu. File đã xoá không tính.',
      read: 'Thanh dài nhất là dự án tốn nhiều nhất; các thanh khác so với nó. Con số bên phải là câu trả lời thật, kèm số file. Chọn một ngày ở ô "xem theo ngày" để thấy dung lượng tại mốc ấy.',
      watch:
        'Một dự án chiếm **quá nửa** tổng dung lượng, hoặc tăng **gấp đôi** giữa hai mốc cách nhau một tuần: thường là bản dựng, video hay file nén tải lên nhầm chỗ — mở trang Files của dự án để xem và xoá.',
    },
    roadmap: {
      what: 'Lộ trình các dự án trên cùng một trục thời gian.',
      read: 'Dùng để thấy chỗ **chồng lấn**: hai dự án lớn cùng chạy một quãng nghĩa là cùng tranh một nhóm người.',
      watch:
        'Nhiều dự án kết thúc sát nhau — giai đoạn bàn giao dồn cục, và đó là lúc chất lượng hay tụt.',
    },
    activity: {
      what: 'Mức độ cập nhật công việc theo từng người theo ngày.',
      read: 'Đo **thói quen cập nhật**, không đo năng suất: ô nhạt nghĩa là hôm đó không ai ghi nhận gì, chứ không phải không ai làm gì.',
      watch:
        '⚠️ Đây là dữ liệu hiệu suất cá nhân. Mỗi lượt mở được ghi lại. Vùng nhạt kéo dài đáng hỏi vì dữ liệu báo cáo đang không đáng tin, chứ không phải để đánh giá con người.',
    },
    teamPerf2Cols: {
      tasksDone: {
        what: 'Số task người này làm xong trong kỳ (hiện vẫn đang ở cột xong).',
        read: 'Task được ghi cho người làm lúc đo velocity, không có thì cho người đang được giao. Task xong rồi bị mở lại và chưa xong lại thì không đếm. Mũi tên: so với kỳ trước.',
        watch: 'Giảm mạnh so với kỳ trước mà không nghỉ phép — hỏi xem có việc lớn nào đang kẹt.',
      },
      checklistDone: {
        what: 'Số mục checklist chính người này tick xong trong kỳ, ở mọi task.',
        read: 'Chỉ tính trạng thái cuối trong kỳ: tick rồi bị bỏ tick thì không đếm, tick – bỏ – tick lại đếm một lần. Tick do hệ thống không ghi cho ai.',
        watch: 'Nhiều mục checklist mà ít task xong: việc đang to, hoặc chia việc chưa khéo.',
      },
      spDeclared: {
        what: 'Tổng story point đã khai trên các task xong trong kỳ.',
        read: 'Task không chấm điểm không cộng vào đây — xem cột SP ước lượng.',
        watch: 'Bằng 0 ở cả đội nghĩa là đội không chấm điểm — xem cột SP ước lượng thay vào.',
      },
      spEstimated: {
        what: 'Tổng story point ước lượng cho các task xong trong kỳ mà không chấm điểm.',
        read: 'Lấy gợi ý AI nếu có; không thì giờ ước lượng ÷ số giờ cho một điểm của tổ chức (trung vị, cần ≥ 5 task có cả hai), làm tròn lên thang Fibonacci. Rê chuột vào số để xem tách AI / công thức / không ước lượng được.',
        watch: 'Lớn hơn SP khai nhiều lần: số này dựa chủ yếu vào ước lượng, kém tin cậy hơn.',
      },
      onTimePct: {
        what: 'Phần trăm task xong đúng hoặc trước hạn, trên các task xong có hạn.',
        read: 'So với hạn có hiệu lực lúc xong — dời hạn về sau không làm đổi con số. Task không có hạn không vào mẫu số; không có task nào có hạn thì hiện "—".',
        watch: 'Dưới 80% đáng xem; dưới 60% thường là kế hoạch sai chứ không phải người chậm.',
      },
      lateDone: {
        what: 'Số task xong sau hạn có hiệu lực lúc xong.',
        read: 'Cùng mẫu với % đúng hạn: đúng hạn + xong trễ = số task xong có hạn.',
        watch: 'Tăng hai kỳ liền.',
      },
      dueExtensions: {
        what: 'Tổng số lần hạn bị dời ra sau, trên các task xong trong kỳ — tính tới lúc task xong. Rê chuột vào ô để xem số lần ấy dồn vào mấy task.',
        read: 'Một lần = hạn đang có được đổi sang ngày muộn hơn, bởi bất kỳ ai (kể cả áp gợi ý dời lịch). Đặt hạn lần đầu, kéo hạn sớm lên hay xoá hạn không tính; dời hạn sau khi đã xong cũng không tính.',
        watch: '% đúng hạn so với hạn lúc xong, nên % đúng hạn cao mà cột này cũng cao là đúng hạn nhờ dời hạn. Một task bị dời nhiều lần thường là ước lượng ban đầu sai — hỏi trước khi kết luận.',
      },
      overdueOpen: {
        what: 'Số task đang giao cho người này, chưa xong tại cuối kỳ, hạn trước ngày cuối kỳ.',
        read: 'Kỳ tới hôm nay là đúng nghĩa "đang quá hạn". Kỳ đã qua tính theo người được giao và hạn hiện tại, nên task đổi người hay dời hạn sau kỳ có thể lệch.',
        watch: 'Từ 3 việc trở lên, hoặc tăng hai kỳ liền.',
      },
      reopenPct: {
        what: 'Phần trăm task xong trong kỳ từng bị mở lại sau khi đã xong.',
        read: 'Mở lại = chuyển từ cột xong về cột khác. Mỗi task đếm một lần dù mở lại mấy lần.',
        watch: 'Trên 15%: "xong" đang được tuyên bố sớm, hoặc tiêu chí hoàn thành chưa rõ.',
      },
      cycleDays: {
        what: 'Số ngày (lịch) từ lúc bắt đầu làm tới lúc xong — trung vị trên các task xong trong kỳ.',
        read: 'Bắt đầu = lần đầu task vào cột "đang làm"; task đi thẳng sang xong không có mốc bắt đầu nên không tính. Trung vị nên một task kéo dài không làm méo số.',
        watch: 'Tăng dần qua các kỳ: việc đang to ra, hoặc đang chờ nhau nhiều hơn.',
      },
      wip: {
        what: 'Số task đang ở cột "đang làm" của người này, tại lúc xem.',
        read: 'Số hiện tại, không theo kỳ nên không so kỳ trước. Nhiều việc dở cùng lúc thường làm cycle time dài ra.',
        watch: 'Trên 3 việc dở cùng lúc.',
      },
      hours: {
        what: 'Giờ người này bấm bằng đồng hồ bấm giờ trong kỳ.',
        read: 'Chỉ phần nằm trong kỳ; đoạn đang chạy tính tới lúc xem. Không gồm giờ nhập tay trên task.',
        watch: 'Thấp bất thường thường là quên bấm giờ, không phải rảnh — hỏi trước khi kết luận.',
      },
      estimateRatio: {
        what: 'Giờ thực tế ÷ giờ ước lượng, cộng trên các task xong có cả hai.',
        read: '1 là khớp; 1,3 là tốn hơn ước lượng 30%; 0,8 là nhanh hơn. Giờ thực tế = số giờ người dùng nhập trên task, không có thì giờ bấm trên chính task ấy.',
        watch: 'Trên 1,5 hoặc dưới 0,7: ước lượng đang lệch có hệ thống.',
      },
      capacityThisWeek: {
        what: 'Tải tuần này (thứ Hai → Chủ nhật): giờ việc được giao ÷ giờ làm được.',
        read: 'Giờ việc = ước lượng của task được giao, trải đều trên các ngày làm việc từ ngày bắt đầu tới hạn, tính cả task đã xong từ thứ Hai. Giờ làm được = lịch làm việc trừ nghỉ phép và ngày lễ. Trên 100% đỏ (quá tải), từ 85% vàng.',
        watch: 'Trên 100% (đỏ) là quá tải; từ 85% (vàng) là sát trần.',
      },
      capacityAhead: {
        what: 'Tải của N ngày tới tính từ ngày mai, N bằng số ngày của kỳ đang chọn.',
        read: 'Cùng phép tính với Capacity tuần này nhưng chỉ task chưa xong. Luôn nhìn tới trước từ hôm nay, kể cả khi kỳ đang chọn nằm trong quá khứ.',
        watch: 'Trên 100% là đã nhận nhiều việc hơn số giờ có trong N ngày tới.',
      },
    },
    myPerf2Overview: {
      what: 'Tám con số của chính bạn trong kỳ đang chọn, mỗi số kèm mũi tên so với kỳ liền trước — cùng phép tính với Tổng quan đội.',
      read: 'Mũi tên xanh là tốt lên, đỏ là xấu đi, xám là không đổi hoặc chỉ số không có chiều tốt. Số này bằng đúng dòng của bạn trong bảng của quản lý. Bấm (i) ở mỗi ô để xem cách đo.',
      watch: 'Đúng hạn dưới 80% hay quá hạn tăng hai kỳ liền là lúc nên xem bảng Theo dự án để biết dự án nào đang kéo con số.',
    },
    myPerf2Projects: {
      what: 'Cùng các chỉ số của Tổng quan, tách theo từng dự án bạn có số trong kỳ này hoặc kỳ trước, hoặc đang có việc dở.',
      read: 'Dưới mỗi số là chênh lệch so với kỳ trước: xanh là tốt lên, đỏ là xấu đi. "—" là chưa đo được, không phải 0. Bấm tên dự án để mở dự án.',
      watch: 'Một dự án có giờ bấm mà không có task xong qua vài kỳ thường là việc đang kẹt hoặc việc quá to — tách nhỏ hoặc hỏi PM.',
    },
    myActivity: {
      what: 'Bạn cập nhật công việc bao nhiêu lần ở mỗi dự án, theo từng ngày của kỳ (kỳ dài hơn 62 ngày thì theo tuần).',
      read: 'Đếm mọi thao tác bạn tự làm: kéo thẻ, sửa việc, tick checklist, bình luận… Hàng cuối là tổng mọi dự án. Đo **thói quen cập nhật**, không đo năng suất.',
      watch: 'Một dự án trắng nhiều ngày trong khi bạn vẫn làm nó nghĩa là báo cáo của dự án đang không phản ánh đúng việc của bạn.',
    },
    teamActivity: {
      what: 'Mỗi người trong đội cập nhật công việc bao nhiêu lần, theo từng ngày của kỳ (kỳ dài hơn 62 ngày thì theo tuần), trên mọi dự án.',
      read: 'Mọi người trong đội đều có một hàng, kể cả người không cập nhật gì — hàng trắng là để nhìn ra họ. Đo **thói quen cập nhật**, không đo năng suất: ô nhạt là hôm đó không ghi nhận gì, chứ không phải không làm gì.',
      watch: '⚠️ Dữ liệu hiệu suất cá nhân — mỗi lượt mở được ghi vào sổ truy cập của từng người. Vùng nhạt kéo dài đáng hỏi vì dữ liệu báo cáo đang không đáng tin, không phải để đánh giá con người.',
    },
    myPerf2: {
      overdue: {
        what: 'Số việc của bạn đang giao, chưa xong tại cuối kỳ, có hạn trước ngày cuối kỳ.',
        read: 'Kỳ kết thúc hôm nay: đúng nghĩa "đang quá hạn". Kỳ trong quá khứ tính theo người được giao và hạn hiện tại.',
        watch: 'Tăng hai kỳ liền — dời hạn có lý do hoặc báo PM sớm, đừng để nó tự dồn.',
      },
      utilization: {
        what: 'Giờ bạn bấm chia cho giờ làm việc theo lịch của bạn trong kỳ.',
        read: 'Chỉ tính giờ từ đồng hồ bấm giờ — quên bấm giờ thì con số thấp không có nghĩa là rảnh.',
        watch: 'Dưới 50% thường là thiếu dữ liệu bấm giờ; trên 100% kéo dài là làm thêm giờ quá nhiều.',
      },
      working: {
        what: 'Số việc của bạn đang ở trạng thái "đang làm" lúc này. Phụ đề: tải tuần này.',
        read: 'Tải = giờ việc được giao ÷ giờ làm được trong tuần này, cùng cách tính với cột Capacity của bảng đội. Không có kỳ trước — đây là con số hiện tại.',
        watch: 'Nhiều việc cùng "đang làm" thường làm mọi việc cùng chậm; trên 100% tải là đã nhận nhiều hơn số giờ có.',
      },
    },
    teamPerf2Overview: {
      what: 'Tám con số của cả đội trong kỳ đang chọn, mỗi số kèm mũi tên so với kỳ liền trước (cùng độ dài; tháng so với tháng, tuần so với cùng các thứ của tuần trước).',
      read: 'Mũi tên xanh là tốt lên, đỏ là xấu đi, màu xám là không đổi hoặc chỉ số không có chiều tốt (giờ bấm, mức sử dụng). Màu là gợi ý để nhìn, không phải kết luận — một kỳ toàn việc dễ cũng làm task xong xanh lên. Tỷ lệ của đội cộng từ số đếm của mọi người, không phải trung bình tỷ lệ của từng người. Bấm (i) ở mỗi ô để xem cách đo.',
      watch:
        'Đúng hạn dưới 80%, quá hạn tăng hai kỳ liền, hoặc mức sử dụng dưới 50% / trên 100% là lúc nên mở tab Theo nhân sự để xem ai đang kéo con số.',
    },
    teamPerf2People: {
      what: 'Chỉ số đếm được của từng người trong kỳ: sản lượng, đúng hạn, chất lượng, dòng chảy và nỗ lực. Dưới mỗi số là chênh lệch so với kỳ trước.',
      read: 'Dưới mỗi số: xanh là tốt lên so với kỳ trước, đỏ là xấu đi (với Quá hạn, Xong trễ, Dời hạn, % mở lại, Cycle time thì giảm mới là tốt; Thực/ước lượng thì càng gần 1 càng tốt), xám là không đổi. Mặc định xếp theo tên — bấm tiêu đề cột để sắp, sắp không tải lại dữ liệu. "—" là chưa đo được (không có việc nào đủ điều kiện), không phải 0. Bấm tên người để mở hồ sơ đầy đủ và đặt mục tiêu.',
      watch:
        'Đây không phải bảng xếp hạng: không có điểm tổng. Một người xong ít task có thể đang gánh việc lớn — đọc SP và cycle time cùng nhau, và hỏi trước khi kết luận. Mỗi lần mở bảng được ghi vào sổ truy cập của từng người.',
    },
    teamPerf2: {
      throughput: {
        what: 'Số task xong trong kỳ (hiện vẫn xong), ghi cho người làm. Phụ đề: số mục checklist mọi người tự tay tick xong trong kỳ.',
        read: 'Bằng đúng cột "Task xong" của Nhân sự × dự án cùng kỳ. Task bị mở lại và chưa xong lại thì không đếm.',
        watch: 'Giảm hơn 30% so với kỳ trước mà số người hoạt động không giảm — xem có việc lớn nào đang kẹt.',
      },
      storyPoints: {
        what: 'Tổng story point của task xong: phần đã khai trên task, cộng phần ước lượng cho task không khai.',
        read: 'Ước lượng lấy gợi ý AI nếu có, không thì quy từ giờ ước lượng theo tỷ lệ giờ/điểm của tổ chức (trung vị, cần ít nhất 5 task có cả hai). Rê chuột vào ô "SP ước lượng" ở bảng để xem tách AI / công thức.',
        watch: 'Phần ước lượng lớn hơn phần khai là dấu hiệu đội ít chấm điểm — số này khi ấy kém tin cậy.',
      },
      onTime: {
        what: 'Phần trăm task xong trước hoặc đúng hạn, trên các task xong có hạn. Phụ đề: số task xong trễ.',
        read: 'So với hạn có hiệu lực lúc xong, không phải hạn hiện tại — dời hạn sau đó không đổi được con số này. Task không có hạn không vào mẫu số.',
        watch: 'Dưới 80% là đáng xem; dưới 60% thường là kế hoạch sai chứ không phải người chậm.',
      },
      overdue: {
        what: 'Số task đang giao, chưa xong tại cuối kỳ, có hạn trước ngày cuối kỳ. Phụ đề: số người có ít nhất một task quá hạn.',
        read: 'Kỳ kết thúc hôm nay: đúng nghĩa "đang quá hạn". Kỳ trong quá khứ: tính theo người được giao và hạn hiện tại, nên task đã đổi người hay dời hạn sau kỳ sẽ lệch.',
        watch: 'Tăng hai kỳ liền, hoặc dồn vào một hai người.',
      },
      cycle: {
        what: 'Số ngày (lịch) từ lúc bắt đầu làm thật tới lúc xong — trung vị trên mọi task xong của đội.',
        read: 'Trung vị nên một task kéo dài cả tháng không làm méo con số. Task chưa từng chuyển sang "đang làm" không có mốc bắt đầu nên không vào mẫu.',
        watch: 'Tăng dần qua các kỳ: việc đang to ra, hoặc đang chờ nhau nhiều hơn.',
      },
      reopen: {
        what: 'Phần trăm task xong trong kỳ từng bị mở lại sau khi đã xong.',
        read: 'Mở lại = chuyển từ cột "xong" về cột khác. Đếm một lần mỗi task dù mở lại bao nhiêu lần.',
        watch: 'Trên 15% là dấu hiệu "xong" đang được tuyên bố sớm, hoặc tiêu chí hoàn thành chưa rõ.',
      },
      utilization: {
        what: 'Giờ bấm của đội chia cho giờ làm việc theo lịch trong kỳ.',
        read: 'Chỉ tính giờ từ đồng hồ bấm giờ. Đội không quen bấm giờ thì con số thấp không có nghĩa là rảnh.',
        watch: 'Dưới 50% thường là thiếu dữ liệu bấm giờ; trên 100% là làm thêm giờ kéo dài.',
      },
      active: {
        what: 'Số người có task xong, giờ bấm hoặc mục checklist trong kỳ, trên tổng số người trong đội. Phụ đề: số người có tải tuần này trên 100%.',
        read: 'Tải = giờ việc được giao ÷ giờ làm được trong tuần này, cùng cách tính với cột Capacity của Nhân sự × dự án.',
        watch: 'Người không hoạt động trong kỳ có thể đang nghỉ phép — xem trước khi hỏi.',
      },
    },
    teamProjects: {
      what: 'Mỗi người trong đội làm ở những dự án nào trong kỳ: giờ đã bấm, task xong, task đang giao, % thời gian đăng ký và thực tế, story point xong, bậc nhân sự, cùng capacity tuần này và N ngày tới.',
      read: '% đăng ký là cam kết PM đặt cho người đó ở dự án (theo lịch làm việc); % thực tế là phần giờ bấm của người đó dồn vào dự án. Tab Phân bổ bày % thực tế thành ma trận: cột là người, hàng là dự án, mỗi cột cộng lại 100%. Lệch từ 20 điểm trở lên được tô vàng. Capacity = giờ việc được giao ÷ giờ làm được — trên 100% là quá tải, từ 85% là sát trần.',
      watch:
        'Giờ chỉ tính từ đồng hồ bấm giờ. Capacity tuần này tính cả việc đã xong từ thứ Hai. Cột "N ngày tới" nhìn tới trước từ ngày mai, N bằng số ngày của kỳ đang chọn.',
    },
    teamDaily: {
      what: 'Mỗi thành viên trong ngày đã chọn: đang bấm giờ trên việc gì, tổng thời gian làm việc, trong đó bao nhiêu là OT (ngoài ca theo lịch làm việc), xong bao nhiêu task và mục checklist.',
      read: 'Bấm một hàng để xem từng việc: giờ trong ngày, tiến độ đầu ngày → tới lúc này (số trong ngoặc là phần tăng thêm), và các mục checklist chính người đó đã tick. Dùng < > để xem ngày khác.',
      watch:
        'Giờ chỉ tính từ đồng hồ bấm giờ — người không bấm giờ hiện 0h dù có làm. Task xong được ghi cho người làm lúc đo velocity, không thì người được giao.',
    },
    allocation: {
      what: 'Mỗi người đang được phân bổ vào những dự án nào, và bao nhiêu phần trăm.',
      read: 'Cộng theo hàng để thấy tổng tải của một người: vượt 100% nghĩa là họ đã được hứa cho nhiều nơi hơn số giờ họ có.',
      watch:
        '⚠️ Đọc bảng này để lại dấu vết: mỗi lượt mở ghi một dòng nhật ký cho từng người trong bảng, và họ đọc được.',
    },
    // APM-GIT-j — chỉ số luồng của tab Git (plan-git-integration §7.1).
    gitCycleTime: {
      what: 'Một merge request mất bao lâu, chia bốn pha: Viết (commit đầu → sẵn sàng review; chưa từng nháp ⇒ lúc tạo MR), Chờ nhận review (sẵn sàng → lượt review đầu), Review (review đầu → merge), Lên bản (merge → lượt triển khai production thành công đầu tiên, ước lượng).',
      read: 'Mỗi cột là trung vị của các MR merge trong tuần, chồng theo pha; các ô bên dưới là trung vị và p85 của cả 12 tuần. MR không ai review hay chưa lên production không góp mẫu vào pha ấy (không tính là 0).',
      watch:
        'Chờ nhận review có trung vị trên 24 giờ: MR nằm chờ không ai nhận — thống nhất một khung giờ review. Review trên 2 ngày, hoặc p85 gấp hơn 3 lần trung vị: MR quá lớn, nên tách nhỏ.',
    },
    gitOpenAge: {
      what: 'Các merge request đang mở tại mốc đang xem, chia theo tuổi tính từ lúc tạo: dưới 1 ngày, 1–3, 3–7 và trên 7 ngày.',
      read: 'Phần lớn MR nên nằm ở hai cột đầu. Con số bên phải mỗi cột là số MR.',
      watch: 'Hơn 3 MR quá 7 ngày, hoặc cột > 7 ngày dài hơn cột < 1 ngày: việc đang dồn mà không merge — đóng hoặc làm xong MR cũ trước.',
    },
    gitDeployFrequency: {
      what: 'Số lượt triển khai thành công lên môi trường production mỗi tuần. Kho không có deployment thì đếm bản phát hành theo tag (phụ đề nói rõ).',
      read: 'Đọc xu hướng hơn là một tuần lẻ; tên môi trường production lấy từ cấu hình của kho.',
      watch: 'Dưới 1 lượt mỗi tuần suốt 4 tuần liền: thay đổi đang chờ dồn thành đợt lớn — phát hành nhỏ và đều thì ít rủi ro hơn.',
    },
    gitLeadTime: {
      what: 'Lead time thay đổi: từ commit đầu của một MR tới lúc nó lên production (ước lượng — lượt triển khai production thành công đầu tiên chứa commit merge, không có thì lượt đầu tiên sau merge trên cùng nhánh).',
      read: 'Cột là trung vị theo tuần, tính bằng ngày; ô bên dưới là trung vị và p85 của 12 tuần. Chỉ MR đã lên production mới được tính.',
      watch: 'Trung vị trên 7 ngày, hoặc tăng 3 tuần liền: xem pha nào dài ra ở biểu đồ bốn pha.',
    },
    gitUnlinkedWork: {
      what: 'Tỷ lệ commit trên nhánh mặc định trong 30 ngày qua không gắn với việc nào (không có mã việc ở nhánh, MR hay lời commit, và không ai gắn tay).',
      read: 'Phần việc nằm ngoài kế hoạch: sửa nóng, dọn code, việc vặt. Con số để nói chuyện với đội, không để chấm ai.',
      watch: 'Trên 30%: một phần lớn công sức không hiện trong kế hoạch lẫn velocity — thống nhất ghi mã việc vào tên nhánh.',
    },
  },
  chart: {
    asOf: 'Đang xem tại {{at}}',
    helpLabel: 'Cách đọc biểu đồ này',
    auditedLabel: 'Lượt xem được ghi lại',
    help: {
      what: 'Biểu đồ này cho biết gì',
      read: 'Đọc thế nào',
      watch: 'Khi nào đáng lo',
    },
    metricHelp: {
      what: 'Là gì',
      read: 'Đo thế nào',
      watch: 'Lưu ý',
    },
    itemCount: '{{count}} task',
    closeDrillDown: 'Đóng danh sách',
    deletedTask: 'đã xoá',
    drillDownEmpty: 'Không có task nào trong ô này.',
    drillDownTruncated: 'Còn {{count}} task nữa — đã cắt bớt danh sách.',
    drillDown: {
      flow_status: 'Task {{category}} ngày {{date}}',
      completed_on: 'Task hoàn thành ngày {{date}}',
      created_on: 'Task được tạo ngày {{date}}',
    },
    category: { todo: 'Chưa làm', in_progress: 'Đang làm', done: 'Đã xong' },
  },
  storageByProject: {
    title: 'Dung lượng file theo dự án',
    subtitle: 'Tổng {{total}} · file còn dùng được, không tính file đã xoá',
    files_one: '· {{count}} file',
    files_other: '· {{count}} file',
    summary: 'Dung lượng file: {{total}} trên {{n}} dự án',
    expand: 'Xem theo dự án',
    collapse: 'Thu gọn',
  },
  myPerf2: {
    overviewTitle: 'Tổng quan của tôi',
    projectsTitle: 'Theo dự án',
    empty: 'Chưa có số nào trong kỳ này',
    emptyHelp: 'Xong task, bấm giờ hoặc tick checklist ở một dự án là số sẽ hiện ở đây.',
    overview: {
      overdueSub: 'việc của tôi, hạn trước cuối kỳ',
      utilizationSub: '{{hours}}h bấm / {{scheduled}}h theo lịch',
      working: 'Đang làm',
      workingSub: 'tải tuần này {{pct}}%',
      workingSubOff: 'nghỉ cả tuần này',
    },
    cols: { project: 'Dự án' },
  },
  periodActivity: {
    axisPeople: 'Nhân sự',
    axisProjects: 'Dự án',
    axisDay: 'Ngày',
    axisWeek: 'Tuần',
    teamTitle: 'Mức độ cập nhật của đội',
    mineTitle: 'Mức độ cập nhật của tôi',
    subtitleDay: 'số lần cập nhật mỗi ngày',
    subtitleWeek: 'số lần cập nhật mỗi tuần — kỳ dài hơn 62 ngày',
    total: 'Tổng',
    rowTotal: 'Cộng',
    cellTitle: '{{label}} · {{column}}: {{count}} lần',
    weekOf: 'tuần từ {{date}}',
    teamEmpty: 'Không có ai trong đội để hiển thị',
    mineEmpty: 'Bạn chưa cập nhật gì trong kỳ này',
    emptyHelp: 'Biểu đồ đếm thao tác do người tạo — kéo thẻ, sửa việc, tick checklist, bình luận.',
  },
  teamPerf2: {
    title: 'Hiệu suất đội',
    overviewTitle: 'Tổng quan đội',
    compareTo: 'so với {{range}}',
    truncated:
      'Kỳ có hơn 5.000 việc xong — % đúng hạn và tỷ lệ mở lại chỉ đo 5.000 việc mới nhất.',
    views: { people: 'Theo nhân sự', projects: 'Nhân sự × dự án' },
    now: 'hiện tại',
    previousValue: 'Kỳ trước: {{value}}',
    unchanged: 'không đổi',
    days: '{{value}} ngày',
    helpLabel: 'Giải thích: {{name}}',
    sortBy: 'Sắp theo',
    openProfile: 'Xem hồ sơ của {{name}}',
    aiEstimate: 'Ước lượng SP bằng AI ({{n}} việc)',
    aiHint:
      'AI đọc tiêu đề, mô tả và checklist của việc đã xong mà chưa có điểm, rồi gợi ý story point. Gợi ý không ghi vào việc — chỉ hiện ở cột "SP ước lượng". Chạy theo quyền và ngân sách AI của bạn, tối đa 20 việc mỗi lần.',
    aiQueued:
      'Đã xếp {{n}} việc cho AI ước lượng ({{skipped}} việc chưa đủ chi tiết, dùng công thức). Tải lại sau ít phút để thấy số mới.',
    aiNothing:
      'Không còn việc nào đủ chi tiết để AI ước lượng ({{skipped}} việc chưa đủ chi tiết, dùng công thức).',
    dueExtensionsTitle: '{{n}} lần dời hạn trên {{tasks}} task',
    spEstimatedTitle:
      'AI: {{ai}} điểm · công thức: {{formula}} điểm · không ước lượng được: {{none}} việc',
    overview: {
      throughput: 'Task xong',
      throughputSub: '{{n}} mục checklist xong',
      storyPoints: 'Story point xong',
      storyPointsSub: '{{declared}} khai · {{estimated}} ước lượng',
      onTime: 'Đúng hạn',
      onTimeSub: '{{n}} việc xong trễ',
      overdue: 'Đang quá hạn',
      overdueSub: '{{n}} người có việc quá hạn',
      cycle: 'Cycle time',
      cycleSub: 'trung vị trên {{n}} việc',
      reopen: 'Mở lại',
      reopenSub: '{{n}} việc bị mở lại',
      utilization: 'Mức sử dụng',
      utilizationSub: '{{hours}}h bấm / {{scheduled}}h theo lịch',
      active: 'Nhân sự hoạt động',
      activeSub: '{{n}} người quá tải tuần này',
    },
    groups: {
      output: 'Sản lượng',
      deadline: 'Đúng hạn',
      quality: 'Chất lượng',
      flow: 'Dòng chảy',
      effort: 'Nỗ lực',
    },
    cols: {
      person: 'Nhân sự',
      tasksDone: 'Task xong',
      checklistDone: 'Mục checklist',
      spDeclared: 'SP khai',
      spEstimated: 'SP ước lượng',
      onTimePct: '% đúng hạn',
      lateDone: 'Xong trễ',
      dueExtensions: 'Dời hạn',
      overdueOpen: 'Quá hạn',
      reopenPct: '% mở lại',
      cycleDays: 'Cycle time',
      wip: 'Đang làm',
      hours: 'Giờ bấm',
      estimateRatio: 'Thực/ước lượng',
    },
  },
  teamProjects: {
    title: 'Nhân sự × dự án',
    presets: {
      thisWeek: 'Tuần này',
      thisMonth: 'Tháng này',
      lastMonth: 'Tháng trước',
      last90: '90 ngày',
    },
    from: 'Từ ngày',
    to: 'Đến ngày',
    totals: {
      hours: 'Giờ đã bấm',
      tasksDone: 'Task xong',
      storyPoints: 'Story point xong',
      projects: 'Dự án',
      people: 'Nhân sự',
    },
    grouping: 'Cách nhìn',
    by: { people: 'Theo nhân sự', projects: 'Theo dự án', matrix: 'Phân bổ Nhân sự × dự án' },
    matrixCorner: 'Dự án ↓ · Nhân sự →',
    matrixHours: '{{hours}} giờ',
    matrixCellHours: '~{{hours}} giờ',
    matrixCellTitle: '{{name}} dành {{pct}}% thời gian cho {{project}} — ~{{hours}} giờ',
    matrixNote:
      'Ô giao nhau là % thời gian của người ở cột dành cho dự án ở hàng — mỗi cột cộng lại 100%. Đầu cột và đầu hàng là tổng giờ đã bấm trong kỳ.',
    matrixEmpty: 'Chưa có ai bấm giờ cho dự án nào trong kỳ này.',
    person: 'Nhân sự',
    project: 'Dự án',
    memberProjectCount: 'Dự án đang tham gia',
    memberProjectCountHint:
      'Số dự án người này là thành viên, đang lập kế hoạch / đang thực hiện / tạm dừng — dù có việc trong kỳ hay không.',
    projectCount: 'Dự án có việc trong kỳ',
    projectCountHint:
      'Số dự án người này có giờ bấm, task xong, task đang giao hoặc cam kết trong kỳ đang chọn.',
    peopleCount: 'Số người',
    tasksDone: 'Task xong',
    storyPoints: 'Story point',
    level: 'Bậc',
    noLevel: 'Chưa xếp bậc',
    tasksOpen: 'Đang giao',
    hours: 'Giờ',
    thisWeek: 'Capacity tuần này',
    ahead: '{{count}} ngày tới',
    teamPct: '% giờ của đội',
    doneEstimate: 'Ước lượng việc xong',
    registeredPct: '% đăng ký',
    actualPct: '% thực tế',
    expand: 'Xem chi tiết của {{name}}',
    loadTitle: '{{committed}} giờ việc được giao / {{capacity}} giờ làm được',
    noCells: 'Không có dự án nào có giờ, task hay cam kết trong kỳ này.',
    empty: 'Chưa có ai trong đội',
    emptyHelp:
      'Bảng này hiện cả nhánh người bạn quản lý. Quản trị tổ chức gán người quản lý ở trang Nhân sự.',
  },
  teamDaily: {
    title: 'Hoạt động trong ngày của đội',
    scopeOrg: 'Cả tổ chức · {{count}} người',
    scopeDirect: 'Cấp dưới trực tiếp · {{count}} người',
    prev: 'Ngày trước',
    next: 'Ngày sau',
    today: 'hôm nay',
    backToToday: 'Hôm nay',
    audited:
      'Lượt xem được ghi vào nhật ký "Ai đã xem hồ sơ hiệu suất của tôi" của từng người (tối đa 30 phút một dòng) — không gửi thông báo hay Telegram.',
    filter: 'Lọc theo tên',
    member: 'Thành viên',
    state: 'Trạng thái',
    current: 'Đang làm',
    minutes: '{{count}} phút',
    hours: 'Giờ',
    totalHours: 'Tổng thời gian làm việc',
    overtime: 'OT',
    overtimeHelp:
      'Thời gian làm ngoài giờ — phần giờ bấm nằm ngoài ca theo lịch làm việc của người đó (ngày nghỉ, ngày lễ: cả ngày là OT).',
    tasksDone: 'Task xong',
    checklistDone: 'Checklist xong',
    totalHoursShort: 'Giờ làm',
    checklistDoneShort: 'Checklist',
    expand: 'Xem từng việc của {{name}}',
    states: { running: 'Đang làm', paused: 'Tạm dừng', idle: 'Không bấm giờ' },
    since: 'từ {{time}}',
    pausedAt: 'dừng lúc {{time}}',
    mostTime: 'Nhiều giờ nhất',
    mostProgress: 'Tiến độ tăng nhiều nhất',
    noItems: 'Không có việc nào có giờ bấm, tiến độ hay checklist trong ngày này.',
    item: 'Việc',
    project: 'Dự án',
    progress: 'Tiến độ trong ngày',
    checklist: 'Mục checklist đã tick',
    done: 'Xong',
    empty: 'Chưa có ai trong đội',
    emptyHelp:
      'Bảng này hiện người bạn quản lý trực tiếp. Quản trị tổ chức gán người quản lý ở trang Nhân sự.',
  },
  dashboard: {
    myProjectsTitle: 'Dự án tôi phụ trách ({{count}})',
    myProjectsHelp:
      'Cùng ba tín hiệu với bảng của lãnh đạo — độ trễ, rủi ro, tiến độ — cho từng dự án bạn làm PM.',
    myProjectsMore: 'Còn {{count}} dự án khác — xem ở trang Dự án.',
    orgProjectsTitle: 'Dự án trên sidebar ({{count}})',
    orgProjectsHelp:
      'Mọi dự án đang có trên sidebar của bạn, xếp đúng thứ tự sidebar — kể cả dự án bạn không trực tiếp phụ trách.',
    sidebarAllHidden: 'Mọi dự án ở mục này đã ẩn khỏi sidebar',
    sidebarAllHiddenHelp: 'Các dự án đã ẩn khỏi sidebar. Mở “Tất cả dự án” để hiện lại.',
    myObjectivesTitle: 'Mục tiêu S.M.A.R.T của các dự án',
    myObjectivesHelp: 'Mỗi dòng là một con số cần đạt. Báo số ở tab Điều lệ của từng dự án.',
    objectiveColumn: 'Mục tiêu',
    valueColumn: 'Hiện tại / Cần đạt',
    progressColumn: 'Tiến độ',
    noValueYet: 'chưa có số',
    tabMe: 'Của tôi',
    tabProject: 'Dự án',
    tabOrg: 'Toàn tổ chức',
    openCount: 'Việc đang mở',
    doneThisWeek: 'Xong trong 7 ngày',
    committed: 'Đã cam kết / năng lực',
    allClear: 'Không có việc nào cần xử lý ngay',
    allClearHelp: 'Không việc nào bị chặn, quá hạn, hay đến hạn hôm nay.',
    blocked: 'Đang bị chặn',
    blockedHelp: 'Việc cần làm ở đây là gỡ chặn, không phải làm nhanh hơn.',
    overdue: 'Quá hạn',
    dueToday: 'Đến hạn hôm nay',
    upcoming: 'Sắp tới',
    healthTitle: 'Bảng tình trạng dự án',
    healthSubtitle: '{{count}} dự án',
    healthEmpty: 'Chưa có dự án nào',
    healthEmptyHelp: 'Tạo dự án đầu tiên để bảng này có gì hiển thị.',
    project: 'Dự án',
    overall: 'Tổng thể',
    signalSchedule: 'Độ trễ',
    signalRisk: 'Rủi ro',
    signalProgress: 'Tiến độ',
    nextMilestone: 'Mốc kế tiếp',
    lateUnit: 'việc trễ',
    scoreUnit: 'điểm',
    gapUnit: 'điểm % chậm',
    projectHealthTitle: 'Tình trạng dự án',
    taskUnit: 'việc đã xong',
    lateTasks: '{{count}} việc trễ baseline',
    openRisks: '{{count}} rủi ro đang mở',
    noMilestone: 'Chưa có mốc nào phía trước',
    roadmapTitle: 'Roadmap toàn bộ dự án',
    roadmapSubtitle: '{{from}} → {{to}}',
    roadmapOpenEnded: 'từ {{start}} · chưa có hạn kết thúc',
    roadmapEmpty: 'Chưa dự án nào đặt ngày bắt đầu và kết thúc',
    roadmapEmptyHelp: 'Roadmap vẽ theo ngày dự án — đặt ngày ở trang cài đặt dự án.',
    milestone: 'Milestone',
    phaseGate: 'Cổng pha',
    passed: 'Đã qua',
    unscheduled: '{{count}} dự án chưa đặt ngày, không vẽ được lên trục',
    attention: {
      title: 'Cần bạn xử lý',
      hint: 'bấm một ô để lọc bảng danh mục hoặc tới khối liên quan',
      allClear: 'Không có gì cần xử lý ngay',
      atRisk: 'dự án nguy cơ cao',
      milestoneOverdue: 'mốc đã quá hạn',
      late: 'việc trễ so với baseline',
      riskRed: 'dự án rủi ro mức đỏ',
      objectivesLow: 'dự án mục tiêu dưới 50%',
      overloadedWeeks: 'tuần nhu cầu vượt năng lực',
      fromWeek: 'từ tuần {{date}}',
      unclocked: 'người chưa bấm giờ hôm nay',
      doneToday: 'việc xong hôm nay',
      idle: 'người còn dư năng lực (dưới 30%)',
      approvals: 'dự án chờ bạn duyệt',
    },
    ended: 'Đã kết thúc',
    endedOn: 'Đã kết thúc · {{date}}',
    pastEndBy: 'Quá ngày kết thúc {{n}} ngày',
    timelineWindow: '90 ngày',
    projectEnd: 'Kết thúc dự án',
    noMilestonesYet: 'Dự án chưa có mốc nào có ngày.',
    todayMark: 'Hôm nay',
    milestoneReached: 'Đã đạt',
    overdueBy: 'Quá hạn {{n}} ngày',
    endedAgo: 'Đã qua {{n}} ngày',
    inDays: 'Còn {{n}} ngày',
    portfolioTitle: 'Danh mục dự án',
    portfolioMatching: '{{shown}}/{{count}} dự án khớp bộ lọc',
    portfolioSort: 'Sắp xếp danh mục',
    portfolioSortBy: { risk: 'Rủi ro trước', due: 'Mốc gần nhất', sidebar: 'Theo sidebar' },
    clearFilter: 'Bỏ lọc',
    doneColumn: 'Hoàn thành',
    timelineColumn: 'Dòng thời gian',
    milestoneOverdue: 'quá hạn',
    expandProject: 'Xem mục tiêu của {{name}}',
    objectivesNowOnly: 'Mục tiêu chỉ có số hiện tại — ẩn khi xem theo ngày cũ.',
    noObjectives: 'Dự án chưa đặt mục tiêu cấp dự án nào.',
    openProject: 'Mở dự án',
    openProjectNamed: 'Mở dự án {{name}}',
    capacityTitle: 'Năng lực vs nhu cầu',
    capacityOk: '{{headcount}} người, không tuần nào vượt năng lực',
    capacityOverloaded: '{{count}} tuần nhu cầu vượt năng lực',
    capacityEmpty: 'Chưa có nhu cầu nào được lên kế hoạch',
    capacityEmptyHelp: 'Cần task có người phụ trách, ngày và giờ ước lượng.',
    demand: 'Nhu cầu',
    capacity: 'Năng lực',
    forwardLookingNote:
      'Năng lực và phân bổ luôn hiện theo kế hoạch hiện tại — không đổi theo mốc thời gian chọn ở trên.',
    allocationTitle: 'Phân bổ xuyên dự án',
    allocationSubtitle: '{{count}} người vượt 100%',
    allocationEmpty: 'Không có ai trong phạm vi bạn được xem',
    allocationEmptyHelp: 'Bạn xem được phân bổ của nhân sự dưới quyền trực tiếp.',
    allocationAudited:
      'Mỗi lượt mở bảng này được ghi lại, và người trong bảng đọc được dấu vết đó.',
    allocationIdleGroup: 'Dư năng lực (dưới {{pct}}%)',
    allocationShowAll: 'Xem cả {{n}} người',
    allocationShowLess: 'Thu gọn',
    person: 'Người',
    projectCount: 'Số dự án',
    hours: 'Giờ',
    allocationPct: 'Phân bổ',
    activityTitle: 'Mức độ cập nhật của đội',
    activitySubtitle: 'số lần cập nhật mỗi ngày, 4 tuần gần nhất',
    activityEmpty: 'Chưa có ai cập nhật gì trong khoảng này',
    activityEmptyHelp: 'Biểu đồ đếm sự kiện do người dùng tạo — kéo thẻ, sửa task, bình luận.',
  },
  reports: {
    loadingOnScroll: 'Biểu đồ sẽ tải khi cuộn tới',
    flowTitle: 'Luồng công việc',
    flowSubtitle: 'dựng từ {{count}} sự kiện',
    emptyTitle: 'Chưa có dữ liệu trong khoảng này',
    emptyHelp: 'Tạo task và kéo thẻ qua các cột — biểu đồ dựng từ chính lịch sử đó.',
    throughputTitle: 'Throughput',
    throughputSubtitle: 'số task hoàn thành mỗi tuần',
    completedCount: 'Task xong',
    noCompleted: 'Chưa task nào hoàn thành trong khoảng này',
    noCompletedHelp: 'Kéo một thẻ sang cột "Hoàn thành" — biểu đồ đọc chính lịch sử đó.',
    drillBand: 'Xem dải',
    cycleTitle: 'Cycle time & control chart',
    cycleSubtitle: 'p50 {{p50}} ngày · p85 {{p85}} ngày',
    cycleNoData: 'chưa đủ dữ liệu để tính percentile',
    cycleLegend: 'Cycle time',
    leadLegend: 'Lead time',
    p85Legend: 'Mốc p85',
    controlAverage: 'Trung bình động',
    controlUpper: 'Ngưỡng trên (2σ)',
    controlValue: 'Từng task',
    agingTitle: 'Aging WIP',
    agingThreshold: 'ngưỡng già: {{days}} ngày (p85 của dự án)',
    agingNoThreshold: 'chưa có task nào hoàn thành để tính ngưỡng',
    agingEmpty: 'Không có task nào đang dở',
    agingEmptyHelp: 'Mọi việc đều đã xong, hoặc chưa có việc nào được bắt đầu.',
    agingMore: 'còn {{count}} task nữa',
    ageDays: '{{days}} ngày',
    overThreshold: 'Quá ngưỡng',
    unassigned: 'Chưa phân công',
    burndownTitle: 'Burndown & đường scope',
    burndownRange: 'theo khoảng ngày đang xem',
    remaining: 'Còn lại',
    scope: 'Tổng scope',
    doneLine: 'Đã xong',
    ideal: 'Lý tưởng',
    pendingTitle: 'Báo cáo chưa chạy được',
    pending: {
      needSprint:
        'Cần ít nhất một sprint. Velocity đo số điểm hoàn thành **mỗi sprint**, nên dự án Waterfall hoặc bảo trì sẽ không bao giờ có số ở đây.',
      needPhaseGate:
        'Cần ít nhất một công việc thuộc hạng mục **Cổng pha**. Đặt hạng mục ấy khi tạo hoặc sửa công việc — dự án nào cũng dùng được, không riêng Waterfall.',
      needBaseline:
        'Cần chốt kế hoạch gốc: mở tab Công việc → Gantt → **Chốt kế hoạch gốc**. Không có mốc gốc thì không có gì để so tiến độ.',
    },
    velocityTitle: 'Velocity',
    asOfLabel: 'Xem theo ngày',
    asOfHint:
      'Chọn một ngày trong quá khứ để xem lại dữ liệu như hồi đó — không đổi dữ liệu hiện tại. Bỏ trống để quay về hiện tại.',
    backToNow: 'Về hiện tại',
    sprintFilter: 'Xem theo:',
    sprintFilterAll: 'Cả dự án',
    notBySprint: 'Nhóm này không đổi theo {{name}}',
    notBySprintHelp:
      'Sức khoẻ, rủi ro còn mở, cây mục tiêu và việc đang ì đều là câu hỏi ở tầng dự án hoặc câu hỏi về hiện tại — không có phiên bản “của một sprint”. Chọn “Cả dự án” để xem, hoặc sang nhóm Luồng công việc.',
    sprintFilterHidden:
      'Đã ẩn luồng công việc, cycle time và aging WIP — chúng nói về cả dự án hoặc về hiện tại, không tách theo sprint được.',
    velocityAverage: 'trung bình {{points}} point mỗi sprint đã đóng',
    velocityNoAverage: 'cần ít nhất hai sprint đã đóng để nói về trung bình',
    velocityEmpty: 'Dự án chưa có sprint nào',
    velocityEmptyHelp: 'Velocity chỉ có nghĩa với dự án Agile chạy theo sprint.',
    scopePoints: 'Point trong sprint (hiện tại)',
    sayDoRatio: 'làm được / đã nhận: {{ratio}}',
    donePoints: 'Point đã xong',
    committedPoints: 'Point đã nhận lúc bắt đầu',
    evmTitle: 'Đường cong S & Earned Value',
    evmSubtitle: 'SPI {{spi}} · CPI {{cpi}} — đơn vị: giờ ước lượng',
    evmNoIndex: 'chưa đủ dữ liệu để tính SPI/CPI',
    evmUnitNote:
      'AC suy ra từ thời gian task nằm ở cột "đang làm", không phải từ giờ bấm ở Timesheet.',
    evmUnestimated: '{{count}} task chưa ước lượng, không nằm trong phép tính',
    evmEmpty: 'Chưa vẽ được đường cong S',
    evmEmptyHelp:
      'EVM cần cả giờ ước lượng lẫn ngày kế hoạch cho task — nhập chúng ở Gantt hoặc ở form task.',
    pv: 'Kế hoạch (PV)',
    ev: 'Đã đạt (EV)',
    ac: 'Đã bỏ ra (AC)',
    slippageTitle: 'Độ trễ so với baseline',
    slippageSubtitle: 'baseline chốt {{at}}',
    slippageNoBaseline: 'dự án chưa chốt baseline — chưa có mốc để so',
    slippageEmpty: 'Không có việc nào trễ so với baseline',
    slippageEmptyHelp: 'Chốt baseline rồi biểu đồ sẽ đo độ trễ tích luỹ theo thời gian.',
    slippageDays: 'Ngày trễ tích luỹ',
    lateTasks: 'Số việc trễ',
    slippageWorst: 'Trễ nhiều nhất',
    slippageStillOpen: 'chưa xong',
    periodComparisonTitle: 'Kỳ này so với kỳ trước',
    periodComparisonSubtitle: 'Đối chiếu với {{previous}}',
    periodMetric: 'Chỉ số',
    periodCurrent: 'Kỳ này',
    periodPrevious: 'Kỳ trước',
    periodDelta: 'Chênh lệch',
    periodMetricName: {
      created: 'Việc mới phát sinh',
      completed: 'Việc đã đóng',
      openAtEnd: 'Tồn đọng cuối kỳ',
      unplannedPct: 'Tỉ lệ không kịp lên kế hoạch',
      avgCycleDays: 'Thời gian xử lý TB (ngày)',
    },
    gatesTitle: 'Trạng thái cổng pha',
    gatesSubtitle: '{{passed}}/{{total}} cổng đã qua',
    gatesEmpty: 'Dự án chưa có cổng pha nào',
    gatesEmptyHelp: 'Đổi loại một mốc thành "cổng pha" ở Gantt để theo dõi ở đây.',
    gatePassed: 'Đã qua',
    gateWaiting: 'Chưa qua',
    gateBlockers: '{{done}}/{{total}} điều kiện xong',
    gateLate: 'trễ {{days}} ngày',
    gateEarly: 'sớm {{days}} ngày',
    riskMatrixTitle: 'Ma trận rủi ro 5×5',
    riskMatrixSubtitle: '{{count}} rủi ro còn mở · tổng điểm {{exposure}}',
    riskUnscored: '{{count}} rủi ro chưa chấm điểm, không lên được ma trận',
    riskProbability: 'Xác suất →',
    riskImpact: 'Ảnh hưởng →',
    riskMatrixEmpty: 'Chưa có rủi ro nào còn mở',
    riskMatrixEmptyHelp:
      'Ghi rủi ro ở RAID log — mỗi rủi ro có xác suất và ảnh hưởng sẽ hiện ở đây.',
    riskBurndownTitle: 'Risk burndown',
    riskBurndownSubtitle: 'tổng điểm rủi ro còn mở theo thời gian',
    riskExposure: 'Tổng điểm còn mở',
    riskRetired: 'Đã xử lý',
    estimateTitle: 'Độ chính xác ước lượng',
    estimateSubtitle: 'trung vị {{ratio}}× so với ước lượng',
    estimateNoData: 'chưa có task nào hoàn thành kèm ước lượng',
    estimateEmpty: 'Chưa có dữ liệu ước lượng so với thực tế',
    estimateEmptyHelp:
      'Cần task đã xong VÀ có giờ ước lượng — biểu đồ đo trên chính hai con số đó.',
    estimateHours: 'Giờ ước lượng',
    actualHours: 'Giờ thực tế',
    estimatePerfect: 'Đúng ước lượng',
    estimateBlocked: 'Từng bị chặn',
    estimateBlockedNote: 'Chấm rỗng là task từng bị chặn — chậm ở đó có thể do ngoại cảnh.',
    estimateByAssignee: 'Theo người',
    estimateByType: 'Theo loại task',
    estimateMedian: '{{ratio}}× ({{count}} task)',
    objectivesTitle: 'Task phục vụ mục tiêu nào',
    objectivesSubtitle: '{{orphans}} mục tiêu chưa có task nào phục vụ',
    objectivesAllServed: 'mọi mục tiêu đều đã có task phục vụ',
    objectivesEmpty: 'Dự án chưa có mục tiêu nào',
    objectivesEmptyHelp: 'Đặt mục tiêu và gắn task vào để thấy việc nào phục vụ mục tiêu nào.',
    objectiveOrphan: 'Chưa có task nào',
    objectivesUnlinked: '{{count}} task không phục vụ mục tiêu nào',
    crTrendTitle: 'Xu hướng Change Request',
    crTrendSubtitle: '{{count}} CR trong khoảng đang xem',
    crTrendEmpty: 'Chưa có CR nào trong khoảng này',
    crTrendEmptyHelp:
      'Số CR tăng dần là tín hiệu sớm của scope creep — biểu đồ này để thấy nó sớm.',
    crCreated: 'Đã đề xuất',
    crApproved: 'Đã duyệt',
    crRejected: 'Bị từ chối',
    crApplied: 'Đã áp dụng',
    documentsTitle: 'Trạng thái tài liệu',
    documentsSubtitle: '{{count}} tài liệu',
    documentsEmpty: 'Dự án chưa có tài liệu nào',
    documentsEmptyHelp: 'Tạo tài liệu từ khuôn dựng sẵn ở màn hình Tài liệu.',
    docDraft: 'Chưa gửi duyệt',
    docReview: 'Chờ duyệt',
    docApproved: 'Đã duyệt',
    docStale: 'Chờ duyệt quá {{days}} ngày',
    docWaiting: '{{days}} ngày',
    resourceTitle: 'Phân bổ nhân lực theo tuần',
    resourceSubtitle: 'giờ đã cam kết so với năng lực — cộng cả dự án khác',
    resourceEmpty: 'Chưa có ai được phân công việc có ngày',
    resourceEmptyHelp: 'Cần task có người phụ trách, ngày bắt đầu, hạn và giờ ước lượng.',
    resourceCommitted: 'Đã cam kết',
    resourceCapacity: 'Năng lực',
    resourceOverloaded: 'Vượt năng lực',
    resourceNote:
      'Biểu đồ này nhìn về tương lai theo kế hoạch hiện tại, nên không đổi theo mốc thời gian đang xem.',
    tabMaintenance: 'Vận hành & bảo trì',
    tabIssues: 'Issue',
    unplannedTitle: 'Tỉ lệ việc phát sinh',
    unplannedSubtitle: 'Việc được tạo sát ngày phải làm (trong {{days}} ngày)',
    unplannedTooltip: '{{percent}}% — {{unplanned}}/{{counted}} việc',
    unplannedNoData: 'Tuần này không có việc nào tính được',
    unplannedNote:
      'Chỉ tính những việc có ngày bắt đầu hoặc hạn. Việc không có ngày nào thì không biết được đã chuẩn bị bao lâu, nên không vào cả tử lẫn mẫu.',
    unplannedEmpty: 'Chưa có việc nào để đo',
    unplannedEmptyHelp:
      'Cần việc có ngày bắt đầu hoặc hạn thì mới tính được thời gian chuẩn bị. Thêm ngày cho vài việc rồi quay lại.',
    tabSummary: 'Sức khoẻ dự án',
    tabFlow: 'Luồng công việc',
    tabSchedule: 'Kế hoạch & tiến độ',
    tabGovernance: 'Rủi ro & quản trị',
    summaryHelp:
      'Những con số trả lời câu hỏi ở tầng dự án. Biểu đồ chỉ có nghĩa trong một khoảng ngắn nằm ở các nhóm bên cạnh.',
    groupEmpty: 'Nhóm này chưa có gì để xem',
    groupEmptyShort: 'Dự án này chưa có dữ liệu cho nhóm đó',
    groupEmptyReason: {
      no_issues:
        'Dự án chưa ghi nhận vấn đề nào từ người dùng. Chưa có sự cố là chuyện tốt — nhóm này sẽ có số liệu ngay khi vấn đề đầu tiên được ghi.',
      no_end_date:
        'Dự án bảo trì không có ngày kết thúc, nên những biểu đồ đo tiến độ so với mốc kết thúc (EVM, trượt tiến độ, cổng pha) không áp dụng được. Xem nhóm "Vận hành & bảo trì".',
      not_maintenance: 'Nhóm này chỉ dành cho dự án bảo trì.',
      no_tasks:
        'Dự án chưa có việc nào, nên chưa có luồng công việc để đo. Tạo vài việc ở tab Board rồi quay lại.',
      no_baseline:
        'Chưa có việc nào được chốt baseline và chưa có cổng pha nào. Chốt baseline ở tab Công việc → Gantt để đo được độ bám kế hoạch.',
      no_governance_data:
        'Chưa có rủi ro, mục tiêu, yêu cầu thay đổi hay tài liệu nào. Với một dự án nhỏ thì đây có thể là chuyện bình thường.',
    },
  },
  // Hai nút Đổi mốc / Đổi hạn cuối ở tab Thay đổi — APM-DL-b.
  deadlineChange: {
    milestoneButton: 'Đổi mốc',
    deadlineButton: 'Đổi hạn cuối',
    milestoneTitle: 'Đổi ngày của một mốc',
    deadlineTitle: 'Đổi hạn cuối dự án hoặc sprint',
    notifyHint: 'Lưu xong, mọi thành viên của dự án sẽ nhận thông báo về ngày mới.',
    milestone: 'Mốc',
    target: 'Hạn cuối của',
    projectTarget: 'Dự án «{{name}}»',
    sprintTarget: 'Sprint «{{name}}»',
    currentDate: 'Hạn hiện tại: {{date}}',
    noDate: 'chưa đặt',
    newDate: 'Ngày mới',
    noMilestones: 'Dự án chưa có mốc nào',
    noMilestonesHelp: 'Đổi một việc thành mốc ở form việc hoặc trên Gantt, rồi quay lại đây.',
    noTargets: 'Chưa có hạn cuối nào để đổi',
    noTargetsHelp: 'Dự án bảo trì không có hạn cuối, và dự án này chưa có sprint nào đang mở.',
    milestoneSaved: 'Đã dời mốc «{{name}}» sang {{date}}',
    deadlineSaved: 'Đã đổi hạn cuối của {{name}} sang {{date}}',
    rebalanceHint: 'Cả đội đã được báo. Xem lại việc để cân bằng cho khớp hạn mới.',
    rebalance: 'Cân bằng lại việc',
  },
  changes: {
    absenceTitle: 'Nhân sự nghỉ trùng lịch việc',
    absenceHelp:
      'Người trong dự án xin nghỉ đúng khoảng có việc đang giao cho họ. Kế hoạch sắp sai dù không ai đổi gì.',
    title: 'Yêu cầu thay đổi',
    new: 'Yêu cầu mới',
    create: 'Tạo yêu cầu',
    createHint: 'Nội dung và lý do đều bắt buộc — người duyệt cần cả hai.',
    crTitle: 'Tiêu đề',
    titlePlaceholder: 'Đổi gì, một câu ngắn',
    kindLabel: 'Loại thay đổi',
    description: 'Nội dung thay đổi',
    descriptionPlaceholder: 'Cụ thể đổi gì: phạm vi, mốc thời gian, nhân lực, ngân sách…',
    reason: 'Lý do',
    reasonPlaceholder: 'Vì sao cần đổi? Sáu tháng nữa đây là câu trả lời duy nhất còn lại.',
    historyTitle: 'Lịch sử thay đổi',
    historyHelp:
      'Mọi thay đổi đã ghi nhận trong dự án, mới nhất trước — kể cả những thay đổi không đi qua yêu cầu thay đổi.',
    affectedTasks: 'Task liên quan (giữ Ctrl để chọn nhiều)',
    empty: 'Chưa có yêu cầu thay đổi nào',
    emptyHelp: 'Mọi thay đổi kế hoạch sau khi chốt baseline đều nên đi qua đây.',
    impact: 'Ảnh hưởng',
    impactTotals: '{{count}} task · {{hours}} giờ · {{people}} người',
    impactTruncated: 'Còn nhiều task nữa bị kéo theo — đã cắt bớt danh sách.',
    noTasksLinked: 'Yêu cầu này chưa gắn task nào, nên chưa dò được ảnh hưởng.',
    direct: 'Nêu tên',
    downstream: 'kéo theo (cách {{distance}} bước)',
    critical: 'Đường găng',
    analyse: 'Nhờ AI nhận xét',
    analysePrompt: 'Nhận xét ảnh hưởng của yêu cầu thay đổi này giúp tôi.',
    note: 'Ghi chú',
    notePlaceholder: 'Ghi chú cho người duyệt, hoặc lý do từ chối…',
    decisionNote: 'Ghi chú duyệt: {{note}}',
    versionLabel: 'Nhãn phiên bản',
    labelPlaceholder: 'Nhãn cho phiên bản sắp tạo, vd "Dời mốc UAT"',
    submit: 'Gửi duyệt',
    approve: 'Duyệt',
    reject: 'Từ chối',
    apply: 'Áp dụng & chốt lại kế hoạch',
    applied: 'Đã áp dụng, kế hoạch chốt lại thành v{{no}}',
    appliedAs: 'Đã áp dụng — sinh ra v{{no}}',
    versions: 'Phiên bản kế hoạch',
    originalPlan: 'Kế hoạch gốc',
    compare: 'So sánh',
    compareFrom: 'Phiên bản cũ',
    compareTo: 'Phiên bản mới',
    compareOrder: 'Chọn phiên bản cũ trước phiên bản mới.',
    diffHeader: 'Khác biệt giữa v{{from}} và v{{to}} — dựng từ {{events}} sự kiện',
    diffEmpty: 'Hai phiên bản này giống nhau.',
    diffTruncated: 'Còn nhiều thay đổi nữa — đã cắt bớt danh sách.',
    kind: {
      scope: 'Phạm vi',
      schedule: 'Tiến độ',
      resource: 'Nhân lực',
      budget: 'Ngân sách',
      other: 'Khác',
    },
    status: {
      draft: 'Bản nháp',
      submitted: 'Chờ duyệt',
      approved: 'Đã duyệt',
      rejected: 'Bị từ chối',
      applied: 'Đã áp dụng',
    },
    change: { added: 'thêm mới', removed: 'đã xoá', changed: 'đã đổi' },
    dependency: { added: 'thêm phụ thuộc', removed: 'bỏ phụ thuộc' },
    field: {
      title: 'Tiêu đề',
      startDate: 'Bắt đầu',
      dueDate: 'Hạn',
      assignee: 'Người làm',
      estimateHours: 'Ước lượng',
      status: 'Trạng thái',
    },
  },
  documents: {
    new: 'Tài liệu mới',
    backToList: 'Danh sách tài liệu',
    reorder: 'Sắp xếp',
    reorderLabel: 'Sắp xếp thứ tự tài liệu',
    reorderTitle: 'Kéo núm ⠿ để đổi thứ tự tài liệu, rồi bấm Lưu thứ tự.',
    reorderFiltered: 'Bỏ ô tìm kiếm và bộ lọc để sắp xếp toàn bộ danh sách',
    reorderSave: 'Lưu thứ tự',
    reorderSaved: 'Đã lưu thứ tự tài liệu',
    dragHandle: 'Kéo để đổi chỗ “{{title}}”',
    formatContent: 'Nội dung soạn trực tiếp (Markdown)',
    create: 'Tạo tài liệu',
    createFromFile: 'Tạo từ tệp tải lên',
    createHint: 'Chọn khuôn dựng sẵn, hoặc gõ nội dung.',
    title: 'Tiêu đề',
    titlePlaceholder: 'Tên tài liệu, vd "Đặc tả yêu cầu thanh toán"',
    template: 'Khuôn',
    kindSelect: 'Loại tài liệu',
    unclassified: 'Chưa phân loại',
    useTemplateNamed: 'Điền sẵn từ khuôn “{{name}}”',
    useTemplate: 'Điền sẵn từ một khuôn',
    pickTemplate: 'Chọn khuôn…',
    content: 'Nội dung',
    contentPlaceholder: 'Nội dung markdown. Bỏ trống nếu bắt đầu từ một khuôn.',
    search: 'Tìm trong tài liệu',
    searchPlaceholder: 'Tìm… (gõ không dấu cũng ra)',
    filterKind: 'Lọc theo loại',
    filterStatus: 'Lọc theo trạng thái',
    allKinds: 'Mọi loại',
    allStatuses: 'Mọi trạng thái',
    empty: 'Kho tài liệu đang trống',
    emptyHelp: 'Tạo tài liệu đầu tiên từ một khuôn dựng sẵn — SRS, thiết kế, kế hoạch kiểm thử.',
    noMatch: 'Không có tài liệu nào khớp “{{query}}”',
    noMatchHelp: 'Thử ít từ hơn. Tìm kiếm khớp cả khi gõ không dấu.',
    versionCount: '{{count}} phiên bản',
    matchedIn: 'khớp ở v{{no}}',
    approvedVersion: 'đã duyệt v{{no}}',
    approvedHint: 'Đã duyệt. Thêm phiên bản mới sẽ đưa tài liệu về bản nháp.',
    history: 'Lịch sử phiên bản',
    noChangeNote: '(không ghi chú thay đổi)',
    unknownAuthor: 'Không rõ',
    fileOnly: 'Phiên bản này là tệp đính kèm, không có nội dung soạn trong app.',
    extraction: {
      pending: 'đang đọc nội dung…',
      skipped: 'chưa đọc được nội dung',
      failed: 'đọc nội dung thất bại',
    },
    newVersion: 'Tạo phiên bản mới',
    newVersionHelp:
      'Mở để sửa: soạn tiếp bản mới nhất trong app, mỗi lần Lưu là một phiên bản mang ghi chú trên. Hoặc tải một tệp lên làm phiên bản mới.',
    newVersionUploadOnly:
      'Định dạng này không soạn trong app được — tải tệp đã sửa lên làm phiên bản mới.',
    versionStatus: { superseded: 'Bản cũ' },
    versionAdded: 'Đã lưu thành v{{no}}',
    changeNote: 'Có gì thay đổi so với bản trước?',
    changeNotePlaceholder: 'Đổi gì so với bản trước?',
    uploadVersion: 'Tải bản mới lên',
    uploading: 'Đang tải lên…',
    note: 'Ghi chú duyệt',
    notePlaceholder: 'Ghi chú cho người duyệt, hoặc lý do trả lại…',
    submit: 'Gửi duyệt',
    approve: 'Duyệt',
    reject: 'Trả lại bản nháp',
    delete: 'Xoá tài liệu',
    deleteTitle: 'Xoá tài liệu “{{title}}”?',
    deleteBody:
      'Tài liệu cùng mọi phiên bản sẽ biến khỏi kho. Lấy lại được ở tab Thay đổi của dự án.',
    deleteConfirm: 'Xoá',
    deleted: 'Đã xoá “{{title}}” — lấy lại ở tab Thay đổi.',
    // Đổi tên tài liệu — APM-DREN.
    rename: 'Đổi tên',
    renameTitle: 'Đổi tên “{{title}}”',
    renameLabel: 'Tên mới',
    renameHint: 'Chỉ đổi tên hiển thị trong dự án — tệp đã tải lên giữ nguyên.',
    renameEmpty: 'Tên không được để trống.',
    renameTooLong: 'Tên dài tối đa {{max}} ký tự.',
    renamed: 'Đã đổi tên thành “{{title}}”',
    quickApprove: 'Duyệt nhanh “{{title}}”',
    quickApproved: 'Đã duyệt “{{title}}”.',
    restore: 'Khôi phục',
    restored: 'Đã khôi phục “{{title}}”.',
    openEditor: 'Mở để sửa',
    preview: {
      open: 'Xem trước “{{title}}”',
      edit: 'Sửa',
      editUnsupported: 'Chưa sửa được định dạng này trong app — tải về để sửa.',
      viewInFiles: 'Xem trong Tệp',
      viewInFilesOthers: 'Tệp này do người khác tải lên nên không nằm trong Tệp của bạn.',
      maximize: 'Mở rộng tối đa',
      restore: 'Thu nhỏ lại',
      download: 'Tải về',
      details: 'Phiên bản & duyệt',
      back: 'Xem trước',
      empty: 'Tài liệu này chưa có nội dung.',
    },
    share: {
      button: 'Chia sẻ ra ngoài — chưa chia sẻ',
      buttonShared: 'Chia sẻ ra ngoài — đang chia sẻ: {{audience}}',
      badgeTitle: 'Đang chia sẻ: {{audience}} · {{version}}',
      title: 'Chia sẻ tài liệu',
      viewOnly: 'Người nhận chỉ xem, không sửa được. Bình luận trong tài liệu không bao giờ được chia sẻ.',
      notShared: 'Chưa chia sẻ ra ngoài dự án',
      managersOnly: 'Chỉ người có quyền duyệt tài liệu mới đổi được chia sẻ.',
      audienceLabel: 'Ai xem được',
      audience: {
        org: 'Trong tổ chức',
        chillpm: 'Có tài khoản ChillPM',
        public: 'Bất cứ ai có link',
      },
      audienceShort: { org: 'Trong tổ chức', chillpm: 'Có tài khoản', public: 'Ai có link' },
      audienceHelp: {
        org: 'Mọi người trong tổ chức của bạn, kể cả ngoài dự án — phải đăng nhập.',
        chillpm: 'Người ngoài tổ chức cũng xem được, miễn có tài khoản ChillPM và đăng nhập.',
        public: 'Không cần đăng nhập — ai cầm link cũng xem được.',
      },
      versionLabel: 'Phiên bản được chia sẻ',
      versionMode: {
        version: 'Một phiên bản cụ thể',
        latest_approved: 'Bản đã duyệt mới nhất',
        latest: 'Bản mới nhất',
        all: 'Tất cả phiên bản',
      },
      versionModeHelp: {
        version: 'Người nhận luôn thấy đúng bản này, kể cả khi có bản mới hơn.',
        latest_approved: 'Bản nháp chưa lộ ra cho tới khi được duyệt.',
        latest: 'Kể cả bản nháp — mỗi lần lưu là người nhận thấy ngay.',
        all: 'Người nhận xem được mọi bản, có nút Phiên bản & duyệt.',
      },
      noApprovedYet: 'Chưa có bản nào được duyệt — người nhận sẽ chưa thấy gì.',
      versionPinned: 'Phiên bản v{{no}}',
      pickVersion: 'Chọn phiên bản',
      versionOption: 'v{{no}} · {{date}}',
      link: 'Link chia sẻ',
      copy: 'Chép',
      copied: 'Đã chép link chia sẻ',
      copyFailed: 'Chưa chép được — chọn link rồi chép tay.',
      opens: '{{count}} lượt mở',
      enable: 'Chia sẻ',
      save: 'Lưu thay đổi',
      saved: 'Đã cập nhật chia sẻ',
      revoke: 'Tắt chia sẻ',
      revokeConfirm: 'Tắt chia sẻ? Link hiện tại sẽ không mở được nữa; bật lại sẽ ra link mới.',
      revoked: 'Đã tắt chia sẻ',
      pending: '{{count}} phiên bản đang chờ chuẩn bị bản chia sẻ (không bình luận).',
      preparing: 'Đang chuẩn bị {{count}} phiên bản cho người nhận…',
      preparingFailed: 'Chưa chuẩn bị được {{count}} phiên bản — người nhận đang thấy "đang chuẩn bị".',
      retry: 'Thử lại',
    },
    status: { draft: 'Chưa gửi duyệt', review: 'Chờ duyệt', approved: 'Đã duyệt' },
    kind: {
      srs: 'Đặc tả',
      design: 'Thiết kế',
      test_plan: 'Kế hoạch kiểm thử',
      meeting_minutes: 'Biên bản họp',
      contract: 'Hợp đồng',
      other: 'Khác',
    },
  },
  /**
   * Issue vận hành — docs/plan-issue-management.md.
   *
   * ⚠️ Tên khối là `issueTracking`, **không** phải `issue`: đặt tên theo miền
   * chứ không theo từ chung. Bài học `budget` ở APM-AI-n — một khoá cấp cao
   * nhất trùng tên sẽ đè khối đang có, và typecheck không bắt được vì `en.ts`
   * và `vi.ts` chỉ cần khớp **nhau** về hình dạng.
   */
  issueTracking: {
    add: 'Ghi nhận vấn đề',
    created: 'Đã ghi nhận vấn đề',
    overridden: '(đã chỉnh mức)',
    noCommitment: 'Không cam kết',
    unassigned: 'Chưa giao',
    kind: { incident: 'Sự cố', request: 'Yêu cầu', problem: 'Nguyên nhân gốc' },
    state: {
      new: 'Mới',
      triaged: 'Đã phân loại',
      in_progress: 'Đang xử lý',
      waiting_customer: 'Chờ người báo',
      waiting_third_party: 'Chờ bên ngoài',
      resolved: 'Đã xử lý xong',
      reopened: 'Mở lại',
      closed: 'Đã đóng',
    },
    priority: { 1: 'P1 · Gấp nhất', 2: 'P2 · Cao', 3: 'P3 · Vừa', 4: 'P4 · Thấp' },
    channel: {
      portal: 'Khách tự nhập',
      email: 'Email',
      phone: 'Điện thoại',
      chat: 'Chat',
      monitoring: 'Hệ thống giám sát',
      internal: 'Nội bộ ghi nhận',
    },
    impactScale: {
      1: 'Một người dùng',
      2: 'Một nhóm hoặc một phòng',
      3: 'Toàn bộ người dùng',
    },
    urgencyScale: {
      1: 'Chờ được',
      2: 'Cản trở, có cách làm vòng',
      3: 'Đang dừng việc',
    },
    waitReason: {
      need_info: 'Chờ thêm thông tin',
      need_approval: 'Chờ duyệt',
      customer_testing: 'Chờ người báo kiểm tra',
      vendor_fix: 'Chờ nhà cung cấp',
      scheduled_window: 'Chờ cửa sổ bảo trì',
      other: 'Lý do khác',
    },
    maintenanceCategory: {
      corrective: 'Sửa lỗi',
      adaptive: 'Theo môi trường đổi',
      perfective: 'Cải thiện',
      preventive: 'Phòng ngừa',
    },
    reports: {
      hourSuffix: 'h',
      noData: 'Chưa có vấn đề nào trong kỳ này',
      noClosed: 'Chưa đóng vấn đề nào trong kỳ này',
      noOpen: 'Không còn vấn đề nào đang mở',
      noHours: 'Chưa có giờ xử lý nào được tính',
      arrival: {
        title: 'Vào / ra theo tuần',
        subtitle: 'Mỗi tuần nhận bao nhiêu vấn đề mới và đóng được bao nhiêu',
        created: 'Ghi nhận mới',
        closed: 'Đã đóng',
      },
      cycle: {
        title: 'Thời gian xử lý theo mức ưu tiên',
        subtitle: 'Phân vị, không phải trung bình',
        samples: 'Số mẫu',
        p50: 'Một nửa xong trong',
        p85: '85% xong trong',
      },
      sla: {
        title: 'Tuân thủ cam kết',
        subtitle: 'Chỉ tính những vấn đề **có** cam kết',
        response: 'Phản hồi đúng hạn',
        resolution: 'Xử lý đúng hạn',
      },
      aging: {
        title: 'Tuổi vấn đề đang mở',
        subtitle: 'Chụp lúc {{at}}',
        upTo: 'tới {{days}} ngày',
        older: 'lâu hơn',
        count: 'Đang mở',
        overdue: 'Đã quá hạn',
      },
      maintenance: {
        title: 'Công sức bảo trì đi vào đâu',
        subtitle: 'Theo giờ quy đổi, không theo số vấn đề',
        category: 'Loại',
        count: 'Số vấn đề',
        hours: 'Giờ',
        unclassified: 'Chưa phân loại',
      },
    },
    filter: { label: 'Lọc vấn đề', open: 'Chưa xong', all: 'Tất cả' },
    column: {
      code: 'Mã',
      title: 'Nội dung',
      priority: 'Mức ưu tiên',
      state: 'Trạng thái',
      due: 'Hạn xử lý',
      assignee: 'Người xử lý',
    },
    empty: {
      title: 'Chưa có vấn đề nào được ghi nhận',
      description:
        'Mỗi sự cố hoặc yêu cầu từ người dùng ghi vào đây sẽ được tính hạn xử lý theo mức ưu tiên, và vào báo cáo vận hành của dự án.',
      action: 'Ghi nhận vấn đề đầu tiên',
    },
    form: {
      kind: 'Loại',
      title: 'Chuyện gì đã xảy ra?',
      description: 'Mô tả',
      steps: 'Các bước tái hiện',
      stepsHint: 'Làm gì thì gặp lại lỗi này? Không dựng lại được thì không sửa được.',
      impact: 'Ảnh hưởng tới bao nhiêu người?',
      impactHint: 'Đếm người đang bị ảnh hưởng, không phải mức độ khó chịu.',
      urgency: 'Gấp tới đâu?',
      urgencyHint: 'Có cách nào làm vòng để tạm thời vẫn làm việc được không?',
      resulting: 'Mức ưu tiên:',
      resultingHint: 'Tính từ hai câu trả lời trên.',
      channel: 'Nhận qua đâu',
      reportedBy: 'Người báo',
      reportedByHint: 'Tên người thật sự gặp vấn đề',
      submit: 'Ghi nhận',
    },
    // Popup chi tiết ở tab Issue — APM-ISC-d.
    detail: {
      label: 'Chi tiết vấn đề',
      open: 'Mở chi tiết {{code}}',
      reporter: 'Người gửi',
      internalNote: 'Ghi chú nội bộ',
      none: 'Chưa có.',
      threads: 'Luồng trao đổi',
      tabPublic: 'Trao đổi với người gửi',
      tabInternal: 'Nội bộ',
    },
    // Luồng trao đổi — APM-ISC-d/-e. Chỉ ghi thêm: lời đã gửi không sửa, không xoá.
    thread: {
      empty: 'Chưa có trao đổi nào.',
      emptyInternal: 'Chưa có trao đổi nội bộ.',
      internalBanner: 'Chỉ đội xử lý thấy — người gửi không đọc được luồng này.',
      labelPublic: 'Trả lời người gửi',
      labelInternal: 'Ghi chú cho đội xử lý',
      placeholderPublic: 'Trả lời người gửi… (gửi rồi không sửa được)',
      placeholderInternal: 'Ghi chú cho đội xử lý… (người gửi không thấy)',
      labelReporter: 'Nhắn cho đội xử lý',
      placeholderReporter: 'Nhắn cho đội xử lý… (gửi rồi không sửa được)',
      send: 'Gửi trả lời',
      sendInternal: 'Gửi nội bộ',
      closedHint: 'Vấn đề đã đóng — mở lại để trao đổi tiếp.',
    },
  },
  raid: {
    all: 'Tất cả',
    add: 'Thêm hạng mục',
    typeLabel: 'Loại',
    addRisk: 'Thêm rủi ro đầu tiên',
    save: 'Lưu',
    empty: 'RAID log đang trống',
    emptyHelp:
      'Ghi lại rủi ro, hành động, vấn đề và quyết định ở đây. Rủi ro xảy ra thật thì escalate thành vấn đề bằng một cú bấm.',
    created: 'Đã thêm {{code}}',
    escalate: 'Escalate',
    escalateHint: 'Rủi ro đã xảy ra thật — tạo vấn đề trỏ về rủi ro này',
    escalated: '{{risk}} đã escalate thành {{issue}}',
    fromRisk: 'từ {{code}}',
    becameIssue: '→ {{code}}',
    frozenHint: 'Rủi ro đã escalate được giữ nguyên làm lịch sử. Hãy sửa vấn đề sinh ra từ nó.',
    col: {
      no: 'Mã',
      category: 'Loại',
      description: 'Nội dung',
      priority: 'Mức độ',
      nextActions: 'Hướng xử lý tiếp',
      owner: 'Phụ trách',
      lastUpdate: 'Cập nhật',
    },
    /** Bốn mức của cột "Mức độ" trên bảng RAID log — khác `severity` (chuỗi
     *  mô tả mức nghiêm trọng 1–5 của một hạng mục đơn lẻ). */
    severityLevel: {
      critical: 'Nghiêm trọng',
      high: 'Cao',
      medium: 'Trung bình',
      low: 'Thấp',
      none: '—',
    },
    linksTitle: 'Công việc liên quan',
    noLinks: 'Chưa nối với công việc nào.',
    linkTask: 'Chọn công việc',
    linkTaskPlaceholder: '— chọn công việc —',
    linkSearch: 'Tìm công việc',
    linkNoMatch: 'Không có công việc nào khớp.',
    linkMore: '+{{count}} việc nữa — gõ để lọc',
    wholeProject: 'Toàn dự án',
    relationLabel: 'Quan hệ',
    addLink: 'Nối',
    linkAdded: 'Đã nối với công việc',
    unlink: 'Bỏ liên kết với {{key}}',
    relation: {
      affects: 'ảnh hưởng',
      blocks: 'đang chặn',
      mitigates: 'xử lý bởi',
    },
    highRisk: '{{count}} rủi ro cao',
    score: 'Điểm {{score}}',
    severity: 'Nghiêm trọng {{value}}/5',
    noOwner: 'Chưa phân công',
    chooseOwner: 'Chọn người…',
    remove: 'Xoá {{code}}',
    detailTitle: 'Chi tiết {{code}}',
    toggleDetail: 'Mở chi tiết {{code}}',
    formHint: 'Điền các ô bắt buộc để lưu.',
    mitigationPlaceholder: 'Kế hoạch giảm thiểu / hướng xử lý…',
    rationalePlaceholder: 'Lý do và căn cứ của quyết định…',
    signalsTitle: 'Tín hiệu rủi ro',
    signalsHelp: 'Do hệ thống dò tự động từ lịch, tải người, ước lượng và mô tả task.',
    signalCount: '{{count}} tín hiệu',
    noSignals: 'Chưa dò được tín hiệu nào. Dữ liệu dự án còn ít, hoặc mọi thứ đang ổn.',
    fromSignal: 'Tạo rủi ro',
    scan: 'Nhờ AI phân tích',
    scanPrompt: 'Quét rủi ro cho dự án này dựa trên các tín hiệu hệ thống đã dò được.',
    scanApply: 'Mở danh sách gợi ý để duyệt',
    scanDone: 'AI đề xuất {{count}} rủi ro, chờ bạn duyệt',
    scanEmpty: 'AI không tìm thấy rủi ro mới nào đáng ghi',
    unavailableSources: 'Chưa dò được: {{list}}',
    pendingSuggestions: '{{count}} gợi ý chờ duyệt',
    suggestionTitle: 'AI đề xuất {{count}} rủi ro',
    suggestionOutdated: 'Gợi ý này được sinh bởi phiên bản cũ — hãy chạy lại.',
    toolsUsed: 'đã đọc: {{list}}',
    evidence: 'Căn cứ: {{text}}',
    selectRisk: 'Chọn rủi ro {{title}}',
    acceptSelected: 'Duyệt {{count}} rủi ro đã chọn',
    accepted: 'Đã thêm {{codes}} vào RAID log',
    dismiss: 'Bỏ qua',
    dismissReason: 'Lý do bỏ qua',
    dismissReasonPlaceholder: 'Vì sao gợi ý này không dùng được? (bắt buộc)',
    signalSource: {
      critical_path_no_buffer: 'Đường găng',
      dependency_pileup: 'Điểm dồn',
      workload_overload: 'Quá tải',
      single_point_of_failure: 'Một người nắm',
      estimate_below_history: 'Ước lượng thấp',
      vague_description: 'Mô tả mơ hồ',
      cr_frequency: 'Tần suất thay đổi',
      cross_project_memory: 'Kinh nghiệm dự án khác',
      assignee_unavailable: 'Vắng người',
    },
    signal: {
      critical_path_no_buffer:
        '{{taskKey}} nằm trên đường găng và chỉ còn {{floatDays}} ngày dự phòng',
      dependency_pileup: '{{predecessorCount}} công việc phải xong trước {{taskKey}}',
      workload_overload:
        '{{subject}} bị quá tải {{overloadedDays}} ngày trong {{horizonDays}} ngày tới, cao nhất {{peakHours}} giờ/ngày',
      single_point_of_failure: 'Chỉ 1 trong {{memberCount}} thành viên khai kỹ năng {{subject}}',
      estimate_below_history:
        '{{taskKey}} ước lượng {{estimateHours}} giờ, trong khi việc cùng loại trước đây trung vị {{medianHours}} giờ ({{samples}} mẫu)',
      vague_description: '{{taskKey}} có mô tả chưa chốt hoặc phụ thuộc bên ngoài',
      cr_frequency: 'Nhiều yêu cầu thay đổi trong thời gian ngắn',
      cross_project_memory: 'Việc tương tự từng gây vấn đề ở dự án khác',
      assignee_unavailable:
        '{{subject}} vắng {{lostHours}} giờ trong khoảng ngày của {{taskKey}}; còn {{availableHours}} giờ, cần thêm {{extraDays}} ngày (dự phòng {{totalFloat}} ngày)',
    },
    type: {
      RISK: 'Rủi ro',
      ASSUMPTION: 'Giả định',
      ACTION: 'Hành động',
      ISSUE: 'Vấn đề',
      DECISION: 'Quyết định',
    },
    titlePlaceholder: {
      RISK: 'Điều gì có thể xảy ra?',
      ASSUMPTION: 'Đang cho là điều gì đúng?',
      ACTION: 'Cần làm gì, ai làm?',
      ISSUE: 'Chuyện gì đã xảy ra?',
      DECISION: 'Đã quyết điều gì?',
    },
    status: {
      open: 'Đang mở',
      in_progress: 'Đang xử lý',
      mitigated: 'Đã giảm thiểu',
      resolved: 'Đã giải quyết',
      escalated: 'Đã escalate',
      recorded: 'Đã ghi nhận',
      closed: 'Đã đóng',
    },
    scale: {
      1: 'Rất thấp',
      2: 'Thấp',
      3: 'Trung bình',
      4: 'Cao',
      5: 'Rất cao',
    },
    field: {
      title: 'Nội dung',
      status: 'Trạng thái',
      owner: 'Người phụ trách',
      decider: 'Người quyết',
      probability: 'Xác suất',
      impact: 'Ảnh hưởng',
      severity: 'Nghiêm trọng',
      dueDate: 'Hạn hoàn thành',
      reviewDate: 'Ngày xem lại',
      decidedAt: 'Ngày quyết',
      mitigation: 'Kế hoạch giảm thiểu',
      rationale: 'Lý do quyết định',
      affectedScope: 'Phạm vi ảnh hưởng',
    },
  },
  objectives: {
    sprintTitle: 'Mục tiêu sprint (S.M.A.R.T)',
    title: 'Mục tiêu dự án (S.M.A.R.T)',
    new: 'Mục tiêu mới',
    create: 'Tạo',
    objectiveTitle: 'Tên mục tiêu',
    titlePlaceholder: 'Tên mục tiêu, vd "Tăng số đại lý đặt hàng qua ứng dụng"',
    empty: 'Chưa đặt mục tiêu nào',
    emptyHelp:
      'Mỗi mục tiêu là một cái tên và một con số cần đạt. PM báo số định kỳ để cả đội thấy mình còn cách đích bao xa.',
    targetValue: 'Giá trị cần đạt',
    newValue: 'Số mới',
    checkIn: 'Báo số',
    checkInNote: 'Lý do thay đổi',
    checkInNotePlaceholder: 'Vì sao con số nhảy? (ba tháng sau sẽ có người đi tìm)',
    history: 'Lịch sử',
    noHistory: 'Chưa có lần báo số nào.',
    overdue: 'Quá hạn',
    targetPlaceholder: 'Cần đạt, vd 50 đại lý, 95%',
    targetInvalid: 'Giá trị cần đạt phải bắt đầu bằng một con số, vd "50 đại lý".',
    target: 'Cần đạt',
    current: 'Hiện tại',
    noValueYet: 'chưa có số',
    noTarget: 'Mục tiêu này chưa có giá trị cần đạt.',
    reportTitle: 'Báo số: {{name}}',
    firstReportHelp:
      'Đây là lần báo đầu tiên: con số này là điểm bắt đầu, nên thanh tiến độ bắt đầu từ đây.',
    reportSaved: 'Đã báo số',
    remove: 'Xoá mục tiêu {{name}}',
    progressLabel: 'Tiến độ: {{name}}',
  },
  plan: {
    chatTitle: 'Bàn lại kế hoạch',
    chatHelp:
      'AI đọc mốc, lịch và tài liệu dự án trước khi trả lời — nó sẽ nói thẳng nếu mốc nào bị trượt.',
    chatEmpty: 'Chưa hỏi gì. Thử: “Đẩy hết sang tháng sau được không?”',
    chatPlaceholder: 'Hỏi hoặc yêu cầu chỉnh kế hoạch…',
    chatLocked: 'Nháp này đã xử lý xong, không chỉnh được nữa.',
    chatSend: 'Gửi',
    pickDocuments: 'Chọn tài liệu để AI đọc',
    pickedDocuments: 'Đã chọn {{count}} tài liệu',
    startOffset: 'Bắt đầu sau (ngày)',
    durationDays: 'Dài (ngày)',
    dialogTitle: 'Kế hoạch nháp',
    dialogHelp:
      'AI đề xuất, bạn duyệt từng dòng. Nháp chưa duyệt không đụng gì tới kế hoạch chính thức.',
    openDrafts: 'Lên kế hoạch tự động',
    newDraft: 'Nháp mới',
    backToList: 'Danh sách nháp',
    draftSummary: '{{count}} việc · {{hours}}h',
    status: {
      clarifying: 'Chờ bạn trả lời',
      pending: 'Chờ duyệt',
      applied: 'Đã áp dụng',
      discarded: 'Đã bỏ',
    },
    step: {
      describe: 'Mô tả',
      context: 'Bối cảnh',
      clarify: 'Làm rõ',
      review: 'Duyệt',
    },
    next: 'Tiếp tục',
    back: 'Quay lại',
    optional: 'Không bắt buộc',
    deadline: 'Mốc phải xong',
    constraints: 'Ràng buộc',
    constraintsPlaceholder:
      'Ví dụ: đội chỉ có 2 backend, không được downtime, phải dùng lại hệ thống thanh toán cũ…',
    contextHint: 'Bỏ trống cũng được — AI sẽ hỏi lại những chỗ nó cần.',
    assign: {
      title: 'Chọn người cho từng hạng mục',
      help: 'AI đọc kỹ năng đã khai, giờ còn dành được cho dự án (đã trừ nghỉ phép và phần trăm cam kết) và việc đang mở của từng người, rồi đề xuất ai làm việc nào.',
      run: 'Đề xuất người phụ trách',
      noteLabel: 'Ràng buộc thêm (không bắt buộc)',
      notePlaceholder: 'Ví dụ: đừng giao cho Minh, tuần sau anh ấy bàn giao…',
      defaultPrompt: 'Không có ràng buộc thêm — chọn theo kỹ năng và giờ còn trống.',
      unassigned: 'Chưa giao được',
      noneAssigned: 'Không hạng mục nào giao được — xem lý do bên dưới.',
      apply_one: 'Áp {{count}} đề xuất vào nháp',
      apply_other: 'Áp {{count}} đề xuất vào nháp',
      applied: 'Đã ghi người phụ trách đề xuất vào bản nháp.',
    },
    clarify: {
      title: 'AI cần làm rõ {{count}} điểm',
      help: 'Mỗi câu đã có đáp án khuyến nghị điền sẵn. Sửa chỗ bạn thấy chưa đúng, hoặc xoá trống để AI tự nêu giả định.',
      why: 'Vì sao hỏi: {{text}}',
      recommended: 'Khuyến nghị: {{text}}',
      useRecommended: 'Dùng khuyến nghị',
      useAll: 'Dùng tất cả khuyến nghị',
      recommendedBadge: 'Khuyến nghị',
      other: 'Câu trả lời khác…',
      optionsFor: 'Phương án cho: {{question}}',
      answerPlaceholder: 'Câu trả lời của bạn…',
      skip: 'Bỏ qua câu này',
      skipped: 'Đã bỏ trống — AI sẽ tự chọn giả định và nêu rõ trong lý do.',
      submit: 'Tiếp tục sinh kế hoạch',
      submitting: 'Đang sinh kế hoạch…',
      progress: 'Đã trả lời {{answered}}/{{total}} câu',
    },
    generateTitle: 'Sinh kế hoạch từ mô tả',
    description: 'Mô tả dự án',
    descriptionPlaceholder: 'Mô tả dự án cần làm: mục tiêu, phạm vi, ràng buộc về thời gian…',
    needLongerDescription: 'Mô tả cần ít nhất 20 ký tự.',
    template: 'Khuôn mẫu',
    noTemplate: 'Không dùng khuôn mẫu',
    generate: 'Sinh kế hoạch',
    noDraft: 'Chưa có kế hoạch nháp nào',
    noDraftHelp:
      'Mô tả dự án ở trên rồi đi qua hai bước “Mô tả” và “Bối cảnh”, hoặc tự tạo task ở tab Backlog.',
    draftTitle: 'Kế hoạch nháp — {{count}} hạng mục',
    totalHours: 'tổng {{hours}} giờ',
    chooseDraft: 'Chọn bản nháp',
    itemTitle: 'Tên hạng mục',
    newItemTitle: 'Hạng mục mới',
    addItem: 'Thêm hạng mục',
    adjustHours: 'Đổi ước lượng {{step}} giờ',
    hours: '{{hours}}h',
    assignee: 'Người phụ trách',
    noAssignee: 'Chưa giao',
    exclude: 'Loại khỏi lần áp dụng',
    restore: 'Đưa lại vào kế hoạch',
    split: 'Chia nhỏ {{title}}',
    remove: 'Xoá {{title}}',
    expand: 'Mở subtask',
    collapse: 'Thu subtask',
    noRationale: 'Không có lý do ước lượng',
    after: 'sau: {{names}}',
    previewTitle: 'Xem trước trên Gantt',
    refine: 'Tinh chỉnh',
    refining: 'Đang tinh chỉnh…',
    draftReady: '{{count}} hạng mục, chờ bạn duyệt',
    clarifyPending: 'AI cần bạn làm rõ vài điểm trước khi dựng kế hoạch',
    refineLabel: 'Tinh chỉnh kế hoạch',
    refinePlaceholder: 'Ví dụ: chia nhỏ hạng mục đầu, hoặc bỏ phần báo cáo',
    startDate: 'Ngày khởi động',
    apply: 'Áp dụng vào dự án',
    applied: 'Đã tạo {{count}} task từ kế hoạch.',
    discard: 'Bỏ nháp',
  },
  replay: {
    noHistory: 'Dự án này chưa có sự kiện nào để tua lại.',
    playOn: 'Chế độ tua',
    playOff: 'Thoát chế độ tua',
    play: 'Phát',
    pause: 'Tạm dừng',
    stop: 'Về đầu đoạn',
    stepForward: 'Bước tới',
    stepBack: 'Bước lùi',
    nextMarker: 'Sự kiện quan trọng kế tiếp',
    prevMarker: 'Sự kiện quan trọng trước đó',
    speed: 'Tốc độ',
    speedValue: '1 giây = {{value}}',
    speedMinutes: '{{minutes}} phút',
    speedHours: '{{hours}} giờ',
    speedDays: '{{days}} ngày',
    mode: { time: 'Theo thời gian', event: 'Theo sự kiện' },
    skipDeadTime: 'Bỏ qua khoảng chết',
    stopAtMarkers: 'Dừng ở sự kiện lớn',
    loop: 'Lặp lại',
    stoppedAtMarker: 'Đã dừng ở một sự kiện lớn',
    filterAssignee: 'Người',
    everyone: 'Cả đội',
    filterSprint: 'Sprint',
    allSprints: 'Mọi sprint',
    burndownTitle: 'Giờ còn lại, vẽ dần theo con trỏ',
    chartCaption: 'Còn {{hours}} giờ tại mốc đang xem',
    chartLabel: 'Biểu đồ giờ còn lại, hiện còn {{hours}} giờ',
    chartTooShort: 'Đoạn này quá ngắn để vẽ đường.',
    feedTitle: 'Sự kiện đang chạy',
    feedEmpty: 'Chưa có sự kiện nào ở mốc này. Bấm Phát để bắt đầu.',
    systemActor: 'Hệ thống',
    feed: {
      taskCreated: 'tạo “{{title}}”',
      statusChanged: 'chuyển “{{title}}” sang {{status}}',
      progressUpdated: 'đặt tiến độ “{{title}}” thành {{value}}%',
      assigned: 'đổi người phụ trách “{{title}}”',
      datesChanged: 'đổi lịch “{{title}}”',
      estimateChanged: 'đổi ước lượng “{{title}}”',
      storyPointsChanged: 'đổi story point “{{title}}”',
      priorityChanged: 'đổi độ ưu tiên “{{title}}”',
      blocked: 'chặn “{{title}}”',
      unblocked: 'bỏ chặn “{{title}}”',
      taskDeleted: 'xoá “{{title}}”',
      sprintStarted: 'bắt đầu một sprint',
      sprintClosed: 'đóng một sprint',
      scopeChanged: 'đổi phạm vi sprint',
      raidCreated: 'thêm RAID “{{title}}”',
      raidStatusChanged: 'đổi trạng thái RAID sang {{status}}',
      documentCreated: 'thêm tài liệu “{{title}}”',
      documentStatusChanged: 'đổi trạng thái tài liệu sang {{status}}',
      crApproved: 'duyệt một CR',
      crCreated: 'tạo CR “{{title}}”',
      baselineSet: 'chốt baseline',
      phaseGate: 'cho qua cổng pha {{phase}}',
      dependencyAdded: 'thêm một phụ thuộc',
      dependencyRemoved: 'xoá một phụ thuộc',
      taskUpdated: 'sửa “{{title}}”',
      becameMilestone: 'đặt “{{title}}” thành mốc',
      becameTask: 'chuyển “{{title}}” về task thường',
      statusCreated: 'tạo cột “{{name}}”',
      memberAdded: 'thêm một thành viên vào dự án',
      objectiveCreated: 'tạo mục tiêu “{{title}}”',
      keyResultUpdated: 'báo số chỉ số: {{value}}',
    },
    narrationTitle: 'Thuyết minh',
    narrate: 'Nhờ AI thuyết minh',
    narrationLoading: 'Đang tải lời thuyết minh…',
    narrationEmpty: 'Chưa có lời thuyết minh. Bảng sự kiện bên cạnh vẫn đọc được ngay.',
    narrationGap: 'Không có lời thuyết minh cho mốc này.',
    narrationApply: 'Hiện phụ đề trên thanh tua',
    narrationDone: 'Đã có lời thuyết minh. Tua lại không tốn thêm tiền.',
    narrationCost: 'Đã sinh {{at}} · ${{cost}} · tua lại không tốn thêm',
    inflectionAt: 'Bước ngoặt {{at}}:',
    quickTour: 'Mốc đáng xem lại',
    scrubberTitle: 'Thanh trượt thời gian',
    eventCount: '{{count}} sự kiện',
    bucket: { day: 'gộp theo ngày', week: 'gộp theo tuần' },
    densityLabel: 'Mật độ sự kiện theo thời gian, ô dày nhất {{peak}} sự kiện',
    jumpTo: 'Nhảy tới {{label}}',
    marker: {
      sprint_started: 'Sprint bắt đầu',
      sprint_closed: 'Sprint kết thúc',
      cr_approved: 'CR được duyệt',
      risk_high: 'Rủi ro cao',
      milestone_set: 'Milestone',
      baseline: 'Baseline',
      phase_gate: 'Cổng pha',
      due_pushed: 'Lùi hạn lần đầu',
    },
    view: {
      board: 'Board',
      gantt: 'Gantt',
      workload: 'Tải đội',
      progress: 'Tiến độ',
      raid: 'RAID',
      objectives: 'Mục tiêu',
      documents: 'Tài liệu',
    },
    viewingPast: 'Đang xem trạng thái lúc {{at}}',
    readOnly: 'Chỉ đọc',
    compareOn: 'So sánh 2 thời điểm',
    compareOff: 'Tắt so sánh',
    compareLeft: 'Mốc A',
    compareRight: 'Mốc B',
    pickCompareAt: 'Chọn mốc so sánh',
    share: 'Chép link',
    linkCopied: 'Đã chép link kèm mốc thời gian.',
    linkCopyFailed: 'Không chép tự động được — chép tay link dưới đây:',
    foldedFromStart: 'Dựng từ đầu lịch sử, {{count}} sự kiện',
    foldedFromSnapshot: 'Dựng từ snapshot {{snapshot}} + {{count}} sự kiện',
    tookMs: '{{ms}}ms',
    partial: 'Lịch sử không dựng lại được: {{fields}}',
    progressPct: '{{value}}%',
    hours: '{{hours}}h',
    blocked: 'Bị chặn',
    emptyBoard: 'Ở mốc này dự án chưa có cột hay thẻ nào.',
    emptyColumn: 'Không có thẻ nào',
    undated: '{{count}} hạng mục chưa có ngày nên không vẽ được.',
    member: 'Thành viên',
    unassigned: 'Chưa phân công',
    openTasks: 'Đang mở',
    openHours: 'Giờ đang mở',
    doneTasks: 'Đã xong',
    blockedTasks: 'Bị chặn',
    emptyWorkload: 'Chưa có thành viên nào ở mốc này.',
    progressLabel: 'Tiến độ',
    doneOfTotal: 'Xong / tổng',
    inProgress: 'Đang làm',
    hoursDoneOfTotal: 'Giờ xong / tổng',
    raidSummary: '{{open}} hạng mục còn treo · tổng điểm rủi ro {{exposure}}',
    raidType: 'Loại',
    raidTitle: 'Nội dung',
    raidStatus: 'Trạng thái',
    raidScore: 'Điểm',
    emptyRaid: 'RAID log trống ở mốc này.',
    emptyObjectives: 'Chưa có mục tiêu nào ở mốc này.',
    linkedTasks: '{{count}} task liên kết',
    docTitle: 'Tài liệu',
    docType: 'Loại',
    docStatus: 'Trạng thái',
    docVersion: 'Phiên bản',
    emptyDocuments: 'Chưa có tài liệu nào ở mốc này.',
  },
  rebalance: {
    title: 'Đề xuất tái phân bổ',
    considered: 'đã xét {{count}} việc sắp tới',
    none: 'Không có đề xuất nào. Tốc độ giữa các thành viên chưa lệch đủ để đáng chuyển việc.',
    save: 'Lưu thành gợi ý',
    saving: 'Đang lưu…',
    saved: 'Đã lưu. Bấm “Áp dụng” ở từng dòng để thực hiện.',
    nothingToSave: 'Chưa có đề xuất nào để lưu.',
    saveFirst: 'Lưu thành gợi ý trước khi áp dụng.',
    apply: 'Áp dụng',
    applied: 'Đã chuyển việc.',
    saves: 'ước tính tiết kiệm {{hours}}h',
    rescheduleFor: 'Dời lịch giúp {{name}}',
    rescheduleHint:
      'Không có ai phù hợp hơn để chuyển. Dời lịch là quyết định của bạn — hệ thống không tự đổi ngày.',
    evidenceFrom: '{{name}}: {{ratio}}× ước lượng ({{samples}} mẫu, {{confidence}})',
    evidenceTo: '{{name}}: {{ratio}}× ({{samples}} mẫu, {{confidence}})',
    overloaded: 'quá tải {{count}} ngày trong 4 tuần tới',
  },
  /**
   * Bảng hiệu suất nhân sự — APM-PERF-g.
   *
   * Không có chuỗi nào tên "điểm", "xếp hạng", "loại A/B/C". Contract cố tình
   * không có `score`, và một nhãn giao diện đặt lại cái tên đó sẽ dựng lại đúng
   * thứ contract vừa từ chối.
   */
  teamPerf: {
    service: 'Vận hành',
    noCommitment: 'chưa cam kết',
    showFull: 'Xem đầy đủ',
    showCompact: 'Rút gọn',
    sortBy: 'Sắp theo',
    sortAsc: 'Đang tăng dần — bấm để đảo',
    sortDesc: 'Đang giảm dần — bấm để đảo',
    title: 'Hiệu suất nhân sự',
    period: '{{from}} – {{to}}',
    groupPerformance: 'Trong kỳ',
    groupLoad: 'Tải sắp tới',
    audited: 'Mỗi lần xem hiệu suất cá nhân đều được lưu',
    truncated:
      'Kỳ này chạm trần mẫu nên số liệu đầu kỳ đã bị cắt. Thu hẹp khoảng thời gian để xem đủ.',
    empty: 'Chưa có ai trong danh sách',
    emptyHelp:
      'Bạn xem được hiệu suất của nhân sự dưới quyền trực tiếp. Chưa ai được gán quản lý trực tiếp là bạn.',
    person: 'Người',
    department: 'Phòng ban',
    noDepartment: 'Chưa gán',
    samples: 'Mẫu',
    environment: 'Loại vì ngoại cảnh',
    windowProjects: 'Dự án trong kỳ',
    windowHours: 'Giờ trong kỳ',
    committed: 'Đã nhận',
    capacity: 'Năng lực',
    allocation: 'Phân bổ',
    activeProjects: 'Dự án đang chạy',
    sampleCount: 'n={{count}}',
    lowMark: '· ít mẫu',
    reviewReason:
      'Chưa đo được — hệ thống chưa có tích hợp code review. Cột để trống chứ không bỏ đi, vì còn một tín hiệu của spec chưa đo.',
    profileTitle: 'Hồ sơ chi tiết',
    windowLabel: 'Kỳ đánh giá',
    // Tiếng Việt không chia số nhiều, nhưng khoá vẫn phải có đủ hai biến thể:
    // `en.ts` được kiểm kiểu theo hình dạng của file này.
    windowDays_one: '{{count}} ngày gần nhất',
    windowDays_other: '{{count}} ngày gần nhất',
    openHint: 'Mở bảng sẽ ghi một dấu vết cho từng người trong đó.',
  },
  performance: {
    loadTitle: 'Từ {{from}} đến {{to}}',
    loadValue: 'Đang nhận {{pct}}% sức — {{count}} dự án',
    loadRoomy: 'còn chỗ cho việc mới',
    previousValue: 'Kỳ trước: {{value}}',
    unchanged: 'không đổi',
    /** Hai tab của trang Hiệu suất — người dùng yêu cầu 2026-09-22. */
    tabs: {
      me: 'Hiệu suất của tôi',
      team: 'Hiệu suất đội của tôi',
    },
    sectionLoad: 'Sức chứa sắp tới',
    sectionProfile: 'Hồ sơ hiệu suất',
    tabTitle: 'Hiệu suất',
    teamAuditNotice:
      'Mọi lượt xem hiệu suất và giờ làm của người khác đều được ghi vào sổ truy cập của chính họ.',
    pageTitle: 'Hiệu suất của tôi',
    noProfileYet:
      'Chưa có việc nào hoàn thành để đo. Hồ sơ sẽ hiện ra sau khi bạn đóng vài việc đầu tiên.',
    speed: 'Tốc độ',
    onTime: 'Đúng hạn',
    rework: 'Không làm lại',
    review: 'Review',
    notMeasured: 'chưa đo được',
    projectWork: 'Công việc dự án',
    onTimeHint: 'việc có hạn, xong kịp',
    reworkHint: 'việc xong, không bị mở lại',
    speedHint: '100 = đúng nhịp dự án',
    serviceTitle: 'Việc vận hành',
    slaMet: 'Đúng cam kết',
    slaSamples: 'trên {{count}} vấn đề có cam kết',
    serviceHours: 'Giờ quy đổi',
    serviceHoursHint: 'chia nhỏ phiếu không làm tăng số này',
    closed: 'Đã đóng',
    closedHint: 'kể cả loại không cam kết',
    reopened: 'Mở lại',
    reopenedHint: 'đối trọng của hai số bên trái',
    indexValue: '{{value}}/100',
    samplesShort: '{{count}} mẫu · {{confidence}}',
    sampleSummary: '{{count}} mẫu trong 12 tháng',
    environment: '{{count}} mẫu loại vì ngoại cảnh',
    noData: 'Chưa đủ dữ liệu để dựng hồ sơ. Mẫu đến từ task đã xong, có ước lượng và có người làm.',
    project: 'Dự án',
    hours: 'Giờ',
    weight: 'Trọng số',
    baseline: 'Nhịp dự án',
    normalised: 'So với nhịp',
  },
  tour: {
    drag: 'Kéo để dời thẻ sang chỗ khác',
    title: 'Hướng dẫn sử dụng',
    next: 'Tiếp',
    back: 'Quay lại',
    done: 'Xong',
    skip: 'Bỏ qua hướng dẫn',
    reopen: 'Hướng dẫn sử dụng',
    progress: 'Bước {{current}}/{{total}}',
    away: 'Bạn đã rời màn hình của bước này.',
    goThere: 'Mở lại màn hình này',
    step: {
      projectList: {
        title: 'Tất cả dự án',
        body: 'Bắt đầu từ đây: nút "Tất cả dự án" ở đầu thanh bên mở bảng toàn bộ dự án, chia theo nhóm (được mời, chưa bắt đầu, đang thực thi, hoàn thành) — mã, tên, vai trò của bạn, trạng thái, thời gian, số người và số việc. Bấm tên để mở dự án; kéo tay cầm ở đầu dòng sang thanh bên để ghim, thùng rác ở thanh bên để bỏ. Chưa có dự án nào thì thanh bên chỉ có nút tạo dự án.',
      },
      createProject: {
        title: 'Tạo dự án mới',
        body: 'Nút "Dự án mới" tạo dự án — điền mã, tên, mục tiêu, phương pháp và loại việc. Nút nằm trong màn "Tất cả dự án": ở hàng nút đầu bảng và ở đầu thanh bên. Chưa có dự án nào thì nút nằm ngay ở thanh bên.',
      },
      aiAssistant: {
        title: 'Trợ lý AI',
        body: 'Nút ✨ cạnh chuông thông báo mở bảng này: mỗi việc AI đang làm hiện từng bước ở đây, kèm những câu AI đang chờ bạn trả lời và lịch sử các lượt đã chạy. Nút "AI tour" trong bảng dẫn đi xem hết các tính năng AI. AI chỉ đề xuất, bạn duyệt.',
      },
      editProject: {
        title: 'Sửa dự án ở tab Điều lệ',
        body: 'Tên, mô tả, ngày bắt đầu – kết thúc và màu nhận dạng của dự án sửa bằng nút "Sửa" ở đây. Thành viên, loại việc và quy chuẩn nằm ở tab Cấu hình.',
      },
      okr: {
        title: 'Đăng ký và quản lý OKR',
        body: 'Mỗi kỳ, mỗi người đăng ký mục tiêu và kết quả then chốt; quản lý duyệt, chốt kỳ và theo dõi tiến độ ở đây. Báo số định kỳ để thanh tiến độ đi đúng.',
      },
      newTask: {
        title: 'Tạo việc mới',
        body: 'Nút "Việc mới" ở tab Công việc: tiêu đề, loại việc, người làm, ước lượng và hạn. Người được giao đang quá tải thì hệ thống cảnh báo ngay trong form.',
      },
      newIssue: {
        title: 'Tạo issue mới',
        body: 'Issue là vấn đề vận hành do người dùng hay khách hàng báo. Bấm nút thêm để ghi lại, đặt mức độ và người xử lý, rồi theo dõi tới khi đóng.',
      },
      designFile: {
        title: 'Thêm file thiết kế',
        body: 'Nối một file Figma vào dự án: hệ thống chụp lại từng màn hình mỗi lần thiết kế đổi, và bạn so được hai phiên bản cạnh nhau.',
      },
      testRound: {
        title: 'Thêm vòng kiểm thử',
        body: 'Mở một vòng test mới khi bản sửa đã sẵn sàng: mọi trường hợp được chạy lại, kết quả từng vòng giữ riêng để so với vòng trước. Mỗi lúc chỉ có một vòng đang mở.',
      },
      reports: {
        title: 'Báo cáo trong dự án',
        body: 'Burndown, CFD, cycle time, EVM — dựng từ dòng sự kiện của dự án, nên luôn khớp với board và chọn được mốc ngày để xem lại.',
      },
      orgChart: {
        title: 'Sơ đồ tổ chức',
        body: 'Ai báo cáo cho ai, theo quan hệ quản lý trực tiếp. Bấm một người để xem hồ sơ; quản trị sửa vị trí và quản lý trực tiếp ngay trên sơ đồ.',
      },
      absences: {
        title: 'Nghỉ phép',
        body: 'Xin nghỉ, duyệt nghỉ và xem ai nghỉ trong tuần tới. Ngày nghỉ được trừ khỏi năng lực, nên lịch và cảnh báo quá tải tự tính lại.',
      },
      mySettings: {
        title: 'Cài đặt của tôi',
        body: 'Ngôn ngữ, giao diện, thông báo, Telegram và key AI của riêng bạn đều nằm ở đây.',
      },
      replay: {
        title: 'Tua lại',
        body: 'Kéo thanh thời gian để xem dự án trông thế nào vào bất kỳ ngày nào — board, Gantt và số liệu dựng lại từ lịch sử sự kiện.',
      },
      performance: {
        title: 'Hiệu suất nhân sự',
        body: 'Tốc độ, độ chính xác ước lượng và khối lượng của từng người, so với chính họ theo thời gian. Mỗi lần xem hiệu suất của người khác đều được ghi vào nhật ký truy cập.',
      },
    },
    fallback:
      'Nút của bước này chưa hiện ở đây: mở một dự án để thấy nút này, hoặc kiểm tra AI đã bật và bạn có quyền dùng nó. Vùng đang sáng là chỗ gần nhất.',
    ai: {
      title: 'Tour tính năng AI',
      open: 'AI tour',
      step: {
        assistant: {
          title: 'Bảng trợ lý AI',
          body: 'Mỗi lượt AI chạy hiện từng bước ở đây, kèm lịch sử các lượt cũ. AI chỉ đề xuất, bạn duyệt — và chưa có key AI thì mọi việc trong tour này vẫn làm tay được.',
        },
        plan: {
          title: 'Lên kế hoạch tự động',
          body: 'Menu "Sửa nhanh" → "Lên kế hoạch tự động": mô tả dự án bằng lời, AI dựng cây công việc kèm ước lượng, phụ thuộc và người làm đề xuất. Không có AI thì tự tạo task hoặc bắt đầu từ mẫu WBS.',
        },
        taskForm: {
          title: 'Gợi ý khi tạo và chia nhỏ task',
          body: 'Trong hộp "Việc mới", AI gợi ý loại việc, ưu tiên và người làm từ tiêu đề đang gõ, và "AI tách giúp" đề xuất subtask kèm giờ. Không có AI thì điền form và thêm subtask như bình thường.',
        },
        dependencies: {
          title: 'Tìm phụ thuộc còn thiếu',
          body: 'Menu "Sửa nhanh" → "Tìm phụ thuộc còn thiếu": AI đọc các task và đề xuất phụ thuộc chưa khai, kèm câu trích làm bằng chứng. Làm tay: bật "Sửa biểu đồ" rồi kéo nối hai thanh trên Gantt.',
        },
        budget: {
          title: 'Ước lượng ngân sách',
          body: 'Nút "Ước lượng ngân sách tự động" ở tab Ngân sách: AI giải thích tiền nằm ở đâu, chỗ nào đang đoán, lệch bao nhiêu so với mức duyệt. Không có AI thì bảng đơn giá và khoản chi vẫn tự tính tổng.',
        },
        adjust: {
          title: 'Việc trễ, xếp lại lịch, sửa hàng loạt',
          body: 'Menu "Sửa nhanh" có "Xử lý task chậm tiến độ" và "Sửa hàng loạt bằng lời"; ở Gantt có "Xếp lịch bằng AI" khi có việc cần xếp lại. Làm tay: kéo thanh Gantt, hoặc chọn nhiều việc rồi đổi một lượt.',
        },
        changes: {
          title: 'Đàm phán phạm vi và ảnh hưởng thay đổi',
          body: 'Ở tab Thay đổi, nhập một ràng buộc mới để AI đề xuất phương án cắt hoặc hoãn kèm ngày kết thúc mô phỏng; mở một yêu cầu thay đổi để AI nêu điều dễ hỏng nếu duyệt. Không có AI thì đọc bảng ảnh hưởng đã tính sẵn.',
        },
        raid: {
          title: 'Gợi ý rủi ro và tra lại quyết định',
          body: '"Tín hiệu rủi ro" để AI đề xuất mục RAID mới từ đường găng, tải người và ước lượng; "Vì sao lúc đó ta chọn thế" dựng lại bối cảnh một quyết định cũ. Làm tay: thêm rủi ro từ bảng tín hiệu, lọc RAID theo Quyết định.',
        },
        delayRisk: {
          title: 'Giải thích rủi ro trễ',
          body: 'Nút "Phân tích rủi ro tự động" ở đầu mục lục tab Báo cáo: AI viết lại điểm rủi ro trễ bằng lời — dự án đang gặp gì, tuần này nên làm gì. Không có AI thì đọc bảng chỉ báo và điểm.',
        },
        replay: {
          title: 'Thuyết minh Replay và "nếu khi đó"',
          body: '"Nếu khi đó làm khác đi" tua về một mốc, đổi vài quyết định rồi so với tiến độ thật; ở "Chế độ tua", "Nhờ AI thuyết minh" viết phụ đề chạy theo lúc tua. Không có AI thì dùng bảng sự kiện và marker trên thanh trượt.',
        },
        teamReport: {
          title: 'Tóm tắt công việc của team',
          body: 'Mở một báo cáo rồi bấm "Viết tóm tắt bằng AI": AI viết lời tóm tắt từ số liệu đã chụp, không bao giờ xếp hạng người. Không có AI thì phần trên cùng có sẵn bản nháp dựng từ số liệu, chỉ cần sửa câu chữ.',
        },
        okr: {
          title: 'Gợi ý OKR',
          body: 'Nút "Gợi ý OKR" đọc kết quả kỳ gần nhất và đề xuất Objective, Key Result đo được kèm mốc hiện tại. Không có AI thì tự đặt OKR hoặc tra thư viện mẫu.',
        },
        testing: {
          title: 'Sinh test case',
          body: '"Sinh case bằng AI" ở tab Kiểm thử đọc mô tả các việc đã chọn cùng tài liệu đính kèm và đề xuất bộ test case. Không có AI thì thêm case bằng tay ngay trong tab này.',
        },
        design: {
          title: 'Mô tả và thuyết minh thiết kế',
          body: 'Mở một file Figma đã liên kết: AI viết mục đích và thành phần của từng màn hình, và khi so hai bản chụp thì nói mỗi thay đổi có ý nghĩa gì. Không có AI thì tự viết mô tả và xem ảnh trước/sau.',
        },
        aiKey: {
          title: 'Nhập key AI',
          body: 'Bắt đầu từ đây: mọi nút trong tour này cần một key AI của chính bạn — nhập ở đây, chọn model và đặt hạn mức chi phí. Chưa nhập thì các nút vẫn hiện, bấm vào sẽ chỉ đường; hệ thống vẫn chạy đủ, chỉ là mọi việc làm tay.',
        },
      },
    },
  },
  goalMetric: {
    on_time_ratio: 'Tỉ lệ đúng hạn',
    rework_ratio: 'Tỉ lệ không làm lại',
    sla_met_ratio: 'Tỉ lệ đúng cam kết',
    reopen_count: 'Số vấn đề mở lại',
    speed_index: 'Chỉ số tốc độ',
    service_hours: 'Giờ quy đổi vận hành',
  },
  goal: {
    edit: 'Sửa',
    delete: 'Xoá',
    updated: 'Đã lưu thay đổi',
    deleted: 'Đã xoá mục tiêu',
    period: 'Kỳ',
    periodEnd: 'Kết thúc',
    periodKind: {
      month: 'Tháng này',
      quarter: 'Quý này',
      year: 'Năm nay',
    },
    suggestionsTitle: 'Gợi ý của AI',
    ask: 'Gợi ý OKR',
    asking: 'Đang hỏi…',
    suggestionsReady: 'Có {{count}} gợi ý để bạn xem',
    noSuggestions: 'Chưa có gợi ý nào đang chờ.',
    measuredBy: 'Số lấy từ: {{by}}',
    ambition: { committed: 'cam kết', aspirational: 'khát vọng' },
    suggestionEmpty: 'AI chưa đủ dữ liệu để đề xuất mục tiêu cho người này.',
    acceptCount_zero: 'Chọn mục để nhận',
    acceptCount_other: 'Nhận {{count}} mục tiêu',
    accepted: 'Đã tạo {{count}} mục tiêu',
    dismiss: 'Bỏ qua',
    dismissReason: 'Vì sao bỏ qua?',
    confirmDismiss: 'Xác nhận bỏ qua',
    dismissed: 'Đã bỏ qua gợi ý',
    sectionTitle: 'Mục tiêu quý này',
    add: 'Thêm kết quả then chốt',
    cancel: 'Thôi',
    save: 'Lưu',
    close: 'Đóng',
    metric: 'Chỉ số',
    targetLabel: 'Mức cần đạt {{unit}}',
    target: 'đích {{value}}',
    current: 'hiện {{value}}',
    start: 'từ {{value}}',
    progressExplain:
      'Đi được {{pct}}% quãng đường từ {{start}} tới đích {{target}} (đang ở {{current}}).',
    startTip: {
      auto: 'Điểm bắt đầu: người này đang ở đâu lúc mục tiêu được đặt. Job đêm đo một lần từ công việc đã hoàn thành, rồi giữ nguyên — mốc chạy theo hiện tại thì tiến độ đứng yên ở 0% mãi mãi.',
      manual:
        'Điểm bắt đầu: con số ở lần báo đầu tiên, và giữ nguyên từ đó. Không ai đo hộ kết quả then chốt tự do.',
    },
    targetTip:
      'Đích: con số cam kết chạm tới trước khi hết kỳ. Đây là số DUY NHẤT trong một mục tiêu đo tự động do con người quyết. Với chỉ số dạng giảm, đích nằm THẤP hơn điểm bắt đầu.',
    currentTip: {
      auto: 'Đo được: job đêm tính từ công việc đã hoàn thành trong kỳ. Không có ô nhập nào cho con số này.',
      manual:
        'Đo được: con số quản lý báo gần nhất. Job đêm không đụng tới kết quả then chốt tự do.',
    },

    progressNoStart: 'Chưa có điểm bắt đầu nên chưa tính được quãng đường đã đi.',
    startHelpLabel: 'Điểm bắt đầu là gì',
    numbersHelpLabel: 'Ba con số này là gì và đo thế nào',
    notMeasuredYet: 'Chưa đo lần nào — số sẽ hiện sau lượt đo đêm nay.',
    created: 'Đã đặt mục tiêu',
    archived: 'Đã đóng mục tiêu',
    emptyForManager: 'Chưa đặt mục tiêu nào cho người này.',
    pairingHint:
      'Mục tiêu về tốc độ hoặc khối lượng phải đi kèm một mục tiêu chất lượng trong cùng kỳ — nếu không, cách dễ nhất để đạt đích là làm ẩu.',

    // ── Nhìn lại OKR — APM-OKR-c ───────────────────────────────────────────
    historyLink: 'Xem toàn bộ OKR các kỳ →',
    historyTitle: 'OKR theo kỳ',
    historyOf: 'OKR của {{name}}',
    historyMine: 'OKR của tôi',
    historySubtitle:
      'Mọi mục tiêu đã đặt, từ kỳ gần nhất trở về trước. Mỗi kết luận đi kèm con số nó dựa vào — không có ô nào để gõ tay một lời đánh giá.',
    historyEmpty: 'Chưa có mục tiêu nào được đặt cho người này.',
    historyForbidden:
      'Bạn không đặt được mục tiêu cho người này, nên cũng không xem được OKR của họ. Chỉ quản lý trực tiếp một cấp mới thấy phần này.',
    backToPerformance: '← Về trang Hiệu suất',
    currentPeriod: 'Kỳ đang chạy',
    /** Chỉ hiện ở kỳ đang chạy, và chỉ cho người đặt được mục tiêu. */
    manageHere: 'Thêm, sửa và xoá mục tiêu ở ngay dưới đây.',

    outcome: {
      in_progress: 'Đang chạy',
      not_measured: 'Không đo được',
      achieved: 'Đạt',
      missed: 'Không đạt',
      closed_early: 'Đóng sớm',
    },
    /**
     * Câu giải thích kết cục — dựng từ dữ liệu, không phải một ô người gõ.
     *
     * Cả tính năng OKR tồn tại để không ai nhập tay con số nào; một ô "lý do"
     * gõ tay là cánh cửa ấy mở lại ở dạng khác, lần này còn đứng cạnh một con
     * số máy đo và trông như cùng loại dữ liệu.
     */
    reason: {
      in_progress:
        'Kỳ còn đang chạy. Tính tới lần đo gần nhất, {{metric}} ở mức {{current}} so với đích {{target}}.',
      not_measured:
        'Không có mẫu nào trong kỳ để đo {{metric}}, nên chưa kết luận được. Đây không phải 0% — chưa có phép đo nào cả.',
      achieved: 'Hết kỳ, {{metric}} ở mức {{current}} — đã chạm đích {{target}}.',
      missed: 'Hết kỳ, {{metric}} dừng ở {{current}}, chưa chạm đích {{target}}.',
      closed_early:
        'Quản lý đóng sổ mục tiêu này trước khi hết kỳ, nên nó không được chấm đạt hay không đạt.',
    },

    basisTitle: 'Dựa vào đâu',
    basisStart: 'Điểm bắt đầu',
    basisCurrent: 'Đo được',
    basisTarget: 'Đích',
    basisSamples: 'Số mẫu',
    basisSource: 'Nguồn số liệu',
    sourceManual: 'quản lý báo số',
    basisMeasuredAt: 'Lần đo gần nhất',
    basisNever: 'chưa đo lần nào',
    basisDirection: {
      up: 'chỉ số này càng cao càng tốt',
      down: 'chỉ số này càng thấp càng tốt',
    },
    lowSamples:
      'Ít mẫu (dưới {{min}}) — đọc kết luận này như một tín hiệu, không phải một phán quyết.',
  },
  /**
   * Nguồn số liệu của từng chỉ số — APM-OKR-c.
   *
   * Khoá theo `metricKind` chứ không theo nhóm: thêm một chỉ số vào `GOAL_METRICS`
   * là phải trả lời "nó đọc từ đâu", và một khoá thiếu sẽ hiện ra ngay.
   */
  /**
   * Trang OKR — APM-OKR2-e, docs/plan-performance-redesign.md §14.
   *
   * ⚠️ Khối cấp cao nhất tên `okr`, không phải `goal`: `goal` đã thuộc về mục
   * tiêu cá nhân từ APM-PERF2-l, và một khối trùng tên sẽ **đè** lên nó mà
   * typecheck không bắt (`en.ts` và `vi.ts` chỉ cần khớp **nhau** về hình
   * dạng). Cạm bẫy đã ghi ở CLAUDE.md.
   */
  okrReview: {
    title: 'Đánh giá kỳ',
    by: '{{name}} chốt ngày {{date}}',
    comment: 'Nhận xét chung cho cả kỳ',
    commentHint: 'Kỳ này đi tới đâu, vì sao, và kỳ sau nên khác thế nào',
    verdict: 'Kết luận',
    verdictValue: { met: 'Đạt', missed: 'Không đạt', exceeded: 'Vượt mức' },
    exceededPct: 'Vượt bao nhiêu phần trăm',
    exceededBy: 'Vượt mức {{pct}}%',
    noteAdd: 'Nhận xét mục này',
    noteEdit: 'Sửa nhận xét',
    noteFor: 'Nhận xét cho "{{name}}"',
    noteSave: 'Lưu nhận xét',
    needSomething: 'Phải có ít nhất một nhận xét trước khi lưu.',
    needPct: 'Chọn "vượt mức" thì phải nhập vượt bao nhiêu phần trăm.',
    needGoalPct: 'Có mục chọn "vượt mức" mà chưa nhập phần trăm.',
    perGoalHint: 'Nhận xét riêng cho từng mục tiêu — không bắt buộc.',
    perGoalPlaceholder: 'Nhận xét cho mục này',
    perGoalVerdict: 'Kết luận cho "{{name}}"',
    perGoalNoVerdict: 'Không chốt riêng',
    save: 'Lưu đánh giá',
    edit: 'Sửa đánh giá',
    saved: 'Đã lưu đánh giá kỳ',
    goalGone: 'Mục tiêu đã xoá',
  },
  okr: {
    lateBadge: 'Kỳ đang chạy chưa có mục tiêu nào — hạn chốt {{date}} đã qua',
    warnBadge: 'Kỳ tới chưa có mục tiêu — hạn chốt {{date}}',
    scopeMine: 'OKR của tôi',
    scopeTeam: 'OKR đội của tôi',
    pickMember: 'Nhân sự',
    selfAddOnly:
      'Bạn sửa, xoá được mục chính mình nhập khi kỳ còn mở. Mục quản lý đặt cho bạn thì nhờ quản lý sửa.',
    myTitle: 'OKR của tôi',
    summaryTitle: 'OKR đang chạy',
    summaryLink: 'Mở trang OKR →',
    subtitle:
      'Mục tiêu theo tháng, quý và năm. Chỉ số của danh mục do hệ thống tự đo mỗi đêm; kết quả then chốt tự do thì quản lý trực tiếp báo số.',
    tabsLabel: 'Các tab OKR',
    tab: {
      overview: 'Chung',
      month: 'OKR Tháng',
      quarter: 'OKR Quý',
      year: 'OKR Năm',
    },
    /** Nhãn tab trên điện thoại — bỏ chữ "OKR" để bốn tab vừa một hàng. */
    tabShort: {
      overview: 'Chung',
      month: 'Tháng',
      quarter: 'Quý',
      year: 'Năm',
    },

    previousPeriod: 'Kỳ trước',
    nextPeriod: 'Kỳ sau',
    currentPeriod: 'Về kỳ hiện tại',
    noFurtherPeriod: 'Chỉ đặt được mục tiêu cho kỳ kế tiếp, nên không đi xa hơn.',
    periodLabel: {
      previous: 'Kỳ trước',
      current: 'Kỳ hiện tại',
      next: 'Kỳ kế tiếp',
      other: 'Kỳ đã qua',
    },
    openUntil: 'Còn thêm/sửa được tới hết {{at}}',
    lockedPeriod: 'Đã khoá — chỉ xem, và báo số nếu là kết quả then chốt tự do',
    periodStrip: {
      label: 'Tổng quan các kỳ',
      month: 'T{{month}}',
      quarter: 'Q{{quarter}}',
      met: 'Đạt',
      missed: 'Không đạt',
      exceeded: 'Vượt {{pct}}%',
      unreviewed: 'Chờ chốt',
      running: 'Đang chạy',
      next: 'Kỳ tới',
      none: 'Trống',
      notSet: 'Chưa đặt',
      krCount_one: '{{count}} KR',
      krCount_other: '{{count}} KR',
      krReached: '{{reached}}/{{count}} KR đạt',
      open: 'Xem kỳ {{label}} — {{status}}',
    },
    periodUnlock: {
      chip: 'Đang mở khoá — sửa được tới {{at}}',
      open: 'Mở khoá cho sửa',
      extend: 'Gia hạn',
      relock: 'Khoá lại',
      dialogTitle: 'Mở khoá kỳ đang chạy cho {{name}}',
      dialogBody:
        'Trong thời gian mở, {{name}} thêm, sửa, xoá được OKR của kỳ này (vẫn chỉ sửa được mục chính mình tạo). Hết hạn thì tự khoá lại; không mở quá ngày cuối kỳ.',
      daysLabel: 'Mở trong',
      days_one: '{{count}} ngày',
      days_other: '{{count}} ngày',
      confirm: 'Mở khoá',
      opened: 'Đã mở khoá tới {{at}}',
      relocked: 'Đã khoá lại kỳ này',
      ownerNote: '{{name}} đã mở khoá kỳ này để bạn sửa OKR, tới {{at}}.',
      thisEmployee: 'nhân viên này',
    },
    warnNextEmpty: 'Kỳ kế tiếp chưa có mục tiêu nào và sắp tới hạn chốt',

    noneThisPeriod: 'Kỳ này chưa có mục tiêu nào.',
    limitTitle: 'Số Objective khuyến nghị tối đa',
    limitHint:
      'Một quý có 12 tuần: mỗi mục tiêu cần đủ thời gian để dịch chuyển được cái gì đó. Ba ô đầu đếm số Objective trong một kỳ; ô cuối đếm số Key Result của một Objective. Vượt trần thì giao diện chỉ cảnh báo, không khoá nút — hơn nửa mục tiêu nên do chính người làm nêu ra.',
    limitKrs: 'Key Result mỗi Objective',
    limitSave: 'Lưu số khuyến nghị',
    reportReminder: {
      title: 'Nhắc báo số kết quả then chốt tự do',
      hint: 'Kể từ lúc chốt OKR, cứ mỗi chừng này phần trăm thời gian của kỳ, ai có kết quả then chốt tự do chưa báo số trong quãng vừa qua sẽ được nhắc (chấm đỏ ở OKR trên thanh điều hướng, thông báo và Telegram). Ngày làm việc cuối cùng của kỳ luôn nhắc thêm một lần.',
      label: 'Nhắc mỗi (% thời gian của kỳ)',
      preview: 'Tháng này: khoảng {{days}} và ngày làm việc cuối tháng',
      save: 'Lưu nhịp nhắc',
      saved: 'Đã lưu nhịp nhắc báo số',
    },
    limitSaved: 'Đã lưu số OKR khuyến nghị',
    status: { reviewed: 'Đã đánh giá', pending: 'Chưa đánh giá', noGoals: 'Không đặt mục tiêu' },
    pendingCount: 'Còn {{count}} người chưa được đánh giá kỳ trước',
    pendingNone: 'Kỳ trước đã đánh giá xong cả nhóm',
    draftNone: 'Tháng tới: chưa soạn',
    draftSome: 'Tháng tới: {{objectives}} MT · {{krs}} KR',
    draftingCount: '{{count}}/{{total}} người đã bắt đầu soạn OKR tháng tới',
    pickMemberAria: 'Chọn nhân sự — đang xem {{name}}',
    reviewColumn: 'Kỳ trước',
    draftColumn: 'Tháng tới',
    statusShort: { reviewed: 'Đã đánh giá', pending: 'Chưa đánh giá', noGoals: 'Không đặt' },
    reviewSignal: 'Kỳ trước: {{status}}',
    draftShortNone: 'Chưa soạn',
    draftShortKr: '{{krs}} KR',
    draftShortBoth: '{{objectives}} MT · {{krs}} KR',
    nextMonthTitle: 'OKR Tháng tới · đang soạn',
    nextMonthOpen: 'Mở OKR Tháng tới',
    nextMonthEmpty: 'Chưa soạn OKR nào cho tháng tới. Hạn chốt {{date}}.',
    nextMonthLock: 'hạn chốt {{date}}',
    tooManyObjectives:
      'Kỳ này đã có {{count}} mục tiêu. Khuyến nghị không quá {{limit}} — nhiều đích cùng lúc thì không đích nào đủ thời gian để nhúc nhích.',
    addObjective: 'Thêm mục tiêu',
    objectiveTitle: 'Câu mục tiêu',
    objectivePlaceholder: 'Giao hàng đúng hẹn mà không đánh đổi chất lượng',
    objectiveHint:
      'Một câu nói ý định, không mang con số. Con số nằm ở kết quả then chốt bên dưới nó — hai chỗ cùng mang số thì cuối kỳ không ai biết chấm theo cái nào.',
    objectiveHasNumber:
      'Câu này đang mang một con số. Chuyển nó xuống thành một kết quả then chốt, và viết lại câu trên thành ý định đằng sau con số ấy.',
    objectiveAmbition: 'Loại mục tiêu',
    ambitionHint: {
      committed: '— kỳ vọng đạt đủ 100%',
      aspirational: '— nhắm xa, đạt 60–70% đã là thành công',
    },
    objectiveEmpty:
      'Mục tiêu này chưa có kết quả then chốt nào, nên cuối kỳ không có gì để chấm. Thêm 2–4 chỉ số chứng minh nó đã đạt.',
    objectiveCreated: 'Đã thêm mục tiêu',
    objectiveDeleted: 'Đã xoá mục tiêu. Các kết quả then chốt của nó vẫn còn.',
    objectiveDelete: 'Xoá mục tiêu "{{name}}"',
    editKr: 'Sửa kết quả then chốt',
    editObjective: 'Sửa mục tiêu',
    moreActions: 'Thao tác với "{{name}}"',
    confirmDeleteKr: 'Xoá kết quả then chốt "{{name}}"?',
    confirmDeleteObjective: 'Xoá mục tiêu "{{name}}"? Các kết quả then chốt của nó vẫn giữ lại.',
    objectiveUpdated: 'Đã lưu mục tiêu',
    details: 'Chi tiết',
    hideDetails: 'Thu gọn',
    krCount_zero: 'Chưa có kết quả then chốt',
    krCount_one: '{{count}} kết quả then chốt',
    krCount_other: '{{count}} kết quả then chốt',
    avgProgress: 'Tiến độ trung bình các kết quả then chốt',
    setByManager: 'Quản lý đặt',
    metricHelpLabel: '"{{name}}" là gì và đo thế nào',
    metricLocked: 'Chỉ số không đổi sang loại tự nhập được — xoá rồi thêm lại nếu cần.',
    autoKrTitle: 'KR hệ thống đo tự động',
    autoKrHint: 'Chọn một chỉ số có sẵn — máy tự đo mỗi đêm, không ai phải nhập số.',
    freeKrTitle: 'KR tự do',
    freeKrHint: 'Tự đặt tên, đơn vị và đích — phải tự báo số trong suốt kỳ.',
    autoKrHintUsed:
      'Còn {{count}} chỉ số chưa dùng trong kỳ này — mỗi chỉ số chỉ đặt một lần mỗi kỳ.',
    allMetricsUsed:
      'Kỳ này đã dùng hết các chỉ số đo tự động. Muốn đổi thì sửa hoặc xoá KR đang có, hoặc thêm một KR tự do.',
    krHelpLabel: '"{{name}}" nghĩa là gì',
    krHelpProgress:
      'Xuất phát {{start}} → đích {{target}}, hiện {{current}}: đã đi **{{pct}}%** quãng đường.',
    krHelpNoStart:
      'Đích {{target}}, hiện {{current}}. Chưa có điểm xuất phát nên chưa tính được %.',
    krHelpBehind:
      'Xuất phát {{start}} → đích {{target}}, hiện {{current}}: đang **lùi** so với lúc xuất phát.',
    krHelpNotMeasured: 'Đích {{target}}. Chưa có số nào — {{when}}.',
    krHelpWhenAuto: 'số hiện sau lượt đo đêm nay',
    krHelpWhenManual: 'bấm "Báo số" để ghi số đầu tiên',
    krHelpUp: 'Càng cao càng tốt',
    krHelpDown: 'Càng thấp càng tốt',
    krHelpAuto: 'máy tự đo mỗi đêm, không ai phải nhập.',
    krHelpManual: 'số do người báo tay.',
    noObjective: 'Không thuộc mục tiêu nào',
    pickObjective: 'Thuộc mục tiêu nào? (bỏ trống được)',
    noObjectiveOption: '— Không thuộc mục tiêu nào —',
    emptyEditable: 'Chưa có mục tiêu nào cho kỳ này — thêm ở nút bên trên.',
    emptyLocked: 'Kỳ này không có mục tiêu nào, và đã khoá nên không thêm được nữa.',

    source: { auto: 'Đo tự động', manual: 'Báo số tay' },
    reportValue: 'Báo số',
    reportDue: {
      cta: 'Cần báo số',
      badge: '{{count}} kết quả then chốt cần báo số',
    },
    valueLabel: 'Số đạt được {{unit}}',
    valueReported: 'Đã ghi số',

    valueForm: {
      titlePlaceholder: 'vd. Ký được khách hàng mới',
      kindLabel: 'Kiểu giá trị',
      kind: { integer: 'Số', decimal: 'Số thập phân', percent: 'Phần trăm', text: 'Chữ' },
      kindHint: {
        integer: 'Đếm được bằng số nguyên: khách hàng, bài viết, lỗi… Tiến độ % tự tính.',
        decimal: 'Số có phần lẻ: điểm đánh giá, doanh thu, giây… Tiến độ % tự tính.',
        percent: 'Một tỉ lệ, thường từ 0 tới 100%. Tiến độ % tự tính.',
        text: 'Không đếm được bằng số: mỗi lần báo ghi đang ở đâu, kèm ước lượng ~ bao nhiêu %.',
      },
      start: 'Xuất phát',
      target: 'Đích',
      textStartDefault: 'Chưa bắt đầu',
      textTargetDefault: 'Hoàn thành',
      textHint: 'Tiến độ lấy từ con số "~ %" bạn ước lượng mỗi lần báo, từ 0% tới 100%.',
      direction: { up: 'Càng cao càng tốt', down: 'Càng thấp càng tốt' },
      example: 'Ví dụ: báo {{value}} thì tiến độ là {{pct}}%.',
    },
    reportForm: {
      valueLabel: 'Số hiện tại',
      notReportedYet: 'Chưa báo số lần nào — bấm "Báo số" để ghi.',
      decrease: 'Giảm 1',
      increase: 'Tăng 1',
      integerOnly: 'Kết quả này chỉ nhận số nguyên.',
      percentLabel: 'Phần trăm hiện tại',
      textLabel: 'Đang ở đâu?',
      textPlaceholder: 'vd. Xong bản nháp, đang chờ duyệt',
      approxLabel: 'Ước lượng đã xong',
      approx: '~ {{pct}}%',
      textTarget: '100% là: {{target}}',
      preview: '{{pct}}% quãng đường',
      previewReached: '{{pct}}% — chạm đích',
      previewBehind: '0% — đang lùi so với xuất phát',
      firstIsStart:
        'Kết quả này chưa khai mốc xuất phát, nên số báo lần đầu sẽ thành mốc và hiện 0%. Muốn tính từ mốc khác thì vào Sửa để khai.',
      farBeyond: 'Gấp hơn hai lần quãng đường tới đích — kiểm lại con số và đơn vị.',
    },

    presetsTitle: 'Chỉ số hệ thống tự đo được',
    presetsHint:
      'Chọn một trong những chỉ số này thì không ai phải nhập số: job đêm đo từ chính công việc đã làm. Mức đích là gợi ý, sửa được trước khi lưu.',
    baselineNow: 'đang ở {{value}}',
    noBaseline: 'chưa đo được cho người này',
    addPreset: 'Thêm',

    freeFormShow: 'Hoặc đặt một kết quả then chốt tự do →',
    freeFormHide: 'Ẩn kết quả then chốt tự do',
    freeFormWarning:
      'Kết quả then chốt tự do không ai đo hộ: quản lý trực tiếp phải tự báo số cho nó trong suốt kỳ.',
    freeTitle: 'Tên kết quả then chốt',
    freeUnit: 'Đơn vị',
    freeUnitPlaceholder: 'khách hàng, bài viết…',
    freeDirection: 'Chiều tốt lên',

    lockTitle: 'Hạn chốt OKR',
    lockSubtitle:
      'Hạn cuối để thêm/sửa OKR của một kỳ, đếm bằng số ngày lệch so với ngày đầu kỳ. Số dương: được sửa thêm mấy ngày đầu kỳ. Số âm: phải chốt xong trước khi kỳ bắt đầu. Hết hạn là hết ngày ấy theo giờ của tổ chức.',
    lockMonth: 'OKR tháng (ngày)',
    lockQuarter: 'OKR quý (ngày)',
    lockYear: 'OKR năm (ngày)',
    lockSaved: 'Đã lưu hạn chốt OKR',
    lockHint:
      'Ví dụ kỳ tháng bắt đầu 01/11: +3 ⇒ sửa được tới hết 04/11; 0 ⇒ tới hết 01/11; -7 ⇒ tới hết 25/10.',
    lockPreview: 'Kỳ {{period}}: thêm/sửa được tới hết {{at}}',
  },
  goalSource: {
    on_time_ratio: 'việc hoàn thành trong kỳ',
    rework_ratio: 'việc hoàn thành trong kỳ',
    speed_index: 'việc hoàn thành trong kỳ',
    sla_met_ratio: 'vấn đề vận hành đã đóng trong kỳ',
    reopen_count: 'vấn đề vận hành đã đóng trong kỳ',
    service_hours: 'vấn đề vận hành đã đóng trong kỳ',
  },
  /** Dấu hiệu bất thường trong số liệu hiệu suất — APM-ACHEAT-g. */
  anomalies: {
    title: 'Dấu hiệu cần nhìn lại',
    subtitle:
      'Mẫu hành vi lặp đủ số lần trong {{days}} ngày qua. Mỗi mẫu đều có cách giải thích vô tội — đây là danh sách để hỏi lại, không phải kết luận. Mỗi lần mở là một dòng trong sổ truy cập dữ liệu nhạy cảm.',
    empty: 'Không có dấu hiệu nào trong cửa sổ này.',
    truncated: 'Cửa sổ có quá nhiều sự kiện — kết quả chỉ là một phần. Thu hẹp khoảng thời gian.',
    person: 'Người',
    pattern: 'Mẫu',
    count: 'Số lần',
    threshold: 'ngưỡng ≥ {{value}}',
    tasks: 'Việc liên quan',
    lastAt: 'Gần nhất',
    kind: {
      rapid_completions: 'Nhiều việc xong trong 10 phút',
      repeated_reschedule: 'Dời hạn muộn hơn nhiều lần trên một việc',
      self_block: 'Tự bật cờ "bị chặn" trên việc của mình',
      estimate_bump_before_done: 'Nâng ước lượng rồi đóng việc trong 24 giờ',
      timesheet_at_cap: 'Đồng hồ bị job dừng vì chạm trần',
    },
    kindHelp: {
      rapid_completions:
        'Có thể là dọn board sau một ngày quên kéo thẻ — hoặc đóng hàng loạt để đẹp số.',
      repeated_reschedule: 'Có thể là phụ thuộc trượt — hoặc dời hạn để không bao giờ "trễ".',
      self_block:
        'Quãng tự chặn không còn được trừ khỏi giờ làm, nhưng thói quen này vẫn đáng hỏi.',
      estimate_bump_before_done: 'Ước lượng sửa sát lúc xong không còn là ước lượng.',
      timesheet_at_cap: 'Quên bấm dừng nhiều lần, hoặc để đồng hồ chạy.',
    },
  },
  velocity: {
    restricted:
      'Trang này dành cho người lập kế hoạch — trưởng nhóm, giám đốc và quản trị tổ chức. Số liệu về chính bạn nằm ở trang Hiệu suất.',
    title: 'Hiệu chỉnh ước lượng',
    subtitle:
      'Loại việc này, công nghệ này, giao cho ai thì mất bao lâu — đo từ dữ liệu task thật, dùng để ước lượng sprint. Hiệu suất của bạn nằm ở trang Hiệu suất. Mọi lần xem số của người khác đều được ghi lại.',
    mineTitle: 'Của tôi',
    mineHint: 'Chỉ bạn và người có quyền hiệu suất xem được.',
    orgTitle: 'Toàn tổ chức',
    orgForbidden:
      'Bạn không có quyền xem velocity của người khác. Phần “Của tôi” ở trên vẫn đầy đủ.',
    audited: 'Mỗi lần xem được ghi vào sổ audit',
    byTechStack: 'Tách theo tech stack',
    sync: 'Dựng lại mẫu',
    syncing: 'Đang dựng…',
    synced: 'Đã dựng {{count}} mẫu mới.',
    window: 'Cửa sổ {{from}} – {{to}} · {{count}} mẫu',
    truncated: 'đã đụng trần, bảng chỉ nói về một phần dữ liệu',
    empty: 'Chưa có mẫu nào. Mẫu được dựng từ task đã xong, có ước lượng và có người làm.',
    person: 'Người',
    taskType: 'Loại task',
    techStack: 'Tech stack',
    anyStack: 'không xác định',
    ratio: 'Tỷ lệ',
    ratioValue: '{{value}}×',
    spread: 'Khoảng giữa',
    samples: 'Mẫu',
    confidence: 'Độ tin cậy',
    confidenceValue: { low: 'Chưa đủ', medium: 'Tạm đủ', high: 'Đủ tin' },
    waiting: 'Chờ',
    waitingValue: '{{count}} mẫu · {{hours}}h',
    waitingHint: 'Mẫu bị loại vì phần lớn thời gian là chờ, tổng {{hours}} giờ',
    samplesTitle: 'Căn cứ: {{name}} · {{type}}',
    close: 'Đóng',
    completedAt: 'Xong ngày',
    estimate: 'Ước lượng',
    worked: 'Làm thật',
    blocked: 'Chờ',
    counted: 'Tính vào',
    isCounted: 'Có',
    notCounted: 'Không (ngoại cảnh)',
  },
  demo: {
    badge: 'DEMO',
    badgeHint: 'Dự án mẫu — không tính vào báo cáo tổ chức hay hồ sơ năng lực.',
  },
  gantt: {
    pageRows: 'Hàng {{from}}–{{to}} / {{total}} · Đường găng tính toàn phạm vi',
    offPageLinks: '{{count}} liên kết nằm ngoài trang này',
    allRows: 'Xem toàn bộ sơ đồ',
    pagedRows: 'Chia trang 200 hàng',
    dependencyType: {
      finish_to_start: 'Xong rồi mới bắt đầu',
      start_to_start: 'Bắt đầu cùng lúc',
      finish_to_finish: 'Kết thúc cùng lúc',
      start_to_finish: 'Bắt đầu rồi mới kết thúc',
    },
    zoom: { day: 'Ngày', week: 'Tuần', month: 'Tháng' },
    chartLabel: 'Biểu đồ Gantt',
    noDates: 'Chưa task nào có ngày. Đặt ngày để thấy thanh trên biểu đồ.',
    emptyTitle: 'Chưa có task nào',
    emptyDescription: 'Tạo task và đặt ngày để dựng lịch trình.',
    criticalOnly: 'Chỉ đường găng',
    colTask: 'Công việc',
    colAssignee: 'Người làm',
    colStatus: 'Trạng thái',
    statusTodo: 'Chưa làm',
    statusDone: 'Đã xong',
    colDays: 'Ngày',
    colDates: 'Từ – đến',
    resizeList: 'Kéo để đổi bề rộng khung danh sách',
    noAssignee: 'chưa giao',
    noDatesShort: 'chưa có ngày',
    linkHint: 'Kéo sang task khác để tạo phụ thuộc',
    edit: 'Sửa biểu đồ',
    editDone: 'Xong',
    moveMilestoneTitle: 'Dời mốc sang ngày khác?',
    moveMilestoneFrom: 'Đang là',
    moveMilestoneTo: 'Ngày mới',
    moveMilestoneConfirm: 'Dời mốc',
    unlinkHint: 'Bấm để bỏ liên kết',
    linked: 'Đã tạo phụ thuộc',
    unlinked: 'Đã bỏ liên kết',
    deadlineLabel: 'Hạn dự án',
    roundMarker: 'Vòng {{number}}',
    roundMarkerOpen: 'Vòng test {{number}} — đang mở. Bấm để xem tab Kiểm thử.',
    roundMarkerClosed: 'Vòng test {{number}} — đã đóng {{date}}. Bấm để xem tab Kiểm thử.',
    kind: { milestone: 'Milestone', phase_gate: 'Cổng pha', task: 'Công việc' },
    selectedCount: 'Đã tích {{count}} việc',
    clearSelection: 'Bỏ tích',
    groupSelected: 'Gom thành nhóm mới',
    moveToExistingGroup: 'Chuyển vào nhóm có sẵn',
    createGroup: 'Tạo nhóm',
    groupName: 'Tên nhóm',
    groupNamePlaceholder: 'Ví dụ: Pha 1 — Khảo sát',
    noGroupYet: 'Dự án chưa có nhóm nào',
    removeFromGroup: 'Bỏ khỏi nhóm',
    ungrouped: 'Chưa thuộc nhóm',
    toggleGroup: 'Gấp/mở nhóm {{name}}',
    renameGroup: 'Đổi tên nhóm {{name}}',
    deleteGroup: 'Xoá nhóm {{name}}',
    selectTask: 'Tích chọn {{name}}',
    groupCreateDone: 'Đã tạo nhóm',
    groupRenameDone: 'Đã đổi tên nhóm',
    groupDeleteDone: 'Đã xoá nhóm — việc bên trong vẫn còn',
    groupAssignDone: 'Đã cập nhật nhóm',
    criticalTitle: 'Nằm trên đường găng',
    criticalLength: 'Đường găng: {{days}} ngày',
    onCriticalPath: 'Trên đường găng — trễ một ngày là dự án trễ một ngày',
    floatDays: 'Còn {{days}} ngày dự phòng',
    barTitle: 'Dự phòng {{float}} ngày',
    holidayTitle: 'Nghỉ lễ: {{name}}',
    violationTitle: 'Bắt đầu sớm hơn {{days}} ngày so với mức phụ thuộc cho phép',
    violationToast: 'Đã lưu, nhưng lịch này sớm hơn {{days}} ngày so với task đi trước.',
    baselineTitle: 'Kế hoạch gốc',
    setBaseline: 'Chốt kế hoạch gốc',
    rebaseline: 'Chốt lại kế hoạch gốc',
    baselineSaved: 'Đã chốt kế hoạch gốc',
    slippage: 'Chậm {{days}} ngày so với kế hoạch gốc',
    legendOnTrack: 'Đúng tiến độ',
    legendBehind: 'Chậm so với tiến độ dự kiến',
    legendOverdue: 'Quá hạn',
    legendDone: 'Đã xong',
    legendDoneLate: 'Xong trễ hạn',
    doneLateTitle: 'Hoàn thành ngày {{done}}, sau hạn {{due}}',
    legendViolation: 'Lịch sai: bắt đầu trước khi việc trước xong',
    legendToggle: 'Chú giải màu',
    offscreenHint: 'Thanh của "{{name}}" nằm ngoài khung — bấm để cuộn tới',
    moreActions: 'Thao tác khác',
    makeMilestone: 'Đổi thành mốc',
    makeTask: 'Đổi thành task',
    passGate: 'Qua cổng pha',
    gatePassed: 'Đã ghi nhận qua cổng pha',
    selectHint: 'Bấm vào một thanh để xem chi tiết. Kéo thân thanh để dời, kéo hai mép để co giãn.',
  },
  recurrence: {
    intro: 'Mẫu việc lặp lại theo lịch. Mỗi lần đến hạn hệ thống sinh một việc thật vào board.',
    new: 'Mẫu định kỳ mới',
    newTitle: 'Mẫu việc định kỳ mới',
    editTitle: 'Sửa mẫu việc định kỳ',
    create: 'Tạo mẫu',
    created: 'Đã tạo mẫu việc định kỳ',
    updated: 'Đã lưu mẫu — thay đổi áp cho các lần sau',
    deleted: 'Đã xoá mẫu. Các việc đã sinh vẫn giữ nguyên',
    confirmDelete: 'Xoá mẫu "{{title}}"? Các việc đã sinh vẫn giữ nguyên.',
    emptyTitle: 'Chưa có việc định kỳ nào',
    emptyHelp:
      'Tạo một mẫu (ví dụ "Rà soát service hằng tuần") để hệ thống tự sinh việc mỗi lần đến hạn.',
    emptyHelpReadOnly: 'PM của dự án tạo mẫu việc định kỳ ở đây.',
    /** Bộ chọn kỳ/sprint bị khoá (không ẩn) khi đang ở cách nhìn Định kỳ. */
    pickersLocked:
      'Mẫu định kỳ không thuộc kỳ hay sprint nào — bộ chọn chỉ dùng cho Board, Gantt và Danh sách.',
    paused: 'Tạm dừng',
    pause: 'Tạm dừng',
    resume: 'Bật lại',
    noOccurrences: 'Chưa sinh lần nào.',
    occurrenceOn: 'Lần {{date}}',
    dueOn: 'hạn {{date}}',
    titleLabel: 'Tên việc',
    titlePlaceholder: 'Ví dụ: Rà soát log và dung lượng service',
    scheduleLabel: 'Lịch lặp',
    freqLabel: 'Lặp',
    freq: {
      daily: 'Mỗi ngày làm việc',
      weekly: 'Hằng tuần',
      monthly: 'Hằng tháng',
      interval: 'Mỗi N ngày',
    },
    weekdaysLabel: 'Các thứ trong tuần',
    weekdayShort: { '0': 'CN', '1': 'T2', '2': 'T3', '3': 'T4', '4': 'T5', '5': 'T6', '6': 'T7' },
    monthDayLabel: 'Ngày trong tháng',
    lastDay: 'Ngày cuối tháng',
    intervalLabel: 'Số ngày giữa hai lần',
    startLabel: 'Bắt đầu',
    endLabel: 'Kết thúc (tuỳ chọn)',
    leadLabel: 'Hiện trước (ngày)',
    leadHelp: 'Việc được sinh vào board trước hạn bấy nhiêu ngày. 0 = sinh đúng ngày đến hạn.',
    previewLabel: '3 lần tới:',
    previewNone: 'Không còn lần nào trong lịch.',
    previewInvalid: 'Lịch chưa hợp lệ',
    previewHelp:
      'Lần rơi vào ngày nghỉ được dời sang ngày làm việc kế tiếp (lịch "mỗi ngày làm việc" thì bỏ qua ngày nghỉ).',
    addChecklist: 'Thêm checklist',
    editHelp: 'Sửa mẫu chỉ áp cho các lần sinh sau; việc đã sinh giữ nguyên.',
    col: {
      title: 'Việc',
      rule: 'Lặp',
      assignee: 'Người phụ trách',
      last: 'Lần gần nhất',
      next: 'Lần kế tiếp',
      pending: 'Đang tồn',
    },
    summary: {
      daily: 'Mỗi ngày làm việc',
      weekly: 'Hằng tuần: {{days}}',
      monthly: 'Ngày {{day}} hằng tháng',
      monthlyLast: 'Ngày cuối tháng',
      interval_one: 'Mỗi {{count}} ngày',
      interval_other: 'Mỗi {{count}} ngày',
    },
    mark: 'Việc định kỳ',
    markHelp:
      'Việc định kỳ — sinh tự động theo mẫu. Sửa ở đây chỉ đổi lần này; muốn đổi mọi lần sau thì sửa mẫu ở cách nhìn "Định kỳ".',
  },
  tasks: {
    view: {
      board: 'Board',
      gantt: 'Gantt',
      list: 'Danh sách',
      recurring: 'Định kỳ',
    },
    pickSprintTitle: 'Chọn một sprint để xem công việc',
    pickSprintHelp:
      'Dự án này chưa có sprint nào đang chạy. Mỗi sprint có cột riêng, nên gộp tất cả lại sẽ cho một board không đọc được.',
  },
  scheduleDrawer: {
    title: 'Việc chưa xếp lịch',
    hint: 'Kéo một dòng lên biểu đồ Gantt để vừa vào sprint vừa đặt ngày.',
    empty: 'Không còn việc nào ngoài sprint.',
    noEstimate: 'chưa ước lượng',
    hours_one: '{{count}} giờ',
    hours_other: '{{count}} giờ',
    sendToSprint: 'Vào {{name}}',
    scheduled: 'Đã xếp {{key}}: {{from}} → {{to}}',
    scopeCreep:
      'Đã thêm {{key}} vào sprint **đang chạy** — phạm vi tăng nhưng cam kết đầu sprint thì không.',
  },
  actualTime: {
    title: 'Baseline, kế hoạch và thực tế',
    baseline: 'Baseline',
    baselineHelp:
      'Kế hoạch gốc: ngày bắt đầu và hạn được chụp lại lúc chốt baseline. Không đổi khi dời deadline — chỉ chốt lại được qua Change Request đã duyệt.',
    dueMoved: 'Deadline đã dời khỏi baseline',
    planned: 'Hiện tại',
    actual: 'Thực tế',
    start: 'Bắt đầu',
    end: 'Kết thúc',
    hours: 'Số giờ',
    hoursValue: '{{count}} giờ',
    elapsed: 'Trôi qua {{count}} giờ từ lúc bắt đầu tới lúc xong (tính cả đêm, ngày nghỉ).',
    actualHoursHelp: 'Tự tính từ đồng hồ bấm giờ — không sửa tay.',
    estimateTitle: 'Ước lượng',
    spValue: '{{value}} SP',
    spNone: 'Chưa có SP',
    estimateRun: 'Ước lượng SP',
    estimateRerun: 'Ước lượng lại',
    openReference: 'Mở việc mẫu ở tab mới',
    badgeTitle: 'Story point — bấm để xem nguồn và ước lượng lại',
    badgeNone: '– SP',
    summary: {
      sp: 'Số SP ước lượng',
      hours: 'Thời gian ước lượng',
      method: 'Cách ước lượng',
      methodReference: 'So với một việc cũ',
      methodEdited: 'So với một việc cũ, sau đó SP được sửa tay',
      methodDialog: 'Tự điền số SP',
      methodForm: 'Điền tay ở form việc',
      methodNone: 'Chưa ước lượng',
      refTask: 'Việc được so',
      refPoints: 'SP của việc đó',
      ratio: 'Chênh lệch',
      ratioMore: '{{pct}} (việc này tốn hơn)',
      ratioLess: '{{pct}} (việc này ít hơn)',
      ratioSame: '0% (ngang nhau)',
      none: 'Chưa có',
    },
    hiddenReference: 'ở dự án bạn không xem được',
  },
  taskList: {
    searchPlaceholder: 'Tìm theo mã hoặc tên việc',
    filterAssignee: 'Lọc theo người phụ trách',
    filterStatus: 'Lọc theo cột',
    everyone: 'Mọi người',
    unassigned: 'Chưa giao ai',
    allStatuses: 'Mọi cột',
    overdueOnly: 'Chỉ việc quá hạn',
    overdue: 'quá hạn',
    doneLate: 'xong trễ',
    doneLateTitle: 'Hoàn thành ngày {{done}}, sau hạn {{due}}',
    count: '{{shown}}/{{total}} việc',
    sortBy: 'Sắp xếp theo {{column}}',
    emptyTitle: 'Không có việc nào',
    emptyFiltered: 'Không việc nào khớp bộ lọc đang đặt. Thử bỏ bớt điều kiện.',
    open: 'Mở chi tiết {{key}}',
    pick: 'Chọn {{key}}',
    pickAll: 'Chọn tất cả',
    picked: 'Đã chọn {{count}} việc',
    clearPick: 'Bỏ chọn',
    changeStatus: 'Đổi cột',
    groupBy: 'Gom theo',
    groupCount: '{{count}} việc',
    groupEmpty: 'Chưa có việc nào trong nhóm này.',
    allRows: 'Tất cả công việc',
    drag: 'Kéo {{key}} sang cột khác',
    group: {
      status: 'Cột',
      assignee: 'Phụ trách',
      none: 'Không gom',
    },
    changePriority: 'Đổi độ ưu tiên',
    changeDue: 'Đổi hạn của {{key}}',
    changeTimeline: 'Đổi khoảng thời gian của {{key}}',
    changeProgress: 'Đổi tiến độ của {{key}}',
    changeAssignee: 'Đổi người phụ trách {{key}}',
    startDate: 'Bắt đầu',
    clearDate: 'Xoá hạn',
    addTask: 'Thêm việc',
    addTaskPlaceholder: 'Tên việc, rồi Enter',
    pickStatus: '— chọn cột —',
    column: {
      key: 'Mã',
      title: 'Việc',
      status: 'Cột',
      assignee: 'Phụ trách',
      due: 'Hạn',
      timeline: 'Thời gian',
      progress: 'Tiến độ',
      priority: 'Ưu tiên',
      points: 'Điểm',
    },
  },
  projectBudget: {
    estimateTitle: 'Ước lượng chi phí',
    approvedTitle: 'Mức đã duyệt',
    ratesTitle: 'Đơn giá giờ',
    itemsTitle: 'Khoản chi',
    newItem: 'Thêm khoản chi',
    aiSpent:
      'Đã tiêu {{value}} USD cho AI qua {{count}} lời gọi (không cộng vào tổng trên — khác đơn vị tiền).',
    loadFailed: 'Không tải được dữ liệu ngân sách.',
    topTasks: 'Tốn nhiều nhất',
    taskHours: '{{hours}} giờ',
    taskGone: '(việc đã bị xoá)',
    assumptionsTitle: 'Giả định của lượt ước lượng bằng AI',
    assumptionsHint:
      'Đây là giả định của một lượt chạy, chưa phải dữ liệu. Lưu thành đơn giá thật thì nó mới áp cho mọi báo cáo về sau.',
    saveAssumption: 'Lưu thành đơn giá',
    assumptionSaved: 'Đã lưu thành đơn giá, hiệu lực từ hôm nay.',
    trendTitle: 'Chi phí ước lượng theo thời gian',
    trendSubtitle: '90 ngày gần nhất',
    trendTotal: 'Tổng ước lượng',
    trendApproved: 'Mức đã duyệt',
    trendEmpty: 'Chưa có gì để vẽ',
    trendEmptyHelp: 'Cần ít nhất một việc có ước lượng giờ và một đơn giá áp được cho nó.',
    labour: 'Nhân công',
    items: 'Khoản chi',
    contingency: 'Dự phòng',
    asOf: 'tại mốc {{asOf}}',
    covered: 'Tính được {{covered}}/{{total}} việc',
    missing: 'Còn thiếu: {{hours}} việc chưa ước lượng giờ, {{rates}} việc chưa có đơn giá.',
    vsApproved: 'So với mức đã duyệt: {{delta}}',
    confidence: { low: 'độ tin cậy thấp', medium: 'độ tin cậy trung bình', high: 'độ tin cậy cao' },
    approvedLine: 'Đã duyệt {{amount}} (bản {{version}}, dự phòng {{contingency}}%)',
    noApproval: 'Chưa ai duyệt mức ngân sách',
    noApprovalHint: 'Duyệt một mức để so ước lượng với cam kết. Mỗi lần duyệt giữ lại bản cũ.',
    approve: 'Duyệt mức này',
    approveAmount: 'Mức duyệt',
    approveContingency: 'Dự phòng (%)',
    approved: 'Đã ghi mức duyệt mới.',
    ratesAggregated:
      'Đang xem bản đã gộp theo chức vụ và kỹ năng — đơn giá theo từng người là dữ liệu lương, cần quyền riêng.',
    ratesFull:
      'Đang xem đầy đủ, gồm cả đơn giá theo từng người. Mỗi lần xem được ghi vào sổ truy cập.',
    noRates: 'Chưa khai đơn giá nào',
    noRatesHint: 'Chưa có đơn giá thì phần nhân công không tính được. Khai ở mục Quản trị.',
    rateSubject: 'Áp cho',
    rateHourly: 'Giá mỗi giờ',
    rateFrom: 'Hiệu lực từ',
    subjectType: { user: 'Một người', project_role: 'Chức vụ dự án', skill: 'Kỹ năng' },
    noItems: 'Chưa có khoản chi nào',
    noItemsHint: 'Thiết bị, giấy phép, hạ tầng, thuê ngoài — những thứ không tính theo giờ công.',
    itemName: 'Tên khoản chi',
    itemAmount: 'Số tiền',
    itemKind: 'Loại',
    itemRecurrence: 'Tần suất',
    addItem: 'Thêm',
    itemAdded: 'Đã thêm khoản chi.',
    removeItem: 'Xoá khoản chi {{name}}',
    kind: {
      equipment: 'Thiết bị',
      license: 'Giấy phép',
      infra: 'Hạ tầng',
      vendor: 'Thuê ngoài',
      travel: 'Đi lại',
      other: 'Khác',
    },
    recurrence: {
      once: 'Một lần',
      daily: 'Hàng ngày',
      weekly: 'Hàng tuần',
      monthly: 'Hàng tháng',
      yearly: 'Hàng năm',
    },
  },
  drift: {
    title_one: '{{count}} việc đang chậm deadline',
    title_other: '{{count}} việc đang chậm deadline',
    show: 'Xem danh sách',
    hide: 'Thu lại',
    due: 'Hạn {{date}}',
    changeDue: 'Đổi deadline của {{key}}',
    dueSaved: 'Đã đổi deadline',
    cause: { late: 'trễ {{days}} ngày làm việc', early: 'sớm {{days}} ngày làm việc' },
  },
  board: {
    moreTabs: 'Còn {{n}} mục nữa',
    tab: {
      sprints: 'Sprint',
      overview: 'Điều lệ',
      tasks: 'Công việc',
      raid: 'RAID',
      documents: 'Tài liệu',
      changes: 'Thay đổi',
      objectives: 'Mục tiêu',
      reports: 'Báo cáo',
      budget: 'Ngân sách',
      testing: 'Kiểm thử',
      design: 'Thiết kế',
      git: 'Git',
      issues: 'Issue',
      coordination: 'Nhân sự',
      replay: 'Tua lại',
      settings: 'Cấu hình',
    },
    status: { planning: 'Đang lập kế hoạch', active: 'Đang chạy', completed: 'Đã đóng' },
    chooseProject: 'Chọn dự án',
    methodologyName: { AGILE: 'Agile', WATERFALL: 'Waterfall', MAINTAIN: 'Bảo trì' },
    methodology: 'Phương pháp: {{value}}',
    noProject: 'Chưa có dự án nào',
    noProjectHelp: 'Tạo dự án đầu tiên để bắt đầu lập kế hoạch.',
    emptyTitle: 'Board đang trống',
    emptyDescription: 'Chưa có task nào ở sprint này. Kéo task từ backlog sang, hoặc tạo task mới.',
    emptyDescriptionPeriod: 'Chưa có việc nào trong kỳ này. Chọn kỳ khác, hoặc tạo việc mới.',
    emptyDescriptionAll: 'Chưa có việc nào. Tạo việc đầu tiên.',
    emptyColumn: 'Thả thẻ vào đây',
    wipTitle: 'Đang có {{count}} thẻ, giới hạn {{limit}}',
    closeTask: 'Hoàn thành',
    closeTaskTitle: 'Chuyển sang {{status}}',
    startTask: 'Bắt đầu làm — chuyển sang {{status}}',
    taskStarted: 'Đã bắt đầu làm việc này.',
    taskClosed: 'Đã hoàn thành việc',
    progressReadOnly: 'Tiến độ: {{value}}%',
    progressRollup: 'Tiến độ tính từ subtask',
    progressNotStarted: 'Chuyển sang Đang làm để cập nhật',
    progressInBacklog: 'Việc đang ở backlog — đưa vào sprint để cập nhật tiến độ',
    progressNotInProgress: 'Chỉ việc đang làm mới cập nhật được tiến độ',
    setProgress: 'Đặt tiến độ {{value}}%',
    progressDown: 'Giảm {{step}}%',
    progressUp: 'Tăng {{step}}%',
    progressSlider: 'Thanh trượt tiến độ',
    progressSaved: 'Đã cập nhật tiến độ',
    backlog: 'Backlog',
    backlogEmpty: 'Backlog trống',
    backlogEmptyHelp: 'Mọi task đã được xếp vào sprint.',
    sprints: 'Sprint',
    addColumn: 'Thêm cột',
    columnName: 'Tên cột',
    columnNamePlaceholder: 'Ví dụ: Đang review, Chờ QA…',
    columnColor: 'Màu cột',
    colorAuto: 'Tự chọn theo nhóm',
    columnCategory: 'Thuộc nhóm',
    categoryHint:
      'Nhóm quyết định cách burndown, cycle time và CFD đếm cột này — không phải cách nó hiện trên board.',
    category: { todo: 'Chưa làm', in_progress: 'Đang làm', done: 'Đã xong' },
    columnMenu: 'Tuỳ chọn cột {{name}}',
    renameColumn: 'Đổi tên cột',
    setWipLimit: 'Đặt WIP limit',
    changeWipLimit: 'WIP limit: {{limit}}',
    moveColumnLeft: 'Chuyển sang trái',
    moveColumnRight: 'Chuyển sang phải',
    deleteColumn: 'Xoá cột',
    deleteColumnBlocked: 'Còn {{count}} thẻ — không xoá được',
    deleteColumnDefault: 'Cột mặc định — không xoá được',
    selectedCount: 'Đã chọn {{count}} việc',
    moveSelectedToSprint: 'Đưa vào sprint',
    clearSelection: 'Bỏ chọn',
    newSprintName: 'Tên sprint mới',
    createAndMove: 'Tạo và chuyển',
    noOpenSprint: 'Chưa có sprint nào đang mở',
    selectTask: 'Chọn {{key}}',
    backlogHint: 'Chọn nhiều việc rồi đưa cả lô vào sprint.',
    sprintPickerNone: '— chọn sprint —',
    sprintPicker: 'Sprint:',
    sprintPickerAll: 'Cả dự án',
    sprintRunning: 'đang chạy',
    sprintFrame: 'Cột của {{name}}',
    sprintFrameAny: 'Cột của sprint',
    sprintFrameEmpty: 'Chọn một sprint để xem cột riêng của nó.',
    sprintFrameNoColumns:
      'Sprint này chưa có cột riêng — việc của nó đang nằm ở các cột dùng chung bên dưới.',
    columnScope: 'Cột này thuộc về',
    scopeThisSprint: 'Riêng {{name}}',
    scopeEverySprint: 'Mọi sprint',
    outsideZone: 'Cột ngoài sprint',
    moveColumnIntoSprint: 'Đưa vào khung sprint',
    moveColumnOutside: 'Đưa ra ngoài khung',
    columnMoved: 'Đã chuyển cột',
    columnMovedDisplaced_one: 'Đã chuyển cột — {{count}} việc phải dời sang cột khác',
    columnMovedDisplaced_other: 'Đã chuyển cột — {{count}} việc phải dời sang cột khác',
    confirmMoveColumn:
      'Cột "{{name}}" đang có {{count}} việc. Việc nào không thuộc sprint mới của cột sẽ bị dời sang cột khác. Tiếp tục?',
    needSprintFirst: 'Chưa có sprint đang chạy — tạo sprint trước rồi mới đưa việc vào.',
    sprintIsClosed:
      '{{name}} đã đóng — không đưa thêm việc vào được. Chọn một sprint đang chạy hoặc tạo sprint mới.',
    sprintClosedGeneric: 'Sprint đã đóng — không đưa thêm việc vào được.',
    sprintClosedTask: 'Sprint đã đóng — việc trong đó là lịch sử, không sửa được nữa.',
    taskCompletedLocked: 'Việc đã xong — mở lại rồi mới sửa được ước lượng hay story point.',
    statusDragOnly:
      'Bạn đổi được cột của việc. Xếp thứ tự là việc của PM; đưa việc vào/ra sprint là việc của PM hoặc người tạo việc.',
    movedToSprint: 'Đã đưa {{count}} việc vào sprint',
    movedToBacklog: 'Đã trả {{count}} việc về hàng đợi',
    sprintStatus: { planning: 'chưa bắt đầu', active: 'đang chạy', completed: 'đã đóng' },
    sprintView: { flow: 'Dòng chảy', list: 'Danh sách sprint' },
    createdBy: 'Người tạo',
    createdByOther: 'Ngoài kế hoạch',
    createdByOtherTitle:
      'Việc này do {{name}} tự thêm, không nằm trong kế hoạch quản lý dự án lập.',
    createdByOtherUnknown: 'Việc này không do quản lý dự án tạo.',
    dragCard: 'Kéo {{key}} sang cột khác',
    milestones: 'Mốc',
    milestoneDone: 'Mốc đã đạt',
    milestoneLate: 'Mốc đã quá ngày mà chưa đạt',
    milestoneOpen: 'Mốc sắp tới — bấm để xem chi tiết',
    cardKey: 'Mã việc',
    cardType: 'Loại việc',
    cardPriority: 'Độ ưu tiên: {{value}}',
    cardPriorityPick: 'Độ ưu tiên: {{value}} — bấm để đổi',
    cardAssigneePick: 'Người phụ trách {{key}}: {{name}} — bấm để giao cho người khác',
    cardAssigneeEmpty: '{{key}} chưa giao ai — bấm để giao việc',
    cardAssign: 'Giao việc',
    cardDue: 'Hạn: {{value}}',
    cardDueLate: 'Hạn: {{value}} — đã quá hạn',
    cardDueDoneLate: 'Hạn: {{value}} — hoàn thành trễ, xong ngày {{done}}',
    cardDuePick: 'Hạn: {{value}} — bấm để đổi',
    dueChanged: 'Đã đổi hạn',
    cardBlocked: 'Đang bị chặn: {{reason}}',
    cardBlockedNoReason: 'Đang bị chặn',
    priorityChanged: 'Đã đổi độ ưu tiên',
    sprintGroup: {
      active: 'Đang chạy ({{count}})',
      planning: 'Chưa bắt đầu ({{count}})',
      completed: 'Đã đóng ({{count}})',
    },
    finishPrompt: '“{{title}}” đã 100%. Chuyển sang cột hoàn thành?',
    finishConfirm: 'Chuyển sang {{column}}',
    newSprint: 'Sprint mới',
    noSprintYet: 'Chưa có sprint nào.',
    noSprint: 'Chưa có sprint',
    chooseSprint: 'Xếp vào sprint',
    moveToSprint: 'Xếp {{key}} vào sprint',
    startSprint: 'Bắt đầu',
    closeSprint: 'Đóng sprint',
    sprintClosed: 'Đã đóng sprint. {{carried}} task chưa xong quay về backlog.',
    quickUpdate: 'Cập nhật nhanh',
    quickUpdateDragHint: 'Cập nhật nhanh — kéo để đổi chỗ nút',
    nothingInProgress: 'Bạn không có task nào đang làm.',
  },
  ai: {
    running: 'Đang xử lý…',
    goManual: 'Làm thủ công',
    keyRequired: {
      title: 'Cần key AI',
      body: '“{{feature}}” chạy bằng AI, nên cần một key AI trước. Nhập key ở trang Cài đặt — chỉ mất một phút.',
      manual: 'Hoặc làm thủ công:',
      openSettings: 'Nhập key AI',
    },
    confirm: {
      run: 'Thực thi',
      genericDescription:
        'Trợ lý AI sẽ đọc dữ liệu liên quan trong dự án rồi đưa ra đề xuất cho việc này.',
      whatHappens: 'Khi bấm Thực thi:',
      readsScope: 'AI chỉ đọc những dữ liệu bạn đang được phép xem.',
      suggestOnly: 'Kết quả chỉ là gợi ý — dự án không thay đổi gì cho tới khi bạn xem và duyệt.',
      costAndTime:
        'Mỗi lượt chạy tốn chi phí AI và mất vài giây tới khoảng một phút; từng bước hiện ở bảng bên phải.',
    },
    failure: {
      title: 'Trợ lý chưa làm được việc này',
    },
    estimate: {
      value: '{{value}} {{unit}}',
      range: '(khoảng {{low}}–{{high}})',
      primary: '· căn cứ chính',
      unit: {
        sp: 'điểm',
        hours: 'giờ',
        days: 'ngày',
        usd: 'USD',
        pct: '%',
      },
      confidence: {
        low: 'tin cậy thấp',
        medium: 'tin cậy trung bình',
        high: 'tin cậy cao',
      },
      evidenceKind: {
        similar_task: 'Việc tương tự:',
        velocity: 'Tốc độ đội:',
        calendar: 'Lịch làm việc:',
        dependency: 'Phụ thuộc:',
        assumption: 'Giả định:',
        knowledge: 'Sổ kiến thức:',
      },
    },
    activity: {
      title: 'Trợ lý AI đang làm gì',
      close: 'Đóng bảng theo dõi',
      toggle: 'Bảng trợ lý AI',
      browseTitle: 'Trợ lý AI',
      browseHelp: 'Việc đang chờ bạn, và những lượt đã chạy.',
      openHistory: 'Xem các lượt đã chạy',
      backToRun: 'Về lượt đang chạy',
      historyBack: 'Về danh sách',
      historyEmpty: 'Bạn chưa nhờ trợ lý làm việc gì.',
      awaitingBadge: 'Chờ bạn trả lời',
      resume: 'Chạy tiếp',
      resumeHint: 'Giữ nguyên những gì trợ lý đã đọc, chỉ chạy tiếp phần còn dở.',
      resumedFrom: 'Nối tiếp sau lượt {{turn}} — phần trên là dữ liệu của lượt chạy trước.',
      controlPhase: {
        evidence: 'Đọc dữ liệu cần thiết',
        synthesis: 'Dữ liệu đã sẵn sàng để sinh kết quả',
        normalized: 'Đã chuẩn hóa định dạng bản nháp',
        repair: 'Giữ bản nháp, sửa phần chưa hợp lệ',
      },
      totalTime: 'Tổng {{value}} giây trong harness. Năm pha tốn nhất:',
      contextMemory_one: 'Bộ nhớ ({{count}} mục)',
      contextMemory_other: 'Bộ nhớ ({{count}} mục)',
      contextCache: 'Điểm cắt cache — phần phía trên dùng lại được ở lượt sau',
      contextDropped: '⚠ Đã bỏ vì quá dài: {{items}}',
      hiddenTools: 'Công cụ bị ẩn vì bạn không có quyền đọc: {{tools}}',
      contextLayer: {
        harness_rules: 'Luật của trợ lý',
        skill_prompt: 'Chỉ dẫn của tính năng',
        org_knowledge: 'Kiến thức tổ chức',
        project_profile: 'Hồ sơ dự án',
        user_request: 'Yêu cầu của bạn',
      },
      noTrace: 'Không còn dấu vết của lượt chạy này — chỉ còn câu hỏi.',
      awaitingQuestions_one: '{{count}} câu hỏi',
      awaitingQuestions_other: '{{count}} câu hỏi',
      historyNoSteps: 'Lượt này không còn bước nào được lưu.',
      waiting: 'Đang chờ trợ lý bắt đầu…',
      idlePhrases: {
        resolving: 'Đang phân giải dữ liệu',
        analyzing: 'Đang phân tích',
        thinking: 'Đang suy nghĩ',
        drafting: 'Đang sinh kết quả tạm thời',
        synthesizing: 'Đang tổng hợp',
      },
      applied: 'Đã áp dụng vào giao diện chính.',
      applyHint: 'Kết quả chỉ vào dự án khi bạn bấm — AI không tự ghi gì.',
      recommended: 'Khuyến nghị: {{value}}',
      cost: '{{cost}} USD · {{turns}} lượt gọi model',
      partial: 'Kết quả một phần — trợ lý dừng vì {{reason}}.',
      partialManual: 'Phần còn thiếu làm tay: {{label}}',
      unverified_one: 'Một điểm chưa kiểm được — hệ thống không đủ dữ liệu để nói đúng hay sai:',
      unverified_other:
        '{{count}} điểm chưa kiểm được — hệ thống không đủ dữ liệu để nói đúng hay sai:',
      stopReason: {
        turn_capped: 'chạm trần số lượt',
        tool_calls_capped: 'chạm trần số công cụ trong một lượt',
        token_capped: 'chạm trần token',
        cost_capped: 'chạm trần chi phí',
        loop_capped: 'gọi lặp một công cụ quá nhiều lần',
      },
      status: {
        running: 'Đang chạy',
        clarifying: 'Đang chờ bạn trả lời',
        done: 'Đã xong',
        error: 'Đã dừng vì lỗi',
      },
      kind: {
        thinking: 'Suy nghĩ',
        reasoning: 'Suy luận (thinking)',
        scratchpad: 'Kế hoạch (scratchpad — model không có thinking)',
        toolCall: 'Dùng công cụ',
        toolResult: 'Kết quả từ {{tool}} ({{ms}}ms)',
        critique: 'Người phản biện (vòng {{round}}/{{rounds}})',
        critiqueOk: 'Không có ý kiến — chấp nhận kết quả.',
        critiqueOtherFamily: 'khác họ',
        critiqueStopped: {
          rounds: 'Hết số vòng phản biện — chấp nhận kết quả, ý còn lại chuyển người duyệt.',
          budget: 'Hết ngân sách phản biện của lượt này — chấp nhận kết quả.',
          no_progress: 'Ý kiến lặp lại vòng trước — dừng, chuyển người duyệt.',
          infra: 'Người phản biện không trả lời được — bỏ qua, không chặn.',
        },
        question: 'AI hỏi lại',
        answer: 'Bạn đã trả lời',
        resume: 'Chạy tiếp lượt trước',
        context: 'Trợ lý đã đọc gì',
        policy: 'Quyền và công cụ',
        timing: 'Thời gian tiêu vào đâu',
        done: 'Kết quả',
        error: 'Lỗi',
      },
    },
  },
  aiKey: {
    demoBlocked: 'Tài khoản trưng bày không thêm key riêng được',
    demoBlockedHelp:
      'Tổ chức trưng bày dùng chung một key do quản trị viên nhập — nếu mỗi người tự kích hoạt key của mình thì key chung bị hạ xuống và AI tắt với mọi người vào sau. Đăng nhập bằng tài khoản thật để dùng key của bạn.',
    chainsTitle: 'Model dùng cho từng tầng',
    chainsSubtitle: 'kéo thứ tự — model đầu được thử trước',
    chainsHelp:
      'Hệ thống thử model số 1; nếu hết quota, gateway quá tải, model bị gỡ, hoặc model chưa có bảng giá thì rơi xuống model kế tiếp. Sai key hoặc vượt hạn mức thì KHÔNG rơi — thử model khác cũng cùng một lỗi.',
    chainEmpty: 'Chưa chọn — dùng cấu hình chung của tổ chức.',
    useSuggestion: 'Dùng gợi ý',
    addModel: '+ Thêm model…',
    saveModels: 'Lưu lựa chọn',
    moveUp: 'Lên một bậc',
    moveDown: 'Xuống một bậc',
    remove: 'Bỏ khỏi danh sách',
    notPriced: 'chưa có giá',
    notPricedHelp:
      'Chưa có dòng giá nên model này sẽ bị bỏ qua. Nhờ quản trị viên thêm vào bảng giá.',
    notUsable: 'không sinh text',
    notUsableHelp:
      'Model này không sinh được text (tts, audio, ảnh, embedding) hoặc là wildcard định tuyến của gateway.',
    modelsSaved: 'Đã lưu lựa chọn model.',
    tier: { strong: 'Việc khó', standard: 'Việc hằng ngày', small: 'Việc dễ' },
    // Mức suy nghĩ theo loại việc và đời model — APM-MDL-c.
    effortLabel: 'Mức suy nghĩ',
    effort: {
      default: 'Mặc định',
      off: 'Tắt',
      low: 'Thấp',
      medium: 'Vừa',
      high: 'Cao',
      adaptive: 'Tự điều chỉnh',
    },
    lifecycle: {
      title: 'Đời model và đề xuất',
      badge_one: '{{count}} việc cần xem',
      badge_other: '{{count}} việc cần xem',
      dot: 'có model mới hoặc đề xuất model',
      menuBadge: 'Model mới',
      scannedAt: 'Quét gateway lần cuối: {{value}}',
      neverScanned: 'Chưa quét gateway lần nào — job chạy lúc 04:00 mỗi ngày.',
      modeLabel: 'Cách theo đời model',
      mode: { latest: 'Luôn dùng bản mới nhất', pinned: 'Cố định phiên bản' },
      modeHint: {
        latest:
          'Gateway có bản mới cùng họ (vd Opus 5 → Opus 5.5) và đã có giá thì tự dùng; bản cũ lùi làm dự phòng.',
        pinned: 'Gọi đúng chuỗi đã lưu. Có bản mới thì báo để bạn tự quyết.',
      },
      scanError: 'Lần quét gần nhất lỗi: {{error}}',
      newer: 'Có bản model mới: {{models}}',
      addNewer: 'Thêm vào chuỗi',
      dismiss: 'Bỏ qua',
      recommendTitle: 'Đề xuất cho từng loại việc (độ chính xác ÷ giá)',
      noRecommendation:
        'Chưa có đề xuất — cần benchmark công khai (trang Harness) hoặc số đo nội bộ (harness:bench).',
      basis: {
        internal: 'golden nội bộ {{score}} %',
        public: 'chỉ số công khai {{score}}',
      },
      price: '${{value}}/1M token',
      apply: 'Áp dụng',
      inUse: 'Đang dùng',
      attribution: 'Nguồn chỉ số công khai: Artificial Analysis (artificialanalysis.ai).',
      unmatched: 'Chưa có benchmark cho: {{models}}',
      askAi: 'Hỏi AI tư vấn',
      usingLatest: 'Đang dùng bản mới nhất: {{model}}',
    },
    tierHint: {
      strong: 'sinh WBS (phân rã công việc), phân tích ảnh hưởng CR',
      standard: 'diễn đạt tín hiệu rủi ro, chia nhỏ task',
      small: 'phân loại, trích xuất — chạy nhiều nên cần rẻ',
    },
    modelsTitle: 'Gateway trả về {{count}} model',
    modelsTruncated: 'Còn {{count}} model nữa — đã cắt bớt cho dễ đọc.',
    modelsHelp:
      'Chép tên model vào ba tầng ở Quản trị → Cấu hình hệ thống. Model nào dùng thật thì phải có dòng giá, nếu không lời gọi bị từ chối.',
    provider: 'Nhà cung cấp',
    providerAnthropic: 'Anthropic (api.anthropic.com)',
    providerLitellm: 'LiteLLM (gateway nội bộ)',
    providerOpenai: 'OpenAI (api.openai.com)',
    providerGemini: 'Google Gemini (AI Studio)',
    directProviderHelp:
      'Bấm "Kiểm tra" sau khi thêm để lấy danh sách model của key, rồi chọn chuỗi model cho ba tầng. Model chưa có dòng giá sẽ bị bỏ qua khi gọi; model nào đã có giá thì xem ở Bảng điều khiển AI → Model.',
    baseUrl: 'Địa chỉ gateway',
    baseUrlHelp: 'Không kèm đuôi /v1 — hệ thống tự thêm. Chỉ LiteLLM cần trường này.',
    labelPlaceholder: 'Cá nhân',
    title: 'Key AI',
    subtitle: 'Key được mã hoá trong CSDL. API không bao giờ trả lại key thật.',
    none: 'Chưa có key nào',
    noneHelp:
      'Thêm key của bạn bên dưới, kiểm tra kết nối, rồi kích hoạt. Chưa có key thì mọi tính năng AI chuyển sang cách làm tay.',
    label: 'Nhãn',
    apiKey: 'API key',
    add: 'Thêm key',
    test: 'Kiểm tra',
    activate: 'Kích hoạt',
    active: 'Đang dùng',
    verified: 'Đã kiểm tra',
    unverified: 'Chưa kiểm tra',
    created: 'Đã thêm key. Hãy kiểm tra kết nối.',
    activated: 'Đã kích hoạt key.',
    testPassed: 'Key hoạt động — thấy {{count}} model.',
    testFailed: 'Kiểm tra thất bại.',
    mustTestFirst: 'Phải kiểm tra kết nối thành công trước khi kích hoạt.',
    testBeforeActivate: 'Key mới chưa được kích hoạt ngay. Kiểm tra kết nối trước.',
  },
  budget: {
    title: 'Hạn mức chi phí AI',
    subtitle:
      'Không có hạn mức thì một vòng lặp lỗi cũng sinh ra hoá đơn thật. Hạn mức cứng sẽ chặn lời gọi mới.',
    none: 'Chưa đặt hạn mức nào — lời gọi AI không bị chặn.',
    periodLabel: 'Kỳ',
    soft: 'Ngưỡng cảnh báo (USD)',
    hard: 'Ngưỡng chặn (USD)',
    saved: 'Đã lưu hạn mức.',
    perOrg: 'toàn tổ chức',
    perUser: 'theo người dùng',
    softMustBeLower: 'Ngưỡng cảnh báo phải nhỏ hơn ngưỡng chặn, nếu không nó không bao giờ hiện.',
    help: 'Chạm ngưỡng cảnh báo thì vẫn chạy, chỉ báo. Chạm ngưỡng chặn thì lời gọi mới bị từ chối.',
    period: { day: 'Theo ngày', month: 'Theo tháng' },
  },
  files: { upload: 'Tải lên' },
  org: {
    demoAccount: 'Tài khoản demo không mở được tổ chức mới. Hãy đăng nhập bằng tài khoản của bạn.',
    title: 'Tổ chức của tôi',
    subtitle: 'Nơi bạn đang làm việc, vai trò ở mỗi nơi, và chỗ mở tổ chức mới.',
    current: 'đang mở',
    createLabel: 'Mở tổ chức mới',
    createPlaceholder: 'Tên tổ chức',
    create: 'Tạo',
    createHelp: 'Bạn sẽ là quản trị tổ chức mới, và màn hình chuyển sang đó ngay.',
    nameTooShort: 'Tên tổ chức cần ít nhất 2 ký tự.',
    loadFailed: 'Không tải được danh sách tổ chức.',
    switchLabel: 'Đổi tổ chức',
    /** Tên và nhãn của không gian cá nhân ở bộ chọn tổ chức — APM-PSPACE-f. */
    personalName: 'Không gian cá nhân',
    personalBadge: 'Cá nhân',
    /** Nhãn cho tư cách `GUEST` ở bộ chọn tổ chức — APM-PSPACE-j. */
    guestBadge: 'Khách',
  },
  orgInvite: {
    demoAccount:
      'Tài khoản demo không nhận được lời mời vào tổ chức thật. Hãy đăng xuất rồi đăng nhập bằng tài khoản của bạn trước khi mở lại link.',
    title: 'Link mời vào tổ chức',
    subtitle:
      'Nhiều link song song, mỗi link một vai. Link đã ngừng vẫn giữ lại nếu từng mời được người.',
    role: 'Vai trò khi gia nhập',
    create: 'Tạo link',
    revoke: 'Thu hồi',
    colRole: 'Vai trò',
    colCreated: 'Ngày tạo',
    colExpires: 'Hết hạn',
    colStatus: 'Trạng thái',
    colUsed: 'Đã mời',
    colMessage: 'Lời nhắn',
    message: 'Lời nhắn (tuỳ chọn)',
    messagePlaceholder: 'Chào Minh, đây là link vào không gian làm việc của nhóm mình.',
    statusActive: 'Còn hoạt động',
    statusStopped: 'Đã ngừng',
    onceOnly: 'Link chỉ hiện một lần. Sao chép ngay — đóng đi là không xem lại được.',
    copy: 'Sao chép link',
    copyManual: 'Chọn và sao chép link ở trên.',
    copied: 'Đã sao chép link.',
    copyFailed: 'Không sao chép được. Hãy chọn và copy thủ công.',
    // Link cần duyệt — APM-ORGJR-b.
    requiresApproval: 'Cần quản trị duyệt',
    requiresApprovalOn: 'Người bấm link gửi đơn; vào tổ chức sau khi một quản trị bấm Duyệt.',
    requiresApprovalOff:
      'Ai cầm link cũng vào thẳng — chỉ dùng cho link gửi riêng tới người tin cậy.',
    colApproval: 'Cách vào',
    needsApproval: 'Cần duyệt',
    direct: 'Vào thẳng',
  },
  joinOrg: {
    title: 'Tham gia tổ chức',
    help: 'Bấm để nhận lời mời. Sau đó màn hình sẽ chuyển sang tổ chức này.',
    accept: 'Tham gia',
    members: '{{count}} thành viên',
    invitedBy: 'mời bạn tham gia với vai trò {{role}}',
    invitedAs: 'Bạn được mời tham gia với vai trò {{role}}',
    invalidTitle: 'Link mời không còn hiệu lực',
    invalidHelp: 'Link có thể đã hết hạn hoặc bị thu hồi. Hãy xin người mời một link mới.',
    // Link cần duyệt — APM-ORGJR-b.
    helpApproval:
      'Tổ chức này duyệt từng người. Bấm để gửi yêu cầu; bạn vào được sau khi quản trị duyệt.',
    request: 'Gửi yêu cầu tham gia',
    pendingTitle: 'Đã gửi yêu cầu',
    pendingHelp:
      'Quản trị của {{org}} sẽ duyệt yêu cầu của bạn. Bạn sẽ nhận thông báo khi có kết quả.',
    failedTitle: 'Chưa tham gia được',
  },
  /** Đơn xin vào tổ chức chờ duyệt — APM-ORGJR-b. */
  orgJoinRequests: {
    // Hai tab của mục Link mời — APM-ORGJR-c.
    tabLinks: 'Link mời',
    tabApprovals: 'Duyệt',
    emptyTitle: 'Chưa có ai chờ duyệt',
    emptyHelp:
      'Người bấm link "Cần duyệt" và gửi yêu cầu sẽ hiện ở đây, kèm thông báo cho quản trị tổ chức.',
    linkCreated: 'Link tạo {{date}}',
    colName: 'Người xin',
    colRole: 'Vai trò',
    colLink: 'Link',
    colSentAt: 'Gửi lúc',
    noAccount: 'chưa có tài khoản — duyệt sẽ tạo tài khoản đăng nhập bằng Google',
    accept: 'Duyệt',
    decline: 'Từ chối',
    accepted: 'Đã duyệt {{name}} vào tổ chức.',
    acceptedNoAccount: 'Đã duyệt {{name}}. Họ đăng nhập bằng Google để vào.',
    declined: 'Đã từ chối yêu cầu của {{name}}.',
    declineTitle: 'Từ chối yêu cầu của {{name}}',
    note: 'Lý do (người xin đọc được, tuỳ chọn)',
    decided: 'Yêu cầu này đã được xử lý.',
  },
  // Gộp / tách tổ chức — APM-ORGMS-f (docs/plan-org-restructure.md §3.7, §3.8).
  orgRestructure: {
    menu: {
      button: 'Gộp / tách tổ chức',
      merge: 'Đề xuất gộp',
      split: 'Đề xuất tách',
    },
    kind: {
      merge: 'Đề xuất gộp tổ chức',
      split: 'Đề xuất tách tổ chức',
    },
    status: {
      awaiting_partner: 'Chờ bên kia nhận lời mời',
      awaiting_approval: 'Đang chờ duyệt',
      approved: 'Đã duyệt đủ — chờ chạy',
      executing: 'Đang chạy',
      done: 'Đã xong',
      cancelled: 'Đã huỷ',
      expired: 'Đã hết hạn',
      failed: 'Chạy chưa xong',
    },
    direction: {
      into_initiator: 'Nhập tổ chức kia vào đây',
      into_initiatorHelp:
        'Tổ chức của bạn được giữ lại; dự án, thành viên và danh mục của bên kia chuyển sang đây, rồi bên kia đóng.',
      into_partner: 'Nhập tổ chức này vào tổ chức kia',
      into_partnerHelp:
        'Tổ chức kia được giữ lại; mọi thứ của tổ chức bạn chuyển sang đó, rồi tổ chức bạn đóng.',
      merge: '«{{source}}» nhập vào «{{target}}»',
      otherOrg: 'tổ chức kia',
      yourOrg: 'tổ chức của bạn',
    },
    banner: {
      partner: 'với «{{name}}»',
      noPartner: 'chưa có bên kia nhận lời mời',
      newOrg: 'tách thành «{{name}}»',
      approved: 'đã duyệt {{done}}/{{total}}',
      open: 'Xem đề xuất',
    },
    propose: {
      title: 'Đề xuất gộp tổ chức',
      direction: 'Chiều gộp',
      help: 'Có thể bỏ trống email: tạo xong bạn nhận một link để gửi cho Admin bên kia. Cấu hình (Admin, Director sau gộp, mã dự án) sửa được sau, trước khi mọi người duyệt.',
      submit: 'Tạo đề xuất',
      created:
        'Đã tạo đề xuất. Gửi link dưới đây cho Admin của tổ chức kia — link dùng được một lần.',
      open: 'Mở đề xuất',
    },
    invite: {
      link: 'Link mời',
      copy: 'Chép link',
      copied: 'Đã chép link',
      copyFailed: 'Không chép được — hãy chọn và chép tay',
      linkGone: 'Link không còn dùng được (đã có người nhận, hết hạn hoặc đề xuất đã đóng).',
      expires: 'Hết hạn {{date}}',
      emails: 'Email Admin bên kia (nhiều email, cách nhau bằng dấu phẩy hoặc xuống dòng)',
      emailsPlaceholder: 'admin@congty-kia.vn',
      emailsHelp:
        'Lời mời tới bằng thông báo trong app và Telegram (nếu đã liên kết), chỉ tới email là Admin một tổ chức. Hệ thống không cho biết email nào có tài khoản.',
      invalidEmails: 'Email chưa đúng dạng: {{emails}}',
      send: 'Gửi lời mời ({{count}})',
      sent: 'Đã gửi lời mời tới những email là Admin một tổ chức',
    },
    panel: {
      label: 'Đề xuất gộp / tách tổ chức',
      meta: '{{by}} tạo ngày {{created}} · hết hạn {{expires}}',
      cancel: 'Huỷ đề xuất',
      cancelConfirm: 'Huỷ đề xuất này? Muốn làm lại phải tạo đề xuất mới.',
      cancelled: 'Đã huỷ đề xuất',
    },
    tab: {
      config: 'Cấu hình',
      preflight: 'Kiểm tra trước',
      approvals: 'Duyệt',
      progress: 'Tiến độ',
      report: 'Báo cáo',
    },
    config: {
      invite: 'Mời bên kia',
      direction: 'Chiều gộp',
      roles: 'Admin và Director của tổ chức sau gộp',
      rolesHelp:
        'Chọn trong thành viên của cả hai bên — cần ít nhất một Admin. Người có ở cả hai bên giữ vai ở tổ chức được giữ lại, trừ khi được chọn ở đây.',
      admin: 'Admin',
      director: 'Director',
      asAdmin: 'Chọn {{name}} làm Admin',
      asDirector: 'Chọn {{name}} làm Director',
      admins: 'Admin',
      directors: 'Director',
      needAdmin: 'Cần chọn ít nhất một Admin.',
      projectKeys: 'Mã dự án trùng',
      projectKeysHelp:
        'Dự án của tổ chức nhập vào có mã trùng với tổ chức giữ lại sẽ đổi mã. Bỏ trống để dùng mã gợi ý.',
      project: 'Dự án',
      oldKey: 'Mã hiện tại',
      newKey: 'Mã sau gộp',
      newKeyFor: 'Mã sau gộp của {{name}}',
      badKey: 'Mã dự án chỉ gồm chữ HOA và số, bắt đầu bằng chữ, từ 2 ký tự.',
      save: 'Lưu cấu hình',
      saved: 'Đã lưu cấu hình bản {{version}} — mọi người cần duyệt lại',
      saveHelp: 'Lưu là sang bản mới: mọi lượt duyệt trước đó hết giá trị.',
      version: 'Cấu hình bản {{version}}',
      stale: 'Cấu hình vừa được người khác sửa — đã tải lại bản mới, hãy xem lại.',
    },
    preflight: {
      blockers: 'Lỗi chặn ({{count}}) — chưa chạy được cho tới khi gỡ hết',
      noBlockers: 'Không có lỗi chặn.',
      warnings: 'Cảnh báo ({{count}})',
      moving: 'Sẽ chuyển từ «{{source}}» sang «{{target}}»',
      projects: 'Dự án',
      members: 'Thành viên',
      newMembers: 'Trong đó mới với tổ chức giữ lại',
      files: 'Tệp',
      storage: 'Dung lượng sau gộp: {{after}} / hạn mức {{quota}}',
      projectKeys: 'Mã dự án sẽ đổi ({{count}})',
      catalogRenames: 'Danh mục trùng sẽ đổi tên ({{count}})',
      peopleInBoth: 'Người có ở cả hai bên ({{count}})',
      personalConflicts: 'Dữ liệu cá nhân trùng',
      handling: {
        report: '{{model}}: {{count}} hàng — giữ bản của tổ chức giữ lại, bản kia vào báo cáo',
        merge_folder: '{{model}}: {{count}} thư mục — dồn tệp vào thư mục cùng tên',
        list: '{{model}}: {{count}} hàng — giữ cả hai',
      },
      dropped: 'Cấu hình của tổ chức nhập vào sẽ bỏ (theo tổ chức giữ lại)',
      rows: '{{model}}: {{count}} hàng',
      levelRateLock:
        '{{members}} thành viên ở {{projects}} dự án đang tính giá theo bậc — giá cũ được chốt tới ngày gộp.',
      computedAt: 'Kiểm lúc {{at}} trên cấu hình bản {{version}}',
    },
    blocker: {
      PARTNER_MISSING: 'Chưa có tổ chức nào nhận lời mời.',
      ORG_DEMO: 'Một bên là tổ chức demo — tổ chức demo không gộp được.',
      ORG_PERSONAL: 'Một bên là không gian cá nhân — không gian cá nhân không gộp được.',
      ORG_DELETED: 'Một bên đã bị xoá.',
      ORG_EXECUTING: 'Một bên đang trong một lượt gộp / tách khác.',
      DUPLICATE_EMAIL: '{{count}} email có hai tài khoản khác nhau ở hai bên — cần xử lý trước.',
      NO_ADMIN: 'Không còn Admin nào trong cấu hình là thành viên đang hoạt động.',
      ROLE_HOLDER_NOT_MEMBER: '{{count}} người trong Admin / Director không còn là thành viên.',
      PROJECT_KEY_CONFLICT: '{{count}} mã dự án sau khi đổi vẫn trùng.',
      PROJECT_KEY_RENAME_STALE:
        '{{count}} mã dự án đã sửa nhắm dự án không còn thuộc tổ chức nhập vào (vd. sau khi đổi chiều gộp).',
    },
    warning: {
      STORAGE_QUOTA:
        'Tệp hai bên cộng lại vượt hạn mức của tổ chức giữ lại — tệp cũ vẫn mở được, tải lên mới bị chặn cho tới khi nâng hạn mức.',
      LEVEL_RATE_LOCK: 'Giá theo bậc của tổ chức nhập vào sẽ chốt thành giá riêng tới ngày gộp.',
      ORG_AUDIENCE_SHARE_LINKS:
        '{{count}} link chia sẻ "trong tổ chức" từ nay mở cho mọi thành viên tổ chức giữ lại.',
      FIGMA_CONNECTION_REVOKED:
        'Cả hai bên có kết nối Figma — kết nối của tổ chức nhập vào sẽ bị thu hồi.',
      GIT_HOSTS_MERGED:
        '{{count}} máy chủ git của tổ chức nhập vào trùng địa chỉ với máy chủ của tổ chức giữ lại — kết nối, kho và tài khoản git sẽ dùng máy chủ của tổ chức giữ lại, máy chủ trùng bị xoá.',
    },
    catalog: {
      department: 'Phòng ban',
      tech_stack: 'Công nghệ',
      task_type: 'Loại việc',
      wbs_template: 'Mẫu WBS',
      document_template: 'Mẫu tài liệu',
    },
    more: '… và {{count}} mục nữa',
    approvals: {
      summary: 'Đã duyệt {{done}}/{{total}} trên cấu hình bản {{version}}',
      state: {
        current: 'Đã duyệt bản {{version}}',
        old: 'Duyệt bản cũ ({{version}})',
        rejected: 'Từ chối',
        pending: 'Chưa duyệt',
      },
      reason: 'Lý do: {{reason}}',
      waitPartner: 'Bên kia nhận lời mời xong thì mới duyệt được.',
      irreversible:
        'Khi người cuối cùng duyệt, hai tổ chức gộp ngay và tạm đóng vài phút. Thao tác không hoàn tác được.',
      approve: 'Duyệt',
      confirm: 'Duyệt cấu hình bản {{version}}? Thao tác không hoàn tác được.',
      reject: 'Từ chối',
      reasonLabel: 'Lý do từ chối',
      rejectHelp: 'Một người từ chối là đề xuất bị huỷ.',
      rejectSubmit: 'Từ chối đề xuất',
      recorded: 'Đã ghi lượt duyệt của bạn',
      allApproved: 'Đủ người duyệt — lượt gộp bắt đầu chạy',
      allApprovedSplit: 'Đủ người duyệt — lượt tách bắt đầu chạy',
      irreversibleSplit:
        'Khi người cuối cùng duyệt, tổ chức mới được tạo ngay; tổ chức này và tổ chức mới tạm đóng vài phút. Thao tác không hoàn tác được.',
      blocked: 'Đã ghi lượt duyệt, nhưng đề xuất còn lỗi chặn nên chưa chạy — xem Kiểm tra trước.',
    },
    progress: {
      steps: 'Các bước',
      state: {
        done: 'xong',
        current: 'đang chạy',
        pending: 'chưa tới',
      },
      queued: 'Đã duyệt đủ — lượt chạy sắp bắt đầu.',
      notStarted: 'Chưa chạy.',
      frozen: 'Hai tổ chức tạm đóng từ {{at}}.',
      projects: 'Đã chuyển {{moved}}/{{total}} dự án',
      failedFrozen:
        'Lượt chạy dừng giữa chừng — hai tổ chức vẫn tạm đóng. Quản trị hệ thống sẽ chạy tiếp.',
      failedOpen: 'Lượt chạy dừng trước khi chuyển dữ liệu — hai tổ chức đã mở lại.',
      errorCode: 'Mã lỗi: {{code}}',
    },
    step: {
      freeze: 'Tạm đóng hai tổ chức',
      preflight: 'Kiểm tra lại',
      catalogs: 'Danh mục',
      projects: 'Dự án',
      personal: 'Dữ liệu cá nhân',
      members: 'Thành viên và vai',
      infra: 'Phiên đăng nhập và lời mời',
      finish: 'Hoàn tất',
    },
    report: {
      none: 'Chưa có báo cáo.',
      executedAt: '«{{source}}» đã nhập vào «{{target}}» lúc {{at}}',
      joined: 'Thành viên chuyển sang',
      merged: 'Thành viên có ở cả hai (gộp làm một)',
      roleChanges: 'Đổi vai',
      projectKeys: 'Mã dự án đã đổi',
      catalogRenames: 'Danh mục đã đổi tên',
      levelRateLocks: 'Thành viên được chốt giá cũ',
      folderMerges: 'Thư mục đã dồn',
      figmaRevoked: 'Kết nối Figma đã thu hồi',
      sessions: 'Phiên đăng nhập đã thu hồi',
      invites: 'Lời mời đã thu hồi',
      leftBehind: 'Không chuyển (theo tổ chức giữ lại)',
      kept: '{{model}}: {{count}} hàng trùng, giữ bản của tổ chức giữ lại',
      dropped: '{{model}}: {{count}} hàng cấu hình bỏ',
      setting: 'Cài đặt «{{column}}» theo tổ chức giữ lại',
    },
    split: {
      title: 'Đề xuất tách tổ chức',
      intro:
        'Chọn người trên sơ đồ bên trái (bấm một người quản lý để chọn cả nhánh), chọn dự án sẽ chuyển, rồi đặt tên và chọn Admin / Director cho tổ chức mới. Mọi Admin, Director của tổ chức này và những người được chọn làm Admin / Director của tổ chức mới phải duyệt.',
      direction: 'Tách từ «{{source}}» thành «{{name}}»',
      treeHint: 'Đang chọn người cho tổ chức mới — đã chọn {{count}}',
      selectPerson: 'Chọn {{name}} sang tổ chức mới',
      modeFor: 'Cách {{name}} sang tổ chức mới',
      mode: {
        move: 'Chuyển hẳn',
        both: 'Ở cả hai',
      },
      modeHelp: {
        move: 'Rời tổ chức này; dữ liệu cá nhân đi theo sang tổ chức mới.',
        both: 'Vẫn ở tổ chức này và có thêm tư cách ở tổ chức mới.',
      },
      branchTitle: 'Chọn cả nhánh?',
      branchBody: '«{{name}}» đang quản lý {{count}} người. Chọn luôn cả những người này?',
      branchOnly: 'Chỉ «{{name}}»',
      branchAll: 'Chọn cả nhánh ({{count}} người)',
      name: 'Tên tổ chức mới',
      slug: 'Slug (địa chỉ) của tổ chức mới',
      slugTaken: 'Slug này đã có tổ chức khác dùng — hãy chọn slug khác.',
      slugBad: 'Slug chỉ gồm chữ thường, số và dấu gạch nối, từ 2 ký tự.',
      timezone: 'Múi giờ',
      projects: 'Dự án chuyển sang ({{count}})',
      projectsHelp:
        'Dự án được chọn chuyển hẳn sang tổ chức mới. Mọi thành viên của dự án tự vào danh sách người ở chế độ «Ở cả hai».',
      projectCount: '{{count}} dự án',
      missingTitle: '{{count}} thành viên của dự án đã chọn không có trong danh sách người',
      missingRow: '{{name}} — dự án {{project}}',
      missingHelp:
        'Dự án sang tổ chức mới thì người làm dự án cũng phải sang. Chọn lại họ, hoặc bỏ họ khỏi dự án trước. Chưa gỡ thì chưa tạo / lưu được.',
      missingFix: 'Chọn lại (ở cả hai)',
      people: 'Người sang tổ chức mới ({{count}})',
      peopleHelp: 'Admin (ít nhất một) và Director của tổ chức mới chọn trong số những người này.',
      noPeople: 'Chưa chọn ai — bấm ô chọn trên thẻ của từng người ở sơ đồ.',
      remove: 'Bỏ {{name}} khỏi danh sách',
      problem: {
        name: 'Chưa đặt tên tổ chức mới.',
        slug: 'Slug chưa hợp lệ.',
        people: 'Chưa chọn người nào.',
        admin: 'Cần chọn ít nhất một Admin cho tổ chức mới.',
      },
      created: 'Đã tạo đề xuất tách — đang chờ mọi người duyệt',
      editHelp:
        'Sửa người trên sơ đồ bên trái hoặc trong danh sách dưới đây. Lưu là sang bản mới: mọi lượt duyệt trước đó hết giá trị.',
    },
    splitBlocker: {
      ORG_DEMO: 'Tổ chức demo không tách được.',
      ORG_PERSONAL: 'Không gian cá nhân không tách được.',
      ORG_DELETED: 'Tổ chức đã bị xoá.',
      ORG_EXECUTING: 'Tổ chức đang trong một lượt gộp / tách khác.',
      SLUG_TAKEN: 'Slug của tổ chức mới đã có tổ chức khác dùng.',
      NO_ADMIN: 'Không còn Admin nào của tổ chức mới là thành viên đang hoạt động.',
      PERSON_NOT_MEMBER: '{{count}} người được chọn không còn là thành viên đang hoạt động.',
      PROJECT_NOT_IN_ORG: '{{count}} dự án được chọn không còn thuộc tổ chức này.',
      PROJECT_MEMBER_NOT_SELECTED:
        '{{count}} thành viên của dự án được chọn không có trong danh sách người — chọn họ, hoặc bỏ họ khỏi dự án trước.',
      LAST_ROLE_HOLDER_LEAVING:
        'Mọi Admin (hoặc mọi Director) của tổ chức này đều «chuyển hẳn» — tổ chức này sẽ không còn ai giữ vai ấy.',
    },
    splitWarning: {
      CROSS_LINKS: 'Liên kết giữa dự án chuyển đi và dự án ở lại sẽ bị cắt.',
      LINE_MANAGER_RESET:
        'Người «chuyển hẳn» đang là quản lý trực tiếp của người ở lại — quản lý của những người ấy về trống.',
      PROJECT_AI_KEY_STAYS:
        'Dự án chuyển đi đang dùng key AI của người ở lại — tổ chức mới sẽ tiêu trên key ấy.',
      FIGMA_NOT_COPIED:
        'Dự án chuyển đi có tệp Figma — kết nối Figma không được chép, Admin tổ chức mới tự cấu hình.',
      STORAGE_QUOTA: 'Tệp của dự án chuyển đi vượt hạn mức dung lượng của tổ chức mới.',
      INTEGRATION_SECRETS_COPIED:
        'Nguồn đồng bộ của dự án chuyển đi mang bí mật app (Lark / Meegle) — bản chép ở tổ chức mới dùng chung app của tổ chức này. Admin tổ chức mới nên tạo app riêng rồi dán đè.',
    },
    splitStep: {
      freeze: 'Tạm đóng tổ chức',
      preflight: 'Kiểm tra lại',
      catalogs: 'Tạo tổ chức mới, chép cấu hình và danh mục',
      projects: 'Chuyển dự án',
      personal: 'Dữ liệu cá nhân',
      members: 'Thành viên và vai',
      infra: 'Phiên đăng nhập và việc chờ',
      finish: 'Hoàn tất',
    },
    splitPreflight: {
      moving: 'Sẽ tách từ «{{source}}» thành «{{name}}»',
      newOrg: 'Slug {{slug}} · múi giờ {{timezone}}',
      movePeople: 'Người chuyển hẳn',
      bothPeople: 'Người ở cả hai',
      catalogCopies: 'Danh mục sẽ chép sang tổ chức mới',
      configCopies: 'Cấu hình sẽ chép sang tổ chức mới',
      crossLinks: 'Liên kết vắt qua ranh giới sẽ bị cắt',
      link: '{{kind}}: {{count}}',
    },
    splitLink: {
      task_dependency: 'Phụ thuộc giữa việc',
      sprint_dependency: 'Phụ thuộc giữa sprint',
      raid_task_link: 'Liên kết RAID – việc',
      change_request_task: 'Việc của yêu cầu thay đổi',
      objective_task: 'Việc của mục tiêu',
      bug_task: 'Liên kết bug – việc',
      issue_task: 'Liên kết vấn đề – việc',
    },
    splitModel: {
      Department: 'Phòng ban',
      TechStack: 'Công nghệ',
      TaskType: 'Loại việc',
      WbsTemplate: 'Mẫu WBS',
      DocumentTemplate: 'Mẫu tài liệu',
      OrgKnowledge: 'Tri thức tổ chức',
      AiMemoryNote: 'Ghi nhớ AI',
      OrgWorkScheduleShift: 'Ca làm việc',
      OrgHoliday: 'Ngày nghỉ lễ',
      LevelRate: 'Giá theo bậc',
      AiBudget: 'Hạn mức chi phí AI',
      CostRate: 'Đơn giá riêng',
      UserSkill: 'Kỹ năng',
      SyncProvider: 'Nguồn đồng bộ',
      GitHost: 'Máy chủ git',
    },
    splitReport: {
      executedAt: '«{{name}}» đã tách khỏi «{{source}}» lúc {{at}}',
      projects: 'Dự án đã chuyển',
      moved: 'Người chuyển hẳn',
      both: 'Người ở cả hai',
      lineManagersReset: 'Quản lý trực tiếp về trống',
      links: 'Liên kết đã cắt',
      copies: 'Đã chép sang tổ chức mới',
    },
    accept: {
      subtitle: 'Lời mời gộp tổ chức',
      title: '«{{org}}» mời gộp tổ chức',
      direction: {
        into_initiator: '«{{org}}» đề nghị nhập «{{mine}}» vào «{{org}}».',
        into_partner: '«{{org}}» đề nghị nhập vào «{{mine}}».',
      },
      size: '{{members}} thành viên · {{projects}} dự án',
      inviter: 'Người mời: {{name}}.',
      expires: 'Link hết hạn {{date}}.',
      pickOrg: 'Nhận cho tổ chức',
      forOrg: 'Nhận cho tổ chức «{{name}}».',
      noEligible: 'Bạn chưa là Admin của tổ chức nào nhận được lời mời này.',
      help: 'Nhận chưa gộp gì cả: sau đó Admin và Director của cả hai bên xem cấu hình và cùng duyệt.',
      submit: 'Nhận lời mời',
      joined: 'Đã nhận lời mời — mở đề xuất',
      back: 'Về Sơ đồ tổ chức',
      refusal: {
        invalid: 'Link gộp không còn hiệu lực',
        not_admin: 'Chỉ Admin tổ chức nhận được lời mời gộp',
        demo: 'Tổ chức demo không gộp được',
      },
      refusalHelp: {
        invalid: 'Link đã hết hạn, đã có người nhận, hoặc đề xuất đã đóng. Hãy xin link mới.',
        not_admin: 'Nhờ Admin của tổ chức bạn mở link này, hoặc đăng nhập bằng tài khoản là Admin.',
        demo: 'Tài khoản demo không là bên của đề xuất gộp nào. Đăng nhập bằng tài khoản thật để nhận.',
      },
    },
    frozen: {
      title: 'Tổ chức đang được gộp / tách',
      body: 'Thường mất vài phút. Trang tự mở lại khi xong — không cần tải lại.',
      switchHint: 'Có tổ chức khác? Đổi tổ chức ở menu tài khoản.',
    },
  },
  orgChart: {
    title: 'Sơ đồ tổ chức',
    subtitle: 'Ai báo cáo cho ai — dựng từ quản lý trực tiếp, không phải từ phòng ban.',
    total: '{{count}} người',
    cycleWarning: '{{count}} người bị bỏ khỏi sơ đồ vì quan hệ quản lý tạo thành vòng lặp',
    lineManager: 'Quản lý trực tiếp',
    lineManagerHelp:
      'Người này sẽ duyệt các dự án do nhân viên mở. Chỉ chọn được Trưởng nhóm trở lên.',
    tier: {
      lead: 'Lãnh đạo',
      manage: 'Trưởng nhóm & quản trị',
      staff: 'Nhân viên',
    },
    expand: 'Mở nhánh',
    collapse: 'Gập nhánh',
    reportCount: '{{count}} người trong nhánh',
    inactive: 'đã khoá',
    empty: 'Chưa dựng được sơ đồ',
    emptyHelp: 'Chưa ai được gán quản lý trực tiếp. Gán ở mục Người dùng trong phần quản trị.',
    invite: 'Mời vào dự án',
    inviteLabel: 'Mời {{name}} vào dự án',
    inviteTitle: 'Mời {{name}} vào dự án',
    inviteHelp:
      'Chỉ hiện những dự án bạn đang làm PM. Người được mời nhận thông báo và tự quyết định có nhận hay không.',
    inviteProject: 'Dự án',
    inviteProjectPick: '— chọn dự án —',
    failed: 'Không tải được sơ đồ tổ chức.',
  },
  orgAdminRole: {
    adminNote:
      'Người này là quản trị tổ chức. Vị trí dưới đây là vai kiêm — quyền của họ gồm quyền quản trị cộng quyền của vị trí.',
    selfLocked: 'Bạn không tự đổi vị trí của mình được. Nhờ một quản trị khác đổi giúp.',
    operatorLocked: 'Tài khoản quản trị hệ thống không có vị trí trong tổ chức để đổi.',
    matrixNote:
      'Quản trị tổ chức là quyền cộng thêm: người quản trị có cả cột này lẫn cột của vị trí họ kiêm (Giám đốc, Trưởng nhóm hoặc Nhân viên).',
  },
  projectFiles: {
    title: 'Files',
    link: 'Files · {{size}}',
    back: 'Quay lại Tổng quan',
    usage_one: 'đã dùng · {{count}} file',
    usage_other: 'đã dùng · {{count}} file',
    empty: 'Dự án chưa có file nào',
    emptyHelp: 'File đính kèm công việc và tài liệu tải lên sẽ hiện ở đây.',
    name: 'Tên file',
    location: 'Nằm ở mục',
    uploadedAt: 'Ngày tải lên',
    size: 'Dung lượng',
    actions: 'Thao tác',
    statusActive: 'Dùng được',
    statusDeleted: 'Đã xoá',
    deletedBy: '{{name}} xoá lúc {{at}}',
    download: 'Tải về {{name}}',
    delete: 'Xoá {{name}}',
    confirmDelete: 'Xoá “{{name}}”? File bị gỡ khỏi kho lưu trữ và không tải về được nữa.',
    deleted: 'Đã xoá file.',
    cannotDeleteDocument: 'File là một phiên bản tài liệu — quản lý ở mục Tài liệu.',
    cannotDeleteOthers: 'Chỉ quản lý dự án hoặc người tải file lên mới xoá được.',
    inTask: 'Công việc',
    inDocument: 'Tài liệu “{{title}}” · bản {{version}}',
    taskGone: 'Công việc đã bị xoá',
    inBug: 'Lỗi #{{code}} {{title}}',
    unattached: 'Chưa gắn vào đâu',
  },
  docFormat: {
    normalize: 'Chuẩn hoá định dạng',
    ai: 'Căn chỉnh bằng AI',
    title: 'Căn chỉnh định dạng',
    before: 'Trước',
    after: 'Sau',
    apply: 'Áp dụng',
    discard: 'Bỏ',
    promptLabel: 'Yêu cầu thêm cho AI (không bắt buộc)',
    promptPlaceholder: 'Ví dụ: trang trọng hơn, tiêu đề dùng font Georgia',
    running: 'AI đang trả lời…',
    run: 'Chạy AI',
    willAsk: 'AI sẽ quyết {{count}} điểm chưa chắc và kế hoạch chung.',
    bodyFont: 'Font chữ thân',
    bodySize: 'Cỡ chữ cơ bản (px)',
    asPlan: 'Theo kế hoạch ({{value}})',
    appDefault: 'Mặc định của ứng dụng',
    bodyHint: 'Chỉ áp cho chữ thường — tiêu đề, chữ tô nền và mã giữ riêng.',
    aiDone: 'AI đã trả lời {{count}} điểm.',
    aiBadge: 'AI',
    aiHelp:
      'AI nhận kế hoạch đã đo sẵn trên máy bạn làm gợi ý rồi quyết font, cỡ chữ, cấp tiêu đề, thụt lề, ảnh cho cả tài liệu. Không sửa chữ nào; bạn xem trước rồi mới áp dụng.',
    manualHelp:
      'Kế hoạch tất định, không cần AI: font và cỡ theo đa số, dòng đánh số thành tiêu đề đúng cấp, thụt lề đồng bộ theo lớp, ảnh đứng một mình và công thức căn giữa. Bảng, mã, màu chữ giữ nguyên.',
    resetFonts: 'Về font và cỡ chữ mặc định của ứng dụng',
    steps: 'Đã làm tự động',
    nothingAuto: 'Không có gì để đổi tự động.',
    step: {
      font: 'Font và cỡ chữ: {{count}} đoạn về {{font}} (mã giữ font riêng)',
      defaultFont: 'font mặc định',
      headings: 'Tiêu đề: {{count}} dòng đổi cấp theo đánh số',
      lists: 'Danh sách: {{count}} dòng thành gạch đầu dòng / đánh số',
      indent: 'Thụt lề: {{count}} đoạn đồng bộ theo lớp',
      images: 'Ảnh: {{count}} khối đặt lại chỗ',
      formulas: 'Công thức: {{count}} căn lại',
    },
    questions: 'Cần quyết định ({{count}})',
    noQuestions: 'Không có điểm nào cần AI — kế hoạch tất định là đủ.',
    truncated: 'Còn {{count}} điểm nữa đã lấy mặc định.',
    notes: 'Ghi chú của AI',
    q: {
      heading: 'Dòng này có phải tiêu đề?',
      fontRole: 'Font nào là chữ thân?',
      indentParagraph: 'Thụt lề đoạn văn',
      indentList: 'Thụt lề mục danh sách',
      image: 'Đặt ảnh thế nào?',
      level: 'Cụm tiêu đề vừa dán',
      imageMove: 'Ảnh sau câu dẫn',
    },
    opt: {
      paragraph: 'Đoạn văn thường',
      bullet: 'Mục đầu của danh sách bên dưới',
      ordered: 'Mục đầu của danh sách đánh số bên dưới',
      heading: 'Tiêu đề cấp {{level}}',
      noIndent: 'Không thụt',
      firstLine: 'Dòng đầu {{first}} mm, trái {{left}} mm',
      hanging: 'Treo {{hang}} mm, trái {{left}} mm',
      square: 'Chữ chảy quanh, {{pct}} %',
      topBottom: 'Một dòng riêng, {{pct}} %',
      sibling: 'Ngang hàng với mục trên',
      child: 'Là mục con',
      move: 'Dời lên sau câu dẫn',
      stay: 'Giữ chỗ',
    },
    noChange: 'Tài liệu đã gọn — không có gì cần đổi.',
    partial: 'AI chưa đọc hết tài liệu (chạm trần) — kế hoạch chỉ áp cho phần đã đọc.',
    tooLong: 'Tài liệu dài hơn {{max}} khối — AI chỉ đọc {{max}} khối đầu.',
    applied: 'Đã áp dụng định dạng — Ctrl+Z để hoàn tác.',
  },
  docCellFormat: {
    button: 'Định dạng dữ liệu',
    title: 'Định dạng dữ liệu trong ô',
    kinds: {
      general: 'Tự động',
      text: 'Văn bản',
      number: 'Số',
      currency: 'Tiền (đ)',
      percent: 'Phần trăm',
      date: 'Ngày giờ',
    },
    hints: {
      general: 'Hiện đúng như gõ',
      text: 'Không tính, kể cả =…',
    },
    decimals: 'Số chữ số thập phân',
    decimalsCount_one: '{{count}} chữ số',
    decimalsCount_other: '{{count}} chữ số',
    fewerDecimals: 'Bớt một chữ số thập phân',
    moreDecimals: 'Thêm một chữ số thập phân',
    datePattern: 'Kiểu hiển thị',
    appliesTo_one: 'Áp cho ô đang chọn',
    appliesTo_other: 'Áp cho {{count}} ô đang chọn',
    dialog: {
      open: 'Định dạng ô…',
      title: 'Định dạng ô',
      category: 'Kiểu định dạng',
      type: 'Kiểu hiển thị',
      preview: 'Xem trước',
      previewCell: 'Xem trước với giá trị của ô đang chọn',
      previewSample: 'Xem trước với giá trị mẫu (ô đang chọn trống)',
      apply: 'Áp dụng định dạng',
      kinds: {
        general: 'Tự động',
        number: 'Số',
        currency: 'Tiền tệ',
        accounting: 'Kế toán',
        date: 'Ngày',
        time: 'Giờ',
        datetime: 'Ngày giờ',
        percent: 'Phần trăm',
        fraction: 'Phân số',
        scientific: 'Khoa học',
        text: 'Văn bản',
        custom: 'Tuỳ chỉnh',
      },
      hints: {
        general: 'Hiện đúng như gõ, không định dạng riêng.',
        number: 'Số có phân cách nghìn, số chữ số thập phân và cách hiện số âm.',
        currency: 'Số kèm ký hiệu tiền; chọn ký hiệu, vị trí và cách hiện số âm.',
        accounting: 'Như Excel: ký hiệu tiền và dấu âm dạt mép trái ô, số dạt mép phải, số 0 hiện "-".',
        date: 'Ô chứa ngày (dd/MM/yyyy) hiện theo kiểu chọn, có nút lịch ở góc ô.',
        time: 'Ô chứa giờ (HH:mm) hoặc phần lẻ của ngày (0,5 = 12:00).',
        datetime: 'Ô chứa ngày giờ (dd/MM/yyyy HH:mm) hiện theo kiểu chọn.',
        percent: 'Nhân 100 và thêm dấu %.',
        fraction: 'Hiện phần lẻ thành phân số.',
        scientific: 'Dạng lũy thừa của 10, như 1,23E+05.',
        text: 'Ô là chữ, không tính — kể cả =… và số.',
        custom: 'Gõ mã định dạng Excel, ví dụ #,##0.00 ₫;[Red]-#,##0.00 ₫ hoặc 0.0%.',
      },
      thousands: 'Dùng dấu phân cách nghìn (.)',
      symbol: 'Ký hiệu',
      symbolPosition: 'Vị trí',
      symbolAfter: 'Sau số',
      symbolBefore: 'Trước số',
      negative: 'Số âm',
      negatives: {
        minus: 'Dấu trừ',
        red: 'Dấu trừ, chữ đỏ',
        parens: 'Trong ngoặc',
        redParens: 'Trong ngoặc, chữ đỏ',
      },
      code: 'Mã định dạng',
      invalidCode: 'Mã định dạng không hợp lệ — kiểm lại dấu ngoặc, dấu nháy.',
    },
    picker: {
      open: 'Chọn ngày',
      title: 'Chọn ngày giờ',
      day: 'Ngày',
      month: 'Tháng',
      year: 'Năm',
      hour: 'Giờ',
      minute: 'Phút',
      monthShort: 'Th{{month}}',
      today: 'Hôm nay',
      clear: 'Xoá',
      done: 'Xong',
      keyboardHint: 'Gõ số vào từng ô, đủ chữ số là tự sang ô kế; Enter để xong.',
    },
  },
  /** Chế độ đề xuất / theo dõi thay đổi của `.chilldoc` — APM-CD2-h, plan-chilldoc-v2 §7.1. */
  chilldocReview: {
    title: 'Xem lại',
    track: 'Theo dõi thay đổi',
    panel: 'Ngăn Xem lại',
    trackOn: 'Đang theo dõi: chữ gõ và chữ xoá thành đề xuất để người khác chấp nhận / từ chối.',
    trackOff: 'Đang tắt: sửa thẳng vào tài liệu.',
    structureBlocked: 'Tắt theo dõi để sửa cấu trúc (bảng, ảnh, biểu đồ, công thức…)',
    empty: 'Chưa có đề xuất nào.',
    count: '{{count}} đề xuất',
    pending_one: '{{count}} đề xuất chờ duyệt',
    pending_other: '{{count}} đề xuất chờ duyệt',
    pendingHint: 'Đang hiện bản chưa duyệt: chữ đề xuất chèn chưa có, chữ đề xuất xoá vẫn còn. Người sửa được xem và duyệt trong trình soạn.',
    kind: { insert: 'Chèn', delete: 'Xoá' },
    accept: 'Chấp nhận',
    reject: 'Từ chối',
    acceptAll: 'Chấp nhận tất cả',
    rejectAll: 'Từ chối tất cả',
    jump: 'Tới chỗ đề xuất',
    close: 'Đóng',
    unknownAuthor: 'Không rõ tác giả',
  },
  docComments: {
    add: 'Bình luận',
    selectFirst: 'Bôi chọn chữ hoặc chọn một đối tượng trước khi bình luận',
    tooMany: 'Tài liệu đã có quá nhiều bình luận (tối đa 500) — xoá bớt bình luận đã xử lý',
    placeholder: 'Viết bình luận…',
    submitHint: 'Ctrl+Enter để gửi',
    cancel: 'Huỷ',
    save: 'Lưu',
    send: 'Gửi',
    close: 'Đóng',
    edited: 'đã sửa',
    edit: 'Sửa',
    delete: 'Xoá',
    deleteThread: 'Xoá bình luận',
    confirmDelete: 'Xoá bình luận này?',
    open: 'Chưa xử lý',
    resolve: 'Đã xử lý',
    reopen: 'Mở lại',
    resolvedBy: 'Đã xử lý bởi {{name}} · {{at}}',
    reply: 'Trả lời',
    replyPlaceholder: 'Trả lời…',
    new: 'Bình luận mới',
    cardLabel: 'Bình luận',
    title_one: '{{count}} bình luận',
    title_other: '{{count}} bình luận',
    bubble_one: '{{count}} bình luận — bấm để xem',
    bubble_other: '{{count}} bình luận — bấm để xem',
    jump_one: '{{count}} bình luận chưa xử lý trong mục — bấm để nhảy tới',
    jump_other:
      '{{count}} bình luận chưa xử lý trong mục — bấm để nhảy tới, bấm tiếp để sang bình luận sau',
    summary: 'Bình luận: {{open}} chưa xử lý · {{resolved}} đã xử lý',
    showResolved: 'Hiện bình luận đã xử lý',
    dragHint: 'Kéo để dời khung bình luận',
    shareStale:
      'Người nhận link toàn bộ và người được mời chưa thấy bản mới nhất (đã bỏ bình luận).',
    shareUpdate: 'Cập nhật bản chia sẻ',
    shareUpdated: 'Đã cập nhật bản chia sẻ',
    shareRefreshFailed: 'Chưa cập nhật được bản chia sẻ — người nhận đang thấy bản lưu trước',
    retry: 'Thử lại',
  },
  docTableSort: {
    open: 'Sắp xếp, lọc cột {{column}}',
    title: 'Cột {{column}}',
    sortAsc: 'Sắp xếp A → Z',
    sortDesc: 'Sắp xếp Z → A',
    blocked: {
      noHeader: 'Bảng chưa có hàng tiêu đề.',
      merged: 'Không sắp xếp được: vùng dữ liệu có ô gộp theo chiều dọc. Tách ô trước rồi sắp.',
      noData: 'Cần ít nhất hai hàng dữ liệu để sắp xếp.',
      readOnly: 'Tài liệu đang ở chế độ chỉ xem — chỉ lọc được.',
    },
    warning:
      'Bảng có công thức trỏ tới hàng khác. Khi sắp xếp, tham chiếu tới một ô đi theo hàng chứa công thức (như chép công thức), còn vùng nhiều hàng (ví dụ B2:B9) giữ nguyên chỗ — các công thức ấy có thể trỏ sang ô khác hoặc ra kết quả khác.',
    fixedRows: 'Hàng {{rows}} tính trên các hàng khác (hàng tổng) — giữ nguyên chỗ, không tham gia sắp xếp.',
    confirmSort: 'Vẫn sắp xếp',
    cancel: 'Huỷ',
    filter: 'Lọc',
    filterNote: 'Lọc chỉ ẩn hàng khi xem, tệp không đổi.',
    search: 'Tìm giá trị',
    selectAll: 'Chọn tất cả',
    noMatch: 'Không có giá trị nào khớp.',
    clearFilter: 'Bỏ lọc cột này',
    clearAll: 'Bỏ mọi bộ lọc của bảng',
    blank: '(Trống)',
    chip: 'Đang lọc: {{filter}}',
    chipValues: '{{column}} = {{values}}',
    chipNone: '{{column}}: ẩn mọi giá trị',
    chipCount: '{{column}}: {{count}}/{{total}} giá trị',
    clearColumn: 'Bỏ lọc: {{filter}}',
    repeatHeader: 'Lặp hàng tiêu đề',
    repeatHeaderHint: 'Ở đầu mỗi trang A4, dính khi cuộn bảng dài, và trong tệp Word.',
  },
  docTable: {
    insertButton: 'Chèn bảng',
    gridPicker: 'Chọn kích thước bảng',
    size: '{{rows}} hàng × {{cols}} cột',
    pickHint: 'Rê chuột để chọn kích thước, hoặc gõ số hàng và cột.',
    rows: 'Hàng',
    cols: 'Cột',
    insert: 'Chèn',
    toolbar: 'Thanh công cụ bảng',
    addRowAbove: 'Chèn hàng phía trên',
    addRowBelow: 'Chèn hàng phía dưới',
    addColumnLeft: 'Chèn cột bên trái',
    addColumnRight: 'Chèn cột bên phải',
    deleteRow: 'Xoá hàng',
    deleteColumn: 'Xoá cột',
    deleteTable: 'Xoá bảng',
    mergeCells: 'Gộp ô (kéo chuột chọn nhiều ô trước)',
    splitCell: 'Tách ô đã gộp',
    widthMode: 'Độ rộng table',
    widthModes: { fit: 'Neo theo lề trái phải', fixed: 'Độ rộng cố định' },
    autoFit: 'Tự căn độ rộng cột theo nội dung',
    tidyTable: 'Căn chỉnh table tự động',
    resizeRow: 'Kéo để đổi chiều cao hàng {{row}} (mũi tên lên/xuống; bấm đúp: tự theo nội dung)',
    resizeColumn: 'Kéo để đổi độ rộng cột {{column}} (mũi tên trái/phải)',
    selectColumn: 'Chọn cả cột {{column}} (đang gõ công thức: chèn vùng của cột)',
    selectRow: 'Chọn cả hàng {{row}} (đang gõ công thức: chèn vùng của hàng)',
    selectTable: 'Chọn cả bảng (đang gõ công thức: chèn vùng của cả bảng)',
    fillHandle: 'Kéo để chép công thức sang ô bên cạnh (bấm đúp: điền xuống tới hàng cuối)',
    headerRows: 'Hàng tiêu đề',
    headerRowsValue: 'Hàng tiêu đề: {{count}}',
    rowsGroup: 'Hàng',
    columnsGroup: 'Cột',
    cellsGroup: 'Ô',
    dataGroup: 'Dữ liệu',
    moveToolbar: 'Kéo để di chuyển thanh (bấm đúp: về chỗ cũ)',
    collapseToolbar: 'Thu gọn thanh — gom nút theo nhóm',
    expandToolbar: 'Mở rộng thanh — hiện đủ các nút',
    noRoomToExpand: 'Không đủ chỗ để hiện đủ các nút — nút đã gom theo nhóm',
    cellColor: 'Màu nền ô',
    alignGroup: 'Căn ngang',
    align: { left: 'Căn trái', center: 'Căn giữa', right: 'Căn phải' },
    valignGroup: 'Căn dọc',
    valign: { top: 'Căn trên', middle: 'Căn giữa dọc', bottom: 'Căn dưới' },
    cellAddress: 'Ô đang chọn',
    formulaBar: 'Công thức hoặc giá trị của ô',
    formulaPlaceholder: 'Gõ giá trị, hoặc =SUM(B2:B5)',
    functions: 'Hàm…',
    fnGroup: {
      math: 'Toán',
      count: 'Đếm, điều kiện',
      logic: 'Logic',
      text: 'Chữ',
      date: 'Ngày',
    },
  },
  formula: {
    fn: {
      SUM: 'Cộng các số.',
      AVERAGE: 'Trung bình cộng.',
      MIN: 'Số nhỏ nhất.',
      MAX: 'Số lớn nhất.',
      ROUND: 'Làm tròn tới số chữ số (0,5 làm tròn lên).',
      ROUNDUP: 'Làm tròn ra xa số 0.',
      ROUNDDOWN: 'Làm tròn về phía số 0.',
      ABS: 'Giá trị tuyệt đối.',
      SQRT: 'Căn bậc hai.',
      MOD: 'Số dư của phép chia (cùng dấu số chia).',
      POWER: 'Luỹ thừa.',
      COUNT: 'Đếm ô là số.',
      COUNTA: 'Đếm ô không trống.',
      COUNTIF: 'Đếm ô thoả điều kiện, vd. ">10".',
      SUMIF: 'Cộng các ô thoả điều kiện.',
      AVERAGEIF: 'Trung bình các ô thoả điều kiện.',
      IF: 'Chọn giá trị theo điều kiện.',
      IFERROR: 'Thay giá trị khi công thức lỗi.',
      AND: 'Đúng khi mọi điều kiện đúng.',
      OR: 'Đúng khi ít nhất một điều kiện đúng.',
      NOT: 'Đảo đúng/sai.',
      CONCAT: 'Nối chữ.',
      LEN: 'Số ký tự.',
      UPPER: 'Chữ in hoa.',
      LOWER: 'Chữ thường.',
      TRIM: 'Bỏ khoảng trắng thừa.',
      TODAY: 'Ngày hôm nay.',
    },
  },
  /** So sánh hai phiên bản `.chilldoc` — APM-CD2-j. */
  chilldocCompare: {
    title: 'So sánh hai phiên bản',
    heading: 'So sánh {{left}} → {{right}}',
    open: 'bản đang mở',
    openVersion: 'Phiên bản {{n}} (đang mở)',
    openUnsaved: 'bản đang mở (gồm thay đổi chưa lưu)',
    loading: 'Đang tải hai phiên bản…',
    loadFailed: 'Không tải được phiên bản để so sánh.',
    added_one: '+{{count}} thêm',
    added_other: '+{{count}} thêm',
    removed_one: '−{{count}} xoá',
    removed_other: '−{{count}} xoá',
    modified_one: '{{count}} sửa',
    modified_other: '{{count}} sửa',
    countsLabel: '{{added}} khối thêm, {{removed}} khối xoá, {{modified}} khối sửa',
    position: '{{k}}/{{n}}',
    previous: 'Thay đổi trước',
    next: 'Thay đổi sau',
    identical: 'Hai bản giống hệt nhau.',
    unchanged_one: '⋯ {{count}} khối không đổi',
    unchanged_other: '⋯ {{count}} khối không đổi',
    formatOnly: 'Đổi định dạng',
    empty: '(đoạn trống)',
    before: 'Trước',
    after: 'Sau',
    restore: 'Khôi phục khối này',
    restored: 'Đã khôi phục khối từ bản cũ — hoàn tác bằng Ctrl+Z',
    restoreFailed: 'Không khôi phục được khối này vào chỗ đó',
    pickTwo: 'So sánh hai bản',
    pickFirst: 'Chọn hai bản để so sánh',
    pickSecond: 'Chọn thêm một bản',
    compareHint: 'Hoặc so một bản với bản đang mở',
    pickVersion: 'Chọn phiên bản {{n}} để so sánh',
    compareWithOpen: 'So sánh phiên bản {{n}} với bản đang mở',
    op: {
      added: 'Khối thêm:',
      removed: 'Khối xoá:',
      modified: 'Khối sửa:',
    },
    object: {
      image: 'Ảnh',
      chart: 'Biểu đồ',
      drawing: 'Hình vẽ',
      slideBreak: 'Slide',
      blockMath: 'Công thức',
      horizontalRule: 'Đường kẻ ngang',
      other: 'Đối tượng',
    },
  },
  myFiles: {
    nav: 'Tệp',
    title: 'Tệp',
    folderLabel: 'Thư mục',
    renameFile: {
      menu: 'Đổi tên',
      title: 'Đổi tên “{{name}}”',
      label: 'Tên mới',
      versionsHint: 'Cả {{count}} phiên bản đổi tên theo.',
      renamed: 'Đã đổi tên thành “{{name}}”',
    },
    convert: {
      menu: 'Chuyển thành .chilldoc',
      title: 'Chuyển thành .chilldoc',
      loading: 'Đang đọc tệp…',
      building: 'Đang chuyển…',
      preview: 'Xem trước tệp .chilldoc',
      previewEmpty: 'Chọn ít nhất một mục để xem trước.',
      cancelled: 'Đã huỷ lượt chuyển.',
      retry: 'Chuyển lại',
      lossyTitle: 'Tệp mới không giữ được:',
      name: 'Tên tệp mới',
      sourceKept: 'Tệp gốc giữ nguyên — kết quả là một tệp mới.',
      create: 'Tạo tệp',
      openEditor: 'Mở để sửa',
      created: 'Đã tạo {{name}}',
      openCreated: 'Mở',
      pdf: { page: 'Trang {{page}}' },
      /** `.pptx` → slide (APM-CVT-d). */
      deck: {
        slide: 'Slide {{n}}',
        empty: 'Tệp không có slide nào — tệp mới chỉ có tiêu đề.',
        lost: {
          images: '{{count}} ảnh EMF / WMF / TIFF không nhúng được — đã bỏ khỏi slide.',
          background: 'Nền và hình trang trí của slide mẫu không giữ ({{count}} slide).',
        },
        imagesDropped: '{{count}} ảnh quá lớn hoặc không đọc được — đã bỏ khỏi slide.',
        sourceKept:
          'Hiệu ứng, chuyển slide và ghi chú diễn giả không có trong .chilldoc. Tệp .pptx gốc giữ nguyên — vẫn mở và trình chiếu được bằng trình soạn PowerPoint.',
      },
      /** Bảng tính → chilldoc — APM-CVT-b. */
      sheet: {
        size: '{{rows}} hàng × {{cols}} cột',
        sizeEmpty: 'trống',
        moreRows: '… còn {{n}} hàng không chuyển.',
        moreCols: '… còn {{n}} cột không chuyển.',
        notes: {
          empty: 'Sheet “{{name}}” trống — đã bỏ qua.',
          budget: 'Sheet “{{name}}” chưa chuyển: cả tệp đã chạm trần {{max}} ô.',
          rows: 'Sheet “{{name}}”: chỉ chuyển {{kept}} hàng đầu, còn {{n}} hàng (trần {{max}} ô mỗi sheet).',
          cols: 'Sheet “{{name}}”: chỉ chuyển {{kept}} cột đầu, còn {{n}} cột.',
          header: 'Sheet “{{name}}”: chưa chắc hàng đầu có phải tiêu đề — đang lấy 1 hàng tiêu đề.',
          unstyled: 'Tệp .xls: không đọc được màu nền và kiểu chữ của ô — bảng chỉ giữ dữ liệu, ô gộp, độ rộng cột.',
          images: '{{count}} ảnh không đọc được — đã bỏ qua.',
        },
      },
      /** Biểu đồ Office → biểu đồ chilldoc — APM-CVT-c. */
      chart: {
        title: 'Biểu đồ',
        category: 'Danh mục',
        value: 'Giá trị',
        series: 'Chuỗi {{n}}',
        notes: {
          percent: 'Biểu đồ “{{title}}”: kiểu chồng 100 % vẽ thành cột chồng theo số thật (.chilldoc không có kiểu 100 %).',
          unstacked: 'Biểu đồ “{{title}}”: không giữ kiểu chồng — các chuỗi vẽ cạnh nhau.',
          vertical: 'Biểu đồ “{{title}}”: thanh ngang chồng vẽ thành cột chồng dọc.',
          secondaryAxis: 'Biểu đồ “{{title}}”: không giữ trục phụ — mọi chuỗi chung một trục.',
          series: 'Biểu đồ “{{title}}”: chỉ giữ {{max}} chuỗi đầu, bỏ {{count}} chuỗi.',
          points: 'Biểu đồ “{{title}}”: chỉ giữ {{max}} điểm đầu, bỏ {{count}} điểm.',
          rings: 'Biểu đồ “{{title}}”: vành khuyên nhiều vòng chỉ giữ vòng đầu, bỏ {{count}} vòng.',
        },
      },
      /** `.ppt` 97–2003 → slide (APM-CVT-e). */
      ppt: {
        fallback:
          'Không đọc được mục lục của tệp — đã đọc slide theo thứ tự lưu (chế độ dự phòng): thứ tự slide hoặc chữ có thể lệch so với PowerPoint.',
        lost: {
          images: '{{count}} ảnh EMF / WMF / TIFF / PICT không nhúng được — đã bỏ khỏi slide.',
        },
        sourceKept:
          'Từ tệp .ppt chỉ lấy chữ, vị trí khung chữ và ảnh PNG / JPEG / BMP. Hình khối, nhóm hình, nền, slide mẫu, định dạng chữ, hiệu ứng và ghi chú diễn giả không có trong tệp mới. Tệp .ppt gốc giữ nguyên.',
        errors: {
          encrypted:
            'Tệp PowerPoint này có mật khẩu (đã mã hoá) — mở bằng PowerPoint, gỡ mật khẩu hoặc lưu thành .pptx rồi chuyển lại.',
          invalid:
            'Không đọc được tệp .ppt này — tệp hỏng hoặc không phải bản trình chiếu PowerPoint 97–2003.',
        },
      },
      pick: {
        label: 'Chọn mục để chuyển',
        count: 'Đã chọn {{count}} / {{total}}',
        all: 'Chọn tất cả',
        none: 'Bỏ chọn tất cả',
        max: 'Tối đa {{max}} mục mỗi lượt.',
      },
      notes: { frontMatter: 'Đã bỏ phần khai báo ở đầu tệp (front matter).' },
      progress: {
        label: 'Tiến độ chuyển tệp',
        download: 'Đang tải tệp · {{done}} / {{total}}',
        downloadUnknown: 'Đang tải tệp · {{done}}',
        read: 'Đang đọc tệp',
        unit: {
          byte: 'Đang chuyển · {{done}} / {{total}}',
          page: 'Đang chuyển trang {{done}} / {{total}}',
          sheet: 'Đang chuyển sheet {{done}} / {{total}}',
          slide: 'Đang chuyển slide {{done}} / {{total}}',
          block: 'Đang chuyển khối {{done}} / {{total}}',
          image: 'Đang xử lý ảnh {{done}} / {{total}}',
          region: 'Đang xử lý vùng {{done}} / {{total}}',
        },
        convertUnknown: 'Đang chuyển…',
        images: 'Đang xử lý ảnh {{done}} / {{total}}',
        imagesUnknown: 'Đang xử lý ảnh…',
        ai: 'AI đang xử lý {{done}} / {{total}}',
        aiUnknown: 'AI đang xử lý…',
        save: 'Đang lưu · {{percent}} %',
        saveUnknown: 'Đang lưu…',
      },
      errors: {
        code: 'mã lỗi: {{code}}',
        tooLarge: 'Tệp lớn hơn {{max}} MB — không chuyển được trên trình duyệt.',
        fetchFailed: 'Không tải được tệp — mạng hoặc cấu hình kho lưu trữ.',
        http: 'Kho lưu trữ trả lỗi {{status}} khi tải tệp.',
        password: 'Tệp có mật khẩu — mở bằng ứng dụng gốc, lưu bản không mật khẩu rồi chuyển lại.',
        browser: 'Trình duyệt này thiếu tính năng cần để đọc tệp — thử Chrome, Edge hoặc Firefox bản mới.',
        invalid: 'Không đọc được tệp này — tệp hỏng hoặc không đúng định dạng.',
        unsupported: 'Chưa chuyển được loại tệp này.',
        reload: 'Không tải được bộ chuyển — hãy tải lại trang.',
        reloadPage: 'Tải lại trang',
        convertFailed: 'Chuyển không thành công — thử khoảng khác hoặc chuyển lại.',
        outputTooLarge: 'Tệp mới {{size}} vượt trần {{max}} — bớt trang, sheet hoặc slide rồi thử lại.',
        saveFailed: 'Không lưu được: {{message}}',
      },
      ai: {
        toggle: 'Dùng AI cho phần khó',
        hint: 'AI sẽ xử lý: {{parts}}. Bản thường vẫn giữ để bạn chọn.',
        hard: {
          pdfFormula: '{{count}} công thức thành LaTeX',
          pdfTable: '{{count}} bảng kẻ khung thành bảng thật',
          pdfAmbiguous: '{{count}} vùng chưa rõ hình hay chữ',
          question: '{{count}} chỗ chưa chắc tiêu đề / độ sâu danh sách',
          omml: '{{count}} công thức Word thành LaTeX',
          sheetHeader: '{{count}} sheet chưa rõ mấy hàng tiêu đề',
        },
        runLabel: 'Chuyển thành .chilldoc — phần khó',
        runDone: 'AI đổi {{count}} khối — xem ở tab "Bản có AI" trong hộp chuyển',
        failed: 'AI chưa xử lý được — vẫn giữ bản thường. {{message}}',
        uploadFailed: 'Không gửi được ảnh của vùng khó lên kho — thử lại sau.',
        tooMany: 'Còn {{count}} vùng giữ dạng ảnh (mỗi lượt AI tối đa {{max}}).',
        tooManyQuestions: 'Còn {{count}} câu hỏi tiêu đề / danh sách giữ mặc định (mỗi lượt AI tối đa {{max}}).',
        tabs: { label: 'Chọn bản để ghi', plain: 'Bản thường', ai: 'Bản có AI' },
        legend: 'Viền vàng: {{count}} khối AI đã đổi. Tạo tệp và Mở để sửa dùng bản đang chọn.',
        legendNone: 'AI không đổi khối nào — hai bản giống nhau.',
        office: {
          formulasLeft_one: '{{count}} công thức AI chưa đọc chắc — vẫn giữ chỗ để bạn gõ lại.',
          formulasLeft_other: '{{count}} công thức AI chưa đọc chắc — vẫn giữ chỗ để bạn gõ lại.',
          tooManyFormulas_one: 'Còn {{count}} công thức giữ chỗ "không nhập được" (mỗi lượt AI tối đa {{max}}).',
          tooManyFormulas_other: 'Còn {{count}} công thức giữ chỗ "không nhập được" (mỗi lượt AI tối đa {{max}}).',
          tooManySheets_one: 'Còn {{count}} sheet lấy một hàng tiêu đề (mỗi lượt AI tối đa {{max}}).',
          tooManySheets_other: 'Còn {{count}} sheet lấy một hàng tiêu đề (mỗi lượt AI tối đa {{max}}).',
        },
      },
      run: {
        start: 'Bắt đầu chuyển',
        setupHint: 'Chọn khoảng trang, có dùng AI cho phần khó không, rồi bấm Bắt đầu chuyển.',
        aiHint:
          'AI chỉ chạy ở chỗ bộ chuyển không tự quyết được — công thức, bảng kẻ khung, vùng chưa rõ hình hay chữ, cấp tiêu đề. Bản thường vẫn giữ để bạn chọn.',
        batchLabel: 'Gộp mỗi lượt AI (số trang)',
        batchOption: '{{count}}',
        batchHint:
          'Gộp nhiều trang ⇒ ít lượt AI hơn, rẻ hơn. Mỗi lượt tối đa {{regions}} vùng và {{questions}} câu hỏi — nhiều hơn thì tự tách lượt.',
        pause: 'Tạm dừng',
        pauseHint: 'Bấm Tạm dừng để xem trước phần đã chuyển xong.',
        resume: 'Tiếp tục',
        stopHere: 'Dừng tại đây',
        restart: 'Chuyển lại',
        paused: 'Đã tạm dừng — đây là phần đã chuyển xong. Tiếp tục để chuyển nốt, hoặc Dừng tại đây để giữ phần này.',
        page: 'Trang {{page}} — {{done}} / {{total}} trang',
        aiCount: 'AI {{done}} / {{total}} lượt',
        aiUpload: 'AI lượt {{batch}}/{{batches}} (trang {{first}}–{{last}}): gửi ảnh {{done}}/{{total}}',
        aiWaiting: 'AI lượt {{batch}}/{{batches}} (trang {{first}}–{{last}}): đang xử lý {{regions}} vùng, {{questions}} câu hỏi',
        aiLabel: 'AI: phần khó trang {{first}}–{{last}}',
        aiLabelPart: 'AI: phần khó trang {{first}}–{{last}} (lượt {{call}}/{{calls}})',
        aiStopped: 'AI dừng từ trang {{page}} ({{message}}) — phần sau chuyển không AI.',
        stoppedAt: 'Đã dừng ở trang {{last}} — tệp gồm trang {{from}}–{{last}} (đã chọn {{from}}–{{to}}).',
      },
    },
    folder: {
      all: 'Tất cả',
      mine: 'Tệp của tôi',
      task: 'Công việc',
      todo: 'To-do',
      document: 'Tài liệu dự án',
      bug: 'Bằng chứng lỗi',
      project: 'Dự án (chưa gắn mục)',
    },
    searchLabel: 'Tìm theo tên file',
    searchPlaceholder: 'Tìm theo tên…',
    typeLabel: 'Lọc theo loại',
    allTypes: 'Mọi loại',
    type: {
      image: 'Ảnh',
      video: 'Video',
      audio: 'Âm thanh',
      document: 'Văn bản Word',
      spreadsheet: 'Bảng tính',
      presentation: 'Trình chiếu',
      pdf: 'PDF',
      code: 'Mã nguồn',
      text: 'Văn bản',
      archive: 'Tệp nén',
      other: 'Khác',
    },
    linkType: 'Liên kết ngoài',
    /** `.chilldoc` sits in the `document` group (filter) but is not a Word file (QA 2026-10-13). */
    typeChilldoc: 'Tài liệu Chill',
    sortLabel: 'Sắp xếp',
    sort: {
      createdAt_desc: 'Mới nhất',
      createdAt_asc: 'Cũ nhất',
      name_asc: 'Tên A → Z',
      name_desc: 'Tên Z → A',
      size_desc: 'Lớn nhất',
      size_asc: 'Nhỏ nhất',
    },
    viewLabel: 'Kiểu xem',
    view: {
      details: 'Chi tiết',
      list: 'Danh sách',
      medium: 'Biểu tượng vừa',
      large: 'Biểu tượng lớn',
      tiles: 'Ô xếp',
    },
    col: {
      name: 'Tên',
      location: 'Nằm ở',
      type: 'Loại',
      size: 'Dung lượng',
      uploadedAt: 'Ngày tải lên',
      actions: 'Thao tác',
    },
    used: 'Đã dùng {{size}}',
    newDocument: 'Tài liệu mới',
    newDocumentFormat: {
      chilldoc: {
        label: 'Tài liệu Chill (.chilldoc)',
        hint: 'Đầy đủ nhất: màu chữ, font, bảng có công thức, dàn ý…',
      },
      markdown: {
        label: 'Markdown (.md)',
        hint: 'Định dạng markdown hỗ trợ: đậm, nghiêng, danh sách, ảnh…',
      },
      text: {
        label: 'Văn bản thuần (.txt)',
        hint: 'Chỉ chữ, không định dạng.',
      },
    },
    margins: {
      label: 'Lề trái và phải',
      left: 'Lề trái (mm)',
      right: 'Lề phải (mm)',
      leftShort: 'Trái',
      rightShort: 'Phải',
    },
    pages: {
      toggle: 'Trang giấy (A4) như Word',
      pageNumber: 'Trang {{n}}',
    },
    ruler: {
      label: 'Thước lề và thụt lề',
      toggle: 'Hiện/ẩn thước',
      firstLine: 'Thụt dòng đầu (mm)',
      hanging: 'Thụt treo (mm)',
      leftIndent: 'Thụt lề trái (mm)',
      rightIndent: 'Thụt lề phải (mm)',
      value: '{{label}}: {{mm}} mm',
    },
    layout: {
      button: 'Lề trang và thụt lề',
      page: 'Lề trang',
      pageHelp: 'Lề của riêng bạn — áp cho mọi tài liệu bạn mở, không ghi vào tệp.',
      pageHelpDocument: 'Lề của tài liệu này — ghi vào tệp, ai mở cũng thấy đúng lề ấy.',
      paragraph: 'Thụt lề đoạn',
      paragraphHelp: 'Lưu trong tệp, áp cho mọi đoạn đang bôi.',
      noBlock: 'Đặt con trỏ vào một đoạn văn hoặc tiêu đề để thụt lề.',
      special: 'Đặc biệt',
      specialNone: 'Không',
      specialFirst: 'Dòng đầu',
      specialHanging: 'Treo',
      by: 'Bằng (mm)',
    },
    mermaid: {
      alt: 'Sơ đồ Mermaid',
      loading: 'Đang vẽ sơ đồ Mermaid',
      empty: 'Khối Mermaid chưa có mã.',
      error: 'Mã Mermaid chưa vẽ được: {{message}}',
      loadFailed: 'Không tải được bộ vẽ Mermaid.',
      imageFailed: 'trình duyệt không hiển thị được ảnh sơ đồ',
      retry: 'Thử lại',
      convert: 'Chuyển thành hình vẽ',
      converting: 'Đang chuyển…',
      convertHint:
        'Để kéo thả khối, đổi cỡ chữ, đổi màu nền bằng chuột. Mã gốc được giữ trong hình vẽ.',
      unsupported:
        'Loại sơ đồ "{{kind}}" chỉ hiển thị. Chuyển thành hình vẽ được với flowchart, sequence, class, ER và state.',
      fixFirst: 'Sửa lỗi trong mã trước khi chuyển thành hình vẽ.',
      tooLarge:
        'Sơ đồ quá lớn cho một khu vực vẽ (tối đa 1600×2000 px, cỡ chữ nhỏ nhất 12) — thử đổi Hướng sang Dọc.',
      cannotConvert: 'Sơ đồ này chưa chuyển được thành hình vẽ sửa được.',
      convertFailed: 'Không chuyển được: {{message}}',
      backToCode: 'Trở lại mã Mermaid',
      toolbar: 'Chỉnh sơ đồ Mermaid',
      showCode: 'Hiện mã',
      hideCode: 'Ẩn mã',
      codeEmpty: 'Khối chưa có mã — gõ mã Mermaid vào đây.',
      codeBroken: 'Mã đang lỗi — sửa xong thì thu gọn được.',
      layout: 'Bố cục',
      layouts: {
        elk: 'ELK xếp lớp',
        elkTree: 'ELK dạng cây',
        elkForce: 'ELK lực đẩy',
        dagre: 'Dagre (bộ dàn gốc của Mermaid)',
      },
      layoutDefault: '{{name}} (mặc định)',
      fallback:
        'Bố cục "{{layout}}" không dàn được sơ đồ này (thường do cạnh tự vòng hoặc nhóm subgraph) — đang hiện bằng {{to}}.',
      directionFixed: 'Bố cục lực đẩy không theo hướng.',
      viewOnly: 'Chỉ đổi khi xem — mở trình soạn để lưu vào tệp.',
      direction: 'Hướng',
      horizontal: 'Ngang',
      vertical: 'Dọc',
      size: 'Cỡ hiển thị',
      sizes: {
        fit: 'Vừa trang',
        max75: 'Tối đa 75%',
        max50: 'Tối đa 50%',
        actual: 'Cỡ thật (cuộn ngang)',
      },
    },
    drawing: {
      insertButton: 'Chèn khu vực vẽ',
      insert: 'Tạo và mở trình vẽ',
      size: 'Kích thước khu vực vẽ',
      width: 'Rộng (px)',
      height: 'Cao (px)',
      presets: { small: 'Nhỏ', medium: 'Vừa', large: 'Lớn', portrait: 'Dọc' },
      shapes: {
        triangle: 'Tam giác',
        rightTriangle: 'Tam giác vuông',
        pentagon: 'Ngũ giác',
        hexagon: 'Lục giác',
        parallelogram: 'Hình bình hành',
        trapezoid: 'Hình thang',
        star: 'Ngôi sao',
        arrowRight: 'Mũi tên khối phải',
        arrowLeft: 'Mũi tên khối trái',
        arrowUp: 'Mũi tên khối lên',
        arrowDown: 'Mũi tên khối xuống',
        arrowBoth: 'Mũi tên hai đầu',
        chevron: 'Chữ V (chevron)',
        plus: 'Dấu cộng',
        cylinder: 'Hình trụ (CSDL)',
        document: 'Tài liệu',
        cloud: 'Đám mây',
        calloutRect: 'Khung chú thích',
        calloutRound: 'Khung chú thích tròn',
      },
      editorTitle: 'Khu vực vẽ',
      style: {
        label: 'Style',
        keep: 'Giữ nguyên',
        sketch: 'Bút vẽ tay',
        sales: 'Bán hàng',
        scientific: 'Khoa học',
        minimal: 'Tối giản',
      },
      minFont: 'Cỡ chữ tối thiểu (px)',
      advanced: 'Nâng cao',
      palette: {
        label: 'Bộ màu',
        style: 'Theo style',
        ocean: 'Đại dương',
        forest: 'Rừng xanh',
        sunset: 'Hoàng hôn',
        pastel: 'Pastel',
        colorblind: 'Dễ phân biệt',
      },
      selectFirst: 'Bôi một đoạn chữ (danh sách, tiêu đề hoặc các bước) trước.',
      previewLoading: 'Đang dựng sơ đồ…',
      fitsAt: 'Vừa khu vực — cỡ chữ {{size}} px.',
      notFit: 'Ở cỡ chữ {{size}} px, sơ đồ cần khu vực {{width}}×{{height}}.',
      cannotGrow:
        'Ở cỡ chữ {{size}} px, kể cả khu vực lớn nhất cũng không đủ — rút gọn nhãn hoặc bớt ý.',
      grow: 'Nới khu vực tới {{width}}×{{height}}',
      insertDiagram: 'Chèn vào tài liệu',
      ai: {
        button: 'Vẽ sơ đồ bằng AI',
        title: 'Vẽ sơ đồ bằng AI',
        previewTitle: 'Sơ đồ AI đề xuất',
        help: 'AI đọc đoạn đã bôi rồi đề xuất các ô và mũi tên; sơ đồ được dàn cho vừa khu vực ở cỡ chữ bạn chọn. Bạn xem trước rồi mới chèn.',
        type: 'Kiểu sơ đồ',
        types: {
          auto: 'Để AI chọn',
          flow: 'Quy trình',
          tree: 'Cây phân cấp',
          mindmap: 'Sơ đồ tư duy',
          cycle: 'Vòng lặp',
          timeline: 'Dòng thời gian',
          comparison: 'So sánh',
        },
        prompt: 'Yêu cầu thêm (không bắt buộc)',
        promptPlaceholder: 'Ví dụ: nhấn mạnh bước kiểm duyệt, gộp các bước nhỏ',
        run: 'Vẽ sơ đồ',
        running: 'Đang vẽ…',
        done: '{{count}} ô',
        shorten: 'Rút gọn nhãn bằng AI',
        shortening: 'Đang rút gọn…',
        partial:
          'AI chưa sửa hết lỗi (vượt sức chứa hoặc mũi tên lạc) — phần lỗi đã được cắt bớt, kiểm lại trước khi chèn.',
        tooLong: 'Đoạn đã bôi dài quá {{max}} ký tự — bôi ngắn hơn.',
      },
      frameName: 'Khu vực vẽ',
      edit: 'Bấm đúp để sửa hình vẽ',
      empty: 'Khu vực vẽ trống',
      emptyEdit: 'Khu vực vẽ trống — bấm đúp để vẽ',
      loading: 'Đang tải hình vẽ…',
      loadingEditor: 'Đang tải trình vẽ…',
      loadFailed: 'Chưa tải được trình vẽ — kiểm tra kết nối rồi thử lại.',
      tooLarge: 'Hình vẽ quá lớn ({{size}} KB, tối đa {{max}} KB) — bớt vài hình rồi lưu lại.',
      confirmDiscard: 'Hình vẽ có thay đổi chưa lưu. Đóng và bỏ các thay đổi?',
    },
    objects: {
      menu: 'Tuỳ chọn đối tượng',
      layoutButton: 'Tuỳ chọn bố cục',
      editDrawing: 'Sửa hình vẽ',
      cut: 'Cắt',
      copy: 'Sao chép',
      paste: 'Dán',
      delete: 'Xoá',
      copyBlocked: 'Trình duyệt không cho chép từ menu — dùng Ctrl+C hoặc Ctrl+X.',
      pasteBlocked: 'Trình duyệt không cho đọc bộ nhớ tạm — dùng Ctrl+V.',
      wrap: 'Ngắt dòng văn bản',
      wraps: {
        inline: 'Cùng dòng với văn bản',
        square: 'Hình vuông',
        tight: 'Khít',
        through: 'Xuyên qua',
        topBottom: 'Trên và dưới',
        behind: 'Sau văn bản',
        front: 'Trước văn bản',
      },
      align: 'Căn lề',
      aligns: { left: 'Trái', center: 'Giữa', right: 'Phải' },
      alignWrapped: 'Chữ chảy quanh chỉ đặt được đối tượng bên trái hoặc bên phải.',
      size: 'Kích thước',
      sizePercent: '{{percent}}% bề ngang trang',
      sizeOriginal: 'Cỡ gốc',
      sizeLoading: 'Ảnh chưa tải xong.',
      rotate: 'Xoay và lật',
      rotateRight: 'Xoay phải 90°',
      rotateLeft: 'Xoay trái 90°',
      flipX: 'Lật ngang',
      flipY: 'Lật dọc',
      border: 'Viền',
      rounded: 'Bo góc',
      order: 'Thứ tự',
      toFront: 'Đưa lên trên cùng',
      toBack: 'Đưa xuống dưới cùng',
      orderHint: 'Chỉ áp cho kiểu Sau văn bản và Trước văn bản.',
      describe: 'Mô tả ảnh',
      removeBackground: 'Xoá nền…',
      reset: 'Đặt lại định dạng',
    },
    imageDescription: {
      title: 'Mô tả ảnh',
      hint: 'Mô tả đi theo tài liệu: AI dùng nó để chọn ảnh cho slide và bố trí ảnh không cắt mất chủ thể.',
      summary: 'Ảnh chụp gì',
      summaryPlaceholder: 'Ví dụ: Vịnh Hạ Long nhìn từ trên cao, nhiều đảo đá vôi',
      kind: 'Loại ảnh',
      kinds: {
        photo: 'Ảnh chụp',
        diagram: 'Sơ đồ',
        chart: 'Biểu đồ',
        screenshot: 'Ảnh màn hình',
        logo: 'Logo',
        text: 'Ảnh chữ',
        other: 'Khác',
      },
      textHeavy: 'Nhiều chữ cần đọc (không cắt ảnh)',
      focal: 'Chủ thể chính ở',
      focalX: { left: 'trái', center: 'giữa', right: 'phải' },
      focalY: { top: 'trên', center: 'giữa', bottom: 'dưới' },
      ai: 'Mô tả bằng AI',
      aiRunning: 'AI đang xem ảnh…',
      aiDone: 'AI đã mô tả — xem lại rồi Lưu.',
      aiFailed: 'AI không mô tả được ảnh này. Bạn có thể tự gõ.',
      none: 'Chưa có mô tả.',
      save: 'Lưu',
    },
    contextMenu: {
      label: 'Menu soạn thảo',
      cut: 'Cắt',
      copy: 'Sao chép',
      paste: 'Dán',
      pastePlain: 'Dán không định dạng',
      smartPaste: 'Dán thông minh…',
      clipboardBlocked: 'Trình duyệt chưa cho đọc/ghi bộ nhớ tạm — dùng Ctrl+C, Ctrl+X, Ctrl+V.',
      clearFormat: 'Xoá định dạng chữ',
      selectBlock: 'Chọn cả đoạn',
      insertEquation: 'Chèn công thức',
      insertTable: 'Chèn bảng 3 × 3',
      toOrdered: 'Chuyển sang danh sách đánh số',
      removeBullet: 'Bỏ gạch đầu dòng',
      toBullet: 'Chuyển sang gạch đầu dòng',
      removeNumbering: 'Bỏ đánh số',
      editEquation: 'Sửa công thức',
      toInline: 'Chuyển thành công thức trong dòng',
      toBlock: 'Chuyển thành công thức khối riêng',
      copyLatex: 'Sao chép LaTeX',
      latexCopied: 'Đã chép LaTeX',
      deleteEquation: 'Xoá công thức',
      openFile: 'Mở tệp',
      removeFile: 'Bỏ khỏi tài liệu (tệp vẫn còn)',
    },
    listNumbering: {
      menu: 'Đánh số danh sách',
      continueFrom: 'Đánh số tiếp sau mục',
      none: 'Chưa có danh sách đánh số nào phía trên',
      restart: 'Bắt đầu lại từ 1',
    },
    crossRef: {
      button: 'Tham chiếu chéo',
      title: 'Chèn tham chiếu chéo',
      hint: 'Chọn tiêu đề, bookmark, hình hoặc bảng. Số và chữ tự cập nhật khi tài liệu đổi.',
      search: 'Tìm theo chữ',
      showLabel: 'Hiện',
      show: { text: 'Chữ', number: 'Số', both: 'Cả hai' },
      targets: 'Đích tham chiếu',
      groups: { heading: 'Tiêu đề', bookmark: 'Bookmark', figure: 'Hình', table: 'Bảng' },
      untitled: '(chưa có chữ)',
      noTargets: 'Tài liệu chưa có tiêu đề, bookmark hay chú thích nào để tham chiếu.',
      noMatch: 'Không có đích nào khớp.',
      pickOne: 'Chọn một đích để chèn.',
      preview: 'Sẽ chèn: {{text}}',
      insert: 'Chèn tham chiếu',
      section: 'mục {{number}}',
      figure: 'Hình',
      table: 'Bảng',
      broken: '⚠ tham chiếu hỏng',
      brokenHint: 'Đích của tham chiếu này đã bị xoá. Xoá tham chiếu hoặc chèn lại.',
      jump: 'Bấm để tới chỗ được tham chiếu',
      jumpEditing: 'Ctrl + bấm để tới chỗ được tham chiếu',
      bookmarkButton: 'Bookmark',
      bookmarkTitle: 'Thêm bookmark',
      bookmarkHint: 'Đặt một điểm có tên ở con trỏ để tham chiếu chéo trỏ tới.',
      bookmarkName: 'Tên bookmark',
      bookmarkAdd: 'Thêm bookmark',
      captionButton: 'Thêm chú thích',
      captionHint: 'Số hình / bảng tự đếm theo thứ tự trong tài liệu.',
      caption: { figure: 'Chú thích hình', table: 'Chú thích bảng' },
    },
    findReplace: {
      button: 'Tìm và thay thế (Ctrl + F / Ctrl + H)',
      region: 'Tìm và thay thế',
      find: 'Tìm trong tài liệu',
      replaceWith: 'Thay bằng',
      toggleReplace: 'Hiện / ẩn ô thay thế (Ctrl + H)',
      previous: 'Kết quả trước (Shift + Enter)',
      next: 'Kết quả sau (Enter)',
      close: 'Đóng (Esc)',
      replace: 'Thay',
      replaceAll: 'Thay tất cả',
      replaceHint: 'Thay chỗ đang chọn rồi tìm chỗ kế tiếp (Enter)',
      replaceAllHint: 'Thay mọi chỗ khớp — một lần hoàn tác gỡ cả loạt (Ctrl + Alt + Enter)',
      position: '{{current}}/{{total}}',
      total: '{{count}} kết quả',
      none: 'Không thấy',
      replacedAll: 'Đã thay {{count}} chỗ',
      matchCase: 'Phân biệt hoa/thường',
      wholeWord: 'Chỉ tìm nguyên từ',
      matchDiacritics: 'Phân biệt dấu',
    },
    docImport: {
      button: 'Nhập từ tệp…',
      title: 'Nhập từ tệp',
      loading: 'Đang đọc tệp…',
      building: 'Đang dựng nội dung…',
      buildingPages: 'Đang dựng trang {{done}}/{{total}}…',
      preview: 'Xem trước nội dung nhập',
      nothing: 'Không có gì để nhập trong khoảng này.',
      insert: 'Nhập',
      insertAi: 'Nhập với AI',
      ai: {
        title: 'Nhập với AI',
        pending: '{{regions}} vùng ảnh và {{questions}} câu hỏi cần AI quyết',
        asking: 'Có {{count}} chỗ cần AI quyết',
        running: 'AI đang đọc công thức và chỗ chưa rõ…',
        applied: 'AI đã đọc {{count}} công thức',
        revert: 'Về bản không AI',
        nothing: 'Không có gì cần AI quyết — đã nhập như bình thường.',
        editedDuring: 'Bạn đã sửa đoạn vừa nhập nên không áp kết quả AI.',
        uploadFailed: 'Không gửi được ảnh công thức lên kho — thử lại sau.',
        tooMany: 'Còn {{count}} công thức giữ dạng ảnh (mỗi lượt tối đa {{max}}).',
        tooManyQuestions: 'Còn {{count}} câu hỏi tiêu đề / danh sách giữ mặc định (mỗi lượt tối đa {{max}}).',
      },
      pages: {
        from: 'Từ trang',
        to: 'Đến trang',
        of: 'trên {{count}} trang',
        strip: 'Chọn trang',
        pick: 'Trang {{page}} — bấm: trang đầu, Shift + bấm: trang cuối',
      },
      sections: {
        from: 'Từ mục',
        to: 'Đến mục',
        intro: 'Mở đầu',
        whole: 'Tài liệu không có tiêu đề — nhập cả tài liệu.',
      },
      summary: {
        heading: '{{count}} tiêu đề',
        paragraph: '{{count}} đoạn',
        listItem: '{{count}} mục',
        list: '{{count}} danh sách',
        figure: '{{count}} hình',
        formula: '{{count}} công thức (ảnh)',
        code: '{{count}} khối mã',
        table: '{{count}} bảng',
        unsupported: '{{count}} không nhập được',
      },
      warnings: {
        scanned: '{{count}} trang không có lớp chữ (scan) — nhập thành ảnh.',
        tooLarge: '{{count}} ảnh quá lớn sau khi nén — đã bỏ.',
        outline: 'Đã dựng {{count}} tiêu đề từ mục lục của PDF.',
        tocLinks: 'Trang mục lục thành {{count}} liên kết bấm được tới tiêu đề.',
      },
      errors: {
        unsupportedType: 'Chỉ nhập được PDF và .docx.',
        tooLarge: 'Tệp lớn hơn {{max}} MB — không đọc được trên trình duyệt.',
        invalid: 'Không đọc được tệp này.',
      },
      unsupported: {
        equation:
          'Không nhập được {{count}} công thức Word — Word lưu chúng ở dạng app không đọc; chụp ảnh rồi dán.',
        chart: 'Không nhập được {{count}} biểu đồ Word — chụp ảnh rồi dán.',
        object: 'Không nhập được {{count}} đối tượng nhúng (OLE / hình vẽ) — chụp ảnh rồi dán.',
      },
      unsupportedBlock: {
        equation: '[Không nhập được: công thức]',
        chart: '[Không nhập được: biểu đồ]',
        object: '[Không nhập được: đối tượng nhúng]',
      },
    },
    smartPaste: {
      button: 'Dán thông minh',
      title: 'Dán thông minh',
      source: 'Nguồn nội dung dán',
      sources: {
        markdown: 'md code',
        markdownPreview: 'md preview',
        word: 'Word',
        excel: 'Excel',
        other: 'Khác',
      },
      hint: 'Nhấn Ctrl + V để dán vào đây',
      readButton: 'Dán từ clipboard',
      blocked: 'Trình duyệt không cho đọc clipboard ở trang này — nhấn Ctrl + V.',
      readFailed: 'Chưa đọc được clipboard — hãy cho phép trình duyệt, hoặc nhấn Ctrl + V.',
      detected: 'Nhận ra: {{source}}',
      pasteAgain: 'Ctrl + V lần nữa để thay',
      preview: 'Xem trước nội dung dán',
      nothing: 'Đọc theo kiểu {{source}} thì không có gì để dán — thử tab khác.',
      droppedImages: '{{count}} ảnh không dán được — dùng "Chèn ảnh".',
      insert: 'Chèn ngay',
      aiTitle: 'Định dạng đoạn vừa dán',
      aiDone: 'Đổi định dạng {{count}} khối',
      aiRunning: 'AI đang định dạng đoạn vừa dán…',
      aiSkip: 'Bỏ qua AI',
      aiApplied: 'AI đã định dạng',
      aiLocal: 'Đã định dạng theo ngữ cảnh',
      aiAsking: 'Đã định dạng theo ngữ cảnh — {{count}} điểm chưa chắc',
      askAi: 'Hỏi AI',
      aiAnswered: 'AI đã trả lời {{count}} điểm',
      keep: 'Giữ',
      revert: 'Về dạng dán thường',
      editedDuring: 'Bạn đã sửa đoạn vừa dán trong lúc AI chạy nên kết quả AI không được áp.',
      reformat: 'Reformat bằng AI',
    },
    math: {
      insertButton: 'Chèn công thức (Alt + =)',
      title: 'Công thức',
      field: 'Ô soạn công thức',
      help: 'Gõ như Word: / ra phân số, ^ số mũ, _ chỉ số, sqrt ra căn. Bấm biểu tượng bàn phím trong ô để mở bàn phím toán.',
      display: 'Bố cục',
      insert: 'Chèn',
      update: 'Cập nhật',
      edit: 'Bấm đúp để sửa công thức',
      empty: 'Công thức trống',
      loading: 'Đang tải công thức…',
      loadingEditor: 'Đang tải bộ soạn công thức…',
      loadFailed: 'Chưa tải được bộ soạn công thức — kiểm tra kết nối rồi thử lại.',
    },
    docSettings: {
      button: 'Cấu hình và chia sẻ',
      tabConfig: 'Cấu hình',
      tabShare: 'Chia sẻ',
      text: 'Văn bản',
      baseSize: 'Cỡ chữ mặc định',
      headings: 'Tiêu đề',
      headingSize: 'Cỡ chữ của {{name}}',
      headingColor: 'Màu của {{name}}',
      headingFont: 'Phông chữ của {{name}}',
      defaultColor: 'Màu mặc định',
      defaultFont: 'Phông mặc định',
      reset: 'Đặt lại cấu hình của tài liệu',
      plainNote:
        'Kiểu chữ và tiêu đề chỉ lưu được trong tài liệu Chill (.chilldoc). Tài liệu này chỉ đặt được lề trang, theo máy của bạn.',
      shareNeedsSave: 'Lưu tài liệu vào Tệp của tôi để chia sẻ.',
      customize: 'Tuỳ chỉnh',
      collapse: 'Thu gọn',
      page: 'Trang',
      marginsRow: 'Lề trang & thụt lề',
      marginsSummary: 'Trái {{left}} mm · Phải {{right}} mm',
      unsaved: 'Có thay đổi chưa lưu',
      unsavedTitle: 'Cấu hình có thay đổi chưa lưu.',
      stay: 'Ở lại',
      discard: 'Bỏ thay đổi',
      saveAndClose: 'Lưu và đóng',
      lists: {
        title: 'Danh sách',
        numbering: 'Đánh số',
        numberingPresets: 'Mẫu đánh số',
        bullets: 'Gạch đầu dòng',
        bulletPresets: 'Mẫu gạch đầu dòng',
        custom: 'Tuỳ chỉnh',
        default: 'Mặc định',
        level: 'Cấp {{level}}',
        format: 'Kiểu số của {{name}}',
        pattern: 'Mẫu dấu mục của {{name}}',
        insertToken: 'Chèn {{token}}',
        patternHint:
          '{1} {2} {3} là số của cấp 1, 2, 3 — ví dụ “{1}.{2}.” ra 1.2., “{2})” ra b). Cấp sâu hơn {{levels}} dùng kiểu của cấp {{levels}}.',
        symbol: 'Ký hiệu của {{name}}',
        symbolsFor: 'Chọn ký hiệu cho {{name}}',
        pickSymbol: 'Chọn',
        formats: {
          decimal: '1, 2, 3',
          'lower-alpha': 'a, b, c',
          'upper-alpha': 'A, B, C',
          'lower-roman': 'i, ii, iii',
          'upper-roman': 'I, II, III',
        },
      },
    },
    versions: {
      saveAs: 'Lưu thành phiên bản khác',
      saveAsWithCount: 'Lưu thành phiên bản khác — tệp đang có {{count}} phiên bản',
      saveAsHint:
        'Bản hiện có của “{{name}}” được giữ lại làm phiên bản trước; nội dung đang soạn thành phiên bản mới.',
      note: 'Ghi chú phiên bản (không bắt buộc)',
      notePlaceholder: 'VD: bản gửi sếp duyệt',
      save: 'Lưu phiên bản',
      saved_one: 'Đã lưu {{name}}',
      saved_other: 'Đã lưu {{name}} — phiên bản {{count}}',
      count_one: '{{count}} phiên bản',
      count_other: '{{count}} phiên bản',
      menu: 'Các phiên bản',
      title: 'Các phiên bản của “{{name}}”',
      number: 'Phiên bản {{n}}',
      representative: 'Đại diện',
      panelTitle: 'Phiên bản',
      current: 'Đang mở',
      newVersion: 'Lưu thành phiên bản mới',
      newVersionHint: 'Bản mới lên đầu danh sách và thành bản đại diện.',
      newVersionHintProject: 'Bản đang có được giữ nguyên. Xem các bản ở “Phiên bản & duyệt”.',
      dragHint: 'Kéo để đổi thứ tự — bản trên cùng là bản đại diện, mở ra khi bấm đúp ở trang Tệp.',
      dragHandle: 'Kéo để đổi thứ tự phiên bản {{n}}',
      openVersion: 'Mở phiên bản {{n}}',
      switchConfirm: 'Thay đổi chưa lưu sẽ mất. Mở phiên bản {{n}}?',
      switchConfirmAction: 'Bỏ thay đổi và mở',
      cannotDeleteOpen: 'Đang mở — chuyển sang bản khác để xoá',
      confirmDeleteRepresentative:
        'Xoá phiên bản {{n}}? Đây là bản đại diện — bản đứng kế tiếp sẽ lên thay.',
      reordered: 'Phiên bản {{n}} là bản đại diện',
      open: 'Mở',
      restore: 'Khôi phục',
      delete: 'Xoá phiên bản',
      restoreNote: 'Khôi phục từ phiên bản {{n}}',
      restored: 'Đã khôi phục phiên bản {{n}} thành phiên bản mới nhất',
      deleted: 'Đã xoá phiên bản {{n}}',
      confirmDelete: 'Xoá phiên bản {{n}}? Không hoàn tác được.',
      loadError: 'Không tải được danh sách phiên bản',
      readOnly: 'Phiên bản {{n}} — chỉ xem',
      deleteAll_one: 'Xoá tệp này?',
      deleteAll_other: 'Xoá tệp này cùng cả {{count}} phiên bản của nó?',
    },
    saveAs: {
      title: 'Lưu thành',
      name: 'Tên tệp',
      folder: 'Lưu vào thư mục',
    },
    shared: {
      folder: 'Được chia sẻ với tôi',
      empty: 'Chưa ai chia sẻ gì với bạn',
      emptyHelp: 'Khi ai đó chia sẻ một tệp hay tài liệu với bạn, nó sẽ hiện ở đây.',
      by: 'Chia sẻ bởi {{name}}',
      mode: { copy: 'Được lưu bản sao', read: 'Chỉ đọc', suggest: 'Được đề xuất chỉnh sửa' },
      suggestOpen: 'Đề xuất chỉnh sửa',
      expires: 'Hết hạn {{time}}',
      stale: 'Nội dung này là bản chủ tài liệu chia sẻ lúc trước — tài liệu đã có bản mới hơn.',
      copy: 'Lưu bản sao vào Tệp của tôi',
      copied: 'Đã lưu "{{name}}" vào Tệp của tôi',
      openMine: 'Mở Tệp của tôi',
      signInToCopy: 'Đăng nhập để lưu bản sao',
      signIn: 'Đăng nhập',
      signInTitle: 'Cần đăng nhập để mở link này',
      signInHelp: 'Link này chỉ dành cho người có tài khoản ChillPM.',
      gone: 'Link không còn mở được',
      goneHelp:
        'Link có thể đã hết hạn, bị thu hồi, hoặc tệp đã bị xoá. Hỏi lại người đã gửi link.',
      orgOnly: 'Chỉ chia sẻ trong tổ chức',
      orgOnlyHelp: 'Link này chỉ mở được với thành viên tổ chức của người tạo link.',
    },
    fileShare: {
      menu: 'Chia sẻ',
      title: 'Chia sẻ "{{name}}"',
    },
    docShare: {
      createLink: 'Tạo link chia sẻ',
      invite: 'Mời người',
      summary: {
        none: 'Chưa chia sẻ với ai.',
        public_one: '{{count}} link công khai',
        public_other: '{{count}} link công khai',
        chillpm_one: '{{count}} link cho người có tài khoản ChillPM',
        chillpm_other: '{{count}} link cho người có tài khoản ChillPM',
        org_one: '{{count}} link trong tổ chức',
        org_other: '{{count}} link trong tổ chức',
        people_one: '{{count}} người được mời',
        people_other: '{{count}} người được mời',
      },
      peopleTitle: 'Người được chia sẻ',
      linksTitle: 'Link chia sẻ',
      noLinks: 'Chưa có link nào.',
      external: 'Ngoài tổ chức',
      permissionOf: 'Quyền của {{name}}',
      revoke: 'Thu hồi',
      revokePerson: 'Thu hồi quyền của {{name}}',
      revokePersonConfirm: 'Thu hồi quyền của {{name}} với tệp này?',
      mode: { copy: 'Được lưu bản sao', read: 'Chỉ đọc', suggest: 'Đề xuất', edit: 'Chỉnh sửa' },
      modeLong: {
        copy: 'Copy thành file của mình',
        read: 'Chỉ đọc',
        suggest: 'Đề xuất chỉnh sửa',
        edit: 'Chỉnh sửa',
      },
      soon: 'Sắp có',
      suggestChilldocOnly: 'chỉ tài liệu Chill',
      suggestHelp:
        'Người nhận soạn ở chế độ đề xuất: mỗi lần họ lưu là một phiên bản mới của tài liệu, bạn chấp nhận hoặc từ chối từng đề xuất ở ngăn Xem lại.',
      audience: {
        org: 'Trong tổ chức',
        chillpm: 'Có tài khoản ChillPM',
        public: 'Công khai trên web',
      },
      scope: { text: 'Văn bản', images: 'Ảnh', tables: 'Bảng', presentation: 'Trình bày' },
      scopeAll: 'Toàn bộ tài liệu',
      expired: 'Đã hết hạn',
      expiresAt: 'Hết hạn {{time}}',
      noExpiry: 'Không hạn',
      opens_one: '{{count}} lượt mở',
      opens_other: '{{count}} lượt mở',
      stale: 'Link đang hiện bản cũ — tài liệu đã được lưu sau lần tạo link.',
      update: 'Cập nhật nội dung',
      updated: 'Link đã hiện bản mới nhất',
      copyLink: 'Chép link',
      copied: 'Đã chép link',
      copyFailed: 'Trình duyệt không cho chép tự động — bôi đen link rồi chép tay: {{url}}',
      deleteLink: 'Xoá link',
      deleteLinkConfirm: 'Xoá link này? Người đang giữ link sẽ không mở được nữa.',
      revoked: 'Đã xoá link',
      modeLabel: 'Kiểu chia sẻ',
      scopeLabel: 'Phạm vi',
      snapshotNote:
        'Link chia sẻ một phần sẽ hiện bản đã lưu gần nhất. Lưu lại tài liệu thì bấm "Cập nhật nội dung" ở danh sách link.',
      expiryLabel: 'Thời hạn',
      expiry: {
        '1': '1 ngày',
        '7': '7 ngày',
        '30': '30 ngày',
        none: 'Không hạn',
        date: 'Chọn ngày',
      },
      expiryDate: 'Ngày hết hạn',
      audienceLabel: 'Ai mở được',
      publicWarning: 'Bất kỳ ai có link đều mở được, không cần đăng nhập.',
      share: 'Chia sẻ',
      personLabel: 'Người nhận',
      personPlaceholder: 'Tìm tên trong tổ chức, hoặc gõ email',
      changePerson: 'Đổi',
      inviteByEmail: 'Mời {{email}} — cần có tài khoản ChillPM với email này.',
      emailNotFound: 'Không có tài khoản ChillPM nào với email {{email}}.',
      permissionLabel: 'Quyền',
      sendInvite: 'Mời',
      invited: 'Đã chia sẻ với {{name}}',
    },
    drafts: {
      folder: 'Bản nháp',
      saving: 'Đang lưu nháp…',
      savedAt: 'Đã lưu nháp lúc {{time}}',
      failedRetry: 'Chưa lưu được nháp — thử lại',
      limitShort: 'Đã đủ {{limit}} bản nháp — tài liệu này chưa được tự lưu.',
      limitReached:
        'Đã đủ {{limit}} bản nháp nên tài liệu này chưa được tự lưu. Bấm Lưu để đặt tên cho nó, hoặc bỏ bớt bản nháp cũ ở mục Bản nháp của trang Tệp.',
      cleanUp: 'Dọn bản nháp',
      closeFailed: 'Chưa lưu được nháp nên chưa đóng — kiểm tra kết nối rồi thử lại.',
      empty: 'Chưa có bản nháp nào',
      emptyHelp: 'Tài liệu mới chưa đặt tên được tự lưu ở đây vài giây sau khi bạn gõ.',
      untitled: 'Tài liệu không tên',
      editedAt: 'sửa lúc {{time}}',
      open: 'Mở',
      discard: 'Bỏ nháp',
      confirmDiscard: 'Bỏ bản nháp “{{title}}”? Nội dung sẽ mất hẳn.',
      discarded: 'Đã bỏ bản nháp.',
    },
    fileRef: {
      insertButton: 'Chèn tệp của tôi',
      pickTitle: 'Chọn tệp để chèn',
      pickList: 'Tệp',
      insert_one: 'Chèn {{count}} tệp',
      insert_other: 'Chèn {{count}} tệp',
      open: 'Mở “{{name}}”',
      missing: 'Tệp không còn — đã bị xoá hoặc bạn không còn quyền xem.',
      missingShort: 'không còn',
    },
    outline: {
      label: 'Dàn ý',
      toggle: 'Hiện/ẩn dàn ý',
      empty: 'Chưa có tiêu đề nào — dùng "Cấp tiêu đề" để tạo.',
      levels: 'Hiện tới cấp',
      showLevel: 'Hiện tới cấp {{n}}',
      showAll: 'Hiện mọi cấp',
      collapse: 'Thu gọn “{{title}}”',
      expand: 'Mở rộng “{{title}}”',
    },
    userFolder: {
      listLabel: 'Thư mục của tôi',
      new: 'Thư mục mới',
      namePlaceholder: 'Tên thư mục',
      created: 'Đã tạo thư mục “{{name}}”.',
      deleted: 'Đã xoá thư mục. Tệp bên trong đã về lại Tệp của tôi.',
      confirmDelete_one:
        'Xoá thư mục “{{name}}”? {{count}} tệp bên trong sẽ về lại Tệp của tôi — không tệp nào bị xoá.',
      confirmDelete_other:
        'Xoá thư mục “{{name}}”? {{count}} tệp bên trong sẽ về lại Tệp của tôi — không tệp nào bị xoá.',
      fileCount_one: '{{count}} tệp',
      fileCount_other: '{{count}} tệp',
      open: 'Mở',
      rename: 'Đổi tên',
      delete: 'Xoá thư mục',
      actionsFor: 'Thao tác với thư mục {{name}}',
      dropInto: 'Thả vào “{{name}}”',
      moveTo: 'Chuyển tới…',
      moveTitle: 'Chuyển “{{name}}” tới',
      moveTitleMany_one: 'Chuyển {{count}} tệp tới',
      moveTitleMany_other: 'Chuyển {{count}} tệp tới',
      moved_one: 'Đã chuyển {{count}} tệp.',
      moved_other: 'Đã chuyển {{count}} tệp.',
      root: 'Tệp của tôi (ngoài thư mục)',
      here: 'Đang ở đây',
      noneYet: 'Chưa có thư mục nào — tạo ở thanh bên, mục "Thư mục mới".',
      breadcrumb: 'Đường dẫn thư mục',
    },
    editor: {
      titleNew: 'Tài liệu mới',
      titleEdit: 'Sửa tài liệu',
      nameLabel: 'Tên tài liệu',
      untitled: 'Tài liệu không tên',
      nameEmpty: 'Hãy đặt tên cho tài liệu.',
      nameTooLong: 'Tên dài quá 255 ký tự.',
      nameSlash: 'Tên không được chứa dấu / hoặc \\.',
      contentLabel: 'Nội dung tài liệu',
      markdownSource: 'Xem mã Markdown',
      markdownSourceLabel: 'Mã Markdown của tài liệu',
      placeholder: 'Bắt đầu viết…',
      saving: 'Đang lưu…',
      loading: 'Đang mở tài liệu…',
      loadFailed: 'Không mở được tài liệu để sửa.',
      confirmDiscard: 'Tài liệu có thay đổi chưa lưu. Đóng và bỏ các thay đổi?',
      imagesPending: 'Chờ ảnh tải lên xong rồi hãy lưu.',
      saved: 'Đã lưu “{{name}}”.',
      savedAsNewVersion:
        'Đã lưu “{{name}}” thành phiên bản {{n}} — bản trước đã gửi duyệt, đã duyệt hoặc do người khác lưu nên được giữ nguyên.',
      nameAndSave: 'Đặt tên và lưu',
      suggestBanner:
        'Bạn đang đề xuất chỉnh sửa: chữ gõ và chữ xoá thành đề xuất để chủ tài liệu chấp nhận hoặc từ chối. Mỗi lần Lưu là một phiên bản mới.',
      savedSuggestion: 'Đã lưu đề xuất thành phiên bản {{n}} của “{{name}}”.',
      suggestStale: {
        message:
          'Chủ tài liệu vừa lưu bản mới nên đề xuất của bạn chưa lưu được. Đề xuất phải nằm trên bản mới nhất.',
        reload: 'Mở bản mới nhất',
        copy: 'Lưu đề xuất thành bản sao của tôi',
        copyName: '{{name}} (đề xuất của tôi)',
        copied: 'Đã lưu bản sao “{{name}}” vào Tệp của tôi.',
        confirmReload:
          'Mở bản mới nhất sẽ bỏ các đề xuất chưa lưu ở đây (bản sao đã lưu vẫn còn). Tiếp tục?',
      },
      storageOff: 'Chưa cấu hình nơi lưu trữ.',
      toolbar: 'Thanh công cụ soạn thảo',
      fileGroup: 'Tệp',
      saveHint: 'Lưu (Ctrl + S)',
      saveUnsaved: 'Lưu — có thay đổi chưa lưu',
      rename: 'Đổi tên',
      renameCurrent: 'Đổi tên — {{name}}',
      collapseToolbar: 'Thu gọn thanh công cụ',
      expandToolbar: 'Mở rộng thanh công cụ',
      moreInGroup: 'Các nút khác của nhóm {{group}}',
      fontSize: 'Cỡ chữ',
      fontSizeHint: 'Gõ cỡ chữ ({{min}}–{{max}}) rồi Enter; để trống là cỡ mặc định',
      headingN: 'Tiêu đề {{level}}',
      defaultFontShort: 'Mặc định',
      normalStyle: 'Đoạn văn',
      notEditable: 'Tệp này không mở được bằng trình soạn tài liệu.',
      mixedStyles: 'Nhiều kiểu',
      groups: {
        history: 'Thao tác',
        style: 'Kiểu đoạn',
        font: 'Phông chữ',
        text: 'Định dạng chữ',
        paragraph: 'Đoạn',
        insert: 'Chèn',
        draw: 'Vẽ',
        review: 'Xem lại',
        view: 'Hiển thị',
      },
    },
    /** Tệp Word/PowerPoint mở bằng trình soạn Chill — APM-WDE-b, docs/plan-office-editors.md. */
    officeEditor: {
      openFailed: 'Không mở được tệp này để sửa. Tải về để mở bằng Office.',
      saveNote: 'Tệp {{from}} — Lưu sẽ ghi thành “{{name}}”.',
      lossyBanner: 'Lưu từ đây sẽ mất: {{list}}. Bản hiện tại vẫn còn trong Phiên bản.',
      lossyConfirm:
        'Tệp này có {{list}} — trình soạn không giữ được chúng, lưu là mất (bản hiện tại vẫn còn trong Phiên bản). Vẫn lưu?',
      lossyDismiss: 'Ẩn cảnh báo',
      lostBanner:
        'Lần lưu vừa rồi không giữ được: {{list}} — chỗ đó đổi cấu trúc nên Chill để nguyên bản gốc. Bản trước vẫn còn trong Phiên bản.',
      patchFallback:
        'Tệp gốc đã thay đổi từ lúc mở nên không vá được — bản lưu được dựng lại từ nội dung trong Chill.',
      lossy: {
        headerFooter: 'đầu trang/chân trang',
        footnotes: 'chú thích chân trang',
        comments: 'bình luận',
        trackChanges: 'theo dõi thay đổi',
        textBoxes: 'khung chữ',
        columns: 'bố cục nhiều cột',
        fields: 'trường và số trang',
        equations: 'công thức (giữ dạng chữ LaTeX)',
        charts: 'biểu đồ',
        objects: 'đối tượng nhúng',
        macros: 'macro',
        styles: 'định dạng trang của bản Word cũ',
        notes: 'ghi chú diễn giả',
        smartArt: 'SmartArt',
        media: 'video/âm thanh',
        animations: 'hiệu ứng và chuyển cảnh',
        shapes: 'hình vẽ',
        links: 'liên kết',
        contentControls: 'ô nhập (ngày, ô chọn…)',
        formulas: 'công thức Excel (chỉ giữ giá trị đã tính)',
      },
    },
    /** Hộp soạn bảng tính (Univer) — APM-XLE-c, docs/plan-sheet-editor.md §4. */
    sheetEditor: {
      title: 'Soạn bảng tính “{{name}}”',
      loading: 'Đang mở bảng tính…',
      openFailed: 'Không mở được bảng tính này để sửa. Tải về để mở bằng Excel.',
      save: 'Lưu',
      saving: 'Đang lưu…',
      saved: 'Đã lưu “{{name}}”.',
      saveFailed: 'Lưu không thành công: {{message}}',
      saveVersion: 'Lưu thành phiên bản khác',
      versionNote: 'Có gì thay đổi? (không bắt buộc)',
      versionSaved: 'Đã lưu thành phiên bản {{version}}.',
      close: 'Đóng',
      confirmDiscard: 'Bảng tính có thay đổi chưa lưu. Đóng và bỏ các thay đổi?',
      xlsNote: 'Tệp .xls — Lưu sẽ ghi thành “{{name}}”.',
      lossyBannerRebuild:
        'Bạn đã chèn/xoá/di chuyển dòng, cột hay đổi sheet nên lần Lưu này dựng lại tệp và sẽ mất: {{list}}. Bản hiện tại vẫn còn trong Phiên bản.',
      lossyConfirmRebuild:
        'Bạn đã chèn/xoá/di chuyển dòng, cột hay đổi sheet nên lưu là dựng lại tệp và mất {{list}} (bản hiện tại vẫn còn trong Phiên bản). Vẫn lưu?',
      lossyBanner: 'Lưu từ đây sẽ mất: {{list}}. Bản hiện tại vẫn còn trong Phiên bản.',
      lossyConfirm:
        'Bảng tính này có {{list}} — trình soạn không giữ được chúng, lưu là mất (bản hiện tại vẫn còn trong Phiên bản). Vẫn lưu?',
      lossyDismiss: 'Ẩn cảnh báo',
      lossy: {
        charts: 'biểu đồ',
        pivot: 'pivot table',
        macros: 'macro',
        images: 'ảnh/hình vẽ',
        conditionalFormatting: 'định dạng có điều kiện',
        dataValidation: 'kiểm tra dữ liệu',
        comments: 'ghi chú ô',
        hyperlinks: 'liên kết trong ô',
        richText: 'định dạng từng đoạn chữ trong ô',
        chartsheets: 'trang biểu đồ',
        brokenCharts: 'biểu đồ thiếu phần đi kèm trong tệp (không chép nguyên vẹn được)',
        lambdaFunctions: 'công thức LET/LAMBDA',
        dynamicArrays: 'mảng động (lưu thành công thức mảng cố định vùng)',
        tables: 'bảng (Format as Table)',
        printSettings: 'cài đặt in (khổ giấy, vùng in, đầu/chân trang)',
        autoFilter: 'bộ lọc',
        protection: 'bảo vệ sheet/workbook',
        externalLinks: 'liên kết tới tệp khác',
        slicers: 'slicer',
        sparklines: 'sparkline',
        threadedComments: 'bình luận dạng hội thoại',
        strictOoxml: 'định dạng Strict Open XML',
      },
    },
    preview: {
      unsupported: 'Chưa xem trước được định dạng này',
      unsupportedHelp: 'Tải về để mở bằng ứng dụng trên máy.',
      errorTitle: 'Không xem trước được',
      loading: 'Đang mở tệp…',
      /** Link riêng của popup xem trước — APM-PVLINK. */
      copyLink: 'Chép link',
      linkCopied: 'Đã chép link — ai có quyền xem tệp này mở link là thấy đúng nó.',
      copyFailed: 'Không chép tự động được — chép tay link này: {{link}}',
      linkUnavailable: 'Không tìm thấy tệp hoặc bạn không có quyền xem.',
      toolbar: {
        label: 'Công cụ xem trước',
        zoomIn: 'Phóng to',
        zoomOut: 'Thu nhỏ',
        zoomMenu: 'Mức phóng: {{percent}}',
        fit: 'Vừa khung',
        fitShort: 'Vừa · {{percent}}',
        actualSize: 'Cỡ thật (100%)',
        textLarger: 'Chữ to hơn',
        textSmaller: 'Chữ nhỏ hơn',
        textReset: 'Cỡ mặc định',
        prevPage: 'Trang trước (PageUp)',
        nextPage: 'Trang sau (PageDown)',
        goToPage: 'Tới trang',
        pageOf: '/ {{total}}',
      },
      outline: {
        toggle: 'Hiện/ẩn dàn ý',
        title: 'Dàn ý',
        slide: 'Slide {{n}}',
        resize: 'Kéo để đổi độ rộng dàn ý (bấm đúp: mặc định)',
      },
      search: {
        open: 'Tìm trong tệp (Ctrl + F)',
        placeholder: 'Tìm trong tệp',
        count: '{{current}} / {{total}}',
        none: 'Không thấy',
        searching: 'Đang tìm…',
        next: 'Kết quả sau (Enter)',
        prev: 'Kết quả trước (Shift + Enter)',
        close: 'Đóng ô tìm (Esc)',
      },
      error: {
        tooLarge: 'Tệp lớn hơn {{limit}} — quá lớn để xem ngay trên trang.',
        fetchFailed:
          'Không đọc được nội dung tệp. Nếu nút Tải về vẫn chạy, có thể kho lưu trữ chưa cho trang này đọc tệp (CORS) — báo quản trị hệ thống.',
        http: 'Kho lưu trữ trả lỗi {{status}} khi đọc tệp.',
        media:
          'Trình duyệt không hiển thị hay phát được tệp này (định dạng hoặc codec không hỗ trợ).',
        library: 'Trình xem gặp lỗi khi mở tệp này.',
        chilldocInvalid: 'Tài liệu bị hỏng — không đọc được nội dung.',
        chilldocNewer:
          'Tài liệu được tạo bởi phiên bản mới hơn của ứng dụng. Tải lại trang để cập nhật rồi mở lại.',
        browser:
          'Trình duyệt này quá cũ để xem trước PDF (cần Chrome 125, Safari hoặc iOS 18 trở lên). Tải về để mở, hoặc cập nhật trình duyệt.',
        password: 'Tệp PDF có mật khẩu — tải về để mở bằng ứng dụng trên máy.',
      },
      downloadOnly: {
        ppt: 'Định dạng PowerPoint cũ (.ppt) chưa có trình xem mã nguồn mở dùng được. Tải về để mở, hoặc lưu lại thành .pptx để xem ngay trên trang.',
      },
      pdfPage: 'Trang {{page}}/{{total}}',
      sheetTabs: 'Các trang tính',
      sheetChart: 'Biểu đồ: {{title}}',
      sheetChartUntitled: 'Biểu đồ',
      sheetChartSeries: 'Chuỗi {{n}}',
      sheetChartUnsupported:
        'Loại biểu đồ này (Excel 2016 trở lên) chưa xem trước được — tải về để mở bằng Excel.',
      sheetXlsNote:
        'Tệp .xls chỉ hiện dữ liệu, không hiện màu và định dạng — lưu lại thành .xlsx để xem đủ.',
      docNote: 'Bản xem trước .doc là gần đúng — bố cục có thể khác bản gốc.',
      truncated: 'Chỉ hiện {{shown}} dòng đầu trên tổng {{total}} dòng — tải về để xem đủ.',
      empty: 'Tệp trống.',
      htmlSource: 'Mã nguồn',
      htmlPage: 'Trang',
      htmlPageNote:
        'Trang hiện trong khung cách ly: không chạy script, không tải tài nguyên bên ngoài.',
      missingImage: 'Ảnh không còn',
      resizeTableColumn:
        'Kéo để đổi độ rộng cột {{column}} — chỉ khi xem, tệp không đổi. Mũi tên trái/phải để chỉnh, bấm đúp để về tự động.',
      gridLabel: 'Bảng dữ liệu của {{name}}',
      gridSize: '{{rows}} dòng · {{columns}} cột',
    },
    actionsFor: 'Thao tác với {{name}}',
    open: 'Mở',
    openLink: 'Mở liên kết',
    download: 'Tải về',
    openOrigin: 'Mở chỗ gốc',
    edit: 'Sửa',
    delete: 'Xoá',
    cannotDeleteDocument: 'Là một phiên bản tài liệu — quản lý ở mục Tài liệu.',
    deleteAtOrigin: 'Gỡ file này ở chỗ gốc của nó.',
    confirmDelete: 'Xoá “{{name}}”? File bị gỡ khỏi kho lưu trữ và không tải về được nữa.',
    deleted: 'Đã xoá file.',
    empty: 'Chưa có file nào ở đây',
    emptyHelp: 'File bạn tải lên ở chỗ này sẽ hiện ra đây.',
    emptyHelpUpload: 'Bấm Tải lên hoặc kéo thả file vào đây — nhận mọi định dạng.',
    noMatch: 'Không có file nào khớp',
    noMatchHelp: 'Thử bỏ bớt bộ lọc hoặc đổi từ khoá.',
    uploadQueue: 'Tiến độ tải lên',
    uploading: 'Đang tải lên {{done}}/{{total}} file…',
    uploadFinished: 'Đã tải lên xong',
    uploadFailed: 'Lỗi',
  },
  orgStorage: {
    title: 'Dung lượng tổ chức',
    subtitle: 'Tổ chức đang dùng bao nhiêu trên hạn mức lưu file, theo từng dự án.',
    ofQuota: 'trên hạn mức {{quota}}',
    help: 'Tính cả lượt tải lên đang dở. Hết hạn mức thì không tải thêm file được — xoá bớt ở trang Files của dự án, hoặc nhờ quản trị hệ thống nâng hạn mức.',
    project: 'Dự án',
    used: 'Đã dùng',
    org: 'Tổ chức',
    quotaTitle: 'Hạn mức dung lượng theo tổ chức',
    quotaSubtitle: 'Đặt mỗi tổ chức được lưu bao nhiêu file. Mặc định 1 GB.',
    quotaHelp:
      'Gần đầy nhất đứng đầu. Hạ hạn mức xuống dưới mức đang dùng không xoá file nào — chỉ chặn tải lên cho tới khi tổ chức dọn bớt.',
    quotaGb: 'Hạn mức (GB)',
    quotaFor: 'Hạn mức của {{name}}, tính bằng GB',
    quotaSaved: 'Đã lưu hạn mức.',
  },
  users: {
    title: 'Người dùng',
    lineManager: 'Quản lý trực tiếp',
    department: 'Phòng ban',
    projects: 'Dự án',
    status: 'Trạng thái',
    /**
     * Tên tiếng Việt của vai trò tổ chức — APM-ORG-a.
     *
     * Trước đó màn hình quản trị hiện thẳng giá trị enum (`ORG_ADMIN`,
     * `MEMBER`). Người gán vai trò là quản trị viên nhân sự, không phải người
     * đọc mã nguồn, và `SCREAMING_SNAKE_CASE` không nói cho họ biết vai nào
     * cao hơn vai nào.
     */
    orgRole: {
      SUPER_ADMIN: 'Quản trị hệ thống',
      ORG_ADMIN: 'Quản trị tổ chức',
      DIRECTOR: 'Giám đốc',
      LEADER: 'Trưởng nhóm',
      EMPLOYEE: 'Nhân viên',
      // Not positions: the shell labels these sessions too (APM-PSPACE-g).
      GUEST: 'Cộng tác viên ngoài',
      CLIENT: 'Khách hàng',
    },
    subtitle: 'Mời người mới, gán vai trò và quản lý trực tiếp, khai kỹ năng.',
    invite: 'Mời',
    invited: 'Đã tạo tài khoản và link đặt mật khẩu.',
    updated: 'Đã cập nhật.',
    displayName: 'Tên hiển thị',
    unsaved: 'Có thay đổi chưa lưu',
    role: 'Vai trò',
    noManager: '— không có quản lý —',
    active: 'Đang hoạt động',
    disabled: 'Đã khoá',
    activeHint: 'Vào tổ chức này và làm việc bình thường.',
    disabledHint:
      'Không vào được tổ chức này cho tới khi được mở khoá. Các tổ chức khác người này tham gia không bị ảnh hưởng.',
    lock: 'Khoá truy cập ngay…',
    unlock: 'Mở khoá',
    lockConfirmAction: 'Khoá',
    lockConfirm:
      'Khoá {{name}} trong tổ chức này? Người này bị đăng xuất khỏi tổ chức ngay và không vào lại được cho tới khi được mở khoá. Các tổ chức khác người này tham gia không bị ảnh hưởng.',
    unlockConfirm: 'Mở khoá {{name}}? Người này vào lại tổ chức được ngay.',
    locked: 'Đã khoá {{name}}.',
    unlocked: 'Đã mở khoá {{name}}.',
    skills: 'Kỹ năng',
    addSkill: '+ Thêm kỹ năng',
    removeSkill: 'Bấm để gỡ',
    googleLinkHelp:
      'Đã thêm. Gửi link đăng nhập này cho người được mời và dặn họ đăng nhập bằng Google với đúng email vừa nhập.',
    linkHelp:
      'Chuyển link này cho người được mời. Link dùng một lần và hết hạn sau 1 giờ. (Module gửi email sẽ thay chỗ này.)',
    level: { learning: 'đang học', proficient: 'thành thạo', expert: 'chuyên sâu' },
  },
  department: {
    title: 'Danh mục phòng ban',
    subtitle:
      'Dùng chung cho cả tổ chức. Là danh mục chứ không phải ô chữ tự do, để bộ lọc theo phòng ban không âm thầm sót người.',
    label: 'Phòng ban',
    none: '— chưa có phòng ban —',
    add: 'Thêm',
    placeholder: 'Kỹ thuật, Kinh doanh, Vận hành…',
    enable: 'bật',
    disable: 'tắt',
    empty: 'Chưa có phòng ban nào.',
    help: 'Tắt thay vì xoá: người đã rời phòng vẫn phải tra ngược được họ từng ở đâu.',
  },
  techStack: {
    title: 'Danh mục kỹ năng',
    subtitle:
      'Dùng chung cho cả tổ chức. Velocity được đo theo từng kỹ năng nên tên phải thống nhất.',
    add: 'Thêm',
    placeholder: 'Node.js, Go, React…',
    enable: 'bật',
    disable: 'tắt',
    help: 'Tắt thay vì xoá: kỹ năng đã khai và lịch sử velocity vẫn phải tra ngược được.',
  },
  taskTypeCatalog: {
    proposed: 'Đã gửi đề xuất. Quản trị tổ chức đã được báo — duyệt xong loại việc sẽ dùng được.',
    alreadyPending: 'Loại “{{name}}” đã có người đề xuất và đang chờ quản trị duyệt.',
    proposeTitle: 'Đề xuất loại việc mới',
    proposeHelp:
      'Loại mới vào danh mục chung của tổ chức và chỉ dùng được sau khi quản trị tổ chức duyệt.',
    propose: 'Gửi đề xuất',
    statusPending: 'Chờ quản trị duyệt',
    statusRejected: 'Bị từ chối: {{note}}',
    pendingTitle_one: '{{count}} đề xuất chờ duyệt',
    pendingTitle_other: '{{count}} đề xuất chờ duyệt',
    proposedBy: '{{name}} đề xuất · {{project}}',
    noProject: 'lúc tạo dự án',
    approve: 'Duyệt',
    reject: 'Từ chối',
    rejectReason: 'Lý do từ chối',
    approved: 'Đã duyệt loại việc.',
    rejected: 'Đã từ chối đề xuất.',
    pendingBadge_one: '{{count}} yêu cầu chờ duyệt',
    pendingBadge_other: '{{count}} yêu cầu chờ duyệt',
    colorN: 'Màu {{n}}',
    colorLabel: 'Màu nền',
    colorFor: 'Màu nền của {{name}}',
    changeColor: 'Đổi màu',
    usedOrgType:
      'Tổ chức đã có loại “{{name}}” — đã bật loại chung thay vì tạo bản sao. Bấm Lưu để giữ.',
    title: 'Danh mục loại việc',
    subtitle:
      'Dùng chung cho cả tổ chức. Mỗi dự án chọn tập loại mình dùng từ đây, và velocity được đo theo từng loại.',
    add: 'Thêm',
    placeholder: 'Backend, Kiểm thử, Thiết kế…',
    rename: 'Tên loại việc {{name}}',
    taskCount_one: '{{count}} việc',
    taskCount_other: '{{count}} việc',
    inactive: 'đã tắt',
    enable: 'Bật',
    disable: 'Tắt',
    adminHelp:
      'Đổi tên giữ nguyên mọi việc cũ và số liệu velocity. Tắt thay vì xoá: loại đã tắt không hiện ở dự án mới, còn việc cũ vẫn giữ loại của nó.',
    emptyCatalog: 'Tổ chức chưa có loại việc nào. Quản trị tổ chức thêm ở trang Quản trị.',
    projectTitle: 'Loại việc',
    projectSubtitle: 'Chọn loại việc dự án này dùng khi tạo và phân loại công việc.',
    projectHelp:
      'Danh mục do tổ chức quản lý — muốn thêm hay đổi tên loại việc thì nhờ quản trị tổ chức.',
    removeWarning_one:
      'Bỏ {{count}} loại khỏi dự án: việc đã có vẫn giữ loại cũ, chỉ việc mới không chọn được nữa.',
    removeWarning_other:
      'Bỏ {{count}} loại khỏi dự án: việc đã có vẫn giữ loại cũ, chỉ việc mới không chọn được nữa.',
    needOne: 'Chọn ít nhất một loại việc.',
    createLabel: 'Loại việc',
    createHelp:
      'Mặc định dùng mọi loại của tổ chức. Bấm vào một loại để bỏ nó ra; sửa lại được ở Cấu hình dự án.',
    // Không gian cá nhân — APM-PSPACE-o: chủ tự thêm/sửa, không ai duyệt.
    personalAddTitle: 'Thêm loại việc',
    personalAddHelp: 'Dùng được ngay — không cần ai duyệt.',
    personalAdd: 'Thêm',
    personalAdded: 'Đã thêm loại “{{name}}” — dùng được ngay.',
    personalProjectHelp:
      'Danh mục của riêng bạn: thêm loại mới ở dưới, đổi tên, đổi màu hoặc tắt ngay trong danh sách.',
    personalManageTitle: 'Danh mục loại việc của bạn',
  },
  matrix: {
    title: 'Ma trận phân quyền',
    subtitle:
      'Sinh từ chính bảng tra mà hệ thống dùng để chặn — không phải bản chép tay từ tài liệu.',
    permission: 'Quyền',
    legend: {
      yes: 'có quyền',
      no: 'không',
      project_member: 'chỉ trong project mình tham gia',
      own: 'chỉ với mục của chính mình',
      direct_report: 'chỉ với nhân sự mình quản lý trực tiếp',
      report_chain: 'với toàn bộ nhánh dưới mình, nhiều cấp',
    },
  },
  audit: {
    title: 'Nhật ký hoạt động',
    subtitle: 'Mọi thay đổi trong tổ chức, kèm người gây ra và thời điểm.',
    when: 'Thời điểm',
    event: 'Sự kiện',
    actor: 'Người thực hiện',
    aggregate: 'Đối tượng',
    filterPlaceholder: 'Lọc theo loại sự kiện, vd task.status_changed',
    loadMore: 'Tải thêm',
    empty: 'Chưa có hoạt động nào',
    archivedNotice: '{{count}} tháng cũ đã chuyển sang lưu trữ S3 và không nằm trong danh sách này',
    sensitiveTitle: 'Truy cập dữ liệu hiệu suất',
    sensitiveSubtitle: 'Ai đã xem hồ sơ hiệu suất của ai. Ghi lại mọi lần đọc, không ngoại lệ.',
    viewed: 'đã xem hồ sơ của',
    noSensitive: 'Chưa có lượt truy cập nào',
    noSensitiveHelp: 'Mọi lần đọc dữ liệu hiệu suất cá nhân sẽ xuất hiện ở đây.',
  },
  // APM-ORGINT-e — nút sao chép trong các bước hướng dẫn (`NumberedSteps`).
  setupSteps: {
    copy: 'Sao chép',
    copied: 'Đã sao chép.',
    copyFailed: 'Không sao chép được — hãy chọn và chép tay.',
  },
  // APM-ORGINT-e — công tắc "Cho phép địa chỉ nội bộ" theo tổ chức (super admin), plan-org-integrations §5.4.
  orgNetwork: {
    title: 'Địa chỉ nội bộ theo tổ chức',
    subtitle:
      'Cho tổ chức nào được nối nguồn đồng bộ / máy chủ git đặt trong mạng nội bộ (GitLab, Redmine của công ty).',
    intro:
      'Admin tổ chức tự khai địa chỉ nguồn đồng bộ và máy chủ git. Mặc định ChillPM từ chối gọi tới địa chỉ nội bộ (như 10.x, 192.168.x, localhost). Tổ chức có GitLab / Redmine trong mạng công ty thì bật riêng cho tổ chức ấy ở đây.',
    risk:
      'Bật nghĩa là admin của tổ chức ấy khiến được máy chủ ChillPM gọi vào mạng nội bộ nơi nó đang chạy. Chỉ bật cho tổ chức bạn tin, và tắt khi không còn cần.',
    resume:
      'Kết nối đồng bộ / kho git đã dừng vì bị chặn **không tự chạy lại** sau khi bật: PM cần bấm "Đồng bộ ngay" (hoặc chạy tay) ở kết nối ấy.',
    search: 'Tìm tổ chức',
    empty: 'Không có tổ chức nào khớp.',
    demo: 'Demo',
    personal: 'Không gian cá nhân',
    usage: '{{providers}} nguồn đồng bộ · {{hosts}} máy chủ git',
    switchFor: 'Cho phép địa chỉ nội bộ cho {{name}}',
    on: 'Cho phép địa chỉ nội bộ',
    off: 'Chặn địa chỉ nội bộ',
    confirmOn:
      'Cho phép "{{name}}" nối tới địa chỉ nội bộ? Admin của tổ chức này sẽ khiến được máy chủ ChillPM gọi vào mạng nội bộ — chỉ bật khi bạn tin họ.',
    confirmOnDemo:
      '"{{name}}" là tổ chức demo — ai cũng đăng nhập được mà không cần mật khẩu. Bật ở đây là mở cho bất kỳ ai đường dò mạng nội bộ của máy chủ. Vẫn bật?',
    confirmOnButton: 'Cho phép',
    turnedOn:
      'Đã cho phép địa chỉ nội bộ cho {{name}}. Kết nối đã dừng vì bị chặn cần PM bấm "Đồng bộ ngay" để chạy lại.',
    turnedOff: 'Đã chặn địa chỉ nội bộ cho {{name}} — nguồn / máy chủ nội bộ của tổ chức này dừng gọi được.',
  },
  adminNav: {
    back: 'Tất cả mục quản trị',
    group: {
      setup: 'Cài đặt hệ thống',
      people: 'Người dùng và phân quyền',
      org: 'Tổ chức và lịch',
      catalog: 'Danh mục dùng chung',
      cost: 'Chi phí và AI',
      monitor: 'Theo dõi và kiểm toán',
    },
  },
  health: {
    stalled: 'Job treo',
    title: 'Sức khoẻ hệ thống',
    subtitle: 'Trang chẩn đoán. Khác /readyz — trang này kiểm cả S3 và key AI.',
    database: 'CSDL',
    storage: 'Lưu trữ',
    ai: 'AI',
    version: 'Phiên bản',
    environment: 'Môi trường',
    uptime: 'Thời gian chạy',
    minutes: 'phút',
    jobQueue: 'Hàng đợi job',
    pending: 'chờ',
    running: 'đang chạy',
    failed: 'lỗi',
    dead: 'hết lượt thử',
    staleJobs: 'Job chờ đã {{minutes}} phút — worker có thể đã chết',
    eventLog: 'Event log',
    state: { configured: 'đã cấu hình', not_configured: 'chưa cấu hình' },
  },
  todos: {
    quickEdit: {
      priority: 'Mức độ: {{value}} — bấm để đổi',
      date: 'Đổi ngày của “{{title}}”',
      startTab: 'Ngày làm',
      dueTab: 'Hạn',
      clearDue: 'Bỏ hạn',
      noDueForRepeat: 'To-do lặp lại không có hạn — chỉ đổi được ngày làm.',
    },
    quick: {
      title: 'To-do cần làm',
      undo: 'Hoàn tác',
      undoLabel: 'Hoàn tác — chưa xong: {{title}}',
    },
    subtitle: 'Việc riêng của bạn, không thuộc dự án nào — chỉ bạn nhìn thấy.',
    create: 'Tạo to-do',
    listLabel: 'Danh sách to-do',
    group: { now: 'Đang cần làm', later: 'Chưa cần làm', done: 'Đã xong' },
    empty: {
      now: 'Không có việc nào cần làm lúc này.',
      later: 'Chưa có việc nào xếp cho những ngày tới.',
      done: 'Chưa xong việc nào.',
    },
    doneTruncated: 'Đang hiện {{shown}} / {{total}} việc đã xong gần nhất.',
    complete: 'Đánh dấu xong: {{title}}',
    reopen: 'Bỏ đánh dấu xong: {{title}}',
    drag: 'Kéo để sắp xếp: {{title}}',
    open: 'Mở: {{title}}',
    attachments: 'Có {{count}} file đính kèm',
    dueTitle: 'Hạn hoàn thành: {{value}}',
    overdue: 'Quá hạn',
    starts: 'Bắt đầu {{value}}',
    priorityTitle: 'Mức độ quan trọng: {{value}}',
    repeat: {
      daily: 'Lặp hằng ngày',
      dailyEvery: 'Lặp mỗi {{count}} ngày',
      weekly: 'Lặp hằng tuần vào {{days}}',
      weeklyEvery: 'Lặp mỗi {{count}} tuần vào {{days}}',
      monthly: 'Lặp hằng tháng',
      monthlyEvery: 'Lặp mỗi {{count}} tháng',
      yearly: 'Lặp hằng năm',
      yearlyEvery: 'Lặp mỗi {{count}} năm',
    },
    weekday: { 0: 'CN', 1: 'T2', 2: 'T3', 3: 'T4', 4: 'T5', 5: 'T6', 6: 'T7' },
    form: {
      createTitle: 'Tạo to-do',
      editTitle: 'Sửa to-do',
      title: 'Tiêu đề',
      titlePlaceholder: 'Việc cần làm…',
      description: 'Mô tả',
      descriptionPlaceholder: 'Ghi chú, đường link, danh sách việc nhỏ…',
      attachments: 'File đính kèm',
      upload: 'Đính kèm file',
      uploading: 'Đang tải lên {{count}} file…',
      uploadError: 'Không tải lên được {{name}}: {{message}}',
      download: 'Tải về {{name}}',
      removeFile: 'Gỡ {{name}}',
      priority: 'Mức độ quan trọng',
      startDate: 'Ngày làm',
      withTime: 'Chi tiết đến giờ',
      startTime: 'Giờ làm',
      hasDue: 'Ngày phải hoàn thành',
      dueDate: 'Ngày hoàn thành',
      dueTime: 'Giờ hoàn thành',
      repeat: 'Lặp lại',
      dueBlocked: 'Việc lặp lại không có hạn — bỏ tích Lặp lại để đặt hạn.',
      repeatBlocked:
        'Việc có hạn hoàn thành thì không lặp — bỏ tích Ngày phải hoàn thành để đặt lặp.',
      freqLabel: 'Tần suất',
      freq: { daily: 'Hằng ngày', weekly: 'Hằng tuần', monthly: 'Hằng tháng', yearly: 'Hằng năm' },
      every: 'Mỗi',
      unit: { daily: 'ngày', weekly: 'tuần', monthly: 'tháng', yearly: 'năm' },
      weekdays: 'Vào các thứ',
      preview: 'Ba lần tới: {{dates}}',
      save: 'Lưu',
      delete: 'Xoá',
      confirmDelete: 'Xoá to-do "{{title}}"?',
    },
    saveError: 'Không lưu được: {{message}}',
  },
  myTasks: {
    moreProjects: '+{{count}} dự án nữa',
    taskCount: '{{count}} việc',
    dayOff: {
      off_shift: 'Ngày nghỉ',
      holiday: 'Nghỉ lễ',
      absence: 'Nghỉ phép',
      left: 'Đã nghỉ việc',
    },
    subtitle: 'Việc được giao cho bạn, gom từ mọi dự án bạn tham gia.',
    viewSwitch: 'Đổi cách xem',
    view: { list: 'Danh sách', calendar: 'Lịch' },
    filter: {
      status: 'Trạng thái',
      /** Nhóm trạng thái khác `done` — APM-MYT-e. Đứng trong nhóm Trạng thái. */
      open: 'Chưa xong',
      priority: 'Độ ưu tiên',
      overdue: 'Quá hạn',
      sort: 'Sắp xếp',
      /** Nút mở nhóm Trạng thái / Độ ưu tiên trên điện thoại. */
      toggle: 'Bộ lọc',
    },
    sort: {
      focus: 'Đang làm & sắp làm',
      dueDate: 'Theo hạn chót',
      priority: 'Theo độ ưu tiên',
      project: 'Theo dự án',
      updatedAt: 'Mới cập nhật',
      assignee: 'Theo người',
    },
    blocked: 'Bị chặn',
    noDueDate: 'Chưa đặt hạn',
    /** Nhóm Lỗi — APM-TEST2-e, plan-testing-v2 §3.5. Mức độ dùng `testing.severity`. */
    bugs: {
      title: 'Lỗi',
      group: {
        fix: 'Lỗi cần sửa ({{count}})',
        reopened: 'Lỗi bị trả lại ({{count}})',
        verify: 'Chờ tôi kiểm lại ({{count}})',
      },
      due: 'hạn {{date}}',
      reopenedTimes: 'Bị trả lại · lần {{count}}',
      markFixed: 'Đã sửa xong',
      pass: '✓ Hết lỗi',
      fail: '✗ Vẫn lỗi',
      failReason: 'Vẫn thấy lỗi gì',
      failPlaceholder: 'Vẫn thấy gì — người sửa cần biết lần này khác lần trước ở đâu',
      sendBack: 'Trả lại',
      fixedToast: 'Đã báo sửa xong — chờ người báo lỗi kiểm lại.',
      passedToast: 'Đã đóng lỗi.',
      failedToast: 'Đã trả lại cho người sửa.',
      openHint: 'Mở lỗi ở tab Kiểm thử của dự án',
      loadError: 'Không tải được danh sách lỗi.',
    },
    progressOnlyInProgress:
      'Đang ở {{value}}%. Chuyển sang "Đang làm" để sửa tay — "Sẵn sàng" và "Xong" đổi tiến độ bằng cách chuyển cột.',
    emptyTitle: 'Chưa có việc nào',
    emptyHelp: 'Bạn chưa được giao việc nào khớp bộ lọc hiện tại.',
    unitSwitch: 'Chọn cách xem lịch',
    unit: { week: 'Tuần', month: 'Tháng' },
    prevPeriod: 'Kỳ trước',
    nextPeriod: 'Kỳ sau',
    today: 'Hôm nay',
    moreItems: '+{{count}} nữa',
    team: {
      tabsLabel: 'Xem việc của ai',
      tab: { me: 'Việc của tôi', todo: 'To-do', team: 'Việc đội của tôi' },
      subtitle:
        'Việc được giao cho cấp dưới trực tiếp của bạn, gom từ mọi dự án — kể cả dự án bạn không tham gia.',
      filter: { member: 'Người', project: 'Dự án', all: 'Tất cả' },
      audited:
        'Mỗi lần mở danh sách này đều được ghi vào nhật ký truy cập của từng người trong đó.',
      truncated: 'Chỉ hiện {{count}} việc đầu tiên. Chọn một người hoặc một dự án để xem đủ.',
      emptyTitle: 'Không có việc nào',
      emptyHelp: 'Không có việc nào của đội khớp bộ lọc hiện tại.',
      calendar: {
        off: '(nghỉ)',
        allOff: 'Cả đội nghỉ',
        moreMembers: '+{{count}} người nữa',
        hint: 'Chỉ đếm việc chưa xong. Bấm một nhãn để mở danh sách việc của người đó ở dự án đó.',
        audited:
          'Mỗi lần mở lịch này đều được ghi vào nhật ký truy cập của từng người có việc trong đó.',
        truncated:
          'Đội có hơn {{count}} việc trong kỳ này nên các con số có thể thiếu. Xem theo tuần để đủ.',
      },
      detail: {
        project: 'Dự án',
        status: 'Trạng thái',
        progress: 'Tiến độ',
        readOnlyNote:
          'Chỉ đọc: bạn không có quyền sửa việc ở dự án này, nên không đổi được tiến độ và không bình luận được.',
      },
    },
  },
  workflow: { todo: 'Chưa bắt đầu', in_progress: 'Đang làm', done: 'Xong' },
  priority: { urgent: 'Khẩn cấp', high: 'Cao', medium: 'Trung bình', low: 'Thấp' },
  calendar: {
    placeholder: 'dd/mm/yyyy',
    open: 'Mở lịch',
    clear: 'Xoá ngày',
    today: 'Hôm nay',
    openTime: 'Mở danh sách giờ',
    prevMonth: 'Tháng trước',
    nextMonth: 'Tháng sau',
    now: 'Bây giờ',
    weekday: { 0: 'CN', 1: 'T2', 2: 'T3', 3: 'T4', 4: 'T5', 5: 'T6', 6: 'T7' },
  },
  privacy: {
    title: 'Ai đã xem hồ sơ hiệu suất của tôi',
    subtitle:
      'Dữ liệu hiệu suất cá nhân được dùng để đánh giá con người, nên mọi lần đọc đều được ghi lại và bạn có quyền xem danh sách đó.',
    emptyTitle: 'Chưa ai xem hồ sơ của bạn',
    emptyHelp: 'Khi có người mở dữ liệu hiệu suất của bạn, lần đọc đó sẽ hiện ở đây.',
    unknownViewer: 'Không xác định',
    column: { viewer: 'Người xem', scope: 'Phạm vi', reason: 'Lý do', when: 'Thời điểm' },
  },
  coordination: {
    matrixTitle: 'Ma trận người – công việc',
    matrixHelp: 'Ai đang gánh gì trong dự án này. Ô đậm hơn = nhiều việc hơn.',
    workloadTitle: 'Tải công việc theo thời gian',
    workloadHelp:
      'Cộng dồn qua mọi dự án, kể cả dự án bạn không tham gia — nên chỉ hiện con số, không hiện tên việc.',
    workloadRestricted: 'Cần quyền phân công',
    workloadRestrictedHelp: 'Chỉ PM và quản lý trực tiếp xem được tải xuyên dự án của thành viên.',
    crossProjectNote:
      'Vạch đứt là năng lực mỗi ngày. Cột đỏ là ngày đã cam kết vượt năng lực, tính cả việc ở dự án khác.',
    person: 'Thành viên',
    total: 'Tổng',
    unassigned: 'Chưa giao ai',
    hoursShort: '({{hours}}h)',
    committedTotal: 'Đã cam kết {{hours}} giờ',
    overloadedDays: '{{count}} ngày quá tải',
    dayTooltip: '{{date}}: {{committed}}/{{capacity}} giờ',
    cellTooltip: '{{count}} việc · {{hours}} giờ ước lượng',
    noMembers: 'Dự án chưa có thành viên',
    noMembersHelp: 'Thêm thành viên vào dự án để xem phân bổ công việc.',
    // APM-ROLE-r3.
    invite: 'Mời thành viên',
    activityRestricted: 'Chỉ người làm việc trong dự án xem được',
    activityRestrictedHelp:
      'Mức độ cập nhật của đội hiện cho PM và thành viên dự án, không cho vai Chỉ xem.',
  },
  collaboration: {
    detailTabs: 'Xem chi tiết',
    tab: { comments: 'Bình luận', activity: 'Lịch sử', attachments: 'Tệp đính kèm' },
    commentPlaceholder: 'Viết bình luận… gõ @ để nhắc tên ai đó',
    mentionSuggestions: 'Gợi ý người để nhắc',
    send: 'Gửi',
    sendHint: 'Ctrl/⌘ + Enter để gửi',
    edited: 'đã chỉnh sửa',
    deleteComment: 'Xoá bình luận',
    unknownAuthor: 'Không rõ',
    syncedFrom: 'từ {{source}}',
    syncedFromTitle: 'Bình luận đồng bộ từ {{source}} — tên hiển thị là người viết bên đó',
    noComments: 'Chưa có bình luận nào',
    noCommentsHelp: 'Hãy là người đầu tiên trao đổi về công việc này.',
    noActivity: 'Chưa có thay đổi nào',
    moreActivity: 'Còn thêm thay đổi cũ hơn không hiển thị ở đây.',
    noAttachments: 'Chưa có tệp nào',
    noAttachmentsHelp: 'Tệp đính kèm của công việc này sẽ hiện ở đây.',
    download: 'Tải xuống',
    removeAttachment: 'Gỡ tệp khỏi công việc',
    addAttachment: 'Đính kèm tệp',
    uploading: 'Đang tải lên…',
    actor: { user: 'Người dùng', ai: 'AI', system: 'Hệ thống' },
    // Dòng lịch sử đến từ một lượt đồng bộ — APM-SYNC-h (plan-project-sync §5.6).
    syncActor: 'Đồng bộ từ {{source}}',
    // Dòng lịch sử do luật tự đổi trạng thái của tab Git gây ra — APM-GIT-h.
    gitActor: 'Git',
  },
  period: {
    label: 'Kỳ:',
    previous: 'Kỳ trước',
    next: 'Kỳ sau',
    kind: { month: 'Tháng', quarter: 'Quý', year: 'Năm' },
    monthLabel: 'Tháng {{month}}/{{year}}',
    quarterLabel: 'Quý {{quarter}}/{{year}}',
    yearLabel: 'Năm {{year}}',
    hint: 'Dự án bảo trì chạy liên tục nên xem theo kỳ. Việc có thời gian **giao** với kỳ thì hiện ở kỳ đó — một việc kéo qua hai kỳ sẽ hiện ở cả hai.',
  },
  activity: {
    'task.created': 'đã tạo công việc',
    'task.checklist_updated': 'đã cập nhật checklist công việc',
    'task.updated': 'đã sửa nội dung',
    'task.status_changed': 'đã đổi trạng thái',
    'task.assigned': 'đã đổi người phụ trách',
    'task.dates_changed': 'đã đổi thời gian',
    'task.progress_updated': 'đã cập nhật tiến độ',
    'task.estimate_changed': 'đã đổi ước lượng',
    'task.story_points_changed': 'đã đổi story point',
    'task.priority_changed': 'đã đổi độ ưu tiên',
    'task.blocked': 'đã đánh dấu bị chặn',
    'task.unblocked': 'đã bỏ đánh dấu bị chặn',
    'task.deleted': 'đã xoá công việc',
    'task.restored': 'đã khôi phục công việc',
    'task.kind_changed': 'đã đổi loại mốc',
    'task.attachment_added': 'đã đính kèm tệp',
    'task.attachment_removed': 'đã gỡ tệp đính kèm',
    'comment.created': 'đã bình luận',
    'comment.updated': 'đã sửa bình luận',
    'comment.deleted': 'đã xoá bình luận',
    // Lịch sử của **cả dự án** trộn nhiều aggregate — APM-CHANGE-a. Thiếu nhãn
    // thì `t()` rơi về tên event thô (`sprint.started`), đọc được nhưng lạc lõng
    // giữa những dòng tiếng Việt.
    'task.group_changed': 'đã chuyển nhóm công việc',
    'task.reordered': 'đã xếp lại thứ tự công việc',
    'dependency.added': 'đã nối phụ thuộc',
    'dependency.removed': 'đã bỏ phụ thuộc',
    'task_group.created': 'đã tạo nhóm công việc',
    'task_group.renamed': 'đã đổi tên nhóm công việc',
    'task_group.deleted': 'đã xoá nhóm công việc',
    'sprint.created': 'đã tạo sprint',
    'sprint.started': 'đã bắt đầu sprint',
    'sprint.closed': 'đã đóng sprint',
    'sprint.updated': 'đã sửa sprint',
    'project.created': 'đã tạo dự án',
    'project.updated': 'đã sửa dự án',
    'project.methodology_changed': 'đã đổi loại dự án',
    'project.baseline_set': 'đã chốt kế hoạch gốc',
    'project.tab_layout_changed': 'đã sắp lại thanh tab',
    'project_sync.connected': 'đã nối dự án với nguồn đồng bộ',
    'project_sync.configured': 'đã đổi cách đồng bộ',
    'project_sync.mapping_changed': 'đã sửa ghép với nguồn đồng bộ',
    'project_sync.key_rotated': 'đã đổi API key của nguồn đồng bộ',
    'project_sync.paused': 'đã tạm dừng đồng bộ',
    'project_sync.resumed': 'đã chạy lại đồng bộ',
    'project_sync.disconnected': 'đã ngắt nguồn đồng bộ',
    'project_sync.released': 'đã giải phóng dự án ngoài khỏi nguồn đồng bộ',
    // Tab Git — APM-GIT-d (docs/plan-git-integration.md §4.1).
    'git_connection.created': 'đã tạo kết nối tới máy chủ git',
    'git_connection.token_rotated': 'đã đổi token của kết nối git',
    'git_connection.revoked': 'đã thu hồi kết nối git',
    'git_connection.status_changed': 'đã đổi trạng thái kết nối git',
    'git_connection.access_changed': 'đã cập nhật quyền ghi của kết nối git',
    'git_repository.linked': 'đã gắn kho git vào dự án',
    'git_repository.settings_changed': 'đã đổi cấu hình kho git',
    'git_repository.unlinked': 'đã gỡ kho git khỏi dự án',
    'git_repository.webhook_changed': 'đã đổi chế độ webhook của kho git',
    // Gắn cả nhóm kho — APM-GIT-s.
    'git_repository_group.linked': 'đã gắn một nhóm kho git vào dự án',
    'git_repository_group.unlinked': 'đã gỡ một nhóm kho git khỏi dự án',
    'git_repository_group.repository_skipped': 'đã bỏ qua một kho gợi ý của nhóm kho git',
    'git_repository_group.repository_unskipped': 'đã bỏ dấu "bỏ qua" một kho của nhóm kho git',
    'git_settings.changed': 'đã đổi cấu hình tab Git (định dạng tên nhánh, luật)',
    'task.git_link_added': 'đã gắn tay một liên kết git',
    'task.git_link_hidden': 'đã ẩn một liên kết git',
    'task.git_link_override_removed': 'đã bỏ một lần gắn / ẩn liên kết git',
    'issue.git_link_added': 'đã gắn tay một liên kết git',
    'issue.git_link_hidden': 'đã ẩn một liên kết git',
    'issue.git_link_override_removed': 'đã bỏ một lần gắn / ẩn liên kết git',
    'task.git_branch_created': 'đã tạo nhánh git từ việc này',
    'task.git_change_request_created': 'đã tạo merge request từ việc này',
    'issue.git_branch_created': 'đã tạo nhánh git từ issue này',
    'issue.git_change_request_created': 'đã tạo merge request từ issue này',
    'task.progress_commits_reported': 'đã báo commit cho một lần cập nhật tiến độ',
    'task.progress_commit_removed': 'đã gỡ một commit khỏi lần báo tiến độ',
    'task.progress_review_completed': 'AI đã rà commit của một lần báo tiến độ',
    'task.progress_review_acknowledged': 'đã xem kết quả AI rà commit',
    'task.progress_review_requeued': 'đã yêu cầu AI rà lại commit',
    'git_release_note.suggested': 'đã đưa gợi ý AI cho ghi chú phát hành vào để duyệt',
    'git_release_note.approved': 'đã duyệt ghi chú phát hành',
    'git_release_note.edited': 'đã viết / sửa ghi chú phát hành',
    // Đổi trạng thái do luật git — APM-GIT-h (plan-git-integration §6.2). Đọc liền
    // sau chữ "Git": "Git chuyển sang Xong — MR !45 «Sửa đăng nhập» đã merge vào main".
    // `{{ref}}` là "MR !45" / "PR #45" — ký hiệu của máy chủ git, không dịch.
    gitRule: {
      moved: 'chuyển sang {{status}} — {{reason}}',
      cr_merged: '{{ref}} «{{title}}» đã merge vào {{branch}}',
      cr_opened: '{{ref}} «{{title}}» đã mở',
      cr_approved: '{{ref}} «{{title}}» đã được duyệt',
      deployed: '{{ref}} «{{title}}» đã lên production',
      work_started_branch: 'nhánh {{branch}} vừa được đẩy lên',
      work_started_commit: 'commit {{sha}} là commit đầu tiên của việc này',
      work_started_change_request: '{{ref}} «{{title}}» vừa được gắn với việc này',
    },
    'workflow_status.created': 'đã thêm cột',
    'workflow_status.updated': 'đã sửa cột',
    'workflow_status.deleted': 'đã xoá cột',
    'membership.added': 'đã thêm thành viên',
    'membership.removed': 'đã gỡ thành viên',
    'membership.role_changed': 'đã đổi vai trò thành viên',
    'document.created': 'đã tạo tài liệu',
    'document.status_changed': 'đã đổi trạng thái tài liệu',
    'document.updated': 'đã sửa tài liệu',
    'document.version_added': 'đã thêm phiên bản tài liệu',
    'document.deleted': 'đã xoá tài liệu',
    'document.restored': 'đã khôi phục tài liệu',
    'raid.created': 'đã ghi một mục RAID',
    'raid.updated': 'đã sửa một mục RAID',
    'objective.created': 'đã tạo mục tiêu',
    'key_result.created': 'đã tạo kết quả then chốt',
    'key_result.value_updated': 'đã cập nhật kết quả then chốt',
    // Sổ chốt phương án — APM-DSHEET.
    'decision_sheet.created': 'đã tạo sổ chốt phương án',
    'decision_sheet.updated': 'đã sửa sổ chốt phương án',
    'decision_sheet.deleted': 'đã xoá sổ chốt phương án',
    'decision_sheet.opened': 'đã mở sổ cho người chốt',
    'decision_sheet.closed': 'đã đóng sổ chốt phương án',
    'decision_sheet.reopened': 'đã mở lại sổ chốt phương án',
    'decision_sheet.deciders_changed': 'đã đổi người chốt của sổ',
    'decision_sheet.group_upserted': 'đã sửa nhóm câu hỏi trong sổ',
    'decision_sheet.group_removed': 'đã xoá nhóm câu hỏi trong sổ',
    'decision_sheet.question_upserted': 'đã sửa câu hỏi trong sổ',
    'decision_sheet.question_removed': 'đã xoá câu hỏi trong sổ',
    'decision_sheet.questions_reordered': 'đã sắp lại câu hỏi trong sổ',
    'decision_sheet.answered': 'đã chốt một câu trong sổ',
    'decision_sheet.answer_cleared': 'đã bỏ chốt một câu trong sổ',
    'decision_sheet.exported': 'đã xuất sổ thành tài liệu',
    'decision_sheet.raid_recorded': 'đã ghi câu đã chốt vào RAID',
    /** Tên field trong `{ before, after }` — dựng câu "cũ → mới". */
    field: {
      title: 'Tên',
      description: 'Mô tả',
      startDate: 'Bắt đầu',
      dueDate: 'Hạn chót',
      estimateHours: 'Ước lượng (giờ)',
      storyPoints: 'Story point',
      progressPct: 'Tiến độ (%)',
      priority: 'Ưu tiên',
      statusName: 'Trạng thái',
      assigneeName: 'Người phụ trách',
      category: 'Nhóm trạng thái',
      kind: 'Hạng mục',
      name: 'Tên',
      blockReason: 'Lý do bị chặn',
      checklist: 'Checklist',
      rule: 'Lịch lặp',
      taskStatusRules: 'Quyền đổi trạng thái',
      taskScheduleRules: 'Quyền đổi lịch',
      minTaskDurationMinutes: 'Thời gian tối thiểu trước khi Xong (phút)',
      actualStartAt: 'Bắt đầu thực tế',
      actualStartDeclared: 'Khai tay giờ bắt đầu',
      targets: 'Mục tiêu SLA',
      commitment: 'Cam kết thời gian',
      screens: 'Màn hình',
      stats: 'Thống kê thay đổi',
      order: 'Thứ tự',
      hidden: 'Đang ẩn',
      statusChange: 'Ai đổi được trạng thái',
      done: 'Ai đánh dấu xong được',
      scheduleChange: 'Ai dời lịch được',
      freq: 'Tần suất',
      weekdays: 'Các thứ',
      monthDay: 'Ngày trong tháng',
      intervalDays: 'Cách (ngày)',
      endDate: 'Kết thúc',
      responseMinutes: 'Phản hồi (phút)',
      resolveMinutes: 'Xử lý xong (phút)',
      roundTheClock: 'Tính cả ngoài giờ',
      mode: 'Kiểu',
      value: 'Mức',
      added: 'Thêm',
      removed: 'Bỏ',
      modified: 'Sửa',
      renamed: 'Đổi tên',
      moved: 'Di chuyển',
      replaced: 'Thay thế',
      changes: 'Tổng thay đổi',
      page: 'Trang',
      groupPath: 'Nhóm',
      text: 'Nội dung',
      weight: 'Trọng số',
    },
    /** Giá trị enum trong object trước/sau — `activity.value.<khoá>.<giá trị>`. */
    value: {
      statusChange: {
        members: 'mọi thành viên',
        assignee_or_creator: 'người phụ trách hoặc người tạo',
        roles: 'các vai trò được chọn',
      },
      done: {
        pm: 'chỉ PM',
        roles_and_pm: 'PM và các vai trò được chọn',
        assignee_or_creator_and_pm: 'PM, người phụ trách hoặc người tạo',
        not_assignee_and_pm: 'PM hoặc người khác người phụ trách',
        anyone: 'bất kỳ ai',
      },
      scheduleChange: {
        pm: 'chỉ PM',
        assignee_or_creator: 'người phụ trách hoặc người tạo',
        roles: 'các vai trò được chọn',
      },
      mode: { hours: 'giờ / tuần', percent: '% thời gian' },
      freq: {
        daily: 'hằng ngày',
        weekly: 'hằng tuần',
        monthly: 'hằng tháng',
        interval: 'cách đều số ngày',
      },
    },
    /** Object trước/sau vẽ thành danh sách thay vì JSON — 2026-10-06. */
    structured: {
      added: 'thêm',
      removed: 'bỏ',
      renamed: 'đổi tên',
      checked: 'đã xong',
      unchecked: 'bỏ đánh dấu xong',
      changed: 'đổi',
      unchanged: '{{count}} mục không đổi',
      more: '+{{count}} mục nữa',
      empty: 'trống',
      lastDay: 'ngày cuối tháng',
    },
  },
  tabLayout: {
    quickEdit: 'Sắp lại thanh tab',
    // APM-GIT-p — tab mặc định ẩn (Git): khối nhắc bật ngay ở chỗ vừa cấu hình xong.
    hiddenNotice: 'Tab {{name}} đang ẩn trên thanh tab của dự án. Bật lên để cả đội thấy.',
    hiddenNoticeAskPm: 'Tab {{name}} đang ẩn trên thanh tab của dự án — nhờ PM bật ở mục Thanh tab.',
    showTab: 'Hiện tab {{name}}',
    shownToast: 'Đã hiện tab {{name}}.',
    title: 'Thanh tab',
    subtitle: 'Sắp lại thứ tự tab của dự án, và tắt tab đội không dùng tới.',
    moveUp: 'Đưa {{name}} lên trên',
    moveDown: 'Đưa {{name}} xuống dưới',
    toggle: 'Hiện {{name}} trên thanh tab',
    pinnedBadge: 'Luôn hiện',
    pinnedReason: 'Tab trụ — sắp xếp được nhưng không tắt được.',
    save: 'Lưu thanh tab',
    reset: 'Hoàn tác',
    saved: 'Đã cập nhật thanh tab',
    futureHint: 'Trang thêm về sau sẽ tự hiện ở cuối hàng, không cần bật lại ở đây.',
  },
  aiPanel: {
    needKey:
      'Dự án này chưa có key AI, nên tính năng chưa chạy được. Thêm key ở tab Cấu hình → “Key AI của dự án” rồi quay lại đây.',
    hasResult: 'có kết quả',
    needParams: 'Điền thông tin phía trên trước đã.',
    contentMismatch:
      'Kết quả này sinh ra ở phiên bản trước và không còn đọc được. Chạy lại để có bản mới.',
    dismiss: 'Bỏ qua',
    cost: '{{value}} USD',
  },
  delayRisk: {
    open: 'Phân tích rủi ro tự động',
    title: 'Vì sao điểm rủi ro trễ như vậy',
    help: 'Bảng chỉ báo bên dưới đã có đủ số. Mục này thêm phần lời: điều gì đang kéo điểm xuống, và làm gì trước.',
    run: 'Giải thích điểm rủi ro',
    prompt: 'Giải thích điểm rủi ro trễ của dự án này và đề xuất tối đa ba việc nên làm trước.',
  },
  inferDeps: {
    title: 'Phụ thuộc còn thiếu',
    help: 'Đọc mô tả và bình luận để tìm phụ thuộc chưa ai khai. Mỗi đề xuất kèm một câu có thật làm dẫn chứng.',
    run: 'Tìm phụ thuộc còn thiếu',
    prompt: 'Tìm những phụ thuộc giữa các việc chưa được khai báo trong dự án này.',
    none: 'Không tìm thấy phụ thuộc nào còn thiếu.',
    cycles: 'Bỏ qua {{count}} đề xuất vì chúng tạo thành vòng lặp',
  },
  budgetAi: {
    open: 'Ước lượng ngân sách tự động',
    title: 'Giải thích ước lượng ngân sách',
    help: 'Con số tổng ở trên do hệ thống tính. Mục này nói tiền nằm ở đâu, giả định nào đang đỡ nó, và thiếu dữ liệu gì.',
    run: 'Giải thích ước lượng',
    prompt:
      'Giải thích ước lượng ngân sách của dự án này: tiền nằm ở đâu, dựa trên giả định nào, còn thiếu dữ liệu gì.',
    noConfidence: 'chưa chốt được mức tin cậy',
    missing: 'Còn thiếu dữ liệu',
  },
  whatIf: {
    title: 'Nếu khi đó làm khác đi',
    help: 'Đặt một giả thiết, hệ thống mô phỏng lại và so với những gì đã thật sự xảy ra.',
    run: 'Mô phỏng giả định',
    placeholder: 'Ví dụ: nếu lúc đó thêm một người vào việc tích hợp thanh toán thì sao?',
    p50: 'Lệch (P50)',
    p85: 'Lệch (P85)',
    affected: 'Việc bị ảnh hưởng',
    verdict: 'Kết luận',
    verdictName: { better: 'tốt hơn', worse: 'tệ hơn', same: 'không khác' },
    days: '{{value}} ngày',
    lesson: 'Bài học rút ra',
    appliesWhen: 'Áp dụng khi: {{value}}',
    seed: 'Seed mô phỏng: {{value}} — cùng seed thì cùng kết quả.',
  },
  decisionDig: {
    title: 'Vì sao lúc đó ta chọn thế',
    help: 'Trả lời “vì sao hồi đó đội chọn thế” bằng chính dấu vết dự án đã để lại: mục Quyết định trong RAID, bình luận trong công việc, và tài liệu đã tải lên. Nó dựng lại bối cảnh tại thời điểm ấy — lúc đó đang chạy sprint nào, ai phụ trách, ràng buộc gì — chứ không trả lời theo tình hình hôm nay. Không tìm thấy gì thì nó nói thẳng là chưa ai ghi lại, và mời ghi bổ sung, thay vì dựng ra một lý do nghe hợp lý.',
    run: 'Tra quyết định cũ',
    placeholder: 'Ví dụ: vì sao dự án chọn MySQL thay vì PostgreSQL?',
    contextAt: 'Bối cảnh dựng lại tại ngày {{value}}',
    backfill: 'Không tìm thấy quyết định nào được ghi lại — nên ghi bổ sung',
    sources: 'Dựng từ {{count}} nguồn',
  },
  scopeNego: {
    title: 'Đàm phán phạm vi',
    help: 'Đưa một ràng buộc mới, nhận lại vài phương án kèm số mô phỏng thật và mục tiêu nào bị đụng.',
    run: 'Dựng phương án',
    placeholder: 'Ví dụ: khách muốn giao sớm hai tuần mà không thêm người',
    recommended: 'nên chọn',
    days: 'P50 {{p50}} ngày · P85 {{p85}} ngày',
    cuts: 'cắt {{count}} việc',
    defers: 'hoãn {{count}} việc',
  },
  taskSummary: {
    title: 'Tóm tắt việc này',
    help: 'Đang ở đâu, ai đang chờ ai, đã chốt gì, còn hỏi gì, và bước kế tiếp.',
    run: 'Tóm tắt',
    prompt: 'Tóm tắt tình trạng của việc {{key}} và luồng bình luận của nó.',
    waitingOn: 'Đang chờ',
    decisions: 'Đã chốt',
    openQuestions: 'Còn bỏ ngỏ',
    nextStep: 'Bước kế tiếp',
    sources: 'Dựng từ {{count}} bình luận và sự kiện',
  },
  handoverBrief: {
    title: 'Bản bàn giao khi một người nghỉ',
    help: 'Chọn một người, nhận lại từng việc của họ đang ở đâu, chờ gì, và nên giao cho ai.',
    run: 'Dựng bản bàn giao',
    prompt: 'Dựng bản bàn giao cho người này: từng việc đang ở đâu, chờ gì, nên giao lại cho ai.',
    noTasks: 'Người này không còn việc nào đang mở.',
    nextStep: 'Bước kế tiếp',
    waitingOn: 'Đang chờ: {{value}}',
    proposed: 'Đề xuất giao cho {{name}}',
    risks: 'Rủi ro khi bàn giao',
  },
  rebalanceAi: {
    open: 'Xử lý task chậm tiến độ',
    noLateTasks: 'Hiện không có việc nào trễ hạn — không có gì cần xử lý.',
    title: 'Việc này trễ thì sao, và nên xử lý thế nào?',
    helpIntro: 'Chọn một việc đang trễ hạn. AI sẽ cho bạn biết:',
    helpDates: 'Những ngày quan trọng nào sẽ bị lùi theo (như ngày bàn giao, ngày ra mắt).',
    helpWaiting: 'Những việc nào khác phải chờ việc này xong mới làm được, nên sẽ bị trễ theo.',
    helpOptions:
      'Có những cách xử lý nào — ví dụ lùi lịch các việc phía sau, hoặc chuyển bớt việc cho người đang rảnh. Với mỗi cách: lùi mấy ngày, ảnh hưởng tới ai, và vì sao lại ước lượng như vậy.',
    helpNote: 'AI chỉ giải thích, không tự đổi lịch. Bạn chọn cách xử lý rồi tự sửa lịch.',
    run: 'Phân tích',
    prompt: 'Phân tích việc đang trễ hạn này: ảnh hưởng tới đâu và nên xử lý thế nào.',
    pickTask: '— chọn việc đang trễ hạn —',
    cause: {
      early: '{{key}} xong sớm {{days}} ngày làm việc',
      late: '{{key}} trễ {{days}} ngày làm việc',
    },
    milestones: 'Ngày quan trọng sẽ bị lùi',
    shift: 'lùi {{value}} ngày làm việc',
    noShift: 'không lùi lịch',
    touches: 'ảnh hưởng {{count}} người',
    moves: '{{count}} việc phải dời',
    solverTitle: 'Cách xử lý hệ thống đề xuất (không cần AI)',
    noOption: 'Hệ thống chưa tìm được cách xử lý nào cho việc này — hãy xem lại lịch trên Gantt.',
    moveDate: 'lùi từ {{from}} sang {{to}}',
    moveAssign: 'chuyển cho {{name}}',
    moveUnschedule: 'gỡ khỏi lịch (không xoá việc)',
  },
  dod: {
    help: 'Việc muốn sang cột Hoàn thành phải tick hết các mục dưới đây. Sửa danh sách ở đây áp cho mọi việc của dự án.',
    title: 'Definition of Done',
    subtitle: 'Điều kiện một việc phải đạt trước khi được coi là xong.',
    helpEmpty:
      'Chưa có mục nào — và đó là trạng thái bình thường. Thêm mục đầu tiên thì từ đó việc muốn sang cột Hoàn thành sẽ phải tick hết.',
    placeholder: 'Ví dụ: đã review, đã viết test',
    add: 'Thêm mục',
    remove: 'Bỏ mục “{{text}}”',
    retired: 'đã bỏ',
  },
  announce: {
    open: 'Soạn thông báo',
    title: 'Gửi thông báo',
    help: 'Thông báo tới thẳng hộp thư của người nhận. Không gửi lại được, nên đọc kỹ trước khi gửi.',
    audience: 'Gửi cho',
    toReports: 'Cấp dưới của tôi',
    toOrg: 'Cả tổ chức',
    toProject: 'Thành viên {{name}}',
    counting: 'Đang đếm người nhận…',
    blocked: {
      direct_reports: 'Chưa ai khai bạn là quản lý trực tiếp, nên chưa có ai để gửi.',
      organization: 'Bạn không có quyền gửi thông báo cho cả tổ chức.',
      project: 'Bạn không sửa được dự án này, nên không gửi thông báo cho nó được.',
    },
    recipients_one: 'Sẽ gửi tới {{count}} người',
    recipients_other: 'Sẽ gửi tới {{count}} người',
    subject: 'Tiêu đề',
    subjectPlaceholder: 'Bảo trì hệ thống tối nay',
    body: 'Nội dung',
    bodyPlaceholder: 'Từ 22h đến 23h, hệ thống sẽ tạm dừng.',
    left: 'Còn {{count}} ký tự',
    send: 'Gửi',
    sendTo_one: 'Gửi cho {{count}} người',
    sendTo_other: 'Gửi cho {{count}} người',
    sent_one: 'Đã gửi tới {{count}} người',
    sent_other: 'Đã gửi tới {{count}} người',
  },
  notifications: {
    // Toast realtime khi câu của loại thông báo thiếu tham số — xem `toastText`.
    fallback: 'Bạn có thông báo mới — mở chuông để xem',
    'task_type.proposed': '{{by}} đề xuất loại việc “{{name}}” — cần bạn duyệt',
    // Duyệt dự án — APM-ROLE-m3. Bốn khoá không tham số là chữ của toast (khoá
    // theo loại SSE), năm khoá có tham số là chữ trong hộp thư (`titleKey`).
    'project_approval.requested': 'Có dự án mới chờ bạn duyệt',
    'project_approval.approved': 'Dự án bạn mở đã được duyệt',
    'project_approval.rejected': 'Dự án bạn mở bị từ chối',
    'project_approval.decided_by_other': 'Một dự án chờ bạn duyệt đã được người khác quyết định',
    'project_approval.request_received': '{{by}} mở dự án «{{name}}» — cần bạn duyệt',
    'project_approval.accepted': 'Dự án «{{name}}» của bạn đã được {{by}} duyệt',
    'project_approval.declined': 'Dự án «{{name}}» của bạn bị {{by}} từ chối: {{note}}',
    'project_approval.accepted_by_other': '{{by}} đã duyệt thay bạn dự án «{{name}}»',
    'project_approval.declined_by_other': '{{by}} đã từ chối thay bạn dự án «{{name}}»: {{note}}',
    'task_type.approved': 'Loại việc “{{name}}” bạn đề xuất đã được duyệt',
    'task_type.rejected': 'Loại việc “{{name}}” bạn đề xuất bị từ chối: {{note}}',
    'announcement.sent': '{{title}}',
    'comment.mentioned': 'Có người nhắc tới bạn trong một bình luận',
    'task.assigned': 'Bạn vừa được giao một việc',
    'task.unassigned': 'Một việc của bạn đã được giao cho người khác',
    // Có gộp nên phải khai dạng số nhiều: `count` truyền vào `t()` sẽ khiến
    // i18next tìm hậu tố. Tiếng Việt chỉ dùng `_other`, nhưng khai cả hai cho
    // khớp `en` — thiếu `_other` thì câu chữ rơi về khoá gốc và mất luôn số lần.
    'task.edited_one': 'Một việc bạn đang làm vừa bị người khác sửa',
    'task.edited_other': 'Một việc bạn đang làm vừa bị người khác sửa {{count}} lần',
    'membership_request.invited': 'Bạn được mời tham gia một dự án',
    'membership_request.applied': '{{name}} đăng ký tham gia dự án {{project}} — cần bạn chốt',
    'client_request.created': 'Khách hàng {{name}} xin vào dự án {{project}} — cần bạn duyệt',
    'client_request.accepted': 'Bạn đã được duyệt vào dự án {{project}}',
    'client_request.declined': 'Yêu cầu vào dự án {{project}} chưa được duyệt',
    'guest_request.created': 'Cộng tác viên {{name}} xin vào dự án {{project}} — cần bạn duyệt',
    'guest_request.accepted': 'Bạn đã được duyệt vào dự án {{project}}',
    'guest_request.declined': 'Yêu cầu vào dự án {{project}} chưa được duyệt',
    'org_join_request.created': '{{name}} xin vào tổ chức — cần bạn duyệt',
    'org_join_request.accepted':
      'Bạn đã được duyệt vào tổ chức {{org}} — đổi tổ chức ở góc trên để vào',
    'org_join_request.declined': 'Yêu cầu vào tổ chức {{org}} chưa được duyệt',
    'offboarding.scheduled':
      '{{name}} nghỉ việc sau ngày {{date}} — sắp xếp chuyển việc và bàn giao',
    'offboarding.rescheduled': '{{name}} đổi ngày nghỉ việc: sau ngày {{date}}',
    'offboarding.cancelled': '{{name}} không nghỉ việc nữa',
    'offboarding.handover_received':
      'Bạn tiếp quản phần của {{name}}: {{files}} tệp, {{reports}} người dưới quyền',
    'offboarding.handover_done': 'Đã bàn giao xong phần của {{name}}',
    'offboarding.handover_failed':
      'Bàn giao phần của {{name}} chưa xong — mở phương án để xem lý do',
    'membership_request.answered.accepted': 'Lời mời bạn gửi đã được chấp nhận',
    'membership_request.answered.declined': 'Lời mời bạn gửi bị từ chối: {{note}}',
    'membership_request.finalized.accepted': 'Đơn tham gia dự án của bạn được duyệt',
    'membership_request.finalized.declined': 'Đơn tham gia dự án của bạn bị từ chối: {{note}}',
    'raid.risk_high': 'Một rủi ro vừa vượt ngưỡng cao trong dự án của bạn',
    'raid.signals_detected': 'Có tín hiệu rủi ro mới trong dự án của bạn',
    'handover.suggested':
      'Một thành viên sắp vắng mặt và còn {{openTasks}} việc đang mở — soạn bản bàn giao?',
    // Sprint hết hạn tự đóng — báo PM trước 2 ngày và sáng ngày cuối (2026-10-13).
    'sprint.ending_soon':
      'Sprint «{{name}}» ({{project}}) kết thúc sau {{daysLeft}} ngày, ngày {{endDate}}, còn {{openTasks}} việc chưa xong — dãn hạn nếu cần, quá hạn sprint tự đóng',
    'sprint.last_day':
      'Hôm nay là ngày cuối của sprint «{{name}}» ({{project}}), còn {{openTasks}} việc chưa xong — hết ngày sprint tự đóng và việc dở về backlog',
    'sprint.auto_closed':
      'Sprint «{{name}}» ({{project}}) đã tự đóng khi hết hạn — {{carriedOver}} việc chưa xong đã về backlog',
    'project.member_left': 'Một thành viên đã rời dự án của bạn',
    'task.due_soon': 'Một việc của bạn sắp tới hạn',
    'task.due_overdue': 'Một việc của bạn đã quá hạn',
    // APM-TLOW — việc đang làm còn ≤ 10% thời gian tới hạn.
    'task.time_running_out':
      '{{taskKey}} «{{title}}» sắp hết thời gian — hạn {{deadline}}, đã dùng 90% thời gian từ lúc bắt đầu làm',
    'design_file.remote_version_detected':
      'File Figma «{{name}}» có bản mới — chụp lại để so sánh?',
    // Đồng bộ dự án — APM-SYNC-e: key của nguồn hỏng ⇒ lịch tự chạy đã dừng.
    'project_sync.failed':
      'Đồng bộ «{{project}}» với {{source}} đã dừng — API key không còn hợp lệ, dán key mới ở Cấu hình dự án',
    // APM-SYNC-alert: mọi lượt lỗi khác, và lượt có việc không nhập được — báo ở lần chuyển trạng thái.
    'project_sync.error':
      'Đồng bộ «{{project}}» với {{source}} đang lỗi: {{reason}} — mở dự án để xem và thử lại',
    'project_sync.skipped':
      'Đồng bộ «{{project}}» với {{source}}: {{count}} việc không nhập được ({{reason}}), nhập được {{imported}} — mở dự án để xem và xử lý',
    'project_sync.pending':
      'Đồng bộ «{{project}}» với {{source}}: {{count}} mục của nguồn chưa ghép được, {{tasks}} việc đang đặt tạm — mở kết quả đồng bộ để ghép',
    // Tab Git — APM-GIT-d: token bị máy chủ git từ chối ⇒ kho đã dừng kéo; và lỗi kéo dài khác.
    'git_sync.failed':
      'Kho «{{repository}}» của «{{project}}» đã dừng kéo dữ liệu từ {{host}} — token không còn hợp lệ, dán token mới ở Cấu hình dự án → Kho mã Git',
    'git_sync.error':
      'Kho «{{repository}}» của «{{project}}» đang không kéo được dữ liệu từ {{host}}: {{reason}} — mở tab Git để xem',
    // Tab Git — APM-GIT-j: token sắp hết hạn (14 ngày trước, một lần); nhánh chính đỏ quá 2 giờ (một lần mỗi đợt đỏ).
    git_token_expiring:
      'Token git «{{label}}» của «{{project}}» hết hạn ngày {{date}} (còn {{days}} ngày) — dán token mới ở Cấu hình dự án → Kho mã Git',
    // APM-PCRV: AI rà commit đã báo thấy thấp — chỉ cảnh báo PM, việc không đổi.
    git_progress_review_unrelated:
      'Commit {{reporter}} báo cho {{taskKey}} «{{task}}» có vẻ không liên quan (AI rà) — {{summary}}',
    git_progress_review_partial:
      'Commit {{reporter}} báo cho {{taskKey}} «{{task}}» chỉ liên quan một phần (AI rà) — {{summary}}',
    git_default_pipeline_failed:
      'Nhánh {{branch}} của kho «{{repository}}» («{{project}}») đã đỏ {{hours}} giờ — mở tab Git để xem lượt CI hỏng',
    // APM-GIT-s-b: kho mới trong một nhóm đã gắn — chỉ gợi ý, PM duyệt.
    git_group_repo_suggested:
      'Nhóm «{{group}}» có kho mới: {{repository}} — mở Cấu hình dự án «{{project}}» → Kho mã Git để gắn hoặc bỏ qua',
    'schedule.impact_detected': 'Lịch đổi làm ảnh hưởng kế hoạch dự án của bạn',
    'schedule.drift_detected':
      'Có {{late}} việc trễ và {{early}} việc xong sớm — xem lại phần lịch phía sau',
    'schedule.drift_late.one':
      '«{{project}}»: {{task}} trễ hạn {{days}} ngày làm việc — dời hạn hoặc sắp lại lịch phía sau',
    'schedule.drift_late.many':
      '«{{project}}»: {{count}} việc trễ hạn ({{tasks}}) — mở tab Công việc để xem và sắp lại lịch',
    'schedule.drift_early.one':
      '«{{project}}»: {{task}} xong sớm {{days}} ngày làm việc — có thể kéo lịch các việc phía sau lên',
    'schedule.drift_early.many':
      '«{{project}}»: {{count}} việc xong sớm ({{tasks}}) — có thể kéo lịch các việc phía sau lên',
    'ai_budget.soft_limit_reached': 'Chi phí AI của tổ chức đã vượt ngưỡng cảnh báo',
    'issue.state.triaged': '{{key}} «{{title}}» đã được tiếp nhận',
    'issue.state.in_progress': '{{key}} «{{title}}» đang được xử lý',
    'issue.state.waiting_customer': '{{key}} «{{title}}» đang chờ bạn phản hồi',
    'issue.state.waiting_third_party': '{{key}} «{{title}}» đang chờ bên thứ ba',
    'issue.state.closed': '{{key}} «{{title}}» đã đóng',
    'issue.resolved': '{{key}} «{{title}}» đã xử lý — xác nhận hoặc mở lại',
    'issue.reopened': '{{key}} «{{title}}» bị người gửi mở lại',
    'issue.watcher_added': 'Bạn được chia sẻ {{key}} «{{title}}» để theo dõi',
    // Trao đổi trên issue — APM-ISC-c. `note` là đoạn đầu của bình luận.
    'issue.replied': 'Đội xử lý trả lời {{key}} «{{title}}»: {{note}}',
    'issue.customer_replied': 'Người gửi phản hồi {{key}} «{{title}}»: {{note}}',
    'issue.internal_comment': 'Trao đổi nội bộ ở {{key}} «{{title}}»: {{note}}',
    'issue.assigned': 'Bạn được giao xử lý {{key}} «{{title}}»',
    // Luồng lỗi kiểm thử — APM-TEST2-b. `actor` là người vừa bấm, `project` là tên dự án.
    'bug.assigned': '{{actor}} giao cho bạn lỗi #{{code}} · {{project}}: {{title}}',
    'bug.fixed': '{{actor}} đã sửa xong lỗi #{{code}} · {{project}}: {{title}} — chờ bạn kiểm lại',
    'bug.still_failing':
      '{{actor}} kiểm lại: lỗi #{{code}} · {{project}}: {{title}} vẫn còn — cần sửa tiếp',
    'bug.closed': '{{actor}} xác nhận lỗi #{{code}} · {{project}}: {{title}} đã hết — lỗi đã đóng',
    // Sổ chốt phương án — APM-DSHEET-i. `name` là người mời, `count` là số câu.
    'decision_sheet.invited': '{{name}} mời bạn chốt sổ «{{title}}» ({{count}} câu)',
    // Gửi duyệt tài liệu — người nhận là PM. `version` là số bản mới nhất.
    'document.review_requested': '{{name}} gửi duyệt tài liệu «{{title}}» (bản {{version}}) · {{project}}',
    // Nhắc tên (@) trong tài liệu — APM-CD2-f. `name` là người nhắc.
    'document.mentioned': '{{name}} nhắc tới bạn trong tài liệu «{{title}}»',
    'document.suggested': '{{name}} đề xuất chỉnh sửa tài liệu «{{title}}» (bản {{version}})',
    // Đời model của key AI — APM-MDL-b/-d.
    'ai.model_update_available': 'Key «{{label}}» có model mới: {{models}}',
    'ai.model_recommendation': 'Đề xuất model cho key «{{label}}»: {{summary}}',
    // Hạn cuối / mốc đổi — APM-DL-a. Ngày đã định dạng sẵn `dd/MM/yyyy` ở API.
    'schedule.deadline_changed.project.moved':
      'Hạn cuối dự án «{{name}}» đã dời từ {{from}} sang {{to}}',
    'schedule.deadline_changed.project.set': 'Dự án «{{name}}» vừa có hạn cuối: {{to}}',
    'schedule.deadline_changed.project.cleared':
      'Dự án «{{name}}» đã bỏ hạn cuối (trước là {{from}})',
    'schedule.deadline_changed.sprint.moved':
      '«{{project}}»: hạn cuối sprint «{{name}}» đã dời từ {{from}} sang {{to}}',
    'schedule.deadline_changed.milestone.moved':
      '«{{project}}»: mốc «{{name}}» đã dời từ {{from}} sang {{to}}',
    'schedule.deadline_changed.milestone.set': '«{{project}}»: mốc «{{name}}» vừa có ngày {{to}}',
    'schedule.deadline_changed.milestone.cleared':
      '«{{project}}»: mốc «{{name}}» đã bỏ ngày (trước là {{from}})',
    'schedule.deadline_changed.many':
      '«{{project}}»: {{count}} hạn cuối và mốc vừa được dời — xem lại việc của bạn',
    'ai.alert.error_rate':
      'Tỉ lệ lượt chạy AI lỗi 6 giờ qua là {{value}}%, vượt ngưỡng {{threshold}}%',
    'ai.alert.cost_per_day': 'Chi phí AI hôm nay {{value}} USD, vượt ngưỡng {{threshold}} USD',
    'timesheet.timer_overdue':
      'Bạn đang bấm giờ cho «{{taskKey}}» đã quá hạn — cập nhật tiến độ hoặc dời hạn?',
    'timesheet.session_capped':
      'Đồng hồ của bạn chạy quá 12 giờ nên đã tự dừng — kiểm tra lại giờ hôm nay',
    'timesheet.overtime_capped':
      'Đã ghi {{hours}} giờ làm thêm và đồng hồ tự dừng. Còn đang làm thì bấm Làm tiếp.',
    'timesheet.day_capped':
      'Hôm nay đã bấm đủ {{hours}} giờ nên đồng hồ tự dừng — mai bấm tiếp nhé.',
    // Báo quản lý trực tiếp (không có ⇒ Giám đốc) — APM-TREM-e. `range` là ngày giờ đã định dạng.
    'absence.requested': '{{name}} xin nghỉ {{range}} — chờ bạn duyệt',
    'absence.retracted': '{{name}} đã rút đơn nghỉ {{range}}',
    'ai.alert.stuck_runs': 'Có {{value}} lượt chạy AI treo, vượt ngưỡng {{threshold}}',

    // Gộp / tách tổ chức — APM-ORGMS-c/e/f. `updated` là chữ của toast (loại SSE), các
    // khoá còn lại là `titleKey` trong hộp thư.
    'org_restructure.updated': 'Đề xuất gộp / tách tổ chức vừa có thay đổi',
    'okr.report_due': 'Có {{count}} kết quả then chốt trong OKR cần báo số',
    'org_restructure.invited': '{{by}} mời tổ chức của bạn gộp với «{{org}}» — bấm để xem lời mời',
    'org_restructure.partner_joined':
      '«{{partner}}» đã nhận đề xuất gộp với «{{initiator}}» — cần bạn duyệt',
    'org_restructure.config_changed':
      'Cấu hình gộp tổ chức vừa đổi (bản {{version}}) — lượt duyệt cũ không còn tính, hãy duyệt lại',
    'org_restructure.rejected': '{{by}} đã từ chối đề xuất gộp tổ chức: {{reason}}',
    'org_restructure.cancelled': 'Đề xuất gộp tổ chức đã bị huỷ ({{by}})',
    'org_restructure.expired': 'Đề xuất gộp tổ chức đã hết hạn — chưa đủ người duyệt sau 14 ngày',
    'org_restructure.executed': '«{{source}}» đã gộp vào «{{target}}»',
    'org_restructure.failed':
      'Gộp «{{source}}» vào «{{target}}» chưa chạy xong — quản trị viên đang xử lý',

    // Giao diện hộp thư — APM-NOTI-c. Khoá ở trên là *nội dung* từng loại thông
    // báo, khoá dưới đây là chữ của chính màn hình.
    title: 'Thông báo',
    filterUnread: 'Chưa đọc',
    markAllRead: 'Đánh dấu đã đọc tất cả',
    markAllReadShort: 'Đọc hết',
    composeShort: 'Soạn',
    empty: 'Chưa có thông báo nào',
    taskPopupLabel: 'Chi tiết công việc',
    emptyUnread: 'Bạn đã đọc hết',
    emptyHelp: 'Thông báo về việc được giao, bị nhắc tên và sắp tới hạn sẽ hiện ở đây.',
    unreadDot: 'Chưa đọc',
    targetGone: 'Nội dung này đã bị xoá',
    bellEmpty: 'Thông báo',
    bellWithCount_one: '{{count}} thông báo chưa đọc',
    bellWithCount_other: '{{count}} thông báo chưa đọc',
    previous: 'Trang trước',
    next: 'Trang sau',
  },
  levelRate: {
    title: 'Giá thuê theo bậc',
    subtitle:
      'Giá mặc định mỗi giờ cho từng bậc nhân sự. PM của mỗi dự án dùng mức này hoặc gõ giá riêng.',
    hint: 'Đây là bảng giá của tổ chức, không phải bảng lương: nó trả lời "một Senior 1 tốn bao nhiêu mỗi giờ". Đổi mức sẽ giữ lại mức cũ để báo cáo của quá khứ không đổi theo.',
    level: {
      JUNIOR_1: 'Junior 1',
      JUNIOR_2: 'Junior 2',
      SENIOR_1: 'Senior 1',
      SENIOR_2: 'Senior 2',
    },
    perHour: 'đ/giờ',
    notSet: 'chưa đặt',
    save: 'Lưu',
    saved: 'Đã lưu giá theo bậc.',
    since: 'từ {{date}}',
    userLevel: 'Bậc',
    userLevelNone: 'Chưa xếp',
  },
  projectAiKey: {
    title: 'Key AI của dự án',
    subtitle: 'Gắn key của bạn vào dự án để cả đội dùng chung, và chi phí dồn về dự án này.',
    intro:
      'Dự án dùng key này cho mọi tính năng AI bên trong nó, kể cả với người đã có key riêng. Key của bạn không bị sao chép — dự án chỉ trỏ tới nó.',
    noneAttached: 'Chưa gắn key. Mỗi người đang dùng key riêng của mình.',
    owner: 'của {{name}}',
    inactive: 'Key này đã bị chủ hạ xuống, nên dự án đang tạm rơi về key riêng của từng người.',
    pick: 'Key của bạn',
    mine: 'đang dùng',
    attach: 'Gắn vào dự án',
    replace: 'Đổi sang key này',
    detach: 'Gỡ khỏi dự án',
    noKeysOfMine:
      'Bạn chưa có key nào đã kiểm kết nối. Thêm và bấm “Kiểm tra” ở trang Cài đặt của tôi trước.',
    warning:
      'Lưu ý: mọi lời gọi AI trong dự án sẽ tính vào key này — tức là tiền của chủ key, không phải của người bấm nút.',
    spent: 'Dự án đã tiêu {{value}} USD cho AI.',
    saved: 'Đã lưu key của dự án.',
  },
  testImport: {
    open: 'Nhập case từ file',
    title: 'Nhập test case từ file',
    subtitle:
      'Excel hoặc CSV. File theo mẫu thì nhập thẳng; file tự soạn thì chọn cột hoặc để AI dò cột. Không có gì được ghi trước khi bạn bấm Nhập.',
    dropHere: 'Kéo file vào đây, hoặc chọn từ máy',
    formats:
      '.xlsx, .xls, .csv — tối đa 10 MB. File chỉ được đọc trên trình duyệt của bạn, không tải lên máy chủ.',
    pickFile: 'Chọn file',
    reading: 'Đang đọc file…',
    tooBig: 'File lớn hơn 10 MB — hãy chia nhỏ rồi nhập từng phần.',
    emptyFile: 'File không có sheet nào có dữ liệu.',
    unreadable: 'Không đọc được file này. Hãy lưu lại dưới dạng .xlsx hoặc .csv rồi thử lại.',
    templateTitle: 'Chưa có file? Dùng file mẫu',
    templateHelp:
      'Mười cột theo đúng thứ tự, kèm hai dòng ví dụ và một sheet hướng dẫn. Điền theo mẫu thì nhập được ngay, không cần AI.',
    downloadTemplate: 'Tải file mẫu',
    sheet: 'Sheet',
    otherFile: 'Chọn file khác',
    showMapping: 'Chọn cột',
    hideMapping: 'Ẩn chọn cột',
    source: {
      template: 'Đúng file mẫu',
      guess: 'Chưa theo mẫu — đã đoán cột theo tên, hãy kiểm lại',
      manual: 'Cột do bạn chọn',
      ai: 'Cột do AI đề xuất — kiểm lại trước khi nhập',
    },
    aiRun: 'Dùng AI chuẩn hoá',
    aiPrompt: 'Dò cột của file test case này theo mẫu chuẩn',
    aiApplied: 'AI đã chọn cột — xem bảng xem trước rồi mới bấm Nhập.',
    aiMismatch: 'Kết quả của AI không đúng dạng — hãy chọn cột bằng tay.',
    headerRow: 'Dòng tiêu đề',
    noHeaderRow: 'Không có dòng tiêu đề',
    rowOption: 'Dòng {{n}}: {{text}}',
    groupRows: 'Dòng chỉ có một ô chữ là tên nhóm',
    noColumn: '— không có —',
    needTitleColumn:
      'Chưa nhận ra cột nào là “Tên case”. Chọn cột ở trên, hoặc bấm “Dùng AI chuẩn hoá” để AI dò cột giúp.',
    noRows: 'Không có dòng dữ liệu nào dưới dòng tiêu đề.',
    tickAll: 'Chọn tất cả',
    tickRow: 'Chọn dòng {{n}}',
    autoCode: 'tự cấp',
    col: { row: 'Dòng', kind: 'Loại', priority: 'Ưu tiên', note: 'Ghi chú' },
    issue: {
      missingTitle: 'Thiếu tên case',
      codeExists: 'Mã đã có trong dự án',
      codeDuplicate: 'Mã trùng dòng trên',
      truncated: 'Có ô bị cắt bớt',
    },
    summary: 'Sẽ nhập {{count}} case · {{skipped}} dòng bỏ qua',
    tooMany: 'Tối đa {{max}} case một lượt — bỏ tích bớt hoặc chia file.',
    import: 'Nhập {{count}} case',
    imported: 'Đã nhập {{count}} test case.',
    downloadNormalised: 'Tải bản đã chuẩn hoá',
    normalisedFileName: 'test-case-da-chuan-hoa.xlsx',
    columns: {
      code: 'Mã case',
      suite: 'Nhóm',
      title: 'Tên case',
      kind: 'Loại (Giao diện/API)',
      priority: 'Ưu tiên (Cao/Trung bình/Thấp)',
      preconditions: 'Điều kiện trước',
      steps: 'Các bước',
      expected: 'Kết quả mong đợi',
      requirementRef: 'Quy tắc liên quan',
      endpoint: 'Endpoint',
    },
    guide: {
      code: 'Không bắt buộc. Để trống thì hệ thống tự cấp theo mã dự án. Mã đã có trong dự án sẽ bị bỏ qua.',
      suite: 'Không bắt buộc. Nhóm chưa có sẽ được tạo mới theo tên.',
      title: 'Bắt buộc. Một câu ngắn nói điều được kiểm.',
      kind: '“Giao diện” hoặc “API”. Để trống là Giao diện.',
      priority: '“Cao”, “Trung bình” hoặc “Thấp”. Để trống là Trung bình.',
      preconditions: 'Trạng thái cần dựng sẵn trước khi test (đã đăng nhập, đã có dữ liệu…).',
      steps: 'Mỗi bước một dòng, đánh số 1., 2., …',
      expected: 'Điều nhìn thấy được trên màn hình hay giá trị trả về.',
      requirementRef: 'Mã yêu cầu / quy tắc nghiệp vụ / mã việc liên quan.',
      endpoint: 'Chỉ dùng cho case API, ví dụ POST /api/v1/login.',
    },
    template: {
      sheet: 'Test case',
      guideSheet: 'Hướng dẫn',
      guideColumn: 'Cột',
      guideMeaning: 'Cách điền',
      fileName: 'mau-test-case.xlsx',
    },
    example1: {
      code: 'AUTH-01',
      suite: 'Đăng nhập',
      title: 'Đăng nhập bằng email và mật khẩu đúng',
      kind: 'Giao diện',
      priority: 'Cao',
      preconditions: 'Đã có tài khoản kích hoạt',
      steps: '1. Mở trang đăng nhập\n2. Nhập email và mật khẩu đúng\n3. Bấm Đăng nhập',
      expected: 'Vào màn hình Tổng quan, góc phải hiện tên người dùng',
      requirementRef: 'BR-01',
      endpoint: '',
    },
    example2: {
      code: '',
      suite: 'Đăng nhập',
      title: 'API đăng nhập trả 401 khi sai mật khẩu',
      kind: 'API',
      priority: 'Trung bình',
      preconditions: '',
      steps: '1. Gửi POST với mật khẩu sai',
      expected: 'Mã 401, body có mã lỗi INVALID_CREDENTIALS',
      requirementRef: 'BR-02',
      endpoint: 'POST /api/v1/auth/login',
    },
  },
  testing: {
    evidenceFiles: 'Ảnh / video từ máy',
    evidenceHelp:
      'Tối đa 10 tệp. Ảnh (PNG, JPG, GIF, WebP) tối đa 5 MB, video (MP4, WebM, MOV) tối đa 100 MB.',
    evidenceImageTooBig: 'ảnh lớn hơn 5 MB',
    evidenceVideoTooBig: 'video lớn hơn 100 MB',
    evidenceWrongType: 'chỉ nhận ảnh hoặc video',
    evidenceDeleted: 'Tệp đã bị xoá ở trang Files',
    title: 'Kiểm thử',
    flowLine:
      'Chạy từng case trên từng môi trường; ô nào Không đạt thì ghi lỗi ngay tại ô đó. Vòng test là đợt chạy lại cả bộ case — dev sửa lỗi không phải đợi vòng.',
    sectionRun: 'Chạy test',
    sectionRunRound: 'Chạy test · Vòng {{number}}',
    sectionBugsOpen: 'Lỗi · {{n}} đang mở',
    report: {
      progressTitle: 'Tiến độ chạy test theo vòng',
      progressSubtitle: 'Đếm theo ô: mỗi case × mỗi môi trường là một ô',
      yieldTitle: 'Hiệu quả sửa lỗi qua các vòng',
      yieldSubtitle: 'Dev báo sửa bao nhiêu, test xác nhận được bao nhiêu',
      convergenceTitle: 'Đường hội tụ',
      convergenceSubtitle: 'Lỗi còn lại và lỗi mới phát sinh, theo vòng',
      latestRound: 'Vòng {{number}} — mới nhất',
      roundShort: 'Vòng {{number}}',
      cardProgress: 'Đã chạy',
      cardRemaining: 'Lỗi còn phải làm',
      cardNew: 'Lỗi mới trong vòng',
      fixYield: 'Sửa được',
      reopenRate: 'Bị mở lại',
      remaining: 'Lỗi còn lại',
      newBugs: 'Lỗi mới',
      overdue: 'Quá hạn dev',
      avgFix: 'Thời gian sửa trung bình',
      hours: '{{value}} giờ',
      notEnoughData: 'chưa đủ dữ liệu',
      bySeverity: 'Theo mức nghiêm trọng (còn/tổng)',
      noRounds: 'Chưa có vòng test nào để báo cáo.',
      noFixData: 'Chưa vòng nào có lỗi được dev báo sửa, nên chưa tính được hiệu quả.',
    },
    viewingRound: 'Đang xem',
    roundLabel: 'Vòng {{number}}',
    roundOpen: 'đang mở',
    openRound: 'Mở vòng mới',
    openFirstRound: 'Mở vòng test đầu tiên',
    closeRound: 'Đóng vòng',
    reopenRound: 'Mở lại vòng',
    reopenRoundHelp:
      'Chỉ vòng cuối cùng mới mở lại được — mở lại thì ghi tiếp kết quả vào vòng này.',
    closeRoundHelp: 'Đóng rồi thì không ghi thêm kết quả vào vòng này được nữa.',
    closeBeforeOpen: 'Đóng vòng đang mở trước khi mở vòng mới.',
    roundOpened: 'Đã mở vòng mới.',
    roundClosed: 'Đã đóng vòng.',
    roundReopened: 'Đã mở lại vòng test',
    confirm: {
      close: {
        title: 'Đóng vòng {{number}}?',
        warning:
          'Đóng rồi thì không ai ghi thêm kết quả vào vòng này được nữa, và số liệu của nó đi vào báo cáo cùng vạch mốc trên Gantt. Mở lại được, nhưng chỉ khi chưa có vòng mới sau nó.',
        action: 'Đóng vòng',
      },
      reopen: {
        title: 'Mở lại vòng {{number}}?',
        warning:
          'Vòng này đang được tính là đã chốt. Mở lại thì kết quả ghi thêm sẽ đổi con số mà báo cáo và bản so sánh giữa các vòng đang dùng.',
        action: 'Mở lại vòng',
      },
      delete: {
        title: 'Xoá vòng {{number}}?',
        warning:
          'Xoá là mất hẳn: mọi ô kết quả của vòng này và kết quả test lại của từng lỗi trong vòng biến mất, không khôi phục được. Bản thân các lỗi đã ghi thì vẫn còn. Vòng mở tiếp theo sẽ lấy lại đúng số vừa trả về.',
        action: 'Xoá vòng',
      },
    },
    roundDeleted: 'Đã xoá vòng test',
    deleteRound: 'Xoá vòng',
    deleteRoundHelp: 'Chỉ vòng cuối cùng mới xoá được. Mọi kết quả trong vòng sẽ mất.',
    noRounds: 'Chưa có vòng test nào',
    noRoundsHelp:
      'Một vòng test là một lượt chạy qua bộ case. Lỗi tìm được sẽ thuộc vòng này, và khi dev sửa xong bạn mở vòng mới để test lại.',
    sectionCases: 'Bộ test case',
    sectionReport: 'Báo cáo',
    sectionBugs: 'Lỗi',
    noCases: 'Chưa có test case nào',
    noCasesHelp: 'Thêm case đầu tiên ở cuối trang. Case sau có thể nhân bản từ case trước.',
    noSuite: 'Chưa phân nhóm',
    noEnvironments: 'Chưa khai môi trường test',
    noEnvironmentsHelp:
      'Môi trường là nơi bạn chạy test — từng trình duyệt, hoặc điện thoại. Có chúng rồi mới ghi được kết quả cho từng nơi.',
    addDefaultEnvironments: 'Dùng 6 môi trường thông dụng',
    environments: {
      title: 'Môi trường test: {{active}}/{{total}} đang dùng',
      help: 'Mỗi môi trường đang dùng là một cột trong lưới kết quả.',
      manageHelp:
        'Mỗi môi trường đang dùng là một cột trong lưới kết quả. Bấm vào tên để tắt/bật — tắt chứ không xoá, kết quả cũ vẫn giữ.',
      turnOff: 'Bấm để tắt — môi trường này sẽ không còn là cột trong lưới',
      turnOn: 'Bấm để dùng lại môi trường này',
      addPlaceholder: 'Thêm môi trường, vd. iPad Safari',
      add: 'Thêm',
      seeded: 'Đã thêm {{count}} môi trường test.',
      readyTitle: 'Môi trường đã sẵn sàng',
      readyHelp:
        'Bước tiếp theo: thêm test case (nút ở cuối trang hoặc sinh bằng AI), rồi mở vòng test ở thanh phía trên. Khi đó mỗi môi trường ở trên thành một cột để ghi kết quả.',
    },
    colCase: 'Test case',
    colAll: 'Mọi nơi',
    allPass: 'Đều đạt',
    allPassHelp: 'Ghi “đạt” cho mọi môi trường của case này trong một lần bấm.',
    cycleHelp: 'Bấm để đổi: chưa chạy → đạt → không đạt → bị chặn → bỏ qua',
    priorityHigh: 'Ưu tiên cao',
    preconditions: 'Điều kiện trước khi test',
    steps: 'Các bước làm',
    expected: 'Kết quả mong đợi',
    endpoint: 'Endpoint',
    requirementRef: 'Quy tắc liên quan',
    caseCode: 'Mã case',
    caseTitle: 'Tên case',
    caseTitlePlaceholder: 'Khách chưa đăng nhập bấm nút Bình chọn',
    addCase: 'Thêm case',
    caseAdded: 'Đã thêm test case.',
    caseUpdated: 'Đã lưu test case.',
    editCase: 'Sửa',
    caseCodeLocked:
      'Mã case không đổi được — cả đội đã gọi tên nhau bằng mã này. Cần mã khác thì nhân bản case.',
    caseKind: 'Loại case',
    kind: { ui: 'Giao diện', api: 'API' },
    priorityLabel: 'Ưu tiên',
    priority: { high: 'Cao', medium: 'Trung bình', low: 'Thấp' },
    caseSuite: 'Nhóm',
    newSuite: '+ Nhóm mới…',
    newSuiteName: 'Tên nhóm mới',
    newSuitePlaceholder: 'Xác thực',
    preconditionsPlaceholder: 'Trình duyệt chưa đăng nhập, đã xoá cookie',
    stepsCasePlaceholder: '1. Mở trang danh sách đề cử\n2. Bấm nút Bình chọn',
    stepsCaseHelp: 'Mỗi bước một dòng. Người khác phải làm theo được mà không hỏi lại.',
    expectedPlaceholder: 'Hiện popup yêu cầu đăng nhập, chưa ghi nhận phiếu',
    tool: 'Công cụ',
    requirementRefHelp: 'Mã quy tắc nghiệp vụ mà case này kiểm — để truy ngược khi yêu cầu đổi.',
    status: {
      none: 'Chưa chạy',
      pass: 'Đạt',
      fail: 'Không đạt',
      blocked: 'Bị chặn',
      skipped: 'Bỏ qua',
    },
    reportBug: 'Ghi lỗi',
    bugReported: 'Đã ghi lỗi.',
    bugTitle: 'Lỗi gì',
    bugTitlePlaceholder: 'Tooltip bị cắt chữ trên điện thoại',
    stepsToReproduce: 'Làm thế nào để thấy lại lỗi này',
    stepsPlaceholder: '1. Mở trang chi tiết\n2. Bấm vào nút Bình chọn\n3. Xem tooltip',
    stepsHelp:
      'Phần quan trọng nhất của một lỗi. Dev không sửa được thứ họ không dựng lại được, và thiếu nó thường mất thêm một vòng test.',
    noStepsWarning: 'Lỗi này chưa có các bước tái hiện — dev sẽ khó sửa và có thể trả lại.',
    severityLabel: 'Mức nghiêm trọng',
    severity: { critical: 'Nghiêm trọng', high: 'Cao', medium: 'Trung bình', low: 'Thấp' },
    environment: 'Xảy ra ở đâu',
    anyEnvironment: 'Mọi nơi / chưa rõ',
    category: 'Thuộc phần nào',
    categoryPlaceholder: 'Giao diện - trang chi tiết',
    attachment: 'Ảnh hoặc video',
    save: 'Lưu',
    noBugs: 'Chưa ghi lỗi nào',
    noBugsHelp: 'Khi chạy test mà thấy sai, bấm “Ghi lỗi” để nó vào danh sách và vào báo cáo.',
    allBugsClosed: 'Không còn lỗi nào phải làm',
    bugState: {
      open: 'Mới ghi',
      fixing: 'Đang sửa',
      retest: 'Chờ test lại',
      closed: 'Đã xong',
      reopened: 'Mở lại',
      rejected: 'Không phải lỗi',
    },
    fixTasks: 'Việc sửa lỗi',
    noFixTasks: 'Chưa gắn việc nào. Lỗi sửa ngay trong ngày thì không cần tạo việc.',
    fixTaskType: 'Loại việc',
    createFixTask: 'Tạo việc sửa lỗi',
    fixTaskCreated: 'Đã tạo việc sửa lỗi và gắn vào lỗi này.',
    unlink: 'Bỏ gắn',
    unlinkHelp: 'Chỉ bỏ liên kết, không xoá việc — việc có thể đang sửa cả lỗi khác.',
    fixTaskHelp:
      'Việc sửa lỗi lên kế hoạch và vào burndown như mọi việc khác. Nhưng kéo việc sang Xong KHÔNG đóng lỗi — chỉ tester test lại mới đóng được.',
    bugsFixedHere: 'Lỗi mà việc này sửa',
    taskDoneNotClosed:
      'Kéo việc này sang Xong không đóng các lỗi trên. Tester phải test lại và xác nhận hết lỗi.',
    assigneeOptional: 'Người sửa (tuỳ chọn)',
    assigneeHelp: 'Chọn luôn thì lỗi vào thẳng cột Đang sửa. Bỏ trống thì nằm ở Chờ giao.',
    assigneeSelfOnly: 'Bạn chỉ tự nhận được — giao cho người khác cần quyền quản lý kiểm thử.',
    dueDate: 'Hạn sửa',
    board: {
      filterLabel: 'Lọc',
      mine: 'Việc của tôi',
      all: 'Tất cả',
      anySeverity: 'Mọi mức độ',
      anyEnvironment: 'Mọi môi trường',
      mineEmpty: 'Bạn không có lỗi nào cần xử lý — đang hiện tất cả.',
      noMatch: 'Không có lỗi nào khớp bộ lọc.',
      column: {
        assign: 'Chờ giao',
        fix: 'Đang sửa',
        verify: 'Chờ kiểm lại',
        done: 'Đã xong',
      },
      columnEmpty: 'Trống',
      expandDone: 'Mở cột Đã xong',
      collapseDone: 'Gập cột Đã xong',
      doneCollapsed: '{{n}} lỗi đã xong — bấm tiêu đề cột để xem.',
      reopened: 'Bị trả lại · lần {{n}}',
      due: 'hạn {{date}}',
      waitAssign: 'Chưa ai nhận',
      waitVerify: 'chờ {{name}} kiểm',
      rejected: 'Không phải lỗi',
      unknownUser: 'Người đã rời dự án',
    },
    detail: {
      waiting: {
        assign: 'Đang chờ: PM giao người sửa',
        fix: 'Đang chờ: {{name}} sửa',
        fixDue: 'Đang chờ: {{name}} sửa — hạn {{date}}',
        verify: 'Đang chờ: {{name}} kiểm lại',
        closed: 'Đã xong — lỗi đã đóng',
        rejected: 'Đã kết luận không phải lỗi',
      },
      action: {
        assign: 'Giao cho…',
        take: 'Tôi nhận',
        fixed: 'Đã sửa xong',
        pass: '✓ Hết lỗi',
        fail: '✗ Vẫn lỗi',
        reopen: 'Mở lại',
        more: 'Thao tác khác',
        reject: 'Không phải lỗi',
        giveBack: 'Trả lại',
        confirm: 'Xác nhận',
        cancel: 'Thôi',
      },
      noAction: 'Bước này không phải việc của bạn.',
      fixedComment: 'Ghi chú cho người kiểm lại (tuỳ chọn)',
      fixedCommentPlaceholder: 'Đã sửa gì, ở đâu',
      failComment: 'Vẫn thấy gì?',
      failCommentPlaceholder: 'Trên Mobile Chrome vẫn lưu được',
      failCommentHelp: 'Bắt buộc — người sửa cần biết lần này khác lần trước ở đâu.',
      reason: 'Lý do',
      rejectPlaceholder: 'Đúng theo đặc tả mục …',
      reopenPlaceholder: 'Bản dựng mới lại thấy lỗi',
      done: {
        assigned: 'Đã giao.',
        taken: 'Đã nhận lỗi.',
        givenBack: 'Đã trả lại — lỗi về Chờ giao.',
        fixed: 'Đã báo sửa xong — lỗi chuyển sang Chờ kiểm lại.',
        pass: 'Đã đóng lỗi.',
        fail: 'Đã trả lại cho người sửa.',
        rejected: 'Đã kết luận không phải lỗi.',
        reopened: 'Đã mở lại lỗi.',
        saved: 'Đã lưu.',
      },
      fieldAssignee: 'Người sửa',
      fieldDue: 'Hạn sửa',
      fieldSeverity: 'Mức độ',
      fieldEnvironment: 'Môi trường',
      fieldReporter: 'Người báo',
      fieldSource: 'Từ case',
      sourceLine: '{{code}} · Vòng {{round}}',
      noDue: 'Chưa đặt',
      noSource: 'Ghi tay, không từ ô nào',
      unassigned: 'Chưa giao',
      description: 'Mô tả, kết quả thực tế',
      evidence: 'Ảnh, video',
      history: 'Lịch sử',
      event: {
        reported: '{{actor}} ghi lỗi',
        reportedAssigned: '{{actor}} ghi lỗi, giao cho {{assignee}}',
        assigned: '{{actor}} giao cho {{assignee}}',
        taken: '{{actor}} tự nhận',
        unassigned: '{{actor}} bỏ giao',
        fixed: '{{actor}}: Đã sửa xong',
        wont_fix: '{{actor}}: đề nghị không sửa',
        verified_pass: '{{actor}}: ✓ Hết lỗi',
        verified_fail: '{{actor}}: ✗ Vẫn lỗi',
        returned: 'Trả lại cho {{assignee}}',
        rejected: '{{actor}}: Không phải lỗi',
        reopened: '{{actor}} mở lại',
        someone: 'Ai đó',
        round: 'Vòng {{number}}',
      },
      plan: 'Thêm vào kế hoạch (tạo việc sửa lỗi)',
    },
    failCell: {
      title: 'Không đạt: {{code}} · {{place}}',
      noEnvironment: 'không theo môi trường',
      modeNew: 'Ghi lỗi mới',
      modeExisting: 'Gắn lỗi có sẵn',
      modeOnly: 'Chỉ đánh Không đạt',
      actual: 'Thực tế thấy gì',
      actualPlaceholder: 'Bấm Lưu không có phản hồi, nút vẫn quay',
      expected: 'Kỳ vọng',
      stepsFromCase: 'Các bước (lấy từ case)',
      pickBug: 'Lỗi nào',
      noOpenBugs: 'Chưa có lỗi nào đang mở để gắn — ghi lỗi mới.',
      onlyHelp: 'Ô chuyển sang Không đạt, không ghi lỗi. Dùng khi lỗi đã được ghi ở chỗ khác.',
      description: 'Kỳ vọng: {{expected}}\nThực tế: {{actual}}',
      reported: 'Đã ghi lỗi và gắn vào ô.',
      linked: 'Đã đánh Không đạt và gắn lỗi #{{code}}.',
      marked: 'Đã đánh Không đạt.',
    },
  },
  testGen: {
    title: 'Sinh case bằng AI',
    open: 'Sinh case bằng AI',
    help: 'Chọn những việc cần kiểm, AI đọc mô tả việc cùng tài liệu gắn kèm rồi đề xuất bộ case. Việc đã xong thường có tài liệu nên case dày hơn; việc chưa xong vẫn sinh được case ở mức luồng chính.',
    run: 'Sinh case',
    prompt: 'Sinh test case cho những việc tôi đã chọn.',
    groupFilter: 'Nhóm việc',
    allGroups: 'Mọi nhóm',
    noGroup: 'Chưa thuộc nhóm',
    pickGroup: 'Chọn cả mục',
    dropGroup: 'Bỏ cả mục',
    pickedCount: 'Đã chọn {{n}}/{{max}} việc',
    noTasks: 'Không có việc nào khớp bộ lọc.',
    doneHint: 'có tài liệu ⇒ case dày hơn',
    category: { todo: 'Chưa làm', in_progress: 'Đang làm', done: 'Hoàn thành' },
    why: 'Căn cứ',
    gaps: 'AI tự thấy chỗ chưa đủ dữ liệu',
    accept: 'Tạo {{n}} case',
    thenOpenRound: 'Mở vòng test mới sau khi tạo',
    created: 'Đã thêm {{n}} case vào bộ case.',
  },
  staffing: {
    title: 'Giá thuê và tốc độ',
    subtitle:
      'Giá dự án trả cho mỗi giờ của từng người, và tốc độ của họ so với mức trung bình chuẩn. Đây không phải lương.',
    member: 'Thành viên',
    hireRate: 'Giá thuê (đ/giờ)',
    speed: 'Hệ số tốc độ',
    notSet: 'chưa đặt',
    save: 'Lưu',
    saved: 'Đã lưu.',
    loadFailed: 'Không tải được bảng nhân sự.',
    bucket: { simple: 'Việc dễ', standard: 'Việc vừa', hard: 'Việc khó' },
    bucketHint: 'Dễ: tới 4 giờ · Vừa: 4–16 giờ · Khó: trên 16 giờ',
    factorHint:
      '1,00 là mức trung bình chuẩn. Nhỏ hơn 1 là nhanh hơn, lớn hơn 1 là chậm hơn. Giờ ước lượng của việc là giờ của một người ở mức chuẩn.',
    learned: 'Đo được: {{value}}',
    learnedSamples: '({{count}} việc)',
    learnedNone: 'chưa đủ dữ liệu',
    learnedHint:
      'Số đo được từ việc đã xong, chỉ để bạn tham khảo. Nó không tự vào phép tính tiền — chỉ hệ số bạn đặt mới tính.',
    noLevel: 'Chưa xếp bậc',
    useCustom: 'Giá riêng',
    noRate: 'Chưa có giá thuê — việc của người này chưa tính được tiền.',
    rateFrom: {
      custom: 'Đang áp: {{value}}đ/giờ (giá riêng của dự án này).',
      level: 'Đang áp: {{value}}đ/giờ (mặc định theo bậc, do tổ chức đặt).',
      none: 'Chưa có giá thuê.',
    },
    autofill: 'Điền tự động theo bậc',
    autofillHint:
      'Điền giá thuê và hệ số tốc độ ước tính theo bậc của từng người vào các ô còn trống. Ô đã có số giữ nguyên.',
    autofillNothing: 'Không còn ô trống nào điền được theo bậc.',
    autofillConfirm:
      'Điền {{rates}} giá thuê và {{speeds}} hệ số tốc độ còn trống bằng số ước tính theo bậc? Ô đã có số giữ nguyên, và sửa lại được từng ô.',
    autofillSkipped: 'Bỏ qua người chưa xếp bậc: {{names}}.',
    unleveledTitle_one: '{{count}} người chưa xếp bậc nên chưa có giá thuê: {{names}}.',
    unleveledTitle_other: '{{count}} người chưa xếp bậc nên chưa có giá thuê: {{names}}.',
    unleveledHint:
      'Nút điền tự động không đoán giá cho họ. Quản trị tổ chức xếp bậc ở Sơ đồ tổ chức, hoặc chọn "Giá riêng" ở hàng của từng người và nhập tay.',
    unleveledLink: 'Mở Sơ đồ tổ chức',
    autofillApply: 'Điền và lưu',
    autofillNote: 'Ước tính ban đầu theo bậc {{level}}',
    empty: 'Dự án chưa có thành viên nào.',
    /** Chip giá đang áp ở đầu thẻ mỗi người. */
    perHour: '{{value}}đ/giờ',
    noRateShort: 'Chưa có giá',
    /** Bảng — người dùng yêu cầu 2026-10-15. */
    effective: 'Đang áp',
    rateMode: 'Cách tính giá thuê',
    /** Ô chọn của bảng — con số ở cột Đang áp. */
    byLevel: 'Theo bậc',
  },
  designControl: {
    narration: {
      aiButton: 'Thuyết minh bằng AI',
      aiLabel: 'Thuyết minh thay đổi thiết kế',
      aiResult_one: 'AI thuyết minh {{count}} thay đổi',
      aiResult_other: 'AI thuyết minh {{count}} thay đổi',
      applied_one: 'Đã thêm {{count}} lời thuyết minh chờ duyệt.',
      applied_other: 'Đã thêm {{count}} lời thuyết minh chờ duyệt.',
      summary: 'Tổng kết',
      write: 'Viết lời thuyết minh',
      summaryPlaceholder: 'Thay đổi nào đáng chú ý nhất với người dùng?',
      changePlaceholder: 'Thay đổi này có ý nghĩa gì với người dùng?',
    },
    ai: {
      button: 'Mô tả bằng AI',
      label: 'Mô tả màn hình thiết kế',
      result_one: 'AI viết mô tả cho {{count}} màn hình',
      result_other: 'AI viết mô tả cho {{count}} màn hình',
      apply: 'Đưa vào để duyệt',
      applied_one: 'Đã thêm {{count}} mô tả chờ duyệt — mở từng màn hình để duyệt.',
      applied_other: 'Đã thêm {{count}} mô tả chờ duyệt — mở từng màn hình để duyệt.',
    },
    compare: {
      title: 'So sánh bản chụp',
      open: 'So sánh',
      base: 'Gốc',
      head: 'Mới',
      swap: 'Đảo chiều',
      back: 'Về file',
      pending: 'Đang so sánh hai bản chụp…',
      failed: 'So sánh hỏng. Bấm lại để tính lại.',
      stats: '{{modified}} màn hình đổi · {{added}} thêm · {{removed}} xoá · {{changes}} thay đổi',
      noChanges: 'Hai bản chụp giống hệt nhau.',
      viewed: 'Đã xem',
      renamedFrom: 'Đổi tên từ «{{name}}»',
      movedFrom: 'Chuyển từ {{path}}',
      maybeReplaced: 'Có thể là thay thế của màn hình cùng tên đã xoá',
      truncated: 'Quá nhiều thay đổi — chỉ hiện 200 dòng đầu.',
      mode2up: 'Cạnh nhau',
      modeSwipe: 'Kéo',
      modeOnion: 'Chồng mờ',
      noImage: 'Không có ảnh',
      pickTwo: 'Chọn hai bản chụp đã xong để so sánh.',
      narrationBy: 'Thuyết minh',
    },
    change: {
      text_changed: 'Chữ «{{before}}» → «{{after}}»',
      node_added: 'Thêm «{{after}}»',
      node_removed: 'Xoá «{{before}}»',
      style_changed: '«{{node}}»: {{property}} {{before}} → {{after}}',
      layout_changed: '«{{node}}»: {{property}} {{before}} → {{after}}',
      component_swapped: '«{{node}}» đổi từ {{before}} sang {{after}}',
      shown: 'Hiện «{{node}}»',
      hidden: 'Ẩn «{{node}}»',
      times: '(×{{count}})',
    },
    property: {
      text: 'chữ',
      fills: 'màu nền',
      strokes: 'viền',
      strokeWeight: 'độ dày viền',
      effects: 'hiệu ứng',
      cornerRadius: 'bo góc',
      opacity: 'độ mờ',
      fontFamily: 'phông',
      fontWeight: 'độ đậm',
      fontSize: 'cỡ chữ',
      lineHeight: 'giãn dòng',
      letterSpacing: 'giãn chữ',
      textAlign: 'căn lề',
      position: 'vị trí',
      size: 'kích thước',
      parent: 'khung chứa',
      direction: 'hướng xếp',
      gap: 'khoảng cách',
      padding: 'lề trong',
      justify: 'căn chính',
      align: 'căn phụ',
      wrap: 'xuống dòng',
    },
    tab: {
      emptyTitle: 'Chưa gắn file Figma nào',
      step1: 'Quản trị viên tổ chức nhập token Figma (Quản trị › Figma).',
      step2: 'Dán link file Figma — có node-id thì chỉ lấy phần đó (một trang, một section).',
      step3: 'Bấm Chụp: hệ thống lưu mô tả và ảnh từng màn hình lên kho lưu trữ.',
      notBackup:
        'Bản chụp là JSON và ảnh của từng màn hình — đủ để xem lại, mô tả và so sánh, nhưng KHÔNG mở lại được trong Figma. Bản gốc và lịch sử phiên bản vẫn do Figma giữ.',
      askWriter: 'Nhờ PM hoặc người có quyền sửa thiết kế gắn file.',
      linkLabel: 'Link file Figma',
      link: 'Gắn file',
      linking: 'Đang đọc file…',
      linked: 'Đã gắn: {{screens}} màn hình, lần chụp đầu dùng khoảng {{calls}} lượt API Figma.',
      alreadyLinked: 'File này đã gắn vào dự án — mở file đó.',
      noSnapshot: 'Chưa có bản chụp',
      screenCount_one: '{{count}} màn hình',
      screenCount_other: '{{count}} màn hình',
      remoteUpdate: 'Có bản mới trên Figma',
      viewerBadge: 'Token chỉ có quyền xem',
      viewerWarning:
        'Token này chỉ có quyền xem file — Figma giới hạn 20 lượt đọc mỗi tháng, đủ cho khoảng một lần chụp. Hãy dùng token của người có ghế Full hoặc Dev.',
      allFiles: 'Tất cả file',
      openInFigma: 'Mở trong Figma',
      snapshot: 'Bản chụp',
      capture: 'Chụp bản mới nhất',
      estimate: 'Lần trước dùng {{calls}} lượt API Figma',
      estimateFirst: 'Lần chụp đầu — số lượt API Figma hiện sau khi xong',
      pickVersion: 'Chọn phiên bản cũ…',
      captureQueued: 'Đã xếp lịch chụp. Trang tự cập nhật khi xong.',
      captureExists: 'Phiên bản này đã có bản chụp.',
      captureHint: 'Bấm Chụp để lưu phiên bản hiện tại của file.',
      queuedHint: 'Đang đọc Figma và lưu ảnh. Trang tự cập nhật.',
      exportMd: 'Tải bản mô tả (.md)',
      search: 'Tìm màn hình…',
      showHidden: 'Hiện cả component, mảnh và màn hình đã ẩn',
      noMatch: 'Không có màn hình nào khớp.',
      noImage: 'Không có ảnh',
    },
    status: {
      queued: 'Đang chụp',
      fetching: 'Đang đọc Figma',
      rendering: 'Đang lưu ảnh',
      ready: 'Xong',
      partial: 'Xong, vài ảnh lỗi',
      failed: 'Chụp hỏng',
    },
    kind: { screen: 'Màn hình', component: 'Component', fragment: 'Mảnh' },
    textStatus: { ai_suggested: 'AI gợi ý', approved: 'Đã duyệt', manual: 'Viết tay' },
    screen: {
      description: 'Mô tả',
      none: 'Chưa có mô tả cho màn hình ở phiên bản này.',
      write: 'Viết mô tả',
      edit: 'Sửa',
      approve: 'Duyệt',
      save: 'Lưu mô tả',
      saved: 'Đã lưu mô tả.',
      template:
        'Mục đích: …\n\nThành phần chính (trên → dưới):\n- …\n\nHành động người dùng:\n- …\n\nTrạng thái / biến thể:\n- …',
      hide: 'Ẩn khỏi danh sách',
      show: 'Hiện trong danh sách',
      downloadJson: 'Tải JSON',
    },
    figma: {
      title: 'Figma',
      subtitle:
        'Token Figma của tổ chức, để tab Thiết kế đọc file, chụp màn hình và so sánh các phiên bản.',
      seatWarning:
        'Dùng token của người có ghế Full hoặc Dev trong team sở hữu file. Figma tính hạn mức theo ghế của người tạo token: ghế View chỉ được 20 lượt đọc mỗi tháng — đủ cho khoảng một lần chụp.',
      scopes:
        'Khi tạo token ở Figma (Settings › Security › Personal access tokens), chỉ cần ba quyền đọc: file_content:read, file_metadata:read, file_versions:read.',
      none: 'Chưa có token. Tab Thiết kế chưa đọc được file Figma nào.',
      active: 'Đang dùng: {{label}} · •••• {{last4}}',
      account: 'Tài khoản Figma: {{handle}}',
      verifiedAt: 'Kiểm tra lần cuối: {{at}}',
      notVerified: 'Chưa kiểm tra được với Figma.',
      verify: 'Kiểm tra lại',
      verifying: 'Đang kiểm…',
      revoke: 'Thu hồi',
      confirmRevoke:
        'Thu hồi token này? Tab Thiết kế sẽ không chụp được bản mới cho tới khi có token khác.',
      revoked: 'Đã thu hồi token.',
      history: '{{count}} token cũ đã thu hồi',
      replaceHint: 'Lưu token mới sẽ thu hồi token đang dùng.',
      label: 'Tên gợi nhớ',
      labelPlaceholder: 'vd Ghế Full của Hằng',
      token: 'Personal access token',
      testFile: 'Link một file để thử (không bắt buộc)',
      testFilePlaceholder: 'https://www.figma.com/design/…',
      save: 'Lưu và kiểm tra',
      saving: 'Đang kiểm…',
      testOk: 'Token dùng được — tài khoản {{handle}}.',
      testOkFile: 'Token dùng được — tài khoản {{handle}}, đọc được file «{{file}}».',
      testSavedUnverified: 'Đã lưu, nhưng chưa kiểm được với Figma: {{reason}}',
      testFileFailed:
        'Token dùng được (tài khoản {{handle}}) nhưng không đọc được file thử: {{reason}}',
    },
  },
  /**
   * Bấm giờ làm việc — APM-TIME.
   *
   * ⚠️ Tên khối là `timesheet`, không phải `time`: khoá cấp cao nhất phải nói
   * đúng miền của nó (bài học `budget` ở APM-AI-n — một khoá trùng tên đè lên
   * khối khác, và typecheck không bắt vì `en.ts`/`vi.ts` chỉ cần khớp nhau).
   */
  timesheet: {
    errors: {
      TIMESHEET_TASK_DONE: 'Việc này đã xong — không bấm giờ cho nó được nữa.',
      TIMESHEET_TASK_NOT_MINE:
        'Việc này đang giao cho người khác — chỉ bấm giờ được việc của mình.',
      TIMESHEET_DAY_CAPPED: 'Hôm nay bạn đã bấm đủ {{hours}} giờ — mai bấm tiếp nhé.',
    },
    title: 'Timesheet',
    person: 'Người',
    me: 'Tôi',
    total: 'Tổng',
    avgPerDay: 'TB/ngày',
    noEntry: 'Chưa bấm giờ',
    previousWeek: 'Tuần trước',
    nextWeek: 'Tuần sau',
    thisWeek: 'Tuần này',
    hoursShort: '{{hours}} giờ',
    showDetail: 'Hiện chi tiết',
    hideDetail: 'Thu gọn',
    weekTotal: 'Tổng {{hours}} giờ',
    noFutureWeek: 'Chưa tới tuần này nên chưa có giờ nào',
    scheduledFooter: 'Theo lịch làm việc của bạn: {{hours}} giờ tuần này',
    overtimeFooter: 'Làm thêm giờ tuần này: {{hours}} giờ',
    overtimeCappedNote: '— trong đó {{hours}} giờ do hệ thống tự dừng, kiểm lại giúp',
    overtimeBadge: '{{hours}}g OT',
    regularGroup: 'Trong giờ',
    overtimeGroup: 'Ngoài giờ',
    overtimeTitle: 'Làm thêm giờ (ngoài ca): {{hours}} giờ',
    overtimeWindow: '90 ngày gần nhất: {{hours}} giờ làm thêm, rải trên {{days}} ngày',
    overtimeHelpLabel: 'giờ làm thêm',
    entryDetail: {
      open: 'Xem kết quả từng khung giờ của {{key}}',
      title: '{{key}} · {{date}}',
      person: 'Người bấm giờ: {{name}}',
      minutes: '{{count}} phút',
      dayTotal: 'Cả ngày',
      session: 'Khung {{from}} – {{to}}',
      running: 'đang chạy',
      progress: 'Tiến độ',
      progressValue: '{{from}}% → {{to}}%',
      checklist: 'Checklist',
      checklistChecked: '+{{count}} mục',
      checklistUnchecked: '−{{count}} bỏ tick',
      checklistNone: 'Không có checklist',
      checklistNoChange: 'Không đổi',
      completedLabel: 'Hoàn thành',
      completedYes: 'Hoàn thành lúc {{time}}',
      completedNo: 'Chưa hoàn thành trong khung',
      noSession: 'Không còn phiên bấm giờ nào của việc này trong ngày.',
      graceNote: 'Tính trong khung bấm giờ, cộng {{minutes}} phút sau khi dừng. Là thay đổi của việc, ai đổi cũng tính.',
    },
    weekday: {
      mon: 'T2',
      tue: 'T3',
      wed: 'T4',
      thu: 'T5',
      fri: 'T6',
      sat: 'T7',
      sun: 'CN',
    },
    create: {
      title: 'Tạo nhanh và bắt đầu làm',
      taskType: 'Loại việc',
      issueKind: 'Loại vấn đề',
      issueKinds: {
        incident: 'Sự cố',
        request: 'Yêu cầu',
        problem: 'Vấn đề gốc',
      },
      titleLabel: 'Tiêu đề',
      description: 'Mô tả (không bắt buộc)',
      estimateHours: 'Ước lượng (giờ)',
      dueDate: 'Hạn',
      impact: 'Mức ảnh hưởng',
      urgency: 'Mức gấp',
      scale: {
        '1': 'Thấp',
        '2': 'Trung bình',
        '3': 'Cao',
      },
      startNow: 'Bắt đầu bấm giờ ngay sau khi tạo',
      createOnly: 'Tạo',
      created: 'Đã tạo',
    },
    // Cái nút ở góc màn hình — APM-TIME-f/g.
    fab: {
      running: 'Đang làm: {{title}}',
      paused: 'Đang tạm dừng: {{title}}',
      idle: 'Trong giờ làm mà chưa bắt đầu việc nào',
      off: 'Ngoài giờ làm việc',
    },
    stopConfirm: {
      title: 'Dừng bấm giờ?',
      body: 'Bạn đang bấm giờ việc “{{title}}”. Việc xong thì đồng hồ sẽ tự dừng.',
      confirm: 'Xong và dừng bấm giờ',
    },
    panel: {
      working: 'Đang làm',
      switchTo: 'Chuyển sang',
      quickCreate: 'Tạo nhanh',
      newTask: 'Việc mới',
      newIssue: 'Vấn đề mới',
      pause: 'Tạm dừng',
      stop: 'Dừng',
      resume: 'Tiếp tục',
      start: 'Bắt đầu',
      nothingRunning: 'Chọn một task hoặc tạo task mới để bắt đầu công việc',
      nothingToSwitch: 'Không có việc nào đang làm dở',
      todayTotal: 'Thời gian làm việc hôm nay: {{hours}} giờ',
      nextShift: 'Ca tiếp theo lúc {{time}}',
      offHours: 'Ngoài giờ làm việc — bấm bắt đầu nếu bạn đang làm thêm',
      resumeOffer: 'Đã sang ca mới. Tiếp tục «{{title}}»?',
      overdue_one: 'Việc này đã quá hạn {{count}} ngày — cập nhật tiến độ hoặc dời hạn',
      overdue_other: 'Việc này đã quá hạn {{count}} ngày — cập nhật tiến độ hoặc dời hạn',
      countdownDays: 'Còn {{days}} ngày {{hours}} giờ',
      countdownClock: 'Còn {{clock}}',
      countdownOver: 'Đã quá hạn',
      dueAt: '· hạn {{date}}',
      openTask: 'Mở việc',
      progressOnlyOnActive: 'Chuyển sang việc này rồi mới cập nhật được tiến độ',
      project: 'Dự án',
      titlePlaceholder: 'Tên việc cần làm',
      createAndStart: 'Tạo và bắt đầu',
      noProject: 'Bạn chưa ở dự án nào',
      started: 'Đã bắt đầu bấm giờ',
      paused_toast: 'Đã tạm dừng',
      stopped: 'Đã dừng',
    },
  },
  teamReport: {
    /** Ủy quyền làm thay — APM-TWRD-d. */
    delegation: {
      title: 'Ủy quyền làm thay',
      hint: 'Chọn một người trong team tạo và chốt báo cáo công việc team thay bạn — ví dụ khi bạn nghỉ phép.',
      assign: 'Ủy quyền',
      change: 'Đổi người',
      revoke: 'Thu hồi',
      none: 'Chưa ủy quyền cho ai.',
      since: 'từ {{date}}',
      until: 'tới hết {{date}}',
      untilRevoked: 'tới khi thu hồi',
      pick: 'Người làm thay',
      pickPlaceholder: '— Chọn một người trong team —',
      endsAt: 'Hết hạn (tuỳ chọn)',
      seesData:
        'Người này thấy số liệu của cả team như bạn: việc đã làm, workload, giờ khai. Mỗi lần xem đều được ghi vết.',
      usesYourAi:
        'AI của những báo cáo họ soạn chạy bằng key AI của bạn và tính vào hạn mức của bạn.',
      oneAtATime: 'Mỗi lúc một người — chọn người mới thì người cũ tự hết quyền.',
      save: 'Lưu ủy quyền',
      granted: 'Đã ủy quyền',
      revoked: 'Đã thu hồi ủy quyền',
      history: 'Lịch sử ủy quyền ({{count}})',
      historyRow: '{{name}} · {{from}} → {{to}}',
      actingFor: 'Bạn đang làm thay báo cáo công việc team cho {{name}}',
      aiOf: 'AI chạy bằng nguồn AI của {{name}}',
      aiOffOf: '{{name}} chưa cấu hình AI — bạn vẫn tự viết được lời văn',
      createFor: 'Tạo báo cáo thay cho {{name}}',
      createTitleFor: 'Tạo báo cáo công việc team thay cho {{name}}',
      byline: '{{delegate}} soạn thay cho {{manager}}',
      runWithAi: 'Viết bằng AI của {{name}}',
      readOnlyNow: 'Bạn đã hết quyền làm thay — chỉ còn xem được bản này.',
      listBy: '{{name}} soạn thay',
    },
    memberStats: {
      label: 'Số liệu từng thành viên',
      member: 'Thành viên',
      tasksDone: 'Task xong',
      issuesResolved: 'Issue xong',
      workload: 'Workload',
      workloadHelp: '{{committed}} giờ việc được giao / {{capacity}} giờ làm việc trong kỳ',
      loggedHours: 'Giờ đã khai',
      avgPerDay: 'TB/ngày trọn',
      avgHelp:
        '{{hours}} trong {{days}} ngày làm trọn ngày — không tính ngày làm nửa buổi, ngày nghỉ, ngày lễ',
      text: '{{name}}: {{tasks}} task xong · {{issues}} issue xong · workload {{workload}} · đã khai {{logged}} · TB {{avg}}/ngày trọn',
    },
    projectOverview: {
      priority: 'Ưu tiên',
      status: 'Trạng thái',
      progress: 'Hoàn thành',
      progressValue: '{{pct}}% ({{done}}/{{total}} task)',
      weekDelta: 'So với tuần trước',
      weekDeltaHelp: '{{pct}}% cách đây 7 ngày tính từ cuối kỳ',
      period: 'Bắt đầu – Kết thúc',
      pm: 'PM',
      members: 'Thành viên',
      membersCount: '{{count}} người',
      membersTitle: 'Thành viên dự án ({{count}})',
      noPm: 'Chưa có PM',
      narrative: 'Thuyết minh',
      text: '{{status}} · Hoàn thành {{progress}} · So với tuần trước {{delta}} · {{period}} · PM: {{pm}} · {{members}}',
    },
    title: 'Báo cáo công việc team',
    subtitle:
      'Tổng hợp việc cấp dưới trực tiếp đã làm trong một kỳ — số liệu chụp lúc tạo, lời văn tự viết hoặc nhờ AI soạn nháp.',
    topSummary: 'Tóm tắt theo dự án',
    sections: {
      mine: 'Báo cáo tôi tạo',
      aboutMe: 'Báo cáo về tôi',
      managed: 'Team tôi quản lý gián tiếp',
    },
    ai: {
      generate: 'Viết tóm tắt bằng AI',
      title: 'Nhờ AI viết nháp lời văn',
      promptHelp: 'Để trống thì AI dùng yêu cầu đã ghi lúc tạo báo cáo.',
      replaceConfirm:
        'Báo cáo đã có lời văn. Thay lời văn hiện tại bằng bản AI viết? Phần đã sửa tay sẽ mất.',
      run: 'Viết nháp',
      replace: 'Thay lời văn',
      ready: 'AI đã viết nháp lời văn — đọc lại và sửa trước khi chốt',
      readyPartial: 'AI viết được một phần lời văn — xem dải cảnh báo trên báo cáo',
    },
    tabs: { projects: 'Theo dự án', people: 'Theo người' },
    detail: { low: 'Ít', medium: 'Vừa', high: 'Nhiều' },
    status: {
      finalized: 'Đã chốt {{date}}',
      draftEmpty: 'Nháp, chưa có lời văn',
    },
    source: {
      ai: 'Nháp do AI soạn',
      ai_edited: 'AI soạn, đã sửa',
      manual: 'Nháp tự viết',
    },
    viewTitle: 'Báo cáo công việc team — {{name}}',
    backToList: 'Về danh sách báo cáo',
    capturedAt: 'Số liệu chụp lúc {{at}}',
    truncated:
      'Số liệu đã bị cắt bớt vì vượt trần (200 việc mỗi người mỗi dự án, hoặc 2 MB cả báo cáo) — những hạng mục cũ nhất không có trong bảng.',
    copy: 'Sao chép dạng văn bản',
    copied: 'Đã sao chép báo cáo',
    copyFailed: 'Không sao chép được — trình duyệt chỉ cho phép khi mở bằng https hoặc localhost.',
    writeNarrative: 'Tự viết tóm tắt',
    editNarrative: 'Sửa lời văn',
    finalize: 'Chốt',
    discard: 'Bỏ bản nháp',
    finalizeTitle: 'Chốt báo cáo?',
    finalizeConfirm:
      'Không sửa được sau khi chốt. Cấp trên và từng thành viên (chỉ phần của mình) sẽ xem được bản này.',
    discardTitle: 'Bỏ bản nháp?',
    discardConfirm:
      'Bản nháp và lời văn đã viết sẽ bị bỏ. Số liệu thì tạo lại được bất cứ lúc nào.',
    finalized: 'Đã chốt báo cáo',
    discarded: 'Đã bỏ bản nháp',
    notFound: 'Không tìm thấy báo cáo, hoặc bạn không có quyền xem.',
    noProjects: 'Không có hoạt động nào được ghi nhận trong kỳ này.',
    noNarrative: 'Chưa có lời tóm tắt cho dự án này.',
    noActivity: 'Không có hoạt động ghi nhận trong kỳ.',
    refs: 'Tham chiếu:',
    hours: '{{hours}} giờ',
    counts: '{{done}} việc xong · {{ongoing}} đang làm · {{issues}} vấn đề · {{hours}} giờ',
    facts: {
      toggle: 'Bảng số liệu',
      item: 'Hạng mục',
      state: 'Tình trạng',
      hours: 'Giờ',
      doneAt: 'Xong {{date}}',
      ongoing: 'Đang làm ({{status}})',
      resolvedAt: 'Xử lý {{date}}',
      workedOfEstimate: '{{worked}} / ước {{estimate}}',
      hoursOnly: 'Chỉ có giờ bấm, không có việc xong hay vấn đề đã xử lý.',
      progressColumn: 'Tiến độ',
      progress: '{{from}}% → {{to}}% ({{delta}})',
      progressTo: '{{to}}%',
      checklistDone_one: '{{count}} mục checklist đã xong',
      checklistDone_other: '{{count}} mục checklist đã xong',
    },
    editor: {
      help: 'Ô để trống thì mục đó không có lời. Số liệu bên dưới không đổi theo lời văn.',
      summary: 'Tóm tắt trên cùng — mỗi dự án một ô, mỗi dòng một việc',
      summaryHelp:
        'Điền sẵn từ số liệu: việc đã xong, mục checklist đã xong, việc đang tiếp tục làm. Mỗi dòng hiện thành một gạch đầu dòng, dòng trống thì bỏ. Không ghi con số tiến độ ở phần này.',
      summaryFor: 'Tóm tắt của dự án {{name}}',
      overview: 'Tóm tắt chung cho cả team',
      projectSummary: 'Dự án này team đã làm được gì',
      highlights: 'Điểm nổi bật — mỗi dòng một ý (tuỳ chọn)',
      highlightsFor: 'Điểm nổi bật của {{name}}',
      personOverview: 'Người này đã làm được gì trong kỳ',
      personProject: '{{name}} ở {{project}}',
      save: 'Lưu lời văn',
      saved: 'Đã lưu lời văn',
      needOverview: 'Cần có tóm tắt chung cho cả team.',
      needSummary: 'Cần ít nhất một dòng tóm tắt trên cùng.',
      needProjectSummary: 'Dự án {{name}} có điểm nổi bật nhưng chưa có tóm tắt.',
      needPersonOverview: '{{name}} có lời theo dự án nhưng chưa có tóm tắt chung.',
      tooLong:
        'Có đoạn quá dài (tối đa {{max}} ký tự một đoạn; 500 ký tự một dòng và 50 dòng cho điểm nổi bật và cho mỗi ô tóm tắt trên cùng).',
    },
    list: {
      period: 'Kỳ',
      manager: 'Người tạo',
      detail: 'Mức chi tiết',
      members: 'Số người',
      status: 'Trạng thái',
      createdAt: 'Ngày tạo',
      emptyMine: 'Chưa có báo cáo nào',
      emptyMineHelp: 'Bấm "Tạo báo cáo" để tổng hợp việc của team trong một kỳ.',
      emptyAboutMe: 'Chưa có báo cáo nào về bạn',
      emptyAboutMeHelp:
        'Khi quản lý trực tiếp của bạn chốt một báo cáo có tên bạn, phần của bạn hiện ở đây. Chỉ quản lý trực tiếp của một team mới tạo được báo cáo — quản lý trực tiếp đặt ở Sơ đồ tổ chức.',
    },
    create: {
      open: 'Tạo báo cáo',
      title: 'Tạo báo cáo công việc team',
      period: 'Kỳ báo cáo',
      periodRange: 'Kỳ: {{period}}',
      from: 'Từ ngày',
      to: 'Đến ngày',
      presets: {
        thisWeek: 'Tuần này',
        lastWeek: 'Tuần trước',
        thisMonth: 'Tháng này',
        lastMonth: 'Tháng trước',
        custom: 'Tuỳ chọn',
      },
      detail: 'Mức chi tiết của lời văn',
      detailHelp: {
        low: 'Mỗi dự án vài câu, mỗi người một câu cho mỗi dự án.',
        medium: 'Mỗi dự án một đoạn và các kết quả chính, mỗi người vài câu.',
        high: 'Mọi hạng mục đáng kể, có tham chiếu tới từng việc.',
      },
      members: 'Thành viên ({{count}})',
      membersUnavailable:
        'Không tải được danh sách xem trước — báo cáo vẫn gồm mọi cấp dưới trực tiếp của bạn.',
      noMembers: 'Bạn chưa có cấp dưới trực tiếp nào đang hoạt động.',
      note: 'Yêu cầu thêm cho AI (tuỳ chọn)',
      notePlaceholder: 'Ví dụ: nhấn mạnh các việc liên quan tới đợt phát hành tháng 9',
      auditNotice: 'Tạo và mở báo cáo ghi một dòng vào nhật ký truy cập của từng thành viên.',
      submit: 'Tạo báo cáo',
      created: 'Đã tạo báo cáo',
      needPeriod: 'Chọn đủ ngày bắt đầu và ngày kết thúc.',
      futureTo: 'Ngày kết thúc không được sau hôm nay.',
    },
    text: {
      title: 'Báo cáo công việc team — {{name}}',
      period: 'Kỳ: {{period}}',
      done: '[Xong]',
      ongoing: '[Đang làm]',
      resolved: '[Vấn đề đã xử lý]',
    },
  },
  pptxTransitions: {
    groups: {
      subtle: 'Tinh tế',
      exciting: 'Ấn tượng',
      dynamic: 'Nội dung động',
    },
    kinds: {
      none: 'Không có',
      morph: 'Biến hình',
      fade: 'Mờ dần',
      push: 'Đẩy',
      wipe: 'Lau',
      split: 'Tách',
      reveal: 'Hé lộ',
      cut: 'Cắt',
      randomBar: 'Thanh ngẫu nhiên',
      shape: 'Hình',
      uncover: 'Mở ra',
      cover: 'Che phủ',
      flash: 'Chớp sáng',
      fallOver: 'Ngã xuống',
      drape: 'Rèm buông',
      curtains: 'Màn sân khấu',
      wind: 'Gió',
      prestige: 'Uy nghi',
      fracture: 'Vỡ vụn',
      crush: 'Nghiền',
      peelOff: 'Bóc',
      pageCurlDouble: 'Cuộn trang',
      airplane: 'Máy bay giấy',
      origami: 'Gấp giấy',
      dissolve: 'Tan biến',
      checker: 'Bàn cờ',
      blinds: 'Rèm sáo',
      clock: 'Đồng hồ',
      ripple: 'Gợn sóng',
      honeycomb: 'Tổ ong',
      glitter: 'Lấp lánh',
      vortex: 'Xoáy',
      shred: 'Xé vụn',
      switch: 'Hoán đổi',
      flip: 'Lật',
      gallery: 'Phòng tranh',
      doors: 'Cửa',
      cube: 'Khối lập phương',
      box: 'Hộp',
      comb: 'Răng lược',
      zoom: 'Thu phóng',
      random: 'Ngẫu nhiên',
      pan: 'Lia',
      ferris: 'Vòng đu quay',
      conveyor: 'Băng chuyền',
      window: 'Cửa sổ',
      flythrough: 'Bay qua',
      rotate: 'Xoay',
      orbit: 'Quỹ đạo',
    },
    options: {
      smoothly: 'Mượt',
      throughBlack: 'Qua nền đen',
      fromRight: 'Từ phải',
      fromLeft: 'Từ trái',
      fromBottom: 'Từ dưới',
      fromTop: 'Từ trên',
      fromBottomRight: 'Từ góc dưới phải',
      fromBottomLeft: 'Từ góc dưới trái',
      fromTopRight: 'Từ góc trên phải',
      fromTopLeft: 'Từ góc trên trái',
      verticalOut: 'Dọc, ra ngoài',
      verticalIn: 'Dọc, vào trong',
      horizontalOut: 'Ngang, ra ngoài',
      horizontalIn: 'Ngang, vào trong',
      smoothlyFromRight: 'Mượt, từ phải',
      smoothlyFromLeft: 'Mượt, từ trái',
      throughBlackFromRight: 'Qua nền đen, từ phải',
      throughBlackFromLeft: 'Qua nền đen, từ trái',
      vertical: 'Dọc',
      horizontal: 'Ngang',
      circle: 'Tròn',
      diamond: 'Thoi',
      plus: 'Dấu cộng',
      left: 'Trái',
      right: 'Phải',
      up: 'Lên',
      down: 'Xuống',
      doubleLeft: 'Hai trang, sang trái',
      doubleRight: 'Hai trang, sang phải',
      singleLeft: 'Một trang, sang trái',
      singleRight: 'Một trang, sang phải',
      clockwise: 'Theo chiều kim đồng hồ',
      counterclockwise: 'Ngược chiều kim đồng hồ',
      wedge: 'Hình nêm',
      center: 'Từ giữa',
      in: 'Vào trong',
      out: 'Ra ngoài',
      byObject: 'Theo đối tượng',
      byWord: 'Theo từ',
      byChar: 'Theo ký tự',
    },
    gallery: 'Kiểu chuyển slide',
    effectOptions: 'Tuỳ chọn hiệu ứng',
    customOption: 'Theo tệp (không có trong danh sách)',
    timing: 'Thời gian',
    duration: 'Thời lượng (giây)',
    onClick: 'Chuyển khi bấm chuột',
    after: 'Tự chuyển sau (giây)',
    afterSeconds: 'Số giây trước khi tự chuyển slide',
    preview: 'Xem trước',
    applyToAll: 'Áp cho tất cả',
    applyToAllHint: 'Dùng hiệu ứng, thời lượng và cách chuyển này cho mọi slide',
    unknown: 'Slide dùng hiệu ứng “{{name}}” mà trình soạn chưa biết — vẫn giữ nguyên khi lưu.',
    playedAsFade:
      'Xem trước và trình chiếu ở đây phát hiệu ứng này như Mờ dần; PowerPoint phát đúng hiệu ứng.',
  },
  pptxAnimations: {
    add: 'Thêm hiệu ứng',
    target: 'Hình',
    noShapes: 'Slide này chưa có hình nào để gắn hiệu ứng.',
    class: 'Nhóm hiệu ứng',
    effect: 'Hiệu ứng',
    option: 'Tuỳ chọn',
    addButton: 'Thêm',
    list_one: 'Hiệu ứng trên slide ({{count}})',
    list_other: 'Hiệu ứng trên slide ({{count}})',
    empty: 'Slide này chưa có hiệu ứng.',
    mainSequence: 'Theo thứ tự bấm',
    triggerShape: 'Khi bấm vào “{{name}}”',
    triggerNone: 'Theo thứ tự bấm của slide',
    row: '{{shape}}: {{effect}}',
    shapeFallback: 'Hình {{id}}',
    custom: 'Hiệu ứng tuỳ chỉnh',
    customHint:
      'Hiệu ứng tuỳ chỉnh không có trong bảng nên giữ nguyên loại; vẫn đổi được thời điểm, thứ tự hoặc xoá.',
    fixedType: 'Loại hiệu ứng này không đổi được ở đây.',
    details: 'Hiệu ứng đang chọn',
    preview: 'Xem trước hiệu ứng',
    replay: 'Xem lại',
    type: 'Loại',
    start: 'Bắt đầu',
    duration: 'Thời lượng (giây)',
    delay: 'Trễ (giây)',
    repeat: 'Lặp lại',
    autoReverse: 'Tự đảo ngược khi chạy xong',
    trigger: 'Kích hoạt',
    moveUp: 'Lên trước',
    moveDown: 'Xuống sau',
    delete: 'Xoá hiệu ứng',
    dragHint: 'Kéo thả để đổi thứ tự trong cùng một chuỗi',
    starts: {
      onClick: 'Khi bấm',
      withPrev: 'Cùng lúc với hiệu ứng trước',
      afterPrev: 'Sau hiệu ứng trước',
    },
    repeats: {
      times: '{{n}} lần',
      untilNextClick: 'Tới lần bấm kế tiếp',
      untilEndOfSlide: 'Tới hết slide',
    },
    classes: {
      entr: 'Vào',
      emph: 'Nhấn mạnh',
      exit: 'Ra',
      path: 'Đường đi',
    },
    entr: {
      appear: 'Xuất hiện',
      fade: 'Mờ dần',
      fly: 'Bay vào',
      float: 'Trôi vào',
      split: 'Tách',
      wipe: 'Lau',
      shape: 'Hình tròn',
      wheel: 'Bánh xe',
      randomBars: 'Thanh ngẫu nhiên',
      grow: 'Lớn dần và xoay',
      zoom: 'Thu phóng',
      swivel: 'Xoay vòng',
      bounce: 'Nảy',
      blinds: 'Rèm',
      box: 'Hộp',
      checkerboard: 'Bàn cờ',
      diamond: 'Kim cương',
      dissolve: 'Tan vào',
      peek: 'Ló vào',
      strips: 'Dải chéo',
      expand: 'Mở rộng',
      rise: 'Trồi lên',
      spinner: 'Con quay',
    },
    emph: {
      pulse: 'Nhịp đập',
      colorPulse: 'Nhịp màu',
      teeter: 'Lắc lư',
      spin: 'Quay',
      growShrink: 'Phóng to/thu nhỏ',
      desaturate: 'Giảm bão hoà màu',
      darken: 'Làm tối',
      lighten: 'Làm sáng',
      transparency: 'Trong suốt',
      objectColor: 'Màu đối tượng',
      complementaryColor: 'Màu bổ sung',
      lineColor: 'Màu viền',
      fillColor: 'Màu tô',
      fontColor: 'Màu chữ',
      underline: 'Gạch chân',
      boldFlash: 'Nháy đậm',
      wave: 'Sóng',
    },
    exit: {
      appear: 'Biến mất',
      fade: 'Mờ dần',
      fly: 'Bay ra',
      float: 'Trôi ra',
      split: 'Tách',
      wipe: 'Lau',
      shape: 'Hình tròn',
      wheel: 'Bánh xe',
      randomBars: 'Thanh ngẫu nhiên',
      grow: 'Thu nhỏ và xoay',
      zoom: 'Thu phóng',
      swivel: 'Xoay vòng',
      bounce: 'Nảy',
      dissolve: 'Tan ra',
    },
    path: {
      lines: 'Đường thẳng',
      arcs: 'Vòng cung',
      turns: 'Rẽ góc',
      shapes: 'Vòng tròn',
      loops: 'Vòng lặp',
      custom: 'Đường tự vẽ',
    },
    mediacall: {
      play: 'Phát',
      pause: 'Tạm dừng',
      stop: 'Dừng',
    },
    options: {
      b: 'Phía dưới',
      lb: 'Dưới bên trái',
      l: 'Bên trái',
      lt: 'Trên bên trái',
      t: 'Phía trên',
      rt: 'Trên bên phải',
      r: 'Bên phải',
      rb: 'Dưới bên phải',
      horzIn: 'Ngang, vào trong',
      horzOut: 'Ngang, ra ngoài',
      vertIn: 'Dọc, vào trong',
      vertOut: 'Dọc, ra ngoài',
      in: 'Vào trong',
      out: 'Ra ngoài',
      horz: 'Ngang',
      vert: 'Dọc',
      across: 'Ngang',
      down: 'Xuống',
      up: 'Lên',
      left: 'Sang trái',
      right: 'Sang phải',
      lu: 'Lên bên trái',
      ru: 'Lên bên phải',
      ld: 'Xuống bên trái',
      rd: 'Xuống bên phải',
      spokes1: '1 nan',
      spokes2: '2 nan',
      spokes3: '3 nan',
      spokes4: '4 nan',
      spokes8: '8 nan',
    },
    cmd: {
      add: 'Thêm hiệu ứng',
      delete: 'Xoá hiệu ứng',
      move: 'Đổi thứ tự hiệu ứng',
      timing: 'Sửa thời điểm hiệu ứng',
      trigger: 'Đổi kích hoạt hiệu ứng',
      preset: 'Đổi loại hiệu ứng',
    },
  },
  pptxShow: {
    play: 'Trình chiếu',
    fromStart: 'Từ đầu',
    fromCurrent: 'Từ slide đang chọn',
    openWindow: 'Mở cửa sổ trình chiếu',
    blocked: 'Trình duyệt chặn cửa sổ chiếu sau khi hỏi quyền màn hình.',
    retry: 'Chiếu lên màn phụ',
    blockedPlain: 'Trình duyệt chặn cửa sổ bật lên — cho phép popup của trang này rồi thử lại.',
    windowTitle: 'Trình chiếu',
    endOfShow: 'Hết bài trình chiếu — bấm để thoát.',
    fullscreen: 'Bấm để chiếu toàn màn hình',
    goto: 'Tới slide {{n}}',
    presenter: {
      current: 'Đang chiếu',
      upNext: 'Slide kế',
      lastSlide: 'Đây là slide cuối.',
      notes: 'Ghi chú',
      noNotes: 'Slide này không có ghi chú.',
      elapsed: 'Đã chiếu',
      clock: 'Giờ',
      position: 'Slide {{n}} / {{total}} · bước {{step}} / {{steps}}',
      prev: 'Lùi',
      next: 'Tiến',
      end: 'Kết thúc',
    },
  },
  // Hộp ghi chú của `.chilldoc` (APM-CD2-a).
  chilldocCallout: {
    insert: 'Hộp ghi chú',
    changeKind: 'Đổi kiểu hộp ghi chú (đang là: {{kind}})',
    remove: 'Bỏ hộp, giữ nội dung',
    kinds: {
      note: 'Ghi chú',
      tip: 'Mẹo',
      warning: 'Cảnh báo',
      danger: 'Nguy hiểm',
      success: 'Thành công',
    },
  },
  // Chế độ đọc / tập trung của `.chilldoc` (APM-CD2-a).
  documentReader: {
    preparing: 'Đang chuẩn bị các trang đọc…',
    loadingPage: 'Đang tải trang {{n}}…',
    pageFailed: 'Không tải được trang.',
    loadFailed: 'Không mở được tài liệu để đọc.',
    storageUnavailable:
      'Trình duyệt không cho phép bộ nhớ tạm hoặc đã hết dung lượng. Hãy cho phép lưu dữ liệu trang web rồi thử lại.',
    page: 'Trang {{n}} / {{total}}',
    goToPage: 'Chuyển đến trang',
    bilingual: 'Song ngữ',
    language: 'Ngôn ngữ bản dịch',
    edit: 'Sửa',
    marginLeft: 'Lề trái',
    marginRight: 'Lề phải',
    translatePage: 'Dịch phần còn thiếu',
    redoPage: 'Dịch lại trang',
    redoConfirm: 'Dịch lại các bản dịch AI của trang này? Bản dịch thủ công được giữ nguyên.',
    replaceManualConfirm: 'Thay bản dịch thủ công của đoạn này bằng bản dịch AI?',
    editTranslation: 'Sửa bản dịch',
    manual: 'Tự dịch',
    redoBlock: 'Dịch lại đoạn',
    translateRest: 'Dịch phần còn lại',
    restConfirm: 'Dịch các đoạn còn thiếu trong {{count}} trang, từ trang đang đọc?',
    batch: {
      "title": "Dịch các trang",
      "description": "Tài liệu có {{total}} trang · Dịch sang {{lang}}",
      "scope": "Chọn trang cần dịch",
      "remaining": "Từ trang đang đọc đến hết ({{start}}–{{total}})",
      "all": "Toàn bộ tài liệu",
      "custom": "Khoảng hoặc danh sách trang",
      "pages": "Các trang cần dịch",
      "placeholder": "Ví dụ: 2-5, 8, 12-15",
      "hint": "Dùng dấu phẩy để ngăn cách các trang, dấu gạch ngang cho một khoảng. Trang trùng chỉ dịch một lần.",
      "checking": "Đang kiểm tra các trang còn thiếu bản dịch…",
      "summary": "{{count}} trong {{selected}} trang đã chọn cần dịch.",
      "list": "Trang: {{pages}}",
      "nothing": "Các trang đã chọn không còn đoạn cần dịch.",
      "missingOnly": "Chỉ dịch phần còn thiếu trong những trang đã chọn. Trang đã đủ bản dịch được bỏ qua.",
      "start": "Bắt đầu dịch {{count}} trang",
      "running": "Đang dịch",
      "stopping": "Đang dừng sau lượt hiện tại…",
      "stopped": "Đã dừng",
      "done": "Đã hoàn thành",
      "failed": "Đã dừng do lỗi",
      "currentPage": "Đang dịch trang {{page}}",
      "failedPage": "Lỗi tại trang {{page}}",
      "progressLabel": "Tiến trình dịch trang",
      "progress": "Đã hoàn thành {{completed}} / {{total}} trang",
      "stopHint": "Dừng sau lượt đang chạy; các bản dịch đã lưu vẫn được giữ. Bạn có thể ẩn hộp thoại và mở lại từ thanh dưới.",
      "hide": "Ẩn hộp thoại",
      "chooseAgain": "Chọn trang khác",
      "viewProgress": "Tiến trình {{completed}} / {{total}}",
      "incomplete": "Lượt dịch chưa trả đủ kết quả. Các bản dịch đã nhận vẫn được giữ.",
      "rangeErrors": {
        "empty": "Nhập ít nhất một trang hoặc khoảng trang.",
        "syntax": "Danh sách trang chưa đúng. Ví dụ: 2-5, 8, 12-15.",
        "bounds": "Số trang phải nằm trong khoảng 1–{{total}}.",
        "reversed": "Trang bắt đầu của mỗi khoảng phải nhỏ hơn hoặc bằng trang kết thúc."
      }
    },
    stop: 'Dừng',
    checklist: 'Mục công việc',
    imageUnavailable: 'Ảnh chưa tải được',
    chartUnavailable: 'Biểu đồ chưa có dữ liệu đã lưu',
    attachment: 'Tệp đính kèm',
    reference: 'Tham chiếu',
    slideBreak: 'Ngắt slide',
    unsupported: 'Nội dung chưa hỗ trợ: {{type}}',
  },
  chilldocReading: {
    enter: 'Chế độ đọc',
    title: 'Chế độ đọc',
    bar: 'Điều khiển chế độ đọc',
    focus: 'Tập trung',
    focusHint: 'Tập trung vào nhóm đoạn quanh đoạn được chọn, khoảng một phần ba trang',
    outline: 'Dàn ý',
    outlineHint: 'Hiện dàn ý bên trái — bấm một mục để tới tiêu đề đó',
    exit: 'Thoát',
    rulerHint:
      '{{label}}: {{mm}} mm — kéo để đổi, bấm đúp để về lề ban đầu. Chỉ khi đọc, tài liệu không đổi.',
  },
  // Song ngữ trong chế độ đọc (APM-BIL-b, plan-chilldoc-bilingual).
  chilldocBilingual: {
    toggle: 'Song ngữ',
    toggleHint: 'Hiện bản dịch song song — dịch từng trang khi bạn bấm',
    needsSave: 'Lưu tài liệu trước để dịch',
    lang: 'Dịch sang',
    langs: {
      vi: 'Tiếng Việt',
      en: 'English',
      ja: '日本語',
      ko: '한국어',
      'zh-Hans': '中文 (简体)',
      fr: 'Français',
      de: 'Deutsch',
      th: 'ไทย',
      es: 'Español',
    },
    column: 'Bản dịch · {{lang}}',
    columnLabel: 'Cột bản dịch',
    cellLabel: 'Bản dịch của khối {{n}}',
    retranslateHint: 'Dịch lại riêng đoạn này bằng AI',
    manual: 'Tự dịch',
    edit: 'Sửa',
    save: 'Lưu',
    cancel: 'Huỷ',
    manualLabel: 'Bản dịch của đoạn',
    manualPlaceholder: 'Gõ bản dịch của đoạn này… (Ctrl+Enter để lưu)',
    translating: 'Đang dịch…',
    sourceChanged: 'Đoạn gốc đã đổi',
    sourceChangedHint: 'Bản dịch này làm cho nội dung cũ: {{text}}',
    byAi: 'AI · {{date}}',
    byPerson: '{{name}} · {{date}}',
    otherStyle: 'dịch với văn phong {{style}}',
    tooLong: 'Đoạn này quá dài để dịch một lượt — hãy chia thành các đoạn ngắn hơn.',
    object: 'Không có chữ để dịch',
    loadFailed: 'Không tải được các bản dịch đã có.',
    aiUnavailable: 'AI chưa sẵn sàng — bạn vẫn tự dịch được từng đoạn.',
    aiLabel: 'Dịch đoạn tài liệu',
    sameLanguage: 'Đoạn này đã ở đúng ngôn ngữ đích — không cần dịch',
    langSource: '{{lang}} (ngôn ngữ gốc)',
    rest: {
      button: 'Dịch phần còn lại',
      hint: 'Dịch mọi đoạn chưa dịch, mỗi lượt AI khoảng một trang A4',
      confirm: 'Dịch {{blocks}} đoạn trong {{count}} lượt AI?',
      confirmCapped: 'Dịch {{blocks}} đoạn đầu trong {{count}} lượt AI? Phần sau bấm lần nữa.',
      start: 'Dịch',
      progress: 'Đang dịch lượt {{n}}/{{total}}…',
      stop: 'Dừng',
      stopped: 'Đã dừng sau lượt {{n}}/{{total}}.',
      failed: 'Dừng ở lượt {{n}}/{{total}} vì lỗi — xem ở ô bị lỗi.',
      done: 'Đã dịch xong {{count}} lượt.',
    },
    page: {
      label: 'Trang {{n}} / {{total}}',
      untranslated: 'Chưa dịch',
      blocks_one: '{{count}} đoạn',
      blocks_other: '{{count}} đoạn',
      progress: '{{done}}/{{total}} đã dịch',
      translate: 'Dịch trang',
      translateHint: 'Dịch mọi đoạn của trang này trong một lượt AI',
      translateMissing_one: 'Dịch phần còn thiếu ({{count}} đoạn)',
      translateMissing_other: 'Dịch phần còn thiếu ({{count}} đoạn)',
      translateMissingHint:
        'Dịch các đoạn chưa dịch (hoặc gốc đã đổi) của trang này trong một lượt AI',
      retranslate: 'Dịch lại trang',
      retranslateHint: 'Dịch lại các đoạn do AI dịch của trang này — bản tự dịch giữ nguyên',
      retranslateConfirm_one: 'Thay {{count}} bản dịch AI của trang này? Bản tự dịch giữ nguyên.',
      retranslateConfirm_other: 'Thay {{count}} bản dịch AI của trang này? Bản tự dịch giữ nguyên.',
      retranslateStart: 'Dịch lại',
      translating: 'Đang dịch trang…',
    },
    blockLabel: 'Đoạn {{n}}',
    blockActions: 'Thao tác với đoạn {{n}} đang chọn',
    retranslateBlock: 'Dịch lại khối này',
    errors: {
      stale:
        'Tài liệu này vừa được lưu thành bản mới ở nơi khác (tab hay thiết bị khác) — đóng rồi mở lại tài liệu để dịch tiếp.',
      notFound:
        'Không tìm thấy tài liệu để gắn bản dịch — có thể tài liệu đã bị xoá hoặc bạn không còn quyền xem. Đóng rồi mở lại tài liệu từ danh sách.',
    },
    style: {
      label: 'Văn phong',
      detecting: 'Đang nhận ra kiểu văn bản…',
      auto: 'tự nhận ra',
      autoGenre: 'tự nhận ra ({{genre}})',
      manual: 'bạn chọn',
      fallback: 'mặc định',
      change: 'Đổi',
      redetect: 'Nhận ra lại',
      redetected: 'Đã nhận ra lại: {{style}}',
      redetectFailed: 'Không nhận ra lại được — giữ văn phong hiện tại.',
      menu: 'Văn phong dịch',
    },
    styles: {
      'formal-administrative': {
        label: 'Trang trọng – hành chính',
        description: 'Câu đầy đủ, xưng hô trang trọng, đúng khuôn văn bản hành chính',
      },
      'legal-precise': {
        label: 'Pháp lý – chính xác từng chữ',
        description: 'Bám sát từng chữ, giữ nguyên thuật ngữ pháp lý, không diễn giải',
      },
      'technical-precise': {
        label: 'Kỹ thuật – giữ thuật ngữ',
        description: 'Giữ thuật ngữ chuyên ngành, câu ngắn, rõ ràng',
      },
      'business-professional': {
        label: 'Kinh doanh – chuyên nghiệp',
        description: 'Lịch sự, gọn, hướng tới người ra quyết định',
      },
      academic: {
        label: 'Học thuật',
        description: 'Khách quan, chặt chẽ, giữ cách dẫn chứng',
      },
      'marketing-fluent': {
        label: 'Truyền thông – tự nhiên, cuốn hút',
        description: 'Tự nhiên như người bản xứ viết, ưu tiên sức hút hơn từng chữ',
      },
      neutral: {
        label: 'Trung tính',
        description: 'Rõ ràng, không quá trang trọng cũng không suồng sã',
      },
      conversational: {
        label: 'Thân mật',
        description: 'Gần gũi như lời nói, câu ngắn',
      },
    },
    genres: {
      administrative: 'Văn bản hành chính',
      legal: 'Văn bản pháp lý',
      technical: 'Tài liệu kỹ thuật',
      business: 'Tài liệu kinh doanh',
      academic: 'Văn bản học thuật',
      marketing: 'Truyền thông',
      meeting: 'Biên bản họp',
      casual: 'Thư từ, ghi chú',
    },
  },
  // Bảng và biểu đồ trong slide (APM-CD2-n).
  docSlideObjects: {
    table: 'Bảng',
    chart: 'Biểu đồ',
    fromRegion: 'Từ vùng',
    edit: 'Sửa bảng / biểu đồ',
    edit_table: 'Sửa bảng',
    edit_chart: 'Sửa biểu đồ',
    editData: 'Sửa số liệu',
    needObject: 'Chọn một ô bảng hoặc biểu đồ để sửa',
    needChart: 'Chọn một biểu đồ để sửa số liệu',
    apply: 'Áp dụng',
    copyNote:
      'Bản sao — không liên kết với bảng / biểu đồ trong văn bản: sửa bên này không đổi bên kia.',
    regionEmpty: 'Vùng văn bản của slide này chưa có bảng hay biểu đồ nào.',
    regionTable: 'Bảng {{n}} ({{rows}} hàng × {{cols}} cột)',
    regionChart: 'Biểu đồ {{n}}',
    tableBroken: 'Bảng hỏng — không đọc được',
    chartBroken: 'Biểu đồ hỏng — không đọc được',
    chartTableLocked:
      'Số liệu nằm ngay trong ô biểu đồ (bản sao) — sửa số bằng nút "Sửa số liệu" ở nhóm Slide.',
    sample: {
      title: 'Biểu đồ mới',
      category: 'Hạng mục',
      value: 'Giá trị',
      item: 'Mục {{n}}',
    },
  },
  // Hình khối, mũi tên, sơ đồ trong slide (APM-CD2-m).
  docSlideShapes: {
    insert: 'Hình',
    diagram: 'Sơ đồ',
    fill: 'Màu nền',
    line: 'Màu viền',
    needShape: 'Chọn một hình trước',
    rotate: 'Xoay 90°',
    rotateHandle: 'Kéo để xoay (Shift: bước 15°)',
    flipH: 'Lật ngang',
    flipV: 'Lật dọc',
    library: 'Thư viện hình',
    search: 'Tìm hình…',
    noMatch: 'Không có hình nào khớp',
    themeColors: 'Màu chủ đề',
    fixedColors: 'Màu cố định',
    noColor: 'Không màu',
    diagramFull: 'Slide không đủ chỗ cho sơ đồ này (tối đa {{max}} ô một slide)',
    arrange: {
      button: 'Căn chỉnh',
      needTwo: 'Shift+bấm để chọn từ 2 ô trở lên',
      needThree: 'Phân bố đều cần từ 3 ô',
      selected: 'Đang chọn {{count}} ô',
      left: 'Căn trái',
      center: 'Căn giữa (ngang)',
      right: 'Căn phải',
      top: 'Căn trên',
      middle: 'Căn giữa (dọc)',
      bottom: 'Căn dưới',
      horizontal: 'Phân bố đều theo chiều ngang',
      vertical: 'Phân bố đều theo chiều dọc',
    },
    colors: {
      accent: 'Màu nhấn',
      surface: 'Nền nhấn',
      title: 'Màu tiêu đề',
      text: 'Màu chữ',
      muted: 'Màu phụ',
      background: 'Màu nền slide',
    },
    groups: {
      lines: 'Đường',
      basic: 'Hình cơ bản',
      arrows: 'Mũi tên khối',
      flowchart: 'Lưu đồ',
      callouts: 'Chú thích',
      stars: 'Sao và dấu',
    },
    presets: {
      line: 'Đường thẳng',
      arrow: 'Mũi tên nối',
      doubleArrow: 'Mũi tên hai đầu',
      rect: 'Hình chữ nhật',
      roundRect: 'Hình chữ nhật bo góc',
      ellipse: 'Hình elip',
      triangle: 'Tam giác',
      rtTriangle: 'Tam giác vuông',
      diamond: 'Hình thoi',
      parallelogram: 'Hình bình hành',
      trapezoid: 'Hình thang',
      pentagon: 'Ngũ giác',
      hexagon: 'Lục giác',
      octagon: 'Bát giác',
      plus: 'Dấu cộng',
      heart: 'Trái tim',
      cloud: 'Đám mây',
      rightArrow: 'Mũi tên phải',
      leftArrow: 'Mũi tên trái',
      upArrow: 'Mũi tên lên',
      downArrow: 'Mũi tên xuống',
      leftRightArrow: 'Mũi tên trái phải',
      chevron: 'Chữ V nằm',
      homePlate: 'Ngũ giác mũi tên',
      bentArrow: 'Mũi tên gấp',
      uturnArrow: 'Mũi tên chữ U',
      flowChartProcess: 'Lưu đồ: xử lý',
      flowChartAlternateProcess: 'Lưu đồ: xử lý thay thế',
      flowChartDecision: 'Lưu đồ: quyết định',
      flowChartInputOutput: 'Lưu đồ: dữ liệu',
      flowChartDocument: 'Lưu đồ: tài liệu',
      flowChartTerminator: 'Lưu đồ: bắt đầu / kết thúc',
      flowChartConnector: 'Lưu đồ: điểm nối',
      flowChartMagneticDisk: 'Lưu đồ: cơ sở dữ liệu',
      wedgeRectCallout: 'Chú thích chữ nhật',
      wedgeRoundRectCallout: 'Chú thích bo góc',
      wedgeEllipseCallout: 'Chú thích elip',
      cloudCallout: 'Chú thích đám mây',
      star4: 'Sao 4 cánh',
      star5: 'Sao 5 cánh',
      star6: 'Sao 6 cánh',
      star8: 'Sao 8 cánh',
      star12: 'Sao 12 cánh',
      irregularSeal1: 'Tia nổ',
    },
    diagrams: {
      process: 'Quy trình',
      processHint: 'Các bước nối tiếp, mũi tên từ trái sang phải',
      cycle: 'Chu trình',
      cycleHint: 'Các bước xếp vòng, bước cuối quay về bước đầu',
      hierarchy: 'Phân cấp 2 tầng',
      hierarchyHint: 'Một ô trên, các nhánh dưới (chọn số nhánh)',
      count: '{{kind}} — {{count}}',
    },
    diagramText: {
      step: 'Bước {{n}}',
      root: 'Chủ đề',
      child: 'Nhánh {{n}}',
    },
  },
  // Xoá nền ảnh — APM-BGR-c, docs/plan-bg-removal.md §7.
  bgRemoval: {
    title: 'Xoá nền',
    apply: 'Dùng ảnh đã xoá nền',
    modeLabel: 'Cách xoá nền',
    modes: { auto: 'Tự động', flat: 'Nền một màu', select: 'Chọn vùng' },
    flatHint:
      'Cho sơ đồ, chữ, logo, ảnh chụp màn hình: xoá đúng màu nền, giữ nguyên mọi nét chữ và đường kẻ. Ảnh chụp thì chọn "Tự động".',
    flat: {
      color: 'Màu nền',
      tolerance: 'Độ nhạy',
      keepInside: 'Giữ phần cùng màu nền nằm trong hình',
    },
    autoHint: 'Tự tìm chủ thể và bỏ hết phần nền. Chưa đúng? Sang "Chọn vùng" để chỉ vật cần giữ hoặc tô sửa.',
    selectHint:
      'Chấm điểm giữ (+) lên vật cần giữ, hoặc khoanh hộp quanh nó. Chỉ chấm điểm bỏ (−) lên một vật thừa là xoá vật đó khỏi kết quả tự động. Cọ giữ / cọ xoá sửa từng chỗ.',
    toolsLabel: 'Công cụ chọn vùng',
    tools: {
      keep: 'Điểm giữ',
      drop: 'Điểm bỏ',
      box: 'Khoanh hộp',
      brushKeep: 'Cọ giữ',
      brushErase: 'Cọ xoá',
    },
    brushSize: 'Cỡ cọ',
    undo: 'Hoàn tác thao tác vừa rồi',
    clear: 'Xoá mọi điểm, hộp và nét cọ',
    softness: 'Mép',
    softnessLevels: { sharp: 'Sắc', normal: 'Vừa', soft: 'Mềm' },
    holdOriginal: 'Giữ để xem ảnh gốc',
    previewLabel: 'Ảnh sau khi xoá nền',
    preview: {
      open: 'Xem trước',
      title: 'Xem trước ảnh đã xoá nền',
      background: 'Nền xem thử',
      backgrounds: { checker: 'Ô caro', white: 'Trắng', dark: 'Tối', color: 'Màu' },
      info: '{{width}} × {{height}} px · {{size}} KB',
      back: 'Quay lại sửa',
      use: 'Dùng ảnh này',
      adjust: 'Màu nổi bật',
      adjustModes: { none: 'Giữ nguyên', invert: 'Đảo sáng tối', outline: 'Viền nổi' },
      outlineColor: 'Màu viền',
      outlineColors: { auto: 'Tự động', white: 'Trắng', black: 'Đen' },
      outlineWidth: 'Độ dày',
      adjusting: 'Đang chỉnh màu…',
      adjustFailed: 'Không chỉnh được màu ảnh này.',
    },
    // AI chỉ chủ thể — APM-BGR-d. AI chỉ chấm điểm, phần cắt vẫn chạy trên máy.
    ai: {
      label: 'Chọn chủ thể bằng AI',
      toggle: 'Dùng AI chọn chủ thể',
      hint: 'Gợi ý cho AI (không bắt buộc)',
      hintPlaceholder: 'Gợi ý (không bắt buộc): giữ cái cốc, bỏ bàn tay cầm nó…',
      ask: 'Hỏi AI',
      running: 'AI đang xem ảnh…',
      picked: 'AI chọn: {{subject}}. Xem các điểm trên ảnh, sửa nếu cần rồi bấm ✓.',
      lowConfidence: 'AI không chắc chủ thể nào — kiểm kỹ trước khi áp dụng.',
      failed: 'AI không chỉ ra được chủ thể. Hãy tự chấm điểm hoặc thử lại.',
      manual: 'Tự chọn vùng',
    },
    device: { webgpu: 'Đang dùng GPU', wasm: 'Đang dùng CPU — chậm hơn' },
    status: {
      load: 'Đang mở ảnh…',
      download: 'Đang tải mô hình xoá nền ({{mb}} MB, chỉ lần đầu) — {{percent}}%',
      auto: 'Đang tách nền… (chạy ngay trên máy này, có thể mất tới một phút)',
      encode: 'Đang chuẩn bị chọn vùng…',
      final: 'Đang dựng ảnh cuối ở cỡ thật…',
      saving: 'Đang làm mép và lưu ảnh…',
    },
    error: {
      gif: 'Ảnh GIF không xoá nền được.',
      download_failed: 'Không tải được mô hình xoá nền. Kiểm tra mạng rồi mở lại.',
      out_of_memory: 'Máy không đủ bộ nhớ để xoá nền ảnh này. Đóng bớt tab rồi thử lại.',
      no_image: 'Mất ảnh đang xử lý. Đóng hộp rồi mở lại.',
      no_embedding: 'Chọn vùng chưa sẵn sàng. Đóng hộp rồi mở lại.',
      too_large: 'Ảnh sau khi xoá nền quá lớn để lưu vào tài liệu.',
      cancelled: 'Đã huỷ.',
      failed: 'Xoá nền không thành công. Thử lại hoặc dùng ảnh khác.',
      apply: 'Không lưu được ảnh vào tài liệu.',
    },
  },
  docSectionWrite: {
    menu: 'Viết chi tiết bằng AI…',
    title: 'Viết chi tiết bằng AI',
    ai: 'Viết chi tiết mục bằng AI',
    target: 'Mục: {{name}}',
    selection: 'Vùng đang bôi',
    untitled: '(mục chưa có tiêu đề)',
    detailLabel: 'Mức chi tiết',
    detail: { more: 'Chi tiết hơn (≈ 2 lần)', much: 'Rất chi tiết (≈ 4 lần)' },
    instruction: 'Yêu cầu thêm (không bắt buộc)',
    instructionPlaceholder: 'Ví dụ: thêm ví dụ chuỗi truy cập trang, viết cho sinh viên năm nhất',
    hint: 'AI giữ đủ ý của bạn và dùng kiến thức chung để viết thêm. Kết quả hiện dưới dạng đề xuất — kiểm lại rồi mới chấp nhận.',
    pending: 'Mục này còn đề xuất chưa duyệt. Chấp nhận hoặc từ chối chúng ở ngăn Xem lại trước.',
    write: 'Viết',
    running: 'AI đang viết…',
    done: 'Đã viết xong mục',
    applied: 'Đã thêm bản viết dưới dạng đề xuất — xem ở ngăn Xem lại.',
    partial: 'Bản viết chưa đạt độ dài mong muốn.',
    touched: 'Mục đã đổi trong lúc AI viết nên không áp kết quả — bấm Viết chi tiết lần nữa.',
    applyFailed: 'Không áp được bản viết vào mục này.',
    tooLong: 'Mục quá dài — bôi một phần nhỏ hơn rồi thử lại.',
    noSection: 'Đặt con trỏ vào một tiêu đề hoặc một mục danh sách (hay bôi vài đoạn) rồi thử lại.',
    author: 'AI · {{name}}',
    manual: 'Tự viết trong mục',
  },
  docSlides: {
    regionLabel: 'Vùng {{index}} · {{count}} slide',
    removeRegion: 'Xoá vùng ngăn',
    // Lưới ô slide ở chế độ chỉ đọc (trình xem, xem trước của hộp chuyển — APM-CVT-d).
    readGrid: {
      label: 'Các slide của vùng {{index}}',
      present: 'Trình chiếu từ slide {{n}}',
    },
    lost: 'Vùng liền trước đã đủ slide — bỏ {{count}} slide của vùng vừa xoá',
    undo: 'Hoàn tác',
    toggle: 'Trình chiếu',
    panel: {
      title: 'Mục trình chiếu',
      resize: 'Kéo để đổi bề ngang (bấm đúp: về mặc định)',
      toolbar: 'Công cụ trình chiếu',
      createRegion: 'Tạo vùng ngăn',
      createRegionNo: 'Ngay trước đoạn này đã là một thanh ngăn',
      noRegionHere: 'Đặt con trỏ trong một vùng ngăn',
      regionFull: 'Vùng đã đủ {{max}} slide',
      deckFull: 'Tài liệu đã đủ {{max}} slide',
      addSlide: 'Thêm slide',
      generate: 'Tạo slide',
      edit: 'Soạn slide',
      editHint: 'Soạn slide (bấm đúp hoặc gõ phím cũng được)',
      fullView: 'Toàn khung',
      settings: 'Cài đặt trình chiếu',
      aspect: 'Tỉ lệ',
      theme: 'Chủ đề',
      slideN: 'Slide {{n}}',
      menu: 'Việc với slide',
      changeLayout: 'Đổi layout',
      duplicate: 'Nhân bản',
      delete: 'Xoá',
      deleted: 'Đã xoá slide',
      regenerate: 'Tạo lại',
      staleNotice: '{{region}} đã đổi từ lúc tạo slide — slide có thể không còn khớp',
      regionHeader: 'Vùng {{index}}',
      emptyRegion: 'Chưa có slide',
      opening: 'Mở đầu',
      closing: 'Kết thúc',
      emptyOpening: 'Chỗ cho trang tiêu đề — bấm "Tạo slide"',
      emptyClosing: 'Chỗ cho trang kết — bấm "Tạo slide"',
      editTab: 'Soạn',
      slidesTab: 'Slide',
    },
    groups: { slide: 'Slide' },
    menu: {
      label: 'Việc với ô slide',
      duplicate: 'Nhân bản ô',
      editText: 'Sửa chữ',
      replaceImage: 'Thay ảnh…',
      removeBackground: 'Xoá nền…',
      bringToFront: 'Đưa lên trên cùng',
      sendToBack: 'Đưa xuống dưới cùng',
      nothingToPaste: 'Bộ nhớ tạm không có ảnh, ô hay chữ để dán.',
    },
    edge: {
      agenda: 'Nội dung',
      summary: 'Tóm tắt',
      thanks: 'Cảm ơn',
      questions: 'Hỏi & đáp',
      presenterLegend: 'Ghi lên slide',
      name: 'Người trình bày',
      organization: 'Tổ chức',
      date: 'Ngày',
    },
    full: {
      canvas: 'Khung soạn slide',
      position: 'Slide {{n}} / {{total}}',
      prev: 'Slide trước',
      next: 'Slide sau',
      exit: 'Về giao diện lai',
      addText: 'Thêm ô chữ',
      insertImage: 'Chèn ảnh',
      sizeNeedsText: 'Chọn một ô có chữ để đổi cỡ chữ',
      deleteBox: 'Xoá ô',
      docImage: 'Ảnh từ tài liệu',
      docImageHint: 'Dùng một ảnh có sẵn trong tài liệu — slide dùng chung ảnh, không chép thêm',
      useDocImage: 'Dùng ảnh này',
      pasteFull: 'Slide đã đủ {{max}} ô — xoá bớt một ô rồi dán.',
      pasteOtherDoc: 'Ảnh này thuộc tài liệu khác — dùng "Chèn ảnh" để đưa vào tài liệu này.',
    },
    generate: {
      title: 'Tạo slide cho vùng {{index}}',
      titleOpening: 'Tạo slide mở đầu',
      titleClosing: 'Tạo slide kết thúc',
      previewTitle: 'Xem trước slide',
      count: 'Số slide',
      // Tầng mô hình cho lượt sinh — người dùng yêu cầu 2026-10-30.
      modelTier: 'Mô hình AI',
      // Mức chi tiết so với nội dung đang soạn — người dùng yêu cầu 2026-10-30.
      detail: 'Mức chi tiết',
      detailLevel: {
        more: 'Nhiều — giữ gần đủ ý, số liệu, ví dụ',
        medium: 'Trung bình (mặc định)',
        less: 'Ít — chỉ ý cốt lõi',
      },
      shortForMore:
        'Vùng này ngắn — slide không chi tiết hơn được nội dung đang có. Muốn thêm nội dung cho mục: chuột phải trong mục › Viết chi tiết bằng AI.',
      tier: {
        strong: 'Tốt — viết và chia ý chặt nhất, tốn nhất',
        standard: 'Trung bình (mặc định)',
        small: 'Thấp — nhanh, rẻ',
      },
      auto: 'Tự chọn',
      modeLabel: 'Vùng đã có slide',
      mode: { add: 'Thêm sau slide hiện có', replace: 'Thay slide đã tạo (giữ slide làm tay)' },
      prompt: 'Yêu cầu thêm (tuỳ chọn)',
      promptPlaceholder: 'Ví dụ: giọng trang trọng, nhấn vào số liệu',
      empty: 'Vùng chưa có nội dung để tạo slide.',
      manual: 'Tạo slide từ vùng (không AI)',
      ai: 'Tạo bằng AI',
      running: 'AI đang viết slide…',
      done: '{{count}} slide đề xuất',
      sampled: 'Vùng dài hơn 12 000 ký tự — AI chỉ đọc phần đầu.',
      partial:
        'AI chưa hoàn tất mọi yêu cầu — slide đã được cắt cho vừa ô, xem lại trước khi chèn.',
      back: 'Quay lại',
      insert: 'Chèn {{count}} slide',
      replace: 'Thay bằng {{count}} slide',
      capped: 'Chỉ còn chỗ cho {{count}} slide trong vùng / tài liệu — phần dư đã bỏ.',
    },
    present: {
      play: 'Trình chiếu',
      fromStart: 'Từ đầu',
      fromCurrent: 'Từ slide đang chọn',
      noSlides: 'Chưa có slide nào để chiếu',
      stage: 'màn chiếu',
      position: 'Slide {{n}} / {{total}}',
      empty: 'Không còn slide nào',
      windowTitle: 'Trình chiếu',
      waiting: 'Đang nối với trình soạn…',
      openFromEditor: 'Mở trình chiếu từ trình soạn tài liệu (nút ▶ ở mục trình chiếu).',
      openWindow: 'Mở cửa sổ trình chiếu',
      blocked: 'Trình duyệt chặn cửa sổ chiếu sau khi hỏi quyền màn hình.',
      retry: 'Chiếu lên màn phụ',
      blockedPlain: 'Trình duyệt chặn cửa sổ bật lên — cho phép popup của trang này rồi thử lại.',
      controls: 'Điều khiển trình chiếu',
      prev: 'Lùi',
      next: 'Tiến',
      stop: 'Kết thúc',
      live: 'Đang chiếu',
      fullscreen: 'Bấm để chiếu toàn màn hình',
    },
    layoutPicker: 'Chọn layout',
    layouts: {
      title: 'Trang tiêu đề',
      titleContent: 'Tiêu đề và nội dung',
      sectionHeader: 'Đầu phần',
      twoContent: 'Hai nội dung',
      comparison: 'So sánh',
      titleOnly: 'Chỉ tiêu đề',
      blank: 'Trống',
      contentCaption: 'Nội dung có chú thích',
      pictureCaption: 'Ảnh có chú thích',
      contentPicture: 'Nội dung và ảnh',
      titlePicture: 'Trang tiêu đề có ảnh',
    },
    themes: {
      light: 'Sáng',
      dark: 'Tối',
      office: 'Công sở',
      warm: 'Ấm',
      minimal: 'Tối giản',
      contrast: 'Tương phản cao',
      glass: 'Liquid Glass',
      glassDark: 'Liquid Glass tối',
    },
    placeholder: {
      title: 'Bấm để thêm tiêu đề',
      subtitle: 'Bấm để thêm phụ đề',
      heading: 'Bấm để thêm đầu cột',
      body: 'Bấm để thêm nội dung',
      caption: 'Bấm để thêm chú thích',
      text: 'Bấm để thêm chữ',
      image: 'Chèn ảnh',
      shape: 'Chữ trong hình',
      table: 'Bảng trống — nhấn đúp để sửa',
      chart: 'Biểu đồ trống',
    },
    gap: {
      menu: 'Việc ở khe giữa hai slide',
      empty: 'Khe của vùng chưa có slide — bấm để chọn, rồi Ctrl+V để dán',
      before: 'Khe trước slide {{n}}',
      after: 'Khe sau slide {{n}}',
      between: 'Khe giữa slide {{a}} và {{b}}',
      newSlide: 'Slide mới',
      fromPptx: 'Chèn slide từ tệp PowerPoint…',
      pptxSoon: 'Chưa hỗ trợ dán tệp PowerPoint vào đây — hãy mở tệp rồi chép slide, hoặc dán ảnh của slide.',
      officeUnreadable: 'Không đọc được slide PowerPoint trong bộ nhớ tạm — dán thành ảnh của slide.',
      nothing: 'Bộ nhớ tạm không có slide hay ảnh nào',
      full: 'Không còn chỗ — mỗi vùng tối đa {{region}} slide, cả tài liệu {{deck}} slide.',
      pasted: 'Đã dán {{count}} slide',
      capped: 'Hết chỗ trong vùng / tài liệu — bỏ {{count}} slide.',
      imagesLost: 'Bỏ {{count}} ảnh không lấy được (ảnh của tài liệu khác hoặc tệp tạm của Office).',
      deleted: 'Đã xoá {{count}} slide',
      copySlide: 'Sao chép slide',
      copySlides: 'Sao chép {{count}} slide',
    },
    pptx: {
      title: 'Chèn slide từ tệp PowerPoint',
      fromDevice: 'Tải từ máy',
      fromMyFiles: 'Tệp của tôi',
      choose: 'Chọn một tệp .pptx để xem các slide trong đó rồi tick những slide cần chèn.',
      otherFile: 'Chọn tệp khác',
      loading: 'Đang mở tệp…',
      invalid: 'Không mở được tệp — tệp hỏng hoặc không phải PowerPoint (.pptx).',
      notPptx: 'Chỉ chèn được slide từ tệp .pptx.',
      tooLarge: 'Tệp lớn hơn {{size}} — chưa mở được ở đây.',
      empty: 'Tệp không có slide nào.',
      grid: 'Các slide trong tệp',
      slide: 'Slide {{n}}',
      selectAll: 'Chọn tất cả',
      clearAll: 'Bỏ chọn tất cả',
      selected: 'Đã chọn {{count}} / {{total}} slide',
      insert: 'Chèn {{count}} slide',
      failed: 'Không chuyển được slide của tệp này.',
      lost: 'Không mang sang: {{what}}.',
      lostKinds: {
        charts: '{{count}} biểu đồ',
        smartArt: 'đồ hoạ của {{count}} SmartArt (chữ vẫn giữ)',
        shapes: '{{count}} hình vẽ',
        images: '{{count}} ảnh EMF / WMF / TIFF',
        media: '{{count}} video / âm thanh',
        background: 'nền và hình trang trí của {{count}} slide',
        animations: 'hiệu ứng, chuyển cảnh của {{count}} slide',
        notes: 'ghi chú diễn giả của {{count}} slide',
      },
    },
    imagePlaceholder: 'Bấm đúp để chèn ảnh',
    imageMissing: 'Ảnh không còn',
    overflow: 'Chữ tràn khỏi ô',
  },
  docChart: {
    loading: 'Đang tải biểu đồ…',
    loadFailed: 'Không tải được bộ vẽ biểu đồ. Tải lại trang để thử lại.',
    broken: 'Biểu đồ hỏng — không đọc được cấu hình.',
    empty: 'Chưa có số liệu để vẽ.',
    figureLabel: 'Biểu đồ: {{title}}',
    select: 'Chọn biểu đồ "{{title}}"',
    toolbar: 'Thao tác với biểu đồ',
    edit: 'Sửa',
    delete: 'Xoá',
    resize: 'Kéo để đổi cỡ',
    lostAt: 'Mất nguồn dữ liệu — đang hiện số lúc lưu {{at}}',
    lostRecent: 'Mất nguồn dữ liệu — đang hiện số gần nhất',
    lostEmpty: 'Mất nguồn dữ liệu — chưa có số đã lưu để hiện.',
    keepNumbers: 'Giữ số hiện tại',
    keepNumbersHint: 'Bỏ liên kết với bảng, giữ biểu đồ với các số đang hiện',
    pickTable: 'Chọn lại bảng',
    other: 'Khác',
    blank: '(trống)',
    countLabel: '{{header}} (số lượng)',
    million: 'tr',
    billion: 'tỷ',
    trillion: 'nghìn tỷ',
    createManual: 'Tạo biểu đồ (không AI)',
    noTable: 'Tài liệu chưa có bảng — chèn một bảng số liệu trước.',
    insight: {
      title: 'Data insight',
      previewTitle: 'Data insight — xem trước',
      help: 'AI đọc phạm vi này, cả bảng và nội dung tài liệu rồi đề xuất biểu đồ: tự chọn loại, cột và cách gộp. Số do ứng dụng tính từ bảng; chưa bấm Chèn thì tài liệu không đổi.',
      scopeRange: 'Vùng {{address}} — {{rows}} hàng × {{cols}} cột',
      scopeTable: 'Cả bảng — {{rows}} hàng × {{cols}} cột',
      readByRows: ' — đọc mỗi hàng là một series (bảng chỉ tiêu × thời gian)',
      labelBorrowed: ' — thêm cột nhãn {{column}} bên trái',
      findings: 'Điểm chạm dữ liệu',
      findingsHint: '— AI đọc từ bảng; kiểm lại con số trước khi dùng',
      insertFindings: 'Chèn các điểm chạm thành danh sách dưới biểu đồ',
      count: 'Số biểu đồ',
      prompt: 'Yêu cầu thêm (không bắt buộc)',
      promptPlaceholder: 'VD: tập trung vào lợi nhuận theo quý',
      run: 'Tạo biểu đồ',
      running: 'Đang tạo…',
      done: 'Đề xuất {{count}} biểu đồ',
      manual: 'Gợi ý không AI',
      manualNotice: 'Gợi ý không AI — chọn theo luật cố định từ kiểu các cột, không kèm nhận xét.',
      manualFewer: 'Dữ liệu chỉ đủ cho {{count}} biểu đồ khác nhau (bạn xin {{requested}}).',
      partial: 'AI chưa hoàn tất — một số biểu đồ không hợp lệ đã bị bỏ.',
      none: 'Không có biểu đồ nào phù hợp với phạm vi này.',
      back: 'Quay lại',
      insert: 'Chèn {{count}} biểu đồ',
      editOne: 'Sửa biểu đồ "{{title}}"',
      blocked: {
        too_few_rows: 'Cần ít nhất 2 hàng dữ liệu.',
        no_columns: 'Không có cột số hay cột nhãn nào để vẽ.',
      },
    },
    dialog: {
      editTitle: 'Sửa biểu đồ',
      createTitle: 'Tạo biểu đồ (không AI)',
      previewTitle: 'Sửa biểu đồ xem trước',
      type: 'Loại biểu đồ',
      title: 'Tiêu đề',
      insight: 'Nhận xét (một câu hiện dưới hình)',
      source: 'Nguồn dữ liệu',
      table: 'Bảng',
      pickTable: '— Chọn bảng —',
      tableN: 'Bảng {{n}} ({{rows}} hàng × {{cols}} cột)',
      tableUnder: 'Bảng {{n}} — {{heading}} ({{rows}} hàng × {{cols}} cột)',
      tableLocked: 'Bảng theo phạm vi Data insight — không đổi bảng ở đây.',
      staticSource: 'Biểu đồ tĩnh — đang vẽ từ số đã giữ. Chọn một bảng để nối lại.',
      relinkHint: 'Không còn thấy bảng nguồn. Chọn bảng để biểu đồ vẽ lại từ số trong bảng.',
      range: 'Vùng',
      wholeTable: 'Cả bảng',
      rangePart: 'Một vùng',
      rangeAddress: 'Địa chỉ vùng',
      rangePlaceholder: 'VD: B2:D10',
      headerRows: 'Số hàng tiêu đề',
      category: 'Cột nhãn',
      scatterX: 'Cột X (số)',
      noCategory: '(Không — mỗi hàng một điểm)',
      pickColumn: '— Chọn cột —',
      missingColumn: 'Cột {{letter}} (không còn trong bảng)',
      columnLetter: 'Cột {{letter}}',
      columnOption: '{{letter}} — {{header}} ({{kind}})',
      group: 'Gộp các hàng cùng nhãn',
      series: 'Các series',
      seriesN: 'Series {{n}}',
      column: 'Cột số',
      aggregate: 'Cách gộp',
      seriesLabel: 'Nhãn',
      seriesKind: 'Vẽ bằng',
      kindBar: 'Cột',
      kindLine: 'Đường',
      axis: 'Trục',
      axisLeft: 'Trái',
      axisRight: 'Phải',
      addSeries: 'Thêm series',
      removeSeries: 'Xoá series {{n}}',
      color: 'Màu',
      colorOfSeries: 'Màu series {{n}}',
      colorOf: 'Tô series {{n}} màu {{color}}',
      defaultColors: 'Màu mặc định',
      sort: 'Sắp xếp',
      limit: 'Chỉ lấy top',
      limitCount: 'Số dòng giữ lại',
      limitRows: 'dòng',
      xLabel: 'Nhãn trục nhóm',
      yLabel: 'Nhãn trục giá trị',
      width: 'Rộng (px)',
      height: 'Cao (px)',
      preview: 'Xem trước',
      noPreview: 'Chọn bảng để xem trước.',
      fixErrors: 'Sửa các lỗi sau để lưu:',
      save: 'Lưu',
      insert: 'Chèn',
      apply: 'Áp dụng',
      defaultTitle: 'Biểu đồ mới',
      pieKept:
        'Biểu đồ {{type}} chỉ có một series — đã giữ series đầu, bỏ {{count}} series còn lại.',
      movedToX: 'Cột {{column}} chuyển thành trục X của biểu đồ phân tán.',
      suggestions: 'Gợi ý',
      suggestionsHint: 'bấm một hình để dùng',
      useSuggestion: 'Dùng gợi ý "{{title}}"',
      firstRowHeader: 'Hàng đầu là tiêu đề',
      firstColumnLabels: 'Cột đầu là nhãn',
      labelColumns: 'Số cột nhãn',
      switchRowsColumns: 'Đổi hàng/cột',
      switchHint: 'Mỗi hàng là một series (thay vì mỗi cột) — như "Switch Row/Column" của Excel',
      seriesInColumns: 'Mỗi cột số là một series',
      seriesInRows: 'Mỗi hàng là một series',
      switched: 'Đã đổi hướng đọc — gợi ý lại theo hướng mới.',
      labelFrom: 'Vùng chọn chỉ có cột số — đã lấy cột {{column}} bên trái làm nhãn.',
      advanced: 'Tuỳ chỉnh thêm',
    },
    types: {
      bar: 'Cột',
      stacked_bar: 'Cột chồng',
      horizontal_bar: 'Thanh ngang',
      line: 'Đường',
      area: 'Vùng',
      pie: 'Bánh',
      donut: 'Vành khuyên',
      scatter: 'Phân tán',
      combo: 'Cột + đường',
    },
    aggregates: {
      none: 'Không gộp',
      sum: 'Tổng',
      avg: 'Trung bình',
      count: 'Đếm',
      min: 'Nhỏ nhất',
      max: 'Lớn nhất',
    },
    sorts: {
      none: 'Theo thứ tự trong bảng',
      value_desc: 'Giá trị giảm dần',
      value_asc: 'Giá trị tăng dần',
      category: 'Theo nhãn',
    },
    kinds: {
      number: 'số',
      percent: '%',
      currency: 'tiền',
      date: 'thời gian',
      category: 'nhóm',
      text: 'chữ',
      empty: 'trống',
    },
    issues: {
      title_required: 'Chưa có tiêu đề.',
      table_required: 'Chưa chọn bảng nguồn.',
      range_invalid: 'Địa chỉ vùng chưa đúng — viết kiểu B2:D10.',
      range_outside: 'Vùng nằm ngoài bảng.',
      column_out_of_table: 'Cột không còn trong bảng.',
      column_out_of_range: 'Cột nằm ngoài vùng đã chọn.',
      pie_series_count: 'Biểu đồ {{type}} chỉ có đúng một series.',
      category_required: 'Loại biểu đồ này cần cột nhãn.',
      x_label_missing: 'Thiếu nhãn trục nhóm.',
      y_label_missing: 'Thiếu nhãn trục giá trị.',
      group_without_category: 'Gộp theo nhãn cần có cột nhãn.',
      group_needs_aggregate: 'Gộp theo nhãn thì phải chọn cách gộp.',
      aggregate_without_group: 'Cách gộp chỉ dùng khi gộp theo nhãn.',
      combo_series_count: 'Biểu đồ cột + đường cần ít nhất 2 series.',
      combo_kind_missing: 'Chọn vẽ bằng cột hay đường.',
      right_axis_not_combo: 'Trục phải chỉ dùng cho biểu đồ cột + đường.',
      series_duplicate: 'Trùng với một series khác (cùng cột, cùng cách gộp).',
      series_not_numeric:
        'Cột này không phải cột số — chọn cột số, hoặc gộp theo nhãn với cách Đếm.',
      scatter_x_not_numeric: 'Cột X của biểu đồ phân tán phải là cột số.',
    },
    warnings: {
      unreadable_cells: '{{count}} ô không đọc ra số — đã bỏ qua.',
      negative_in_pie: '{{count}} lát âm — biểu đồ bánh không vẽ được, đã bỏ.',
      points_capped: 'Có {{total}} điểm — chỉ vẽ 200 điểm đầu.',
      column_missing: 'Cột {{columns}} không còn trong bảng.',
      total_rows_skipped: 'Đã bỏ {{count}} hàng tổng ở cuối vùng.',
    },
  },
  /** Sổ chốt phương án — APM-DSHEET-c, docs/plan-decision-sheet.md. */
  decisionSheet: {
    blockTitle: 'Sổ chốt phương án',
    blockEmpty:
      'Chưa có sổ nào. Sổ chốt phương án là bộ câu hỏi nhiều phương án để BA / khách chốt từng điểm.',
    create: 'Tạo sổ',
    createBlank: 'Soạn mới',
    createBlankHint: 'Sổ trống, thêm nhóm và câu hỏi trong trình soạn',
    newTitle: 'Sổ chốt phương án mới',
    created: 'Đã tạo sổ',
    progress: '{{answered}}/{{total}} đã chốt',
    updatedAt: 'Cập nhật {{at}}',
    noDeciders: 'Chưa chọn người trả lời',
    open: 'Mở sổ {{title}}',
    status: { draft: 'Đang soạn', open: 'Đang mở', closed: 'Đã đóng' },
    eyebrow: 'Sổ chốt phương án',
    back: 'Quay lại tài liệu',
    legend: 'Chú giải',
    origin: { documented: 'Tài liệu đã có', new: 'Chưa nói đến' },
    originHint: {
      documented: 'Tài liệu nguồn có viết nhưng chưa đủ rõ',
      new: 'Người soạn nêu thêm, tài liệu nguồn chưa nhắc tới',
    },
    recommended: 'nên chọn',
    recommendedHint: 'Đề xuất của người soạn',
    /** Câu chọn nhiều đáp án — APM-DSX-multi. */
    multipleHint: 'Chọn được nhiều phương án',
    totals: {
      label: 'Tổng kết sổ',
      answered: 'Đã chốt',
      recommended: 'Chọn đúng đề xuất',
      pending: 'Còn chờ',
    },
    filter: {
      label: 'Lọc câu hỏi',
      all: 'Tất cả',
      open: 'Chưa chốt',
      answered: 'Đã chốt',
      link: 'Qua link',
    },
    /** Người ngoài chốt qua link công khai — dòng dưới "Người chốt" (APM-DSX). */
    linkRespondents: {
      line: 'Trả lời qua link:',
      item: '{{name}} ({{count}} câu)',
    },
    viewResult: 'Xem kết quả',
    groupCount: '{{answered}}/{{total}} đã chốt',
    ungrouped: 'Chưa xếp nhóm',
    questionStatus: { open: 'Chưa chốt', answered: 'Đã chốt' },
    sourceRef: 'Tài liệu',
    context: 'Tình huống',
    asks: 'Cần chốt',
    options: 'Phương án của câu {{code}}',
    other: 'Phương án khác',
    otherDetail: 'Không phương án nào ở trên — ghi rõ ở ô ghi chú',
    otherNeedsNote: 'Chọn "Phương án khác" thì cần ghi chú — chưa lưu cho tới khi có ghi chú.',
    note: 'Ghi chú',
    notePlaceholder: 'Ghi chú thêm (tuỳ chọn)',
    otherNotePlaceholder: 'Ghi rõ phương án được chọn (bắt buộc)',
    clear: 'Bỏ chọn',
    trace: 'Chọn {{key}} · {{at}} · {{name}}',
    traceImported: 'Chọn {{key}} · {{at}} · nhập từ nguồn ngoài',
    /** Người ngoài qua link công khai — APM-DSX-b, plan §11.3. */
    traceLink: 'Chọn {{key}} · {{at}} · {{who}} · {{via}}',
    respondent: {
      viaLink: 'qua link',
      viaLinkUnverified: 'qua link (chưa xác minh)',
      decidedBy: '{{name}} ({{email}}, qua link)',
    },
    someone: 'Ai đó',
    history: 'Lịch sử',
    historyTitle: 'Lịch sử câu {{code}}',
    historyEmpty: 'Câu này chưa ai chốt.',
    historyChose: 'Chọn {{key}}. {{title}}',
    historyCleared: 'Bỏ chọn',
    historyImported: 'nhập từ nguồn ngoài',
    historyViewAt: 'Xem sổ lúc này',
    onlyDeciders: 'Chỉ người chốt chọn được: {{names}}',
    onlyDecidersNone: 'Sổ chưa có người chốt nào — chưa ai chọn được.',
    closedNotice: 'Sổ đã đóng — mọi lựa chọn đã khoá. Mở lại để chốt tiếp.',
    draftNotice: 'Sổ đang soạn — người chốt chưa thấy sổ này. Mở sổ để họ bắt đầu chọn.',
    asOfNotice: 'Đang xem sổ tại {{at}} — chỉ đọc.',
    asOfExit: 'Về hiện tại',
    conflictChose:
      '{{name}} vừa chọn {{key}} lúc {{time}} ở câu {{code}} — lựa chọn của bạn chưa lưu. Xem lại rồi chọn lại nếu cần.',
    conflictCleared: 'Câu {{code}} vừa được người khác bỏ chọn — lựa chọn của bạn chưa lưu.',
    deciders: 'Người chốt',
    decidersLine: 'Người trả lời: {{names}}',
    decidersTitle: 'Chọn người trả lời',
    decidersHint:
      'Thành viên được chọn trả lời (chốt) được ngay trong app. Người soạn không tự động là người trả lời — muốn chốt thì tự thêm mình.',
    decidersSave: 'Lưu người trả lời',
    decidersSaved: 'Đã lưu người trả lời',
    decidersLimit: 'Tối đa {{max}} người trả lời.',
    decidersEmpty: 'Dự án chưa có thành viên nào.',
    /** Hộp "Chọn người trả lời" — thành viên dự án + link công khai (người dùng 2026-10-07). */
    answerers: {
      action: 'Chọn người trả lời',
      title: 'Chọn người trả lời',
      tabs: { members: 'Thành viên dự án', link: 'Người ngoài qua link' },
      openNow: 'Mở sổ ngay',
    },
    /** Hộp "Chưa mở được sổ" — lý do do server trả (409 DECISION_SHEET_NOT_READY). */
    openProblems: {
      title: 'Chưa mở được sổ',
      intro: 'Sửa các mục dưới đây rồi bấm "Mở sổ" lại:',
      noQuestions: 'Sổ chưa có câu hỏi nào.',
      addQuestions: 'Thêm câu hỏi',
      noAnswerers:
        'Chưa có người trả lời — chọn thành viên dự án, hoặc tạo link "Trả lời" cho người ngoài.',
    },
    transition: { open: 'Mở sổ', close: 'Đóng sổ', reopen: 'Mở lại' },
    transitioned: { open: 'Đã mở sổ', close: 'Đã đóng sổ', reopen: 'Đã mở lại sổ' },
    openNotReady: 'Cần ít nhất một câu hỏi và một người trả lời mới mở được sổ.',
    openNeedsDeciders:
      'Sổ cần ít nhất một người trả lời mới mở được: chọn thành viên rồi lưu (sổ mở ngay), hoặc tạo link "Trả lời" ở thẻ "Người ngoài qua link" rồi bấm "Mở sổ ngay".',
    openNeedsQuestions: 'Sổ chưa có câu hỏi nào — thêm câu ở chế độ Sửa rồi mới mở được.',
    /** Chế độ Xem mở trong cửa sổ riêng, khung giống trang chia sẻ (2026-10-07). */
    openWindow: 'Mở trong cửa sổ mới',
    standalone: {
      signIn: 'Đăng nhập',
      switchAccount: 'Đổi tài khoản',
      canAnswer: 'Bạn là người trả lời của sổ — chọn đáp án ngay bên dưới.',
      viewOnly: 'Bạn chỉ xem được — chỉ người trả lời của sổ chọn được đáp án.',
      notOpen: 'Sổ không mở để trả lời — mọi lựa chọn đang khoá.',
      signInTitle: 'Đăng nhập để xem sổ',
      signInHint:
        'Sổ này nằm trong một dự án — đăng nhập bằng tài khoản là thành viên dự án để xem và trả lời. Người ngoài trả lời qua link chia sẻ.',
    },
    resultTitle: 'Kết quả đã chốt',
    resultCopy: 'Sao chép',
    resultCopied: 'Đã chép kết quả',
    resultCopyFailed: 'Không chép được — hãy chọn văn bản rồi chép tay.',
    result: {
      matchesRecommended: 'đúng đề xuất',
      unanswered: 'CHƯA CHỐT',
      note: 'Ghi chú:',
    },
    empty: 'Sổ chưa có câu hỏi nào.',
    emptyFiltered: 'Không có câu nào khớp bộ lọc.',
    download: 'Tải JSON',
    /** Trình soạn — APM-DSHEET-d; chế độ Sửa tại chỗ — APM-DSX-e. */
    editor: {
      modeLabel: 'Chế độ của sổ',
      modeView: 'Xem',
      modeEdit: 'Sửa',
      closedNoEdit: 'Sổ đã đóng — mở lại sổ để sửa.',
      openNotice: 'Sổ đang mở — sửa được, trừ xoá câu đã chốt và xoá phương án đang là đáp án.',
      sheetTitle: 'Tên sổ',
      sheetDescription: 'Mô tả',
      sheetDescriptionHint: 'Thêm mô tả cho sổ (tuỳ chọn)',
      allowOther: 'Có "Phương án khác" (bắt buộc ghi chú)',
      deleteSheet: 'Xoá sổ',
      deleteSheetConfirm: 'Xoá sổ "{{title}}"? Lịch sử chốt vẫn giữ trong nhật ký dự án.',
      deleteSheetConfirmOpen:
        'Xoá sổ "{{title}}"? Sổ đang mở — người trả lời (kể cả qua link) sẽ không mở được nữa. Lịch sử chốt vẫn giữ trong nhật ký dự án.',
      sheetDeleted: 'Đã xoá sổ',
      dragHint:
        'Bấm vào chữ để sửa — tự lưu khi rời câu. Kéo núm bên trái thẻ để đổi thứ tự hoặc chuyển câu sang nhóm khác.',
      dragHandle: 'Kéo để đổi thứ tự câu',
      addGroup: 'Thêm nhóm',
      newGroupTitle: 'Nhóm mới',
      groupCode: 'Mã nhóm',
      groupCodeEdit: 'Mã nhóm {{code}} — bấm để sửa',
      deleteGroup: 'Xoá nhóm',
      deleteGroupCode: 'Xoá nhóm {{code}}',
      deleteGroupConfirm: 'Xoá nhóm {{code}}?',
      groupNotEmpty: 'Nhóm còn câu hỏi — chuyển các câu sang nhóm khác trước khi xoá.',
      duplicateGroup: 'Trùng mã nhóm {{code}}',
      groupTitle: 'Tên nhóm',
      groupNote: 'Ghi chú nhóm',
      groupNoteHint: 'Ghi chú nhóm (tuỳ chọn)',
      highlight: 'Nhãn nổi bật',
      highlightHint: 'Ví dụ: Ảnh hưởng KPI / tiền',
      addQuestion: 'Thêm câu hỏi',
      deleteQuestion: 'Xoá câu',
      deleteQuestionCode: 'Xoá câu {{code}}',
      deleteQuestionConfirm: 'Xoá câu {{code}}?',
      discardDraft: 'Bỏ câu chưa lưu',
      duplicateCode: 'Trùng mã câu {{code}} — mã câu phải duy nhất trong sổ',
      code: 'Mã câu',
      codeEdit: 'Mã câu {{code}} — bấm để sửa',
      questionTitle: 'Câu hỏi',
      questionTitlePlaceholder: 'Câu hỏi cần chốt',
      origin: 'Nguồn',
      sourceRefHint:
        'Chỗ trong tài liệu nguồn, vd. "File 2, sheet 3, ô A34–A35" — hoặc "Không có."',
      contextHint: 'Bối cảnh — vì sao phải chốt (tuỳ chọn)',
      askLine: 'Điểm cần chốt {{index}}',
      askHint: 'Một điểm cần chốt — Enter để thêm dòng',
      addAsk: 'Thêm điểm cần chốt',
      optionTitle: 'Tên phương án {{key}}',
      optionTitlePlaceholder: 'Tên phương án',
      optionDetail: 'Mô tả phương án {{key}}',
      optionDetailHint: 'Mô tả một dòng (tuỳ chọn)',
      addOption: 'Thêm phương án',
      optionLimit: 'Đã đủ {{max}} phương án.',
      removeOption: 'Xoá phương án {{key}}',
      minOptions: 'Cần ít nhất {{min}} phương án',
      recommendToggle: 'Phương án {{key}} là "nên chọn"',
      multiple: 'Cho chọn nhiều đáp án',
      multipleLocked: 'Câu đang chốt nhiều phương án — bỏ chốt trước khi chuyển về chọn một',
      optionInUse: 'Đang là đáp án — không xoá được',
      answeredLock:
        'Câu đã chốt {{key}} — muốn xoá câu thì bỏ chọn ở chế độ Xem trước; phương án {{key}} không xoá được.',
      otherPreview: 'Người chốt luôn thấy thêm lựa chọn này — bật / tắt ở đầu sổ.',
      saving: 'Đang lưu…',
      saved: 'Đã lưu',
      saveFailed: 'Lỗi — thử lại',
      unsaved: 'Chưa lưu',
      needTitle: 'Chưa lưu: câu hỏi còn trống.',
      needCode: 'Chưa lưu: mã câu còn trống.',
      needOptionTitle: 'Chưa lưu: phương án {{key}} chưa có tên.',
    },
    /** AI soạn / trích sổ và bước duyệt gợi ý — APM-DSHEET-g/h, plan §5.4–5.5. */
    ai: {
      draftMenu: 'AI soạn từ tài liệu',
      draftMenuHint: 'Chọn 1–5 tài liệu dự án, AI soạn câu hỏi chờ chốt',
      draftUnavailable: 'Chưa bật AI — dùng "Soạn mới" hoặc "Nhập JSON" ở trên',
      draftTitle: 'AI soạn sổ từ tài liệu',
      draftIntro:
        'Chọn tối đa {{max}} tài liệu (SRS, biên bản, sitemap). AI đọc chúng và soạn những câu còn phải chốt, mỗi câu kèm chỗ trích trong tài liệu. Kết quả là bản nháp để bạn duyệt.',
      documentsLabel: 'Tài liệu ({{count}}/{{max}})',
      noDocuments: 'Dự án chưa có tài liệu nào',
      noDocumentsHint: 'Thêm tài liệu ở khối Tài liệu dự án, hoặc dùng "Soạn mới" / "Nhập JSON".',
      goalLabel: 'Mục tiêu (tuỳ chọn)',
      goalHint: 'Ví dụ: những chỗ BA chưa chốt ảnh hưởng tới tính tiền',
      run: 'Soạn bằng AI',
      running: 'AI đang chạy…',
      extractRun: 'Trích bằng AI',
      pasteIntro:
        'Dán chữ chép từ trang hoặc mã nguồn HTML (vd. sổ do một AI Agent ngoài như Claude, ChatGPT, Gemini dựng). Dán đúng tệp JSON apm-decision-sheet thì tạo sổ thẳng, không gọi AI.',
      pastePlaceholder: 'Dán nội dung ở đây…',
      pasteCount: '{{count}}/{{max}} ký tự (đã bỏ CSS)',
      pasteTooLong: 'Nội dung dài quá {{max}} ký tự kể cả khi đã bỏ CSS — dán bớt rồi thử lại.',
      reviewIntro:
        'Đây là gợi ý của AI, chưa có sổ nào. Đổi tên, bỏ câu không cần rồi bấm "Tạo sổ nháp" — hoặc "Bỏ".',
      partial: 'AI dừng giữa chừng (chạm giới hạn lượt chạy) — kết quả có thể thiếu câu.',
      unverified: 'Phần AI chưa tự kiểm được:',
      unreadable:
        'Gợi ý này không còn đọc được thành sổ (có thể do phiên bản cũ) — hãy bỏ và chạy lại.',
      titleLabel: 'Tên sổ',
      summary: 'Giữ {{kept}}/{{total}} câu · {{groups}} nhóm · {{answers}} đáp án',
      questionsLabel: 'Câu hỏi AI đề xuất',
      include: 'Giữ câu {{code}}',
      answered: '← đã chọn',
      afterCreate:
        'Sổ tạo ra ở trạng thái đang soạn — sửa tiếp lời câu, phương án, nhóm trong trình soạn trước khi mở cho người chốt.',
      accept: 'Tạo sổ nháp',
      discard: 'Bỏ',
      created: 'Đã tạo sổ nháp từ gợi ý AI',
      discarded: 'Đã bỏ gợi ý',
    },
    /** Hộp thoại Nhập — APM-DSHEET-d, plan §5.2–5.3. */
    import: {
      menu: 'Nhập JSON / dán nội dung',
      menuHint: 'Tệp apm-decision-sheet, ví dụ do một AI Agent ngoài soạn',
      title: 'Nhập sổ chốt phương án',
      tab: { json: 'Tệp / dán JSON', paste: 'Dán văn bản / HTML' },
      pickFile: 'Chọn tệp .json',
      downloadSample: 'Tải tệp JSON mẫu',
      sampleHint:
        'Tệp mẫu đủ mọi trường hợp, có hướng dẫn ngay trong tệp — đưa nó cho AI Agent ngoài (Claude, ChatGPT, Gemini…) kèm tài liệu để soạn sổ đúng định dạng.',
      orPaste: 'hoặc dán nội dung JSON vào ô dưới',
      textLabel: 'Nội dung JSON',
      tooLarge: 'Tệp lớn hơn {{max}} KB.',
      notJson: 'Không đọc được JSON: {{reason}}',
      issues: 'Tệp có {{count}} lỗi — sửa hết rồi nhập lại:',
      preview: '"{{title}}" · {{groups}} nhóm · {{questions}} câu · {{answers}} đáp án',
      create: 'Tạo sổ nháp',
      guideToggle: 'Cách lấy từ AI Agent ngoài',
      guideIntro:
        'Máy chủ không đọc được link chia sẻ của AI Agent ngoài (Claude, ChatGPT, Gemini…). Với sổ do AI Agent dựng, dán câu dưới đây vào cuộc trò chuyện đã tạo trang để nó thêm nút xuất JSON — hoặc đưa nó tệp JSON mẫu ở trên:',
      guideThen:
        'Rồi bấm "Chép JSON cho ChillPM" trên trang đó và dán vào ô bên dưới (hoặc tải tệp về rồi bấm "Chọn tệp .json").',
      guideCopied: 'Đã chép câu nhờ AI Agent',
      claudePrompt:
        'Thêm hai nút cạnh nhau: "Chép JSON cho ChillPM" (chép thẳng nội dung JSON vào bộ nhớ tạm bằng navigator.clipboard.writeText, có dự phòng chọn sẵn chữ trong một ô văn bản khi trình duyệt chặn, và báo "Đã chép") và "Tải JSON cho ChillPM" (tải tệp .json). Cả hai xuất bộ câu hỏi (và các lựa chọn đã chốt) theo định dạng apm-decision-sheet v1, cùng một nội dung, định dạng thụt lề 2 dấu cách. Quy tắc: chỉ xuất MỘT đối tượng JSON hợp lệ, giữ nguyên tên trường tiếng Anh; trường tuỳ chọn không có thì bỏ hẳn (không ghi null); "highlight" của nhóm là nhãn chữ ngắn, không phải true/false; mỗi câu 2–8 phương án, mã phương án là một chữ in hoa A–W, tối đa một phương án "recommended": true; câu cho chọn nhiều đáp án cùng lúc (ô vuông, "chọn mọi … áp dụng") thì ghi "multiple": true và KHÔNG có "recommended"; không tự thêm "Phương án khác" — trong "answers" dùng key "X" kèm "note" bắt buộc; câu "multiple" đã chọn nhiều thì "key" là các mã nối bằng dấu phẩy, ví dụ "A,C" hoặc "B,X"; chỉ ghi "answers" cho câu đã thật sự chốt. Cấu trúc (dấu ? = tuỳ chọn):',
    },
    /** Xuất thành tài liệu dự án — APM-DSHEET-e, plan §6.1. */
    exportDoc: {
      action: 'Xuất thành tài liệu dự án',
      exporting: 'Đang xuất…',
      created: 'Đã xuất thành tài liệu dự án',
      versioned: 'Đã xuất — phiên bản {{version}} của tài liệu',
      changeNote: 'Xuất lại từ sổ chốt phương án',
      exportedAt: 'Đã xuất lúc {{at}} (phiên bản {{version}})',
      exportedAtChilldoc: 'Đã xuất .chilldoc lúc {{at}} (phiên bản {{version}})',
      exportedAtMd: 'Đã xuất .md lúc {{at}} (phiên bản {{version}})',
      open: 'Mở tài liệu',
      gone: 'Tài liệu .chilldoc đã xuất trước đây đã bị xoá — lần xuất sau sẽ tạo tài liệu mới.',
      goneMd: 'Tài liệu .md đã xuất trước đây đã bị xoá — lần xuất .md sau sẽ tạo tài liệu mới.',
      // Hộp chọn định dạng — APM-DSX.
      dialogTitle: 'Xuất thành tài liệu dự án',
      dialogHint:
        'Mỗi định dạng là một tài liệu dự án riêng. Xuất lại thì thêm phiên bản mới cho đúng tài liệu ấy.',
      formats: {
        chilldoc: {
          title: 'Tài liệu ChillPM (.chilldoc)',
          hint: 'Bảng định dạng đẹp, mở và sửa được ngay trong app.',
        },
        md: {
          title: 'Markdown (.md)',
          hint: 'Đọc được ở mọi nơi — hợp để dán vào Git, wiki hay đưa cho AI.',
        },
      },
      openShort: 'Mở',
      submit: 'Xuất',
      // Sổ chưa đóng thì không xuất — APM-DSX, người dùng 2026-10-07.
      notClosed: {
        title: 'Chưa xuất được tài liệu',
        open: 'Sổ đang mở — người trả lời vẫn đổi được đáp án. Đóng sổ rồi mới xuất được tài liệu chốt.',
        draft:
          'Sổ chưa mở để trả lời — chưa có đáp án nào để chốt. Mở sổ, chờ trả lời xong rồi đóng sổ mới xuất được tài liệu chốt.',
        close: 'Đóng sổ',
      },
      meta: 'Xuất lúc {{at}} · {{answered}}/{{total}} đã chốt',
      columns: {
        code: 'Mã',
        question: 'Câu',
        answer: 'Đáp án',
        recommended: 'Phương án đề xuất',
        note: 'Ghi chú',
        decidedBy: 'Người chốt',
        at: 'Lúc',
      },
    },
    /** Ghi câu đã chốt thành Quyết định RAID — APM-DSHEET-f, plan §6.2. */
    raid: {
      action: 'Ghi vào RAID',
      title: 'Ghi quyết định vào RAID',
      hint: 'Mỗi câu đã chốt thành một mục Quyết định trong RAID: người chốt là người quyết, ngày chốt là ngày quyết. Câu đã ghi mà đổi đáp án sẽ thành một quyết định mới — quyết định cũ giữ nguyên.',
      empty: 'Chưa có câu nào đã chốt.',
      submit: 'Ghi {{count}} câu vào RAID',
      recorded: 'đã ghi',
      changed: 'đã đổi sau khi ghi',
      noDecider: 'Không rõ người chốt — không ghi được vào RAID.',
      done: 'Đã ghi {{count}} quyết định vào RAID',
      partial: 'Đã ghi {{done}} câu; {{failed}} câu chưa ghi được:',
      syncFailed:
        'Quyết định đã tạo trong RAID nhưng sổ chưa ghi nhận ({{reason}}) — kiểm tra tab RAID trước khi ghi lại để khỏi trùng.',
      openRaid: 'Mở {{code}} trong RAID',
      note: 'Ghi chú: {{note}}',
      fromSheet: 'Từ sổ "{{title}}"',
      replaces: 'Thay quyết định {{ref}}',
      respondent: 'Người trả lời: {{name}} ({{email}}, qua link)',
    },
    /** Chia sẻ sổ qua link công khai — APM-DSX-b, plan §11.3. */
    share: {
      action: 'Chia sẻ',
      title: 'Chia sẻ sổ qua link',
      hint: 'Ai có link đều mở được sổ, không cần tài khoản. Người chưa đăng nhập ghi tên và email trước khi chốt — câu họ chốt hiện "qua link (chưa xác minh)".',
      mode: 'Người mở link được',
      modes: { answer: 'Trả lời', view: 'Chỉ xem' },
      expiry: 'Hạn của link',
      expiries: { d7: '7 ngày', d30: '30 ngày', d90: '90 ngày', none: 'Không hạn' },
      create: 'Tạo link',
      created: 'Đã tạo link và chép vào bộ nhớ tạm',
      newLink: 'Link vừa tạo',
      copy: 'Chép link',
      copied: 'Đã chép link',
      copyFailed: 'Không chép được — hãy chọn link rồi chép tay.',
      links: 'Link đã tạo',
      empty: 'Chưa có link nào.',
      limit: 'Đã đủ {{max}} link còn hiệu lực — thu hồi bớt rồi mới tạo thêm.',
      expiresAt: 'hết hạn {{at}}',
      noExpiry: 'không hạn',
      expired: 'đã hết hạn',
      revokedTag: 'đã thu hồi',
      answers_one: '{{count}} lần trả lời',
      answers_other: '{{count}} lần trả lời',
      lastUsed: 'lần cuối {{at}}',
      createdBy: 'tạo bởi {{name}}',
      revoke: 'Thu hồi link',
      revokeConfirm: 'Thu hồi link này? Người đang giữ link sẽ không mở được nữa.',
      revoked: 'Đã thu hồi link',
    },
    /** Trang công khai `/d/$token` — APM-DSX-b. */
    public: {
      from: '{{project}} · {{org}}',
      expires: 'Link hết hạn {{at}}',
      whoTitle: 'Bạn là ai?',
      whoHint:
        'Ghi tên và email để người soạn sổ biết ai đã chốt. Không cần tài khoản; email không được xác minh.',
      name: 'Họ tên',
      namePlaceholder: 'Nguyễn Văn A',
      email: 'Email',
      emailPlaceholder: 'ban@congty.vn',
      whoRequired: 'Điền tên và email hợp lệ ở trên rồi mới chọn được.',
      whoReady: 'Câu bạn chốt sẽ ghi: {{who}} · qua link (chưa xác minh).',
      signInPrompt: 'Đã có tài khoản ChillPM?',
      signIn: 'Đăng nhập để trả lời bằng tài khoản',
      whoSave: 'Lưu',
      whoSaveHint: 'Bấm Lưu để dùng tên và email này khi chọn.',
      whoChange: 'Đổi',
      demoNote: 'Bạn đang dùng tài khoản demo — tài khoản demo không dùng để trả lời được.',
      demoSwitch: 'Đăng xuất để đăng nhập tài khoản khác',
      signedInAs: 'Trả lời với tư cách {{name}}',
      viewOnly: 'Link này chỉ để xem — không chốt được qua link này.',
      closed: 'Sổ đã đóng — mọi lựa chọn đã khoá.',
      draft: 'Sổ chưa mở để chốt — người soạn còn đang sửa.',
      unavailableTitle: 'Link không còn dùng được',
      unavailable:
        'Link đã bị thu hồi, đã hết hạn hoặc không đúng. Hỏi lại người gửi để lấy link mới.',
      poweredBy: 'Sổ chốt phương án trên ChillPM',
    },
    /** Giao việc trả lời — task nhúng sổ, APM-DSX-d, plan §11.2. */
    assign: {
      action: 'Tạo việc',
      title: 'Tạo việc trả lời sổ',
      hint: 'Tạo một việc cho người sẽ chốt sổ này. Người được giao tự động thành người chốt; việc không tự đóng khi chốt xong.',
      tabs: { create: 'Tạo việc mới', link: 'Gắn việc có sẵn' },
      taskTitle: 'Tên việc',
      suggestedTitle: 'Chốt sổ: {{title}}',
      assignee: 'Người được giao',
      assigneeNone: 'Chưa giao ai',
      due: 'Hạn',
      taskType: 'Loại việc',
      description: 'Trả lời sổ chốt phương án "{{title}}": {{url}}',
      submit: 'Giao việc',
      noTypes: 'Dự án chưa có loại việc nào — thêm loại việc ở Cài đặt dự án trước.',
      search: 'Tìm việc theo mã hoặc tên',
      noTasks: 'Không có việc nào khớp.',
      linkSubmit: 'Gắn việc',
      done: 'Đã giao {{code}}',
      doneDecider: 'Đã giao {{code}} — {{name}} thành người chốt của sổ',
      linkFailed: 'Đã tạo việc {{code}} nhưng chưa gắn được vào sổ: {{reason}}',
      retryLink: 'Thử gắn lại',
    },
    /** Việc đang nhúng sổ, trên trang sổ — APM-DSX-d. */
    tasks: {
      title: 'Việc trả lời sổ',
      unassigned: 'Chưa giao ai',
      done: 'Xong',
      open: 'Mở việc {{code}}',
      unlink: 'Bỏ gắn việc {{code}}',
      unlinkConfirm: 'Bỏ gắn việc {{code}} khỏi sổ? Việc vẫn còn, người chốt giữ nguyên.',
      unlinkLabel: 'Bỏ gắn',
      unlinked: 'Đã bỏ gắn việc',
    },
    /** Khối "Sổ chốt phương án" trong chi tiết task — APM-DSX-d. */
    taskBlock: {
      title: 'Sổ chốt phương án',
      open: 'Mở sổ',
      notDecider:
        'Người được giao việc chưa là người chốt của sổ này nên chưa chọn được — nhờ người soạn sổ thêm vào.',
      hint: 'Chốt xong mọi câu thì tự chuyển việc sang Xong — việc không tự đóng.',
    },
  },
  /** Vỏ trang công khai (`/d/$token`) theo thiết kế trang giới thiệu — 2026-10-07. */
  documentSharePage: {
    eyebrow: 'Tài liệu được chia sẻ',
    logo: 'Đăng nhập ChillPM',
    signIn: 'Đăng nhập',
    poweredBy: 'Chia sẻ qua ChillPM',
    viewOnly: 'Chỉ xem',
    version: 'Phiên bản v{{no}}',
    pending: 'Bản này đang được chuẩn bị để chia sẻ — thử tải lại trang sau ít phút.',
    noApproved: 'Tài liệu chưa có bản nào được duyệt để xem.',
    state: { approved: 'Đã duyệt', review: 'Chờ duyệt', draft: 'Bản nháp', old: 'Bản cũ' },
    signInTitle: 'Đăng nhập để xem tài liệu',
    signInHelp: 'Người chia sẻ yêu cầu đăng nhập bằng tài khoản ChillPM để xem tài liệu này.',
    orgOnly: 'Tài liệu chỉ chia sẻ trong tổ chức',
    orgOnlyHelp: 'Tài khoản đang đăng nhập không thuộc tổ chức của dự án này.',
    gone: 'Link không còn mở được',
    goneHelp: 'Người chia sẻ đã tắt link, hoặc tài liệu không còn nữa.',
  },
  publicShell: {
    navLabel: 'Điều hướng',
    tryIt: 'Dùng thử',
    openApp: 'Vào ứng dụng',
    about: 'Giới thiệu ChillPM',
    outline: 'Mục lục',
    outlineShow: 'Hiện mục lục',
    outlineHide: 'Ẩn mục lục',
    outlineProgress: '{{answered}}/{{total}} đã trả lời',
    answered: 'Đã trả lời',
    unanswered: 'Chưa trả lời',
    loading: 'Đang mở sổ chốt phương án…',
  },
  pptxEditor: {
    title: 'Bản trình chiếu “{{name}}”',
    loading: 'Đang mở bản trình chiếu…',
    openFailed: 'Không mở được bản trình chiếu này. Tải về để mở bằng PowerPoint.',
    empty: 'Tệp này không có slide nào.',
    save: 'Lưu',
    saving: 'Đang lưu…',
    saved: 'Đã lưu “{{name}}”.',
    saveFailed: 'Lưu không thành công: {{message}}',
    saveVersion: 'Lưu thành phiên bản khác',
    versionNote: 'Có gì thay đổi? (không bắt buộc)',
    versionSaved: 'Đã lưu thành phiên bản {{version}}.',
    close: 'Đóng',
    confirmDiscard: 'Bản trình chiếu có thay đổi chưa lưu. Đóng và bỏ các thay đổi?',
    toolbar: 'Công cụ soạn slide',
    slides: 'Danh sách slide',
    slideLabel: 'Slide {{n}}',
    hiddenSlide: 'slide ẩn',
    prev: 'Slide trước',
    next: 'Slide sau',
    counter: '{{n}} / {{total}}',
    notes: 'Ghi chú của người trình bày',
    noNotes: 'Slide này chưa có ghi chú.',
    panelsLabel: 'Bảng bên phải',
    undo: 'Hoàn tác',
    redo: 'Làm lại',
    undoStep: 'Hoàn tác: {{step}}',
    redoStep: 'Làm lại: {{step}}',
    flipH: 'Lật ngang',
    flipV: 'Lật dọc',
    selectionLayer: 'Chọn và kéo hình trên slide',
    textEditor: 'Sửa chữ trong hình',
    commandFailed: 'Không thực hiện được thao tác: {{message}}',
    insert: 'Chèn',
    textBox: 'Ô chữ',
    shape: 'Hình',
    shapes: {
      rect: 'Hình chữ nhật',
      roundRect: 'Hình chữ nhật bo góc',
      ellipse: 'Hình elip',
      triangle: 'Tam giác',
      rightArrow: 'Mũi tên phải',
      star5: 'Ngôi sao 5 cánh',
      line: 'Đường thẳng',
    },
    image: 'Ảnh',
    imageTooLarge: 'Ảnh lớn hơn {{max}} MB — hãy thu nhỏ ảnh trước khi chèn.',
    imageUnsupported: 'Chỉ chèn được ảnh PNG, JPEG, GIF hoặc BMP.',
    table: 'Bảng',
    tableSize: '{{rows}} hàng × {{cols}} cột',
    deleteShape: 'Xoá hình đang chọn',
    arrange: 'Sắp xếp',
    bringToFront: 'Lên trên cùng',
    sendToBack: 'Xuống dưới cùng',
    bringForward: 'Lên một lớp',
    sendBackward: 'Xuống một lớp',
    group: 'Nhóm (chọn thêm hình bằng Shift + bấm)',
    ungroup: 'Bỏ nhóm',
    format: 'Định dạng hình',
    fillColor: 'Màu nền',
    lineColor: 'Màu viền',
    lineWidth: 'Độ dày viền (pt)',
    noFill: 'Không tô',
    noLine: 'Không viền',
    styleDefault: 'Theo mẫu',
    apply: 'Áp dụng',
    slideMenu: 'Thao tác với slide {{n}}',
    newSlide: 'Thêm slide',
    newSlideOn: 'Thêm slide theo bố cục',
    duplicateSlide: 'Nhân bản slide',
    deleteSlide: 'Xoá slide',
    hideSlide: 'Ẩn slide khi trình chiếu',
    showSlide: 'Hiện lại slide',
    moveUp: 'Chuyển lên',
    moveDown: 'Chuyển xuống',
    notesPlaceholder: 'Bấm để thêm ghi chú cho người trình bày',
    cmd: {
      move: 'Di chuyển',
      resize: 'Đổi cỡ',
      rotate: 'Xoay',
      flip: 'Lật',
      editText: 'Sửa chữ',
      insertTextBox: 'Chèn ô chữ',
      insertShape: 'Chèn hình',
      insertImage: 'Chèn ảnh',
      replaceImage: 'Thay ảnh',
      insertTable: 'Chèn bảng',
      delete: 'Xoá hình',
      bringToFront: 'Đưa lên trên cùng',
      sendToBack: 'Đưa xuống dưới cùng',
      bringForward: 'Đưa lên một lớp',
      sendBackward: 'Đưa xuống một lớp',
      group: 'Nhóm',
      ungroup: 'Bỏ nhóm',
      fill: 'Đổi màu nền',
      line: 'Đổi viền',
      newSlide: 'Thêm slide',
      duplicateSlide: 'Nhân bản slide',
      deleteSlide: 'Xoá slide',
      moveSlide: 'Đổi thứ tự slide',
      hideSlide: 'Ẩn slide',
      showSlide: 'Hiện slide',
      editNotes: 'Sửa ghi chú',
      transition: 'Đổi chuyển slide',
      transitionAll: 'Áp chuyển slide cho tất cả',
    },
    panels: {
      animations: 'Hiệu ứng',
      transitions: 'Chuyển slide',
      design: 'Thiết kế',
    },
    master: {
      open: 'Master',
      openHint: 'Chế độ xem Master: sửa master và bố cục — slide dùng chúng đổi theo',
      close: 'Đóng chế độ Master',
      bar: 'Công cụ chế độ Master',
      tree: 'Master và bố cục',
      master: 'Master',
      masterN: 'Master {{n}}',
      masterLabel: 'Master “{{name}}”',
      layout: 'Bố cục',
      layoutLabel: 'Bố cục “{{name}}”',
      unnamed: 'Bố cục không tên',
      usedBy: '{{n}} slide đang dùng',
      unused: 'Chưa slide nào dùng',
      addLayout: 'Thêm bố cục',
      copyName: '{{name}} (bản sao)',
      newLayoutName: 'Bố cục mới',
      rename: 'Đổi tên',
      name: 'Tên',
      deleteLayout: 'Xoá bố cục',
      blocked: {
        inUse: 'Không xoá được: {{n}} slide đang dùng bố cục này.',
        lastLayout: 'Không xoá được bố cục cuối cùng của master.',
        notLayout: 'Chọn một bố cục để xoá.',
      },
      addPlaceholder: 'Thêm chỗ dành sẵn',
      placeholderOnLayout: 'Chọn một bố cục để thêm chỗ dành sẵn.',
      placeholders: {
        obj: 'Nội dung',
        body: 'Chữ',
        pic: 'Ảnh',
        chart: 'Biểu đồ',
        tbl: 'Bảng',
        title: 'Tiêu đề',
        dt: 'Ngày',
        ftr: 'Chân trang',
        sldNum: 'Số slide',
      },
      prompts: {
        obj: 'Bấm để thêm nội dung',
        body: 'Bấm để thêm chữ',
        pic: 'Bấm để thêm ảnh',
        chart: 'Bấm để thêm biểu đồ',
        tbl: 'Bấm để thêm bảng',
        title: 'Bấm để sửa tiêu đề',
      },
      textStyles: 'Kiểu chữ',
      textStylesTitle: 'Kiểu chữ của master',
      textStylesHint:
        'Ô để trống thì kế thừa. Slide nào tự đặt định dạng riêng thì giữ nguyên. Chuyển kiểu hay cấp là áp dụng cấp đang sửa.',
      style: 'Kiểu chữ',
      styles: {
        titleStyle: 'Tiêu đề',
        bodyStyle: 'Nội dung',
        otherStyle: 'Khác',
      },
      level: 'Cấp',
      levelN: 'Cấp {{n}}',
      size: 'Cỡ chữ (pt)',
      font: 'Phông chữ',
      color: 'Màu chữ (RRGGBB)',
      colorPicker: 'Chọn màu chữ',
      themeColor: 'Theo màu theme “{{name}}”',
      bullet: 'Dấu đầu dòng',
      bulletNone: 'Không',
      bulletChar: 'Ký tự',
      bulletCharLabel: 'Ký tự đầu dòng',
      marL: 'Lề trái (pt)',
      indent: 'Thụt dòng đầu (pt)',
      inherit: 'Kế thừa',
      invalid: 'Giá trị chưa hợp lệ: {{field}}',
      fields: {
        size: 'cỡ chữ (1–4000 pt)',
        color: 'màu (6 chữ số hex, ví dụ 1F4E79)',
        font: 'phông chữ',
        bullet: 'dấu đầu dòng (đúng một ký tự)',
        marL: 'lề trái (0–4032 pt)',
        indent: 'thụt dòng đầu (−4032–4032 pt)',
      },
      cmd: {
        addLayout: 'Thêm bố cục',
        rename: 'Đổi tên bố cục',
        deleteLayout: 'Xoá bố cục',
        addPlaceholder: 'Thêm chỗ dành sẵn',
        textStyle: 'Đổi kiểu chữ của master',
      },
    },
    design: {
      layout: 'Bố cục của slide',
      layoutHint:
        'Chữ trong chỗ dành sẵn được giữ. Chỗ không còn trong bố cục mới thì giữ nguyên vị trí; chỗ trống thì bỏ đi.',
      themeColors: 'Màu theme',
      themeColorsHint: 'Mọi chỗ dùng màu theme trên các slide đổi theo.',
      slots: {
        dk1: 'Tối 1 (chữ)',
        lt1: 'Sáng 1 (nền)',
        dk2: 'Tối 2',
        lt2: 'Sáng 2',
        accent1: 'Nhấn 1',
        accent2: 'Nhấn 2',
        accent3: 'Nhấn 3',
        accent4: 'Nhấn 4',
        accent5: 'Nhấn 5',
        accent6: 'Nhấn 6',
        hlink: 'Liên kết',
        folHlink: 'Liên kết đã mở',
      },
      noTheme: 'Slide này không gắn với theme nào.',
      apply: 'Áp dụng',
      discard: 'Bỏ thay đổi',
      themeFonts: 'Phông theme',
      headingFont: 'Phông tiêu đề',
      bodyFont: 'Phông nội dung',
      background: 'Nền',
      backgroundTarget: 'Áp nền cho',
      backgroundColor: 'Màu nền',
      targets: {
        slide: 'Slide này',
        layout: 'Bố cục',
        master: 'Master',
      },
      origin: {
        shape: 'Đang dùng nền riêng.',
        layout: 'Đang theo nền của bố cục.',
        master: 'Đang theo nền của master.',
        theme: 'Đang theo nền của theme.',
        default: 'Đang dùng nền mặc định (trắng).',
      },
      notSolid: 'Nền hiện tại là ảnh hoặc chuyển màu — chọn màu để thay.',
      applyAll: 'Áp cho tất cả',
      reset: 'Đặt lại',
      resetHint: 'Bỏ nền riêng để dùng lại nền kế thừa',
      slideSize: 'Kích thước slide',
      sizes: {
        wide: 'Màn rộng 16:9',
        standard: 'Chuẩn 4:3',
        custom: 'Tuỳ chỉnh',
      },
      currentSize: 'Hiện tại: {{w}} × {{h}} cm',
      width: 'Rộng (cm)',
      height: 'Cao (cm)',
      sizeInvalid: 'Kích thước phải từ 2,54 đến 142,24 cm.',
      applySize: 'Đổi kích thước',
      scaleTitle: 'Đổi kích thước slide',
      scaleQuestion: 'Đổi sang {{w}} × {{h}} cm. Nội dung trên slide nên thế nào?',
      maximize: 'Phóng to tối đa',
      maximizeHint: 'Nội dung lấp đầy slide, có thể tràn ra ngoài mép.',
      fit: 'Đảm bảo vừa',
      fitHint: 'Thu nhỏ hình và chữ để mọi thứ nằm trong slide.',
      palettes: 'Bảng màu dựng sẵn',
      paletteNames: {
        office: 'Office',
        office2007: 'Office 2007–2010',
        blue: 'Xanh dương',
        green: 'Xanh lá',
        redOrange: 'Đỏ cam',
        violet: 'Tím',
        yellow: 'Vàng',
        grayscale: 'Xám',
      },
      fontPairs: 'Cặp phông',
      fontSample: 'Chữ nội dung',
      backgroundSwatches: 'Màu nền gợi ý',
      pale: '{{name}} nhạt',
      phRoles: {
        title: 'Tiêu đề',
        content: 'Nội dung',
        picture: 'Ảnh',
      },
      cmd: {
        colors: 'Đổi màu theme',
        fonts: 'Đổi phông theme',
        background: 'Đổi nền',
        backgroundAll: 'Áp nền cho tất cả',
        slideSize: 'Đổi kích thước slide',
        changeLayout: 'Đổi bố cục slide',
      },
    },
    devCompare: {
      title: 'So bộ vẽ slide mới với pptx-renderer (trang dev)',
      slide: 'Slide {{n}}',
      ours: 'Bộ vẽ mới',
      theirs: 'pptx-renderer',
      fallback: 'Vẽ qua lớp dự phòng: {{list}}',
      noFallback: 'Không có hình nào qua lớp dự phòng.',
      loading: 'Đang mở tệp…',
    },
  },
  chilldocTasks: {
    createTask: 'Tạo task',
    createTitle: 'Tạo task từ dòng checklist',
    title: 'Tiêu đề (chữ của dòng)',
    emptyLine: 'Dòng đang trống — gõ nội dung cho dòng trước khi tạo task.',
    project: 'Dự án',
    noProjects: 'Bạn chưa ở dự án nào được phép tạo task.',
    taskType: 'Loại task',
    assignee: 'Người nhận',
    unassigned: 'Chưa giao',
    dueDate: 'Hạn',
    created: 'Đã tạo task "{{title}}" và gắn vào dòng.',
    checkbox: 'Đánh dấu xong: {{text}}',
    emptyText: 'dòng trống',
    unavailable: 'Không xem được',
    unavailableHint: 'Task đã bị xoá hoặc bạn không có quyền xem nó.',
    loading: 'Đang tải trạng thái task, thử lại sau giây lát.',
    openTask: 'Mở {{key}}: {{title}}',
    due: 'Hạn {{date}}',
    noDoneStatus: 'Dự án của task này không có cột "Hoàn thành" nào để chuyển vào.',
    noTodoStatus: 'Dự án của task này không có cột "Cần làm" nào để chuyển về.',
    toggleFailed: 'Không đổi được trạng thái {{key}}: {{reason}}',
  },
  // Nhắc người `@` / trỏ task, issue `#` trong `.chilldoc` — APM-CD2-f.
  chilldocMentions: {
    peopleTitle: 'Nhắc người',
    refsTitle: 'Task / issue',
    loading: 'Đang tải…',
    empty: 'Không có kết quả khớp.',
    refUnavailable: 'Đã bị xoá hoặc bạn không có quyền xem.',
    openRef: 'Mở {{code}}: {{title}}',
    notified: 'Đã báo cho {{names}}.',
    notMember: '{{names}} không xem được tài liệu này (không ở dự án) — chưa gửi thông báo.',
    notShared: '{{names}} chưa được chia sẻ tài liệu này — chưa gửi thông báo.',
    shareAction: 'Chia sẻ (chỉ xem)',
    sharedAndNotified: 'Đã chia sẻ và báo cho {{names}}.',
    shareFailed: 'Không chia sẻ được: {{reason}}',
    notifyFailed: 'Đã lưu, nhưng chưa gửi được thông báo nhắc tên: {{reason}}',
  },
  chilldocTemplates: {
    fromTemplate: 'Từ mẫu…',
    fromTemplateHint: 'Biên bản họp, kế hoạch, báo cáo… điền sẵn tên dự án và ngày',
    pickerTitle: 'Tạo tài liệu từ mẫu',
    blank: 'Tài liệu trống',
    blankHint: 'Bắt đầu từ trang trắng',
    builtinGroup: 'Có sẵn',
    orgGroup: 'Của tổ chức',
    orgEmpty: 'Tổ chức chưa có mẫu riêng.',
    orgEmptyAdmin:
      'Mở menu ⋯ của một tệp .chilldoc ở trang Tệp và chọn “Đặt làm mẫu của tổ chức”.',
    orgLoadFailed: 'Không tải được mẫu của tổ chức.',
    unavailable: 'Không đọc được nội dung mẫu này.',
    opening: 'Đang mở mẫu…',
    openFailed: 'Không mở được mẫu “{{name}}”.',
    byAuthor: 'Do {{name}} đặt',
    projectHint: 'Tên dự án {{name}}, ngày hôm nay, tên bạn và thành viên dự án được điền sẵn.',
    noProjectHint:
      'Ngày hôm nay và tên bạn được điền sẵn; tên dự án, thành viên để trống có gạch dưới để bạn điền.',
    manage: 'Quản lý mẫu {{name}}',
    edit: 'Sửa thông tin',
    remove: 'Gỡ mẫu',
    confirmRemove: 'Gỡ mẫu “{{name}}”? Tài liệu đã tạo từ mẫu này không bị ảnh hưởng.',
    removed: 'Đã gỡ mẫu “{{name}}”.',
    setAsTemplate: 'Đặt làm mẫu của tổ chức',
    createTitle: 'Đặt “{{name}}” làm mẫu của tổ chức',
    editTitle: 'Sửa mẫu “{{name}}”',
    name: 'Tên mẫu',
    description: 'Mô tả (không bắt buộc)',
    category: 'Nhóm',
    nameEmpty: 'Tên mẫu không được để trống.',
    nameTooLong: 'Tên mẫu tối đa {{max}} ký tự.',
    descriptionTooLong: 'Mô tả tối đa {{max}} ký tự.',
    create: 'Đặt làm mẫu',
    save: 'Lưu',
    created: 'Đã thêm mẫu “{{name}}” cho cả tổ chức.',
    updated: 'Đã lưu mẫu “{{name}}”.',
    categories: {
      meeting: 'Họp',
      plan: 'Kế hoạch',
      proposal: 'Tờ trình',
      spec: 'Đặc tả',
      report: 'Báo cáo',
      other: 'Khác',
    },
    builtin: {
      meetingMinutes: {
        name: 'Biên bản họp',
        description: 'Thành phần, nội dung, quyết định và việc cần làm giao được thành task',
      },
      projectPlan: {
        name: 'Kế hoạch dự án',
        description: 'Mục tiêu, phạm vi, các mốc, rủi ro và nguồn lực',
      },
      proposal: {
        name: 'Tờ trình',
        description: 'Đề nghị phê duyệt: căn cứ, nội dung, kinh phí, kiến nghị',
      },
      requirementsSpec: {
        name: 'Đặc tả yêu cầu (SRS)',
        description: 'Yêu cầu chức năng, phi chức năng, người dùng và giao diện',
      },
      weeklyReport: {
        name: 'Báo cáo tuần',
        description: 'Việc đã xong, đang làm, vướng mắc và kế hoạch tuần tới',
      },
      postProjectReview: {
        name: 'Đánh giá sau dự án',
        description: 'Kết quả so với mục tiêu, bài học kinh nghiệm, việc cải tiến',
      },
    },
  },
  placeholder: {
    comingSoon: 'Màn hình này sẽ có ở sprint sau.',
    dashboard: 'Tổng quan dự án, burndown và RAID sẽ xuất hiện ở đây (S8).',
    myTasks: 'Công việc đa dự án của bạn sẽ xuất hiện ở đây (S5).',
    projects: 'Danh sách dự án sẽ xuất hiện ở đây (S5).',
    reports: 'Bộ báo cáo và biểu đồ sẽ xuất hiện ở đây (S8).',
  },
};

/**
 * Không `as const`: ta cần ràng buộc **tập khoá**, không phải giá trị. Với
 * `as const` thì mỗi chuỗi thành một literal type riêng và `en.ts` sẽ không
 * bao giờ gán được — TypeScript đòi bản tiếng Anh phải trùng từng chữ với bản
 * tiếng Việt.
 */
export type Translations = typeof vi;
